/* tslint:disable */
/* eslint-disable */
/**
 * api-svc
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface ApiSvcAccessToken
 */
export interface ApiSvcAccessToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccessToken
   */
  value: string;
}
/**
 *
 * @export
 * @interface ApiSvcAccountBalanceLine
 */
export interface ApiSvcAccountBalanceLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBalanceLine
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBalanceLine
   */
  currencyId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBalanceLine
   */
  amount: string;
}
/**
 *
 * @export
 * @interface ApiSvcAccountBasedBlockchainTransaction
 */
export interface ApiSvcAccountBasedBlockchainTransaction {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  type: ApiSvcAccountBasedBlockchainTransactionTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  txId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  to: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  from: string;
  /**
   *
   * @type {ApiSvcTxnCryptoAmount}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  amount: ApiSvcTxnCryptoAmount;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  isComplete: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  isErrored: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  methodId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  data?: string;
  /**
   *
   * @type {Array<ApiSvcSubTransaction>}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  subTransactions?: Array<ApiSvcSubTransaction>;
  /**
   *
   * @type {ApiSvcTxnCryptoAmount}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  fee?: ApiSvcTxnCryptoAmount;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainTransaction
   */
  feeAddress?: string;
}

export const ApiSvcAccountBasedBlockchainTransactionTypeEnum = {
  AccountBasedBlockchainTransaction: 'account-based-blockchain-transaction',
} as const;

export type ApiSvcAccountBasedBlockchainTransactionTypeEnum =
  typeof ApiSvcAccountBasedBlockchainTransactionTypeEnum[keyof typeof ApiSvcAccountBasedBlockchainTransactionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcAccountBasedBlockchainWalletDTO
 */
export interface ApiSvcAccountBasedBlockchainWalletDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainWalletDTO
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainWalletDTO
   */
  networkId: string;
  /**
   *
   * @type {ApiSvcRollupConfigDTO}
   * @memberof ApiSvcAccountBasedBlockchainWalletDTO
   */
  rollupConfig?: ApiSvcRollupConfigDTO;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcAccountBasedBlockchainWalletDTO
   */
  metadata?: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainWalletDTO
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainWalletDTO
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainWalletDTO
   */
  remoteId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainWalletDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountBasedBlockchainWalletDTO
   */
  viewKey?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcAccountDetailsTypeDTO = {
  AccountTransfer: 'AccountTransfer',
  Trade: 'Trade',
  Standard: 'Standard',
  DeFi: 'DeFi',
} as const;

export type ApiSvcAccountDetailsTypeDTO = typeof ApiSvcAccountDetailsTypeDTO[keyof typeof ApiSvcAccountDetailsTypeDTO];

/**
 *
 * @export
 * @interface ApiSvcAccountInfo
 */
export interface ApiSvcAccountInfo {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountInfo
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountInfo
   */
  subAccountId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcAccountTransaction
 */
export interface ApiSvcAccountTransaction {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransaction
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransaction
   */
  link?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAccountTransaction
   */
  timestampSEC: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransaction
   */
  desc: string;
}
/**
 *
 * @export
 * @interface ApiSvcAccountTransferCategorizationDTO
 */
export interface ApiSvcAccountTransferCategorizationDTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeAccountTransfer}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  type: ApiSvcCategorizationTypeAccountTransfer;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  otherAccountId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcTransferDirection}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  transferDirection: ApiSvcTransferDirection;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  taxable: boolean;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  notionalTransferValue: ApiSvcRawValueDTO;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  notionalFeeValue?: ApiSvcRawValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  feeContactId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  taxDetailsMissing?: boolean;
  /**
   *
   * @type {ApiSvcAccountTransferCategorizationDTOExternalTaxDetails}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  externalTaxDetails?: ApiSvcAccountTransferCategorizationDTOExternalTaxDetails;
  /**
   *
   * @type {Array<ApiSvcFlatExchangeRateDTO>}
   * @memberof ApiSvcAccountTransferCategorizationDTO
   */
  exchangeRates?: Array<ApiSvcFlatExchangeRateDTO>;
}

/**
 *
 * @export
 * @interface ApiSvcAccountTransferCategorizationDTOExternalTaxDetails
 */
export interface ApiSvcAccountTransferCategorizationDTOExternalTaxDetails {
  /**
   *
   * @type {number}
   * @memberof ApiSvcAccountTransferCategorizationDTOExternalTaxDetails
   */
  acquisitionDateSEC: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferCategorizationDTOExternalTaxDetails
   */
  acquisitionCost: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferCategorizationDTOExternalTaxDetails
   */
  type: ApiSvcAccountTransferCategorizationDTOExternalTaxDetailsTypeEnum;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAccountTransferCategorizationDTOExternalTaxDetails
   */
  dispositionDateSEC: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferCategorizationDTOExternalTaxDetails
   */
  dispositionProceeds: string;
}

export const ApiSvcAccountTransferCategorizationDTOExternalTaxDetailsTypeEnum = {
  Disposition: 'disposition',
} as const;

export type ApiSvcAccountTransferCategorizationDTOExternalTaxDetailsTypeEnum =
  typeof ApiSvcAccountTransferCategorizationDTOExternalTaxDetailsTypeEnum[keyof typeof ApiSvcAccountTransferCategorizationDTOExternalTaxDetailsTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcAccountTransferTransactionInput
 */
export interface ApiSvcAccountTransferTransactionInput {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcAccountTransferTransactionInput
   */
  metadata?: Array<string> | null;
  /**
   *
   * @type {Array<ApiSvcExchangeRateInput>}
   * @memberof ApiSvcAccountTransferTransactionInput
   */
  exchangeRates?: Array<ApiSvcExchangeRateInput> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferTransactionInput
   */
  feeContactId?: string | null;
  /**
   *
   * @type {ApiSvcUncheckedValueBase}
   * @memberof ApiSvcAccountTransferTransactionInput
   */
  notionalFeeValue?: ApiSvcUncheckedValueBase | null;
  /**
   *
   * @type {ApiSvcUncheckedValueBase}
   * @memberof ApiSvcAccountTransferTransactionInput
   */
  notionalTransferValue: ApiSvcUncheckedValueBase;
  /**
   *
   * @type {ApiSvcTransferDirectionInput}
   * @memberof ApiSvcAccountTransferTransactionInput
   */
  direction: ApiSvcTransferDirectionInput;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferTransactionInput
   */
  otherAccountId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferTransactionInput
   */
  description: string;
}

/**
 *
 * @export
 * @interface ApiSvcAccountTransferTxnDetailsDTO
 */
export interface ApiSvcAccountTransferTxnDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferTxnDetailsDTO
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferTxnDetailsDTO
   */
  otherAccountId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcAccountTransferTxnDetailsDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {ApiSvcTransferDirection}
   * @memberof ApiSvcAccountTransferTxnDetailsDTO
   */
  direction: ApiSvcTransferDirection;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountTransferTxnDetailsDTO
   */
  feeContactId?: string;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcAccountTransferTxnDetailsDTO
   */
  exchangeRates?: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {ApiSvcTaxDispositionDetailsDTO}
   * @memberof ApiSvcAccountTransferTxnDetailsDTO
   */
  dispositionDetails?: ApiSvcTaxDispositionDetailsDTO;
  /**
   *
   * @type {ApiSvcTaxAcquisitionDetailsDTO}
   * @memberof ApiSvcAccountTransferTxnDetailsDTO
   */
  acquisitionDetails?: ApiSvcTaxAcquisitionDetailsDTO;
}

/**
 *
 * @export
 * @interface ApiSvcAccountValidationResponse
 */
export interface ApiSvcAccountValidationResponse {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountValidationResponse
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountValidationResponse
   */
  error?: string;
  /**
   *
   * @type {ApiSvcAccountValidationResults}
   * @memberof ApiSvcAccountValidationResponse
   */
  results?: ApiSvcAccountValidationResults;
}
/**
 *
 * @export
 * @interface ApiSvcAccountValidationResults
 */
export interface ApiSvcAccountValidationResults {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountValidationResults
   */
  approximateTransactionCountHeader: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAccountValidationResults
   */
  approximateTransactionCount: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountValidationResults
   */
  accountName?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcAccountValidationResults
   */
  addressSample?: Array<string>;
  /**
   *
   * @type {Array<ApiSvcAccountTransaction>}
   * @memberof ApiSvcAccountValidationResults
   */
  recentTransactions?: Array<ApiSvcAccountTransaction>;
  /**
   *
   * @type {Array<ApiSvcAccountBalanceLine>}
   * @memberof ApiSvcAccountValidationResults
   */
  balances: Array<ApiSvcAccountBalanceLine>;
  /**
   *
   * @type {ApiSvcAccountInfo}
   * @memberof ApiSvcAccountValidationResults
   */
  accountInfo: ApiSvcAccountInfo;
}
/**
 *
 * @export
 * @interface ApiSvcAccountingConfigDTO
 */
export interface ApiSvcAccountingConfigDTO {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountingConfigDTO
   */
  multiCurrency: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountingConfigDTO
   */
  separateFeeTransactions: boolean;
  /**
   *
   * @type {Array<ApiSvcAccountingConfigDTONetworkContactIdsInner>}
   * @memberof ApiSvcAccountingConfigDTO
   */
  networkContactIds?: Array<ApiSvcAccountingConfigDTONetworkContactIdsInner>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingConfigDTO
   */
  defaultFeeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingConfigDTO
   */
  defaultAccountsReceivableCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingConfigDTO
   */
  defaultAccountsPayableCategoryId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountingConfigDTO
   */
  allowTxnInference?: boolean;
  /**
   *
   * @type {Array<ApiSvcAccountingConfigDTODefaultFeeCategoryIdsInner>}
   * @memberof ApiSvcAccountingConfigDTO
   */
  defaultFeeCategoryIds: Array<ApiSvcAccountingConfigDTODefaultFeeCategoryIdsInner>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountingConfigDTO
   */
  collapseAcrossWallets?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountingConfigDTO
   */
  useTxnMemoForReconciliation?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcAccountingConfigDTODefaultFeeCategoryIdsInner
 */
export interface ApiSvcAccountingConfigDTODefaultFeeCategoryIdsInner {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingConfigDTODefaultFeeCategoryIdsInner
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingConfigDTODefaultFeeCategoryIdsInner
   */
  blockchain: string;
}
/**
 *
 * @export
 * @interface ApiSvcAccountingConfigDTONetworkContactIdsInner
 */
export interface ApiSvcAccountingConfigDTONetworkContactIdsInner {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingConfigDTONetworkContactIdsInner
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingConfigDTONetworkContactIdsInner
   */
  blockchain: string;
}
/**
 * Non-secret projection of a single accounting connection on an org. Returned by `GET /orgs/:orgId/accounting-connections` so payments-svc (or any other caller) can decide which connection(s) to push to.  No OAuth tokens, no realm secrets, no provider-internal credentials — only fields the caller needs to make a push decision and to label results.
 * @export
 * @interface ApiSvcAccountingConnectionDTO
 */
export interface ApiSvcAccountingConnectionDTO {
  /**
   *
   * @type {ApiSvcNetsuiteConnectionDetailsDTO}
   * @memberof ApiSvcAccountingConnectionDTO
   */
  netsuite?: ApiSvcNetsuiteConnectionDetailsDTO;
  /**
   *
   * @type {ApiSvcQuickbooksConnectionDetailsDTO}
   * @memberof ApiSvcAccountingConnectionDTO
   */
  quickbooks?: ApiSvcQuickbooksConnectionDetailsDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingConnectionDTO
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountingConnectionDTO
   */
  disabled: boolean;
  /**
   * Connection type, emitted as the lowercase semantic name from `mapConnectionTypes` / the `ConnectionType` string enum (e.g. `\"quickbooks\"`, `\"netsuite2024\"`, `\"sage-intacct\"`).
   * @type {string}
   * @memberof ApiSvcAccountingConnectionDTO
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingConnectionDTO
   */
  id: string;
}
/**
 *
 * @export
 * @interface ApiSvcAccountingConnectionsResponseDTO
 */
export interface ApiSvcAccountingConnectionsResponseDTO {
  /**
   *
   * @type {Array<ApiSvcAccountingConnectionDTO>}
   * @memberof ApiSvcAccountingConnectionsResponseDTO
   */
  connections: Array<ApiSvcAccountingConnectionDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcAccountingDetailsDTO
 */
export interface ApiSvcAccountingDetailsDTO {
  /**
   *
   * @type {ApiSvcSimpleTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  simple?: ApiSvcSimpleTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcSellTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  sell?: ApiSvcSellTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcBillPayTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  billPay?: ApiSvcBillPayTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcTradeTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  trade?: ApiSvcTradeTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcSimpleTradeTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  simpleTrade?: ApiSvcSimpleTradeTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcTransferTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  transfer?: ApiSvcTransferTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcIntercompanyTransferTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  intercompanyTransfer?: ApiSvcIntercompanyTransferTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcAccountTransferTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  accountTransfer?: ApiSvcAccountTransferTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcStakingTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  staking?: ApiSvcStakingTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcDetailedTxnDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  detailed?: ApiSvcDetailedTxnDTO;
  /**
   *
   * @type {ApiSvcMultiValueTxnDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  multivalue?: ApiSvcMultiValueTxnDTO;
  /**
   *
   * @type {ApiSvcInvoicePaymentTxnDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  invoice?: ApiSvcInvoicePaymentTxnDTO;
  /**
   *
   * @type {ApiSvcAssetStakingTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  assetStaking?: ApiSvcAssetStakingTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcDeFiTransferTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  deFiTransfer?: ApiSvcDeFiTransferTxnDetailsDTO;
  /**
   *
   * @type {ApiSvcAdvanceDeFiTxnDetailsDTO}
   * @memberof ApiSvcAccountingDetailsDTO
   */
  advanceDeFi?: ApiSvcAdvanceDeFiTxnDetailsDTO;
}
/**
 *
 * @export
 * @interface ApiSvcAccountingEntry
 */
export interface ApiSvcAccountingEntry {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  memo: string;
  /**
   *
   * @type {ApiSvcAccountingEntryMeta}
   * @memberof ApiSvcAccountingEntry
   */
  metadata?: ApiSvcAccountingEntryMeta;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  transactionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  localDateTimeISO: string;
  /**
   *
   * @type {ApiSvcAccountingEntryType}
   * @memberof ApiSvcAccountingEntry
   */
  entryType: ApiSvcAccountingEntryType;
  /**
   *
   * @type {Array<ApiSvcEntryLine>}
   * @memberof ApiSvcAccountingEntry
   */
  lines: Array<ApiSvcEntryLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  remoteContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  remoteContactName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  accountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  accountRemoteId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  accountName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  internalCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  internalContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntry
   */
  subsidiaryId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcAccountingEntryMeta
 */
export interface ApiSvcAccountingEntryMeta {
  /**
   *
   * @type {Array<ApiSvcAccountingEntryMetadata>}
   * @memberof ApiSvcAccountingEntryMeta
   */
  metadata?: Array<ApiSvcAccountingEntryMetadata>;
}
/**
 *
 * @export
 * @interface ApiSvcAccountingEntryMetadata
 */
export interface ApiSvcAccountingEntryMetadata {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntryMetadata
   */
  remoteType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntryMetadata
   */
  remoteId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntryMetadata
   */
  name: ApiSvcAccountingEntryMetadataNameEnum;
  /**
   *
   * @type {ApiSvcMetadataComponentTag}
   * @memberof ApiSvcAccountingEntryMetadata
   */
  component: ApiSvcMetadataComponentTag;
  /**
   *
   * @type {ApiSvcAccountingEntryTagSourceTransactions}
   * @memberof ApiSvcAccountingEntryMetadata
   */
  tag: ApiSvcAccountingEntryTagSourceTransactions;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcAccountingEntryMetadata
   */
  sourceTxnIds: Array<string>;
}

export const ApiSvcAccountingEntryMetadataNameEnum = {
  SourceTransactions: 'Source Transactions',
} as const;

export type ApiSvcAccountingEntryMetadataNameEnum =
  typeof ApiSvcAccountingEntryMetadataNameEnum[keyof typeof ApiSvcAccountingEntryMetadataNameEnum];

/**
 * generated from metadata record
 * @export
 * @interface ApiSvcAccountingEntryReconcileMetadata
 */
export interface ApiSvcAccountingEntryReconcileMetadata {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntryReconcileMetadata
   */
  remoteType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntryReconcileMetadata
   */
  remoteId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntryReconcileMetadata
   */
  name: string;
  /**
   *
   * @type {ApiSvcMetadataComponentReconcile}
   * @memberof ApiSvcAccountingEntryReconcileMetadata
   */
  component: ApiSvcMetadataComponentReconcile;
}

/**
 * Metadata for tracking source transaction IDs in rolled-up entries. This enables idempotent push operations by allowing us to mark individual transactions as synced after successful ERP push.
 * @export
 * @interface ApiSvcAccountingEntrySourceTransactionsMetadata
 */
export interface ApiSvcAccountingEntrySourceTransactionsMetadata {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcAccountingEntrySourceTransactionsMetadata
   */
  sourceTxnIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntrySourceTransactionsMetadata
   */
  name: ApiSvcAccountingEntrySourceTransactionsMetadataNameEnum;
  /**
   *
   * @type {ApiSvcAccountingEntryTagSourceTransactions}
   * @memberof ApiSvcAccountingEntrySourceTransactionsMetadata
   */
  tag: ApiSvcAccountingEntryTagSourceTransactions;
  /**
   *
   * @type {ApiSvcMetadataComponentTag}
   * @memberof ApiSvcAccountingEntrySourceTransactionsMetadata
   */
  component: ApiSvcMetadataComponentTag;
}

export const ApiSvcAccountingEntrySourceTransactionsMetadataNameEnum = {
  SourceTransactions: 'Source Transactions',
} as const;

export type ApiSvcAccountingEntrySourceTransactionsMetadataNameEnum =
  typeof ApiSvcAccountingEntrySourceTransactionsMetadataNameEnum[keyof typeof ApiSvcAccountingEntrySourceTransactionsMetadataNameEnum];

/**
 * generated at run time, to add metadata to an entry line or to the accountingEntry
 * @export
 * @enum {string}
 */

export const ApiSvcAccountingEntryTag = {
  Forex: 'Forex',
  Fee: 'Fee',
  Other: 'Other',
  ImputedFee: 'ImputedFee',
  SourceTransactions: 'SourceTransactions',
} as const;

export type ApiSvcAccountingEntryTag = typeof ApiSvcAccountingEntryTag[keyof typeof ApiSvcAccountingEntryTag];

/**
 *
 * @export
 * @interface ApiSvcAccountingEntryTagMetadata
 */
export interface ApiSvcAccountingEntryTagMetadata {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingEntryTagMetadata
   */
  name: string;
  /**
   *
   * @type {ApiSvcAccountingEntryTag}
   * @memberof ApiSvcAccountingEntryTagMetadata
   */
  tag: ApiSvcAccountingEntryTag;
  /**
   *
   * @type {ApiSvcMetadataComponentTag}
   * @memberof ApiSvcAccountingEntryTagMetadata
   */
  component: ApiSvcMetadataComponentTag;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcAccountingEntryTagSourceTransactions = {
  SourceTransactions: 'SourceTransactions',
} as const;

export type ApiSvcAccountingEntryTagSourceTransactions =
  typeof ApiSvcAccountingEntryTagSourceTransactions[keyof typeof ApiSvcAccountingEntryTagSourceTransactions];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcAccountingEntryType = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export type ApiSvcAccountingEntryType = typeof ApiSvcAccountingEntryType[keyof typeof ApiSvcAccountingEntryType];

/**
 * Non-secret projection of a single QBO Item, returned by `GET /orgs/:orgId/quickbooks/connections/:connectionId/items`. Used by payments-svc / the UI to populate the \"Default Invoice Item\" dropdown on the payments-settings page.
 * @export
 * @interface ApiSvcAccountingItemDTO
 */
export interface ApiSvcAccountingItemDTO {
  /**
   * QBO Item.Type: \"Inventory\", \"NonInventory\", \"Service\", \"Category\", …
   * @type {string}
   * @memberof ApiSvcAccountingItemDTO
   */
  type?: string;
  /**
   * False for archived items. UI typically filters these out by default.
   * @type {boolean}
   * @memberof ApiSvcAccountingItemDTO
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingItemDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingItemDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingItemDTO
   */
  id: string;
}
/**
 *
 * @export
 * @interface ApiSvcAccountingItemsResponseDTO
 */
export interface ApiSvcAccountingItemsResponseDTO {
  /**
   *
   * @type {Array<ApiSvcAccountingItemDTO>}
   * @memberof ApiSvcAccountingItemsResponseDTO
   */
  items: Array<ApiSvcAccountingItemDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcAccountingSetupDTO
 */
export interface ApiSvcAccountingSetupDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingSetupDTO
   */
  initialSyncMethod: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountingSetupDTO
   */
  isReconciled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAccountingSetupDTO
   */
  isFinished?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingSetupDTO
   */
  balanceExportStartDate?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAccountingSetupDTO
   */
  balanceExportReportId?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcAccountingSourceIds = {
  Xero: 'xero',
  Quickbooks: 'quickbooks',
  Netsuite: 'netsuite',
  SageIntacct: 'sage-intacct',
  Manual: 'manual',
  Workday: 'workday',
  OracleFusion: 'oracle-fusion',
  Rillet: 'rillet',
} as const;

export type ApiSvcAccountingSourceIds = typeof ApiSvcAccountingSourceIds[keyof typeof ApiSvcAccountingSourceIds];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcAccountingTransactionDirection = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export type ApiSvcAccountingTransactionDirection =
  typeof ApiSvcAccountingTransactionDirection[keyof typeof ApiSvcAccountingTransactionDirection];

/**
 *
 * @export
 * @interface ApiSvcAction
 */
export interface ApiSvcAction {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  type: ApiSvcActionTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcAction
   */
  labels?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAction
   */
  ignoreFailPricing?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  feeContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  categoryId: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAction
   */
  isIntercompanyTransfer?: boolean;
  /**
   *
   * @type {Array<ApiSvcDetailedCategorizationActionLines>}
   * @memberof ApiSvcAction
   */
  lines: Array<ApiSvcDetailedCategorizationActionLines>;
  /**
   *
   * @type {Array<ApiSvcSplit>}
   * @memberof ApiSvcAction
   */
  feeSplits?: Array<ApiSvcSplit>;
  /**
   *
   * @type {Array<ApiSvcSplit>}
   * @memberof ApiSvcAction
   */
  splits: Array<ApiSvcSplit>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  acquiredCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  acquiredContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  disposedCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  disposedContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAction
   */
  deFiWalletId: string;
}

export const ApiSvcActionTypeEnum = {
  DeFiCategorization: 'DeFiCategorization',
} as const;

export type ApiSvcActionTypeEnum = typeof ApiSvcActionTypeEnum[keyof typeof ApiSvcActionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcActionsSummaryReportLine
 */
export interface ApiSvcActionsSummaryReportLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  transaction_period: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  subsidiaryName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  category: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  asset: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  wallet: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  contact: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_asset_unit_adj: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_cost_basis_acquired: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_cost_basis_relieved: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_fair_market_value_disposed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_short_term_gain_loss: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_long_term_gain_loss: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_impairment_expense?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_realized_gain_loss: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_fair_value_adjustment_upward?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcActionsSummaryReportLine
   */
  total_fair_value_adjustment_downward?: number;
}
/**
 *
 * @export
 * @interface ApiSvcActionsSummaryReportResp
 */
export interface ApiSvcActionsSummaryReportResp {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcActionsSummaryReportResp
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcActionsSummaryReportResp
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcActionsSummaryReportResp
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcActionsSummaryReportResp
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcActionsSummaryReportResp
   */
  metadata?: object;
  /**
   *
   * @type {Array<ApiSvcActionsSummaryReportLine>}
   * @memberof ApiSvcActionsSummaryReportResp
   */
  lines: Array<ApiSvcActionsSummaryReportLine>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcActionsSummaryReportResp
   */
  includeImpairmentColumns?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcActionsSummaryReportResp
   */
  includeFairValueAdjustmentColumns?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcActionsSummaryReportResp
   */
  pageToken?: string;
}

/**
 *
 * @export
 * @interface ApiSvcAddressEnrollmentStatus
 */
export interface ApiSvcAddressEnrollmentStatus {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressEnrollmentStatus
   */
  address: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAddressEnrollmentStatus
   */
  emailSent: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAddressEnrollmentStatus
   */
  enrolled: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressEnrollmentStatus
   */
  signature?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressEnrollmentStatus
   */
  signatureData?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressEnrollmentStatus
   */
  pennyTestAmount?: string;
  /**
   *
   * @type {ApiSvcManualValidation}
   * @memberof ApiSvcAddressEnrollmentStatus
   */
  manualValidation?: ApiSvcManualValidation;
}
/**
 *
 * @export
 * @interface ApiSvcAddressNotFoundError
 */
export interface ApiSvcAddressNotFoundError {
  /**
   *
   * @type {ApiSvcPermanantlyFatalErrorReasonAddressNotFound}
   * @memberof ApiSvcAddressNotFoundError
   */
  errorType: ApiSvcPermanantlyFatalErrorReasonAddressNotFound;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressNotFoundError
   */
  rawMessage?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAddressNotFoundError
   */
  httpStatus?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcAddressNotFoundError
   */
  metadata?: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressNotFoundError
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressNotFoundError
   */
  network?: string;
}

/**
 *
 * @export
 * @interface ApiSvcAddressPointer
 */
export interface ApiSvcAddressPointer {
  /**
   *
   * @type {ApiSvcPointerTypes}
   * @memberof ApiSvcAddressPointer
   */
  type: ApiSvcPointerTypes;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressPointer
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressPointer
   */
  address: string;
}

/**
 *
 * @export
 * @interface ApiSvcAddressPointerInput
 */
export interface ApiSvcAddressPointerInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressPointerInput
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressPointerInput
   */
  networkId: string;
}
/**
 *
 * @export
 * @interface ApiSvcAddressWallet
 */
export interface ApiSvcAddressWallet {
  /**
   *
   * @type {ApiSvcRollupConfig}
   * @memberof ApiSvcAddressWallet
   */
  rollupConfig?: ApiSvcRollupConfig | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressWallet
   */
  address: string;
}
/**
 *
 * @export
 * @interface ApiSvcAddressWalletDTO
 */
export interface ApiSvcAddressWalletDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressWalletDTO
   */
  address: string;
  /**
   *
   * @type {ApiSvcRollupConfigDTO}
   * @memberof ApiSvcAddressWalletDTO
   */
  rollupConfig?: ApiSvcRollupConfigDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressWalletDTO
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressWalletDTO
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAddressWalletDTO
   */
  remoteId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiCategorizationDTO
 */
export interface ApiSvcAdvanceDeFiCategorizationDTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeAdvanceDeFi}
   * @memberof ApiSvcAdvanceDeFiCategorizationDTO
   */
  type: ApiSvcCategorizationTypeAdvanceDeFi;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcAdvanceDeFiCategorizationDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAdvanceDeFiCategorizationDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiCategorizationDTO
   */
  memo?: string;
  /**
   *
   * @type {Array<ApiSvcAdvanceDeFiItemDTO>}
   * @memberof ApiSvcAdvanceDeFiCategorizationDTO
   */
  items: Array<ApiSvcAdvanceDeFiItemDTO>;
  /**
   *
   * @type {Array<ApiSvcFeeLineDTO>}
   * @memberof ApiSvcAdvanceDeFiCategorizationDTO
   */
  fees?: Array<ApiSvcFeeLineDTO>;
}

/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiItem
 */
export interface ApiSvcAdvanceDeFiItem {
  /**
   *
   * @type {Array<ApiSvcAdvanceDeFiLine>}
   * @memberof ApiSvcAdvanceDeFiItem
   */
  lines: Array<ApiSvcAdvanceDeFiLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItem
   */
  defiWalletId: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiItemDTO
 */
export interface ApiSvcAdvanceDeFiItemDTO {
  /**
   *
   * @type {Array<ApiSvcAdvanceDeFiItemDTOLinesInner>}
   * @memberof ApiSvcAdvanceDeFiItemDTO
   */
  lines: Array<ApiSvcAdvanceDeFiItemDTOLinesInner>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTO
   */
  defiWalletId: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiItemDTOLinesInner
 */
export interface ApiSvcAdvanceDeFiItemDTOLinesInner {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  type: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  isNonVaultTracking?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  sourceTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  walletId?: string;
  /**
   *
   * @type {Array<ApiSvcMetadataStructDTO>}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  metadata?: Array<ApiSvcMetadataStructDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  fiatAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemDTOLinesInner
   */
  contactId: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiItemInput
 */
export interface ApiSvcAdvanceDeFiItemInput {
  /**
   *
   * @type {Array<ApiSvcAdvanceDeFiLineNonPostInput>}
   * @memberof ApiSvcAdvanceDeFiItemInput
   */
  nonpostingLines?: Array<ApiSvcAdvanceDeFiLineNonPostInput> | null;
  /**
   *
   * @type {Array<ApiSvcAdvanceDeFiLinePostInput>}
   * @memberof ApiSvcAdvanceDeFiItemInput
   */
  postingLines?: Array<ApiSvcAdvanceDeFiLinePostInput> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiItemInput
   */
  defiWalletId: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiLine
 */
export interface ApiSvcAdvanceDeFiLine {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  isNonVaultTracking?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  sourceTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  type: string;
  /**
   *
   * @type {Array<ApiSvcMetadataStructDTO>}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  metadata?: Array<ApiSvcMetadataStructDTO> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  fiatAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLine
   */
  contactId: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiLineNonPost
 */
export interface ApiSvcAdvanceDeFiLineNonPost {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAdvanceDeFiLineNonPost
   */
  isNonVaultTracking?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPost
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPost
   */
  sourceTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPost
   */
  type: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiLineNonPostDTO
 */
export interface ApiSvcAdvanceDeFiLineNonPostDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPostDTO
   */
  type: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAdvanceDeFiLineNonPostDTO
   */
  isNonVaultTracking?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPostDTO
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPostDTO
   */
  sourceTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPostDTO
   */
  walletId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiLineNonPostInput
 */
export interface ApiSvcAdvanceDeFiLineNonPostInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPostInput
   */
  walletId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAdvanceDeFiLineNonPostInput
   */
  isNonVaultTracking?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPostInput
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLineNonPostInput
   */
  sourceTicker: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiLinePost
 */
export interface ApiSvcAdvanceDeFiLinePost {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  isNonVaultTracking?: boolean | null;
  /**
   *
   * @type {Array<ApiSvcMetadataStructDTO>}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  metadata?: Array<ApiSvcMetadataStructDTO> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  fiatAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  sourceTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePost
   */
  type: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiLinePostDTO
 */
export interface ApiSvcAdvanceDeFiLinePostDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  type: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  isNonVaultTracking?: boolean;
  /**
   *
   * @type {Array<ApiSvcMetadataStructDTO>}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  metadata?: Array<ApiSvcMetadataStructDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  fiatAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  sourceTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostDTO
   */
  contactId: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiLinePostInput
 */
export interface ApiSvcAdvanceDeFiLinePostInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  walletId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  isNonVaultTracking?: boolean | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  metadataIds?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  fiatAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  sourceTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvanceDeFiLinePostInput
   */
  contactId: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiTransactionInput
 */
export interface ApiSvcAdvanceDeFiTransactionInput {
  /**
   *
   * @type {Array<ApiSvcDetailedFeeInput>}
   * @memberof ApiSvcAdvanceDeFiTransactionInput
   */
  fees?: Array<ApiSvcDetailedFeeInput> | null;
  /**
   *
   * @type {Array<ApiSvcExchangeRateInput>}
   * @memberof ApiSvcAdvanceDeFiTransactionInput
   */
  exchangeRates: Array<ApiSvcExchangeRateInput>;
  /**
   *
   * @type {Array<ApiSvcAdvanceDeFiItemInput>}
   * @memberof ApiSvcAdvanceDeFiTransactionInput
   */
  items: Array<ApiSvcAdvanceDeFiItemInput>;
}
/**
 *
 * @export
 * @interface ApiSvcAdvanceDeFiTxnDetailsDTO
 */
export interface ApiSvcAdvanceDeFiTxnDetailsDTO {
  /**
   *
   * @type {Array<ApiSvcDetailedFeeDTO>}
   * @memberof ApiSvcAdvanceDeFiTxnDetailsDTO
   */
  fees?: Array<ApiSvcDetailedFeeDTO>;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcAdvanceDeFiTxnDetailsDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {Array<ApiSvcAdvanceDeFiItemDTO>}
   * @memberof ApiSvcAdvanceDeFiTxnDetailsDTO
   */
  items: Array<ApiSvcAdvanceDeFiItemDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcAdvancedCostBasisRollForwardLine
 */
export interface ApiSvcAdvancedCostBasisRollForwardLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  asset: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  asset_id: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  starting_fiat_value: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  starting_qty_value: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  fiat_increases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  internal_cost_basis_acquired?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  qty_increases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  qty_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  ending_fiat_value: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  ending_qty_value: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  fmv_disposed_fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  internal_cost_basis_disposed?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  stGainLoss_fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  ltGainLoss_fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  impairExpense_fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  fiat_check_mustbe_zero: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  qty_check_mustbe_zero: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  undatedGainLoss_fiat_decreases: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  lotID?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  original_inventory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  original_wallet?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  inventory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  wallet?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  current_price?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  fair_market_value?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  unrealized_gain_loss?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  impairExpenseReversal_fiat_increases?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardLine
   */
  subsidiaryName?: string;
}
/**
 *
 * @export
 * @interface ApiSvcAdvancedCostBasisRollForwardResp
 */
export interface ApiSvcAdvancedCostBasisRollForwardResp {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcAdvancedCostBasisRollForwardResp
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcAdvancedCostBasisRollForwardResp
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardResp
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardResp
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcAdvancedCostBasisRollForwardResp
   */
  metadata?: object;
  /**
   *
   * @type {Array<ApiSvcAdvancedCostBasisRollForwardLine>}
   * @memberof ApiSvcAdvancedCostBasisRollForwardResp
   */
  lines: Array<ApiSvcAdvancedCostBasisRollForwardLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAdvancedCostBasisRollForwardResp
   */
  pageToken?: string;
}

/**
 *
 * @export
 * @interface ApiSvcAmountDTO
 */
export interface ApiSvcAmountDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAmountDTO
   */
  displayValue: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAmountDTO
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAmountDTO
   */
  coin: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAmountDTO
   */
  unit: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAmountDTO
   */
  parentTimestamp?: number;
  /**
   *
   * @type {ApiSvcValueBase}
   * @memberof ApiSvcAmountDTO
   */
  itemValue: ApiSvcValueBase;
  /**
   *
   * @type {ApiSvcOrgDTO}
   * @memberof ApiSvcAmountDTO
   */
  org: ApiSvcOrgDTO;
  /**
   *
   * @type {ApiSvcFiatValueDTO}
   * @memberof ApiSvcAmountDTO
   */
  fiatValue?: ApiSvcFiatValueDTO;
}
/**
 *
 * @export
 * @interface ApiSvcAmountLiteDTO
 */
export interface ApiSvcAmountLiteDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAmountLiteDTO
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAmountLiteDTO
   */
  currencyId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAmountLiteDTO
   */
  coin?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAmountLiteDTO
   */
  unit?: string;
}
/**
 *
 * @export
 * @interface ApiSvcAmountRange
 */
export interface ApiSvcAmountRange {
  /**
   *
   * @type {number}
   * @memberof ApiSvcAmountRange
   */
  from?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAmountRange
   */
  to?: number;
}
/**
 *
 * @export
 * @interface ApiSvcApiKeyToken
 */
export interface ApiSvcApiKeyToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcApiKeyToken
   */
  apiKey: string;
}
/**
 *
 * @export
 * @interface ApiSvcApplyPriceVersionRequest
 */
export interface ApiSvcApplyPriceVersionRequest {
  /**
   *
   * @type {number}
   * @memberof ApiSvcApplyPriceVersionRequest
   */
  version: number;
}
/**
 *
 * @export
 * @interface ApiSvcApplyRuleToTxnResult
 */
export interface ApiSvcApplyRuleToTxnResult {
  /**
   *
   * @type {ApiSvcAccountingDetailsDTO}
   * @memberof ApiSvcApplyRuleToTxnResult
   */
  categorization?: ApiSvcAccountingDetailsDTO;
  /**
   *
   * @type {ApiSvcRuleProcessingResult}
   * @memberof ApiSvcApplyRuleToTxnResult
   */
  result: ApiSvcRuleProcessingResult;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcAssetAccountMapping = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export type ApiSvcAssetAccountMapping = typeof ApiSvcAssetAccountMapping[keyof typeof ApiSvcAssetAccountMapping];

/**
 *
 * @export
 * @interface ApiSvcAssetBasedValuationConfig
 */
export interface ApiSvcAssetBasedValuationConfig {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetBasedValuationConfig
   */
  assetId: string;
  /**
   *
   * @type {ApiSvcAssetValuationStrategies}
   * @memberof ApiSvcAssetBasedValuationConfig
   */
  strategy: ApiSvcAssetValuationStrategies;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcAssetExtractor = {
  Eth: 'ETH',
  Token: 'TOKEN',
  Coin: 'COIN',
  Fiat: 'FIAT',
} as const;

export type ApiSvcAssetExtractor = typeof ApiSvcAssetExtractor[keyof typeof ApiSvcAssetExtractor];

/**
 *
 * @export
 * @interface ApiSvcAssetStakingPoolDetails
 */
export interface ApiSvcAssetStakingPoolDetails {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetStakingPoolDetails
   */
  addressPoolTokens: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetStakingPoolDetails
   */
  totalPoolTokens: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetStakingPoolDetails
   */
  percentOfPool: string;
}
/**
 *
 * @export
 * @interface ApiSvcAssetStakingPoolDetailsInput
 */
export interface ApiSvcAssetStakingPoolDetailsInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetStakingPoolDetailsInput
   */
  percentOfPool: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetStakingPoolDetailsInput
   */
  totalPoolTokens: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetStakingPoolDetailsInput
   */
  addressPoolTokens: string;
}
/**
 *
 * @export
 * @interface ApiSvcAssetStakingTransactionInput
 */
export interface ApiSvcAssetStakingTransactionInput {
  /**
   *
   * @type {ApiSvcDetailedMultiFeeInput}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  fee?: ApiSvcDetailedMultiFeeInput | null;
  /**
   *
   * @type {Array<ApiSvcExchangeRateInput>}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  exchangeRates: Array<ApiSvcExchangeRateInput>;
  /**
   *
   * @type {ApiSvcAddressPointerInput}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  stakingTarget: ApiSvcAddressPointerInput;
  /**
   *
   * @type {ApiSvcAddressPointerInput}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  holdingAddress: ApiSvcAddressPointerInput;
  /**
   *
   * @type {ApiSvcBlockPointerInput}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  block: ApiSvcBlockPointerInput;
  /**
   *
   * @type {ApiSvcAssetStakingPoolDetailsInput}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  poolDetails?: ApiSvcAssetStakingPoolDetailsInput | null;
  /**
   *
   * @type {Array<ApiSvcMultiValueTransactionItemInput>}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  recognizedRevenue?: Array<ApiSvcMultiValueTransactionItemInput> | null;
  /**
   *
   * @type {Array<ApiSvcValueInput>}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  totalHoldings?: Array<ApiSvcValueInput> | null;
  /**
   *
   * @type {Array<ApiSvcValueInput>}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  withdrawnAssets?: Array<ApiSvcValueInput> | null;
  /**
   *
   * @type {Array<ApiSvcValueInput>}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  stakedAssets: Array<ApiSvcValueInput>;
  /**
   *
   * @type {ApiSvcAssetStakingTxnType}
   * @memberof ApiSvcAssetStakingTransactionInput
   */
  type: ApiSvcAssetStakingTxnType;
}

/**
 *
 * @export
 * @interface ApiSvcAssetStakingTxnDetailsDTO
 */
export interface ApiSvcAssetStakingTxnDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  type: string;
  /**
   *
   * @type {Array<ApiSvcValueDetailsDTO>}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  stakedAssets: Array<ApiSvcValueDetailsDTO>;
  /**
   *
   * @type {Array<ApiSvcValueDetailsDTO>}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  withdrawnAssets?: Array<ApiSvcValueDetailsDTO>;
  /**
   *
   * @type {Array<ApiSvcValueDetailsDTO>}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  totalHoldings?: Array<ApiSvcValueDetailsDTO>;
  /**
   *
   * @type {ApiSvcAssetStakingPoolDetails}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  poolDetails?: ApiSvcAssetStakingPoolDetails;
  /**
   *
   * @type {ApiSvcBlockPointer}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  block: ApiSvcBlockPointer;
  /**
   *
   * @type {ApiSvcAddressPointer}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  holdingAddress: ApiSvcAddressPointer;
  /**
   *
   * @type {ApiSvcAddressPointer}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  stakingTarget: ApiSvcAddressPointer;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {Array<ApiSvcMultiValueTxnItemDTO>}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  recognizedRevenue?: Array<ApiSvcMultiValueTxnItemDTO>;
  /**
   *
   * @type {ApiSvcDetailedMultiFeeOutDTO}
   * @memberof ApiSvcAssetStakingTxnDetailsDTO
   */
  fee?: ApiSvcDetailedMultiFeeOutDTO;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcAssetStakingTxnType = {
  LiquidityPoolAdd: 'LiquidityPoolAdd',
  LiquidityPoolRemove: 'LiquidityPoolRemove',
  Stake: 'Stake',
  Unstake: 'Unstake',
  Balance: 'Balance',
  VaultDeposit: 'VaultDeposit',
  VaultWithdraw: 'VaultWithdraw',
  Repayment: 'Repayment',
  Borrow: 'Borrow',
} as const;

export type ApiSvcAssetStakingTxnType = typeof ApiSvcAssetStakingTxnType[keyof typeof ApiSvcAssetStakingTxnType];

/**
 *
 * @export
 * @interface ApiSvcAssetSummary
 */
export interface ApiSvcAssetSummary {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetSummary
   */
  asset: string;
  /**
   *
   * @type {ApiSvcDateRangeFrom}
   * @memberof ApiSvcAssetSummary
   */
  amount: ApiSvcDateRangeFrom;
  /**
   *
   * @type {ApiSvcDateRangeFrom}
   * @memberof ApiSvcAssetSummary
   */
  value: ApiSvcDateRangeFrom;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcAssetValuationStrategies = {
  HistoricalCost: 'historical-cost',
  Impairment: 'impairment',
  MarkToMarket: 'mark-to-market',
  ImpairmentReversalNonRevalued: 'impairment-reversal-non-revalued',
  ImpairmentReversalRevalued: 'impairment-reversal-revalued',
  GaapFairValue: 'gaap-fair-value',
} as const;

export type ApiSvcAssetValuationStrategies =
  typeof ApiSvcAssetValuationStrategies[keyof typeof ApiSvcAssetValuationStrategies];

/**
 *
 * @export
 * @interface ApiSvcAssetValuationStrategy
 */
export interface ApiSvcAssetValuationStrategy {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetValuationStrategy
   */
  ticker: string;
  /**
   *
   * @type {ApiSvcAssetValuationStrategies}
   * @memberof ApiSvcAssetValuationStrategy
   */
  assetValuationStrategy: ApiSvcAssetValuationStrategies;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetValuationStrategy
   */
  currencyId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcAssetValueDTO
 */
export interface ApiSvcAssetValueDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetValueDTO
   */
  assetId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssetValueDTO
   */
  amount: string;
}
/**
 *
 * @export
 * @interface ApiSvcAssetsSummaryResponse
 */
export interface ApiSvcAssetsSummaryResponse {
  /**
   *
   * @type {Array<ApiSvcAssetSummary>}
   * @memberof ApiSvcAssetsSummaryResponse
   */
  items: Array<ApiSvcAssetSummary>;
  /**
   *
   * @type {ApiSvcAssetSummary}
   * @memberof ApiSvcAssetsSummaryResponse
   */
  total: ApiSvcAssetSummary;
}
/**
 *
 * @export
 * @interface ApiSvcAssignPath200Response
 */
export interface ApiSvcAssignPath200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssignPath200Response
   */
  checkListRunId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssignPath200Response
   */
  reportId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssignPath200Response
   */
  sftpPathId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAssignPath200Response
   */
  assignedAt: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssignPath200Response
   */
  assignedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssignPath200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssignPath200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcAssignSftpPathRequest
 */
export interface ApiSvcAssignSftpPathRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAssignSftpPathRequest
   */
  sftpPathId: string;
}
/**
 *
 * @export
 * @interface ApiSvcAssignmentWithPathResponse
 */
export interface ApiSvcAssignmentWithPathResponse {
  /**
   *
   * @type {ApiSvcSftpPathAssignmentDTO}
   * @memberof ApiSvcAssignmentWithPathResponse
   */
  assignment: ApiSvcSftpPathAssignmentDTO;
  /**
   *
   * @type {ApiSvcSftpPathDTO}
   * @memberof ApiSvcAssignmentWithPathResponse
   */
  path: ApiSvcSftpPathDTO;
}
/**
 *
 * @export
 * @interface ApiSvcAuditLogEntryDTO
 */
export interface ApiSvcAuditLogEntryDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  entityType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  entityId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  action: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  timestamp: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  userEmail: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  userName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  category: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcAuditLogEntryDTO
   */
  detail?: string;
}
/**
 *
 * @export
 * @interface ApiSvcBackfillOrgManagedTableResult
 */
export interface ApiSvcBackfillOrgManagedTableResult {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBackfillOrgManagedTableResult
   */
  orgId: string;
  /**
   *
   * @type {ApiSvcOrgManagedTableTypes}
   * @memberof ApiSvcBackfillOrgManagedTableResult
   */
  tableType: ApiSvcOrgManagedTableTypes;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBackfillOrgManagedTableResult
   */
  ok: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBackfillOrgManagedTableResult
   */
  skipped: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBackfillOrgManagedTableResult
   */
  rowsCopied?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBackfillOrgManagedTableResult
   */
  migratedAtSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBackfillOrgManagedTableResult
   */
  error?: string;
}

/**
 *
 * @export
 * @interface ApiSvcBadApiKeyError
 */
export interface ApiSvcBadApiKeyError {
  /**
   *
   * @type {ApiSvcPermanantlyFatalErrorReasonBadApiKey}
   * @memberof ApiSvcBadApiKeyError
   */
  errorType: ApiSvcPermanantlyFatalErrorReasonBadApiKey;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBadApiKeyError
   */
  rawMessage?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBadApiKeyError
   */
  httpStatus?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcBadApiKeyError
   */
  metadata?: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBadApiKeyError
   */
  credentialType?: string;
}

/**
 *
 * @export
 * @interface ApiSvcBalanceCheckJobRequest
 */
export interface ApiSvcBalanceCheckJobRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCheckJobRequest
   */
  associatedSyncJobRunId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBalanceCheckJobRequest
   */
  syncJobPipelineFreshness: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCheckJobRequest
   */
  correlationId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcBalanceCheckJobRequest
   */
  walletIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCheckJobRequest
   */
  connectionId?: string;
  /**
   *
   * @type {ApiSvcBalanceCheckTolerances}
   * @memberof ApiSvcBalanceCheckJobRequest
   */
  tolerances?: ApiSvcBalanceCheckTolerances;
}
/**
 *
 * @export
 * @interface ApiSvcBalanceCheckResultDTO
 */
export interface ApiSvcBalanceCheckResultDTO {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBalanceCheckResultDTO
   */
  metaSuccess: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBalanceCheckResultDTO
   */
  metaIsNegative: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCheckResultDTO
   */
  serviceName?: string;
  /**
   *
   * @type {Array<ApiSvcBalanceCompareResultDTO>}
   * @memberof ApiSvcBalanceCheckResultDTO
   */
  results: Array<ApiSvcBalanceCompareResultDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCheckResultDTO
   */
  balanceId: string;
}
/**
 *
 * @export
 * @interface ApiSvcBalanceCheckTolerances
 */
export interface ApiSvcBalanceCheckTolerances {
  /**
   *
   * @type {number}
   * @memberof ApiSvcBalanceCheckTolerances
   */
  absoluteThreshold?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBalanceCheckTolerances
   */
  relativeThreshold?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBalanceCheckTolerances
   */
  failOnNegativeBalance?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcBalanceCompareResult
 */
export interface ApiSvcBalanceCompareResult {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCompareResult
   */
  controlSourceName: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBalanceCompareResult
   */
  controlTimestamp: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCompareResult
   */
  testSourceName: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBalanceCompareResult
   */
  testTimestamp: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCompareResult
   */
  totalFiatValue?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCompareResult
   */
  totalFiatDelta?: string;
  /**
   *
   * @type {Array<ApiSvcLineDelta>}
   * @memberof ApiSvcBalanceCompareResult
   */
  lineDeltas: Array<ApiSvcLineDelta>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBalanceCompareResult
   */
  succeedsThresholdCheck: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBalanceCompareResult
   */
  isNegative: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcBalanceCompareResult
   */
  warnings: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcBalanceCompareResultDTO
 */
export interface ApiSvcBalanceCompareResultDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  controlSource: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  controlTimestamp: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  testSource: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  testTimestamp: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  totalFiatValue: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  totalFiatDelta: string;
  /**
   *
   * @type {Array<ApiSvcLineDeltaDTO>}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  lineDeltas: Array<ApiSvcLineDeltaDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  succeedsThresholdCheck: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  isNegative: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcBalanceCompareResultDTO
   */
  warnings: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcBalanceType = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;

export type ApiSvcBalanceType = typeof ApiSvcBalanceType[keyof typeof ApiSvcBalanceType];

/**
 *
 * @export
 * @interface ApiSvcBatchLookupRequest
 */
export interface ApiSvcBatchLookupRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcBatchLookupRequest
   */
  ids: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcBatchLookupResponse
 */
export interface ApiSvcBatchLookupResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcBatchLookupResponse
   */
  ids: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcBigqueryITableSchema
 */
export interface ApiSvcBigqueryITableSchema {
  /**
   * Describes the fields in a table.
   * @type {Array<ApiSvcITableFieldSchema>}
   * @memberof ApiSvcBigqueryITableSchema
   */
  fields?: Array<ApiSvcITableFieldSchema>;
}
/**
 *
 * @export
 * @interface ApiSvcBillPayTxnDetailsDTO
 */
export interface ApiSvcBillPayTxnDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBillPayTxnDetailsDTO
   */
  billId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBillPayTxnDetailsDTO
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBillPayTxnDetailsDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBillPayTxnDetailsDTO
   */
  description?: string;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcBillPayTxnDetailsDTO
   */
  costBasis: ApiSvcCostBasisDTO;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcBitcoinMultisigDerivationMode = {
  Legacy: 'legacy',
  P2shSegwit: 'p2shSegwit',
  NativeSegwit: 'nativeSegwit',
} as const;

export type ApiSvcBitcoinMultisigDerivationMode =
  typeof ApiSvcBitcoinMultisigDerivationMode[keyof typeof ApiSvcBitcoinMultisigDerivationMode];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcBlockHeightEvaluator = {
  GreaterThanOrEqualTo: '>=',
  LessThanOrEqualTo: '<=',
} as const;

export type ApiSvcBlockHeightEvaluator = typeof ApiSvcBlockHeightEvaluator[keyof typeof ApiSvcBlockHeightEvaluator];

/**
 *
 * @export
 * @interface ApiSvcBlockPointer
 */
export interface ApiSvcBlockPointer {
  /**
   *
   * @type {ApiSvcPointerTypes}
   * @memberof ApiSvcBlockPointer
   */
  type: ApiSvcPointerTypes;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockPointer
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockPointer
   */
  blockId: string;
}

/**
 *
 * @export
 * @interface ApiSvcBlockPointerInput
 */
export interface ApiSvcBlockPointerInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockPointerInput
   */
  blockId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockPointerInput
   */
  networkId: string;
}
/**
 *
 * @export
 * @interface ApiSvcBlockchainTransaction
 */
export interface ApiSvcBlockchainTransaction {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockchainTransaction
   */
  type: ApiSvcBlockchainTransactionTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockchainTransaction
   */
  walletId: string;
  /**
   *
   * @type {ApiSvcBlockchainTransactionDiscoveringAddress}
   * @memberof ApiSvcBlockchainTransaction
   */
  discoveringAddress: ApiSvcBlockchainTransactionDiscoveringAddress;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockchainTransaction
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockchainTransaction
   */
  block: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockchainTransaction
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBlockchainTransaction
   */
  createdSEC: number;
  /**
   *
   * @type {ApiSvcAccountBasedBlockchainTransaction}
   * @memberof ApiSvcBlockchainTransaction
   */
  txn: ApiSvcAccountBasedBlockchainTransaction;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBlockchainTransaction
   */
  fullTransactionDetailsLink?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcBlockchainTransaction
   */
  metadata?: { [key: string]: string };
  /**
   *
   * @type {ApiSvcTxnOrigin}
   * @memberof ApiSvcBlockchainTransaction
   */
  txnOrigin?: ApiSvcTxnOrigin;
}

export const ApiSvcBlockchainTransactionTypeEnum = {
  Blockchain: 'blockchain',
} as const;

export type ApiSvcBlockchainTransactionTypeEnum =
  typeof ApiSvcBlockchainTransactionTypeEnum[keyof typeof ApiSvcBlockchainTransactionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcBlockchainTransactionDiscoveringAddress
 */
export interface ApiSvcBlockchainTransactionDiscoveringAddress {}
/**
 *
 * @export
 * @interface ApiSvcBulkAssignSftpPathRequest
 */
export interface ApiSvcBulkAssignSftpPathRequest {
  /**
   *
   * @type {Array<ApiSvcBulkAssignSftpPathRequestAssignmentsInner>}
   * @memberof ApiSvcBulkAssignSftpPathRequest
   */
  assignments: Array<ApiSvcBulkAssignSftpPathRequestAssignmentsInner>;
}
/**
 *
 * @export
 * @interface ApiSvcBulkAssignSftpPathRequestAssignmentsInner
 */
export interface ApiSvcBulkAssignSftpPathRequestAssignmentsInner {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkAssignSftpPathRequestAssignmentsInner
   */
  sftpPathId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkAssignSftpPathRequestAssignmentsInner
   */
  reportId: string;
}
/**
 *
 * @export
 * @interface ApiSvcBulkCategorizeTransactions200Response
 */
export interface ApiSvcBulkCategorizeTransactions200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactions200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactions200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactions200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcBulkCategorizeTransactionsDTO
 */
export interface ApiSvcBulkCategorizeTransactionsDTO {
  /**
   *
   * @type {ApiSvcBulkCategorizeTransactionsDTOOptions}
   * @memberof ApiSvcBulkCategorizeTransactionsDTO
   */
  options?: ApiSvcBulkCategorizeTransactionsDTOOptions;
  /**
   *
   * @type {ApiSvcBulkCategorizeTransactionsDTOCategorization}
   * @memberof ApiSvcBulkCategorizeTransactionsDTO
   */
  categorization: ApiSvcBulkCategorizeTransactionsDTOCategorization;
}
/**
 *
 * @export
 * @interface ApiSvcBulkCategorizeTransactionsDTOCategorization
 */
export interface ApiSvcBulkCategorizeTransactionsDTOCategorization {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorization
   */
  accountingConnectionId: string;
  /**
   *
   * @type {ApiSvcBulkCategorizeTransactionsDTOCategorizationTransfer}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorization
   */
  transfer?: ApiSvcBulkCategorizeTransactionsDTOCategorizationTransfer;
  /**
   *
   * @type {ApiSvcBulkCategorizeTransactionsDTOCategorizationTransfer}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorization
   */
  trade?: ApiSvcBulkCategorizeTransactionsDTOCategorizationTransfer;
  /**
   *
   * @type {ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorization
   */
  multivalue?: ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue;
}
/**
 *
 * @export
 * @interface ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue
 */
export interface ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue
   */
  receiveCategoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue
   */
  receiveContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue
   */
  sendCategoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue
   */
  sendContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue
   */
  feeCategoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue
   */
  feeContactId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationMultivalue
   */
  txnIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcBulkCategorizeTransactionsDTOCategorizationTransfer
 */
export interface ApiSvcBulkCategorizeTransactionsDTOCategorizationTransfer {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationTransfer
   */
  feeCategoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationTransfer
   */
  feeContactId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOCategorizationTransfer
   */
  txnIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcBulkCategorizeTransactionsDTOOptions
 */
export interface ApiSvcBulkCategorizeTransactionsDTOOptions {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBulkCategorizeTransactionsDTOOptions
   */
  overwriteExistingCategorization?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcBulkTransactionStateUpdateDTO
 */
export interface ApiSvcBulkTransactionStateUpdateDTO {
  /**
   *
   * @type {ApiSvcTransactionStateTransitions}
   * @memberof ApiSvcBulkTransactionStateUpdateDTO
   */
  update: ApiSvcTransactionStateTransitions;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcBulkTransactionStateUpdateDTO
   */
  transactionIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateUpdateDTO
   */
  bulkActionId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcBulkTransactionStateWorkflowStartResponse
 */
export interface ApiSvcBulkTransactionStateWorkflowStartResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  workflowId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  status: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  success: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  processed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  successCount: number;
  /**
   *
   * @type {Array<ApiSvcResolveTransactionsResponseFailedInner>}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  failed: Array<ApiSvcResolveTransactionsResponseFailedInner>;
  /**
   *
   * @type {Array<ApiSvcBulkTransactionWorkflowTxnResult>}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  transactions: Array<ApiSvcBulkTransactionWorkflowTxnResult>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  startTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  closeTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateWorkflowStartResponse
   */
  bulkActionId: string;
}
/**
 *
 * @export
 * @interface ApiSvcBulkTransactionStateWorkflowStatusResponse
 */
export interface ApiSvcBulkTransactionStateWorkflowStatusResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateWorkflowStatusResponse
   */
  workflowId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateWorkflowStatusResponse
   */
  status: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBulkTransactionStateWorkflowStatusResponse
   */
  success: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBulkTransactionStateWorkflowStatusResponse
   */
  processed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBulkTransactionStateWorkflowStatusResponse
   */
  successCount: number;
  /**
   *
   * @type {Array<ApiSvcResolveTransactionsResponseFailedInner>}
   * @memberof ApiSvcBulkTransactionStateWorkflowStatusResponse
   */
  failed: Array<ApiSvcResolveTransactionsResponseFailedInner>;
  /**
   *
   * @type {Array<ApiSvcBulkTransactionWorkflowTxnResult>}
   * @memberof ApiSvcBulkTransactionStateWorkflowStatusResponse
   */
  transactions: Array<ApiSvcBulkTransactionWorkflowTxnResult>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateWorkflowStatusResponse
   */
  startTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionStateWorkflowStatusResponse
   */
  closeTime?: string;
}
/**
 *
 * @export
 * @interface ApiSvcBulkTransactionWorkflowTxnResult
 */
export interface ApiSvcBulkTransactionWorkflowTxnResult {
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionWorkflowTxnResult
   */
  transactionId: string;
  /**
   *
   * @type {ApiSvcBulkTransactionWorkflowTxnStatus}
   * @memberof ApiSvcBulkTransactionWorkflowTxnResult
   */
  status: ApiSvcBulkTransactionWorkflowTxnStatus;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkTransactionWorkflowTxnResult
   */
  error?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcBulkTransactionWorkflowTxnStatus = {
  Pending: 'pending',
  Running: 'running',
  Succeeded: 'succeeded',
  Failed: 'failed',
} as const;

export type ApiSvcBulkTransactionWorkflowTxnStatus =
  typeof ApiSvcBulkTransactionWorkflowTxnStatus[keyof typeof ApiSvcBulkTransactionWorkflowTxnStatus];

/**
 *
 * @export
 * @interface ApiSvcBulkUpdateTransactionStatus200Response
 */
export interface ApiSvcBulkUpdateTransactionStatus200Response {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  success: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  processed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  successCount: number;
  /**
   *
   * @type {Array<ApiSvcResolveTransactionsResponseFailedInner>}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  failed: Array<ApiSvcResolveTransactionsResponseFailedInner>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  workflowId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  status: string;
  /**
   *
   * @type {Array<ApiSvcBulkTransactionWorkflowTxnResult>}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  transactions: Array<ApiSvcBulkTransactionWorkflowTxnResult>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  startTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  closeTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcBulkUpdateTransactionStatus200Response
   */
  bulkActionId: string;
}
/**
 *
 * @export
 * @interface ApiSvcCancelResult
 */
export interface ApiSvcCancelResult {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCancelResult
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCancelResult
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCancelResult
   */
  error?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCategoriesBatch200Response
 */
export interface ApiSvcCategoriesBatch200Response {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategoriesBatch200Response
   */
  ids: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoriesBatch200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoriesBatch200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcCategoriesResponse
 */
export interface ApiSvcCategoriesResponse {
  /**
   *
   * @type {Array<ApiSvcCategoryDTO>}
   * @memberof ApiSvcCategoriesResponse
   */
  items: Array<ApiSvcCategoryDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoriesResponse
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoriesResponse
   */
  nextPage?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizSuccess
 */
export interface ApiSvcCategorizSuccess {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizSuccess
   */
  txnId: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizSuccess
   */
  success: ApiSvcCategorizSuccessSuccessEnum;
}

export const ApiSvcCategorizSuccessSuccessEnum = {
  True: true,
} as const;

export type ApiSvcCategorizSuccessSuccessEnum =
  typeof ApiSvcCategorizSuccessSuccessEnum[keyof typeof ApiSvcCategorizSuccessSuccessEnum];

/**
 *
 * @export
 * @interface ApiSvcCategorizationDTO
 */
export interface ApiSvcCategorizationDTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeSimple}
   * @memberof ApiSvcCategorizationDTO
   */
  type: ApiSvcCategorizationTypeSimple;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcCategorizationDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizationDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  memo?: string;
  /**
   *
   * @type {Array<ApiSvcMultiValueCategorizationItemDTO>}
   * @memberof ApiSvcCategorizationDTO
   */
  items: Array<ApiSvcMultiValueCategorizationItemDTO>;
  /**
   *
   * @type {Array<ApiSvcFeeLineDTO>}
   * @memberof ApiSvcCategorizationDTO
   */
  fees?: Array<ApiSvcFeeLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  totalAmount: string;
  /**
   *
   * @type {Array<ApiSvcMultiContactInvoicePaymentLineDTO>}
   * @memberof ApiSvcCategorizationDTO
   */
  invoices: Array<ApiSvcMultiContactInvoicePaymentLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  invoiceType: string;
  /**
   *
   * @type {ApiSvcInvoicePaymentLineForexDTO}
   * @memberof ApiSvcCategorizationDTO
   */
  forex?: ApiSvcInvoicePaymentLineForexDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  notes: string;
  /**
   *
   * @type {Array<ApiSvcTransferLineDTO>}
   * @memberof ApiSvcCategorizationDTO
   */
  disposedAssets: Array<ApiSvcTransferLineDTO>;
  /**
   *
   * @type {Array<ApiSvcTransferLineDTO>}
   * @memberof ApiSvcCategorizationDTO
   */
  acquiredAssets: Array<ApiSvcTransferLineDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizationDTO
   */
  excludeIntercompanyGainLoss?: boolean;
  /**
   *
   * @type {Array<ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO>}
   * @memberof ApiSvcCategorizationDTO
   */
  unapplied?: Array<ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizationDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizationDTO
   */
  labels?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  accountingConnectionId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategorizationDTO
   */
  dateTimeSec: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizationDTO
   */
  carryForwardCostBasis?: boolean;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcCategorizationDTO
   */
  feeCostBasis?: ApiSvcRawValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  feeContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  feeWalletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  otherAccountId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcTransferDirection}
   * @memberof ApiSvcCategorizationDTO
   */
  transferDirection: ApiSvcTransferDirection;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizationDTO
   */
  taxable: boolean;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcCategorizationDTO
   */
  notionalTransferValue: ApiSvcRawValueDTO;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcCategorizationDTO
   */
  notionalFeeValue?: ApiSvcRawValueDTO;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizationDTO
   */
  taxDetailsMissing?: boolean;
  /**
   *
   * @type {ApiSvcAccountTransferCategorizationDTOExternalTaxDetails}
   * @memberof ApiSvcCategorizationDTO
   */
  externalTaxDetails?: ApiSvcAccountTransferCategorizationDTOExternalTaxDetails;
  /**
   *
   * @type {Array<ApiSvcFlatExchangeRateDTO>}
   * @memberof ApiSvcCategorizationDTO
   */
  exchangeRates?: Array<ApiSvcFlatExchangeRateDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizationDTO
   */
  contactId: string;
  /**
   *
   * @type {ApiSvcSimpleCostBasisDTO}
   * @memberof ApiSvcCategorizationDTO
   */
  costBasis: ApiSvcSimpleCostBasisDTO;
  /**
   *
   * @type {ApiSvcSimpleFeeDTO}
   * @memberof ApiSvcCategorizationDTO
   */
  fee?: ApiSvcSimpleFeeDTO;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationMethod = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
} as const;

export type ApiSvcCategorizationMethod = typeof ApiSvcCategorizationMethod[keyof typeof ApiSvcCategorizationMethod];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationMethodology = {
  Manual: 'manual',
  Inferred: 'inferred',
  Rule: 'rule',
  System: 'system',
  Ops: 'ops',
  Unknown: 'unknown',
} as const;

export type ApiSvcCategorizationMethodology =
  typeof ApiSvcCategorizationMethodology[keyof typeof ApiSvcCategorizationMethodology];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationStatusDTO = {
  All: 'All',
  Uncategorized: 'Uncategorized',
  Categorized: 'Categorized',
} as const;

export type ApiSvcCategorizationStatusDTO =
  typeof ApiSvcCategorizationStatusDTO[keyof typeof ApiSvcCategorizationStatusDTO];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTransactionType = {
  Invoice: 'invoice',
  InvoiceV2: 'invoice-v2',
  Multivalue: 'multivalue',
  Trade: 'trade',
  Transfer: 'transfer',
  AdvanceDefi: 'advance-defi',
  IntercompanyTransfer: 'intercompany-transfer',
  PreCategorizeInvoice: 'pre-categorize-invoice',
  AccountTransfer: 'account-transfer',
} as const;

export type ApiSvcCategorizationTransactionType =
  typeof ApiSvcCategorizationTransactionType[keyof typeof ApiSvcCategorizationTransactionType];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTransactionTypeAdvanceDeFi = {
  AdvanceDefi: 'advance-defi',
} as const;

export type ApiSvcCategorizationTransactionTypeAdvanceDeFi =
  typeof ApiSvcCategorizationTransactionTypeAdvanceDeFi[keyof typeof ApiSvcCategorizationTransactionTypeAdvanceDeFi];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTransactionTypeIntercompanyTransfer = {
  IntercompanyTransfer: 'intercompany-transfer',
} as const;

export type ApiSvcCategorizationTransactionTypeIntercompanyTransfer =
  typeof ApiSvcCategorizationTransactionTypeIntercompanyTransfer[keyof typeof ApiSvcCategorizationTransactionTypeIntercompanyTransfer];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTransactionTypeInvoice = {
  Invoice: 'invoice',
} as const;

export type ApiSvcCategorizationTransactionTypeInvoice =
  typeof ApiSvcCategorizationTransactionTypeInvoice[keyof typeof ApiSvcCategorizationTransactionTypeInvoice];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTransactionTypeInvoiceV2 = {
  InvoiceV2: 'invoice-v2',
} as const;

export type ApiSvcCategorizationTransactionTypeInvoiceV2 =
  typeof ApiSvcCategorizationTransactionTypeInvoiceV2[keyof typeof ApiSvcCategorizationTransactionTypeInvoiceV2];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTransactionTypeMultivalue = {
  Multivalue: 'multivalue',
} as const;

export type ApiSvcCategorizationTransactionTypeMultivalue =
  typeof ApiSvcCategorizationTransactionTypeMultivalue[keyof typeof ApiSvcCategorizationTransactionTypeMultivalue];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTransactionTypePreCategorizeInvoice = {
  PreCategorizeInvoice: 'pre-categorize-invoice',
} as const;

export type ApiSvcCategorizationTransactionTypePreCategorizeInvoice =
  typeof ApiSvcCategorizationTransactionTypePreCategorizeInvoice[keyof typeof ApiSvcCategorizationTransactionTypePreCategorizeInvoice];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTransactionTypeTrade = {
  Trade: 'trade',
} as const;

export type ApiSvcCategorizationTransactionTypeTrade =
  typeof ApiSvcCategorizationTransactionTypeTrade[keyof typeof ApiSvcCategorizationTransactionTypeTrade];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTransactionTypeTransfer = {
  Transfer: 'transfer',
} as const;

export type ApiSvcCategorizationTransactionTypeTransfer =
  typeof ApiSvcCategorizationTransactionTypeTransfer[keyof typeof ApiSvcCategorizationTransactionTypeTransfer];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTypeAccountTransfer = {
  AccountTransfer: 'account-transfer',
} as const;

export type ApiSvcCategorizationTypeAccountTransfer =
  typeof ApiSvcCategorizationTypeAccountTransfer[keyof typeof ApiSvcCategorizationTypeAccountTransfer];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTypeAdvanceDeFi = {
  AdvanceDefi: 'advance-defi',
} as const;

export type ApiSvcCategorizationTypeAdvanceDeFi =
  typeof ApiSvcCategorizationTypeAdvanceDeFi[keyof typeof ApiSvcCategorizationTypeAdvanceDeFi];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTypeIntercompanyTransfer = {
  IntercompanyTransfer: 'intercompany-transfer',
} as const;

export type ApiSvcCategorizationTypeIntercompanyTransfer =
  typeof ApiSvcCategorizationTypeIntercompanyTransfer[keyof typeof ApiSvcCategorizationTypeIntercompanyTransfer];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTypeInvoicePayment = {
  InvoicePayment: 'invoice-payment',
} as const;

export type ApiSvcCategorizationTypeInvoicePayment =
  typeof ApiSvcCategorizationTypeInvoicePayment[keyof typeof ApiSvcCategorizationTypeInvoicePayment];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTypeMultiContactInvoice = {
  MultiContactInvoice: 'multi-contact-invoice',
} as const;

export type ApiSvcCategorizationTypeMultiContactInvoice =
  typeof ApiSvcCategorizationTypeMultiContactInvoice[keyof typeof ApiSvcCategorizationTypeMultiContactInvoice];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTypeMultivalue = {
  Multivalue: 'multivalue',
} as const;

export type ApiSvcCategorizationTypeMultivalue =
  typeof ApiSvcCategorizationTypeMultivalue[keyof typeof ApiSvcCategorizationTypeMultivalue];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTypeSimple = {
  Simple: 'simple',
} as const;

export type ApiSvcCategorizationTypeSimple =
  typeof ApiSvcCategorizationTypeSimple[keyof typeof ApiSvcCategorizationTypeSimple];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTypeTrade = {
  Trade: 'trade',
} as const;

export type ApiSvcCategorizationTypeTrade =
  typeof ApiSvcCategorizationTypeTrade[keyof typeof ApiSvcCategorizationTypeTrade];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizationTypeTransfer = {
  Transfer: 'transfer',
} as const;

export type ApiSvcCategorizationTypeTransfer =
  typeof ApiSvcCategorizationTypeTransfer[keyof typeof ApiSvcCategorizationTypeTransfer];

/**
 *
 * @export
 * @interface ApiSvcCategorizeAdvanceDeFiItemDTO
 */
export interface ApiSvcCategorizeAdvanceDeFiItemDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeAdvanceDeFiItemDTO
   */
  defiWalletId: string;
  /**
   *
   * @type {Array<ApiSvcCategorizeAdvanceDeFiNonPostLineDTO>}
   * @memberof ApiSvcCategorizeAdvanceDeFiItemDTO
   */
  lines: Array<ApiSvcCategorizeAdvanceDeFiNonPostLineDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeAdvanceDeFiNonPostLineDTO
 */
export interface ApiSvcCategorizeAdvanceDeFiNonPostLineDTO {
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcCategorizeAdvanceDeFiNonPostLineDTO
   */
  source: ApiSvcAssetValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeAdvanceDeFiNonPostLineDTO
   */
  walletId: string;
  /**
   *
   * @type {ApiSvcCategorizeLineOperation}
   * @memberof ApiSvcCategorizeAdvanceDeFiNonPostLineDTO
   */
  operation: ApiSvcCategorizeLineOperation;
}

/**
 *
 * @export
 * @interface ApiSvcCategorizeAdvanceDeFiTransactionDTO
 */
export interface ApiSvcCategorizeAdvanceDeFiTransactionDTO {
  /**
   *
   * @type {ApiSvcCategorizationTransactionTypeAdvanceDeFi}
   * @memberof ApiSvcCategorizeAdvanceDeFiTransactionDTO
   */
  type: ApiSvcCategorizationTransactionTypeAdvanceDeFi;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcCategorizeAdvanceDeFiTransactionDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeAdvanceDeFiTransactionDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeAdvanceDeFiTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeAdvanceDeFiTransactionDTO
   */
  accountingConnectionId: string;
  /**
   * exchange rate used in the categorization
   * @type {Array<ApiSvcExchangeRateV2DTO>}
   * @memberof ApiSvcCategorizeAdvanceDeFiTransactionDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateV2DTO>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategorizeAdvanceDeFiTransactionDTO
   */
  exchangeRateVersion: number;
  /**
   *
   * @type {Array<ApiSvcCategorizeAdvanceDeFiItemDTO>}
   * @memberof ApiSvcCategorizeAdvanceDeFiTransactionDTO
   */
  items: Array<ApiSvcCategorizeAdvanceDeFiItemDTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeFeeV2DTO>}
   * @memberof ApiSvcCategorizeAdvanceDeFiTransactionDTO
   */
  fees?: Array<ApiSvcCategorizeFeeV2DTO>;
}

/**
 *
 * @export
 * @interface ApiSvcCategorizeFailure
 */
export interface ApiSvcCategorizeFailure {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeFailure
   */
  reason: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeFailure
   */
  txnId: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeFailure
   */
  success: ApiSvcCategorizeFailureSuccessEnum;
}

export const ApiSvcCategorizeFailureSuccessEnum = {
  False: false,
} as const;

export type ApiSvcCategorizeFailureSuccessEnum =
  typeof ApiSvcCategorizeFailureSuccessEnum[keyof typeof ApiSvcCategorizeFailureSuccessEnum];

/**
 *
 * @export
 * @interface ApiSvcCategorizeFeeDTO
 */
export interface ApiSvcCategorizeFeeDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeFeeDTO
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeFeeDTO
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeFeeDTO
   */
  feeContactId: string;
  /**
   *
   * @type {ApiSvcValueDTO}
   * @memberof ApiSvcCategorizeFeeDTO
   */
  source: ApiSvcValueDTO;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeFeeV2DTO
 */
export interface ApiSvcCategorizeFeeV2DTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeFeeV2DTO
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeFeeV2DTO
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeFeeV2DTO
   */
  feeContactId: string;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcCategorizeFeeV2DTO
   */
  source: ApiSvcAssetValueDTO;
}
/**
 * DTO for categorizing intercompany transfer transactions
 * @export
 * @interface ApiSvcCategorizeIntercompanyTransferTransactionDTO
 */
export interface ApiSvcCategorizeIntercompanyTransferTransactionDTO {
  /**
   *
   * @type {ApiSvcCategorizationTransactionTypeIntercompanyTransfer}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  type: ApiSvcCategorizationTransactionTypeIntercompanyTransfer;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  accountingConnectionId: string;
  /**
   * exchange rate used in the categorization
   * @type {Array<ApiSvcExchangeRateV2DTO>}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateV2DTO>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  exchangeRateVersion: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  notes: string;
  /**
   *
   * @type {Array<ApiSvcIntercompanyTransferAssetDTO>}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  acquired: Array<ApiSvcIntercompanyTransferAssetDTO>;
  /**
   *
   * @type {Array<ApiSvcIntercompanyTransferAssetDTO>}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  disposed: Array<ApiSvcIntercompanyTransferAssetDTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeFeeV2DTO>}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  fees: Array<ApiSvcCategorizeFeeV2DTO>;
  /**
   *
   * @type {ApiSvcNestedExchangeRatesDTO}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  nestedExchangeRates: ApiSvcNestedExchangeRatesDTO;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeIntercompanyTransferTransactionDTO
   */
  excludeIntercompanyGainLoss?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcCategorizeInvoiceDTO
 */
export interface ApiSvcCategorizeInvoiceDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceDTO
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceDTO
   */
  forexCategoryId: string;
  /**
   *
   * @type {ApiSvcValueDTO}
   * @memberof ApiSvcCategorizeInvoiceDTO
   */
  source: ApiSvcValueDTO;
  /**
   *
   * @type {ApiSvcValueDTO}
   * @memberof ApiSvcCategorizeInvoiceDTO
   */
  paid: ApiSvcValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceDTO
   */
  invoiceId: string;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeInvoiceTransactionV2DTO
 */
export interface ApiSvcCategorizeInvoiceTransactionV2DTO {
  /**
   *
   * @type {ApiSvcCategorizationTransactionTypeInvoiceV2}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  type: ApiSvcCategorizationTransactionTypeInvoiceV2;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  accountingConnectionId: string;
  /**
   * exchange rate used in the categorization
   * @type {Array<ApiSvcExchangeRateV2DTO>}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  exchangeRates: Array<ApiSvcExchangeRateV2DTO>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  exchangeRateVersion: number;
  /**
   *
   * @type {Array<ApiSvcCategorizeInvoiceV2DTO>}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  invoices: Array<ApiSvcCategorizeInvoiceV2DTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeUnappliedV2DTO>}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  unapplied?: Array<ApiSvcCategorizeUnappliedV2DTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeFeeV2DTO>}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  fees?: Array<ApiSvcCategorizeFeeV2DTO>;
  /**
   *
   * @type {ApiSvcInvoiceInputType}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  invoiceType: ApiSvcInvoiceInputType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceTransactionV2DTO
   */
  totalFmv: string;
}

/**
 *
 * @export
 * @interface ApiSvcCategorizeInvoiceV2DTO
 */
export interface ApiSvcCategorizeInvoiceV2DTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceV2DTO
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceV2DTO
   */
  forexCategoryId: string;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcCategorizeInvoiceV2DTO
   */
  source: ApiSvcAssetValueDTO;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcCategorizeInvoiceV2DTO
   */
  paid: ApiSvcAssetValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceV2DTO
   */
  invoiceId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeInvoiceV2DTO
   */
  contactId: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizeLineOperation = {
  Send: 'Send',
  Receive: 'Receive',
  Fee: 'Fee',
} as const;

export type ApiSvcCategorizeLineOperation =
  typeof ApiSvcCategorizeLineOperation[keyof typeof ApiSvcCategorizeLineOperation];

/**
 *
 * @export
 * @interface ApiSvcCategorizeMultiValueItemTO
 */
export interface ApiSvcCategorizeMultiValueItemTO {
  /**
   *
   * @type {Array<ApiSvcCategorizeMultiValueLineDTO>}
   * @memberof ApiSvcCategorizeMultiValueItemTO
   */
  lines: Array<ApiSvcCategorizeMultiValueLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeMultiValueItemTO
   */
  contactId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeMultiValueItemTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeMultiValueItemTO
   */
  labels?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeMultiValueLineDTO
 */
export interface ApiSvcCategorizeMultiValueLineDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeMultiValueLineDTO
   */
  categoryId: string;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcCategorizeMultiValueLineDTO
   */
  sourceValue: ApiSvcAssetValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeMultiValueLineDTO
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeMultiValueLineDTO
   */
  description: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeMultiValueLineDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeMultiValueLineDTO
   */
  labels?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategorizeMultiValueLineDTO
   */
  txnLineId?: number;
  /**
   *
   * @type {ApiSvcCategorizeMultiValueLineDTOAttributes}
   * @memberof ApiSvcCategorizeMultiValueLineDTO
   */
  attributes: ApiSvcCategorizeMultiValueLineDTOAttributes;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeMultiValueLineDTOAttributes
 */
export interface ApiSvcCategorizeMultiValueLineDTOAttributes {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeMultiValueLineDTOAttributes
   */
  forceZeroGainLoss?: boolean;
  /**
   *
   * @type {ApiSvcCategorizeLineOperation}
   * @memberof ApiSvcCategorizeMultiValueLineDTOAttributes
   */
  operation: ApiSvcCategorizeLineOperation;
}

/**
 *
 * @export
 * @interface ApiSvcCategorizeMultivalueTransactionDTO
 */
export interface ApiSvcCategorizeMultivalueTransactionDTO {
  /**
   *
   * @type {ApiSvcCategorizationTransactionTypeMultivalue}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  type: ApiSvcCategorizationTransactionTypeMultivalue;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  accountingConnectionId: string;
  /**
   * exchange rate used in the categorization
   * @type {Array<ApiSvcExchangeRateV2DTO>}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateV2DTO>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  exchangeRateVersion: number;
  /**
   *
   * @type {Array<ApiSvcCategorizeMultiValueItemTO>}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  items: Array<ApiSvcCategorizeMultiValueItemTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeMultivalueTransactionDTO
   */
  labels?: Array<string>;
}

/**
 *
 * @export
 * @interface ApiSvcCategorizeResult
 */
export interface ApiSvcCategorizeResult {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeResult
   */
  txnId: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeResult
   */
  success: ApiSvcCategorizeResultSuccessEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeResult
   */
  reason: string;
}

export const ApiSvcCategorizeResultSuccessEnum = {
  False: false,
} as const;

export type ApiSvcCategorizeResultSuccessEnum =
  typeof ApiSvcCategorizeResultSuccessEnum[keyof typeof ApiSvcCategorizeResultSuccessEnum];

/**
 *
 * @export
 * @interface ApiSvcCategorizeTradeAssetDTO
 */
export interface ApiSvcCategorizeTradeAssetDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTradeAssetDTO
   */
  walletId: string;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcCategorizeTradeAssetDTO
   */
  asset: ApiSvcAssetValueDTO;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeTradeTransactionDTO
 */
export interface ApiSvcCategorizeTradeTransactionDTO {
  /**
   *
   * @type {ApiSvcCategorizationTransactionTypeTrade}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  type: ApiSvcCategorizationTransactionTypeTrade;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  accountingConnectionId: string;
  /**
   * exchange rate used in the categorization
   * @type {Array<ApiSvcExchangeRateV2DTO>}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateV2DTO>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  exchangeRateVersion: number;
  /**
   *
   * @type {Array<ApiSvcCategorizeTradeAssetDTO>}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  disposedAssets: Array<ApiSvcCategorizeTradeAssetDTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeTradeAssetDTO>}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  acquiredAssets: Array<ApiSvcCategorizeTradeAssetDTO>;
  /**
   *
   * @type {ApiSvcCategorizeTradeTransactionDTOTradeFees}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  tradeFees?: ApiSvcCategorizeTradeTransactionDTOTradeFees;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeTradeTransactionDTO
   */
  metadataIds?: Array<string>;
}

/**
 *
 * @export
 * @interface ApiSvcCategorizeTradeTransactionDTOTradeFees
 */
export interface ApiSvcCategorizeTradeTransactionDTOTradeFees {
  /**
   *
   * @type {Array<ApiSvcCategorizeTradeAssetDTO>}
   * @memberof ApiSvcCategorizeTradeTransactionDTOTradeFees
   */
  fees: Array<ApiSvcCategorizeTradeAssetDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTradeTransactionDTOTradeFees
   */
  feeContactId: string;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeTransaction200Response
 */
export interface ApiSvcCategorizeTransaction200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransaction200Response
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransaction200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransaction200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransaction200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeTransactionDTO
 */
export interface ApiSvcCategorizeTransactionDTO {
  /**
   *
   * @type {ApiSvcCategorizationTransactionTypeIntercompanyTransfer}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  type: ApiSvcCategorizationTransactionTypeIntercompanyTransfer;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {Array<ApiSvcCategorizeInvoiceV2DTO>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  invoices: Array<ApiSvcCategorizeInvoiceV2DTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeUnappliedV2DTO>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  unapplied?: Array<ApiSvcCategorizeUnappliedV2DTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeFeeV2DTO>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  fees: Array<ApiSvcCategorizeFeeV2DTO>;
  /**
   * exchange rate used in the categorization
   * @type {Array<ApiSvcExchangeRateV2DTO>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateV2DTO>;
  /**
   *
   * @type {ApiSvcInvoiceInputType}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  invoiceType: ApiSvcInvoiceInputType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  totalFmv: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  accountingConnectionId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  exchangeRateVersion: number;
  /**
   *
   * @type {Array<ApiSvcCategorizeAdvanceDeFiItemDTO>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  items: Array<ApiSvcCategorizeAdvanceDeFiItemDTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  labels?: Array<string>;
  /**
   *
   * @type {Array<ApiSvcCategorizeTradeAssetDTO>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  disposedAssets: Array<ApiSvcCategorizeTradeAssetDTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeTradeAssetDTO>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  acquiredAssets: Array<ApiSvcCategorizeTradeAssetDTO>;
  /**
   *
   * @type {ApiSvcCategorizeTradeTransactionDTOTradeFees}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  tradeFees?: ApiSvcCategorizeTradeTransactionDTOTradeFees;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  notes: string;
  /**
   *
   * @type {Array<ApiSvcIntercompanyTransferAssetDTO>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  acquired: Array<ApiSvcIntercompanyTransferAssetDTO>;
  /**
   *
   * @type {Array<ApiSvcIntercompanyTransferAssetDTO>}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  disposed: Array<ApiSvcIntercompanyTransferAssetDTO>;
  /**
   *
   * @type {ApiSvcImputedFeeDetailsDTO}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  imputedFee?: ApiSvcImputedFeeDetailsDTO;
  /**
   *
   * @type {ApiSvcNestedExchangeRatesDTO}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  nestedExchangeRates: ApiSvcNestedExchangeRatesDTO;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeTransactionDTO
   */
  excludeIntercompanyGainLoss?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcCategorizeTransactionParam
 */
export interface ApiSvcCategorizeTransactionParam {
  /**
   *
   * @type {ApiSvcTransactionDataInput}
   * @memberof ApiSvcCategorizeTransactionParam
   */
  transactionData: ApiSvcTransactionDataInput;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransactionParam
   */
  txnId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransactionParam
   */
  orgId: string;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeTransactions200Response
 */
export interface ApiSvcCategorizeTransactions200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransactions200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransactions200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransactions200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeTransferTransactionDTO
 */
export interface ApiSvcCategorizeTransferTransactionDTO {
  /**
   *
   * @type {ApiSvcCategorizationTransactionTypeTransfer}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  type: ApiSvcCategorizationTransactionTypeTransfer;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  accountingConnectionId: string;
  /**
   * exchange rate used in the categorization
   * @type {Array<ApiSvcExchangeRateV2DTO>}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateV2DTO>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  exchangeRateVersion: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  notes: string;
  /**
   *
   * @type {Array<ApiSvcTransferAssetDTO>}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  acquired: Array<ApiSvcTransferAssetDTO>;
  /**
   *
   * @type {Array<ApiSvcTransferAssetDTO>}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  disposed: Array<ApiSvcTransferAssetDTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeFeeV2DTO>}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  fees?: Array<ApiSvcCategorizeFeeV2DTO>;
  /**
   *
   * @type {ApiSvcImputedFeeDetailsDTO}
   * @memberof ApiSvcCategorizeTransferTransactionDTO
   */
  imputedFee?: ApiSvcImputedFeeDetailsDTO;
}

/**
 *
 * @export
 * @interface ApiSvcCategorizeUnappliedDTO
 */
export interface ApiSvcCategorizeUnappliedDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeUnappliedDTO
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeUnappliedDTO
   */
  forexCategoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeUnappliedDTO
   */
  contactId: string;
  /**
   *
   * @type {ApiSvcValueDTO}
   * @memberof ApiSvcCategorizeUnappliedDTO
   */
  source: ApiSvcValueDTO;
  /**
   *
   * @type {ApiSvcValueDTO}
   * @memberof ApiSvcCategorizeUnappliedDTO
   */
  paid: ApiSvcValueDTO;
}
/**
 *
 * @export
 * @interface ApiSvcCategorizeUnappliedV2DTO
 */
export interface ApiSvcCategorizeUnappliedV2DTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeUnappliedV2DTO
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeUnappliedV2DTO
   */
  forexCategoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategorizeUnappliedV2DTO
   */
  contactId: string;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcCategorizeUnappliedV2DTO
   */
  source: ApiSvcAssetValueDTO;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcCategorizeUnappliedV2DTO
   */
  paid: ApiSvcAssetValueDTO;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizedLineDirection = {
  Disposed: 'disposed',
  Acquired: 'acquired',
} as const;

export type ApiSvcCategorizedLineDirection =
  typeof ApiSvcCategorizedLineDirection[keyof typeof ApiSvcCategorizedLineDirection];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizedLineTypeFeeLine = {
  FeeLine: 'fee-line',
} as const;

export type ApiSvcCategorizedLineTypeFeeLine =
  typeof ApiSvcCategorizedLineTypeFeeLine[keyof typeof ApiSvcCategorizedLineTypeFeeLine];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizedLineTypeIntercompanyTransferLine = {
  IntercompanyTransferLine: 'intercompany-transfer-line',
} as const;

export type ApiSvcCategorizedLineTypeIntercompanyTransferLine =
  typeof ApiSvcCategorizedLineTypeIntercompanyTransferLine[keyof typeof ApiSvcCategorizedLineTypeIntercompanyTransferLine];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizedLineTypeInvoicePaymentLine = {
  InvoicePaymentLine: 'invoice-payment-line',
} as const;

export type ApiSvcCategorizedLineTypeInvoicePaymentLine =
  typeof ApiSvcCategorizedLineTypeInvoicePaymentLine[keyof typeof ApiSvcCategorizedLineTypeInvoicePaymentLine];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizedLineTypeMultiContactInvoicePaymentLine = {
  MultiContactInvoicePaymentLine: 'multi-contact-invoice-payment-line',
} as const;

export type ApiSvcCategorizedLineTypeMultiContactInvoicePaymentLine =
  typeof ApiSvcCategorizedLineTypeMultiContactInvoicePaymentLine[keyof typeof ApiSvcCategorizedLineTypeMultiContactInvoicePaymentLine];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizedLineTypeMultiContactInvoiceUnappliedPaymentLine = {
  MultiContactInvoiceUnappliedPaymentLine: 'multi-contact-invoice-unapplied-payment-line',
} as const;

export type ApiSvcCategorizedLineTypeMultiContactInvoiceUnappliedPaymentLine =
  typeof ApiSvcCategorizedLineTypeMultiContactInvoiceUnappliedPaymentLine[keyof typeof ApiSvcCategorizedLineTypeMultiContactInvoiceUnappliedPaymentLine];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizedLineTypeMultiValueLine = {
  MultiValueLine: 'multi-value-line',
} as const;

export type ApiSvcCategorizedLineTypeMultiValueLine =
  typeof ApiSvcCategorizedLineTypeMultiValueLine[keyof typeof ApiSvcCategorizedLineTypeMultiValueLine];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizedLineTypeTradeLine = {
  TradeLine: 'trade-line',
} as const;

export type ApiSvcCategorizedLineTypeTradeLine =
  typeof ApiSvcCategorizedLineTypeTradeLine[keyof typeof ApiSvcCategorizedLineTypeTradeLine];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategorizedLineTypeTransferLine = {
  TransferLine: 'transfer-line',
} as const;

export type ApiSvcCategorizedLineTypeTransferLine =
  typeof ApiSvcCategorizedLineTypeTransferLine[keyof typeof ApiSvcCategorizedLineTypeTransferLine];

/**
 *
 * @export
 * @interface ApiSvcCategoryDTO
 */
export interface ApiSvcCategoryDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoryDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoryDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoryDTO
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoryDTO
   */
  code: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCategoryDTO
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoryDTO
   */
  source: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoryDTO
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCategoryDTO
   */
  accountingConnectionId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCategoryDTO
   */
  lastUpdatedSEC?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategoryTypeIds = {
  Expense: 'expense',
  Revenue: 'revenue',
  Equity: 'equity',
  Liability: 'liability',
  Asset: 'asset',
  Bank: 'bank',
  Other: 'other',
} as const;

export type ApiSvcCategoryTypeIds = typeof ApiSvcCategoryTypeIds[keyof typeof ApiSvcCategoryTypeIds];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCategoryTypes = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
} as const;

export type ApiSvcCategoryTypes = typeof ApiSvcCategoryTypes[keyof typeof ApiSvcCategoryTypes];

/**
 *
 * @export
 * @interface ApiSvcChangelogEntryTransactionChangeLog
 */
export interface ApiSvcChangelogEntryTransactionChangeLog {
  /**
   *
   * @type {string}
   * @memberof ApiSvcChangelogEntryTransactionChangeLog
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcChangelogEntryTransactionChangeLog
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcChangelogEntryTransactionChangeLog
   */
  updatedAt: string;
  /**
   *
   * @type {ApiSvcTransactionChangeLog}
   * @memberof ApiSvcChangelogEntryTransactionChangeLog
   */
  item?: ApiSvcTransactionChangeLog;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcChangelogEntryTransactionChangeLog
   */
  deleted: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcCheckPriceDirty200Response
 */
export interface ApiSvcCheckPriceDirty200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckPriceDirty200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckPriceDirty200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcCheckResult
 */
export interface ApiSvcCheckResult {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckResult
   */
  checkName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckResult
   */
  status: ApiSvcCheckResultStatusEnum;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCheckResult
   */
  itemsScanned: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCheckResult
   */
  exceptions: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckResult
   */
  severity: ApiSvcCheckResultSeverityEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckResult
   */
  notes: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckResult
   */
  taskId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckResult
   */
  commandId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckResult
   */
  reportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckResult
   */
  acceptedReason?: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcCheckResult
   */
  taskOutput?: any;
}

export const ApiSvcCheckResultStatusEnum = {
  Pass: 'PASS',
  Fail: 'FAIL',
  ExceptionsApproved: 'EXCEPTIONS APPROVED',
  Pending: 'PENDING',
} as const;

export type ApiSvcCheckResultStatusEnum = typeof ApiSvcCheckResultStatusEnum[keyof typeof ApiSvcCheckResultStatusEnum];
export const ApiSvcCheckResultSeverityEnum = {
  Blocking: 'Blocking',
  Warning: 'Warning',
} as const;

export type ApiSvcCheckResultSeverityEnum =
  typeof ApiSvcCheckResultSeverityEnum[keyof typeof ApiSvcCheckResultSeverityEnum];

/**
 *
 * @export
 * @interface ApiSvcCheckRuleApplication200Response
 */
export interface ApiSvcCheckRuleApplication200Response {
  /**
   *
   * @type {ApiSvcAccountingDetailsDTO}
   * @memberof ApiSvcCheckRuleApplication200Response
   */
  categorization?: ApiSvcAccountingDetailsDTO;
  /**
   *
   * @type {ApiSvcRuleProcessingResult}
   * @memberof ApiSvcCheckRuleApplication200Response
   */
  result: ApiSvcRuleProcessingResult;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckRuleApplication200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckRuleApplication200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCheckRuleApplication200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcClearCache200Response
 */
export interface ApiSvcClearCache200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcClearCache200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcClearCache200Response
   */
  message: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcClearCache200Response
   */
  success: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcClearCache200Response
   */
  assetCount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcClearCache200Response
   */
  deletedCount?: number;
}
/**
 *
 * @export
 * @interface ApiSvcClearOrgPriceCacheOptions
 */
export interface ApiSvcClearOrgPriceCacheOptions {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcClearOrgPriceCacheOptions
   */
  failed?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcClearOrgPriceCacheOptions
   */
  toDate?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcClearOrgPriceCacheOptions
   */
  fromDate?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcClearOrgPriceCacheOptions
   */
  assets?: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcClientTransferDirection = {
  Deposit: 'deposit',
  Withdrawal: 'withdrawal',
} as const;

export type ApiSvcClientTransferDirection =
  typeof ApiSvcClientTransferDirection[keyof typeof ApiSvcClientTransferDirection];

/**
 *
 * @export
 * @interface ApiSvcCloneCollectionRequest
 */
export interface ApiSvcCloneCollectionRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloneCollectionRequest
   */
  srcCollectionName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloneCollectionRequest
   */
  destCollectionName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloneCollectionRequest
   */
  documentIdsToCopy: string;
}
/**
 *
 * @export
 * @interface ApiSvcCloneOrgConfigDTO
 */
export interface ApiSvcCloneOrgConfigDTO {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  cloneConnectionToken?: boolean;
  /**
   *
   * @type {ApiSvcCloneTypes}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  type: ApiSvcCloneTypes;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  dangerAllowPartialClone?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  cloneRateTables?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  cloneWalletBalances?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  skipInvoices?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  auditMode?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  backgroundMigration?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  generateAuditReport?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  txnUpdatedAfterSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneOrgConfigDTO
   */
  txnUpdatedBeforeSEC?: number;
}

/**
 *
 * @export
 * @interface ApiSvcCloneTxnComparisonReport
 */
export interface ApiSvcCloneTxnComparisonReport {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  tableId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  sourceCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  targetCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  matchedCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  missingTargetCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  stateMatchCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  stateMismatchCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  firestoreCategorizedCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  spannerCategorizedCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  firestoreUncategorizedCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  spannerUncategorizedCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  firestoreIgnoredCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  spannerIgnoredCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  firestoreDeletedCount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneTxnComparisonReport
   */
  spannerDeletedCount: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCloneTypes = {
  Upgrade: 'upgrade',
  Migrate: 'migrate',
  Clone: 'clone',
  Replicate: 'replicate',
} as const;

export type ApiSvcCloneTypes = typeof ApiSvcCloneTypes[keyof typeof ApiSvcCloneTypes];

/**
 *
 * @export
 * @interface ApiSvcCloneWorkflowResult
 */
export interface ApiSvcCloneWorkflowResult {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloneWorkflowResult
   */
  correlationId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloneWorkflowResult
   */
  status: ApiSvcCloneWorkflowResultStatusEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloneWorkflowResult
   */
  toOrgId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloneWorkflowResult
   */
  error?: string;
  /**
   * True when the run was an audit-mode (no-write dry-run).
   * @type {boolean}
   * @memberof ApiSvcCloneWorkflowResult
   */
  auditMode?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCloneWorkflowResult
   */
  backgroundMigration?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCloneWorkflowResult
   */
  upgradeTxnCheckpointSEC?: number;
  /**
   *
   * @type {ApiSvcCloneTxnComparisonReport}
   * @memberof ApiSvcCloneWorkflowResult
   */
  txnComparisonReport?: ApiSvcCloneTxnComparisonReport;
  /**
   * Total number of errors recorded during an audit run. Each failing item/step is also logged with the `CLONE_AUDIT_ERROR` marker — grep the logs by correlationId to recover the specific ids to fix.
   * @type {number}
   * @memberof ApiSvcCloneWorkflowResult
   */
  auditErrorCount?: number;
}

export const ApiSvcCloneWorkflowResultStatusEnum = {
  Completed: 'completed',
  Failed: 'failed',
} as const;

export type ApiSvcCloneWorkflowResultStatusEnum =
  typeof ApiSvcCloneWorkflowResultStatusEnum[keyof typeof ApiSvcCloneWorkflowResultStatusEnum];

/**
 *
 * @export
 * @interface ApiSvcCloseReportWorkflowStatusResponse
 */
export interface ApiSvcCloseReportWorkflowStatusResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloseReportWorkflowStatusResponse
   */
  reportRunId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloseReportWorkflowStatusResponse
   */
  workflowId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloseReportWorkflowStatusResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloseReportWorkflowStatusResponse
   */
  startTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCloseReportWorkflowStatusResponse
   */
  closeTime?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcClosedTransactionStates = {
  Syncing: 'syncing',
  Synced: 'synced',
  FailedToSync: 'failed-to-sync',
  MarkedSynced: 'marked-synced',
  ClosedNeedsReview: 'closed-needs-review',
} as const;

export type ApiSvcClosedTransactionStates =
  typeof ApiSvcClosedTransactionStates[keyof typeof ApiSvcClosedTransactionStates];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCoin = {
  NUMBER_999999: 999999,
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_20: 20,
  NUMBER_30: 30,
  NUMBER_703: 703,
  NUMBER_704: 704,
  NUMBER_731: 731,
  NUMBER_800: 800,
  NUMBER_1000: 1000,
  NUMBER_1001: 1001,
  NUMBER_1002: 1002,
  NUMBER_1003: 1003,
  NUMBER_1005: 1005,
  NUMBER_1012: 1012,
  NUMBER_1018: 1018,
  NUMBER_1022: 1022,
  NUMBER_1023: 1023,
  NUMBER_1025: 1025,
  NUMBER_1041: 1041,
  NUMBER_1044: 1044,
  NUMBER_1072: 1072,
  NUMBER_1087: 1087,
  NUMBER_1103: 1103,
  NUMBER_1107: 1107,
  NUMBER_1152: 1152,
  NUMBER_2435: 2435,
  NUMBER_2729: 2729,
  NUMBER_2882: 2882,
  NUMBER_3170: 3170,
  NUMBER_3315: 3315,
} as const;

export type ApiSvcCoin = typeof ApiSvcCoin[keyof typeof ApiSvcCoin];

/**
 *
 * @export
 * @interface ApiSvcCoinMapping
 */
export interface ApiSvcCoinMapping {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCoinMapping
   */
  currencyId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCoinMapping
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCoinMapping
   */
  unit?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCoinMapping
   */
  networkId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCoinMapping
   */
  networkName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCoinMapping
   */
  nft?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCoinMapping
   */
  tokenId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCoinMapping
   */
  address?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCoinUnit = {
  NUMBER_999999: 999999,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_20: 20,
  NUMBER_30: 30,
  NUMBER_50: 50,
  NUMBER_51: 51,
  NUMBER_52: 52,
  NUMBER_53: 53,
  NUMBER_54: 54,
  NUMBER_55: 55,
  NUMBER_56: 56,
  NUMBER_703: 703,
  NUMBER_704: 704,
  NUMBER_731: 731,
  NUMBER_800: 800,
  NUMBER_1000: 1000,
  NUMBER_1001: 1001,
  NUMBER_1002: 1002,
  NUMBER_1003: 1003,
  NUMBER_1005: 1005,
  NUMBER_1012: 1012,
  NUMBER_1018: 1018,
  NUMBER_1022: 1022,
  NUMBER_1023: 1023,
  NUMBER_1025: 1025,
  NUMBER_1041: 1041,
  NUMBER_1044: 1044,
  NUMBER_1072: 1072,
  NUMBER_1087: 1087,
  NUMBER_1103: 1103,
  NUMBER_1107: 1107,
  NUMBER_1152: 1152,
  NUMBER_2435: 2435,
  NUMBER_2729: 2729,
  NUMBER_2882: 2882,
  NUMBER_3170: 3170,
  NUMBER_3315: 3315,
} as const;

export type ApiSvcCoinUnit = typeof ApiSvcCoinUnit[keyof typeof ApiSvcCoinUnit];

/**
 *
 * @export
 * @interface ApiSvcCoinValue
 */
export interface ApiSvcCoinValue {
  /**
   *
   * @type {number}
   * @memberof ApiSvcCoinValue
   */
  type: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCoinValue
   */
  value: string;
  /**
   * prefers to use currencyId method instead
   * @type {string}
   * @memberof ApiSvcCoinValue
   */
  valueIdentifier: string;
  /**
   *
   * @type {ApiSvcCoin}
   * @memberof ApiSvcCoinValue
   */
  coin: ApiSvcCoin;
  /**
   *
   * @type {ApiSvcCoinUnit}
   * @memberof ApiSvcCoinValue
   */
  coinUnit: ApiSvcCoinUnit;
}

/**
 *
 * @export
 * @interface ApiSvcColumnUniqueValueResponse
 */
export interface ApiSvcColumnUniqueValueResponse {
  /**
   *
   * @type {Array<ApiSvcDateRangeFrom>}
   * @memberof ApiSvcColumnUniqueValueResponse
   */
  values: Array<ApiSvcDateRangeFrom>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcColumnUniqueValueResponse
   */
  nextPageToken?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCombinationDetailsDTO
 */
export interface ApiSvcCombinationDetailsDTO {
  /**
   *
   * @type {Array<number>}
   * @memberof ApiSvcCombinationDetailsDTO
   */
  timestampSECRange?: Array<number>;
  /**
   *
   * @type {ApiSvcCombinationMethods}
   * @memberof ApiSvcCombinationDetailsDTO
   */
  type: ApiSvcCombinationMethods;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCombinationMethods = {
  Combined: 'combined',
  RolledUp: 'rolled-up',
  RolledUpFromTo: 'rolled-up-from-to',
} as const;

export type ApiSvcCombinationMethods = typeof ApiSvcCombinationMethods[keyof typeof ApiSvcCombinationMethods];

/**
 *
 * @export
 * @interface ApiSvcCombineTransactionsV2200Response
 */
export interface ApiSvcCombineTransactionsV2200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCombineTransactionsV2200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCombineTransactionsV2200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCombineTransactionsV2200Response
   */
  traceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCombineTransactionsV2200Response
   */
  id: string;
}
/**
 *
 * @export
 * @interface ApiSvcCombineTransactionsV2200ResponseAnyOf
 */
export interface ApiSvcCombineTransactionsV2200ResponseAnyOf {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCombineTransactionsV2200ResponseAnyOf
   */
  id: string;
}
/**
 *
 * @export
 * @interface ApiSvcCombinedTxnDTO
 */
export interface ApiSvcCombinedTxnDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCombinedTxnDTO
   */
  parentTxnId: string;
  /**
   *
   * @type {ApiSvcCombinationMethods}
   * @memberof ApiSvcCombinedTxnDTO
   */
  type: ApiSvcCombinationMethods;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcComparison = {
  Eq: 'EQ',
  Lt: 'LT',
  Lte: 'LTE',
  Gt: 'GT',
  Gte: 'GTE',
} as const;

export type ApiSvcComparison = typeof ApiSvcComparison[keyof typeof ApiSvcComparison];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcComparisonGraphQL = {
  Eq: 'EQ',
  Lt: 'LT',
  Lte: 'LTE',
  Gt: 'GT',
  Gte: 'GTE',
} as const;

export type ApiSvcComparisonGraphQL = typeof ApiSvcComparisonGraphQL[keyof typeof ApiSvcComparisonGraphQL];

/**
 *
 * @export
 * @interface ApiSvcConfirmAddressManually200Response
 */
export interface ApiSvcConfirmAddressManually200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcConfirmAddressManually200Response
   */
  address: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConfirmAddressManually200Response
   */
  emailSent: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConfirmAddressManually200Response
   */
  enrolled: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConfirmAddressManually200Response
   */
  signature?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConfirmAddressManually200Response
   */
  signatureData?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConfirmAddressManually200Response
   */
  pennyTestAmount?: string;
  /**
   *
   * @type {ApiSvcManualValidation}
   * @memberof ApiSvcConfirmAddressManually200Response
   */
  manualValidation?: ApiSvcManualValidation;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConfirmAddressManually200Response
   */
  stack?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcConnectionCategory = {
  AccountingConnection: 'AccountingConnection',
  ExchangeConnection: 'ExchangeConnection',
  ExchangeConnectionPointer: 'ExchangeConnectionPointer',
} as const;

export type ApiSvcConnectionCategory = typeof ApiSvcConnectionCategory[keyof typeof ApiSvcConnectionCategory];

/**
 *
 * @export
 * @interface ApiSvcConnectionDTO
 */
export interface ApiSvcConnectionDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  orgId: string;
  /**
   *
   * @type {ApiSvcConnectionType}
   * @memberof ApiSvcConnectionDTO
   */
  type: ApiSvcConnectionType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  provider: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcConnectionDTO
   */
  lastSyncSEC?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConnectionDTO
   */
  isDisabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConnectionDTO
   */
  isDeleted: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConnectionDTO
   */
  isSetupComplete: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  location?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  subAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  s3Bucket?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  s3Prefix?: string;
  /**
   *
   * @type {ApiSvcConnectionCategory}
   * @memberof ApiSvcConnectionDTO
   */
  category?: ApiSvcConnectionCategory;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcConnectionDTO
   * @deprecated
   */
  syncerVersion?: number;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcConnectionDTO
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  feeAccountCode?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConnectionDTO
   */
  syncSubAccounts?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  accountCode?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcConnectionDTO
   */
  connectionSpecificFields?: object;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConnectionDTO
   */
  isDefault?: boolean;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcConnectionDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  subAccountName?: string;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcConnectionDTO
   */
  lastSuccessfulJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcConnectionDTO
   */
  lastJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {number}
   * @memberof ApiSvcConnectionDTO
   */
  lastRotatedAt?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionDTO
   */
  keyFingerprint?: string;
}

/**
 *
 * @export
 * @interface ApiSvcConnectionFlags
 */
export interface ApiSvcConnectionFlags {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConnectionFlags
   */
  inferVaultTradeMovements?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcConnectionFlags
   */
  useCompletedAtStartTime?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcConnectionFlags
   */
  syncStartTime?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcConnectionFlags
   */
  syncEndTime?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionFlags
   */
  walletCreateFilter?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcConnectionFlags
   */
  useExtractedSyncerAsOfSEC?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConnectionFlags
   */
  disableWalletsOnCreation?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcConnectionFlags
   */
  useFppsDayEarned?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcConnectionSyncStatus = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_10: 10,
  NUMBER_20: 20,
} as const;

export type ApiSvcConnectionSyncStatus = typeof ApiSvcConnectionSyncStatus[keyof typeof ApiSvcConnectionSyncStatus];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcConnectionType = {
  Xero: 'xero',
  Quickbooks: 'quickbooks',
  Binance: 'binance',
  Bitfinex: 'bitfinex',
  Kraken: 'kraken',
  Itbit: 'itbit',
  Bitstamp: 'bitstamp',
  Gemini: 'gemini',
  Bitgo: 'bitgo',
  Paxos: 'paxos',
  Nydig: 'nydig',
  Bittrex: 'bittrex',
  Ftx: 'ftx',
  Netsuite: 'netsuite',
  Netsuite2024: 'netsuite2024',
  SageIntacct: 'sage-intacct',
  Sfox: 'sfox',
  PrimeTrust: 'prime-trust',
  CoinbasePro: 'coinbase-pro',
  CoinbaseCustody: 'coinbase-custody',
  CoinbaseCommerce: 'coinbase-commerce',
  CoinbasePrime: 'coinbase-prime',
  CoinbaseRetail: 'coinbase-retail',
  Fireblocks: 'fireblocks',
  CryptoDotCom: 'crypto-dot-com',
  Circle: 'circle',
  Foundry: 'foundry',
  FidelityDigitalAssets: 'fidelity-digital-assets',
  Test: 'test',
  Anchorage: 'anchorage',
  Manual: 'manual',
  Request: 'request',
  OracleFusion: 'oracle-fusion',
  Sftp: 'sftp',
} as const;

export type ApiSvcConnectionType = typeof ApiSvcConnectionType[keyof typeof ApiSvcConnectionType];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcConnectionTypes = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_12: 12,
  NUMBER_13: 13,
  NUMBER_14: 14,
  NUMBER_15: 15,
  NUMBER_16: 16,
  NUMBER_17: 17,
  NUMBER_18: 18,
  NUMBER_19: 19,
  NUMBER_20: 20,
  NUMBER_21: 21,
  NUMBER_22: 22,
  NUMBER_23: 23,
  NUMBER_24: 24,
  NUMBER_25: 25,
  NUMBER_26: 26,
  NUMBER_50: 50,
  NUMBER_100: 100,
  NUMBER_200: 200,
  NUMBER_205: 205,
  NUMBER_300: 300,
  NUMBER_400: 400,
  NUMBER_500: 500,
  NUMBER_600: 600,
  NUMBER_999: 999,
} as const;

export type ApiSvcConnectionTypes = typeof ApiSvcConnectionTypes[keyof typeof ApiSvcConnectionTypes];

/**
 *
 * @export
 * @interface ApiSvcConnectionsErrorResponse
 */
export interface ApiSvcConnectionsErrorResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionsErrorResponse
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionsErrorResponse
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcConnectionsResponse
 */
export interface ApiSvcConnectionsResponse {
  /**
   *
   * @type {Array<ApiSvcConnectionDTO>}
   * @memberof ApiSvcConnectionsResponse
   */
  items: Array<ApiSvcConnectionDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionsResponse
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcConnectionsResponse
   */
  nextPage?: string;
}
/**
 *
 * @export
 * @interface ApiSvcContactAddressDTO
 */
export interface ApiSvcContactAddressDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactAddressDTO
   */
  networkId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactAddressDTO
   */
  defaultRevenueCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactAddressDTO
   */
  defaultExpenseCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactAddressDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactAddressDTO
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactAddressDTO
   * @deprecated
   */
  coin?: string;
}
/**
 *
 * @export
 * @interface ApiSvcContactDTO
 */
export interface ApiSvcContactDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  name: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcContactDTO
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  source: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  type: string;
  /**
   *
   * @type {Array<ApiSvcContactAddressDTO>}
   * @memberof ApiSvcContactDTO
   */
  addresses?: Array<ApiSvcContactAddressDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  emailAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  remoteId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  connectionId: string;
  /**
   * Equivalent to connectionId
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  accountingConnectionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  defaultExpenseCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactDTO
   */
  defaultRevenueCategoryId?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcContactDTO
   */
  metadata?: object;
}
/**
 *
 * @export
 * @interface ApiSvcContactErrorResponse
 */
export interface ApiSvcContactErrorResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactErrorResponse
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcContactErrorResponse
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcCostAverageOverride
 */
export interface ApiSvcCostAverageOverride {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCostAverageOverride
   */
  ticker: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCostAverageOverride
   */
  value: number;
}
/**
 *
 * @export
 * @interface ApiSvcCostBasisDTO
 */
export interface ApiSvcCostBasisDTO {
  /**
   *
   * @type {number}
   * @memberof ApiSvcCostBasisDTO
   */
  cost: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCostBasisDTO
   */
  exchangeRate: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCostBasisDTO
   */
  currency: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCostBasisDTO
   */
  invoiceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCostBasisDTO
   */
  notes?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCostBasisDTO
   */
  costBasisType: string;
}
/**
 *
 * @export
 * @interface ApiSvcCostBasisInput
 */
export interface ApiSvcCostBasisInput {
  /**
   *
   * @type {ApiSvcCostBasisType}
   * @memberof ApiSvcCostBasisInput
   */
  costBasisType: ApiSvcCostBasisType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCostBasisInput
   */
  notes?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCostBasisInput
   */
  invoiceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCostBasisInput
   */
  currency: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCostBasisInput
   */
  exchangeRate: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCostBasisInput
   */
  cost: number;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCostBasisType = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
} as const;

export type ApiSvcCostBasisType = typeof ApiSvcCostBasisType[keyof typeof ApiSvcCostBasisType];

/**
 *
 * @export
 * @interface ApiSvcCreateAnchorage
 */
export interface ApiSvcCreateAnchorage {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateAnchorage
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateAnchorage
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateAnchorage
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateAnchorage
   */
  apiKey: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateApiKeyDTO
 */
export interface ApiSvcCreateApiKeyDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateApiKeyDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateApiKeyDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateApiKeyDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateApiKeyDTO
   */
  apiKey: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateBitGoDTO
 */
export interface ApiSvcCreateBitGoDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateBitGoDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateBitGoDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateBitGoDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateBitGoDTO
   */
  token: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateBitstampDTO
 */
export interface ApiSvcCreateBitstampDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateBitstampDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateBitstampDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateBitstampDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateBitstampDTO
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateBitstampDTO
   */
  secret: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateCategoryRequest
 */
export interface ApiSvcCreateCategoryRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCategoryRequest
   */
  connectionId?: string;
  /**
   *
   * @type {ApiSvcAccountingSourceIds}
   * @memberof ApiSvcCreateCategoryRequest
   */
  source: ApiSvcAccountingSourceIds;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCategoryRequest
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCategoryRequest
   */
  name: string;
  /**
   *
   * @type {ApiSvcCategoryTypeIds}
   * @memberof ApiSvcCreateCategoryRequest
   */
  type: ApiSvcCategoryTypeIds;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCategoryRequest
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCategoryRequest
   */
  description: string;
}

/**
 *
 * @export
 * @interface ApiSvcCreateClientTransaction200Response
 */
export interface ApiSvcCreateClientTransaction200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateClientTransaction200Response
   */
  id: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateClientTransaction200Response
   */
  success: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcCreateCoinbasePrime
 */
export interface ApiSvcCreateCoinbasePrime {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbasePrime
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbasePrime
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateCoinbasePrime
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbasePrime
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbasePrime
   */
  passphrase: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbasePrime
   */
  signingKey: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateCoinbaseProDTO
 */
export interface ApiSvcCreateCoinbaseProDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbaseProDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbaseProDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateCoinbaseProDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbaseProDTO
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbaseProDTO
   */
  apiSecret: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateCoinbaseProDTO
   */
  apiPassphrase: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateCoinbaseProDTO
   */
  isPrime?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcCreateConnection200Response
 */
export interface ApiSvcCreateConnection200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateConnection200Response
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateConnection200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateConnection200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateConnectionDTO
 */
export interface ApiSvcCreateConnectionDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateConnectionDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateConnectionDTO
   */
  name?: string;
  /**
   *
   * @type {ApiSvcCreateLocationDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createBinance?: ApiSvcCreateLocationDTO;
  /**
   *
   * @type {ApiSvcCreateFtx}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createFtx?: ApiSvcCreateFtx;
  /**
   *
   * @type {ApiSvcCreateAnchorage}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createAnchorage?: ApiSvcCreateAnchorage;
  /**
   *
   * @type {ApiSvcCreateKeySecretDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createBittrex?: ApiSvcCreateKeySecretDTO;
  /**
   *
   * @type {ApiSvcCreateKeySecretDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createCoinbaseCustody?: ApiSvcCreateKeySecretDTO;
  /**
   *
   * @type {ApiSvcCreateKeySecretDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createBitfinex?: ApiSvcCreateKeySecretDTO;
  /**
   *
   * @type {ApiSvcCreateKeySecretDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createGemini?: ApiSvcCreateKeySecretDTO;
  /**
   *
   * @type {ApiSvcCreatePrimeTrustDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createPrimeTrust?: ApiSvcCreatePrimeTrustDTO;
  /**
   *
   * @type {ApiSvcCreatePrivateKeySecretDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createKraken?: ApiSvcCreatePrivateKeySecretDTO;
  /**
   *
   * @type {ApiSvcCreateXeroDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createXero?: ApiSvcCreateXeroDTO;
  /**
   *
   * @type {ApiSvcCreateNyDig}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createNyDig?: ApiSvcCreateNyDig;
  /**
   *
   * @type {ApiSvcCreateCoinbaseProDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createCoinbasePro?: ApiSvcCreateCoinbaseProDTO;
  /**
   *
   * @type {ApiSvcCreateItBitDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createItBit?: ApiSvcCreateItBitDTO;
  /**
   *
   * @type {ApiSvcCreateBitstampDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createBitstamp?: ApiSvcCreateBitstampDTO;
  /**
   *
   * @type {ApiSvcCreateBitGoDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createBitGo?: ApiSvcCreateBitGoDTO;
  /**
   *
   * @type {ApiSvcCreatePaxosDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createPaxos?: ApiSvcCreatePaxosDTO;
  /**
   *
   * @type {ApiSvcCreateNetSuite}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createNetSuite?: ApiSvcCreateNetSuite;
  /**
   *
   * @type {ApiSvcCreateSageIntacct}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createSageIntacct?: ApiSvcCreateSageIntacct;
  /**
   *
   * @type {ApiSvcCreateSFOX}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createSFOX?: ApiSvcCreateSFOX;
  /**
   *
   * @type {ApiSvcCreateKeySecretDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createCoinbaseCommerce?: ApiSvcCreateKeySecretDTO;
  /**
   *
   * @type {ApiSvcCreateCoinbasePrime}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createCoinbasePrime?: ApiSvcCreateCoinbasePrime;
  /**
   *
   * @type {ApiSvcCreatePrivateKeySecretDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createFireblocks?: ApiSvcCreatePrivateKeySecretDTO;
  /**
   *
   * @type {ApiSvcCreateKeySecretDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createCoinbaseRetail?: ApiSvcCreateKeySecretDTO;
  /**
   *
   * @type {ApiSvcCreateKeySecretDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createCryptoDotCom?: ApiSvcCreateKeySecretDTO;
  /**
   *
   * @type {ApiSvcCreateApiKeyDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createCircle?: ApiSvcCreateApiKeyDTO;
  /**
   *
   * @type {ApiSvcCreateFoundryDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createFoundry?: ApiSvcCreateFoundryDTO;
  /**
   *
   * @type {ApiSvcCreateFidelityDigitalAssets}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createFidelityDigitalAssets?: ApiSvcCreateFidelityDigitalAssets;
  /**
   *
   * @type {ApiSvcCreateRequestApiKeyDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createRequest?: ApiSvcCreateRequestApiKeyDTO;
  /**
   *
   * @type {ApiSvcCreateOracleFusion}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createOracleFusion?: ApiSvcCreateOracleFusion;
  /**
   *
   * @type {ApiSvcCreateSftpDTO}
   * @memberof ApiSvcCreateConnectionDTO
   */
  createSftp?: ApiSvcCreateSftpDTO;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcCreateConnectionDTO
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
}
/**
 *
 * @export
 * @interface ApiSvcCreateFidelityDigitalAssets
 */
export interface ApiSvcCreateFidelityDigitalAssets {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFidelityDigitalAssets
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFidelityDigitalAssets
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateFidelityDigitalAssets
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFidelityDigitalAssets
   */
  clientId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFidelityDigitalAssets
   */
  clientSecret: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateFoundryDTO
 */
export interface ApiSvcCreateFoundryDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFoundryDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFoundryDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateFoundryDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFoundryDTO
   */
  xApiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFoundryDTO
   */
  subAccountName: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateFtx
 */
export interface ApiSvcCreateFtx {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFtx
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFtx
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateFtx
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFtx
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFtx
   */
  apiSecret: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateFtx
   */
  location: ApiSvcCreateFtxLocationEnum;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateFtx
   */
  syncSubAccounts: boolean;
}

export const ApiSvcCreateFtxLocationEnum = {
  Us: 'us',
  Standard: 'standard',
} as const;

export type ApiSvcCreateFtxLocationEnum = typeof ApiSvcCreateFtxLocationEnum[keyof typeof ApiSvcCreateFtxLocationEnum];

/**
 *
 * @export
 * @interface ApiSvcCreateInventoryGroupRequest
 */
export interface ApiSvcCreateInventoryGroupRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateInventoryGroupRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateInventoryGroupRequest
   */
  description?: string;
  /**
   *
   * @type {ApiSvcMissingWalletHandling}
   * @memberof ApiSvcCreateInventoryGroupRequest
   */
  missingWalletHandling?: ApiSvcMissingWalletHandling;
}

/**
 *
 * @export
 * @interface ApiSvcCreateInventoryViewRequest
 */
export interface ApiSvcCreateInventoryViewRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateInventoryViewRequest
   */
  name: string;
  /**
   *
   * @type {ApiSvcGainLossConfigCreateRequest}
   * @memberof ApiSvcCreateInventoryViewRequest
   */
  config: ApiSvcGainLossConfigCreateRequest;
  /**
   *
   * @type {ApiSvcGainLossSetupDTO}
   * @memberof ApiSvcCreateInventoryViewRequest
   */
  strategy: ApiSvcGainLossSetupDTO;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateInventoryViewRequest
   */
  impair: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateInventoryViewRequest
   */
  ignoreNFTs: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateInventoryViewRequest
   */
  ignoreOrgWrappingTreatments: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateInventoryViewRequest
   */
  isReallocatedView?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCreateInventoryViewRequest
   */
  subsidiaryIds?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcCreateItBitDTO
 */
export interface ApiSvcCreateItBitDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateItBitDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateItBitDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateItBitDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateItBitDTO
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateItBitDTO
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateItBitDTO
   */
  secret: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateKeySecretDTO
 */
export interface ApiSvcCreateKeySecretDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateKeySecretDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateKeySecretDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateKeySecretDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateKeySecretDTO
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateKeySecretDTO
   */
  apiSecret: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateLocationDTO
 */
export interface ApiSvcCreateLocationDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateLocationDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateLocationDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateLocationDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateLocationDTO
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateLocationDTO
   */
  apiSecret: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateLocationDTO
   */
  location: ApiSvcCreateLocationDTOLocationEnum;
}

export const ApiSvcCreateLocationDTOLocationEnum = {
  Us: 'us',
  Standard: 'standard',
} as const;

export type ApiSvcCreateLocationDTOLocationEnum =
  typeof ApiSvcCreateLocationDTOLocationEnum[keyof typeof ApiSvcCreateLocationDTOLocationEnum];

/**
 *
 * @export
 * @interface ApiSvcCreateManualAccountingConnection200Response
 */
export interface ApiSvcCreateManualAccountingConnection200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateManualAccountingConnection200Response
   */
  connectionId: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateMetadataDTO
 */
export interface ApiSvcCreateMetadataDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateMetadataDTO
   */
  remoteType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateMetadataDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateMetadataDTO
   */
  remoteId?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcCreateMetadataDTO
   */
  properties?: object;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateMetadataDTO
   */
  enabled?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcCreateNetSuite
 */
export interface ApiSvcCreateNetSuite {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNetSuite
   */
  subsidiary?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNetSuite
   */
  assetAccountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNetSuite
   */
  feeAccountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNetSuite
   */
  account: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNetSuite
   */
  consumerKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNetSuite
   */
  consumerSecret: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNetSuite
   */
  tokenId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNetSuite
   */
  tokenSecret: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNetSuite
   */
  name?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcCreateNetSuite
   */
  accountMappingConfig?: object;
}
/**
 *
 * @export
 * @interface ApiSvcCreateNyDig
 */
export interface ApiSvcCreateNyDig {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNyDig
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNyDig
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateNyDig
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNyDig
   */
  s3Bucket: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateNyDig
   */
  s3Prefix: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateOracleFusion
 */
export interface ApiSvcCreateOracleFusion {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  assetAccountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  feeAccountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  restServerUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  password?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  tokenUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  clientId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  clientSecret?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  scope?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  apiBaseUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateOracleFusion
   */
  useWhitelistedIPs?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOracleFusion
   */
  subsidiary?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateOrgLabelRequest
 */
export interface ApiSvcCreateOrgLabelRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOrgLabelRequest
   */
  id?: string;
  /**
   * Label identifier. Lowercase letters, digits, underscores, and dashes only; letter-leading. Becomes the `labelId` after slug normalization.
   * @type {string}
   * @memberof ApiSvcCreateOrgLabelRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateOrgLabelRequest
   */
  description?: string;
  /**
   * `true` when the label accepts a typed per-transaction slug value (`client_id` -> `client_id:12345` on the transaction). `false` for bare on/off tags like `spam` or `mining_revenue`. Default `false`.
   * @type {boolean}
   * @memberof ApiSvcCreateOrgLabelRequest
   */
  allowSlugs?: boolean;
  /**
   *
   * @type {ApiSvcSlugType}
   * @memberof ApiSvcCreateOrgLabelRequest
   */
  slugType?: ApiSvcSlugType;
  /**
   * Required when `slugType=\'StringRegex\'`. RE2-compatible regex; the BE wraps it with `^…$` at validation time.
   * @type {string}
   * @memberof ApiSvcCreateOrgLabelRequest
   */
  slugValidationPattern?: string;
}

/**
 *
 * @export
 * @interface ApiSvcCreatePath200Response
 */
export interface ApiSvcCreatePath200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePath200Response
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePath200Response
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePath200Response
   */
  connectionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePath200Response
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePath200Response
   */
  serverPath: string;
  /**
   *
   * @type {ApiSvcSftpPathAction}
   * @memberof ApiSvcCreatePath200Response
   */
  action: ApiSvcSftpPathAction;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCreatePath200Response
   */
  createdAt: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePath200Response
   */
  createdBy?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCreatePath200Response
   */
  updatedAt?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePath200Response
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePath200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePath200Response
   */
  message: string;
}

/**
 *
 * @export
 * @interface ApiSvcCreatePaxosDTO
 */
export interface ApiSvcCreatePaxosDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePaxosDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePaxosDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreatePaxosDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePaxosDTO
   */
  clientId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePaxosDTO
   */
  clientSecret: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePaxosDTO
   */
  scope: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePaxosDTO
   */
  itBitUserId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePaxosDTO
   */
  itBitKey?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePaxosDTO
   */
  itBitSecret?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreatePricingContextRoute200Response
 */
export interface ApiSvcCreatePricingContextRoute200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePricingContextRoute200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePricingContextRoute200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreatePrimeTrustDTO
 */
export interface ApiSvcCreatePrimeTrustDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrimeTrustDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrimeTrustDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreatePrimeTrustDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreatePrimeTrustDTO
   */
  useJwt: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrimeTrustDTO
   */
  jwt?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrimeTrustDTO
   */
  user?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrimeTrustDTO
   */
  password?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrimeTrustDTO
   */
  accountId: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreatePrivateKeySecretDTO
 */
export interface ApiSvcCreatePrivateKeySecretDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrivateKeySecretDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrivateKeySecretDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreatePrivateKeySecretDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrivateKeySecretDTO
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreatePrivateKeySecretDTO
   */
  privateKey: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateRequestApiKeyDTO
 */
export interface ApiSvcCreateRequestApiKeyDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateRequestApiKeyDTO
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateRequestApiKeyDTO
   */
  name?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateResult
 */
export interface ApiSvcCreateResult {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateResult
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateResult
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateResult
   */
  error?: string;
}
/**
 * Data transfer object for creating rollup configuration Note: walletRollupRules is an object/map in the DTO for HTTP/TSOA compatibility, but is converted to a Map internally. Format: { \"wallet-id\": WalletRollupRuleData, ... }
 * @export
 * @interface ApiSvcCreateRolledUpJeReportConfigurationDTO
 */
export interface ApiSvcCreateRolledUpJeReportConfigurationDTO {
  /**
   * When true, adjustments from internal transfers are grouped with other adjustments
   * @type {boolean}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  groupInternalTransferAdjustments?: boolean;
  /**
   * Map of subsidiary IDs to their default settings (TSOA-compatible)
   * @type {{ [key: string]: ApiSvcRollupDefaultSettings; }}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  subsidiaryDefaultSettings?: { [key: string]: ApiSvcRollupDefaultSettings };
  /**
   * When true, excludes buy/sell sides of internal transfers (only fees are included)
   * @type {boolean}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  excludeInternalTransfers?: boolean;
  /**
   *
   * @type {ApiSvcEntryTypeOverridesMap}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  entryTypeOverrides?: ApiSvcEntryTypeOverridesMap;
  /**
   * When true, adjustment lines on sell actions are merged into the SELL JE
   * @type {boolean}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  mergeAdjustmentsIntoSale?: boolean;
  /**
   *
   * @type {ApiSvcRollupDefaultSettings}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  defaultSettings: ApiSvcRollupDefaultSettings;
  /**
   * Map of wallet IDs to their rollup rules (TSOA-compatible) Use this instead of Record<string, WalletRollupRuleData> because TSOA doesn\'t handle Record properly
   * @type {{ [key: string]: ApiSvcWalletRollupRuleData; }}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  walletRollupRules?: { [key: string]: ApiSvcWalletRollupRuleData };
  /**
   *
   * @type {Array<ApiSvcRollupGroupBy>}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  defaultGroupBy: Array<ApiSvcRollupGroupBy>;
  /**
   *
   * @type {ApiSvcRollupStrategy}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  defaultRollupStrategy: ApiSvcRollupStrategy;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  connectionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateRolledUpJeReportConfigurationDTO
   */
  name: string;
}

/**
 *
 * @export
 * @interface ApiSvcCreateSFOX
 */
export interface ApiSvcCreateSFOX {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSFOX
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSFOX
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateSFOX
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSFOX
   */
  apiKey: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateSageIntacct
 */
export interface ApiSvcCreateSageIntacct {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSageIntacct
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSageIntacct
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSageIntacct
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSageIntacct
   */
  userPassword: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSageIntacct
   */
  assetAccountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSageIntacct
   */
  feeAccountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSageIntacct
   */
  baseCurrency?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSageIntacct
   */
  sageDigitalAssetAccountCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSageIntacct
   */
  name?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateSftpDTO
 */
export interface ApiSvcCreateSftpDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpDTO
   */
  host: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpDTO
   */
  user: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpDTO
   */
  port: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpDTO
   */
  password?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpDTO
   */
  pemKey?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpDTO
   */
  pemPassword?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpDTO
   */
  pgpPublicKey?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateSftpPathRequest
 */
export interface ApiSvcCreateSftpPathRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpPathRequest
   */
  connectionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpPathRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSftpPathRequest
   */
  serverPath: string;
  /**
   *
   * @type {ApiSvcSftpPathAction}
   * @memberof ApiSvcCreateSftpPathRequest
   */
  action: ApiSvcSftpPathAction;
}

/**
 *
 * @export
 * @interface ApiSvcCreateSodaReportSnapshotRequest
 */
export interface ApiSvcCreateSodaReportSnapshotRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSodaReportSnapshotRequest
   */
  title: string;
  /**
   *
   * @type {ApiSvcRecordType}
   * @memberof ApiSvcCreateSodaReportSnapshotRequest
   */
  recordType: ApiSvcRecordType;
  /**
   *
   * @type {ApiSvcRecordBucketSodaReports}
   * @memberof ApiSvcCreateSodaReportSnapshotRequest
   */
  recordBucket: ApiSvcRecordBucketSodaReports;
  /**
   *
   * @type {Array<ApiSvcSodaLine>}
   * @memberof ApiSvcCreateSodaReportSnapshotRequest
   */
  lines: Array<ApiSvcSodaLine>;
  /**
   *
   * @type {ApiSvcCreateSodaReportSnapshotRequestConfig}
   * @memberof ApiSvcCreateSodaReportSnapshotRequest
   */
  config: ApiSvcCreateSodaReportSnapshotRequestConfig;
}

/**
 *
 * @export
 * @interface ApiSvcCreateSodaReportSnapshotRequestConfig
 */
export interface ApiSvcCreateSodaReportSnapshotRequestConfig {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSodaReportSnapshotRequestConfig
   */
  runId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSodaReportSnapshotRequestConfig
   */
  inventoryViewId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSodaReportSnapshotRequestConfig
   */
  reportAsOfDate: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateSubsidiaryRequest
 */
export interface ApiSvcCreateSubsidiaryRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSubsidiaryRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSubsidiaryRequest
   */
  parentSubsidiaryId: string;
  /**
   *
   * @type {ApiSvcSubsidiaryRelationship}
   * @memberof ApiSvcCreateSubsidiaryRequest
   */
  relationship: ApiSvcSubsidiaryRelationship;
  /**
   *
   * @type {ApiSvcFiat}
   * @memberof ApiSvcCreateSubsidiaryRequest
   */
  baseCurrency: ApiSvcFiat;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateSubsidiaryRequest
   */
  accountingConnectionSubsidiaryId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcCreateTransactionBatch200Response
 */
export interface ApiSvcCreateTransactionBatch200Response {
  /**
   *
   * @type {Array<ApiSvcCreateTransactionBatchItemResult>}
   * @memberof ApiSvcCreateTransactionBatch200Response
   */
  transactions: Array<ApiSvcCreateTransactionBatchItemResult>;
  /**
   *
   * @type {Array<ApiSvcTxnBatchCollisionWarning>}
   * @memberof ApiSvcCreateTransactionBatch200Response
   */
  warnings?: Array<ApiSvcTxnBatchCollisionWarning>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionBatch200Response
   */
  traceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionBatch200Response
   */
  systemId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionBatch200Response
   */
  error: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateTransactionBatch200ResponseAnyOf
 */
export interface ApiSvcCreateTransactionBatch200ResponseAnyOf {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionBatch200ResponseAnyOf
   */
  traceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionBatch200ResponseAnyOf
   */
  systemId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionBatch200ResponseAnyOf
   */
  error: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateTransactionBatchItemResult
 */
export interface ApiSvcCreateTransactionBatchItemResult {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionBatchItemResult
   */
  transactionId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCreateTransactionBatchItemResult
   */
  systemIds: Array<string>;
  /**
   *
   * @type {ApiSvcCreateTransactionBatchItemResultCategorization}
   * @memberof ApiSvcCreateTransactionBatchItemResult
   */
  categorization: ApiSvcCreateTransactionBatchItemResultCategorization;
  /**
   *
   * @type {ApiSvcPersistenceState}
   * @memberof ApiSvcCreateTransactionBatchItemResult
   */
  persisted?: ApiSvcPersistenceState;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionBatchItemResult
   */
  persistedReason?: string;
}

/**
 *
 * @export
 * @interface ApiSvcCreateTransactionBatchItemResultCategorization
 */
export interface ApiSvcCreateTransactionBatchItemResultCategorization {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionBatchItemResultCategorization
   */
  error?: string;
  /**
   *
   * @type {ApiSvcCreateTransactionCategorizationStatus}
   * @memberof ApiSvcCreateTransactionBatchItemResultCategorization
   */
  status: ApiSvcCreateTransactionCategorizationStatus;
}

/**
 *
 * @export
 * @interface ApiSvcCreateTransactionBatchResult
 */
export interface ApiSvcCreateTransactionBatchResult {
  /**
   *
   * @type {Array<ApiSvcCreateTransactionBatchItemResult>}
   * @memberof ApiSvcCreateTransactionBatchResult
   */
  transactions: Array<ApiSvcCreateTransactionBatchItemResult>;
  /**
   *
   * @type {Array<ApiSvcTxnBatchCollisionWarning>}
   * @memberof ApiSvcCreateTransactionBatchResult
   */
  warnings?: Array<ApiSvcTxnBatchCollisionWarning>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCreateTransactionCategorizationStatus = {
  Applied: 'applied',
  NotRequested: 'not_requested',
  Skipped: 'skipped',
  Failed: 'failed',
} as const;

export type ApiSvcCreateTransactionCategorizationStatus =
  typeof ApiSvcCreateTransactionCategorizationStatus[keyof typeof ApiSvcCreateTransactionCategorizationStatus];

/**
 *
 * @export
 * @interface ApiSvcCreateTransactionDTO
 */
export interface ApiSvcCreateTransactionDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  systemId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  blockchainId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  transactionType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  time?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  amount?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  amountTicker?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  cost?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  costTicker?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  fee?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  feeTicker?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateTransactionDTO
   */
  taxExempt?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  categoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  remoteContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  accountingConnectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  fromAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  toAddress?: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcCreateTransactionDTO
   */
  metadata?: any;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCreateTransactionDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  tradeId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransactionDTO
   */
  importId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateTransferRecord
 */
export interface ApiSvcCreateTransferRecord {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransferRecord
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCreateTransferRecord
   */
  createdSEC: number;
  /**
   *
   * @type {ApiSvcClientTransferDirection}
   * @memberof ApiSvcCreateTransferRecord
   */
  direction: ApiSvcClientTransferDirection;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransferRecord
   */
  amount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransferRecord
   */
  ticker: string;
  /**
   *
   * @type {ApiSvcTxnOrigin}
   * @memberof ApiSvcCreateTransferRecord
   */
  txnOrigin: ApiSvcTxnOrigin;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransferRecord
   */
  blockchainId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransferRecord
   */
  networkId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransferRecord
   */
  costBasisAsset?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateTransferRecord
   */
  costBasisAmount?: string;
}

/**
 *
 * @export
 * @interface ApiSvcCreateUser201Response
 */
export interface ApiSvcCreateUser201Response {
  /**
   *
   * @type {ApiSvcCreateUser201ResponseAnyOfMeta}
   * @memberof ApiSvcCreateUser201Response
   */
  meta: ApiSvcCreateUser201ResponseAnyOfMeta;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201Response
   */
  organization: string;
  /**
   *
   * @type {Array<any>}
   * @memberof ApiSvcCreateUser201Response
   */
  groups: Array<any>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateUser201Response
   */
  active: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201Response
   */
  locale: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201Response
   */
  displayName: string;
  /**
   *
   * @type {ApiSvcCreateUser201ResponseAnyOfName}
   * @memberof ApiSvcCreateUser201Response
   */
  name: ApiSvcCreateUser201ResponseAnyOfName;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201Response
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201Response
   */
  id: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCreateUser201Response
   */
  schemas: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201Response
   */
  errors: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateUser201ResponseAnyOf
 */
export interface ApiSvcCreateUser201ResponseAnyOf {
  /**
   *
   * @type {ApiSvcCreateUser201ResponseAnyOfMeta}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  meta: ApiSvcCreateUser201ResponseAnyOfMeta;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  organization: string;
  /**
   *
   * @type {Array<any>}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  groups: Array<any>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  active: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  locale: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  displayName: string;
  /**
   *
   * @type {ApiSvcCreateUser201ResponseAnyOfName}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  name: ApiSvcCreateUser201ResponseAnyOfName;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  id: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCreateUser201ResponseAnyOf
   */
  schemas: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcCreateUser201ResponseAnyOf1
 */
export interface ApiSvcCreateUser201ResponseAnyOf1 {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOf1
   */
  errors: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateUser201ResponseAnyOfMeta
 */
export interface ApiSvcCreateUser201ResponseAnyOfMeta {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOfMeta
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOfMeta
   */
  resourceType: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateUser201ResponseAnyOfName
 */
export interface ApiSvcCreateUser201ResponseAnyOfName {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOfName
   */
  familyName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateUser201ResponseAnyOfName
   */
  givenName: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateVarianceReport200Response
 */
export interface ApiSvcCreateVarianceReport200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateVarianceReport200Response
   */
  csv: string;
  /**
   *
   * @type {ApiSvcCreateVarianceReport200ResponseMetadata}
   * @memberof ApiSvcCreateVarianceReport200Response
   */
  metadata: ApiSvcCreateVarianceReport200ResponseMetadata;
}
/**
 *
 * @export
 * @interface ApiSvcCreateVarianceReport200ResponseMetadata
 */
export interface ApiSvcCreateVarianceReport200ResponseMetadata {
  /**
   *
   * @type {Array<ApiSvcVarianceReportLineV2>}
   * @memberof ApiSvcCreateVarianceReport200ResponseMetadata
   */
  lines: Array<ApiSvcVarianceReportLineV2>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateVarianceReport200ResponseMetadata
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateVarianceReport200ResponseMetadata
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateVarianceReport200ResponseMetadata
   */
  walletId: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateVarianceReport200ResponseMetadata
   */
  coinId: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcCreateWallet200Response
 */
export interface ApiSvcCreateWallet200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWallet200Response
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWallet200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWallet200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateWalletDTO
 */
export interface ApiSvcCreateWalletDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  name: string;
  /**
   *
   * @type {ApiSvcCreateWalletTypes}
   * @memberof ApiSvcCreateWalletDTO
   */
  type: ApiSvcCreateWalletTypes;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  accountingConnection?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  defaultInflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  defaultInflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  defaultOutflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  defaultOutflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  defaultFeeContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  defaultFeeCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  feeContact?: string;
  /**
   *
   * @type {Array<ApiSvcWatchDTO>}
   * @memberof ApiSvcCreateWalletDTO
   */
  watches?: Array<ApiSvcWatchDTO>;
  /**
   *
   * @type {ApiSvcWatchDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  watch?: ApiSvcWatchDTO;
  /**
   *
   * @type {ApiSvcEnterpriseWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  enterpriseWallet?: ApiSvcEnterpriseWalletDTO;
  /**
   *
   * @type {ApiSvcMultisigWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  multisig?: ApiSvcMultisigWalletDTO;
  /**
   *
   * @type {ApiSvcHardwareWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  hardware?: ApiSvcHardwareWalletDTO;
  /**
   *
   * @type {ApiSvcManualWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  manual?: ApiSvcManualWalletDTO;
  /**
   *
   * @type {ApiSvcManualBlockchainWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  manualBlockchain?: ApiSvcManualBlockchainWalletDTO;
  /**
   *
   * @type {ApiSvcUserWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  user?: ApiSvcUserWalletDTO;
  /**
   *
   * @type {ApiSvcAddressWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  addressBasedBlockchain?: ApiSvcAddressWalletDTO;
  /**
   *
   * @type {ApiSvcAccountBasedBlockchainWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  accountBasedBlockchain?: ApiSvcAccountBasedBlockchainWalletDTO;
  /**
   *
   * @type {ApiSvcLrcMarketplaceWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  lrcMarketplace?: ApiSvcLrcMarketplaceWalletDTO;
  /**
   *
   * @type {ApiSvcGroupWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  group?: ApiSvcGroupWalletDTO;
  /**
   *
   * @type {ApiSvcDefiWalletDTO}
   * @memberof ApiSvcCreateWalletDTO
   */
  defi?: ApiSvcDefiWalletDTO;
  /**
   *
   * @type {ApiSvcWalletsFlags}
   * @memberof ApiSvcCreateWalletDTO
   */
  flags?: ApiSvcWalletsFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletDTO
   */
  walletRoleId?: string;
  /**
   *
   * @type {ApiSvcWalletSyncSetting}
   * @memberof ApiSvcCreateWalletDTO
   */
  userSyncSetting?: ApiSvcWalletSyncSetting;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateWalletDTO
   */
  isBalanceMonitoringOnly?: boolean;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcCreateWalletDTO
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
}

/**
 *
 * @export
 * @interface ApiSvcCreateWalletRequest
 */
export interface ApiSvcCreateWalletRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  name: string;
  /**
   *
   * @type {ApiSvcCreateWalletTypes}
   * @memberof ApiSvcCreateWalletRequest
   */
  type: ApiSvcCreateWalletTypes;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  remoteId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  connectionId?: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcCreateWalletRequest
   */
  metadata?: any;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  defaultInflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  defaultInflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  defaultOutflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  defaultOutflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  defaultFeeContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  defaultFeeCategory?: string;
  /**
   *
   * @type {ApiSvcWalletsFlags}
   * @memberof ApiSvcCreateWalletRequest
   */
  flags?: ApiSvcWalletsFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  groupId?: string;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcCreateWalletRequest
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  subsidiaryId?: string;
  /**
   *
   * @type {ApiSvcWalletSyncSetting}
   * @memberof ApiSvcCreateWalletRequest
   */
  userSyncSetting?: ApiSvcWalletSyncSetting;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  accountingConnection?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  feeContact?: string;
  /**
   *
   * @type {Array<ApiSvcWatchDTO>}
   * @memberof ApiSvcCreateWalletRequest
   */
  watches?: Array<ApiSvcWatchDTO>;
  /**
   *
   * @type {ApiSvcWatchDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  watch?: ApiSvcWatchDTO;
  /**
   *
   * @type {ApiSvcEnterpriseWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  enterpriseWallet?: ApiSvcEnterpriseWalletDTO;
  /**
   *
   * @type {ApiSvcMultisigWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  multisig?: ApiSvcMultisigWalletDTO;
  /**
   *
   * @type {ApiSvcHardwareWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  hardware?: ApiSvcHardwareWalletDTO;
  /**
   *
   * @type {ApiSvcManualWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  manual?: ApiSvcManualWalletDTO;
  /**
   *
   * @type {ApiSvcManualBlockchainWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  manualBlockchain?: ApiSvcManualBlockchainWalletDTO;
  /**
   *
   * @type {ApiSvcUserWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  user?: ApiSvcUserWalletDTO;
  /**
   *
   * @type {ApiSvcAddressWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  addressBasedBlockchain?: ApiSvcAddressWalletDTO;
  /**
   *
   * @type {ApiSvcAccountBasedBlockchainWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  accountBasedBlockchain?: ApiSvcAccountBasedBlockchainWalletDTO;
  /**
   *
   * @type {ApiSvcLrcMarketplaceWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  lrcMarketplace?: ApiSvcLrcMarketplaceWalletDTO;
  /**
   *
   * @type {ApiSvcGroupWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  group?: ApiSvcGroupWalletDTO;
  /**
   *
   * @type {ApiSvcDefiWalletDTO}
   * @memberof ApiSvcCreateWalletRequest
   */
  defi?: ApiSvcDefiWalletDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequest
   */
  walletRoleId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateWalletRequest
   */
  isBalanceMonitoringOnly?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcCreateWalletRequestDTO
 */
export interface ApiSvcCreateWalletRequestDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  name: string;
  /**
   *
   * @type {ApiSvcWalletTypes}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  type: ApiSvcWalletTypes;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  remoteId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  connectionId?: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  metadata?: any;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  defaultInflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  defaultInflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  defaultOutflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  defaultOutflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  defaultFeeContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  defaultFeeCategory?: string;
  /**
   *
   * @type {ApiSvcWalletsFlags}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  flags?: ApiSvcWalletsFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  groupId?: string;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {ApiSvcWalletSyncSetting}
   * @memberof ApiSvcCreateWalletRequestDTO
   */
  userSyncSetting?: ApiSvcWalletSyncSetting;
}

/**
 *
 * @export
 * @interface ApiSvcCreateWalletResponse
 */
export interface ApiSvcCreateWalletResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletResponse
   */
  walletId: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateWalletRoleRequestDTO
 */
export interface ApiSvcCreateWalletRoleRequestDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRoleRequestDTO
   */
  name: string;
}
/**
 *
 * @export
 * @interface ApiSvcCreateWalletRule200Response
 */
export interface ApiSvcCreateWalletRule200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  ruleId?: string;
  /**
   *
   * @type {ApiSvcWalletRuleType}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  ruleType?: ApiSvcWalletRuleType;
  /**
   *
   * @type {ApiSvcSubsidiary}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  ruleValue?: ApiSvcSubsidiary;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  metadataKey?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  metadataValue?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  enabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  isDeleted: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  createdAtSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  updatedAtSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  deletedAtSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRule200Response
   */
  message: string;
}

/**
 *
 * @export
 * @interface ApiSvcCreateWalletRuleRequest
 */
export interface ApiSvcCreateWalletRuleRequest {
  /**
   *
   * @type {ApiSvcWalletRuleType}
   * @memberof ApiSvcCreateWalletRuleRequest
   */
  ruleType: ApiSvcWalletRuleType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRuleRequest
   */
  subsidiaryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRuleRequest
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRuleRequest
   */
  metadataKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateWalletRuleRequest
   */
  metadataValue: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCreateWalletTypes = {
  Eh: 'eh',
  Watch: 'watch',
  Multisig: 'multisig',
  Hardware: 'hardware',
  Manual: 'manual',
  User: 'user',
  AccountBasedBlockchain: 'accountBasedBlockchain',
  LrcMarketplace: 'lrc-marketplace',
  Group: 'group',
  Celo: 'celo',
  Polygon: 'polygon',
  Avalanche: 'avalanche',
  Stx: 'stx',
  Heco: 'heco',
  Bsc: 'bsc',
  Klay: 'klay',
  Loopring: 'loopring',
  Flow: 'flow',
  Mina: 'mina',
  Optimism: 'optimism',
  Defi: 'defi',
} as const;

export type ApiSvcCreateWalletTypes = typeof ApiSvcCreateWalletTypes[keyof typeof ApiSvcCreateWalletTypes];

/**
 *
 * @export
 * @interface ApiSvcCreateXeroDTO
 */
export interface ApiSvcCreateXeroDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateXeroDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateXeroDTO
   */
  exchangeContactId: string;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcCreateXeroDTO
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateXeroDTO
   */
  consumerKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateXeroDTO
   */
  consumerSecret: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateXeroDTO
   */
  accountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCreateXeroDTO
   */
  feeAccountCode: string;
}
/**
 *
 * @export
 * @interface ApiSvcCryptoExchangeTransferMeta
 */
export interface ApiSvcCryptoExchangeTransferMeta {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCryptoExchangeTransferMeta
   */
  cryptoTxId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCryptoExchangeTransferMeta
   */
  fromAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCryptoExchangeTransferMeta
   */
  toAddress?: string;
  /**
   *
   * @type {ApiSvcDateRangeFrom}
   * @memberof ApiSvcCryptoExchangeTransferMeta
   */
  externalStatus?: ApiSvcDateRangeFrom;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCryptoExchangeTransferMeta
   */
  exchangeId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCryptoExchangeTransferMeta
   */
  balance?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCryptoExchangeTransferMeta
   */
  bankName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCryptoExchangeTransferMeta
   */
  holdingPeriodCompletionDate?: string;
}
/**
 *
 * @export
 * @interface ApiSvcCsvExportResponse
 */
export interface ApiSvcCsvExportResponse {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcCsvExportResponse
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcCsvExportResponse
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCsvExportResponse
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCsvExportResponse
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcCsvExportResponse
   */
  metadata?: object;
}

/**
 *
 * @export
 * @interface ApiSvcCustomerReport
 */
export interface ApiSvcCustomerReport {
  /**
   *
   * @type {string}
   * @memberof ApiSvcCustomerReport
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCustomerReport
   */
  customerId: string;
  /**
   *
   * @type {ApiSvcCustomerReportType}
   * @memberof ApiSvcCustomerReport
   */
  type: ApiSvcCustomerReportType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcCustomerReport
   */
  name: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCustomerReportType = {
  GainLoss: 'gain-loss',
} as const;

export type ApiSvcCustomerReportType = typeof ApiSvcCustomerReportType[keyof typeof ApiSvcCustomerReportType];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcCustomerType = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
} as const;

export type ApiSvcCustomerType = typeof ApiSvcCustomerType[keyof typeof ApiSvcCustomerType];

/**
 *
 * @export
 * @interface ApiSvcDataWarehousePersistOptions
 */
export interface ApiSvcDataWarehousePersistOptions {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDataWarehousePersistOptions
   */
  tableName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcDataWarehousePersistOptions
   */
  persistReport?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcDateOrder = {
  Asc: 'asc',
  Desc: 'desc',
} as const;

export type ApiSvcDateOrder = typeof ApiSvcDateOrder[keyof typeof ApiSvcDateOrder];

/**
 * Bounds accept either unix seconds (number or numeric string) or a local YYYY-MM-DD date evaluated in the request\'s `timezone` (UTC fallback) — a date `from` spans from the start of that day, a date `to` through the end of that day. Anything else is rejected with a ValidationError.
 * @export
 * @interface ApiSvcDateRange
 */
export interface ApiSvcDateRange {
  /**
   *
   * @type {ApiSvcDateRangeFrom}
   * @memberof ApiSvcDateRange
   */
  from?: ApiSvcDateRangeFrom;
  /**
   *
   * @type {ApiSvcDateRangeFrom}
   * @memberof ApiSvcDateRange
   */
  to?: ApiSvcDateRangeFrom;
}
/**
 *
 * @export
 * @interface ApiSvcDateRangeFrom
 */
export interface ApiSvcDateRangeFrom {}
/**
 *
 * @export
 * @interface ApiSvcDateValue
 */
export interface ApiSvcDateValue {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDateValue
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDateValue
   */
  value: string;
}
/**
 *
 * @export
 * @interface ApiSvcDeFiCategorizationAction
 */
export interface ApiSvcDeFiCategorizationAction {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcDeFiCategorizationAction
   */
  labels?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDeFiCategorizationAction
   */
  deFiWalletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDeFiCategorizationAction
   */
  feeContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDeFiCategorizationAction
   */
  type: ApiSvcDeFiCategorizationActionTypeEnum;
}

export const ApiSvcDeFiCategorizationActionTypeEnum = {
  DeFiCategorization: 'DeFiCategorization',
} as const;

export type ApiSvcDeFiCategorizationActionTypeEnum =
  typeof ApiSvcDeFiCategorizationActionTypeEnum[keyof typeof ApiSvcDeFiCategorizationActionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcDeFiTransferTransactionInput
 */
export interface ApiSvcDeFiTransferTransactionInput {
  /**
   *
   * @type {ApiSvcDetailedMultiFeeInput}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  fee?: ApiSvcDetailedMultiFeeInput | null;
  /**
   *
   * @type {Array<ApiSvcExchangeRateInput>}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  exchangeRates: Array<ApiSvcExchangeRateInput>;
  /**
   *
   * @type {ApiSvcBlockPointerInput}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  block: ApiSvcBlockPointerInput;
  /**
   *
   * @type {ApiSvcAssetStakingPoolDetailsInput}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  poolDetails?: ApiSvcAssetStakingPoolDetailsInput | null;
  /**
   *
   * @type {Array<ApiSvcMultiValueTransactionItemInput>}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  recognizedRevenue?: Array<ApiSvcMultiValueTransactionItemInput> | null;
  /**
   *
   * @type {Array<ApiSvcValueInput>}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  withdrawnAssets?: Array<ApiSvcValueInput> | null;
  /**
   *
   * @type {Array<ApiSvcValueInput>}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  toTotalHoldings: Array<ApiSvcValueInput>;
  /**
   *
   * @type {Array<ApiSvcValueInput>}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  fromTotalHoldings: Array<ApiSvcValueInput>;
  /**
   *
   * @type {ApiSvcAddressPointerInput}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  toAddress: ApiSvcAddressPointerInput;
  /**
   *
   * @type {ApiSvcAddressPointerInput}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  fromAddress: ApiSvcAddressPointerInput;
  /**
   *
   * @type {ApiSvcAddressPointerInput}
   * @memberof ApiSvcDeFiTransferTransactionInput
   */
  stakingTarget: ApiSvcAddressPointerInput;
}
/**
 *
 * @export
 * @interface ApiSvcDeFiTransferTxnDetailsDTO
 */
export interface ApiSvcDeFiTransferTxnDetailsDTO {
  /**
   *
   * @type {Array<ApiSvcValueDetailsDTO>}
   * @memberof ApiSvcDeFiTransferTxnDetailsDTO
   */
  toTotalHoldings: Array<ApiSvcValueDetailsDTO>;
  /**
   *
   * @type {Array<ApiSvcValueDetailsDTO>}
   * @memberof ApiSvcDeFiTransferTxnDetailsDTO
   */
  fromTotalHoldings: Array<ApiSvcValueDetailsDTO>;
  /**
   *
   * @type {ApiSvcAssetStakingPoolDetails}
   * @memberof ApiSvcDeFiTransferTxnDetailsDTO
   */
  poolDetails?: ApiSvcAssetStakingPoolDetails;
  /**
   *
   * @type {ApiSvcBlockPointer}
   * @memberof ApiSvcDeFiTransferTxnDetailsDTO
   */
  block: ApiSvcBlockPointer;
  /**
   *
   * @type {ApiSvcAddressPointer}
   * @memberof ApiSvcDeFiTransferTxnDetailsDTO
   */
  stakingTarget: ApiSvcAddressPointer;
  /**
   *
   * @type {ApiSvcAddressPointer}
   * @memberof ApiSvcDeFiTransferTxnDetailsDTO
   */
  fromAddress: ApiSvcAddressPointer;
  /**
   *
   * @type {ApiSvcAddressPointer}
   * @memberof ApiSvcDeFiTransferTxnDetailsDTO
   */
  toAddress: ApiSvcAddressPointer;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcDeFiTransferTxnDetailsDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {ApiSvcDetailedMultiFeeOutDTO}
   * @memberof ApiSvcDeFiTransferTxnDetailsDTO
   */
  fee?: ApiSvcDetailedMultiFeeOutDTO;
}
/**
 *
 * @export
 * @interface ApiSvcDefiWalletDTO
 */
export interface ApiSvcDefiWalletDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  walletAddress: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  vaultAddress: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  protocol?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  tokenId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcDefiWalletDTO
   */
  isSyncEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  defaultInflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  defaultInflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  defaultOutflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  defaultOutflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  defaultFeeContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  defaultFeeCategory?: string;
  /**
   *
   * @type {ApiSvcWalletsFlags}
   * @memberof ApiSvcDefiWalletDTO
   */
  flags?: ApiSvcWalletsFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletDTO
   */
  name?: string;
}
/**
 *
 * @export
 * @interface ApiSvcDefiWalletInput
 */
export interface ApiSvcDefiWalletInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletInput
   */
  name?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcDefiWalletInput
   */
  isSyncEnabled?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletInput
   */
  tokenId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletInput
   */
  protocol?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletInput
   */
  vaultAddress: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletInput
   */
  walletAddress: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletInput
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletInput
   */
  groupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDefiWalletInput
   */
  connectionId?: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcDeleteOrgLabelDefinition200Response
 */
export interface ApiSvcDeleteOrgLabelDefinition200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDeleteOrgLabelDefinition200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDeleteOrgLabelDefinition200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
 */
export interface ApiSvcDeprecatedCategorizeInvoiceTransactionDTO {
  /**
   *
   * @type {ApiSvcCategorizationTransactionTypeInvoice}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  type: ApiSvcCategorizationTransactionTypeInvoice;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {Array<ApiSvcCategorizeInvoiceDTO>}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  invoices: Array<ApiSvcCategorizeInvoiceDTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeUnappliedDTO>}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  unapplied?: Array<ApiSvcCategorizeUnappliedDTO>;
  /**
   *
   * @type {Array<ApiSvcCategorizeFeeDTO>}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  fees?: Array<ApiSvcCategorizeFeeDTO>;
  /**
   *
   * @type {Array<ApiSvcDeprecatedExchangeRateDTO>}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  exchangeRates: Array<ApiSvcDeprecatedExchangeRateDTO>;
  /**
   *
   * @type {ApiSvcInvoiceInputType}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  invoiceType: ApiSvcInvoiceInputType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  totalFmv: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDeprecatedCategorizeInvoiceTransactionDTO
   */
  accountingConnectionId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcDeprecatedExchangeRateDTO
 */
export interface ApiSvcDeprecatedExchangeRateDTO {
  /**
   *
   * @type {ApiSvcExchangeRateSource}
   * @memberof ApiSvcDeprecatedExchangeRateDTO
   */
  source?: ApiSvcExchangeRateSource;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDeprecatedExchangeRateDTO
   */
  rate: string;
  /**
   * fiat ticker
   * @type {string}
   * @memberof ApiSvcDeprecatedExchangeRateDTO
   */
  fiat: string;
  /**
   * coin unit
   * @type {string}
   * @memberof ApiSvcDeprecatedExchangeRateDTO
   */
  unit: string;
  /**
   * coin ticker
   * @type {string}
   * @memberof ApiSvcDeprecatedExchangeRateDTO
   */
  coin: string;
}

/**
 *
 * @export
 * @interface ApiSvcDetailCategorizationAction
 */
export interface ApiSvcDetailCategorizationAction {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcDetailCategorizationAction
   */
  labels?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcDetailCategorizationAction
   */
  isIntercompanyTransfer?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcDetailCategorizationAction
   */
  ignoreFailPricing?: boolean;
  /**
   *
   * @type {Array<ApiSvcDetailedCategorizationActionLines>}
   * @memberof ApiSvcDetailCategorizationAction
   */
  lines: Array<ApiSvcDetailedCategorizationActionLines>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailCategorizationAction
   */
  type: ApiSvcDetailCategorizationActionTypeEnum;
}

export const ApiSvcDetailCategorizationActionTypeEnum = {
  DetailedCategorization: 'DetailedCategorization',
} as const;

export type ApiSvcDetailCategorizationActionTypeEnum =
  typeof ApiSvcDetailCategorizationActionTypeEnum[keyof typeof ApiSvcDetailCategorizationActionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcDetailedCategorizationActionLines
 */
export interface ApiSvcDetailedCategorizationActionLines {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcDetailedCategorizationActionLines
   */
  labels?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcDetailedCategorizationActionLines
   */
  metadataIds?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedCategorizationActionLines
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedCategorizationActionLines
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedCategorizationActionLines
   */
  lineQualifierExtractor?: string | null;
  /**
   *
   * @type {ApiSvcAssetExtractor}
   * @memberof ApiSvcDetailedCategorizationActionLines
   */
  assetExtractor: ApiSvcAssetExtractor;
  /**
   *
   * @type {ApiSvcValueExtractor}
   * @memberof ApiSvcDetailedCategorizationActionLines
   */
  valueExtractor: ApiSvcValueExtractor;
}

/**
 *
 * @export
 * @interface ApiSvcDetailedFeeDTO
 */
export interface ApiSvcDetailedFeeDTO {
  /**
   *
   * @type {ApiSvcAmountDTO}
   * @memberof ApiSvcDetailedFeeDTO
   */
  fee: ApiSvcAmountDTO;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcDetailedFeeDTO
   */
  cost: ApiSvcCostBasisDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedFeeDTO
   */
  feePayeeId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedFeeDTO
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedFeeDTO
   */
  walletId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcDetailedFeeDTO
   */
  imputed?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedFeeDTO
   */
  imputedFeeDirection?: string;
}
/**
 *
 * @export
 * @interface ApiSvcDetailedFeeInput
 */
export interface ApiSvcDetailedFeeInput {
  /**
   *
   * @type {ApiSvcImputedFeeDirection}
   * @memberof ApiSvcDetailedFeeInput
   */
  imputedFeeDirection?: ApiSvcImputedFeeDirection | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcDetailedFeeInput
   */
  imputed?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedFeeInput
   */
  walletId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedFeeInput
   */
  feeCategoryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedFeeInput
   */
  feeContactId: string;
  /**
   *
   * @type {ApiSvcCostBasisInput}
   * @memberof ApiSvcDetailedFeeInput
   */
  costBasis: ApiSvcCostBasisInput;
  /**
   *
   * @type {ApiSvcUncheckedAmountInput}
   * @memberof ApiSvcDetailedFeeInput
   */
  amount?: ApiSvcUncheckedAmountInput | null;
}

/**
 *
 * @export
 * @interface ApiSvcDetailedForexDTO
 */
export interface ApiSvcDetailedForexDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedForexDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedForexDTO
   */
  amount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedForexDTO
   */
  fiat: string;
}
/**
 *
 * @export
 * @interface ApiSvcDetailedMultiFeeInput
 */
export interface ApiSvcDetailedMultiFeeInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedMultiFeeInput
   */
  feeContactId: string;
  /**
   *
   * @type {Array<ApiSvcFeeItemInput>}
   * @memberof ApiSvcDetailedMultiFeeInput
   */
  feeItems?: Array<ApiSvcFeeItemInput> | null;
}
/**
 *
 * @export
 * @interface ApiSvcDetailedMultiFeeOutDTO
 */
export interface ApiSvcDetailedMultiFeeOutDTO {
  /**
   *
   * @type {Array<ApiSvcFeeItemOutDTO>}
   * @memberof ApiSvcDetailedMultiFeeOutDTO
   */
  feeItems: Array<ApiSvcFeeItemOutDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedMultiFeeOutDTO
   */
  feeContactId: string;
}
/**
 *
 * @export
 * @interface ApiSvcDetailedTxnDTO
 */
export interface ApiSvcDetailedTxnDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedTxnDTO
   */
  orgId: string;
  /**
   *
   * @type {Array<ApiSvcDetailedTxnItemDTO>}
   * @memberof ApiSvcDetailedTxnDTO
   */
  items: Array<ApiSvcDetailedTxnItemDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedTxnDTO
   */
  notes?: string;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcDetailedTxnDTO
   */
  costBasis: ApiSvcCostBasisDTO;
}
/**
 *
 * @export
 * @interface ApiSvcDetailedTxnItemDTO
 */
export interface ApiSvcDetailedTxnItemDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedTxnItemDTO
   */
  contactId: string;
  /**
   *
   * @type {Array<ApiSvcDetailedTxnLineDTO>}
   * @memberof ApiSvcDetailedTxnItemDTO
   */
  lines: Array<ApiSvcDetailedTxnLineDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcDetailedTxnLineDTO
 */
export interface ApiSvcDetailedTxnLineDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedTxnLineDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcDetailedTxnLineDTO
   */
  description?: string;
  /**
   *
   * @type {ApiSvcSimpleAmountDTO}
   * @memberof ApiSvcDetailedTxnLineDTO
   */
  amount: ApiSvcSimpleAmountDTO;
}
/**
 *
 * @export
 * @interface ApiSvcDisplayConfigDTO
 */
export interface ApiSvcDisplayConfigDTO {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcDisplayConfigDTO
   */
  useOrgTimezone: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcDownloadCloseReport200Response
 */
export interface ApiSvcDownloadCloseReport200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcDownloadCloseReport200Response
   */
  downloadUrl: string;
}
/**
 *
 * @export
 * @interface ApiSvcEmailAuthCodeParams
 */
export interface ApiSvcEmailAuthCodeParams {
  /**
   *
   * @type {string}
   * @memberof ApiSvcEmailAuthCodeParams
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEmailAuthCodeParams
   */
  code: string;
}
/**
 *
 * @export
 * @interface ApiSvcEnableConnectionMetadataRequest
 */
export interface ApiSvcEnableConnectionMetadataRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcEnableConnectionMetadataRequest
   */
  metadataIds?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcEnterprisePaymentSettings
 */
export interface ApiSvcEnterprisePaymentSettings {
  /**
   *
   * @type {string}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  defaultForexCategoryId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  pricingSources: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  pricingTimezone: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  kycProvider: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  custodian: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  enabledCryptoCurrencies: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  enabledFiats: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  locked: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  remittanceContactEmail?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  remittanceSenderName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  isKytDisabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  defaultPricingMethod?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  defaultFeeContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEnterprisePaymentSettings
   */
  defaultFeeCategoryId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcEnterpriseWalletDTO
 */
export interface ApiSvcEnterpriseWalletDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcEnterpriseWalletDTO
   */
  cosigners: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcEnterpriseWalletDTO
   */
  minCosigners: number;
}
/**
 *
 * @export
 * @interface ApiSvcEnterpriseWalletInput
 */
export interface ApiSvcEnterpriseWalletInput {
  /**
   *
   * @type {number}
   * @memberof ApiSvcEnterpriseWalletInput
   */
  minCosigners: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcEnterpriseWalletInput
   */
  cosigners: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcEntryLine
 */
export interface ApiSvcEntryLine {
  /**
   *
   * @type {ApiSvcFiatValue}
   * @memberof ApiSvcEntryLine
   */
  amount: ApiSvcFiatValue;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryLine
   */
  description: string;
  /**
   *
   * @type {Array<ApiSvcAccountingEntryMetadata>}
   * @memberof ApiSvcEntryLine
   */
  metadata?: Array<ApiSvcAccountingEntryMetadata>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryLine
   */
  accountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryLine
   */
  accountRemoteId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryLine
   */
  accountName: string;
  /**
   *
   * @type {ApiSvcCategoryTypes}
   * @memberof ApiSvcEntryLine
   */
  accountType: ApiSvcCategoryTypes;
  /**
   *
   * @type {ApiSvcCoinValue}
   * @memberof ApiSvcEntryLine
   */
  cryptoAmount?: ApiSvcCoinValue;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryLine
   */
  internalCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryLine
   */
  relatedInvocieId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryLine
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryLine
   */
  overrideAssetAccountCode?: string;
  /**
   *
   * @type {ApiSvcAccountingTransactionDirection}
   * @memberof ApiSvcEntryLine
   */
  direction?: ApiSvcAccountingTransactionDirection;
  /**
   * whether to exclude this entry line from the journal report this should ONLY be used for internal transfers. we only want the outer accounting entry not this line
   * @type {boolean}
   * @memberof ApiSvcEntryLine
   */
  excludeFromJournalReport?: boolean;
}

/**
 * Details about a single entry push result
 * @export
 * @interface ApiSvcEntryPushResult
 */
export interface ApiSvcEntryPushResult {
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryPushResult
   */
  entryId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcEntryPushResult
   */
  transactionIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryPushResult
   */
  erpEntryId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcEntryPushResult
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcEntryPushResult
   */
  error?: string;
}
/**
 * Default settings for a specific entry type (gain/loss or adjustment)
 * @export
 * @interface ApiSvcEntryTypeDefaultSettings
 */
export interface ApiSvcEntryTypeDefaultSettings {
  /**
   * GL account code for this entry type
   * @type {string}
   * @memberof ApiSvcEntryTypeDefaultSettings
   */
  accountCode: string;
  /**
   * Default contact ID for this entry type
   * @type {string}
   * @memberof ApiSvcEntryTypeDefaultSettings
   */
  contactId?: string;
  /**
   * Metadata key-value map (TSOA-compatible alternative to Record<string, string>)
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcEntryTypeDefaultSettings
   */
  metadata?: { [key: string]: string };
}
/**
 * Map of entry types to their rollup settings overrides
 * @export
 * @interface ApiSvcEntryTypeOverridesMap
 */
export interface ApiSvcEntryTypeOverridesMap {
  /**
   *
   * @type {ApiSvcEntryTypeRollupSettingsData}
   * @memberof ApiSvcEntryTypeOverridesMap
   */
  BUY?: ApiSvcEntryTypeRollupSettingsData;
  /**
   *
   * @type {ApiSvcEntryTypeRollupSettingsData}
   * @memberof ApiSvcEntryTypeOverridesMap
   */
  SELL?: ApiSvcEntryTypeRollupSettingsData;
  /**
   *
   * @type {ApiSvcEntryTypeRollupSettingsData}
   * @memberof ApiSvcEntryTypeOverridesMap
   */
  ADJUSTMENT?: ApiSvcEntryTypeRollupSettingsData;
}
/**
 * Entry type rollup settings as plain object (for DTOs)
 * @export
 * @interface ApiSvcEntryTypeRollupSettingsData
 */
export interface ApiSvcEntryTypeRollupSettingsData {
  /**
   * Minimum transaction value (in base currency) to include. Transactions below this threshold are ignored.
   * @type {number}
   * @memberof ApiSvcEntryTypeRollupSettingsData
   */
  minimumTransactionValue?: number;
  /**
   *
   * @type {Array<ApiSvcRollupGroupBy>}
   * @memberof ApiSvcEntryTypeRollupSettingsData
   */
  groupBy?: Array<ApiSvcRollupGroupBy>;
  /**
   *
   * @type {ApiSvcRollupStrategy}
   * @memberof ApiSvcEntryTypeRollupSettingsData
   */
  strategy?: ApiSvcRollupStrategy;
}

/**
 *
 * @export
 * @interface ApiSvcError
 */
export interface ApiSvcError {
  /**
   *
   * @type {string}
   * @memberof ApiSvcError
   */
  stack?: string;
}
/**
 *
 * @export
 * @interface ApiSvcExchageRateUsedDTO
 */
export interface ApiSvcExchageRateUsedDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchageRateUsedDTO
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchageRateUsedDTO
   */
  to: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchageRateUsedDTO
   */
  rate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchageRateUsedDTO
   */
  priceId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchageRateUsedDTO
   */
  errorMessage?: string;
}
/**
 *
 * @export
 * @interface ApiSvcExchangeCreateParams
 */
export interface ApiSvcExchangeCreateParams {
  /**
   *
   * @type {Array<ApiSvcExchangePayload>}
   * @memberof ApiSvcExchangeCreateParams
   */
  exchanges: Array<ApiSvcExchangePayload>;
}
/**
 *
 * @export
 * @interface ApiSvcExchangePayload
 */
export interface ApiSvcExchangePayload {
  /**
   * The remoteExchangeId from wallet manager svc
   * @type {string}
   * @memberof ApiSvcExchangePayload
   */
  remoteExchangeId: string;
  /**
   *
   * @type {ApiSvcExchangePayloadExchange}
   * @memberof ApiSvcExchangePayload
   */
  exchange: ApiSvcExchangePayloadExchange;
}
/**
 * Wallet payload
 * @export
 * @interface ApiSvcExchangePayloadExchange
 */
export interface ApiSvcExchangePayloadExchange {
  /**
   *
   * @type {ApiSvcCreateConnectionDTO}
   * @memberof ApiSvcExchangePayloadExchange
   */
  createConnection: ApiSvcCreateConnectionDTO;
}
/**
 *
 * @export
 * @interface ApiSvcExchangeRateDTO
 */
export interface ApiSvcExchangeRateDTO {
  /**
   *
   * @type {number}
   * @memberof ApiSvcExchangeRateDTO
   */
  rate: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcExchangeRateDTO
   */
  dateTime: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateDTO
   */
  displayRate: string;
}
/**
 *
 * @export
 * @interface ApiSvcExchangeRateDetails
 */
export interface ApiSvcExchangeRateDetails {
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcExchangeRateDetails
   */
  exchangeRates?: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcExchangeRateDetails
   */
  exchangeRatesDirty?: boolean | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcExchangeRateDetails
   */
  exchangeRatesError?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcExchangeRateDetailsDTO
 */
export interface ApiSvcExchangeRateDetailsDTO {
  /**
   * this is the ticker, not the Id
   * @type {string}
   * @memberof ApiSvcExchangeRateDetailsDTO
   */
  coin: string;
  /**
   * this is name of the unit, not the Id
   * @type {string}
   * @memberof ApiSvcExchangeRateDetailsDTO
   */
  coinUnit: string;
  /**
   * CurrencyId of the asset
   * @type {string}
   * @memberof ApiSvcExchangeRateDetailsDTO
   */
  currencyId: string;
  /**
   * this is the ticker, not the Id
   * @type {string}
   * @memberof ApiSvcExchangeRateDetailsDTO
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateDetailsDTO
   */
  rate: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcExchangeRateDetailsDTO
   */
  failedOrIncomplete: boolean;
  /**
   * the unique pricing id
   * @type {string}
   * @memberof ApiSvcExchangeRateDetailsDTO
   */
  priceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcExchangeRateFailedDTO
 */
export interface ApiSvcExchangeRateFailedDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateFailedDTO
   */
  fromAssetId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateFailedDTO
   */
  toAssetId: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeFailed}
   * @memberof ApiSvcExchangeRateFailedDTO
   */
  source: ApiSvcExchangeRateTypeFailed;
}

/**
 *
 * @export
 * @interface ApiSvcExchangeRateInput
 */
export interface ApiSvcExchangeRateInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateInput
   */
  currencyId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateInput
   */
  priceId?: string | null;
  /**
   *
   * @type {ApiSvcExchangeRateSource}
   * @memberof ApiSvcExchangeRateInput
   */
  source?: ApiSvcExchangeRateSource | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateInput
   */
  rate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateInput
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateInput
   */
  unit: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateInput
   */
  coin: string;
}

/**
 *
 * @export
 * @interface ApiSvcExchangeRateManualDTO
 */
export interface ApiSvcExchangeRateManualDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateManualDTO
   */
  fromAssetId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateManualDTO
   */
  toAssetId: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeManual}
   * @memberof ApiSvcExchangeRateManualDTO
   */
  source: ApiSvcExchangeRateTypeManual;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateManualDTO
   */
  rate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateManualDTO
   */
  note: string;
}

/**
 *
 * @export
 * @interface ApiSvcExchangeRateOverrideDTO
 */
export interface ApiSvcExchangeRateOverrideDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateOverrideDTO
   */
  currencyId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateOverrideDTO
   */
  rate: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcExchangeRateSource = {
  Automatic: 'Automatic',
  Manual: 'Manual',
  Invoice: 'Invoice',
} as const;

export type ApiSvcExchangeRateSource = typeof ApiSvcExchangeRateSource[keyof typeof ApiSvcExchangeRateSource];

/**
 *
 * @export
 * @interface ApiSvcExchangeRateSystemSuccessDTO
 */
export interface ApiSvcExchangeRateSystemSuccessDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateSystemSuccessDTO
   */
  fromAssetId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateSystemSuccessDTO
   */
  toAssetId: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeSuccess}
   * @memberof ApiSvcExchangeRateSystemSuccessDTO
   */
  source: ApiSvcExchangeRateTypeSuccess;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateSystemSuccessDTO
   */
  rate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateSystemSuccessDTO
   */
  priceId: string;
}

/**
 *
 * @export
 * @interface ApiSvcExchangeRateSystemUnableToPriceDTO
 */
export interface ApiSvcExchangeRateSystemUnableToPriceDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateSystemUnableToPriceDTO
   */
  fromAssetId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateSystemUnableToPriceDTO
   */
  toAssetId: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeUnableToPrice}
   * @memberof ApiSvcExchangeRateSystemUnableToPriceDTO
   */
  source: ApiSvcExchangeRateTypeUnableToPrice;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateSystemUnableToPriceDTO
   */
  priceId?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcExchangeRateType = {
  SuccessfullyPriced: 'successfully-priced',
  FailedToPrice: 'failed-to-price',
  ManuallyPriced: 'manually-priced',
  UnableToPrice: 'unable-to-price',
} as const;

export type ApiSvcExchangeRateType = typeof ApiSvcExchangeRateType[keyof typeof ApiSvcExchangeRateType];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcExchangeRateTypeFailed = {
  FailedToPrice: 'failed-to-price',
} as const;

export type ApiSvcExchangeRateTypeFailed =
  typeof ApiSvcExchangeRateTypeFailed[keyof typeof ApiSvcExchangeRateTypeFailed];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcExchangeRateTypeManual = {
  ManuallyPriced: 'manually-priced',
} as const;

export type ApiSvcExchangeRateTypeManual =
  typeof ApiSvcExchangeRateTypeManual[keyof typeof ApiSvcExchangeRateTypeManual];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcExchangeRateTypeSuccess = {
  SuccessfullyPriced: 'successfully-priced',
} as const;

export type ApiSvcExchangeRateTypeSuccess =
  typeof ApiSvcExchangeRateTypeSuccess[keyof typeof ApiSvcExchangeRateTypeSuccess];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcExchangeRateTypeUnableToPrice = {
  UnableToPrice: 'unable-to-price',
} as const;

export type ApiSvcExchangeRateTypeUnableToPrice =
  typeof ApiSvcExchangeRateTypeUnableToPrice[keyof typeof ApiSvcExchangeRateTypeUnableToPrice];

/**
 *
 * @export
 * @interface ApiSvcExchangeRateUsed
 */
export interface ApiSvcExchangeRateUsed {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateUsed
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateUsed
   */
  to: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateUsed
   */
  priceId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateUsed
   */
  rate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateUsed
   */
  errorMessage?: string;
}
/**
 *
 * @export
 * @interface ApiSvcExchangeRateV2DTO
 */
export interface ApiSvcExchangeRateV2DTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateV2DTO
   */
  fromAssetId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateV2DTO
   */
  toAssetId: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeFailed}
   * @memberof ApiSvcExchangeRateV2DTO
   */
  source: ApiSvcExchangeRateTypeFailed;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateV2DTO
   */
  rate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateV2DTO
   */
  note: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExchangeRateV2DTO
   */
  priceId: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcExchangeTransferType = {
  Deposit: 'deposit',
  Withdrawal: 'withdrawal',
} as const;

export type ApiSvcExchangeTransferType = typeof ApiSvcExchangeTransferType[keyof typeof ApiSvcExchangeTransferType];

/**
 *
 * @export
 * @interface ApiSvcExecContext
 */
export interface ApiSvcExecContext {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExecContext
   */
  userId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcExecContext
   */
  orgs: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcExecContext
   */
  isServiceAccount: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcExecContext
   */
  isSuperAdmin?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcExecContext
   */
  scopes: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExecContext
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcExpandedExchangeRateDTO
 */
export interface ApiSvcExpandedExchangeRateDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcExpandedExchangeRateDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExpandedExchangeRateDTO
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExpandedExchangeRateDTO
   */
  to: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeUnableToPrice}
   * @memberof ApiSvcExpandedExchangeRateDTO
   */
  type: ApiSvcExchangeRateTypeUnableToPrice;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExpandedExchangeRateDTO
   */
  priceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExpandedExchangeRateDTO
   */
  rate: ApiSvcExpandedExchangeRateDTORateEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExpandedExchangeRateDTO
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExpandedExchangeRateDTO
   */
  reason?: string;
}

export const ApiSvcExpandedExchangeRateDTORateEnum = {
  _0: '0',
} as const;

export type ApiSvcExpandedExchangeRateDTORateEnum =
  typeof ApiSvcExpandedExchangeRateDTORateEnum[keyof typeof ApiSvcExpandedExchangeRateDTORateEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcExportFileType = {
  CsvsDeprecated: 'csvs_deprecated',
  Csv: 'csv',
  Zip: 'zip',
} as const;

export type ApiSvcExportFileType = typeof ApiSvcExportFileType[keyof typeof ApiSvcExportFileType];

/**
 *
 * @export
 * @interface ApiSvcExportResponse
 */
export interface ApiSvcExportResponse {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcExportResponse
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcExportResponse
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExportResponse
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExportResponse
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcExportResponse
   */
  metadata?: object;
}

/**
 *
 * @export
 * @interface ApiSvcExternalAcquisitionDetailsDTO
 */
export interface ApiSvcExternalAcquisitionDetailsDTO {
  /**
   *
   * @type {number}
   * @memberof ApiSvcExternalAcquisitionDetailsDTO
   */
  acquisitionDateSEC: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExternalAcquisitionDetailsDTO
   */
  acquisitionCost: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExternalAcquisitionDetailsDTO
   */
  type: ApiSvcExternalAcquisitionDetailsDTOTypeEnum;
}

export const ApiSvcExternalAcquisitionDetailsDTOTypeEnum = {
  Acquisition: 'acquisition',
} as const;

export type ApiSvcExternalAcquisitionDetailsDTOTypeEnum =
  typeof ApiSvcExternalAcquisitionDetailsDTOTypeEnum[keyof typeof ApiSvcExternalAcquisitionDetailsDTOTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcExternalAddressEnrollmentStatus
 */
export interface ApiSvcExternalAddressEnrollmentStatus {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcExternalAddressEnrollmentStatus
   */
  emailSent: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcExternalAddressEnrollmentStatus
   */
  enrolled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcExternalAddressEnrollmentStatus
   */
  isManual: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcExternalDispositionDetailsDTO
 */
export interface ApiSvcExternalDispositionDetailsDTO {
  /**
   *
   * @type {number}
   * @memberof ApiSvcExternalDispositionDetailsDTO
   */
  dispositionDateSEC: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExternalDispositionDetailsDTO
   */
  dispositionProceeds: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcExternalDispositionDetailsDTO
   */
  type: ApiSvcExternalDispositionDetailsDTOTypeEnum;
}

export const ApiSvcExternalDispositionDetailsDTOTypeEnum = {
  Disposition: 'disposition',
} as const;

export type ApiSvcExternalDispositionDetailsDTOTypeEnum =
  typeof ApiSvcExternalDispositionDetailsDTOTypeEnum[keyof typeof ApiSvcExternalDispositionDetailsDTOTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcFailedToPriceExchangeRateDTO
 */
export interface ApiSvcFailedToPriceExchangeRateDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcFailedToPriceExchangeRateDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFailedToPriceExchangeRateDTO
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFailedToPriceExchangeRateDTO
   */
  to: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeFailed}
   * @memberof ApiSvcFailedToPriceExchangeRateDTO
   */
  type: ApiSvcExchangeRateTypeFailed;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFailedToPriceExchangeRateDTO
   */
  priceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFailedToPriceExchangeRateDTO
   */
  error?: string;
}

/**
 *
 * @export
 * @interface ApiSvcFeatureFlag
 */
export interface ApiSvcFeatureFlag {
  /**
   *
   * @type {string}
   * @memberof ApiSvcFeatureFlag
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFeatureFlag
   */
  value: string;
}
/**
 *
 * @export
 * @interface ApiSvcFeeItemInput
 */
export interface ApiSvcFeeItemInput {
  /**
   *
   * @type {ApiSvcCostBasisInput}
   * @memberof ApiSvcFeeItemInput
   */
  costBasis: ApiSvcCostBasisInput;
  /**
   *
   * @type {ApiSvcUncheckedAmountInput}
   * @memberof ApiSvcFeeItemInput
   */
  amount?: ApiSvcUncheckedAmountInput | null;
}
/**
 *
 * @export
 * @interface ApiSvcFeeItemOutDTO
 */
export interface ApiSvcFeeItemOutDTO {
  /**
   *
   * @type {ApiSvcValueDetail}
   * @memberof ApiSvcFeeItemOutDTO
   */
  amount: ApiSvcValueDetail;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcFeeItemOutDTO
   */
  costBasis: ApiSvcCostBasisDTO;
}
/**
 *
 * @export
 * @interface ApiSvcFeeLineDTO
 */
export interface ApiSvcFeeLineDTO {
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcFeeLineDTO
   */
  sourceValue: ApiSvcRawValueDTO;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcFeeLineDTO
   */
  appliedExchangeRateValue?: ApiSvcRawValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFeeLineDTO
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcCategorizedLineTypeFeeLine}
   * @memberof ApiSvcFeeLineDTO
   */
  type: ApiSvcCategorizedLineTypeFeeLine;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFeeLineDTO
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFeeLineDTO
   */
  categoryId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcFeeLineDTO
   */
  isImputed?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFeeLineDTO
   */
  imputedFeeDirection?: string;
}

/**
 *
 * @export
 * @interface ApiSvcFeeOnlyCategorizationAction
 */
export interface ApiSvcFeeOnlyCategorizationAction {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcFeeOnlyCategorizationAction
   */
  labels?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcFeeOnlyCategorizationAction
   */
  ignoreFailPricing?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFeeOnlyCategorizationAction
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFeeOnlyCategorizationAction
   */
  feeContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFeeOnlyCategorizationAction
   */
  type: ApiSvcFeeOnlyCategorizationActionTypeEnum;
}

export const ApiSvcFeeOnlyCategorizationActionTypeEnum = {
  FeeOnlyCategorization: 'FeeOnlyCategorization',
} as const;

export type ApiSvcFeeOnlyCategorizationActionTypeEnum =
  typeof ApiSvcFeeOnlyCategorizationActionTypeEnum[keyof typeof ApiSvcFeeOnlyCategorizationActionTypeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcFiat = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_12: 12,
  NUMBER_13: 13,
  NUMBER_14: 14,
  NUMBER_15: 15,
  NUMBER_16: 16,
  NUMBER_17: 17,
  NUMBER_18: 18,
  NUMBER_19: 19,
  NUMBER_20: 20,
  NUMBER_21: 21,
  NUMBER_22: 22,
  NUMBER_23: 23,
  NUMBER_24: 24,
  NUMBER_25: 25,
  NUMBER_26: 26,
  NUMBER_27: 27,
  NUMBER_28: 28,
  NUMBER_29: 29,
  NUMBER_30: 30,
  NUMBER_31: 31,
  NUMBER_32: 32,
  NUMBER_33: 33,
  NUMBER_34: 34,
  NUMBER_35: 35,
  NUMBER_36: 36,
  NUMBER_37: 37,
  NUMBER_38: 38,
  NUMBER_39: 39,
  NUMBER_100: 100,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_103: 103,
  NUMBER_104: 104,
  NUMBER_105: 105,
  NUMBER_106: 106,
  NUMBER_107: 107,
} as const;

export type ApiSvcFiat = typeof ApiSvcFiat[keyof typeof ApiSvcFiat];

/**
 *
 * @export
 * @interface ApiSvcFiatValue
 */
export interface ApiSvcFiatValue {
  /**
   *
   * @type {number}
   * @memberof ApiSvcFiatValue
   */
  type: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFiatValue
   */
  value: string;
  /**
   * prefers to use currencyId method instead
   * @type {string}
   * @memberof ApiSvcFiatValue
   */
  valueIdentifier: string;
  /**
   *
   * @type {ApiSvcFiat}
   * @memberof ApiSvcFiatValue
   */
  fiat: ApiSvcFiat;
}

/**
 *
 * @export
 * @interface ApiSvcFiatValueDTO
 */
export interface ApiSvcFiatValueDTO {
  /**
   *
   * @type {number}
   * @memberof ApiSvcFiatValueDTO
   */
  value: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFiatValueDTO
   */
  displayValue: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFiatValueDTO
   */
  currency: string;
  /**
   *
   * @type {ApiSvcExchangeRateDTO}
   * @memberof ApiSvcFiatValueDTO
   */
  exchangeRate?: ApiSvcExchangeRateDTO;
}
/**
 *
 * @export
 * @interface ApiSvcFilePointer
 */
export interface ApiSvcFilePointer {
  /**
   *
   * @type {string}
   * @memberof ApiSvcFilePointer
   */
  fileId: string;
  /**
   *
   * @type {ApiSvcFilePointerStorageLocations}
   * @memberof ApiSvcFilePointer
   */
  storageLocation: ApiSvcFilePointerStorageLocations;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFilePointer
   */
  url: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcFilePointerStorageLocations = {
  Gcp: 'gcp',
  Test: 'test',
} as const;

export type ApiSvcFilePointerStorageLocations =
  typeof ApiSvcFilePointerStorageLocations[keyof typeof ApiSvcFilePointerStorageLocations];

/**
 *
 * @export
 * @interface ApiSvcFileRecord
 */
export interface ApiSvcFileRecord {
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  id: string;
  /**
   *
   * @type {ApiSvcRecordType}
   * @memberof ApiSvcFileRecord
   */
  recordType: ApiSvcRecordType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  recordPath: string;
  /**
   *
   * @type {ApiSvcRecordBucket}
   * @memberof ApiSvcFileRecord
   */
  recordBucket: ApiSvcRecordBucket;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  dateSelected?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  groupBy?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  assetType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  updatedAt?: string;
  /**
   *
   * @type {ApiSvcOrgUserDTO}
   * @memberof ApiSvcFileRecord
   */
  updatedBy?: ApiSvcOrgUserDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  createdAt?: string;
  /**
   *
   * @type {ApiSvcOrgUserDTO}
   * @memberof ApiSvcFileRecord
   */
  createdBy?: ApiSvcOrgUserDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  deletedAt?: string;
  /**
   *
   * @type {ApiSvcOrgUserDTO}
   * @memberof ApiSvcFileRecord
   */
  deletedBy?: ApiSvcOrgUserDTO;
  /**
   *
   * @type {ApiSvcRecordBinaryContent}
   * @memberof ApiSvcFileRecord
   */
  recordBinaryContent?: ApiSvcRecordBinaryContent;
  /**
   *
   * @type {number}
   * @memberof ApiSvcFileRecord
   */
  expireAt?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcFileRecord
   */
  recordBytes?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFileRecord
   */
  runId?: string;
  /**
   *
   * @type {ApiSvcBigqueryITableSchema}
   * @memberof ApiSvcFileRecord
   */
  schema?: ApiSvcBigqueryITableSchema;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcFingerPrintType = {
  IncomingNative: 'incomingNative',
  IncomingToken: 'incomingToken',
  OutgoingNative: 'outgoingNative',
  OutgoingToken: 'outgoingToken',
  OnlyFee: 'onlyFee',
  Errored: 'errored',
  Any: 'any',
  SimpleIncoming: 'simpleIncoming',
  SimpleOutgoing: 'simpleOutgoing',
  SimpleTrade: 'simpleTrade',
} as const;

export type ApiSvcFingerPrintType = typeof ApiSvcFingerPrintType[keyof typeof ApiSvcFingerPrintType];

/**
 *
 * @export
 * @interface ApiSvcFlatExchangeRateDTO
 */
export interface ApiSvcFlatExchangeRateDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcFlatExchangeRateDTO
   */
  fromTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFlatExchangeRateDTO
   */
  fromUnit?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFlatExchangeRateDTO
   */
  toTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFlatExchangeRateDTO
   */
  toUnit?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcFlatExchangeRateDTO
   */
  rate: string;
}
/**
 *
 * @export
 * @interface ApiSvcForceMaterializeWalletLiveBalance200Response
 */
export interface ApiSvcForceMaterializeWalletLiveBalance200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcForceMaterializeWalletLiveBalance200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcForceMaterializeWalletLiveBalance200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcForexInput
 */
export interface ApiSvcForexInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcForexInput
   */
  amount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcForexInput
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcForexInput
   */
  categoryId: string;
}
/**
 *
 * @export
 * @interface ApiSvcGainLossConfig
 */
export interface ApiSvcGainLossConfig {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  capitalizeTradingFees: boolean;
  /**
   *
   * @type {ApiSvcImpairmentMethodology}
   * @memberof ApiSvcGainLossConfig
   */
  impairmentMethodology?: ApiSvcImpairmentMethodology;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGainLossConfig
   */
  wrappingTreatments?: object;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGainLossConfig
   */
  impairmentWhitelist?: Array<string>;
  /**
   *
   * @type {ApiSvcInventoryMappingRule}
   * @memberof ApiSvcGainLossConfig
   */
  inventoryMappingRule?: ApiSvcInventoryMappingRule;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGainLossConfig
   */
  engineVersion?: number;
  /**
   *
   * @type {ApiSvcAssetValuationStrategies}
   * @memberof ApiSvcGainLossConfig
   */
  defaultValuationStrategy?: ApiSvcAssetValuationStrategies;
  /**
   *
   * @type {Array<ApiSvcAssetValuationStrategy>}
   * @memberof ApiSvcGainLossConfig
   */
  assetValuationStrategies?: Array<ApiSvcAssetValuationStrategy>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  costBasisCarryForwardAcquiredSide?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  processAcquisitionsBeforeDisposals?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  useOriginalAcquisitionDateForWliTransfers?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  intercompanyTransferAtFmv?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  includeIntraGroupInternalTransfers?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  useFiatTotalInTradeAcquisitions?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  synthesizeTradeExchangeRates?: boolean;
  /**
   *
   * @type {ApiSvcPricingMethod}
   * @memberof ApiSvcGainLossConfig
   */
  defaultFairMarketValueMethodology?: ApiSvcPricingMethod;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGainLossConfig
   */
  activeLabelEffects?: object;
  /**
   *
   * @type {ApiSvcLabelInclusionRule}
   * @memberof ApiSvcGainLossConfig
   */
  labelInclusionRule?: ApiSvcLabelInclusionRule;
  /**
   *
   * @type {ApiSvcLabelTrackingRule}
   * @memberof ApiSvcGainLossConfig
   */
  labelTrackingRule?: ApiSvcLabelTrackingRule;
  /**
   * When true, fiat transactions (including base/functional currency) are no longer dropped from the tax run. Each fiat currency is bucketed on its own and processed by the BalanceOnly path: a Buy/Sell action is emitted per transaction with a running balance, but no lot matching, cost basis, or gain/loss is computed. Off by default (fiat continues to be skipped per the legacy base-currency rule and the `ignore-fiat-transactions` org flag).
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  includeFiatActions?: boolean;
  /**
   * View-level override for intercompany transfer treatment. When enabled, intercompany transfers categorized with gain/loss are run at cost basis for this inventory view, matching transaction-level `excludeIntercompanyGainLoss`.
   * @type {boolean}
   * @memberof ApiSvcGainLossConfig
   */
  excludeIntercompanyGainLoss?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcGainLossConfigCreateRequest
 */
export interface ApiSvcGainLossConfigCreateRequest {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  capitalizeTradingFees: boolean;
  /**
   *
   * @type {ApiSvcImpairmentMethodology}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  impairmentMethodology?: ApiSvcImpairmentMethodology;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  wrappingTreatments?: object;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  impairmentWhitelist?: Array<string>;
  /**
   *
   * @type {ApiSvcInventoryMappingRuleRequest}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  inventoryMappingRule?: ApiSvcInventoryMappingRuleRequest;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  engineVersionOverride?: number;
  /**
   *
   * @type {ApiSvcAssetValuationStrategies}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  defaultValuationStrategy?: ApiSvcAssetValuationStrategies;
  /**
   *
   * @type {Array<ApiSvcAssetValuationStrategy>}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  assetValuationStrategies?: Array<ApiSvcAssetValuationStrategy>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  costBasisCarryForwardAcquiredSide?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  processAcquisitionsBeforeDisposals?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  useOriginalAcquisitionDateForWliTransfers?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  intercompanyTransferAtFmv?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  includeIntraGroupInternalTransfers?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  useFiatTotalInTradeAcquisitions?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  synthesizeTradeExchangeRates?: boolean;
  /**
   *
   * @type {ApiSvcPricingMethod}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  defaultFairMarketValueMethodology?: ApiSvcPricingMethod;
  /**
   *
   * @type {{ [key: string]: ApiSvcInventoryEffectType; }}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  activeLabelEffects?: { [key: string]: ApiSvcInventoryEffectType };
  /**
   *
   * @type {ApiSvcLabelInclusionRuleRequest}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  labelInclusionRule?: ApiSvcLabelInclusionRuleRequest;
  /**
   *
   * @type {ApiSvcLabelTrackingRuleRequest}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  labelTrackingRule?: ApiSvcLabelTrackingRuleRequest;
  /**
   * When true, fiat transactions (including base/functional currency) are included in the run as BalanceOnly actions (Buy/Sell with a running balance) but with no lot matching or gain/loss. Defaults to false.
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  includeFiatActions?: boolean;
  /**
   * When true, intercompany transfers categorized with gain/loss are treated as no-gain/loss intercompany transfers for this inventory view.
   * @type {boolean}
   * @memberof ApiSvcGainLossConfigCreateRequest
   */
  excludeIntercompanyGainLoss?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcGainLossRunFiles
 */
export interface ApiSvcGainLossRunFiles {
  /**
   *
   * @type {ApiSvcFilePointer}
   * @memberof ApiSvcGainLossRunFiles
   */
  actions: ApiSvcFilePointer;
  /**
   *
   * @type {ApiSvcFilePointer}
   * @memberof ApiSvcGainLossRunFiles
   */
  gainLoss: ApiSvcFilePointer;
  /**
   *
   * @type {ApiSvcFilePointer}
   * @memberof ApiSvcGainLossRunFiles
   */
  results: ApiSvcFilePointer;
}
/**
 *
 * @export
 * @interface ApiSvcGainLossSetupDTO
 */
export interface ApiSvcGainLossSetupDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGainLossSetupDTO
   */
  taxStrategy: ApiSvcGainLossSetupDTOTaxStrategyEnum;
  /**
   *
   * @type {Array<ApiSvcCostAverageOverride>}
   * @memberof ApiSvcGainLossSetupDTO
   */
  costAverageOverrides?: Array<ApiSvcCostAverageOverride>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGainLossSetupDTO
   */
  costAverageOverrideEndDate?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGainLossSetupDTO
   */
  taxStartDate?: string;
  /**
   *
   * @type {Array<ApiSvcStartingBalanceDetail>}
   * @memberof ApiSvcGainLossSetupDTO
   */
  startingBalanceDetails?: Array<ApiSvcStartingBalanceDetail>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGainLossSetupDTO
   */
  defaultToZeroCostBasis?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGainLossSetupDTO
   */
  excludedCoins?: Array<string>;
  /**
   *
   * @type {Array<ApiSvcSpecificIdentificationSelectionStrategy>}
   * @memberof ApiSvcGainLossSetupDTO
   */
  specIdStrategy?: Array<ApiSvcSpecificIdentificationSelectionStrategy>;
  /**
   *
   * @type {ApiSvcAssetValuationStrategies}
   * @memberof ApiSvcGainLossSetupDTO
   */
  defaultValuationStrategy?: ApiSvcAssetValuationStrategies;
  /**
   *
   * @type {Array<ApiSvcAssetBasedValuationConfig>}
   * @memberof ApiSvcGainLossSetupDTO
   */
  assetValuationStrategies?: Array<ApiSvcAssetBasedValuationConfig>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGainLossSetupDTO
   */
  matchDataSourceId?: string;
}

export const ApiSvcGainLossSetupDTOTaxStrategyEnum = {
  SpecificIdentification: 'SpecificIdentification',
  Fifo: 'FIFO',
  Lifo: 'LIFO',
  Hifo: 'HIFO',
  CostAverage: 'CostAverage',
  SelectedSpecificIdentification: 'SelectedSpecificIdentification',
  BalanceOnly: 'BalanceOnly',
} as const;

export type ApiSvcGainLossSetupDTOTaxStrategyEnum =
  typeof ApiSvcGainLossSetupDTOTaxStrategyEnum[keyof typeof ApiSvcGainLossSetupDTOTaxStrategyEnum];

/**
 *
 * @export
 * @interface ApiSvcGainLossSummary
 */
export interface ApiSvcGainLossSummary {
  /**
   *
   * @type {number}
   * @memberof ApiSvcGainLossSummary
   */
  stGainLossTotal: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGainLossSummary
   */
  undatedGainLossTotal: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGainLossSummary
   */
  ltGainLossTotal: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGainLossSummary
   */
  impairExpenseTotal: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGainLossSummary
   */
  impairExpenseReversalTotal: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGainLossSummary
   */
  wrappingAdjustmentExpenseTotal: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGainLossSummary
   */
  totalErrorCount: number;
}
/**
 *
 * @export
 * @interface ApiSvcGainLossSummaryResponse
 */
export interface ApiSvcGainLossSummaryResponse {
  /**
   *
   * @type {Array<ApiSvcGainLossSummary>}
   * @memberof ApiSvcGainLossSummaryResponse
   */
  summary: Array<ApiSvcGainLossSummary>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGainLossSummaryResponse
   */
  nextPageToken?: string;
}
/**
 *
 * @export
 * @interface ApiSvcGenerateCloseReportRequest
 */
export interface ApiSvcGenerateCloseReportRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateCloseReportRequest
   */
  checkListRunId: string;
}
/**
 *
 * @export
 * @interface ApiSvcGenerateCloseReportResponse
 */
export interface ApiSvcGenerateCloseReportResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  reportId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  reportRunId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  checkListRunId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  periodStart: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  periodEnd: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  executedAt: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  overallStatus: ApiSvcGenerateCloseReportResponseOverallStatusEnum;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  totalChecks: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  passedChecks: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  failedChecks: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  exceptionsApproved: number;
  /**
   *
   * @type {Array<ApiSvcCheckResult>}
   * @memberof ApiSvcGenerateCloseReportResponse
   */
  checks: Array<ApiSvcCheckResult>;
}

export const ApiSvcGenerateCloseReportResponseOverallStatusEnum = {
  Pass: 'PASS',
  Fail: 'FAIL',
  ExceptionsApproved: 'EXCEPTIONS APPROVED',
} as const;

export type ApiSvcGenerateCloseReportResponseOverallStatusEnum =
  typeof ApiSvcGenerateCloseReportResponseOverallStatusEnum[keyof typeof ApiSvcGenerateCloseReportResponseOverallStatusEnum];

/**
 *
 * @export
 * @interface ApiSvcGeneratePricingReports200Response
 */
export interface ApiSvcGeneratePricingReports200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGeneratePricingReports200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGeneratePricingReports200Response
   */
  message: string;
}
/**
 * Request body for generating a rolled-up JE report
 * @export
 * @interface ApiSvcGenerateRolledUpJeReportRequest
 */
export interface ApiSvcGenerateRolledUpJeReportRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateRolledUpJeReportRequest
   */
  runId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateRolledUpJeReportRequest
   */
  periodStart: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateRolledUpJeReportRequest
   */
  periodEnd: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateRolledUpJeReportRequest
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateRolledUpJeReportRequest
   */
  rollupConfigId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcGenerateRolledUpJeReportResponse
 */
export interface ApiSvcGenerateRolledUpJeReportResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGenerateRolledUpJeReportResponse
   */
  reportId: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetAssignmentWithPath200Response
 */
export interface ApiSvcGetAssignmentWithPath200Response {
  /**
   *
   * @type {ApiSvcSftpPathAssignmentDTO}
   * @memberof ApiSvcGetAssignmentWithPath200Response
   */
  assignment: ApiSvcSftpPathAssignmentDTO;
  /**
   *
   * @type {ApiSvcSftpPathDTO}
   * @memberof ApiSvcGetAssignmentWithPath200Response
   */
  path: ApiSvcSftpPathDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetAssignmentWithPath200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetAssignmentWithPath200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetBulkTransactionStateWorkflowStatus200Response
 */
export interface ApiSvcGetBulkTransactionStateWorkflowStatus200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  workflowId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  status: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  success: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  processed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  successCount: number;
  /**
   *
   * @type {Array<ApiSvcResolveTransactionsResponseFailedInner>}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  failed: Array<ApiSvcResolveTransactionsResponseFailedInner>;
  /**
   *
   * @type {Array<ApiSvcBulkTransactionWorkflowTxnResult>}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  transactions: Array<ApiSvcBulkTransactionWorkflowTxnResult>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  startTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  closeTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetBulkTransactionStateWorkflowStatus200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetCashflowDashboardResponse
 */
export interface ApiSvcGetCashflowDashboardResponse {
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetCashflowDashboardResponse
   */
  inflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetCashflowDashboardResponse
   */
  outflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetCashflowDashboardResponse
   */
  net_total: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetCategories200Response
 */
export interface ApiSvcGetCategories200Response {
  /**
   *
   * @type {Array<ApiSvcCategoryDTO>}
   * @memberof ApiSvcGetCategories200Response
   */
  items: Array<ApiSvcCategoryDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetCategories200Response
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetCategories200Response
   */
  nextPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetCategories200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetCategories200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetCategorizedByCountDashboardResponse
 */
export interface ApiSvcGetCategorizedByCountDashboardResponse {
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetCategorizedByCountDashboardResponse
   */
  categorized: Array<ApiSvcDateValue>;
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetCategorizedByCountDashboardResponse
   */
  uncategorized: Array<ApiSvcDateValue>;
}
/**
 *
 * @export
 * @interface ApiSvcGetCategorizedByFmvDashboardResponse
 */
export interface ApiSvcGetCategorizedByFmvDashboardResponse {
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetCategorizedByFmvDashboardResponse
   */
  categorized_inflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetCategorizedByFmvDashboardResponse
   */
  categorized_outflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetCategorizedByFmvDashboardResponse
   */
  uncategorized_inflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetCategorizedByFmvDashboardResponse
   */
  uncategorized_outflow: Array<ApiSvcDateValue>;
}
/**
 *
 * @export
 * @interface ApiSvcGetClients200Response
 */
export interface ApiSvcGetClients200Response {
  /**
   *
   * @type {Array<ApiSvcOrgResponseDTO>}
   * @memberof ApiSvcGetClients200Response
   */
  items: Array<ApiSvcOrgResponseDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcGetClientsV2200Response
 */
export interface ApiSvcGetClientsV2200Response {
  /**
   *
   * @type {Array<ApiSvcOrgRelationshipsV2>}
   * @memberof ApiSvcGetClientsV2200Response
   */
  items: Array<ApiSvcOrgRelationshipsV2>;
}
/**
 *
 * @export
 * @interface ApiSvcGetConnection200Response
 */
export interface ApiSvcGetConnection200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  orgId: string;
  /**
   *
   * @type {ApiSvcConnectionType}
   * @memberof ApiSvcGetConnection200Response
   */
  type: ApiSvcConnectionType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  provider: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetConnection200Response
   */
  lastSyncSEC?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetConnection200Response
   */
  isDisabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetConnection200Response
   */
  isDeleted: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetConnection200Response
   */
  isSetupComplete: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  location?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  subAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  s3Bucket?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  s3Prefix?: string;
  /**
   *
   * @type {ApiSvcConnectionCategory}
   * @memberof ApiSvcGetConnection200Response
   */
  category?: ApiSvcConnectionCategory;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetConnection200Response
   * @deprecated
   */
  syncerVersion?: number;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcGetConnection200Response
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  feeAccountCode?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetConnection200Response
   */
  syncSubAccounts?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  accountCode?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGetConnection200Response
   */
  connectionSpecificFields?: object;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetConnection200Response
   */
  isDefault?: boolean;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcGetConnection200Response
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  subAccountName?: string;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcGetConnection200Response
   */
  lastSuccessfulJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcGetConnection200Response
   */
  lastJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetConnection200Response
   */
  lastRotatedAt?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  keyFingerprint?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnection200Response
   */
  message: string;
}

/**
 *
 * @export
 * @interface ApiSvcGetConnections200Response
 */
export interface ApiSvcGetConnections200Response {
  /**
   *
   * @type {Array<ApiSvcConnectionDTO>}
   * @memberof ApiSvcGetConnections200Response
   */
  items: Array<ApiSvcConnectionDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnections200Response
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnections200Response
   */
  nextPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnections200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetConnections200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetContacts200Response
 */
export interface ApiSvcGetContacts200Response {
  /**
   *
   * @type {Array<ApiSvcContactDTO>}
   * @memberof ApiSvcGetContacts200Response
   */
  items: Array<ApiSvcContactDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetContacts200Response
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetContacts200Response
   */
  nextPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetContacts200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetContacts200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetInventoryBalanceCheckReport200Response
 */
export interface ApiSvcGetInventoryBalanceCheckReport200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetInventoryBalanceCheckReport200Response
   */
  csv: string;
  /**
   *
   * @type {ApiSvcInventoryBalanceCheckReportResp}
   * @memberof ApiSvcGetInventoryBalanceCheckReport200Response
   */
  metadata: ApiSvcInventoryBalanceCheckReportResp;
}
/**
 *
 * @export
 * @interface ApiSvcGetOrg200Response
 */
export interface ApiSvcGetOrg200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrg200Response
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrg200Response
   */
  name: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetOrg200Response
   */
  flags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrg200Response
   */
  timezone?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetOrg200Response
   */
  baseCurrency?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrg200Response
   */
  kekResourceName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrg200Response
   */
  storageBucket?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetOrg200Response
   */
  customerType: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrg200Response
   */
  trialExpiry?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrg200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrg200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetOrgLabelDefinition200Response
 */
export interface ApiSvcGetOrgLabelDefinition200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  labelId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  description?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  enabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  isDeleted: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  createdAtSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  updatedAtSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  deletedAtSEC?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  isReserved: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  allowSlugs: boolean;
  /**
   *
   * @type {ApiSvcSlugType}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  slugType?: ApiSvcSlugType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  slugValidationPattern?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetOrgLabelDefinition200Response
   */
  message: string;
}

/**
 *
 * @export
 * @interface ApiSvcGetPrice200Response
 */
export interface ApiSvcGetPrice200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetPrice200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetPrice200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetPrice200Response
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetPrice200Response
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetPrice200Response
   */
  assetId: string;
  /**
   *
   * @type {object}
   * @memberof ApiSvcGetPrice200Response
   */
  resolution: object;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetPrice200Response
   */
  normalizedTimestampSEC: number;
  /**
   *
   * @type {ApiSvcPriceSvcPricingResult}
   * @memberof ApiSvcGetPrice200Response
   */
  price: ApiSvcPriceSvcPricingResult;
  /**
   * Storage key for this record — the composed price ref (Spanner `PriceResultsId` / Firestore doc id produced by `generatePriceRef`), NOT the UUID `id`.  Deliberately NOT a `@JsonProperty`: it must never be written into the persisted `Data` blob, only carried in-memory. Reads that need to preserve the row key (e.g. the Firestore→Spanner migration) populate it from the source doc id so the Spanner row is keyed by the ref the read path looks it up by — instead of the UUID.
   * @type {string}
   * @memberof ApiSvcGetPrice200Response
   */
  priceResultsId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetPricingContextRoutes200Response
 */
export interface ApiSvcGetPricingContextRoutes200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetPricingContextRoutes200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetPricingContextRoutes200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetPricingContexts200Response
 */
export interface ApiSvcGetPricingContexts200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetPricingContexts200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetPricingContexts200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetReport200Response
 */
export interface ApiSvcGetReport200Response {
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGetReport200Response
   */
  links: object;
  /**
   *
   * @type {ApiSvcReportRunRecordReportRunConfig}
   * @memberof ApiSvcGetReport200Response
   */
  data: ApiSvcReportRunRecordReportRunConfig;
}
/**
 *
 * @export
 * @interface ApiSvcGetReportDetailsResponse
 */
export interface ApiSvcGetReportDetailsResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  reportId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  reportRunId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  checkListRunId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  periodStart: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  periodEnd: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  executedAt: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  overallStatus: ApiSvcGetReportDetailsResponseOverallStatusEnum;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  totalChecks: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  passedChecks: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  failedChecks: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  exceptionsApproved: number;
  /**
   *
   * @type {Array<ApiSvcCheckResult>}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  checks: Array<ApiSvcCheckResult>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReportDetailsResponse
   */
  createdBy?: string;
}

export const ApiSvcGetReportDetailsResponseOverallStatusEnum = {
  Pass: 'PASS',
  Fail: 'FAIL',
  ExceptionsApproved: 'EXCEPTIONS APPROVED',
} as const;

export type ApiSvcGetReportDetailsResponseOverallStatusEnum =
  typeof ApiSvcGetReportDetailsResponseOverallStatusEnum[keyof typeof ApiSvcGetReportDetailsResponseOverallStatusEnum];

/**
 *
 * @export
 * @interface ApiSvcGetReports200Response
 */
export interface ApiSvcGetReports200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetReports200Response
   */
  nextPageToken?: string;
  /**
   *
   * @type {Array<ApiSvcReportRunRecordReportRunConfig>}
   * @memberof ApiSvcGetReports200Response
   */
  items: Array<ApiSvcReportRunRecordReportRunConfig>;
}
/**
 *
 * @export
 * @interface ApiSvcGetRules200Response
 */
export interface ApiSvcGetRules200Response {
  /**
   *
   * @type {Array<ApiSvcTransferRuleDTO>}
   * @memberof ApiSvcGetRules200Response
   */
  items: Array<ApiSvcTransferRuleDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetRules200Response
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetRules200Response
   */
  nextPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetRules200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetRules200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetSplitGroupV2200Response
 */
export interface ApiSvcGetSplitGroupV2200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  traceId?: string;
  /**
   * The transaction the split was performed on, restored by an unsplit.
   * @type {string}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  parentTxnId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  parentState?: string;
  /**
   *
   * @type {ApiSvcTransactionQueryDTO}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  parentTransaction?: ApiSvcTransactionQueryDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  splitRunId?: string;
  /**
   * How many children the split recorded: from child metadata when a child was asked about, and from the parent\'s split pointers when the parent was, so the answer does not depend on which member of the group you pass.
   * @type {number}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  expectedChildCount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  missingChildCount: number;
  /**
   *
   * @type {Array<ApiSvcSplitGroupChildDTO>}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  children: Array<ApiSvcSplitGroupChildDTO>;
  /**
   * Whether an unsplit is expected to succeed.  Necessary but not sufficient. This covers every precondition that can be evaluated from a read: child count, blocked children, and children on another parent or run. It cannot cover unsplitTransaction\'s post-command projection assertions, which are only known once the commands are built. Callers must still handle a failed unsplit rather than treating `true` as a guarantee.
   * @type {boolean}
   * @memberof ApiSvcGetSplitGroupV2200Response
   */
  canUnsplit: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcGetSubsidiaryCoinMappings200Response
 */
export interface ApiSvcGetSubsidiaryCoinMappings200Response {
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGetSubsidiaryCoinMappings200Response
   */
  materializedMappings: object;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGetSubsidiaryCoinMappings200Response
   */
  explicitMappings: object;
}
/**
 *
 * @export
 * @interface ApiSvcGetTokenFilteringRules200Response
 */
export interface ApiSvcGetTokenFilteringRules200Response {
  /**
   *
   * @type {Array<ApiSvcTokenFilteringRulesConfigWalletSyncPreferencesInner>}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  walletSyncPreferences?: Array<ApiSvcTokenFilteringRulesConfigWalletSyncPreferencesInner>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  filteredAddresses?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  erc20FilterThreshold?: string;
  /**
   *
   * @type {Array<ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner>}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  disabledDeployedByBlockHeightRules?: Array<ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner>;
  /**
   *
   * @type {Array<ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner>}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  allowDeployedBlockHeightRules?: Array<ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  disabledContractAddresses?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  disabledDeployedByAddresses?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  allowedDeployedByAddresses?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  allowedContractAddresses?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  traceId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  message: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTokenFilteringRules200Response
   */
  success: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcGetTokenFilteringRules200ResponseAnyOf
 */
export interface ApiSvcGetTokenFilteringRules200ResponseAnyOf {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTokenFilteringRules200ResponseAnyOf
   */
  traceId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTokenFilteringRules200ResponseAnyOf
   */
  message: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTokenFilteringRules200ResponseAnyOf
   */
  success: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcGetTokenV1200Response
 */
export interface ApiSvcGetTokenV1200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTokenV1200Response
   */
  access_token: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTokenV1200Response
   */
  token_type: ApiSvcGetTokenV1200ResponseTokenTypeEnum;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTokenV1200Response
   */
  expires_in: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTokenV1200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTokenV1200Response
   */
  message: string;
}

export const ApiSvcGetTokenV1200ResponseTokenTypeEnum = {
  Bearer: 'Bearer',
  Cookie: 'Cookie',
} as const;

export type ApiSvcGetTokenV1200ResponseTokenTypeEnum =
  typeof ApiSvcGetTokenV1200ResponseTokenTypeEnum[keyof typeof ApiSvcGetTokenV1200ResponseTokenTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcGetTransaction200Response
 */
export interface ApiSvcGetTransaction200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransaction200Response
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTransaction200Response
   */
  created: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransaction200Response
   */
  txnType: string;
  /**
   *
   * @type {Array<ApiSvcTransactionActorDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  from: Array<ApiSvcTransactionActorDTO>;
  /**
   *
   * @type {Array<ApiSvcTransactionActorDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  to: Array<ApiSvcTransactionActorDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransaction200Response
   */
  reconciliationStatus: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransaction200Response
   */
  categorizationStatus: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransaction200Response
   */
  taxReconciliationStatus: string;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  fees: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  amountsWithoutFees: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  amountsWithFees: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  fullAmountSet: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcWalletValues>}
   * @memberof ApiSvcGetTransaction200Response
   */
  valuesByWallets: Array<ApiSvcWalletValues>;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  paidFees: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  exchangeRates?: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {Array<ApiSvcTransactionDetailsDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  details: Array<ApiSvcTransactionDetailsDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransaction200Response
   */
  isBlockchain: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransaction200Response
   */
  ignore: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransaction200Response
   */
  hasMatchedInvoices: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransaction200Response
   */
  readonly: boolean;
  /**
   *
   * @type {Array<ApiSvcWalletPointer>}
   * @memberof ApiSvcGetTransaction200Response
   */
  walletPointers: Array<ApiSvcWalletPointer>;
  /**
   *
   * @type {Array<ApiSvcAccountingDetailsDTO>}
   * @memberof ApiSvcGetTransaction200Response
   */
  accountingDetails?: Array<ApiSvcAccountingDetailsDTO>;
  /**
   *
   * @type {ApiSvcTaxTxnInfoDTO}
   * @memberof ApiSvcGetTransaction200Response
   */
  taxInfo?: ApiSvcTaxTxnInfoDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransaction200Response
   */
  memo?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransaction200Response
   */
  reconciledRemoteIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransaction200Response
   */
  combinedIntoTxnId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransaction200Response
   */
  combinedSubTxnIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransaction200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransaction200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionAuditLog200Response
 */
export interface ApiSvcGetTransactionAuditLog200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionAuditLog200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionAuditLog200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionAuditLog200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionChangeLog200Response
 */
export interface ApiSvcGetTransactionChangeLog200Response {
  /**
   *
   * @type {Array<ApiSvcChangelogEntryTransactionChangeLog>}
   * @memberof ApiSvcGetTransactionChangeLog200Response
   */
  items: Array<ApiSvcChangelogEntryTransactionChangeLog>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionChangeLog200Response
   */
  nextPageToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionChangeLog200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionChangeLog200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionDashboardCashflowFmvResponse
 */
export interface ApiSvcGetTransactionDashboardCashflowFmvResponse {
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetTransactionDashboardCashflowFmvResponse
   */
  inflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetTransactionDashboardCashflowFmvResponse
   */
  outflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionDashboardCashflowFmvResponse
   */
  netTotal: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionDashboardCategorizedFmvResponse
 */
export interface ApiSvcGetTransactionDashboardCategorizedFmvResponse {
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetTransactionDashboardCategorizedFmvResponse
   */
  categorizedInflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetTransactionDashboardCategorizedFmvResponse
   */
  categorizedOutflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetTransactionDashboardCategorizedFmvResponse
   */
  uncategorizedInflow: Array<ApiSvcDateValue>;
  /**
   *
   * @type {Array<ApiSvcDateValue>}
   * @memberof ApiSvcGetTransactionDashboardCategorizedFmvResponse
   */
  uncategorizedOutflow: Array<ApiSvcDateValue>;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionLookups200Response
 */
export interface ApiSvcGetTransactionLookups200Response {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionLookups200Response
   */
  values: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionLookups200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionLookups200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionLookups200ResponseAnyOf
 */
export interface ApiSvcGetTransactionLookups200ResponseAnyOf {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionLookups200ResponseAnyOf
   */
  values: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionState200Response
 */
export interface ApiSvcGetTransactionState200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionState200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionState200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionState200Response
   */
  traceId?: string;
  /**
   *
   * @type {ApiSvcTransactionStateDTO}
   * @memberof ApiSvcGetTransactionState200Response
   */
  state: ApiSvcTransactionStateDTO;
  /**
   * this is the coin mapping for all the unique assets of the transaction
   * @type {Array<ApiSvcCoinMapping>}
   * @memberof ApiSvcGetTransactionState200Response
   */
  assets: Array<ApiSvcCoinMapping>;
  /**
   * friendly warnings on the txn
   * @type {Array<ApiSvcTxnWarnings>}
   * @memberof ApiSvcGetTransactionState200Response
   */
  warnings?: Array<ApiSvcTxnWarnings>;
  /**
   * all the errors of the transaction e.g. sync errors
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionState200Response
   */
  summaryErrors?: Array<string>;
  /**
   * default exchange rate set to fall back
   * @type {Array<ApiSvcManuallyPricedExchangeRateDTO>}
   * @memberof ApiSvcGetTransactionState200Response
   */
  defaultExchangeRateSet?: Array<ApiSvcManuallyPricedExchangeRateDTO>;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGetTransactionState200Response
   */
  walletNonBaseCurrencies?: object;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionStateDTO
 */
export interface ApiSvcGetTransactionStateDTO {
  /**
   *
   * @type {ApiSvcTransactionStateDTO}
   * @memberof ApiSvcGetTransactionStateDTO
   */
  state: ApiSvcTransactionStateDTO;
  /**
   * this is the coin mapping for all the unique assets of the transaction
   * @type {Array<ApiSvcCoinMapping>}
   * @memberof ApiSvcGetTransactionStateDTO
   */
  assets: Array<ApiSvcCoinMapping>;
  /**
   * friendly warnings on the txn
   * @type {Array<ApiSvcTxnWarnings>}
   * @memberof ApiSvcGetTransactionStateDTO
   */
  warnings?: Array<ApiSvcTxnWarnings>;
  /**
   * all the errors of the transaction e.g. sync errors
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionStateDTO
   */
  summaryErrors?: Array<string>;
  /**
   * default exchange rate set to fall back
   * @type {Array<ApiSvcManuallyPricedExchangeRateDTO>}
   * @memberof ApiSvcGetTransactionStateDTO
   */
  defaultExchangeRateSet?: Array<ApiSvcManuallyPricedExchangeRateDTO>;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGetTransactionStateDTO
   */
  walletNonBaseCurrencies?: object;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionV3200Response
 */
export interface ApiSvcGetTransactionV3200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  categorizationStatus: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  reconciliationStatus: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  timestamp: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  txViewLink?: string;
  /**
   *
   * @type {ApiSvcTxnType}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  transactionType: ApiSvcTxnType;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  metadata?: object;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  ignored: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  state: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  methodId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  isTxnLineAndValuesMismatched: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  isCombinedParent: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  isEditable?: boolean;
  /**
   *
   * @type {Array<ApiSvcTransactionQueryLineDTO>}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  lines: Array<ApiSvcTransactionQueryLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  updatedAt: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  version: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionV3200Response
   */
  message: string;
}

/**
 *
 * @export
 * @interface ApiSvcGetTransactionsChangelogV3200Response
 */
export interface ApiSvcGetTransactionsChangelogV3200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsChangelogV3200Response
   */
  nextToken?: string;
  /**
   *
   * @type {Array<ApiSvcTransactionChangelogEntryDTO>}
   * @memberof ApiSvcGetTransactionsChangelogV3200Response
   */
  items: Array<ApiSvcTransactionChangelogEntryDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsChangelogV3200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsChangelogV3200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionsChangelogV3200ResponseAnyOf
 */
export interface ApiSvcGetTransactionsChangelogV3200ResponseAnyOf {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsChangelogV3200ResponseAnyOf
   */
  nextToken?: string;
  /**
   *
   * @type {Array<ApiSvcTransactionChangelogEntryDTO>}
   * @memberof ApiSvcGetTransactionsChangelogV3200ResponseAnyOf
   */
  items: Array<ApiSvcTransactionChangelogEntryDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionsCountV3200Response
 */
export interface ApiSvcGetTransactionsCountV3200Response {
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTransactionsCountV3200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsCountV3200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsCountV3200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionsCountV3200ResponseAnyOf
 */
export interface ApiSvcGetTransactionsCountV3200ResponseAnyOf {
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTransactionsCountV3200ResponseAnyOf
   */
  count: number;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionsFilters
 */
export interface ApiSvcGetTransactionsFilters {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  toAddresses?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  fromAddresses?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  operations?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  transactionIds?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsFilters
   */
  categorizationStatus?: string | null;
  /**
   * Legacy alias of `categorizationStatus` some clients still send. Expands identically (\'Categorized\' | \'Uncategorized\') and intersects with categorizationStatus if both are present.
   * @type {string}
   * @memberof ApiSvcGetTransactionsFilters
   */
  transactionStatus?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   * @deprecated
   */
  amountCurrencyNames?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  assetIds?: Array<string> | null;
  /**
   *
   * @type {ApiSvcAmountRange}
   * @memberof ApiSvcGetTransactionsFilters
   */
  amountRange?: ApiSvcAmountRange | null;
  /**
   *
   * @type {ApiSvcAmountRange}
   * @memberof ApiSvcGetTransactionsFilters
   */
  fmvAmountRange?: ApiSvcAmountRange | null;
  /**
   *
   * @type {ApiSvcDateRange}
   * @memberof ApiSvcGetTransactionsFilters
   */
  dateRange?: ApiSvcDateRange | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  categorizationStatuses?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  reconciliationStatuses?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  ignoredStatuses?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  transactionTypes?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  walletIds?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  methodIds?: Array<string> | null;
  /**
   *
   * @type {ApiSvcStages}
   * @memberof ApiSvcGetTransactionsFilters
   */
  stage?: ApiSvcStages | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionsFilters
   * @deprecated
   */
  usePositiveAmount?: boolean | null;
  /**
   * Case-insensitive substring match against TxnId, From and To across the lines table. Capped at 5 entries — the queries get expensive past that.
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  searchTokens?: Array<string> | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionsFilters
   */
  includeCombinedTransactions?: boolean | null;
  /**
   * Narrows results to transactions whose lines belong to wallets in the given subsidiaries. Resolved to walletIds at the routing-service layer and intersected with any caller-supplied walletIds.
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  subsidiaryIds?: Array<string> | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionsFilters
   */
  isCombinedParent?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionsFilters
   */
  isSplitChild?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionsFilters
   */
  isSplitParent?: boolean | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  states?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsFilters
   */
  state?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcGetTransactionsFilters
   */
  needsReview?: boolean | null;
  /**
   * Combined from/to filter. Matches when an address appears on either side of any line — i.e. `From IN UNNEST(@addresses) OR To IN UNNEST(@addresses)`.
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsFilters
   */
  addresses?: Array<string> | null;
  /**
   * Convenience flag for \"show only errored\". Expands to [OpenTransactionStates.FailedToPrice, ClosedTransactionStates.FailedToSync] and composes with the other state filters by intersection.
   * @type {boolean}
   * @memberof ApiSvcGetTransactionsFilters
   */
  errored?: boolean | null;
}

/**
 *
 * @export
 * @interface ApiSvcGetTransactionsLite200Response
 */
export interface ApiSvcGetTransactionsLite200Response {
  /**
   *
   * @type {Array<ApiSvcTransactionLite>}
   * @memberof ApiSvcGetTransactionsLite200Response
   */
  txns: Array<ApiSvcTransactionLite>;
  /**
   *
   * @type {Array<ApiSvcCoinMapping>}
   * @memberof ApiSvcGetTransactionsLite200Response
   */
  coins: Array<ApiSvcCoinMapping>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsLite200Response
   */
  olderPageToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsLite200Response
   */
  newerPageToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsLite200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsLite200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionsPaginated200Response
 */
export interface ApiSvcGetTransactionsPaginated200Response {
  /**
   *
   * @type {Array<ApiSvcTransactionDTO>}
   * @memberof ApiSvcGetTransactionsPaginated200Response
   */
  items: Array<ApiSvcTransactionDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsPaginated200Response
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsPaginated200Response
   */
  nextPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsPaginated200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsPaginated200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionsRequest
 */
export interface ApiSvcGetTransactionsRequest {
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTransactionsRequest
   */
  limit?: number | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsRequest
   */
  timezone?: string | null;
  /**
   * Local date in YYYY-MM-DD form, evaluated in `timezone` (UTC fallback). Used as an exclusive upper bound (end-of-day in the supplied tz).
   * @type {string}
   * @memberof ApiSvcGetTransactionsRequest
   */
  pivotDate?: string | null;
  /**
   * Order direction for the sort field. Defaults to \'desc\'.
   * @type {string}
   * @memberof ApiSvcGetTransactionsRequest
   */
  sortDirection?: ApiSvcGetTransactionsRequestSortDirectionEnum;
  /**
   *
   * @type {ApiSvcGetTransactionsFilters}
   * @memberof ApiSvcGetTransactionsRequest
   */
  filters?: ApiSvcGetTransactionsFilters | null;
  /**
   *
   * @type {ApiSvcGetTransactionsRequestSortBy}
   * @memberof ApiSvcGetTransactionsRequest
   */
  sortBy?: ApiSvcGetTransactionsRequestSortBy | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsRequest
   */
  nextToken?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsRequest
   */
  prevToken?: string | null;
}

export const ApiSvcGetTransactionsRequestSortDirectionEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;

export type ApiSvcGetTransactionsRequestSortDirectionEnum =
  typeof ApiSvcGetTransactionsRequestSortDirectionEnum[keyof typeof ApiSvcGetTransactionsRequestSortDirectionEnum];

/**
 * \'txnTimestamp\' (aliases: \'timestamp\', \'date\') or \'updatedAt\' (alias: \'updated_at\'). Unrecognized columns fall back to the txnTimestamp default.
 * @export
 * @interface ApiSvcGetTransactionsRequestSortBy
 */
export interface ApiSvcGetTransactionsRequestSortBy {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsRequestSortBy
   */
  column?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsRequestSortBy
   */
  direction?: string | null;
}
/**
 * Object form of sortBy some clients (web-app-v3 among them) send. `column` accepts the same aliases as the string form; `direction` accepts asc/desc in any case and loses to the top-level sortDirection when both are present.
 * @export
 * @interface ApiSvcGetTransactionsSortBy
 */
export interface ApiSvcGetTransactionsSortBy {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsSortBy
   */
  column?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsSortBy
   */
  direction?: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionsSummaryV2200Response
 */
export interface ApiSvcGetTransactionsSummaryV2200Response {
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTransactionsSummaryV2200Response
   */
  needsCategorization: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTransactionsSummaryV2200Response
   */
  toBeReconciled: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTransactionsSummaryV2200Response
   */
  needsReview: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcGetTransactionsSummaryV2200Response
   */
  all: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsSummaryV2200Response
   */
  firstRecordDate: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsSummaryV2200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsSummaryV2200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetTransactionsV3200Response
 */
export interface ApiSvcGetTransactionsV3200Response {
  /**
   *
   * @type {Array<ApiSvcTransactionQueryDTO>}
   * @memberof ApiSvcGetTransactionsV3200Response
   */
  transactions: Array<ApiSvcTransactionQueryDTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGetTransactionsV3200Response
   */
  assetIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsV3200Response
   * @deprecated
   */
  pageToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsV3200Response
   */
  nextToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsV3200Response
   */
  prevToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsV3200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetTransactionsV3200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetUserOrganizations200Response
 */
export interface ApiSvcGetUserOrganizations200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetUserOrganizations200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetUserOrganizations200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetWallet200Response
 */
export interface ApiSvcGetWallet200Response {
  /**
   *
   * @type {ApiSvcWalletResponseDTO}
   * @memberof ApiSvcGetWallet200Response
   */
  data: ApiSvcWalletResponseDTO;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcGetWallet200Response
   */
  _links: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWallet200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWallet200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetWalletRoles200Response
 */
export interface ApiSvcGetWalletRoles200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWalletRoles200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWalletRoles200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetWalletRules200Response
 */
export interface ApiSvcGetWalletRules200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWalletRules200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWalletRules200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGetWallets200Response
 */
export interface ApiSvcGetWallets200Response {
  /**
   *
   * @type {Array<ApiSvcWalletResponseDTO>}
   * @memberof ApiSvcGetWallets200Response
   */
  items: Array<ApiSvcWalletResponseDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWallets200Response
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWallets200Response
   */
  nextPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWallets200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGetWallets200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcGroupWallet
 */
export interface ApiSvcGroupWallet {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGroupWallet
   */
  children?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGroupWallet
   */
  description?: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcGroupWalletDTO
 */
export interface ApiSvcGroupWalletDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcGroupWalletDTO
   */
  description: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcGroupWalletDTO
   */
  children: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGroupWalletDTO
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcGroupWalletDTO
   */
  remoteId?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcHardwareDevices = {
  Ledger: 'Ledger',
  Trezor: 'Trezor',
} as const;

export type ApiSvcHardwareDevices = typeof ApiSvcHardwareDevices[keyof typeof ApiSvcHardwareDevices];

/**
 *
 * @export
 * @interface ApiSvcHardwareWallet
 */
export interface ApiSvcHardwareWallet {
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWallet
   */
  derivationKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWallet
   */
  hd?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWallet
   */
  address?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWallet
   */
  path: string;
  /**
   *
   * @type {ApiSvcHardwareDevices}
   * @memberof ApiSvcHardwareWallet
   */
  deviceType: ApiSvcHardwareDevices;
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWallet
   */
  coin?: string | null;
}

/**
 *
 * @export
 * @interface ApiSvcHardwareWalletDTO
 */
export interface ApiSvcHardwareWalletDTO {
  /**
   *
   * @type {ApiSvcCoin}
   * @memberof ApiSvcHardwareWalletDTO
   */
  coin: ApiSvcCoin;
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWalletDTO
   */
  deviceName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWalletDTO
   */
  deviceType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWalletDTO
   */
  path: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWalletDTO
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcHardwareWalletDTO
   */
  derivationKey?: string;
}

/**
 *
 * @export
 * @interface ApiSvcITableFieldSchema
 */
export interface ApiSvcITableFieldSchema {
  /**
   * [Required] The field data type. Possible values include STRING, BYTES, INTEGER, INT64 (same as INTEGER), FLOAT, FLOAT64 (same as FLOAT), NUMERIC, BIGNUMERIC, BOOLEAN, BOOL (same as BOOLEAN), TIMESTAMP, DATE, TIME, DATETIME, INTERVAL, RECORD (where RECORD indicates that the field contains a nested schema) or STRUCT (same as RECORD).
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  type?: string;
  /**
   * [Optional] See documentation for precision.
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  scale?: string;
  /**
   * Optional. Rounding Mode specification of the field. It only can be set on NUMERIC or BIGNUMERIC type fields.
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  roundingMode?: string;
  /**
   *
   * @type {ApiSvcITableFieldSchemaRangeElementType}
   * @memberof ApiSvcITableFieldSchema
   */
  rangeElementType?: ApiSvcITableFieldSchemaRangeElementType;
  /**
   * [Optional] Precision (maximum number of total digits in base 10) and scale (maximum number of digits in the fractional part in base 10) constraints for values of this field for NUMERIC or BIGNUMERIC. It is invalid to set precision or scale if type ≠ \"NUMERIC\" and ≠ \"BIGNUMERIC\". If precision and scale are not specified, no value range constraint is imposed on this field insofar as values are permitted by the type. Values of this NUMERIC or BIGNUMERIC field must be in this range when: - Precision (P) and scale (S) are specified: [-10P-S + 10-S, 10P-S - 10-S] - Precision (P) is specified but not scale (and thus scale is interpreted to be equal to zero): [-10P + 1, 10P - 1]. Acceptable values for precision and scale if both are specified: - If type = \"NUMERIC\": 1 ≤ precision - scale ≤ 29 and 0 ≤ scale ≤ 9. - If type = \"BIGNUMERIC\": 1 ≤ precision - scale ≤ 38 and 0 ≤ scale ≤ 38. Acceptable values for precision if only precision is specified but not scale (and thus scale is interpreted to be equal to zero): - If type = \"NUMERIC\": 1 ≤ precision ≤ 29. - If type = \"BIGNUMERIC\": 1 ≤ precision ≤ 38. If scale is specified but not precision, then it is invalid.
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  precision?: string;
  /**
   *
   * @type {ApiSvcITableFieldSchemaPolicyTags}
   * @memberof ApiSvcITableFieldSchema
   */
  policyTags?: ApiSvcITableFieldSchemaPolicyTags;
  /**
   * [Required] The field name. The name must contain only letters (a-z, A-Z), numbers (0-9), or underscores (_), and must start with a letter or underscore. The maximum length is 300 characters.
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  name?: string;
  /**
   * [Optional] The field mode. Possible values include NULLABLE, REQUIRED and REPEATED. The default value is NULLABLE.
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  mode?: string;
  /**
   * [Optional] Maximum length of values of this field for STRINGS or BYTES. If max_length is not specified, no maximum length constraint is imposed on this field. If type = \"STRING\", then max_length represents the maximum UTF-8 length of strings in this field. If type = \"BYTES\", then max_length represents the maximum number of bytes in this field. It is invalid to set this field if type ≠ \"STRING\" and ≠ \"BYTES\".
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  maxLength?: string;
  /**
   * [Optional] Describes the nested schema fields if the type property is set to RECORD.
   * @type {Array<ApiSvcITableFieldSchema>}
   * @memberof ApiSvcITableFieldSchema
   */
  fields?: Array<ApiSvcITableFieldSchema>;
  /**
   * [Optional] The field description. The maximum length is 1,024 characters.
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  description?: string;
  /**
   * Optional. A SQL expression to specify the default value for this field. It can only be set for top level fields (columns). You can use struct or array expression to specify default value for the entire struct or array. The valid SQL expressions are: - Literals for all data types, including STRUCT and ARRAY. - Following functions: - CURRENT_TIMESTAMP - CURRENT_TIME - CURRENT_DATE - CURRENT_DATETIME - GENERATE_UUID - RAND - SESSION_USER - ST_GEOGPOINT - Struct or array composed with the above allowed functions, for example, [CURRENT_DATE(), DATE \'2020-01-01\']
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  defaultValueExpression?: string;
  /**
   * Optional. Collation specification of the field. It only can be set on string type field.
   * @type {string}
   * @memberof ApiSvcITableFieldSchema
   */
  collation?: string;
  /**
   *
   * @type {ApiSvcITableFieldSchemaCategories}
   * @memberof ApiSvcITableFieldSchema
   */
  categories?: ApiSvcITableFieldSchemaCategories;
}
/**
 * [Optional] The categories attached to this field, used for field-level access control.
 * @export
 * @interface ApiSvcITableFieldSchemaCategories
 */
export interface ApiSvcITableFieldSchemaCategories {
  /**
   * A list of category resource names. For example, \"projects/1/taxonomies/2/categories/3\". At most 5 categories are allowed.
   * @type {Array<string>}
   * @memberof ApiSvcITableFieldSchemaCategories
   */
  names?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcITableFieldSchemaPolicyTags
 */
export interface ApiSvcITableFieldSchemaPolicyTags {
  /**
   * A list of category resource names. For example, \"projects/1/location/eu/taxonomies/2/policyTags/3\". At most 1 policy tag is allowed.
   * @type {Array<string>}
   * @memberof ApiSvcITableFieldSchemaPolicyTags
   */
  names?: Array<string>;
}
/**
 * Optional. The subtype of the RANGE, if the type of this field is RANGE. If the type is RANGE, this field is required. Possible values for the field element type of a RANGE include: - DATE - DATETIME - TIMESTAMP
 * @export
 * @interface ApiSvcITableFieldSchemaRangeElementType
 */
export interface ApiSvcITableFieldSchemaRangeElementType {
  /**
   * The field element type of a RANGE
   * @type {string}
   * @memberof ApiSvcITableFieldSchemaRangeElementType
   */
  type?: string;
}
/**
 *
 * @export
 * @interface ApiSvcIetfEnterpriseUser
 */
export interface ApiSvcIetfEnterpriseUser {
  /**
   *
   * @type {string}
   * @memberof ApiSvcIetfEnterpriseUser
   */
  employeeNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIetfEnterpriseUser
   */
  costCenter?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIetfEnterpriseUser
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIetfEnterpriseUser
   */
  division?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIetfEnterpriseUser
   */
  department?: string;
  /**
   *
   * @type {ApiSvcIetfEnterpriseUserManager}
   * @memberof ApiSvcIetfEnterpriseUser
   */
  manager?: ApiSvcIetfEnterpriseUserManager;
}
/**
 *
 * @export
 * @interface ApiSvcIetfEnterpriseUserManager
 */
export interface ApiSvcIetfEnterpriseUserManager {
  /**
   *
   * @type {string}
   * @memberof ApiSvcIetfEnterpriseUserManager
   */
  value?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIetfEnterpriseUserManager
   */
  $ref?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIetfEnterpriseUserManager
   */
  displayName?: string;
}
/**
 *
 * @export
 * @interface ApiSvcIgnoreAction
 */
export interface ApiSvcIgnoreAction {
  /**
   *
   * @type {string}
   * @memberof ApiSvcIgnoreAction
   */
  type: ApiSvcIgnoreActionTypeEnum;
}

export const ApiSvcIgnoreActionTypeEnum = {
  Ignore: 'Ignore',
} as const;

export type ApiSvcIgnoreActionTypeEnum = typeof ApiSvcIgnoreActionTypeEnum[keyof typeof ApiSvcIgnoreActionTypeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcIgnoreTypeDTO = {
  All: 'All',
  Ignored: 'Ignored',
  Unignored: 'Unignored',
} as const;

export type ApiSvcIgnoreTypeDTO = typeof ApiSvcIgnoreTypeDTO[keyof typeof ApiSvcIgnoreTypeDTO];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcImpairmentMethodology = {
  DailyLow: 'daily-low',
  DailyClose: 'daily-close',
  DailyOpen: 'daily-open',
  OrgDefault: 'org-default',
  MonthlyLow: 'monthly-low',
  MonthlyClose: 'monthly-close',
  MonthlyOpen: 'monthly-open',
  YearlyLow: 'yearly-low',
  YearlyClose: 'yearly-close',
  YearlyOpen: 'yearly-open',
} as const;

export type ApiSvcImpairmentMethodology = typeof ApiSvcImpairmentMethodology[keyof typeof ApiSvcImpairmentMethodology];

/**
 *
 * @export
 * @interface ApiSvcImputedFeeDetailsDTO
 */
export interface ApiSvcImputedFeeDetailsDTO {
  /**
   * Optional direction override. If not provided, direction is auto-calculated from acquired vs disposed amounts.
   * @type {string}
   * @memberof ApiSvcImputedFeeDetailsDTO
   */
  imputedFeeDirection?: ApiSvcImputedFeeDetailsDTOImputedFeeDirectionEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcImputedFeeDetailsDTO
   */
  feeContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcImputedFeeDetailsDTO
   */
  feeCategoryId: string;
}

export const ApiSvcImputedFeeDetailsDTOImputedFeeDirectionEnum = {
  Inflow: 'INFLOW',
  Outflow: 'OUTFLOW',
} as const;

export type ApiSvcImputedFeeDetailsDTOImputedFeeDirectionEnum =
  typeof ApiSvcImputedFeeDetailsDTOImputedFeeDirectionEnum[keyof typeof ApiSvcImputedFeeDetailsDTOImputedFeeDirectionEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcImputedFeeDirection = {
  Inflow: 'INFLOW',
  Outflow: 'OUTFLOW',
} as const;

export type ApiSvcImputedFeeDirection = typeof ApiSvcImputedFeeDirection[keyof typeof ApiSvcImputedFeeDirection];

/**
 *
 * @export
 * @interface ApiSvcIndexedTransactionsUnionType
 */
export interface ApiSvcIndexedTransactionsUnionType {
  /**
   *
   * @type {ApiSvcTransactionsUnionType}
   * @memberof ApiSvcIndexedTransactionsUnionType
   */
  txn: ApiSvcTransactionsUnionType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIndexedTransactionsUnionType
   */
  txnId: string;
}
/**
 * DTO for intercompany transfer assets that includes categoryId
 * @export
 * @interface ApiSvcIntercompanyTransferAssetDTO
 */
export interface ApiSvcIntercompanyTransferAssetDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferAssetDTO
   */
  description?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcIntercompanyTransferAssetDTO
   */
  labels?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcIntercompanyTransferAssetDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferAssetDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferAssetDTO
   */
  walletId: string;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcIntercompanyTransferAssetDTO
   */
  asset: ApiSvcAssetValueDTO;
}
/**
 *
 * @export
 * @interface ApiSvcIntercompanyTransferAssetResponseDTO
 */
export interface ApiSvcIntercompanyTransferAssetResponseDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferAssetResponseDTO
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferAssetResponseDTO
   */
  amount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferAssetResponseDTO
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferAssetResponseDTO
   */
  categoryId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcIntercompanyTransferAssetResponseDTO
   */
  labels?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcIntercompanyTransferCategorizationAction
 */
export interface ApiSvcIntercompanyTransferCategorizationAction {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  labels?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  isIntercompanyTransfer?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  ignoreFailPricing?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  acquiredCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  acquiredContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  disposedCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  disposedContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  feeContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferCategorizationAction
   */
  type: ApiSvcIntercompanyTransferCategorizationActionTypeEnum;
}

export const ApiSvcIntercompanyTransferCategorizationActionTypeEnum = {
  IntercompanyTransferCategorization: 'IntercompanyTransferCategorization',
} as const;

export type ApiSvcIntercompanyTransferCategorizationActionTypeEnum =
  typeof ApiSvcIntercompanyTransferCategorizationActionTypeEnum[keyof typeof ApiSvcIntercompanyTransferCategorizationActionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcIntercompanyTransferCategorizationDTO
 */
export interface ApiSvcIntercompanyTransferCategorizationDTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeIntercompanyTransfer}
   * @memberof ApiSvcIntercompanyTransferCategorizationDTO
   */
  type: ApiSvcCategorizationTypeIntercompanyTransfer;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcIntercompanyTransferCategorizationDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcIntercompanyTransferCategorizationDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferCategorizationDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferCategorizationDTO
   */
  notes: string;
  /**
   *
   * @type {Array<ApiSvcIntercompanyTransferLineDTO>}
   * @memberof ApiSvcIntercompanyTransferCategorizationDTO
   */
  disposedAssets: Array<ApiSvcIntercompanyTransferLineDTO>;
  /**
   *
   * @type {Array<ApiSvcIntercompanyTransferLineDTO>}
   * @memberof ApiSvcIntercompanyTransferCategorizationDTO
   */
  acquiredAssets: Array<ApiSvcIntercompanyTransferLineDTO>;
  /**
   *
   * @type {Array<ApiSvcFeeLineDTO>}
   * @memberof ApiSvcIntercompanyTransferCategorizationDTO
   */
  fees?: Array<ApiSvcFeeLineDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcIntercompanyTransferCategorizationDTO
   */
  excludeIntercompanyGainLoss?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcIntercompanyTransferLineDTO
 */
export interface ApiSvcIntercompanyTransferLineDTO {
  /**
   *
   * @type {ApiSvcCategorizedLineTypeIntercompanyTransferLine}
   * @memberof ApiSvcIntercompanyTransferLineDTO
   */
  type: ApiSvcCategorizedLineTypeIntercompanyTransferLine;
  /**
   *
   * @type {ApiSvcIntercompanyTransferLineDTOSourceValue}
   * @memberof ApiSvcIntercompanyTransferLineDTO
   */
  sourceValue: ApiSvcIntercompanyTransferLineDTOSourceValue;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferLineDTO
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferLineDTO
   */
  categoryId: string;
  /**
   *
   * @type {ApiSvcCategorizedLineDirection}
   * @memberof ApiSvcIntercompanyTransferLineDTO
   */
  direction: ApiSvcCategorizedLineDirection;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcIntercompanyTransferLineDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcIntercompanyTransferLineDTO
   */
  labels?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferLineDTO
   */
  description?: string;
}

/**
 *
 * @export
 * @interface ApiSvcIntercompanyTransferLineDTOSourceValue
 */
export interface ApiSvcIntercompanyTransferLineDTOSourceValue {
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferLineDTOSourceValue
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferLineDTOSourceValue
   */
  currencyId: string;
}
/**
 *
 * @export
 * @interface ApiSvcIntercompanyTransferTxnDetailsDTO
 */
export interface ApiSvcIntercompanyTransferTxnDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcIntercompanyTransferTxnDetailsDTO
   */
  notes: string;
  /**
   *
   * @type {Array<ApiSvcIntercompanyTransferAssetResponseDTO>}
   * @memberof ApiSvcIntercompanyTransferTxnDetailsDTO
   */
  disposedAssets: Array<ApiSvcIntercompanyTransferAssetResponseDTO>;
  /**
   *
   * @type {Array<ApiSvcIntercompanyTransferAssetResponseDTO>}
   * @memberof ApiSvcIntercompanyTransferTxnDetailsDTO
   */
  acquiredAssets: Array<ApiSvcIntercompanyTransferAssetResponseDTO>;
  /**
   *
   * @type {Array<ApiSvcDetailedFeeDTO>}
   * @memberof ApiSvcIntercompanyTransferTxnDetailsDTO
   */
  fees?: Array<ApiSvcDetailedFeeDTO>;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcIntercompanyTransferTxnDetailsDTO
   */
  exchangeRates?: Array<ApiSvcExchangeRateDetailsDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcInternalError
 */
export interface ApiSvcInternalError {
  /**
   *
   * @type {ApiSvcTransientErrorReasonInternalError}
   * @memberof ApiSvcInternalError
   */
  errorType: ApiSvcTransientErrorReasonInternalError;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInternalError
   */
  rawMessage?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInternalError
   */
  httpStatus?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcInternalError
   */
  metadata?: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInternalError
   */
  errorCode?: string;
}

/**
 *
 * @export
 * @interface ApiSvcInternalTransferCategorizationAction
 */
export interface ApiSvcInternalTransferCategorizationAction {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcInternalTransferCategorizationAction
   */
  labels?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInternalTransferCategorizationAction
   */
  ignoreFailPricing?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInternalTransferCategorizationAction
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInternalTransferCategorizationAction
   */
  feeContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInternalTransferCategorizationAction
   */
  type: ApiSvcInternalTransferCategorizationActionTypeEnum;
}

export const ApiSvcInternalTransferCategorizationActionTypeEnum = {
  InternalTransferCategorization: 'InternalTransferCategorization',
} as const;

export type ApiSvcInternalTransferCategorizationActionTypeEnum =
  typeof ApiSvcInternalTransferCategorizationActionTypeEnum[keyof typeof ApiSvcInternalTransferCategorizationActionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcInventoryAction
 */
export interface ApiSvcInventoryAction {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  runId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryAction
   */
  timestampSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  timestamp?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  action?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  txnId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  eventId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  lotId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  asset?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  assetId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  assetUnitAdj?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  assetBalance?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryAction
   */
  lotAcquisitionTimestampSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  txnExchangeRate?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  carryingValue?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  impairmentExpense?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  fairMarketValueDisposed?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  shortTermGainLoss?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  longTermGainLoss?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  undatedGainLoss?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  costBasisAcquired?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  costBasisRelieved?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  costAverageRate?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryAction
   */
  isTrade?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  lineError?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  transferLotId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  originalLotId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  inventory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  wallet?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  fromWallet?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  toWallet?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  categoryCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  categoryType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryAction
   */
  subsidiaryName?: string;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryActionResponse
 */
export interface ApiSvcInventoryActionResponse {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcInventoryActionResponse
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcInventoryActionResponse
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryActionResponse
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryActionResponse
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcInventoryActionResponse
   */
  metadata?: object;
  /**
   *
   * @type {Array<ApiSvcInventoryAction>}
   * @memberof ApiSvcInventoryActionResponse
   */
  actions: Array<ApiSvcInventoryAction>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryActionResponse
   */
  nextPageToken?: string;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryBalanceCheckReportLine
 */
export interface ApiSvcInventoryBalanceCheckReportLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  org_name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  walletid: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  wallet_name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  asset_symbol: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  bitwave_balance_time: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  bitwave_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  thirdparty_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  difference: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportLine
   */
  thirdparty_balance_time: string;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryBalanceCheckReportResp
 */
export interface ApiSvcInventoryBalanceCheckReportResp {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcInventoryBalanceCheckReportResp
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcInventoryBalanceCheckReportResp
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportResp
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportResp
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcInventoryBalanceCheckReportResp
   */
  metadata?: object;
  /**
   *
   * @type {ApiSvcInventoryBalanceCheckReportRespLines}
   * @memberof ApiSvcInventoryBalanceCheckReportResp
   */
  lines: ApiSvcInventoryBalanceCheckReportRespLines;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryBalanceCheckReportResp
   */
  pageToken?: string;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryBalanceCheckReportRespLines
 */
export interface ApiSvcInventoryBalanceCheckReportRespLines {}
/**
 *
 * @export
 * @interface ApiSvcInventoryBalanceResp
 */
export interface ApiSvcInventoryBalanceResp {
  /**
   *
   * @type {Array<ApiSvcInventoryShortBalanceLine>}
   * @memberof ApiSvcInventoryBalanceResp
   */
  lines: Array<ApiSvcInventoryShortBalanceLine>;
  /**
   *
   * @type {ApiSvcInventoryCounts}
   * @memberof ApiSvcInventoryBalanceResp
   */
  counts: ApiSvcInventoryCounts;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryBalanceRespPaginated
 */
export interface ApiSvcInventoryBalanceRespPaginated {
  /**
   *
   * @type {ApiSvcPaginatedResponseInventoryShortBalanceLine}
   * @memberof ApiSvcInventoryBalanceRespPaginated
   */
  lines: ApiSvcPaginatedResponseInventoryShortBalanceLine;
  /**
   *
   * @type {ApiSvcInventoryCounts}
   * @memberof ApiSvcInventoryBalanceRespPaginated
   */
  counts: ApiSvcInventoryCounts;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryCostBasisRollForwardLine
 */
export interface ApiSvcInventoryCostBasisRollForwardLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  asset: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  asset_id: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  starting_fiat_value: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  starting_qty_value: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  fiat_increases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  internal_cost_basis_acquired?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  qty_increases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  qty_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  ending_fiat_value: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  ending_qty_value: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  fmv_disposed_fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  internal_cost_basis_disposed?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  stGainLoss_fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  ltGainLoss_fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  impairExpense_fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  fiat_check_mustbe_zero: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  qty_check_mustbe_zero: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  undatedGainLoss_fiat_decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  current_price?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  fair_market_value?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  unrealized_gain_loss?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  impairExpenseReversal_fiat_increases?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryCostBasisRollForwardLine
   */
  subsidiaryName?: string;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryCostBasisRollForwardResp
 */
export interface ApiSvcInventoryCostBasisRollForwardResp {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcInventoryCostBasisRollForwardResp
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcInventoryCostBasisRollForwardResp
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryCostBasisRollForwardResp
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryCostBasisRollForwardResp
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcInventoryCostBasisRollForwardResp
   */
  metadata?: object;
  /**
   *
   * @type {Array<ApiSvcInventoryCostBasisRollForwardLine>}
   * @memberof ApiSvcInventoryCostBasisRollForwardResp
   */
  lines: Array<ApiSvcInventoryCostBasisRollForwardLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryCostBasisRollForwardResp
   */
  pageToken?: string;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryCounts
 */
export interface ApiSvcInventoryCounts {
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCounts
   */
  actions: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCounts
   */
  acquisitions: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCounts
   */
  dispositions: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCounts
   */
  uncategorized: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCounts
   */
  errored: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCounts
   */
  negativeBalanceError?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryCounts
   */
  lineErrors?: number;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryCountsResp
 */
export interface ApiSvcInventoryCountsResp {
  /**
   *
   * @type {ApiSvcInventoryCounts}
   * @memberof ApiSvcInventoryCountsResp
   */
  counts: ApiSvcInventoryCounts;
}
/**
 * Effects that consumers can apply to metadata dimensions. Defined here in the gain-loss domain because these effects are specific to inventory view processing.
 * @export
 * @enum {string}
 */

export const ApiSvcInventoryEffectType = {
  ForceZeroCost: 'force-zero-cost',
} as const;

export type ApiSvcInventoryEffectType = typeof ApiSvcInventoryEffectType[keyof typeof ApiSvcInventoryEffectType];

/**
 *
 * @export
 * @interface ApiSvcInventoryEnhancedGainLossResp
 */
export interface ApiSvcInventoryEnhancedGainLossResp {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcInventoryEnhancedGainLossResp
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcInventoryEnhancedGainLossResp
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryEnhancedGainLossResp
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryEnhancedGainLossResp
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcInventoryEnhancedGainLossResp
   */
  metadata?: object;
  /**
   *
   * @type {Array<ApiSvcInventoryJeReclassLine>}
   * @memberof ApiSvcInventoryEnhancedGainLossResp
   */
  lines: Array<ApiSvcInventoryJeReclassLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryEnhancedGainLossResp
   */
  pageToken?: string;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryGroupDTO
 */
export interface ApiSvcInventoryGroupDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryGroupDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryGroupDTO
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryGroupDTO
   */
  name: string;
  /**
   *
   * @type {Array<ApiSvcInventoryGroupDTOWalletIdsToInventoryIdsInner>}
   * @memberof ApiSvcInventoryGroupDTO
   */
  walletIdsToInventoryIds: Array<ApiSvcInventoryGroupDTOWalletIdsToInventoryIdsInner>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryGroupDTO
   */
  description: string;
  /**
   *
   * @type {ApiSvcMissingWalletHandling}
   * @memberof ApiSvcInventoryGroupDTO
   */
  missingWalletHandling: ApiSvcMissingWalletHandling;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryGroupDTOWalletIdsToInventoryIdsInner
 */
export interface ApiSvcInventoryGroupDTOWalletIdsToInventoryIdsInner {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryGroupDTOWalletIdsToInventoryIdsInner
   */
  inventoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryGroupDTOWalletIdsToInventoryIdsInner
   */
  walletId: string;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryGroupResponse
 */
export interface ApiSvcInventoryGroupResponse {
  /**
   *
   * @type {ApiSvcInventoryGroupDTO}
   * @memberof ApiSvcInventoryGroupResponse
   */
  item: ApiSvcInventoryGroupDTO;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryGroupsResult
 */
export interface ApiSvcInventoryGroupsResult {
  /**
   *
   * @type {Array<ApiSvcInventoryGroupDTO>}
   * @memberof ApiSvcInventoryGroupsResult
   */
  items: Array<ApiSvcInventoryGroupDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryJeReclassLine
 */
export interface ApiSvcInventoryJeReclassLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  asset: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  Reclass_Debit_Account: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  Reclass_Debit: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  Reclass_Credit_Account: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  Reclass_Credit: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  COLUMN_BREAK: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  period_change_in_digital_asset: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  starting_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  increases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  decreases: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  gain_Loss_changes: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  impariment_changes: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryJeReclassLine
   */
  ending_balance: number;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryJeReclassResp
 */
export interface ApiSvcInventoryJeReclassResp {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcInventoryJeReclassResp
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcInventoryJeReclassResp
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryJeReclassResp
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryJeReclassResp
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcInventoryJeReclassResp
   */
  metadata?: object;
  /**
   *
   * @type {Array<ApiSvcInventoryJeReclassLine>}
   * @memberof ApiSvcInventoryJeReclassResp
   */
  lines: Array<ApiSvcInventoryJeReclassLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryJeReclassResp
   */
  pageToken?: string;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryLot
 */
export interface ApiSvcInventoryLot {
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryLot
   */
  timestampSEC: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  lotId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  asset: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  qty: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  unitsAcquired: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  unitsDisposed: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  costBasisAcquired: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  costBasisRelieved: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  impairmentExpense: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  costBasis: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  carryingValue: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  inventory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  assetId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  txnId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  subsidiaryName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  adjustedToValue?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  wallet?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryLot
   */
  exchangeRate?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLot
   */
  fairMarketValue?: string;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryLotResponse
 */
export interface ApiSvcInventoryLotResponse {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcInventoryLotResponse
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcInventoryLotResponse
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLotResponse
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLotResponse
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcInventoryLotResponse
   */
  metadata?: object;
  /**
   *
   * @type {Array<ApiSvcInventoryLot>}
   * @memberof ApiSvcInventoryLotResponse
   */
  lots: Array<ApiSvcInventoryLot>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryLotResponse
   */
  nextPageToken?: string;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryMappingRule
 */
export interface ApiSvcInventoryMappingRule {
  /**
   *
   * @type {ApiSvcInventoryMappingRuleType}
   * @memberof ApiSvcInventoryMappingRule
   */
  type: ApiSvcInventoryMappingRuleType;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryMappingRuleRequest
 */
export interface ApiSvcInventoryMappingRuleRequest {
  /**
   *
   * @type {ApiSvcInventoryMappingRuleType}
   * @memberof ApiSvcInventoryMappingRuleRequest
   */
  type: ApiSvcInventoryMappingRuleType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryMappingRuleRequest
   */
  inventoryGroupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryMappingRuleRequest
   */
  inventoryMappingId?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcInventoryMappingRuleType = {
  GroupMapping: 'inventory-group-mapping',
  PerWallet: 'inventory-per-wallet',
} as const;

export type ApiSvcInventoryMappingRuleType =
  typeof ApiSvcInventoryMappingRuleType[keyof typeof ApiSvcInventoryMappingRuleType];

/**
 *
 * @export
 * @interface ApiSvcInventoryReallocationReportReq
 */
export interface ApiSvcInventoryReallocationReportReq {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryReallocationReportReq
   */
  originalInventoryViewId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryReallocationReportReq
   */
  walletBalanceInventoryViewId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryReallocationReportReq
   */
  endDate: string;
  /**
   *
   * @type {ApiSvcInventorySortFilter}
   * @memberof ApiSvcInventoryReallocationReportReq
   */
  inventorySortFilter?: ApiSvcInventorySortFilter;
  /**
   *
   * @type {ApiSvcInventorySortFilter}
   * @memberof ApiSvcInventoryReallocationReportReq
   */
  walletBalanceSortFilter?: ApiSvcInventorySortFilter;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryReallocationReportReq
   */
  reallocationDataSourceId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryReallocationReportReq
   */
  skipImportChecks?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryReallocationResponse
 */
export interface ApiSvcInventoryReallocationResponse {
  /**
   *
   * @type {Array<ApiSvcInventoryLot>}
   * @memberof ApiSvcInventoryReallocationResponse
   */
  lots: Array<ApiSvcInventoryLot>;
  /**
   *
   * @type {Array<ApiSvcInventoryLot>}
   * @memberof ApiSvcInventoryReallocationResponse
   */
  unallocatedLots: Array<ApiSvcInventoryLot>;
  /**
   *
   * @type {Array<ApiSvcWalletBalanceInventoryLine>}
   * @memberof ApiSvcInventoryReallocationResponse
   */
  unallocatedWalletLines: Array<ApiSvcWalletBalanceInventoryLine>;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryShortBalanceLine
 */
export interface ApiSvcInventoryShortBalanceLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  asset: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  assetId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  qty: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  costBasisAcquired: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  costBasisRelieved: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  impairmentExpense: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  impairmentExpenseReversal: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  costBasis: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  carryingValue: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  fairValueAdjustmentUpward: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  fairValueAdjustmentDownward: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  revaluationAdjustmentUpward: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  revaluationAdjustmentDownward: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  subsidiaryId: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryShortBalanceLine
   */
  subsidiaryName: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcInventorySortFilter
 */
export interface ApiSvcInventorySortFilter {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventorySortFilter
   */
  field: string;
  /**
   *
   * @type {ApiSvcSortDirection}
   * @memberof ApiSvcInventorySortFilter
   */
  direction: ApiSvcSortDirection;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryView
 */
export interface ApiSvcInventoryView {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryView
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryView
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryView
   */
  createdSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryView
   */
  updatedSEC: number;
  /**
   *
   * @type {ApiSvcUserPointer}
   * @memberof ApiSvcInventoryView
   */
  createdBy: ApiSvcUserPointer;
  /**
   *
   * @type {ApiSvcUserPointer}
   * @memberof ApiSvcInventoryView
   */
  updatedBy: ApiSvcUserPointer;
  /**
   *
   * @type {ApiSvcTaxStrategy}
   * @memberof ApiSvcInventoryView
   */
  inventoryPickingStrategy: ApiSvcTaxStrategy;
  /**
   *
   * @type {ApiSvcGainLossConfig}
   * @memberof ApiSvcInventoryView
   */
  inventoryConfig: ApiSvcGainLossConfig;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryView
   */
  impair: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryView
   */
  ignoreNFTs?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryView
   */
  lastUpdateRunSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryView
   */
  activeViewUpdateId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryView
   */
  activeRunId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryView
   */
  deleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryView
   */
  ignoreOrgWrappingTreatments: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryView
   */
  allowUpdate: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryView
   */
  isReallocatedView: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcInventoryView
   */
  subsidiaryIds?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryViewDTO
 */
export interface ApiSvcInventoryViewDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryViewDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryViewDTO
   */
  name: string;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryViewDownloadLinksResponse
 */
export interface ApiSvcInventoryViewDownloadLinksResponse {
  /**
   *
   * @type {ApiSvcInventoryViewDownloadLinksResponseLinks}
   * @memberof ApiSvcInventoryViewDownloadLinksResponse
   */
  _links: ApiSvcInventoryViewDownloadLinksResponseLinks;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryViewDownloadLinksResponseLinks
 */
export interface ApiSvcInventoryViewDownloadLinksResponseLinks {
  /**
   *
   * @type {ApiSvcLinkDTO}
   * @memberof ApiSvcInventoryViewDownloadLinksResponseLinks
   */
  gainLoss: ApiSvcLinkDTO;
  /**
   *
   * @type {ApiSvcLinkDTO}
   * @memberof ApiSvcInventoryViewDownloadLinksResponseLinks
   */
  results: ApiSvcLinkDTO;
  /**
   *
   * @type {ApiSvcLinkDTO}
   * @memberof ApiSvcInventoryViewDownloadLinksResponseLinks
   */
  actions: ApiSvcLinkDTO;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryViewResponse
 */
export interface ApiSvcInventoryViewResponse {
  /**
   *
   * @type {ApiSvcInventoryView}
   * @memberof ApiSvcInventoryViewResponse
   */
  item: ApiSvcInventoryView;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryViewUpdate
 */
export interface ApiSvcInventoryViewUpdate {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryViewUpdate
   */
  id?: string;
  /**
   *
   * @type {ApiSvcJobStatus}
   * @memberof ApiSvcInventoryViewUpdate
   */
  status: ApiSvcJobStatus;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryViewUpdate
   */
  inventoryViewId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryViewUpdate
   */
  updateRequestedSEC: number;
  /**
   *
   * @type {ApiSvcUserPointer}
   * @memberof ApiSvcInventoryViewUpdate
   */
  updateRequestedBy: ApiSvcUserPointer;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryViewUpdate
   */
  updateCompletedSEC?: number;
  /**
   *
   * @type {ApiSvcGainLossRunFiles}
   * @memberof ApiSvcInventoryViewUpdate
   */
  files?: ApiSvcGainLossRunFiles;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcInventoryViewUpdate
   */
  errors?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryViewUpdate
   */
  gainLossRunId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryViewUpdate
   */
  runIdReference?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryViewUpdate
   */
  startingSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInventoryViewUpdate
   */
  endingSEC?: number;
  /**
   *
   * @type {ApiSvcInventoryReallocationReportReq}
   * @memberof ApiSvcInventoryViewUpdate
   */
  reallocationReq?: ApiSvcInventoryReallocationReportReq;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryViewUpdate
   */
  transferAtHistoricalCost?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcInventoryViewUpdateEnhancedReq
 */
export interface ApiSvcInventoryViewUpdateEnhancedReq {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryViewUpdateEnhancedReq
   */
  runIdReference?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryViewUpdateEnhancedReq
   */
  startingDate?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInventoryViewUpdateEnhancedReq
   */
  endingDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInventoryViewUpdateEnhancedReq
   */
  transferAtHistoricalCost?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryViewUpdatesResult
 */
export interface ApiSvcInventoryViewUpdatesResult {
  /**
   *
   * @type {Array<ApiSvcInventoryViewUpdate>}
   * @memberof ApiSvcInventoryViewUpdatesResult
   */
  items: Array<ApiSvcInventoryViewUpdate>;
}
/**
 *
 * @export
 * @interface ApiSvcInventoryViewsResult
 */
export interface ApiSvcInventoryViewsResult {
  /**
   *
   * @type {Array<ApiSvcInventoryViewDTO>}
   * @memberof ApiSvcInventoryViewsResult
   */
  items: Array<ApiSvcInventoryViewDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcInvoiceCategorizationLineDTO
 */
export interface ApiSvcInvoiceCategorizationLineDTO {
  /**
   *
   * @type {ApiSvcCategorizedLineTypeInvoicePaymentLine}
   * @memberof ApiSvcInvoiceCategorizationLineDTO
   */
  type: ApiSvcCategorizedLineTypeInvoicePaymentLine;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceCategorizationLineDTO
   */
  invoiceId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceCategorizationLineDTO
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcInvoiceCategorizationLineDTO
   */
  paidAmount: ApiSvcRawValueDTO;
}

/**
 *
 * @export
 * @interface ApiSvcInvoiceDTO
 */
export interface ApiSvcInvoiceDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  reference?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  status: string;
  /**
   *
   * @type {Array<ApiSvcInvoiceLineDTO>}
   * @memberof ApiSvcInvoiceDTO
   */
  lines: Array<ApiSvcInvoiceLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  dueDate?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInvoiceDTO
   */
  dueAmount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInvoiceDTO
   */
  totalAmount: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  source: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInvoiceDTO
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceDTO
   */
  url?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInvoiceDTO
   */
  hasMatchedTransactions?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInvoiceDTO
   */
  exchangeRate: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcInvoiceDTO
   */
  metadata?: object;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInvoiceDTO
   */
  lastUpdatedSEC?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcInvoiceInputType = {
  Bill: 'Bill',
  Invoice: 'Invoice',
} as const;

export type ApiSvcInvoiceInputType = typeof ApiSvcInvoiceInputType[keyof typeof ApiSvcInvoiceInputType];

/**
 *
 * @export
 * @interface ApiSvcInvoiceLineDTO
 */
export interface ApiSvcInvoiceLineDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceLineDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceLineDTO
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInvoiceLineDTO
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInvoiceLineDTO
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInvoiceLineDTO
   */
  unitAmount?: number;
}
/**
 *
 * @export
 * @interface ApiSvcInvoicePaymentCategorizationDTO
 */
export interface ApiSvcInvoicePaymentCategorizationDTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeInvoicePayment}
   * @memberof ApiSvcInvoicePaymentCategorizationDTO
   */
  type: ApiSvcCategorizationTypeInvoicePayment;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcInvoicePaymentCategorizationDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInvoicePaymentCategorizationDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentCategorizationDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentCategorizationDTO
   */
  totalAmount: string;
  /**
   *
   * @type {Array<ApiSvcInvoiceCategorizationLineDTO>}
   * @memberof ApiSvcInvoicePaymentCategorizationDTO
   */
  invoices: Array<ApiSvcInvoiceCategorizationLineDTO>;
  /**
   *
   * @type {Array<ApiSvcFeeLineDTO>}
   * @memberof ApiSvcInvoicePaymentCategorizationDTO
   */
  fees?: Array<ApiSvcFeeLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentCategorizationDTO
   */
  invoiceType: string;
  /**
   *
   * @type {ApiSvcInvoicePaymentLineForexDTO}
   * @memberof ApiSvcInvoicePaymentCategorizationDTO
   */
  forex?: ApiSvcInvoicePaymentLineForexDTO;
}

/**
 *
 * @export
 * @interface ApiSvcInvoicePaymentLineDTO
 */
export interface ApiSvcInvoicePaymentLineDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineDTO
   */
  invoiceId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineDTO
   */
  amount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineDTO
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineDTO
   */
  contactId: string;
  /**
   *
   * @type {ApiSvcInvoicePaymentLineDTOCoin}
   * @memberof ApiSvcInvoicePaymentLineDTO
   */
  coin?: ApiSvcInvoicePaymentLineDTOCoin;
  /**
   *
   * @type {ApiSvcInvoicePaymentLineDTOUnit}
   * @memberof ApiSvcInvoicePaymentLineDTO
   */
  unit?: ApiSvcInvoicePaymentLineDTOUnit;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineDTO
   */
  coinAmount?: string;
  /**
   *
   * @type {ApiSvcDetailedForexDTO}
   * @memberof ApiSvcInvoicePaymentLineDTO
   */
  forex?: ApiSvcDetailedForexDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineDTO
   */
  walletId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcInvoicePaymentLineDTOCoin
 */
export interface ApiSvcInvoicePaymentLineDTOCoin {}
/**
 *
 * @export
 * @interface ApiSvcInvoicePaymentLineDTOUnit
 */
export interface ApiSvcInvoicePaymentLineDTOUnit {}
/**
 *
 * @export
 * @interface ApiSvcInvoicePaymentLineForexDTO
 */
export interface ApiSvcInvoicePaymentLineForexDTO {
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcInvoicePaymentLineForexDTO
   */
  sourceValue: ApiSvcRawValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineForexDTO
   */
  categoryId: string;
}
/**
 *
 * @export
 * @interface ApiSvcInvoicePaymentLineInput
 */
export interface ApiSvcInvoicePaymentLineInput {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcInvoicePaymentLineInput
   */
  walletDisabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineInput
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcForexInput}
   * @memberof ApiSvcInvoicePaymentLineInput
   */
  forex?: ApiSvcForexInput | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineInput
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineInput
   */
  sourceTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineInput
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineInput
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineInput
   */
  amountPaid: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentLineInput
   */
  invoiceId?: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcInvoicePaymentTxnDTO
 */
export interface ApiSvcInvoicePaymentTxnDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicePaymentTxnDTO
   */
  totalAmount: string;
  /**
   *
   * @type {Array<ApiSvcInvoicePaymentLineDTO>}
   * @memberof ApiSvcInvoicePaymentTxnDTO
   */
  invoices: Array<ApiSvcInvoicePaymentLineDTO>;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcInvoicePaymentTxnDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {Array<ApiSvcDetailedFeeDTO>}
   * @memberof ApiSvcInvoicePaymentTxnDTO
   */
  fees?: Array<ApiSvcDetailedFeeDTO>;
}
/**
 * Draft - not submitted for approval AwaitingApproval AwaitingPayment - Open invoice Paid - Paid In Full Rejected - not approved OnHold - approved but should not be paid Other - unknown status
 * @export
 * @enum {string}
 */

export const ApiSvcInvoiceStatuses = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_9: 9,
} as const;

export type ApiSvcInvoiceStatuses = typeof ApiSvcInvoiceStatuses[keyof typeof ApiSvcInvoiceStatuses];

/**
 *
 * @export
 * @interface ApiSvcInvoiceTransactionInput
 */
export interface ApiSvcInvoiceTransactionInput {
  /**
   *
   * @type {ApiSvcInvoiceInputType}
   * @memberof ApiSvcInvoiceTransactionInput
   */
  type: ApiSvcInvoiceInputType;
  /**
   *
   * @type {Array<ApiSvcDetailedFeeInput>}
   * @memberof ApiSvcInvoiceTransactionInput
   */
  fees?: Array<ApiSvcDetailedFeeInput> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoiceTransactionInput
   */
  totalAmount: string;
  /**
   *
   * @type {Array<ApiSvcExchangeRateInput>}
   * @memberof ApiSvcInvoiceTransactionInput
   */
  exchangeRates: Array<ApiSvcExchangeRateInput>;
  /**
   *
   * @type {Array<ApiSvcInvoicePaymentLineInput>}
   * @memberof ApiSvcInvoiceTransactionInput
   */
  invoices: Array<ApiSvcInvoicePaymentLineInput>;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcInvoiceTypes = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export type ApiSvcInvoiceTypes = typeof ApiSvcInvoiceTypes[keyof typeof ApiSvcInvoiceTypes];

/**
 * This class allows for custom filtering implementation based on the InvoiceDTO
 * @export
 * @interface ApiSvcInvoicesDTOFilteredPaginated
 */
export interface ApiSvcInvoicesDTOFilteredPaginated {
  /**
   *
   * @type {Array<ApiSvcInvoiceDTO>}
   * @memberof ApiSvcInvoicesDTOFilteredPaginated
   */
  records: Array<ApiSvcInvoiceDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicesDTOFilteredPaginated
   */
  previousPageToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicesDTOFilteredPaginated
   */
  nextPageToken?: string;
}
/**
 *
 * @export
 * @interface ApiSvcInvoicingSettings
 */
export interface ApiSvcInvoicingSettings {
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  fromEmail: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  fromName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  bitcoinAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  bitcoinXPub?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  bitcoinXPubPath?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcInvoicingSettings
   */
  bitcoinCurrentXPubIndex?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  ethAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  zecAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  usdcAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  usdtAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  avaxAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  alotAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcInvoicingSettings
   */
  aleoAddress?: string;
}
/**
 *
 * @export
 * @interface ApiSvcJobPointerInterface
 */
export interface ApiSvcJobPointerInterface {
  /**
   *
   * @type {ApiSvcJobPointerInterfaceLinks}
   * @memberof ApiSvcJobPointerInterface
   */
  _links: ApiSvcJobPointerInterfaceLinks;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobPointerInterface
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobPointerInterface
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobPointerInterface
   */
  groupId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobPointerInterface
   */
  groupName: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcJobPointerInterface
   */
  cadenceSEC: number;
}
/**
 *
 * @export
 * @interface ApiSvcJobPointerInterfaceLinks
 */
export interface ApiSvcJobPointerInterfaceLinks {
  /**
   *
   * @type {ApiSvcJobPointerInterfaceLinksExec}
   * @memberof ApiSvcJobPointerInterfaceLinks
   */
  exec: ApiSvcJobPointerInterfaceLinksExec;
}
/**
 *
 * @export
 * @interface ApiSvcJobPointerInterfaceLinksExec
 */
export interface ApiSvcJobPointerInterfaceLinksExec {
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobPointerInterfaceLinksExec
   */
  method: ApiSvcJobPointerInterfaceLinksExecMethodEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobPointerInterfaceLinksExec
   */
  href: string;
}

export const ApiSvcJobPointerInterfaceLinksExecMethodEnum = {
  Post: 'POST',
} as const;

export type ApiSvcJobPointerInterfaceLinksExecMethodEnum =
  typeof ApiSvcJobPointerInterfaceLinksExecMethodEnum[keyof typeof ApiSvcJobPointerInterfaceLinksExecMethodEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcJobStatus = {
  New: 'New',
  Queued: 'Queued',
  Running: 'Running',
  Errored: 'Errored',
  Complete: 'Complete',
  TimedOut: 'TimedOut',
  Cancelled: 'Cancelled',
} as const;

export type ApiSvcJobStatus = typeof ApiSvcJobStatus[keyof typeof ApiSvcJobStatus];

/**
 *
 * @export
 * @interface ApiSvcJobTableData
 */
export interface ApiSvcJobTableData {
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobTableData
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobTableData
   */
  orgid?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobTableData
   */
  endpoint: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobTableData
   */
  walletid?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobTableData
   */
  connectionid?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobTableData
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobTableData
   */
  href: string;
}
/**
 *
 * @export
 * @interface ApiSvcJobsPageResultDto
 */
export interface ApiSvcJobsPageResultDto {
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobsPageResultDto
   */
  nextPageToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJobsPageResultDto
   */
  service?: string;
  /**
   *
   * @type {Array<ApiSvcJobPointerInterface>}
   * @memberof ApiSvcJobsPageResultDto
   */
  jobs?: Array<ApiSvcJobPointerInterface>;
}
/**
 * This is for display  accountDebit or accountCredit will be the amount shown as the difference of debits and credits of the lines totalDebit and totalCredit are the totals of all the lines
 * @export
 * @interface ApiSvcJournalEntryDTO
 */
export interface ApiSvcJournalEntryDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  transactionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  localDateTimeISO?: string;
  /**
   *
   * @type {ApiSvcJournalReportEntryType}
   * @memberof ApiSvcJournalEntryDTO
   */
  transactionType?: ApiSvcJournalReportEntryType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  ref?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  account?: string;
  /**
   *
   * @type {ApiSvcFiatValue}
   * @memberof ApiSvcJournalEntryDTO
   */
  accountDebit?: ApiSvcFiatValue;
  /**
   *
   * @type {ApiSvcFiatValue}
   * @memberof ApiSvcJournalEntryDTO
   */
  accountCredit?: ApiSvcFiatValue;
  /**
   *
   * @type {ApiSvcFiatValue}
   * @memberof ApiSvcJournalEntryDTO
   */
  totalDebit?: ApiSvcFiatValue;
  /**
   *
   * @type {ApiSvcFiatValue}
   * @memberof ApiSvcJournalEntryDTO
   */
  totalCredit?: ApiSvcFiatValue;
  /**
   *
   * @type {Array<ApiSvcJournalEntryLineDTO>}
   * @memberof ApiSvcJournalEntryDTO
   */
  lines: Array<ApiSvcJournalEntryLineDTO>;
  /**
   *
   * @type {ApiSvcJournalEntryMeta}
   * @memberof ApiSvcJournalEntryDTO
   */
  meta?: ApiSvcJournalEntryMeta;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  internalCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryDTO
   */
  internalContactId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcJournalEntryLineDTO
 */
export interface ApiSvcJournalEntryLineDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  ref?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  desc: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  account: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  accountId?: string;
  /**
   *
   * @type {ApiSvcFiatValue}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  debit?: ApiSvcFiatValue;
  /**
   *
   * @type {ApiSvcFiatValue}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  credit?: ApiSvcFiatValue;
  /**
   *
   * @type {ApiSvcJournalEntryLineMeta}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  meta?: ApiSvcJournalEntryLineMeta;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  internalCategoryId?: string;
  /**
   *
   * @type {Array<ApiSvcAccountingEntryMetadata>}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  metadata?: Array<ApiSvcAccountingEntryMetadata>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  walletId?: string;
  /**
   * whether to exclude this entry line from the journal report this should ONLY be used for internal transfers. we only want the outer accounting entry not this line
   * @type {boolean}
   * @memberof ApiSvcJournalEntryLineDTO
   */
  excludeFromJournalReport?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcJournalEntryLineMeta
 */
export interface ApiSvcJournalEntryLineMeta {
  /**
   *
   * @type {string}
   * @memberof ApiSvcJournalEntryLineMeta
   */
  currencyId: string;
  /**
   *
   * @type {ApiSvcCoinValue}
   * @memberof ApiSvcJournalEntryLineMeta
   */
  cryptoAmount: ApiSvcCoinValue;
}
/**
 *
 * @export
 * @interface ApiSvcJournalEntryMeta
 */
export interface ApiSvcJournalEntryMeta {
  /**
   *
   * @type {Array<ApiSvcJournalEntryLineMeta>}
   * @memberof ApiSvcJournalEntryMeta
   */
  cryptoAmounts: Array<ApiSvcJournalEntryLineMeta>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcJournalReportEntryType = {
  Expense: 'Expense',
  Deposit: 'Deposit',
  InvoicePayment: 'Invoice Payment',
  BillPayment: 'Bill Payment',
  Transfer: 'Transfer',
} as const;

export type ApiSvcJournalReportEntryType =
  typeof ApiSvcJournalReportEntryType[keyof typeof ApiSvcJournalReportEntryType];

/**
 *
 * @export
 * @interface ApiSvcJwtBasedToken
 */
export interface ApiSvcJwtBasedToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcJwtBasedToken
   */
  jwt: string;
}
/**
 *
 * @export
 * @interface ApiSvcKeyBasedPassToken
 */
export interface ApiSvcKeyBasedPassToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcKeyBasedPassToken
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcKeyBasedPassToken
   */
  passphrase: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcKeyBasedPassToken
   */
  signingKey: string;
}
/**
 *
 * @export
 * @interface ApiSvcKeyBasedToken
 */
export interface ApiSvcKeyBasedToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcKeyBasedToken
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcKeyBasedToken
   */
  secret?: string;
}
/**
 * Whether a label inclusion rule keeps matching transactions (Include) or drops them (Exclude). Absence of a rule (or an empty selector list) means \"include every transaction\" — i.e. no filtering at all.
 * @export
 * @enum {string}
 */

export const ApiSvcLabelInclusionMode = {
  Include: 'include',
  Exclude: 'exclude',
} as const;

export type ApiSvcLabelInclusionMode = typeof ApiSvcLabelInclusionMode[keyof typeof ApiSvcLabelInclusionMode];

/**
 *
 * @export
 * @interface ApiSvcLabelInclusionRule
 */
export interface ApiSvcLabelInclusionRule {
  /**
   *
   * @type {ApiSvcLabelInclusionMode}
   * @memberof ApiSvcLabelInclusionRule
   */
  mode: ApiSvcLabelInclusionMode;
  /**
   *
   * @type {Array<ApiSvcLabelSelector>}
   * @memberof ApiSvcLabelInclusionRule
   */
  selectors: Array<ApiSvcLabelSelector>;
  /**
   *
   * @type {ApiSvcLabelMatchMode}
   * @memberof ApiSvcLabelInclusionRule
   */
  match?: ApiSvcLabelMatchMode;
}

/**
 *
 * @export
 * @interface ApiSvcLabelInclusionRuleRequest
 */
export interface ApiSvcLabelInclusionRuleRequest {
  /**
   *
   * @type {ApiSvcLabelInclusionMode}
   * @memberof ApiSvcLabelInclusionRuleRequest
   */
  mode: ApiSvcLabelInclusionMode;
  /**
   *
   * @type {ApiSvcLabelMatchMode}
   * @memberof ApiSvcLabelInclusionRuleRequest
   */
  match?: ApiSvcLabelMatchMode;
  /**
   *
   * @type {Array<ApiSvcLabelSelectorRequest>}
   * @memberof ApiSvcLabelInclusionRuleRequest
   */
  selectors: Array<ApiSvcLabelSelectorRequest>;
}

/**
 * How a rule\'s selectors combine.  - Any: a transaction matches if it carries at least one selected label/template (OR).  - All: a transaction matches only if it carries every selected label/template (AND). Absent `match` is treated as Any (the original single-selector-OR behavior).
 * @export
 * @enum {string}
 */

export const ApiSvcLabelMatchMode = {
  Any: 'any',
  All: 'all',
} as const;

export type ApiSvcLabelMatchMode = typeof ApiSvcLabelMatchMode[keyof typeof ApiSvcLabelMatchMode];

/**
 *
 * @export
 * @interface ApiSvcLabelSelector
 */
export interface ApiSvcLabelSelector {
  /**
   *
   * @type {ApiSvcLabelSelectorKind}
   * @memberof ApiSvcLabelSelector
   */
  kind: ApiSvcLabelSelectorKind;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLabelSelector
   */
  value: string;
}

/**
 * How a single selector matches a transaction\'s labels.  - Label: exact labelId match (a flat label such as `mining_revenue`).  - Template: prefix match on a slugged label template such as `client`, which    matches every value under it (`client:12345`, `client:67890`, ...). The    prefix is the substring before the single `:` separator; a bare label with    no colon never matches a Template selector.
 * @export
 * @enum {string}
 */

export const ApiSvcLabelSelectorKind = {
  Label: 'label',
  Template: 'template',
} as const;

export type ApiSvcLabelSelectorKind = typeof ApiSvcLabelSelectorKind[keyof typeof ApiSvcLabelSelectorKind];

/**
 *
 * @export
 * @interface ApiSvcLabelSelectorRequest
 */
export interface ApiSvcLabelSelectorRequest {
  /**
   *
   * @type {ApiSvcLabelSelectorKind}
   * @memberof ApiSvcLabelSelectorRequest
   */
  kind: ApiSvcLabelSelectorKind;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLabelSelectorRequest
   */
  value: string;
}

/**
 * Designates a single label template (e.g. `client`) as the inventory tracking dimension for a view: every distinct value under it (`client:001`, `client:002`, ...) gets its own independent inventory, cost basis, and gain/loss. `template` is the prefix before the `:` separator. A transaction with no value under the template falls back to the default wallet-level inventory mapping. Create-time only and at most one per view (more than one tracking dimension would make lot assignment ambiguous).
 * @export
 * @interface ApiSvcLabelTrackingRule
 */
export interface ApiSvcLabelTrackingRule {
  /**
   *
   * @type {string}
   * @memberof ApiSvcLabelTrackingRule
   */
  template: string;
}
/**
 *
 * @export
 * @interface ApiSvcLabelTrackingRuleRequest
 */
export interface ApiSvcLabelTrackingRuleRequest {
  /**
   * The label template (prefix) designated as the inventory tracking dimension, e.g. `client`. Each distinct value under it (`client:001`, `client:002`, ...) gets its own independent inventory. Create-time only; at most one per view.
   * @type {string}
   * @memberof ApiSvcLabelTrackingRuleRequest
   */
  template: string;
}
/**
 *
 * @export
 * @interface ApiSvcLineDelta
 */
export interface ApiSvcLineDelta {
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDelta
   */
  ticker: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcLineDelta
   */
  succeededCheck: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcLineDelta
   */
  isNegative: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDelta
   */
  localValue?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDelta
   */
  localFiatValue?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDelta
   */
  remoteValue?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDelta
   */
  remoteFiatValue?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcLineDelta
   */
  warnings?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcLineDeltaDTO
 */
export interface ApiSvcLineDeltaDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDeltaDTO
   */
  ticker: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcLineDeltaDTO
   */
  succeededCheck: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcLineDeltaDTO
   */
  isNegative: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDeltaDTO
   */
  localValue?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDeltaDTO
   */
  localFiatValue?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDeltaDTO
   */
  remoteValue?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLineDeltaDTO
   */
  remoteFiatValue?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcLineDeltaDTO
   */
  warnings?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcLinkDTO
 */
export interface ApiSvcLinkDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcLinkDTO
   */
  href: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLinkDTO
   */
  method: ApiSvcLinkDTOMethodEnum;
  /**
   *
   * @type {number}
   * @memberof ApiSvcLinkDTO
   */
  expiresAtSEC?: number;
}

export const ApiSvcLinkDTOMethodEnum = {
  Get: 'get',
  Post: 'post',
  Put: 'put',
} as const;

export type ApiSvcLinkDTOMethodEnum = typeof ApiSvcLinkDTOMethodEnum[keyof typeof ApiSvcLinkDTOMethodEnum];

/**
 *
 * @export
 * @interface ApiSvcListAssignments200Response
 */
export interface ApiSvcListAssignments200Response {
  /**
   *
   * @type {Array<ApiSvcSftpPathAssignmentDTO>}
   * @memberof ApiSvcListAssignments200Response
   */
  items: Array<ApiSvcSftpPathAssignmentDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcListAssignments200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcListAssignments200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcListAssignments200ResponseAnyOf
 */
export interface ApiSvcListAssignments200ResponseAnyOf {
  /**
   *
   * @type {Array<ApiSvcSftpPathAssignmentDTO>}
   * @memberof ApiSvcListAssignments200ResponseAnyOf
   */
  items: Array<ApiSvcSftpPathAssignmentDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcListCloseReportsResponse
 */
export interface ApiSvcListCloseReportsResponse {
  /**
   *
   * @type {Array<ApiSvcGetReportDetailsResponse>}
   * @memberof ApiSvcListCloseReportsResponse
   */
  reports: Array<ApiSvcGetReportDetailsResponse>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcListCloseReportsResponse
   */
  nextCursor?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcListCloseReportsResponse
   */
  hasMore: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcListPaths200Response
 */
export interface ApiSvcListPaths200Response {
  /**
   *
   * @type {Array<ApiSvcSftpPathDTO>}
   * @memberof ApiSvcListPaths200Response
   */
  items: Array<ApiSvcSftpPathDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcListPaths200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcListPaths200Response
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcListPaths200ResponseAnyOf
 */
export interface ApiSvcListPaths200ResponseAnyOf {
  /**
   *
   * @type {Array<ApiSvcSftpPathDTO>}
   * @memberof ApiSvcListPaths200ResponseAnyOf
   */
  items: Array<ApiSvcSftpPathDTO>;
}
/**
 * Response wrapper for `GET /v2/orgs/{orgId}/report-runs`.
 * @export
 * @interface ApiSvcListReportRunsResponse
 */
export interface ApiSvcListReportRunsResponse {
  /**
   *
   * @type {Array<ApiSvcReportRunSummaryDTO>}
   * @memberof ApiSvcListReportRunsResponse
   */
  items: Array<ApiSvcReportRunSummaryDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcListReportRunsResponse
   */
  nextPageToken?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcLogLevel = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
} as const;

export type ApiSvcLogLevel = typeof ApiSvcLogLevel[keyof typeof ApiSvcLogLevel];

/**
 *
 * @export
 * @interface ApiSvcLrcMarketplaceWallet
 */
export interface ApiSvcLrcMarketplaceWallet {
  /**
   *
   * @type {string}
   * @memberof ApiSvcLrcMarketplaceWallet
   */
  connectionId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLrcMarketplaceWallet
   */
  groupId?: string | null;
  /**
   *
   * @type {ApiSvcRollupConfig}
   * @memberof ApiSvcLrcMarketplaceWallet
   */
  rollupConfig?: ApiSvcRollupConfig | null;
  /**
   *
   * @type {number}
   * @memberof ApiSvcLrcMarketplaceWallet
   */
  submitterId: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcLrcMarketplaceWallet
   */
  affiliateId: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLrcMarketplaceWallet
   */
  description?: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcLrcMarketplaceWalletDTO
 */
export interface ApiSvcLrcMarketplaceWalletDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcLrcMarketplaceWalletDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLrcMarketplaceWalletDTO
   */
  networkId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcLrcMarketplaceWalletDTO
   */
  affiliateId: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcLrcMarketplaceWalletDTO
   */
  submitterId: number;
  /**
   *
   * @type {ApiSvcRollupConfigDTO}
   * @memberof ApiSvcLrcMarketplaceWalletDTO
   */
  rollupConfig?: ApiSvcRollupConfigDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLrcMarketplaceWalletDTO
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcLrcMarketplaceWalletDTO
   */
  connectionId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcManualBlockchainWalletDTO
 */
export interface ApiSvcManualBlockchainWalletDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualBlockchainWalletDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualBlockchainWalletDTO
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualBlockchainWalletDTO
   */
  remoteId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcManualTransaction
 */
export interface ApiSvcManualTransaction {
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualTransaction
   */
  type: ApiSvcManualTransactionTypeEnum;
  /**
   *
   * @type {ApiSvcRemoteSystemId}
   * @memberof ApiSvcManualTransaction
   */
  remoteSystemId?: ApiSvcRemoteSystemId;
  /**
   *
   * @type {ApiSvcTransactionId}
   * @memberof ApiSvcManualTransaction
   */
  transactionId?: ApiSvcTransactionId;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualTransaction
   */
  connectionId?: string;
  /**
   *
   * @type {Array<ApiSvcTransactionMovementDetails>}
   * @memberof ApiSvcManualTransaction
   */
  from: Array<ApiSvcTransactionMovementDetails>;
  /**
   *
   * @type {Array<ApiSvcTransactionMovementDetails>}
   * @memberof ApiSvcManualTransaction
   */
  to: Array<ApiSvcTransactionMovementDetails>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualTransaction
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualTransaction
   */
  walletName?: string;
  /**
   *
   * @type {ApiSvcSources}
   * @memberof ApiSvcManualTransaction
   */
  source: ApiSvcSources;
  /**
   *
   * @type {ApiSvcManualTxnTypes}
   * @memberof ApiSvcManualTransaction
   */
  transactionType: ApiSvcManualTxnTypes;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcManualTransaction
   */
  amounts: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcManualTransaction
   */
  createdSEC: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcManualTransaction
   */
  isComplete: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualTransaction
   */
  contactId?: string;
  /**
   *
   * @type {ApiSvcTransferTransactionTransferAmount}
   * @memberof ApiSvcManualTransaction
   */
  fee?: ApiSvcTransferTransactionTransferAmount;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcManualTransaction
   */
  isOnChain?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcManualTransaction
   */
  isTaxExempt?: boolean;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcManualTransaction
   */
  metadata?: { [key: string]: string };
  /**
   *
   * @type {ApiSvcTxnOrigin}
   * @memberof ApiSvcManualTransaction
   */
  txnOrigin?: ApiSvcTxnOrigin;
}

export const ApiSvcManualTransactionTypeEnum = {
  Manual: 'manual',
} as const;

export type ApiSvcManualTransactionTypeEnum =
  typeof ApiSvcManualTransactionTypeEnum[keyof typeof ApiSvcManualTransactionTypeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcManualTxnTypes = {
  Deposit: 'deposit',
  Withdrawal: 'withdrawal',
  Other: 'other',
} as const;

export type ApiSvcManualTxnTypes = typeof ApiSvcManualTxnTypes[keyof typeof ApiSvcManualTxnTypes];

/**
 *
 * @export
 * @interface ApiSvcManualValidation
 */
export interface ApiSvcManualValidation {
  /**
   *
   * @type {number}
   * @memberof ApiSvcManualValidation
   */
  timestamp: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualValidation
   */
  user: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualValidation
   */
  userReason: string;
}
/**
 *
 * @export
 * @interface ApiSvcManualWallet
 */
export interface ApiSvcManualWallet {
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcManualWallet
   */
  metadata?: object | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualWallet
   */
  remoteId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualWallet
   */
  description?: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcManualWalletDTO
 */
export interface ApiSvcManualWalletDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualWalletDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualWalletDTO
   */
  remoteId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualWalletDTO
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManualWalletDTO
   */
  connectionId?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcManualWalletDTO
   */
  metadata?: object;
}
/**
 *
 * @export
 * @interface ApiSvcManuallyPricedExchangeRateDTO
 */
export interface ApiSvcManuallyPricedExchangeRateDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcManuallyPricedExchangeRateDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManuallyPricedExchangeRateDTO
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManuallyPricedExchangeRateDTO
   */
  to: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeManual}
   * @memberof ApiSvcManuallyPricedExchangeRateDTO
   */
  type: ApiSvcExchangeRateTypeManual;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManuallyPricedExchangeRateDTO
   */
  priceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManuallyPricedExchangeRateDTO
   */
  rate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcManuallyPricedExchangeRateDTO
   */
  reason?: string;
}

/**
 *
 * @export
 * @interface ApiSvcMarketplaceAffiliateToken
 */
export interface ApiSvcMarketplaceAffiliateToken {
  /**
   *
   * @type {number}
   * @memberof ApiSvcMarketplaceAffiliateToken
   */
  affiliateId: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMarketplaceAffiliateToken
   */
  submitterId: number;
}
/**
 *
 * @export
 * @interface ApiSvcMaterializedInventoryBalanceCheckReportLine
 */
export interface ApiSvcMaterializedInventoryBalanceCheckReportLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  org_name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  walletid: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  wallet_name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  asset_symbol: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  bitwave_balance_time: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  bitwave_register_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  bitwave_raw_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  thirdparty_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  register_difference: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  raw_difference: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLine
   */
  thirdparty_balance_time: string;
}
/**
 *
 * @export
 * @interface ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
 */
export interface ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  org_name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  walletid: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  wallet_name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  asset_symbol: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  bitwave_balance_time: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  bitwave_register_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  bitwave_raw_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  abbs_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  thirdparty_balance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  register_difference: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  raw_difference: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  register_vs_abbs_difference: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  raw_vs_abbs_difference: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMaterializedInventoryBalanceCheckReportLineWithAbbs
   */
  thirdparty_balance_time: string;
}
/**
 *
 * @export
 * @interface ApiSvcMe200Response
 */
export interface ApiSvcMe200Response {
  /**
   *
   * @type {ApiSvcUserTosAcceptance}
   * @memberof ApiSvcMe200Response
   */
  tosAcceptance: ApiSvcUserTosAcceptance;
  /**
   *
   * @type {ApiSvcMe200ResponseFeatureFlags}
   * @memberof ApiSvcMe200Response
   */
  featureFlags: ApiSvcMe200ResponseFeatureFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMe200Response
   */
  loginMethod: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMe200Response
   */
  photoUrl: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMe200Response
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMe200Response
   */
  id: string;
}
/**
 *
 * @export
 * @interface ApiSvcMe200ResponseFeatureFlags
 */
export interface ApiSvcMe200ResponseFeatureFlags {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMe200ResponseFeatureFlags
   */
  'create-org': string;
}
/**
 * This is the internal designated type of the metadata.
 * @export
 * @enum {string}
 */

export const ApiSvcMetaDataType = {
  Segment: 'segment',
  Other: 'other',
} as const;

export type ApiSvcMetaDataType = typeof ApiSvcMetaDataType[keyof typeof ApiSvcMetaDataType];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcMetaType = {
  Segment: 'segment',
  Other: 'other',
} as const;

export type ApiSvcMetaType = typeof ApiSvcMetaType[keyof typeof ApiSvcMetaType];

/**
 *
 * @export
 * @interface ApiSvcMetadataComparison
 */
export interface ApiSvcMetadataComparison {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMetadataComparison
   */
  txnRecordRule?: boolean | null;
  /**
   *
   * @type {Array<ApiSvcMetadataComparisonGraphQLMetadataInner>}
   * @memberof ApiSvcMetadataComparison
   */
  metadata: Array<ApiSvcMetadataComparisonGraphQLMetadataInner>;
  /**
   *
   * @type {ApiSvcMetadataOperator}
   * @memberof ApiSvcMetadataComparison
   */
  operator: ApiSvcMetadataOperator;
}

/**
 *
 * @export
 * @interface ApiSvcMetadataComparisonGraphQL
 */
export interface ApiSvcMetadataComparisonGraphQL {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMetadataComparisonGraphQL
   */
  txnRecordRule?: boolean | null;
  /**
   *
   * @type {Array<ApiSvcMetadataComparisonGraphQLMetadataInner>}
   * @memberof ApiSvcMetadataComparisonGraphQL
   */
  metadata: Array<ApiSvcMetadataComparisonGraphQLMetadataInner>;
  /**
   *
   * @type {ApiSvcMetadataOperator}
   * @memberof ApiSvcMetadataComparisonGraphQL
   */
  operator: ApiSvcMetadataOperator;
}

/**
 *
 * @export
 * @interface ApiSvcMetadataComparisonGraphQLMetadataInner
 */
export interface ApiSvcMetadataComparisonGraphQLMetadataInner {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataComparisonGraphQLMetadataInner
   */
  value?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataComparisonGraphQLMetadataInner
   */
  key: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcMetadataComponentReconcile = {
  Reconcile: 'reconcile',
} as const;

export type ApiSvcMetadataComponentReconcile =
  typeof ApiSvcMetadataComponentReconcile[keyof typeof ApiSvcMetadataComponentReconcile];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcMetadataComponentTag = {
  Tag: 'tag',
} as const;

export type ApiSvcMetadataComponentTag = typeof ApiSvcMetadataComponentTag[keyof typeof ApiSvcMetadataComponentTag];

/**
 *
 * @export
 * @interface ApiSvcMetadataDTO
 */
export interface ApiSvcMetadataDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataDTO
   */
  remoteType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataDTO
   */
  remoteId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataDTO
   */
  name: string;
  /**
   *
   * @type {object}
   * @memberof ApiSvcMetadataDTO
   */
  properties: object;
  /**
   *
   * @type {ApiSvcSpecialMetadataType}
   * @memberof ApiSvcMetadataDTO
   */
  type?: ApiSvcSpecialMetadataType;
  /**
   *
   * @type {object}
   * @memberof ApiSvcMetadataDTO
   */
  customData?: object;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcMetadataOperator = {
  And: 'AND',
  Nand: 'NAND',
  Or: 'OR',
  Nor: 'NOR',
  Xor: 'XOR',
} as const;

export type ApiSvcMetadataOperator = typeof ApiSvcMetadataOperator[keyof typeof ApiSvcMetadataOperator];

/**
 *
 * @export
 * @interface ApiSvcMetadataRecordDTO
 */
export interface ApiSvcMetadataRecordDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataRecordDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataRecordDTO
   */
  connectionId: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMetadataRecordDTO
   */
  enabled: boolean;
  /**
   *
   * @type {ApiSvcMetadataRecordDTOSource}
   * @memberof ApiSvcMetadataRecordDTO
   */
  source: ApiSvcMetadataRecordDTOSource;
  /**
   *
   * @type {ApiSvcMetaDataType}
   * @memberof ApiSvcMetadataRecordDTO
   */
  metaType: ApiSvcMetaDataType;
  /**
   *
   * @type {ApiSvcMetadataDTO}
   * @memberof ApiSvcMetadataRecordDTO
   */
  data: ApiSvcMetadataDTO;
}

/**
 *
 * @export
 * @interface ApiSvcMetadataRecordDTOSource
 */
export interface ApiSvcMetadataRecordDTOSource {}
/**
 *
 * @export
 * @interface ApiSvcMetadataStructDTO
 */
export interface ApiSvcMetadataStructDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataStructDTO
   */
  id: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMetadataStructDTO
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataStructDTO
   */
  source: string;
  /**
   *
   * @type {ApiSvcMetaType}
   * @memberof ApiSvcMetadataStructDTO
   */
  metaType: ApiSvcMetaType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataStructDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataStructDTO
   */
  remoteType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataStructDTO
   */
  connectionId: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcMetadataStructDTO
   */
  properties?: object | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMetadataStructDTO
   */
  specialMetadataType?: string | null;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcMetadataStructDTO
   */
  customData?: object | null;
}

/**
 *
 * @export
 * @interface ApiSvcMigrationTemporalWorkflowRequest
 */
export interface ApiSvcMigrationTemporalWorkflowRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationTemporalWorkflowRequest
   */
  migrationId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationTemporalWorkflowRequest
   */
  orgId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMigrationTemporalWorkflowRequest
   */
  auditMode?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationTemporalWorkflowRequest
   */
  reportTableId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcMigrationTemporalWorkflowStartResponse
 */
export interface ApiSvcMigrationTemporalWorkflowStartResponse {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMigrationTemporalWorkflowStartResponse
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationTemporalWorkflowStartResponse
   */
  workflowId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationTemporalWorkflowStartResponse
   */
  traceId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationTemporalWorkflowStartResponse
   */
  message?: string;
}
/**
 *
 * @export
 * @interface ApiSvcMigrationWorkflowResult
 */
export interface ApiSvcMigrationWorkflowResult {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationWorkflowResult
   */
  migrationId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationWorkflowResult
   */
  correlationId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationWorkflowResult
   */
  status: ApiSvcMigrationWorkflowResultStatusEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationWorkflowResult
   */
  orgId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMigrationWorkflowResult
   */
  auditMode?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationWorkflowResult
   */
  reportTableId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMigrationWorkflowResult
   */
  error?: string;
}

export const ApiSvcMigrationWorkflowResultStatusEnum = {
  Completed: 'completed',
  Failed: 'failed',
} as const;

export type ApiSvcMigrationWorkflowResultStatusEnum =
  typeof ApiSvcMigrationWorkflowResultStatusEnum[keyof typeof ApiSvcMigrationWorkflowResultStatusEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcMissingWalletHandling = {
  Default: 'map-to-default',
  Wallet: 'map-to-wallet',
} as const;

export type ApiSvcMissingWalletHandling = typeof ApiSvcMissingWalletHandling[keyof typeof ApiSvcMissingWalletHandling];

/**
 *
 * @export
 * @interface ApiSvcMultiContactInvoiceCategorizationDTO
 */
export interface ApiSvcMultiContactInvoiceCategorizationDTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeMultiContactInvoice}
   * @memberof ApiSvcMultiContactInvoiceCategorizationDTO
   */
  type: ApiSvcCategorizationTypeMultiContactInvoice;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcMultiContactInvoiceCategorizationDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultiContactInvoiceCategorizationDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiContactInvoiceCategorizationDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiContactInvoiceCategorizationDTO
   */
  totalAmount: string;
  /**
   *
   * @type {Array<ApiSvcMultiContactInvoicePaymentLineDTO>}
   * @memberof ApiSvcMultiContactInvoiceCategorizationDTO
   */
  invoices: Array<ApiSvcMultiContactInvoicePaymentLineDTO>;
  /**
   *
   * @type {Array<ApiSvcFeeLineDTO>}
   * @memberof ApiSvcMultiContactInvoiceCategorizationDTO
   */
  fees?: Array<ApiSvcFeeLineDTO>;
  /**
   *
   * @type {Array<ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO>}
   * @memberof ApiSvcMultiContactInvoiceCategorizationDTO
   */
  unapplied?: Array<ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO>;
}

/**
 *
 * @export
 * @interface ApiSvcMultiContactInvoicePaymentLineDTO
 */
export interface ApiSvcMultiContactInvoicePaymentLineDTO {
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  sourceValue: ApiSvcRawValueDTO;
  /**
   * source value multiply by exchange rate not every categorization has it
   * @type {any}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  appliedExchangeRateValue?: any;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcCategorizedLineTypeMultiContactInvoicePaymentLine}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  type: ApiSvcCategorizedLineTypeMultiContactInvoicePaymentLine;
  /**
   *
   * @type {ApiSvcCategorizedLineDirection}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  direction: ApiSvcCategorizedLineDirection;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  invoiceId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  contactId: string;
  /**
   *
   * @type {ApiSvcInvoicePaymentLineForexDTO}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  forex?: ApiSvcInvoicePaymentLineForexDTO;
  /**
   *
   * @type {ApiSvcMultiContactInvoicePaymentLineDTOOpts}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  opts?: ApiSvcMultiContactInvoicePaymentLineDTOOpts;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTO
   */
  paidAmount: ApiSvcRawValueDTO;
}

/**
 *
 * @export
 * @interface ApiSvcMultiContactInvoicePaymentLineDTOOpts
 */
export interface ApiSvcMultiContactInvoicePaymentLineDTOOpts {
  /**
   *
   * @type {ApiSvcDateRangeFrom}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTOOpts
   */
  currencyRemoteId?: ApiSvcDateRangeFrom;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMultiContactInvoicePaymentLineDTOOpts
   */
  exchangeRateToFunctionalCurrency?: number;
}
/**
 *
 * @export
 * @interface ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
 */
export interface ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO {
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
   */
  sourceValue: ApiSvcRawValueDTO;
  /**
   * source value multiply by exchange rate not every categorization has it
   * @type {any}
   * @memberof ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
   */
  appliedExchangeRateValue?: any;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcCategorizedLineTypeMultiContactInvoiceUnappliedPaymentLine}
   * @memberof ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
   */
  type: ApiSvcCategorizedLineTypeMultiContactInvoiceUnappliedPaymentLine;
  /**
   *
   * @type {ApiSvcCategorizedLineDirection}
   * @memberof ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
   */
  direction: ApiSvcCategorizedLineDirection;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
   */
  paidAmount: ApiSvcRawValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
   */
  contactId: string;
  /**
   *
   * @type {ApiSvcInvoicePaymentLineForexDTO}
   * @memberof ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
   */
  forex?: ApiSvcInvoicePaymentLineForexDTO;
  /**
   *
   * @type {ApiSvcMultiContactInvoicePaymentLineDTOOpts}
   * @memberof ApiSvcMultiContactInvoiceUnappliedPaymentLineDTO
   */
  opts?: ApiSvcMultiContactInvoicePaymentLineDTOOpts;
}

/**
 *
 * @export
 * @interface ApiSvcMultiValueCategorizationDTO
 */
export interface ApiSvcMultiValueCategorizationDTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeMultivalue}
   * @memberof ApiSvcMultiValueCategorizationDTO
   */
  type: ApiSvcCategorizationTypeMultivalue;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcMultiValueCategorizationDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultiValueCategorizationDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueCategorizationDTO
   */
  memo?: string;
  /**
   *
   * @type {Array<ApiSvcMultiValueCategorizationItemDTO>}
   * @memberof ApiSvcMultiValueCategorizationDTO
   */
  items: Array<ApiSvcMultiValueCategorizationItemDTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueCategorizationDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueCategorizationDTO
   */
  labels?: Array<string>;
}

/**
 *
 * @export
 * @interface ApiSvcMultiValueCategorizationItemDTO
 */
export interface ApiSvcMultiValueCategorizationItemDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueCategorizationItemDTO
   */
  contactId: string;
  /**
   *
   * @type {Array<ApiSvcMultiValueLineDTO>}
   * @memberof ApiSvcMultiValueCategorizationItemDTO
   */
  lines: Array<ApiSvcMultiValueLineDTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueCategorizationItemDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueCategorizationItemDTO
   */
  labels?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcMultiValueLineDTO
 */
export interface ApiSvcMultiValueLineDTO {
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcMultiValueLineDTO
   */
  sourceValue: ApiSvcRawValueDTO;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcMultiValueLineDTO
   */
  appliedExchangeRateValue?: ApiSvcRawValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueLineDTO
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcCategorizedLineTypeMultiValueLine}
   * @memberof ApiSvcMultiValueLineDTO
   */
  type: ApiSvcCategorizedLineTypeMultiValueLine;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueLineDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueLineDTO
   */
  description: string;
  /**
   *
   * @type {ApiSvcCategorizedLineDirection}
   * @memberof ApiSvcMultiValueLineDTO
   */
  direction: ApiSvcCategorizedLineDirection;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueLineDTO
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueLineDTO
   */
  labels?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMultiValueLineDTO
   */
  txnLineId?: number;
  /**
   *
   * @type {ApiSvcMultiValueLineDTOAttributes}
   * @memberof ApiSvcMultiValueLineDTO
   */
  attributes?: ApiSvcMultiValueLineDTOAttributes;
}

/**
 *
 * @export
 * @interface ApiSvcMultiValueLineDTOAttributes
 */
export interface ApiSvcMultiValueLineDTOAttributes {
  /**
   * only applicable for dispositions
   * @type {boolean}
   * @memberof ApiSvcMultiValueLineDTOAttributes
   */
  forceZeroGainLoss?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultiValueLineDTOAttributes
   */
  isFee?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcMultiValueTransactionInput
 */
export interface ApiSvcMultiValueTransactionInput {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueTransactionInput
   */
  metadataIds?: Array<string> | null;
  /**
   *
   * @type {Array<ApiSvcExchangeRateInput>}
   * @memberof ApiSvcMultiValueTransactionInput
   */
  exchangeRates: Array<ApiSvcExchangeRateInput>;
  /**
   *
   * @type {Array<ApiSvcMultiValueTransactionItemInput>}
   * @memberof ApiSvcMultiValueTransactionInput
   */
  items: Array<ApiSvcMultiValueTransactionItemInput>;
}
/**
 *
 * @export
 * @interface ApiSvcMultiValueTransactionItemInput
 */
export interface ApiSvcMultiValueTransactionItemInput {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueTransactionItemInput
   */
  labels?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueTransactionItemInput
   */
  metadataIds?: Array<string> | null;
  /**
   *
   * @type {Array<ApiSvcMultiValueTransactionLineInput>}
   * @memberof ApiSvcMultiValueTransactionItemInput
   */
  lines: Array<ApiSvcMultiValueTransactionLineInput>;
  /**
   *
   * @type {ApiSvcMultiValueTransactionItemInputTransactionType}
   * @memberof ApiSvcMultiValueTransactionItemInput
   */
  transactionType: ApiSvcMultiValueTransactionItemInputTransactionType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTransactionItemInput
   */
  contactId: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcMultiValueTransactionItemInputTransactionType = {
  Expense: 'Expense',
  Income: 'Income',
} as const;

export type ApiSvcMultiValueTransactionItemInputTransactionType =
  typeof ApiSvcMultiValueTransactionItemInputTransactionType[keyof typeof ApiSvcMultiValueTransactionItemInputTransactionType];

/**
 *
 * @export
 * @interface ApiSvcMultiValueTransactionLineInput
 */
export interface ApiSvcMultiValueTransactionLineInput {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  labels?: Array<string> | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  forceZeroGainLoss?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  isFee?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  walletId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  txnLineId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  address?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  metadataIds?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  fiatAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  sourceAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  sourceTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTransactionLineInput
   */
  categoryId: string;
}
/**
 *
 * @export
 * @interface ApiSvcMultiValueTxnDTO
 */
export interface ApiSvcMultiValueTxnDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnDTO
   */
  orgId: string;
  /**
   *
   * @type {Array<ApiSvcMultiValueTxnItemDTO>}
   * @memberof ApiSvcMultiValueTxnDTO
   */
  items: Array<ApiSvcMultiValueTxnItemDTO>;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcMultiValueTxnDTO
   */
  exchangeRates: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {Array<ApiSvcMetadataStructDTO>}
   * @memberof ApiSvcMultiValueTxnDTO
   */
  metadata?: Array<ApiSvcMetadataStructDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnDTO
   */
  notes?: string;
}
/**
 *
 * @export
 * @interface ApiSvcMultiValueTxnItemDTO
 */
export interface ApiSvcMultiValueTxnItemDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnItemDTO
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnItemDTO
   */
  transactionType: string;
  /**
   *
   * @type {Array<ApiSvcMultiValueTxnLineDTO>}
   * @memberof ApiSvcMultiValueTxnItemDTO
   */
  lines: Array<ApiSvcMultiValueTxnLineDTO>;
  /**
   *
   * @type {Array<ApiSvcMetadataStructDTO>}
   * @memberof ApiSvcMultiValueTxnItemDTO
   */
  metadata?: Array<ApiSvcMetadataStructDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcMultiValueTxnLineDTO
 */
export interface ApiSvcMultiValueTxnLineDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  categoryId: string;
  /**
   *
   * @type {ApiSvcValueDTO}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  sourceValue: ApiSvcValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  coin?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  unit?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  coinAmount?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  fiat: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  fiatAmount: string;
  /**
   *
   * @type {Array<ApiSvcMetadataStructDTO>}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  metadata?: Array<ApiSvcMetadataStructDTO>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  txnLineId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  walletId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  isFee?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  forceZeroGainLoss?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultiValueTxnLineDTO
   */
  labels?: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcMultisigAddressModes = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export type ApiSvcMultisigAddressModes = typeof ApiSvcMultisigAddressModes[keyof typeof ApiSvcMultisigAddressModes];

/**
 *
 * @export
 * @interface ApiSvcMultisigWallet
 */
export interface ApiSvcMultisigWallet {
  /**
   *
   * @type {ApiSvcBitcoinMultisigDerivationMode}
   * @memberof ApiSvcMultisigWallet
   */
  customDerivationMode: ApiSvcBitcoinMultisigDerivationMode;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultisigWallet
   */
  customPrependPath?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultisigWallet
   */
  customSortPublicKeys?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultisigWallet
   */
  customUseChange?: boolean | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultisigWallet
   */
  hds: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMultisigWallet
   */
  minCosigners: number;
  /**
   *
   * @type {ApiSvcMultisigWalletMode}
   * @memberof ApiSvcMultisigWallet
   */
  mode: ApiSvcMultisigWalletMode;
}

/**
 *
 * @export
 * @interface ApiSvcMultisigWalletDTO
 */
export interface ApiSvcMultisigWalletDTO {
  /**
   *
   * @type {ApiSvcMultisigAddressModes}
   * @memberof ApiSvcMultisigWalletDTO
   */
  mode: ApiSvcMultisigAddressModes;
  /**
   *
   * @type {number}
   * @memberof ApiSvcMultisigWalletDTO
   */
  minCosigners: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcMultisigWalletDTO
   */
  hds: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultisigWalletDTO
   */
  customUseChange?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcMultisigWalletDTO
   */
  customSortPublicKeys?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcMultisigWalletDTO
   */
  customPrependPath?: string;
  /**
   *
   * @type {ApiSvcBitcoinMultisigDerivationMode}
   * @memberof ApiSvcMultisigWalletDTO
   */
  customDerivationMode?: ApiSvcBitcoinMultisigDerivationMode;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcMultisigWalletMode = {
  ElectrumLegacyBtc: 'ElectrumLegacyBTC',
  ElectrumP2ShSegwitBtc: 'ElectrumP2SHSegwitBTC',
  ElectrumSegwitBtc: 'ElectrumSegwitBTC',
  Bitcoincom: 'Bitcoincom',
  Custom: 'custom',
} as const;

export type ApiSvcMultisigWalletMode = typeof ApiSvcMultisigWalletMode[keyof typeof ApiSvcMultisigWalletMode];

/**
 *
 * @export
 * @interface ApiSvcName
 */
export interface ApiSvcName {
  /**
   *
   * @type {string}
   * @memberof ApiSvcName
   */
  givenName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcName
   */
  familyName: string;
}
/**
 * DTO for nested exchange rates by fiat and currency
 * @export
 * @interface ApiSvcNestedExchangeRatesDTO
 */
export interface ApiSvcNestedExchangeRatesDTO {
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcNestedExchangeRatesDTO
   */
  rates: object;
}
/**
 * NetSuite-specific connection fields useful to a caller deciding to push. `netsuiteAccount` is the NS account identifier (used to disambiguate multiple NS connections on the same org for user display). `subsidiary` is the NS-internal subsidiary id this connection scopes to.
 * @export
 * @interface ApiSvcNetsuiteConnectionDetailsDTO
 */
export interface ApiSvcNetsuiteConnectionDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetsuiteConnectionDetailsDTO
   */
  defaultTaxCodeId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetsuiteConnectionDetailsDTO
   */
  defaultClassId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetsuiteConnectionDetailsDTO
   */
  defaultDepartmentId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetsuiteConnectionDetailsDTO
   */
  defaultLocationId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetsuiteConnectionDetailsDTO
   */
  currencyRemoteId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetsuiteConnectionDetailsDTO
   */
  feeAccountCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetsuiteConnectionDetailsDTO
   */
  accountCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetsuiteConnectionDetailsDTO
   */
  subsidiary?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetsuiteConnectionDetailsDTO
   */
  netsuiteAccount: string;
}
/**
 *
 * @export
 * @interface ApiSvcNetworkAddressWallet
 */
export interface ApiSvcNetworkAddressWallet {
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetworkAddressWallet
   */
  viewKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetworkAddressWallet
   */
  subsidiaryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetworkAddressWallet
   */
  connectionId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetworkAddressWallet
   */
  groupId?: string | null;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcNetworkAddressWallet
   */
  metadata?: object | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetworkAddressWallet
   */
  remoteId?: string | null;
  /**
   *
   * @type {ApiSvcRollupConfig}
   * @memberof ApiSvcNetworkAddressWallet
   */
  rollupConfig?: ApiSvcRollupConfig | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetworkAddressWallet
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcNetworkAddressWallet
   */
  address: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcNetworks = {
  Btc: 'btc',
  Bch: 'bch',
  Btg: 'btg',
  Eth: 'eth',
  Dash: 'dash',
  Eos: 'eos',
  Ltc: 'ltc',
  Xlm: 'xlm',
  Zec: 'zec',
  Trx: 'trx',
  One: 'one',
  Sol: 'sol',
  Dot: 'dot',
  Xtz: 'xtz',
  Scrt: 'scrt',
  Avax: 'avax',
  Avaxc: 'avaxc',
  Avaxp: 'avaxp',
  Avaxx: 'avaxx',
  Aion: 'aion',
  Icx: 'icx',
  Atom: 'atom',
  Band: 'band',
  Kava: 'kava',
  Iris: 'iris',
  Fil: 'fil',
  Rose: 'rose',
  Near: 'near',
  Bsv: 'bsv',
  Xvg: 'xvg',
  Polygon: 'polygon',
  Celo: 'celo',
  Etc: 'etc',
  Rvn: 'rvn',
  Doge: 'doge',
  Ada: 'ada',
  Mina: 'mina',
  Flow: 'flow',
  Ksm: 'ksm',
  Hbar: 'hbar',
  Xrp: 'xrp',
  Omni: 'omni',
  Bsc: 'bsc',
  Heco: 'heco',
  Terra: 'terra',
  Klay: 'klay',
  Algo: 'algo',
  Lrc: 'lrc',
  Casper: 'casper',
  Stx: 'stx',
  Bnb: 'bnb',
  Cosmos: 'cosmos',
  Ftm: 'ftm',
  Gnosis: 'gnosis',
  Op: 'op',
  Moon: 'moon',
  Icp: 'icp',
  Iost: 'iost',
  Iota: 'iota',
  Imx: 'imx',
  Ethw: 'ethw',
  Ronin: 'ronin',
  Shimmer: 'shimmer',
  Neo: 'neo',
  Qtum: 'qtum',
  Sgb: 'sgb',
  Vet: 'vet',
  Aurora: 'aurora',
  Apt: 'apt',
  Ont: 'ont',
  Sc: 'sc',
  Xem: 'xem',
  Xmr: 'xmr',
  Arb: 'arb',
  Osmo: 'osmo',
  Bld: 'bld',
  Aioz: 'aioz',
  Akt: 'akt',
  Mntl: 'mntl',
  Axl: 'axl',
  Bze: 'bze',
  Bcna: 'bcna',
  Btsg: 'btsg',
  Boot: 'boot',
  Canto: 'canto',
  Cro: 'cro',
  Inj: 'inj',
  Fet: 'fet',
  Ankr: 'ankr',
  Juno: 'juno',
  Kda: 'kda',
  Okt: 'okt',
  Zen: 'zen',
  Zil: 'zil',
  Kas: 'kas',
  Hot: 'hot',
  Audio: 'audio',
  Astr: 'astr',
  Bdx: 'bdx',
  Hnt: 'hnt',
  Regen: 'regen',
  Umee: 'umee',
  Evmos: 'evmos',
  Movr: 'movr',
  Dvpn: 'dvpn',
  Xprt: 'xprt',
  Egld: 'egld',
  Dgb: 'dgb',
  Sui: 'sui',
  Base: 'base',
  Beacon: 'beacon',
  Zeta: 'zeta',
  Dydx: 'dydx',
  Qkc: 'qkc',
  Xec: 'xec',
  Kmd: 'kmd',
  Dcr: 'dcr',
  Pivx: 'pivx',
  Canton: 'canton',
  Steem: 'steem',
  Lsk: 'lsk',
  Rsk: 'rsk',
  Zora: 'zora',
  Render: 'render',
  Iotx: 'iotx',
  Theta: 'theta',
  Rune: 'rune',
  Blast: 'blast',
  Ton: 'ton',
  Chiliz: 'chiliz',
  Sei: 'sei',
  Seievm: 'seievm',
  Flare: 'flare',
  Manta: 'manta',
  Ordinals: 'ordinals',
  Obt: 'obt',
  Zksync: 'zksync',
  Linea: 'linea',
  Zkevm: 'zkevm',
  Polyx: 'polyx',
  Core: 'core',
  Kly: 'kly',
  Aleo: 'aleo',
  Alot: 'alot',
  Kaia: 'kaia',
  Gunz: 'gunz',
  Berachain: 'berachain',
  Tao: 'tao',
  Ink: 'ink',
  Scr: 'scr',
  Hype: 'hype',
  Baby: 'baby',
  Mezo: 'mezo',
  Monad: 'monad',
  Plasma: 'plasma',
  Tac: 'tac',
  Unichain: 'unichain',
  Lighter: 'lighter',
  Cbtc: 'cbtc',
  Soneium: 'soneium',
  Sonic: 'sonic',
  Mantra: 'mantra',
} as const;

export type ApiSvcNetworks = typeof ApiSvcNetworks[keyof typeof ApiSvcNetworks];

/**
 * Generic internal-notification request. Conforms to what InternalNotificationService.send() consumes: a message and a target channel.  Extend this per use case (e.g. DeFi upsell leads) and post to the same endpoint — the controller stays generic. Extra properties on the body are ignored (tsoa strips them), so callers can send a richer shape.
 * @export
 * @interface ApiSvcNotificationRequest
 */
export interface ApiSvcNotificationRequest {
  /**
   * Slack channel ID to deliver to (e.g. a channel like C0XXXXXXX).
   * @type {string}
   * @memberof ApiSvcNotificationRequest
   */
  channel: string;
  /**
   * Message text to post (Slack mrkdwn).
   * @type {string}
   * @memberof ApiSvcNotificationRequest
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcOAuth2Response
 */
export interface ApiSvcOAuth2Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcOAuth2Response
   */
  access_token: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOAuth2Response
   */
  token_type: ApiSvcOAuth2ResponseTokenTypeEnum;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOAuth2Response
   */
  expires_in: number;
}

export const ApiSvcOAuth2ResponseTokenTypeEnum = {
  Bearer: 'Bearer',
  Cookie: 'Cookie',
} as const;

export type ApiSvcOAuth2ResponseTokenTypeEnum =
  typeof ApiSvcOAuth2ResponseTokenTypeEnum[keyof typeof ApiSvcOAuth2ResponseTokenTypeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcOAuth2TokenTypes = {
  IetfparamsoauthtokenTypejwt: 'urn:ietf:params:oauth:token-type:jwt',
  BitwaveparamsoauthtokenTypecookie: 'urn:bitwave:params:oauth:token-type:cookie',
} as const;

export type ApiSvcOAuth2TokenTypes = typeof ApiSvcOAuth2TokenTypes[keyof typeof ApiSvcOAuth2TokenTypes];

/**
 *
 * @export
 * @interface ApiSvcOAuthToken
 */
export interface ApiSvcOAuthToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcOAuthToken
   */
  accessToken: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOAuthToken
   */
  refreshToken: string;
}
/**
 *
 * @export
 * @interface ApiSvcOpSuccess
 */
export interface ApiSvcOpSuccess {
  /**
   *
   * @type {number}
   * @memberof ApiSvcOpSuccess
   */
  affectedCount?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOpSuccess
   */
  message?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcOpenTransactionStates = {
  New: 'new',
  ReadyToPrice: 'ready-to-price',
  FailedToPrice: 'failed-to-price',
  Priced: 'priced',
  Categorized: 'categorized',
  ReadyToSync: 'ready-to-sync',
  OpenNeedsReview: 'open-needs-review',
  NewNeedsReview: 'new-needs-review',
} as const;

export type ApiSvcOpenTransactionStates = typeof ApiSvcOpenTransactionStates[keyof typeof ApiSvcOpenTransactionStates];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcOrderingDirection = {
  Asc: 'asc',
  Desc: 'desc',
} as const;

export type ApiSvcOrderingDirection = typeof ApiSvcOrderingDirection[keyof typeof ApiSvcOrderingDirection];

/**
 *
 * @export
 * @interface ApiSvcOrgDTO
 */
export interface ApiSvcOrgDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgDTO
   */
  name: string;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof ApiSvcOrgDTO
   */
  roles: { [key: string]: number };
  /**
   *
   * @type {ApiSvcAccountingSetupDTO}
   * @memberof ApiSvcOrgDTO
   */
  accountingSetup?: ApiSvcAccountingSetupDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgDTO
   * @deprecated
   */
  accountingInventoryGroupId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcOrgDTO
   */
  accountingInventoryGroupIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgDTO
   */
  accountingERPId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgDTO
   */
  timezone?: string;
  /**
   *
   * @type {ApiSvcSubscriptionDetailsDTO}
   * @memberof ApiSvcOrgDTO
   */
  subscriptionDetails?: ApiSvcSubscriptionDetailsDTO;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOrgDTO
   */
  provisionedAccountingUsers?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOrgDTO
   */
  provisionedWalletUsers?: number;
  /**
   *
   * @type {ApiSvcTaxStrategy}
   * @memberof ApiSvcOrgDTO
   */
  taxStrategy?: ApiSvcTaxStrategy;
  /**
   *
   * @type {ApiSvcPricingSettingsDTO}
   * @memberof ApiSvcOrgDTO
   */
  pricingSettings?: ApiSvcPricingSettingsDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgDTO
   */
  baseCurrency?: string;
  /**
   *
   * @type {ApiSvcSSODTO}
   * @memberof ApiSvcOrgDTO
   */
  sso?: ApiSvcSSODTO | null;
  /**
   *
   * @type {Array<ApiSvcUserRole>}
   * @memberof ApiSvcOrgDTO
   */
  userRoles?: Array<ApiSvcUserRole>;
  /**
   *
   * @type {ApiSvcTaxConfigDTO}
   * @memberof ApiSvcOrgDTO
   */
  taxConfig?: ApiSvcTaxConfigDTO;
  /**
   *
   * @type {ApiSvcInvoicingSettings}
   * @memberof ApiSvcOrgDTO
   */
  invoicingSettings?: ApiSvcInvoicingSettings;
  /**
   *
   * @type {ApiSvcAccountingConfigDTO}
   * @memberof ApiSvcOrgDTO
   */
  accountingConfig?: ApiSvcAccountingConfigDTO;
  /**
   *
   * @type {Array<ApiSvcFeatureFlag>}
   * @memberof ApiSvcOrgDTO
   */
  flags?: Array<ApiSvcFeatureFlag>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgDTO
   */
  trialExpiry?: string;
  /**
   *
   * @type {ApiSvcDisplayConfigDTO}
   * @memberof ApiSvcOrgDTO
   */
  displayConfig?: ApiSvcDisplayConfigDTO;
  /**
   *
   * @type {ApiSvcTokenFilteringRulesConfig}
   * @memberof ApiSvcOrgDTO
   */
  tokenFilteringConfig?: ApiSvcTokenFilteringRulesConfig;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgDTO
   */
  hardCloseDate?: string;
  /**
   *
   * @type {ApiSvcEnterprisePaymentSettings}
   * @memberof ApiSvcOrgDTO
   */
  enterprisePaymentSettings?: ApiSvcEnterprisePaymentSettings;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcOrgDTO
   */
  scimEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcOrgDTO
   */
  isDisabled: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOrgDTO
   */
  engineVersion?: number;
}
/**
 *
 * @export
 * @interface ApiSvcOrgFeature
 */
export interface ApiSvcOrgFeature {
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgFeature
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgFeature
   */
  displayName: string;
}
/**
 * State for an org label definition.  Under the BW4-2664 template-model rework: a label is a *shape* — an identifier plus optional slug rules. Concrete slug values are not stored here; they live on the transaction as free text, validated against this row\'s slug rules on the tx-write path.  Effects (e.g. ForceZeroCost) are defined by the consumer (e.g. GainLossConfig), not by the label itself.
 * @export
 * @interface ApiSvcOrgLabelDefinition
 */
export interface ApiSvcOrgLabelDefinition {
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgLabelDefinition
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgLabelDefinition
   */
  labelId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgLabelDefinition
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgLabelDefinition
   */
  description?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcOrgLabelDefinition
   */
  enabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcOrgLabelDefinition
   */
  isDeleted: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOrgLabelDefinition
   */
  createdAtSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOrgLabelDefinition
   */
  updatedAtSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOrgLabelDefinition
   */
  deletedAtSEC?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcOrgLabelDefinition
   */
  isReserved: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcOrgLabelDefinition
   */
  allowSlugs: boolean;
  /**
   *
   * @type {ApiSvcSlugType}
   * @memberof ApiSvcOrgLabelDefinition
   */
  slugType?: ApiSvcSlugType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgLabelDefinition
   */
  slugValidationPattern?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgLabelDefinition
   */
  displayName: string;
}

/**
 *
 * @export
 * @interface ApiSvcOrgLabelDefinitionsResponse
 */
export interface ApiSvcOrgLabelDefinitionsResponse {
  /**
   *
   * @type {Array<ApiSvcOrgLabelDefinition>}
   * @memberof ApiSvcOrgLabelDefinitionsResponse
   */
  items: Array<ApiSvcOrgLabelDefinition>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgLabelDefinitionsResponse
   */
  nextPageToken?: string;
}
/**
 *
 * @export
 * @interface ApiSvcOrgLabelSlugTemplatesResponse
 */
export interface ApiSvcOrgLabelSlugTemplatesResponse {
  /**
   * Distinct slug-enabled label identifiers in the org. Used by the rules picker and the transaction filter UI.
   * @type {Array<string>}
   * @memberof ApiSvcOrgLabelSlugTemplatesResponse
   */
  labelIds: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcOrgLabelStatusFilter = {
  Enabled: 'enabled',
  Disabled: 'disabled',
  All: 'all',
} as const;

export type ApiSvcOrgLabelStatusFilter = typeof ApiSvcOrgLabelStatusFilter[keyof typeof ApiSvcOrgLabelStatusFilter];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcOrgManagedTableTypes = {
  GlActions: 'gl_actions',
} as const;

export type ApiSvcOrgManagedTableTypes = typeof ApiSvcOrgManagedTableTypes[keyof typeof ApiSvcOrgManagedTableTypes];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcOrgRelationshipType = {
  Client: 'client',
  Employee: 'employee',
} as const;

export type ApiSvcOrgRelationshipType = typeof ApiSvcOrgRelationshipType[keyof typeof ApiSvcOrgRelationshipType];

/**
 *
 * @export
 * @interface ApiSvcOrgRelationshipsV2
 */
export interface ApiSvcOrgRelationshipsV2 {
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgRelationshipsV2
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgRelationshipsV2
   */
  orgName: string;
  /**
   *
   * @type {ApiSvcOrgRelationshipType}
   * @memberof ApiSvcOrgRelationshipsV2
   */
  relType: ApiSvcOrgRelationshipType;
}

/**
 *
 * @export
 * @interface ApiSvcOrgResponseDTO
 */
export interface ApiSvcOrgResponseDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgResponseDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgResponseDTO
   */
  name: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcOrgResponseDTO
   */
  flags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgResponseDTO
   */
  timezone?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOrgResponseDTO
   */
  baseCurrency?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgResponseDTO
   */
  kekResourceName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgResponseDTO
   */
  storageBucket?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOrgResponseDTO
   */
  customerType: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgResponseDTO
   */
  trialExpiry?: string;
}
/**
 *
 * @export
 * @interface ApiSvcOrgSystemDetailsDTO
 */
export interface ApiSvcOrgSystemDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgSystemDetailsDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgSystemDetailsDTO
   */
  name: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcOrgSystemDetailsDTO
   */
  flags: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgSystemDetailsDTO
   */
  timezone: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcOrgSystemDetailsDTO
   */
  baseCurrency: number;
  /**
   *
   * @type {ApiSvcSsoSettings}
   * @memberof ApiSvcOrgSystemDetailsDTO
   */
  sso?: ApiSvcSsoSettings;
}
/**
 *
 * @export
 * @interface ApiSvcOrgUserDTO
 */
export interface ApiSvcOrgUserDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgUserDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgUserDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgUserDTO
   */
  email?: string;
  /**
   *
   * @type {Array<ApiSvcRolesDTO>}
   * @memberof ApiSvcOrgUserDTO
   */
  role?: Array<ApiSvcRolesDTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcOrgUserDTO
   */
  emailContactPreferences?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcOrgUserDTO
   */
  assertedIdentity?: string;
  /**
   *
   * @type {ApiSvcUserTosAcceptance}
   * @memberof ApiSvcOrgUserDTO
   */
  tosAcceptance?: ApiSvcUserTosAcceptance;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcOrgUserDTO
   */
  walletIds?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcPaginatedResponseChangelogEntryTransactionChangeLog
 */
export interface ApiSvcPaginatedResponseChangelogEntryTransactionChangeLog {
  /**
   *
   * @type {Array<ApiSvcChangelogEntryTransactionChangeLog>}
   * @memberof ApiSvcPaginatedResponseChangelogEntryTransactionChangeLog
   */
  items: Array<ApiSvcChangelogEntryTransactionChangeLog>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPaginatedResponseChangelogEntryTransactionChangeLog
   */
  nextPageToken?: string;
}
/**
 *
 * @export
 * @interface ApiSvcPaginatedResponseInventoryShortBalanceLine
 */
export interface ApiSvcPaginatedResponseInventoryShortBalanceLine {
  /**
   *
   * @type {Array<ApiSvcInventoryShortBalanceLine>}
   * @memberof ApiSvcPaginatedResponseInventoryShortBalanceLine
   */
  items: Array<ApiSvcInventoryShortBalanceLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPaginatedResponseInventoryShortBalanceLine
   */
  nextPageToken?: string;
}
/**
 * Partial default settings for updates - all fields optional for deep merge
 * @export
 * @interface ApiSvcPartialRollupDefaultSettings
 */
export interface ApiSvcPartialRollupDefaultSettings {
  /**
   * Metadata key-value map (TSOA-compatible alternative to Record<string, string>)
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcPartialRollupDefaultSettings
   */
  metadata?: { [key: string]: string };
  /**
   * Default contact ID to use when transaction has no contact
   * @type {string}
   * @memberof ApiSvcPartialRollupDefaultSettings
   */
  defaultContactId?: string;
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcPartialRollupDefaultSettings
   */
  clearing?: ApiSvcEntryTypeDefaultSettings;
  /**
   * override timezone
   * @type {string}
   * @memberof ApiSvcPartialRollupDefaultSettings
   */
  timezone?: string;
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcPartialRollupDefaultSettings
   */
  unrealizedGainLoss?: ApiSvcEntryTypeDefaultSettings;
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcPartialRollupDefaultSettings
   */
  digitalAsset?: ApiSvcEntryTypeDefaultSettings;
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcPartialRollupDefaultSettings
   */
  adjustment?: ApiSvcEntryTypeDefaultSettings;
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcPartialRollupDefaultSettings
   */
  gainLoss?: ApiSvcEntryTypeDefaultSettings;
}
/**
 *
 * @export
 * @interface ApiSvcPatchConnectionRequest
 */
export interface ApiSvcPatchConnectionRequest {
  /**
   *
   * @type {ApiSvcConnectionTypes}
   * @memberof ApiSvcPatchConnectionRequest
   */
  type?: ApiSvcConnectionTypes;
  /**
   *
   * @type {ApiSvcConnectionSyncStatus}
   * @memberof ApiSvcPatchConnectionRequest
   */
  status?: ApiSvcConnectionSyncStatus;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPatchConnectionRequest
   */
  lastSyncSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchConnectionRequest
   */
  location?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchConnectionRequest
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPatchConnectionRequest
   */
  syncerVersion?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPatchConnectionRequest
   */
  _disabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchConnectionRequest
   */
  subAccountName?: string;
  /**
   *
   * @type {object}
   * @memberof ApiSvcPatchConnectionRequest
   */
  accountMappingConfig?: object;
  /**
   *
   * @type {ApiSvcAssetAccountMapping}
   * @memberof ApiSvcPatchConnectionRequest
   */
  assetAccountMapping?: ApiSvcAssetAccountMapping;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcPatchConnectionRequest
   */
  lastSuccessfulJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcPatchConnectionRequest
   */
  lastJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchConnectionRequest
   */
  tokenUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchConnectionRequest
   */
  clientId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchConnectionRequest
   */
  clientSecret?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchConnectionRequest
   */
  scope?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchConnectionRequest
   */
  apiBaseUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPatchConnectionRequest
   */
  useWhitelistedIPs?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcPatchOrgLabelRequest
 */
export interface ApiSvcPatchOrgLabelRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchOrgLabelRequest
   */
  description?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPatchOrgLabelRequest
   */
  disabled?: boolean;
  /**
   * Slug validation pattern update. Omit for \"no change\", pass `null` to clear, or pass a string to set/replace. Only meaningful for `slugType=\'StringRegex\'` labels.  Note: `name`, `allowSlugs`, and `slugType` are immutable post-create (changing them would invalidate every transaction already carrying the label).
   * @type {string}
   * @memberof ApiSvcPatchOrgLabelRequest
   */
  slugValidationPattern?: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcPatchScimUser200Response
 */
export interface ApiSvcPatchScimUser200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchScimUser200Response
   */
  detail: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchScimUser200Response
   */
  scimType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchScimUser200Response
   */
  status: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcPatchScimUser200Response
   */
  schemas: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcPatchWalletRequest
 */
export interface ApiSvcPatchWalletRequest {
  /**
   *
   * @type {ApiSvcSyncStatus}
   * @memberof ApiSvcPatchWalletRequest
   */
  status?: ApiSvcSyncStatus;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPatchWalletRequest
   */
  lastSyncSEC?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPatchWalletRequest
   */
  userSyncEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPatchWalletRequest
   */
  isBalanceMonitoringOnly?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPatchWalletRequest
   */
  disabled?: boolean;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcPatchWalletRequest
   */
  metadata?: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPatchWalletRequest
   */
  description?: string;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcPatchWalletRequest
   */
  lastSuccessfulJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcPatchWalletRequest
   */
  lastJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcPatchWalletRequest
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
  /**
   *
   * @type {ApiSvcWalletsFlags}
   * @memberof ApiSvcPatchWalletRequest
   */
  flags?: ApiSvcWalletsFlags;
}

/**
 *
 * @export
 * @interface ApiSvcPaymentStatus
 */
export interface ApiSvcPaymentStatus {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPaymentStatus
   */
  synced?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPaymentStatus
   */
  sent?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPaymentStatus
   */
  created: string;
}
/**
 *
 * @export
 * @interface ApiSvcPendingExpandedExchangeRateDTO
 */
export interface ApiSvcPendingExpandedExchangeRateDTO {
  /**
   *
   * @type {ApiSvcExpandedExchangeRateDTO}
   * @memberof ApiSvcPendingExpandedExchangeRateDTO
   */
  exchangeRate: ApiSvcExpandedExchangeRateDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPendingExpandedExchangeRateDTO
   */
  changeReason: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPendingExpandedExchangeRateDTO
   */
  changeAuditLog?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPermanantlyFatalErrorReason = {
  BadApiKey: 'badApiKey',
  TooManyTxns: 'tooManyTxns',
  AddressNotFound: 'addressNotFound',
  UnmappableTransaction: 'unmappableTransaction',
  TransactionTooLarge: 'transactionTooLarge',
  UnmappableTicker: 'unmappableTicker',
  InvalidJobConfig: 'invalidJobConfig',
} as const;

export type ApiSvcPermanantlyFatalErrorReason =
  typeof ApiSvcPermanantlyFatalErrorReason[keyof typeof ApiSvcPermanantlyFatalErrorReason];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPermanantlyFatalErrorReasonAddressNotFound = {
  AddressNotFound: 'addressNotFound',
} as const;

export type ApiSvcPermanantlyFatalErrorReasonAddressNotFound =
  typeof ApiSvcPermanantlyFatalErrorReasonAddressNotFound[keyof typeof ApiSvcPermanantlyFatalErrorReasonAddressNotFound];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPermanantlyFatalErrorReasonBadApiKey = {
  BadApiKey: 'badApiKey',
} as const;

export type ApiSvcPermanantlyFatalErrorReasonBadApiKey =
  typeof ApiSvcPermanantlyFatalErrorReasonBadApiKey[keyof typeof ApiSvcPermanantlyFatalErrorReasonBadApiKey];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPermanantlyFatalErrorReasonUnmappableTicker = {
  UnmappableTicker: 'unmappableTicker',
} as const;

export type ApiSvcPermanantlyFatalErrorReasonUnmappableTicker =
  typeof ApiSvcPermanantlyFatalErrorReasonUnmappableTicker[keyof typeof ApiSvcPermanantlyFatalErrorReasonUnmappableTicker];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPermanantlyFatalErrorReasonUnmappableTransaction = {
  UnmappableTransaction: 'unmappableTransaction',
} as const;

export type ApiSvcPermanantlyFatalErrorReasonUnmappableTransaction =
  typeof ApiSvcPermanantlyFatalErrorReasonUnmappableTransaction[keyof typeof ApiSvcPermanantlyFatalErrorReasonUnmappableTransaction];

/**
 *
 * @export
 * @interface ApiSvcPersistReportOptions
 */
export interface ApiSvcPersistReportOptions {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPersistReportOptions
   */
  saveReportWithTTL?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPersistReportOptions
   */
  persistReport?: boolean;
  /**
   *
   * @type {ApiSvcDataWarehousePersistOptions}
   * @memberof ApiSvcPersistReportOptions
   */
  customerDataWarehouse?: ApiSvcDataWarehousePersistOptions;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPersistenceState = {
  Created: 'created',
  Existing: 'existing',
  Rejected: 'rejected',
} as const;

export type ApiSvcPersistenceState = typeof ApiSvcPersistenceState[keyof typeof ApiSvcPersistenceState];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPointerTypes = {
  Address: 'address',
  Block: 'block',
} as const;

export type ApiSvcPointerTypes = typeof ApiSvcPointerTypes[keyof typeof ApiSvcPointerTypes];

/**
 *
 * @export
 * @interface ApiSvcPreCategorizationDetailsDTO
 */
export interface ApiSvcPreCategorizationDetailsDTO {
  /**
   *
   * @type {ApiSvcCategorizationMethodology}
   * @memberof ApiSvcPreCategorizationDetailsDTO
   */
  preCategorizationMethod: ApiSvcCategorizationMethodology;
  /**
   *
   * @type {Array<ApiSvcExchageRateUsedDTO>}
   * @memberof ApiSvcPreCategorizationDetailsDTO
   */
  exchangeRatesUsed?: Array<ApiSvcExchageRateUsedDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizationDetailsDTO
   */
  preCategorizationError?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPreCategorizationDetailsDTO
   */
  sourceVersion?: number;
}

/**
 *
 * @export
 * @interface ApiSvcPreCategorizeInvoiceLineDTO
 */
export interface ApiSvcPreCategorizeInvoiceLineDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeInvoiceLineDTO
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeInvoiceLineDTO
   */
  invoiceId: string;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcPreCategorizeInvoiceLineDTO
   */
  sourceValue: ApiSvcAssetValueDTO;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcPreCategorizeInvoiceLineDTO
   */
  invoicePaidAmount: ApiSvcAssetValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeInvoiceLineDTO
   */
  forexCategoryId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcPreCategorizeInvoiceTransactionDTO
 */
export interface ApiSvcPreCategorizeInvoiceTransactionDTO {
  /**
   *
   * @type {ApiSvcCategorizationTransactionTypePreCategorizeInvoice}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  type: ApiSvcCategorizationTransactionTypePreCategorizeInvoice;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  txnTimestampSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  txnTimestampMS?: number;
  /**
   *
   * @type {Array<ApiSvcExchangeRateUsed>}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  exchangeRatesUsed?: Array<ApiSvcExchangeRateUsed>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  onCategorizeAutoSync?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  sourceVersion?: number;
  /**
   *
   * @type {Array<ApiSvcPreCategorizeInvoiceLineDTO>}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  lines: Array<ApiSvcPreCategorizeInvoiceLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  feeContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  feeCategoryId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  feeMetadataIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  accountingConnectionId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPreCategorizeInvoiceTransactionDTO
   */
  shouldInitializeStream?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcPreCategorizeOpsTransactionInput
 */
export interface ApiSvcPreCategorizeOpsTransactionInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  createdBy?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  createdAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  deleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  transactionId?: string;
  /**
   *
   * @type {ApiSvcPaymentStatus}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  status: ApiSvcPaymentStatus;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  tokenTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  tokenContract: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  networkId: string;
  /**
   *
   * @type {ApiSvcMultiValueTransactionInput}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  payment: ApiSvcMultiValueTransactionInput;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPreCategorizeOpsTransactionInput
   */
  name: string;
}
/**
 *
 * @export
 * @interface ApiSvcPriceAsset200Response
 */
export interface ApiSvcPriceAsset200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceAsset200Response
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceAsset200Response
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceAsset200Response
   */
  to: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeUnableToPrice}
   * @memberof ApiSvcPriceAsset200Response
   */
  type: ApiSvcExchangeRateTypeUnableToPrice;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceAsset200Response
   */
  priceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceAsset200Response
   */
  rate: ApiSvcPriceAsset200ResponseRateEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceAsset200Response
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceAsset200Response
   */
  reason?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceAsset200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceAsset200Response
   */
  message: string;
}

export const ApiSvcPriceAsset200ResponseRateEnum = {
  _0: '0',
} as const;

export type ApiSvcPriceAsset200ResponseRateEnum =
  typeof ApiSvcPriceAsset200ResponseRateEnum[keyof typeof ApiSvcPriceAsset200ResponseRateEnum];

/**
 *
 * @export
 * @interface ApiSvcPriceSvcCacheClearResult
 */
export interface ApiSvcPriceSvcCacheClearResult {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPriceSvcCacheClearResult
   */
  success: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcCacheClearResult
   */
  assetCount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcCacheClearResult
   */
  deletedCount?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcCacheClearResult
   */
  message?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcConversionDirectiveTypesPricingSource = {
  PricingSource: 'pricing-source',
} as const;

export type ApiSvcPriceSvcConversionDirectiveTypesPricingSource =
  typeof ApiSvcPriceSvcConversionDirectiveTypesPricingSource[keyof typeof ApiSvcPriceSvcConversionDirectiveTypesPricingSource];

/**
 *
 * @export
 * @interface ApiSvcPriceSvcConversionPricingDirectiveDTO
 */
export interface ApiSvcPriceSvcConversionPricingDirectiveDTO {
  /**
   *
   * @type {ApiSvcPriceSvcConversionDirectiveTypesPricingSource}
   * @memberof ApiSvcPriceSvcConversionPricingDirectiveDTO
   */
  type: ApiSvcPriceSvcConversionDirectiveTypesPricingSource;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcConversionPricingDirectiveDTO
   */
  price: number;
  /**
   *
   * @type {ApiSvcPriceSvcPricingSourceDTO}
   * @memberof ApiSvcPriceSvcConversionPricingDirectiveDTO
   */
  source: ApiSvcPriceSvcPricingSourceDTO;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcExchanges = {
  None: 'none',
  Coinbase: 'coinbase',
  Binance: 'binance',
  BinanceUs: 'binance-us',
  Bitfinex: 'bitfinex',
  Ftx: 'ftx',
  FtxUs: 'ftx-us',
  Kraken: 'kraken',
  Gemini: 'gemini',
  Huobipro: 'huobipro',
  Poloniex: 'poloniex',
  Kucoin: 'kucoin',
  Bitvavo: 'bitvavo',
  BitCom: 'bit.com',
  Mexc: 'mexc',
} as const;

export type ApiSvcPriceSvcExchanges = typeof ApiSvcPriceSvcExchanges[keyof typeof ApiSvcPriceSvcExchanges];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcMessages = {
  Raw: 'raw',
  PricingSucceeded: 'pricing.succeeded',
  PricingSucceededDetailed: 'pricing.succeeded.detailed',
  PricingFailed: 'pricing.failed',
  PricingFailedDetails: 'pricing.failed.details',
  PricingStatic: 'pricing.static',
} as const;

export type ApiSvcPriceSvcMessages = typeof ApiSvcPriceSvcMessages[keyof typeof ApiSvcPriceSvcMessages];

/**
 *
 * @export
 * @interface ApiSvcPriceSvcMsg
 */
export interface ApiSvcPriceSvcMsg {
  /**
   *
   * @type {ApiSvcPriceSvcMessages}
   * @memberof ApiSvcPriceSvcMsg
   */
  messageId: ApiSvcPriceSvcMessages;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcPriceSvcMsg
   */
  params: Array<string>;
}

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPrice
 */
export interface ApiSvcPriceSvcPrice {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPrice
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPrice
   */
  price: string;
  /**
   *
   * @type {ApiSvcPriceSvcPriceDetails}
   * @memberof ApiSvcPriceSvcPrice
   */
  details: ApiSvcPriceSvcPriceDetails;
  /**
   *
   * @type {Array<ApiSvcPriceSvcPricingStep>}
   * @memberof ApiSvcPriceSvcPrice
   */
  steps: Array<ApiSvcPriceSvcPricingStep>;
}
/**
 *
 * @export
 * @interface ApiSvcPriceSvcPriceDetails
 */
export interface ApiSvcPriceSvcPriceDetails {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPriceDetails
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPriceDetails
   */
  pricedActionDesc?: string;
}
/**
 *
 * @export
 * @interface ApiSvcPriceSvcPriceRecord
 */
export interface ApiSvcPriceSvcPriceRecord {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPriceRecord
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPriceRecord
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPriceRecord
   */
  assetId: string;
  /**
   *
   * @type {object}
   * @memberof ApiSvcPriceSvcPriceRecord
   */
  resolution: object;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPriceRecord
   */
  normalizedTimestampSEC: number;
  /**
   *
   * @type {ApiSvcPriceSvcPricingResult}
   * @memberof ApiSvcPriceSvcPriceRecord
   */
  price: ApiSvcPriceSvcPricingResult;
  /**
   * Storage key for this record — the composed price ref (Spanner `PriceResultsId` / Firestore doc id produced by `generatePriceRef`), NOT the UUID `id`.  Deliberately NOT a `@JsonProperty`: it must never be written into the persisted `Data` blob, only carried in-memory. Reads that need to preserve the row key (e.g. the Firestore→Spanner migration) populate it from the source doc id so the Spanner row is keyed by the ref the read path looks it up by — instead of the UUID.
   * @type {string}
   * @memberof ApiSvcPriceSvcPriceRecord
   */
  priceResultsId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcPriceSvcPriceRuleDTO
 */
export interface ApiSvcPriceSvcPriceRuleDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPriceRuleDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPriceRuleDTO
   */
  assetId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPriceRuleDTO
   */
  walletId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPriceRuleDTO
   */
  priority: number;
  /**
   *
   * @type {ApiSvcPriceSvcPricingRuleApplication}
   * @memberof ApiSvcPriceSvcPriceRuleDTO
   */
  application: ApiSvcPriceSvcPricingRuleApplication;
  /**
   *
   * @type {ApiSvcPriceSvcPricingDirectiveDTO}
   * @memberof ApiSvcPriceSvcPriceRuleDTO
   */
  action: ApiSvcPriceSvcPricingDirectiveDTO;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPriceRuleDTO
   */
  fromSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPriceRuleDTO
   */
  toSEC?: number;
}

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPriceRuleRecordDTO
 */
export interface ApiSvcPriceSvcPriceRuleRecordDTO {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPriceSvcPriceRuleRecordDTO
   */
  disabled: boolean;
  /**
   *
   * @type {ApiSvcPriceSvcPriceRuleDTO}
   * @memberof ApiSvcPriceSvcPriceRuleRecordDTO
   */
  rule: ApiSvcPriceSvcPriceRuleDTO;
}
/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingContext
 */
export interface ApiSvcPriceSvcPricingContext {
  /**
   * free form text of the pricing rule, once it is set, it cannot be changed could be well known ids, e.g. transaction OR could be random string
   * @type {object}
   * @memberof ApiSvcPriceSvcPricingContext
   */
  id: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContext
   */
  description: string;
  /**
   *
   * @type {object}
   * @memberof ApiSvcPriceSvcPricingContext
   */
  resolution: object;
  /**
   *
   * @type {ApiSvcPriceSvcPricingMethodology}
   * @memberof ApiSvcPriceSvcPricingContext
   */
  methodology: ApiSvcPriceSvcPricingMethodology;
  /**
   *
   * @type {ApiSvcPriceSvcPricingDirective}
   * @memberof ApiSvcPriceSvcPricingContext
   */
  action: ApiSvcPriceSvcPricingDirective;
  /**
   *
   * @type {Array<ApiSvcPriceSvcPricingRuleRecord>}
   * @memberof ApiSvcPriceSvcPricingContext
   */
  rules: Array<ApiSvcPriceSvcPricingRuleRecord>;
}

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingContextDTO
 */
export interface ApiSvcPriceSvcPricingContextDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextDTO
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextDTO
   */
  resolution: string;
  /**
   *
   * @type {ApiSvcPriceSvcPricingMethodology}
   * @memberof ApiSvcPriceSvcPricingContextDTO
   */
  methodology: ApiSvcPriceSvcPricingMethodology;
  /**
   *
   * @type {ApiSvcPriceSvcPricingDirectiveDTO}
   * @memberof ApiSvcPriceSvcPricingContextDTO
   */
  action: ApiSvcPriceSvcPricingDirectiveDTO;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPriceSvcPricingContextDTO
   */
  isDisabled?: boolean;
  /**
   *
   * @type {Array<ApiSvcPriceSvcPriceRuleRecordDTO>}
   * @memberof ApiSvcPriceSvcPricingContextDTO
   */
  rules: Array<ApiSvcPriceSvcPriceRuleRecordDTO>;
}

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingContextMetadataMatcherDTO
 */
export interface ApiSvcPriceSvcPricingContextMetadataMatcherDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextMetadataMatcherDTO
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextMetadataMatcherDTO
   */
  value: string;
  /**
   *
   * @type {ApiSvcPriceSvcPricingContextRouteMetadataMatcherOperators}
   * @memberof ApiSvcPriceSvcPricingContextMetadataMatcherDTO
   */
  operator: ApiSvcPriceSvcPricingContextRouteMetadataMatcherOperators;
}

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingContextRoute
 */
export interface ApiSvcPriceSvcPricingContextRoute {
  /**
   * system generated id
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   */
  orgId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   */
  priority: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   */
  routeToContextId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   * @deprecated
   */
  walletId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   */
  walletIds?: Array<string>;
  /**
   *
   * @type {ApiSvcPriceSvcPricingContextRouteDirection}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   */
  direction?: ApiSvcPriceSvcPricingContextRouteDirection;
  /**
   *
   * @type {Array<ApiSvcPriceSvcPricingContextRouteMetadataMatcher>}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   */
  metadata?: Array<ApiSvcPriceSvcPricingContextRouteMetadataMatcher>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   */
  inclusiveStartTimestampSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingContextRoute
   */
  inclusiveEndTimestampSEC?: number;
}

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingContextRouteDTO
 */
export interface ApiSvcPriceSvcPricingContextRouteDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  orgId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  priority: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  routeToContextId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  walletIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   * @deprecated
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcPriceSvcPricingContextRouteDirection}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  direction?: ApiSvcPriceSvcPricingContextRouteDirection;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  isDisabled?: boolean;
  /**
   *
   * @type {Array<ApiSvcPriceSvcPricingContextMetadataMatcherDTO>}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  metadata?: Array<ApiSvcPriceSvcPricingContextMetadataMatcherDTO>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  inclusiveStartTimestampSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingContextRouteDTO
   */
  inclusiveEndTimestampSEC?: number;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingContextRouteDirection = {
  Inflow: 'inflow',
  Outflow: 'outflow',
  BiDirectional: 'bi-directional',
} as const;

export type ApiSvcPriceSvcPricingContextRouteDirection =
  typeof ApiSvcPriceSvcPricingContextRouteDirection[keyof typeof ApiSvcPriceSvcPricingContextRouteDirection];

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingContextRouteMetadataMatcher
 */
export interface ApiSvcPriceSvcPricingContextRouteMetadataMatcher {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRouteMetadataMatcher
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingContextRouteMetadataMatcher
   */
  value: string;
  /**
   *
   * @type {ApiSvcPriceSvcPricingContextRouteMetadataMatcherOperators}
   * @memberof ApiSvcPriceSvcPricingContextRouteMetadataMatcher
   */
  operator: ApiSvcPriceSvcPricingContextRouteMetadataMatcherOperators;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingContextRouteMetadataMatcherOperators = {
  Equal: '=',
  NotEqual: '!=',
  GreaterThan: '>',
  LessThan: '<',
  GreaterThanOrEqualTo: '>=',
  LessThanOrEqualTo: '<=',
  Includes: 'includes',
} as const;

export type ApiSvcPriceSvcPricingContextRouteMetadataMatcherOperators =
  typeof ApiSvcPriceSvcPricingContextRouteMetadataMatcherOperators[keyof typeof ApiSvcPriceSvcPricingContextRouteMetadataMatcherOperators];

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingDirective
 */
export interface ApiSvcPriceSvcPricingDirective {
  /**
   *
   * @type {ApiSvcPriceSvcPricingDirectiveTypes}
   * @memberof ApiSvcPriceSvcPricingDirective
   */
  type: ApiSvcPriceSvcPricingDirectiveTypes;
}

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingDirectiveDTO
 */
export interface ApiSvcPriceSvcPricingDirectiveDTO {
  /**
   *
   * @type {ApiSvcPriceSvcPricingDirectiveTypesUseDefault}
   * @memberof ApiSvcPriceSvcPricingDirectiveDTO
   */
  type: ApiSvcPriceSvcPricingDirectiveTypesUseDefault;
  /**
   *
   * @type {Array<ApiSvcPriceSvcPricingSourceDTO>}
   * @memberof ApiSvcPriceSvcPricingDirectiveDTO
   */
  sourceOrdering: Array<ApiSvcPriceSvcPricingSourceDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingDirectiveDTO
   */
  overrideAssetId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingDirectiveDTO
   */
  percentage?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingDirectiveDTO
   */
  price: number;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingDirectiveTypes = {
  UseDefault: 'use-default',
  PriceOverride: 'price-override',
  OrderedSourceSearch: 'ordered-source-search',
  RateTable: 'rate-table',
} as const;

export type ApiSvcPriceSvcPricingDirectiveTypes =
  typeof ApiSvcPriceSvcPricingDirectiveTypes[keyof typeof ApiSvcPriceSvcPricingDirectiveTypes];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingDirectiveTypesUseDefault = {
  UseDefault: 'use-default',
} as const;

export type ApiSvcPriceSvcPricingDirectiveTypesUseDefault =
  typeof ApiSvcPriceSvcPricingDirectiveTypesUseDefault[keyof typeof ApiSvcPriceSvcPricingDirectiveTypesUseDefault];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingMethodology = {
  High: 'high',
  Low: 'low',
  Close: 'close',
  Open: 'open',
  Vwap: 'vwap',
} as const;

export type ApiSvcPriceSvcPricingMethodology =
  typeof ApiSvcPriceSvcPricingMethodology[keyof typeof ApiSvcPriceSvcPricingMethodology];

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingResult
 */
export interface ApiSvcPriceSvcPricingResult {
  /**
   *
   * @type {ApiSvcPriceSvcPricingResultStatus}
   * @memberof ApiSvcPriceSvcPricingResult
   */
  status: ApiSvcPriceSvcPricingResultStatus;
  /**
   *
   * @type {ApiSvcPriceSvcPrice}
   * @memberof ApiSvcPriceSvcPricingResult
   */
  result?: ApiSvcPriceSvcPrice;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcPriceSvcPricingResult
   */
  errors?: Array<string>;
  /**
   *
   * @type {Array<ApiSvcPriceSvcPricingStep>}
   * @memberof ApiSvcPriceSvcPricingResult
   */
  failingSteps?: Array<ApiSvcPriceSvcPricingStep>;
  /**
   *
   * @type {ApiSvcPriceSvcPricingContext}
   * @memberof ApiSvcPriceSvcPricingResult
   */
  pricingContext?: ApiSvcPriceSvcPricingContext;
  /**
   *
   * @type {ApiSvcPriceSvcPricingContextRoute}
   * @memberof ApiSvcPriceSvcPricingResult
   */
  pricingContextRoute?: ApiSvcPriceSvcPricingContextRoute;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingResultStatus = {
  PricedSuccessfully: 'priced-successfully',
  UnableToPrice: 'unable-to-price',
  DownstreamServiceFailure: 'downstream-service-failure',
} as const;

export type ApiSvcPriceSvcPricingResultStatus =
  typeof ApiSvcPriceSvcPricingResultStatus[keyof typeof ApiSvcPriceSvcPricingResultStatus];

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingRule
 */
export interface ApiSvcPriceSvcPricingRule {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRule
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRule
   */
  assetId?: string;
  /**
   * prefers not to be used stand alone for wallet level pricing, prefers to use pricing context
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRule
   */
  walletId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingRule
   */
  priority: number;
  /**
   *
   * @type {ApiSvcPriceSvcPricingRuleApplication}
   * @memberof ApiSvcPriceSvcPricingRule
   */
  application: ApiSvcPriceSvcPricingRuleApplication;
  /**
   *
   * @type {ApiSvcPriceSvcPricingDirective}
   * @memberof ApiSvcPriceSvcPricingRule
   */
  action: ApiSvcPriceSvcPricingDirective;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingRule
   */
  fromSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingRule
   */
  toSEC: number;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingRuleApplication = {
  BeforeDefault: 'before-default',
  AfterDefault: 'after-default',
  SuppressDefault: 'suppress-default',
  Default: 'default',
} as const;

export type ApiSvcPriceSvcPricingRuleApplication =
  typeof ApiSvcPriceSvcPricingRuleApplication[keyof typeof ApiSvcPriceSvcPricingRuleApplication];

/**
 * One entry in a pricing rule\\\'s audit log: a single event that happened to the rule (what, who, when). Modeled on api-svc\\\'s transaction AuditLogEntryDTO so clients get the same \\\"who did what\\\" shape.
 * @export
 * @interface ApiSvcPriceSvcPricingRuleAuditEntryDTO
 */
export interface ApiSvcPriceSvcPricingRuleAuditEntryDTO {
  /**
   * Aggregate stream version; strictly increasing, oldest change = lowest.
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  version: number;
  /**
   * Commit time of the event (Unix seconds).
   * @type {number}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  timestampSEC: number;
  /**
   * Commit time of the event as an ISO-8601 string, for display.
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  timestamp: string;
  /**
   *
   * @type {ApiSvcPriceSvcPricingRuleEventTypes}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  eventType: ApiSvcPriceSvcPricingRuleEventTypes;
  /**
   * Coarse action verb: created | updated | disabled | enabled.
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  action: string;
  /**
   * Stable category for grouping/filtering in the UI.
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  category: string;
  /**
   * Friendly action name, e.g. \\\"Rule created\\\".
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  name: string;
  /**
   * Acting principal id (a userId), or a synthetic actor for background changes.
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  userId: string;
  /**
   * On-behalf-of / token actor, when the request acted as another principal.
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  actingAsId?: string;
  /**
   * Friendly actor label; background-sync events read \\\"System (auto-sync)\\\".
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  actorLabel: string;
  /**
   * True when the change was made by a background process, not a user.
   * @type {boolean}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  isSystemActor: boolean;
  /**
   * The entity kind this log belongs to. Always \\\"pricing-rule\\\".
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  entityType: string;
  /**
   * The entity id this log belongs to (the ruleId).
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  entityId: string;
  /**
   * One-line human-readable summary of what happened.
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  message: string;
  /**
   * The fields this update changed and the value each was set to, when any.
   * @type {Array<ApiSvcPriceSvcPricingRuleFieldChange>}
   * @memberof ApiSvcPriceSvcPricingRuleAuditEntryDTO
   */
  detail?: Array<ApiSvcPriceSvcPricingRuleFieldChange>;
}

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingRuleAuditLogDTO
 */
export interface ApiSvcPriceSvcPricingRuleAuditLogDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditLogDTO
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleAuditLogDTO
   */
  ruleId: string;
  /**
   * True only when the org is fully event-sourced (post-cutover). For dual-write orgs the event stream is lazily backfilled and reconciled changes are attributed to the system actor, so pre-migration history and the original user attributions may be missing — treat the log as best-effort.
   * @type {boolean}
   * @memberof ApiSvcPriceSvcPricingRuleAuditLogDTO
   */
  complete: boolean;
  /**
   * Chronological, oldest first.
   * @type {Array<ApiSvcPriceSvcPricingRuleAuditEntryDTO>}
   * @memberof ApiSvcPriceSvcPricingRuleAuditLogDTO
   */
  entries: Array<ApiSvcPriceSvcPricingRuleAuditEntryDTO>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingRuleEventTypes = {
  PricingRuleCreated: 'PricingRuleCreated',
  PricingRuleUpdated: 'PricingRuleUpdated',
  PricingRuleDisabled: 'PricingRuleDisabled',
  PricingRuleEnabled: 'PricingRuleEnabled',
} as const;

export type ApiSvcPriceSvcPricingRuleEventTypes =
  typeof ApiSvcPriceSvcPricingRuleEventTypes[keyof typeof ApiSvcPriceSvcPricingRuleEventTypes];

/**
 * A single field an update changed, with the value it was set to. `field` is the stable machine key (e.g. \\\"toSEC\\\"); `label` is the human-readable name for the UI (e.g. \\\"End date\\\"); `value` is a rendered display string (undefined => the field was cleared).
 * @export
 * @interface ApiSvcPriceSvcPricingRuleFieldChange
 */
export interface ApiSvcPriceSvcPricingRuleFieldChange {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleFieldChange
   */
  field: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleFieldChange
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleFieldChange
   */
  value?: string;
}
/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingRuleRecord
 */
export interface ApiSvcPriceSvcPricingRuleRecord {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleRecord
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleRecord
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleRecord
   */
  assetId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingRuleRecord
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcPriceSvcPricingRule}
   * @memberof ApiSvcPriceSvcPricingRuleRecord
   */
  pricingRule: ApiSvcPriceSvcPricingRule;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPriceSvcPricingRuleRecord
   */
  disabled?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingSourceDTO
 */
export interface ApiSvcPriceSvcPricingSourceDTO {
  /**
   *
   * @type {ApiSvcPriceSvcPricingSourcesKaikoStatePrice}
   * @memberof ApiSvcPriceSvcPricingSourceDTO
   */
  type: ApiSvcPriceSvcPricingSourcesKaikoStatePrice;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingSourceDTO
   */
  conversionAssetId?: string;
  /**
   *
   * @type {ApiSvcPriceSvcConversionPricingDirectiveDTO}
   * @memberof ApiSvcPriceSvcPricingSourceDTO
   */
  conversionPricingDirective?: ApiSvcPriceSvcConversionPricingDirectiveDTO;
  /**
   *
   * @type {ApiSvcPriceSvcExchanges}
   * @memberof ApiSvcPriceSvcPricingSourceDTO
   */
  exchange?: ApiSvcPriceSvcExchanges;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcPriceSvcPricingSourceDTO
   */
  fiatToCoinTickerMapping: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingSourceDTO
   */
  rateTableId: string;
  /**
   *
   * @type {ApiSvcPriceSvcRateTableSourceLocator}
   * @memberof ApiSvcPriceSvcPricingSourceDTO
   */
  sourceLocator: ApiSvcPriceSvcRateTableSourceLocator;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingSourceDTO
   */
  sourceLocatorId: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingSourcesKaikoStatePrice = {
  KaikoStatePrice: 'kaiko-state-price',
} as const;

export type ApiSvcPriceSvcPricingSourcesKaikoStatePrice =
  typeof ApiSvcPriceSvcPricingSourcesKaikoStatePrice[keyof typeof ApiSvcPriceSvcPricingSourcesKaikoStatePrice];

/**
 *
 * @export
 * @interface ApiSvcPriceSvcPricingStep
 */
export interface ApiSvcPriceSvcPricingStep {
  /**
   *
   * @type {ApiSvcPriceSvcPricingStepTypes}
   * @memberof ApiSvcPriceSvcPricingStep
   */
  type: ApiSvcPriceSvcPricingStepTypes;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingStep
   */
  friendlyDesc: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingStep
   */
  friendlyDetails?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceSvcPricingStep
   */
  ruleId: string;
  /**
   *
   * @type {ApiSvcPriceSvcMsg}
   * @memberof ApiSvcPriceSvcPricingStep
   */
  message: ApiSvcPriceSvcMsg;
  /**
   *
   * @type {ApiSvcPriceSvcMsg}
   * @memberof ApiSvcPriceSvcPricingStep
   */
  details?: ApiSvcPriceSvcMsg;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcPricingStepTypes = {
  Match: 'match',
  FallThrough: 'fall-through',
} as const;

export type ApiSvcPriceSvcPricingStepTypes =
  typeof ApiSvcPriceSvcPricingStepTypes[keyof typeof ApiSvcPriceSvcPricingStepTypes];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcRateTableSourceLocator = {
  Org: 'org',
} as const;

export type ApiSvcPriceSvcRateTableSourceLocator =
  typeof ApiSvcPriceSvcRateTableSourceLocator[keyof typeof ApiSvcPriceSvcRateTableSourceLocator];

/**
 *
 * @export
 * @interface ApiSvcPriceSvcTransactionPricesStateLiteDTO
 */
export interface ApiSvcPriceSvcTransactionPricesStateLiteDTO {
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcTransactionPricesStateLiteDTO
   */
  version: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceSvcTransactionPricesStateLiteDTO
   */
  timestampSEC?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcPriceSvcTransactionPricesStateLiteDTO
   */
  systemExchangeRates?: object;
  /**
   *
   * @type {ApiSvcPriceSvcTransactionPricesStates}
   * @memberof ApiSvcPriceSvcTransactionPricesStateLiteDTO
   */
  state: ApiSvcPriceSvcTransactionPricesStates;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcTransactionPricesStates = {
  New: 'new',
  Pricing: 'pricing',
  Priced: 'priced',
  PricesDirtied: 'prices-dirtied',
  FailedToPrice: 'failed-to-price',
} as const;

export type ApiSvcPriceSvcTransactionPricesStates =
  typeof ApiSvcPriceSvcTransactionPricesStates[keyof typeof ApiSvcPriceSvcTransactionPricesStates];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPriceSvcWellKnownPricingContexts = {
  Transaction: 'transaction',
  Revaluation: 'revaluation',
  Reporting: 'reporting',
  Payment: 'payment',
} as const;

export type ApiSvcPriceSvcWellKnownPricingContexts =
  typeof ApiSvcPriceSvcWellKnownPricingContexts[keyof typeof ApiSvcPriceSvcWellKnownPricingContexts];

/**
 *
 * @export
 * @interface ApiSvcPriceTransaction200Response
 */
export interface ApiSvcPriceTransaction200Response {
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceTransaction200Response
   */
  version: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceTransaction200Response
   */
  timestampSEC?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcPriceTransaction200Response
   */
  systemExchangeRates?: object;
  /**
   *
   * @type {ApiSvcPriceSvcTransactionPricesStates}
   * @memberof ApiSvcPriceTransaction200Response
   */
  state: ApiSvcPriceSvcTransactionPricesStates;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceTransaction200Response
   */
  code: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcPriceTransaction200Response
   */
  message: any;
}

/**
 *
 * @export
 * @interface ApiSvcPriceTransaction200ResponseAnyOf
 */
export interface ApiSvcPriceTransaction200ResponseAnyOf {
  /**
   *
   * @type {any}
   * @memberof ApiSvcPriceTransaction200ResponseAnyOf
   */
  message: any;
}
/**
 *
 * @export
 * @interface ApiSvcPriceTransactionV3200Response
 */
export interface ApiSvcPriceTransactionV3200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceTransactionV3200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceTransactionV3200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceTransactionV3200Response
   */
  traceId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceTransactionV3200Response
   */
  version: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPriceTransactionV3200Response
   */
  timestampSEC?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcPriceTransactionV3200Response
   */
  systemExchangeRates?: object;
  /**
   *
   * @type {ApiSvcPriceSvcTransactionPricesStates}
   * @memberof ApiSvcPriceTransactionV3200Response
   */
  state: ApiSvcPriceSvcTransactionPricesStates;
}

/**
 *
 * @export
 * @interface ApiSvcPriceTransactionV3200ResponseAnyOf
 */
export interface ApiSvcPriceTransactionV3200ResponseAnyOf {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPriceTransactionV3200ResponseAnyOf
   */
  message: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPricingMethod = {
  Close: 'close',
  Vwap: 'vwap',
  Low: 'low',
  Open: 'open',
  High: 'high',
} as const;

export type ApiSvcPricingMethod = typeof ApiSvcPricingMethod[keyof typeof ApiSvcPricingMethod];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPricingPeriod = {
  _1h: '1h',
  _1d: '1d',
  _15m: '15m',
  T1d: 't1d',
  T1h: 't1h',
  T15m: 't15m',
} as const;

export type ApiSvcPricingPeriod = typeof ApiSvcPricingPeriod[keyof typeof ApiSvcPricingPeriod];

/**
 *
 * @export
 * @interface ApiSvcPricingReportParams
 */
export interface ApiSvcPricingReportParams {
  /**
   *
   * @type {number}
   * @memberof ApiSvcPricingReportParams
   */
  endTimeSec?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPricingReportParams
   */
  startTimeSec?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPricingReportParams
   */
  ticker: string;
}
/**
 *
 * @export
 * @interface ApiSvcPricingSettingsDTO
 */
export interface ApiSvcPricingSettingsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPricingSettingsDTO
   */
  preferredExchange?: string;
}
/**
 *
 * @export
 * @interface ApiSvcPrivateKeyToken
 */
export interface ApiSvcPrivateKeyToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPrivateKeyToken
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPrivateKeyToken
   */
  privateKey: string;
}
/**
 *
 * @export
 * @interface ApiSvcProvisionSamlUser201Response
 */
export interface ApiSvcProvisionSamlUser201Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcProvisionSamlUser201Response
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcProvisionSamlUser201Response
   */
  assertedIdentity: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcProvisionSamlUser201Response
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcProvisionSamlUser201Response
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcProvisionSamlUser201Response
   */
  id: string;
}
/**
 * Postal address used on a pushed customer. Maps to QBO `BillAddr` / `ShipAddr` and to Netsuite address sublist fields.
 * @export
 * @interface ApiSvcPushCustomerAddressDTO
 */
export interface ApiSvcPushCustomerAddressDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerAddressDTO
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerAddressDTO
   */
  postalCode?: string;
  /**
   * State/province code, e.g. \"CA\". Maps to QBO CountrySubDivisionCode.
   * @type {string}
   * @memberof ApiSvcPushCustomerAddressDTO
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerAddressDTO
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerAddressDTO
   */
  line2?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerAddressDTO
   */
  line1?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPushCustomerErrorCode = {
  AccountingValidation: 'ACCOUNTING_VALIDATION',
  AccountingDuplicate: 'ACCOUNTING_DUPLICATE',
  AccountingUnavailable: 'ACCOUNTING_UNAVAILABLE',
  BadRequest: 'BAD_REQUEST',
} as const;

export type ApiSvcPushCustomerErrorCode = typeof ApiSvcPushCustomerErrorCode[keyof typeof ApiSvcPushCustomerErrorCode];

/**
 *
 * @export
 * @interface ApiSvcPushCustomerErrorDTO
 */
export interface ApiSvcPushCustomerErrorDTO {
  /**
   * Present on ACCOUNTING_DUPLICATE — the remoteId that already holds the matching record (matched by DisplayName), so the caller can reconcile.
   * @type {string}
   * @memberof ApiSvcPushCustomerErrorDTO
   */
  existingRemoteId?: string;
  /**
   * Raw error body from the accounting system, when available.
   * @type {string}
   * @memberof ApiSvcPushCustomerErrorDTO
   */
  remoteErrorBody?: string;
  /**
   * HTTP status returned by the accounting system, when applicable.
   * @type {number}
   * @memberof ApiSvcPushCustomerErrorDTO
   */
  remoteStatusCode?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerErrorDTO
   */
  message: string;
  /**
   *
   * @type {ApiSvcPushCustomerErrorCode}
   * @memberof ApiSvcPushCustomerErrorDTO
   */
  code: ApiSvcPushCustomerErrorCode;
}

/**
 * Request body for pushing a single customer/contact to one specific accounting connection. The connection is identified by the `:connectionId` path parameter on the push endpoint; callers that need to push to multiple connections do their own fan-out using the connection list from `GET /orgs/:orgId/accounting-connections`.  Field shape mirrors `Contact` in `src/models/contact.ts` (the same shape that flows through the inbound contact sync) with the push-direction diffs:  - no `remoteId` (assigned by the accounting system, returned in the result)  - no `connectionId` (path parameter on the endpoint)  - no `source` (implied by the route)  - `customerId` added as the top-level idempotency key.
 * @export
 * @interface ApiSvcPushCustomerRequest
 */
export interface ApiSvcPushCustomerRequest {
  /**
   * Bitwave-side subsidiary id.
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  subsidiaryId?: string;
  /**
   * Subsidiary remoteId. Required for Netsuite; ignored for QBO.
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  remoteSubsidiaryId?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcPushCustomerRequest
   */
  metadata?: object;
  /**
   * AssetId (e.g. \"USD\"). Maps to QBO `CurrencyRef.value`.
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  currencyId?: string;
  /**
   *
   * @type {ApiSvcPushCustomerAddressDTO}
   * @memberof ApiSvcPushCustomerRequest
   */
  shippingAddress?: ApiSvcPushCustomerAddressDTO;
  /**
   *
   * @type {ApiSvcPushCustomerAddressDTO}
   * @memberof ApiSvcPushCustomerRequest
   */
  billingAddress?: ApiSvcPushCustomerAddressDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  familyName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  givenName?: string;
  /**
   * Required. QBO `DisplayName` (must be unique per QBO company); also used for Netsuite `entityId`.
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  displayName: string;
  /**
   * Caller-owned contact id. Used for idempotency tracking on the caller side and may be persisted to the accounting system as a private note.
   * @type {string}
   * @memberof ApiSvcPushCustomerRequest
   */
  customerId: string;
}
/**
 * Per-connection outcome. Exactly one of `remoteId`/`pushedCustomer` or `error` will be populated, depending on `outcome`.  Returned directly by `POST /orgs/:orgId/quickbooks/connections/:connectionId/customers/push` — one push call, one result. Callers that need to push to multiple connections do their own fan-out using the connection list from `GET /orgs/:orgId/accounting-connections`.
 * @export
 * @interface ApiSvcPushCustomerResultDTO
 */
export interface ApiSvcPushCustomerResultDTO {
  /**
   *
   * @type {ApiSvcPushCustomerErrorDTO}
   * @memberof ApiSvcPushCustomerResultDTO
   */
  error?: ApiSvcPushCustomerErrorDTO;
  /**
   *
   * @type {ApiSvcPushedCustomerDTO}
   * @memberof ApiSvcPushCustomerResultDTO
   */
  pushedCustomer?: ApiSvcPushedCustomerDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerResultDTO
   */
  remoteId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerResultDTO
   */
  outcome: ApiSvcPushCustomerResultDTOOutcomeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushCustomerResultDTO
   */
  connectionId: string;
}

export const ApiSvcPushCustomerResultDTOOutcomeEnum = {
  Success: 'success',
  Error: 'error',
} as const;

export type ApiSvcPushCustomerResultDTOOutcomeEnum =
  typeof ApiSvcPushCustomerResultDTOOutcomeEnum[keyof typeof ApiSvcPushCustomerResultDTOOutcomeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcPushInvoiceErrorCode = {
  AccountingValidation: 'ACCOUNTING_VALIDATION',
  AccountingDuplicate: 'ACCOUNTING_DUPLICATE',
  AccountingUnavailable: 'ACCOUNTING_UNAVAILABLE',
  BadRequest: 'BAD_REQUEST',
} as const;

export type ApiSvcPushInvoiceErrorCode = typeof ApiSvcPushInvoiceErrorCode[keyof typeof ApiSvcPushInvoiceErrorCode];

/**
 *
 * @export
 * @interface ApiSvcPushInvoiceErrorDTO
 */
export interface ApiSvcPushInvoiceErrorDTO {
  /**
   * Present on ACCOUNTING_DUPLICATE when the provider exposes the existing remote id. Some providers, including Rillet invoice/bill create errors, can report a duplicate without a lookup path for the existing record.
   * @type {string}
   * @memberof ApiSvcPushInvoiceErrorDTO
   */
  existingRemoteId?: string;
  /**
   * Raw error body from the accounting system, when available.
   * @type {string}
   * @memberof ApiSvcPushInvoiceErrorDTO
   */
  remoteErrorBody?: string;
  /**
   * HTTP status returned by the accounting system, when applicable.
   * @type {number}
   * @memberof ApiSvcPushInvoiceErrorDTO
   */
  remoteStatusCode?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushInvoiceErrorDTO
   */
  message: string;
  /**
   *
   * @type {ApiSvcPushInvoiceErrorCode}
   * @memberof ApiSvcPushInvoiceErrorDTO
   */
  code: ApiSvcPushInvoiceErrorCode;
}

/**
 * A line item on the invoice/bill being pushed to the accounting system. Mirrors the shape of `Line` in `src/models/invoice.ts`.
 * @export
 * @interface ApiSvcPushInvoiceLineDTO
 */
export interface ApiSvcPushInvoiceLineDTO {
  /**
   * GL account remoteId (QBO AccountRef.value, NS account internalId). Required for bills.
   * @type {string}
   * @memberof ApiSvcPushInvoiceLineDTO
   */
  accountCode?: string;
  /**
   * Item remoteId in the accounting system (QBO ItemRef.value, NS item internalId).
   * @type {string}
   * @memberof ApiSvcPushInvoiceLineDTO
   */
  itemId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushInvoiceLineDTO
   */
  unitAmount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushInvoiceLineDTO
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushInvoiceLineDTO
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushInvoiceLineDTO
   */
  description?: string;
}
/**
 * Mirrors `InvoiceOpts` in `src/models/invoice.ts`.
 * @export
 * @interface ApiSvcPushInvoiceOptsDTO
 */
export interface ApiSvcPushInvoiceOptsDTO {
  /**
   *
   * @type {ApiSvcDateRangeFrom}
   * @memberof ApiSvcPushInvoiceOptsDTO
   */
  arapAccountRemoteId?: ApiSvcDateRangeFrom;
  /**
   *
   * @type {ApiSvcDateRangeFrom}
   * @memberof ApiSvcPushInvoiceOptsDTO
   */
  currencyRemoteId?: ApiSvcDateRangeFrom;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushInvoiceOptsDTO
   */
  exchangeRate?: number;
}
/**
 * Request body for pushing a single invoice or bill to one specific accounting connection. The connection is identified by the `:connectionId` path parameter on the push endpoint; callers that need to push to multiple connections do their own fan-out using the connection list from `GET /orgs/:orgId/accounting-connections`.  Field shape mirrors `Invoice` in `src/models/invoice.ts` — the same shape that flows through the inbound `remote_invoices` topic — with the push-direction diffs: - no `remoteId` (assigned by the accounting system, returned in the result) - no `connectionId` (path parameter on the endpoint) - no `source` (implied by the route) - `invoiceId` added as the top-level idempotency key; written to QBO   `DocNumber` and Netsuite `externalId`.
 * @export
 * @interface ApiSvcPushInvoiceRequest
 */
export interface ApiSvcPushInvoiceRequest {
  /**
   * Bitwave-side subsidiary id.
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  subsidiaryId?: string;
  /**
   * Subsidiary remoteId. Required for Netsuite; ignored for QBO.
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  remoteSubsidiaryId?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcPushInvoiceRequest
   */
  metadata?: object;
  /**
   *
   * @type {ApiSvcPushInvoiceOptsDTO}
   * @memberof ApiSvcPushInvoiceRequest
   */
  opts?: ApiSvcPushInvoiceOptsDTO;
  /**
   * AssetId (e.g. \"USD\").
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  currency: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushInvoiceRequest
   */
  totalAmount: number;
  /**
   * Optional on create; defaults to totalAmount when omitted.
   * @type {number}
   * @memberof ApiSvcPushInvoiceRequest
   */
  dueAmount?: number;
  /**
   * YYYY-MM-DD
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  dueDate?: string;
  /**
   * YYYY-MM-DD
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  date?: string;
  /**
   * Free-form note. Maps to the QBO invoice\'s `PrivateNote`. Distinct from `reference`: `reference` is meant for an external document id; `memo` is for human-readable annotations (e.g. token-denominated invoice rate snapshots). When both are set, `memo` wins.
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  reference?: string;
  /**
   *
   * @type {Array<ApiSvcPushInvoiceLineDTO>}
   * @memberof ApiSvcPushInvoiceRequest
   */
  lines: Array<ApiSvcPushInvoiceLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  title: string;
  /**
   * Customer (Receiving) or vendor (Paying) remoteId in the accounting system.
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  contactId: string;
  /**
   *
   * @type {ApiSvcInvoiceTypes}
   * @memberof ApiSvcPushInvoiceRequest
   */
  type: ApiSvcInvoiceTypes;
  /**
   * Caller-owned invoice id. Used as the idempotency key against the accounting system (QBO DocNumber, Netsuite externalId).
   * @type {string}
   * @memberof ApiSvcPushInvoiceRequest
   */
  invoiceId: string;
}

/**
 * Per-connection outcome. Exactly one of `remoteId`/`status`/`pushedInvoice` or `error` will be populated, depending on `outcome`.  Returned directly by `POST /orgs/:orgId/quickbooks/connections/:connectionId/invoices/push` — one push call, one result. Callers that need to push to multiple connections do their own fan-out using the connection list from `GET /orgs/:orgId/accounting-connections`.
 * @export
 * @interface ApiSvcPushInvoiceResultDTO
 */
export interface ApiSvcPushInvoiceResultDTO {
  /**
   *
   * @type {ApiSvcPushInvoiceErrorDTO}
   * @memberof ApiSvcPushInvoiceResultDTO
   */
  error?: ApiSvcPushInvoiceErrorDTO;
  /**
   *
   * @type {ApiSvcPushedInvoiceDTO}
   * @memberof ApiSvcPushInvoiceResultDTO
   */
  pushedInvoice?: ApiSvcPushedInvoiceDTO;
  /**
   *
   * @type {ApiSvcInvoiceStatuses}
   * @memberof ApiSvcPushInvoiceResultDTO
   */
  status?: ApiSvcInvoiceStatuses;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushInvoiceResultDTO
   */
  remoteId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushInvoiceResultDTO
   */
  outcome: ApiSvcPushInvoiceResultDTOOutcomeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushInvoiceResultDTO
   */
  connectionId: string;
}

export const ApiSvcPushInvoiceResultDTOOutcomeEnum = {
  Success: 'success',
  Error: 'error',
} as const;

export type ApiSvcPushInvoiceResultDTOOutcomeEnum =
  typeof ApiSvcPushInvoiceResultDTOOutcomeEnum[keyof typeof ApiSvcPushInvoiceResultDTOOutcomeEnum];

/**
 * Request body for pushing a rolled-up JE report to ERP
 * @export
 * @interface ApiSvcPushRolledUpJeReportRequest
 */
export interface ApiSvcPushRolledUpJeReportRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushRolledUpJeReportRequest
   */
  connectionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushRolledUpJeReportRequest
   */
  rollupConfigId?: string;
}
/**
 * Response from pushing a rolled-up JE report to ERP
 * @export
 * @interface ApiSvcPushRolledUpJeReportResponse
 */
export interface ApiSvcPushRolledUpJeReportResponse {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcPushRolledUpJeReportResponse
   */
  success: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushRolledUpJeReportResponse
   */
  entriesPushed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushRolledUpJeReportResponse
   */
  entriesFailed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushRolledUpJeReportResponse
   */
  transactionsReconciled: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcPushRolledUpJeReportResponse
   */
  erpEntryIds: Array<string>;
  /**
   *
   * @type {Array<ApiSvcEntryPushResult>}
   * @memberof ApiSvcPushRolledUpJeReportResponse
   */
  entryResults: Array<ApiSvcEntryPushResult>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcPushRolledUpJeReportResponse
   */
  errors: Array<string>;
}
/**
 * Hydrated customer payload returned on a successful push. Field shape matches `Contact` in `src/models/contact.ts`.
 * @export
 * @interface ApiSvcPushedCustomerDTO
 */
export interface ApiSvcPushedCustomerDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedCustomerDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedCustomerDTO
   */
  remoteSubsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedCustomerDTO
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedCustomerDTO
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedCustomerDTO
   */
  familyName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedCustomerDTO
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedCustomerDTO
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedCustomerDTO
   */
  remoteId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushedCustomerDTO
   */
  source: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedCustomerDTO
   */
  connectionId: string;
}
/**
 * Hydrated invoice payload returned on a successful push. Field shape matches `Invoice` in `src/models/invoice.ts`.
 * @export
 * @interface ApiSvcPushedInvoiceDTO
 */
export interface ApiSvcPushedInvoiceDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  remoteSubsidiaryId?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  metadata?: object;
  /**
   *
   * @type {Array<ApiSvcPushedInvoiceDTOLinesInner>}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  lines: Array<ApiSvcPushedInvoiceDTOLinesInner>;
  /**
   *
   * @type {ApiSvcPushInvoiceOptsDTO}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  opts?: ApiSvcPushInvoiceOptsDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  currency: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  totalAmount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  dueAmount: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  dueDate?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  reference?: string;
  /**
   *
   * @type {ApiSvcInvoiceStatuses}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  status: ApiSvcInvoiceStatuses;
  /**
   *
   * @type {ApiSvcInvoiceTypes}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  type: ApiSvcInvoiceTypes;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  remoteId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  source: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTO
   */
  connectionId: string;
}

/**
 *
 * @export
 * @interface ApiSvcPushedInvoiceDTOLinesInner
 */
export interface ApiSvcPushedInvoiceDTOLinesInner {
  /**
   * GL account remoteId (QBO AccountRef.value, NS account internalId). Required for bills.
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTOLinesInner
   */
  accountCode?: string;
  /**
   * Item remoteId in the accounting system (QBO ItemRef.value, NS item internalId).
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTOLinesInner
   */
  itemId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushedInvoiceDTOLinesInner
   */
  unitAmount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushedInvoiceDTOLinesInner
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcPushedInvoiceDTOLinesInner
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTOLinesInner
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTOLinesInner
   */
  id?: string;
}
/**
 *
 * @export
 * @interface ApiSvcPushedInvoiceDTOLinesInnerAllOf
 */
export interface ApiSvcPushedInvoiceDTOLinesInnerAllOf {
  /**
   *
   * @type {string}
   * @memberof ApiSvcPushedInvoiceDTOLinesInnerAllOf
   */
  id?: string;
}
/**
 * QBO-specific connection fields useful to a caller deciding to push. The `realm` is included so callers can disambiguate multiple QBO connections on the same org for user display.
 * @export
 * @interface ApiSvcQuickbooksConnectionDetailsDTO
 */
export interface ApiSvcQuickbooksConnectionDetailsDTO {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcQuickbooksConnectionDetailsDTO
   */
  excludeZeroBalanceInvoices?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcQuickbooksConnectionDetailsDTO
   */
  defaultJobId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcQuickbooksConnectionDetailsDTO
   */
  defaultDepartmentId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcQuickbooksConnectionDetailsDTO
   */
  defaultClassId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcQuickbooksConnectionDetailsDTO
   */
  feeAccountCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcQuickbooksConnectionDetailsDTO
   */
  accountCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcQuickbooksConnectionDetailsDTO
   */
  realm: string;
}
/**
 * on purpose we are not adding ticker here
 * @export
 * @interface ApiSvcRawValueDTO
 */
export interface ApiSvcRawValueDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRawValueDTO
   */
  currencyId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRawValueDTO
   */
  value: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRecResult = {
  Succeeded: 'succeeded',
  Failed: 'failed',
  PartialSuccess: 'partial-success',
  QueuedToSync: 'queued-to-sync',
} as const;

export type ApiSvcRecResult = typeof ApiSvcRecResult[keyof typeof ApiSvcRecResult];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcReconciliationStatusDTO = {
  All: 'All',
  Unreconciled: 'Unreconciled',
  Reconciled: 'Reconciled',
} as const;

export type ApiSvcReconciliationStatusDTO =
  typeof ApiSvcReconciliationStatusDTO[keyof typeof ApiSvcReconciliationStatusDTO];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRecordBinaryContent = {
  Csv: 'csv',
  Pdf: 'pdf',
  Png: 'png',
  Txt: 'txt',
  Json: 'json',
} as const;

export type ApiSvcRecordBinaryContent = typeof ApiSvcRecordBinaryContent[keyof typeof ApiSvcRecordBinaryContent];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRecordBucket = {
  SodaReports: 'soda-reports',
  JournalReports: 'journal-reports',
  BalanceReports: 'balance-reports',
  TrialBalanceReports: 'trial-balance-reports',
  TransactionsExportReports: 'transactions-export-reports',
  BalanceCheckReports: 'balance-check-reports',
  ActionsReports: 'actions-reports',
  CostBasisRollforwardReports: 'cost-basis-rollforward-reports',
  Reports: 'reports',
  SftpFiles: 'sftp_files',
} as const;

export type ApiSvcRecordBucket = typeof ApiSvcRecordBucket[keyof typeof ApiSvcRecordBucket];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRecordBucketSodaReports = {
  SodaReports: 'soda-reports',
} as const;

export type ApiSvcRecordBucketSodaReports =
  typeof ApiSvcRecordBucketSodaReports[keyof typeof ApiSvcRecordBucketSodaReports];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRecordType = {
  Json: 'json',
  Binary: 'binary',
} as const;

export type ApiSvcRecordType = typeof ApiSvcRecordType[keyof typeof ApiSvcRecordType];

/**
 *
 * @export
 * @interface ApiSvcRelatedOrgsBalanceLine
 */
export interface ApiSvcRelatedOrgsBalanceLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsBalanceLine
   */
  clientId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsBalanceLine
   */
  clientName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsBalanceLine
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsBalanceLine
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsBalanceLine
   */
  currency: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsBalanceLine
   */
  value: string;
}
/**
 *
 * @export
 * @interface ApiSvcRelatedOrgsBalanceReportParams
 */
export interface ApiSvcRelatedOrgsBalanceReportParams {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRelatedOrgsBalanceReportParams
   */
  relatedOrgIds: Array<string>;
  /**
   *
   * @type {ApiSvcOrgRelationshipType}
   * @memberof ApiSvcRelatedOrgsBalanceReportParams
   */
  relatedOrgsType: ApiSvcOrgRelationshipType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRelatedOrgsBalanceReportParams
   */
  relatedWalletIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsBalanceReportParams
   */
  pageToken?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRelatedOrgsBalanceReportParams
   */
  startTimestamp?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRelatedOrgsBalanceReportParams
   */
  endTimestamp?: number;
}

/**
 *
 * @export
 * @interface ApiSvcRelatedOrgsTransactionsLine
 */
export interface ApiSvcRelatedOrgsTransactionsLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  orgName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  timestamp: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  symbol: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  amount?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  price?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  priceSource?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  value?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  feeAmount?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  feeAsset?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  to: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  operation: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  hash: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsLine
   */
  combinedParentTxnId: string;
}
/**
 *
 * @export
 * @interface ApiSvcRelatedOrgsTransactionsReportParams
 */
export interface ApiSvcRelatedOrgsTransactionsReportParams {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRelatedOrgsTransactionsReportParams
   */
  relatedOrgIds: Array<string>;
  /**
   *
   * @type {ApiSvcOrgRelationshipType}
   * @memberof ApiSvcRelatedOrgsTransactionsReportParams
   */
  relatedOrgsType: ApiSvcOrgRelationshipType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRelatedOrgsTransactionsReportParams
   */
  relatedWalletIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRelatedOrgsTransactionsReportParams
   */
  pageToken?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRelatedOrgsTransactionsReportParams
   */
  startTimestamp?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRelatedOrgsTransactionsReportParams
   */
  endTimestamp?: number;
}

/**
 *
 * @export
 * @interface ApiSvcRemittanceOptions
 */
export interface ApiSvcRemittanceOptions {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRemittanceOptions
   */
  remittanceContactEmail: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRemittanceOptions
   */
  remittanceBusinessName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRemittanceOptions
   */
  remittanceBusinessLogo: string;
}
/**
 *
 * @export
 * @interface ApiSvcRemoteSyncStatus
 */
export interface ApiSvcRemoteSyncStatus {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRemoteSyncStatus
   */
  itemId: string;
  /**
   *
   * @type {ApiSvcRecResult}
   * @memberof ApiSvcRemoteSyncStatus
   */
  res: ApiSvcRecResult;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRemoteSyncStatus
   */
  errors: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRemoteSyncStatus
   */
  remoteIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRemoteSyncStatus
   */
  warnings?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRemoteSyncStatus
   */
  unbookedLines?: Array<string>;
}

/**
 *
 * @export
 * @interface ApiSvcRemoteSyncStatusDTO
 */
export interface ApiSvcRemoteSyncStatusDTO {
  /**
   *
   * @type {ApiSvcRecResult}
   * @memberof ApiSvcRemoteSyncStatusDTO
   */
  result: ApiSvcRecResult;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRemoteSyncStatusDTO
   */
  errors?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRemoteSyncStatusDTO
   */
  remoteIds?: Array<string>;
}

/**
 *
 * @export
 * @interface ApiSvcRemoteSystemId
 */
export interface ApiSvcRemoteSystemId {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRemoteSystemId
   */
  remoteId: string;
  /**
   *
   * @type {ApiSvcSources}
   * @memberof ApiSvcRemoteSystemId
   */
  source: ApiSvcSources;
}

/**
 *
 * @export
 * @interface ApiSvcReportData
 */
export interface ApiSvcReportData {
  /**
   *
   * @type {ApiSvcReportRunType}
   * @memberof ApiSvcReportData
   */
  reportType: ApiSvcReportRunType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportData
   */
  reportRunId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportData
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportData
   */
  subTitle1?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportData
   */
  subTitle2?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcReportData
   */
  columns: Array<string>;
  /**
   *
   * @type {Array<ApiSvcReportRow>}
   * @memberof ApiSvcReportData
   */
  rows: Array<ApiSvcReportRow>;
  /**
   *
   * @type {Array<ApiSvcReportOption>}
   * @memberof ApiSvcReportData
   */
  filterOptions: Array<ApiSvcReportOption>;
  /**
   *
   * @type {ApiSvcLinkDTO}
   * @memberof ApiSvcReportData
   */
  downloadLink?: ApiSvcLinkDTO;
}

/**
 *
 * @export
 * @interface ApiSvcReportExecutionTask
 */
export interface ApiSvcReportExecutionTask {
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportExecutionTask
   */
  reportId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportExecutionTask
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportExecutionTask
   */
  customerId: string;
}
/**
 *
 * @export
 * @interface ApiSvcReportInput
 */
export interface ApiSvcReportInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportInput
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportInput
   */
  value: string;
}
/**
 *
 * @export
 * @interface ApiSvcReportOption
 */
export interface ApiSvcReportOption {
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportOption
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportOption
   */
  key: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcReportOption
   */
  options?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcReportOption
   */
  boolean?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcReportResultTypes = {
  GainLossReportResults: 'gain-loss-report-results',
  JournalEntrySaveDown: 'journal-entry-save-down',
  BalanceReport: 'balance-report',
  RelatedOrgsBalanceReport: 'related-orgs-balance-report',
  TxnExportBqReport: 'txn-export-bq-report',
  PriceExceptionBqReport: 'price-exception-bq-report',
  BalanceReconBqReport: 'balance-recon-bq-report',
  RelatedOrgsTransactionsReport: 'related-orgs-transactions-report',
  TxnActionCompareBqReport: 'txn-action-compare-bq-report',
  XrpCustomFusionEcbBigqueryReport: 'xrp-custom-fusion-ecb-bigquery-report',
  XrpCustomFusionJeBigqueryReport: 'xrp-custom-fusion-je-bigquery-report',
  GlSummaryBigqueryReport: 'gl-summary-bigquery-report',
  GlDetailedBigqueryReport: 'gl-detailed-bigquery-report',
  ValuationRollforwardBigqueryReport: 'valuation-rollforward-bigquery-report',
  RolledUpActionsJeReport: 'rolled-up-actions-je-report',
  XrpCustomFusionJeEliminationBigqueryReport: 'xrp-custom-fusion-je-elimination-bigquery-report',
  XrpCustomNetChangeBigqueryReport: 'xrp-custom-net-change-bigquery-report',
  XrpCustomPurchasedXrpBalancesReport: 'xrp-custom-purchased-xrp-balances-report',
  FusionCustomJeImportBqReport: 'fusion-custom-je-import-bq-report',
} as const;

export type ApiSvcReportResultTypes = typeof ApiSvcReportResultTypes[keyof typeof ApiSvcReportResultTypes];

/**
 *
 * @export
 * @interface ApiSvcReportResults
 */
export interface ApiSvcReportResults {
  /**
   *
   * @type {ApiSvcReportResultTypes}
   * @memberof ApiSvcReportResults
   */
  type: ApiSvcReportResultTypes;
  /**
   *
   * @type {ApiSvcFilePointer}
   * @memberof ApiSvcReportResults
   */
  results: ApiSvcFilePointer;
}

/**
 *
 * @export
 * @interface ApiSvcReportRow
 */
export interface ApiSvcReportRow {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcReportRow
   */
  cells: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportRow
   */
  headerText?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcReportRow
   */
  isTotalRow?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcReportRow
   */
  expandable: boolean;
  /**
   *
   * @type {Array<ApiSvcReportRow>}
   * @memberof ApiSvcReportRow
   */
  rows: Array<ApiSvcReportRow>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportRow
   */
  additionalRowsToken?: string;
}
/**
 *
 * @export
 * @interface ApiSvcReportRunConfig
 */
export interface ApiSvcReportRunConfig {
  /**
   *
   * @type {ApiSvcReportRunConfigTypes}
   * @memberof ApiSvcReportRunConfig
   */
  type: ApiSvcReportRunConfigTypes;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportRunConfig
   */
  scope: string;
  /**
   *
   * @type {ApiSvcPersistReportOptions}
   * @memberof ApiSvcReportRunConfig
   */
  persistOptions?: ApiSvcPersistReportOptions;
  /**
   *
   * @type {ApiSvcReportSpecificOptions}
   * @memberof ApiSvcReportRunConfig
   */
  reportSpecificOptions?: ApiSvcReportSpecificOptions;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcReportRunConfigTypes = {
  GainLossReport: 'gain-loss-report',
  JournalEntrySaveDown: 'journal-entry-save-down',
  BalanceReport: 'balance-report',
  RelatedOrgsBalanceReport: 'related-orgs-balance-report',
  RelatedOrgsTransactionsReport: 'related-orgs-transactions-report',
  SodaReport: 'soda-report',
  UnspecifiedReport: 'unspecified-report',
  TxnExportBqReport: 'txn-export-bq-report',
  PriceExceptionBqReport: 'price-exception-bq-report',
  BalanceReconBqReport: 'balance-recon-bq-report',
  TxnActionCompareBqReport: 'txn-action-compare-bq-report',
  XrpCustomFusionEcbBigqueryReport: 'xrp-custom-fusion-ecb-bigquery-report',
  XrpCustomFusionJeBigqueryReport: 'xrp-custom-fusion-je-bigquery-report',
  ValuationRollforwardBigqueryReport: 'valuation-rollforward-bigquery-report',
  GlSummaryBigqueryReport: 'gl-summary-bigquery-report',
  GlDetailedBigqueryReport: 'gl-detailed-bigquery-report',
  RolledUpActionsJeReport: 'rolled-up-actions-je-report',
  CashFlowStatementReport: 'cash-flow-statement-report',
  ReportInputsConfig: 'report-inputs-config',
  XrpCustomFusionJeEliminationBigqueryReport: 'xrp-custom-fusion-je-elimination-bigquery-report',
  XrpCustomNetChangeBigqueryReport: 'xrp-custom-net-change-bigquery-report',
  XrpCustomPurchasedXrpBalancesReport: 'xrp-custom-purchased-xrp-balances-report',
  FusionCustomJeImportBqReport: 'fusion-custom-je-import-bq-report',
} as const;

export type ApiSvcReportRunConfigTypes = typeof ApiSvcReportRunConfigTypes[keyof typeof ApiSvcReportRunConfigTypes];

/**
 *
 * @export
 * @interface ApiSvcReportRunRecordReportRunConfig
 */
export interface ApiSvcReportRunRecordReportRunConfig {
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportRunRecordReportRunConfig
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportRunRecordReportRunConfig
   */
  orgId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcReportRunRecordReportRunConfig
   */
  createdSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcReportRunRecordReportRunConfig
   */
  updatedSEC: number;
  /**
   *
   * @type {ApiSvcUserPointer}
   * @memberof ApiSvcReportRunRecordReportRunConfig
   */
  createdBy: ApiSvcUserPointer;
  /**
   *
   * @type {ApiSvcReportRunStatus}
   * @memberof ApiSvcReportRunRecordReportRunConfig
   */
  status: ApiSvcReportRunStatus;
  /**
   *
   * @type {ApiSvcReportRunConfig}
   * @memberof ApiSvcReportRunRecordReportRunConfig
   */
  config: ApiSvcReportRunConfig;
  /**
   *
   * @type {ApiSvcExecContext}
   * @memberof ApiSvcReportRunRecordReportRunConfig
   */
  execContext: ApiSvcExecContext;
  /**
   *
   * @type {ApiSvcReportResults}
   * @memberof ApiSvcReportRunRecordReportRunConfig
   */
  results?: ApiSvcReportResults;
}

/**
 *
 * @export
 * @interface ApiSvcReportRunResponse
 */
export interface ApiSvcReportRunResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportRunResponse
   */
  reportRunId: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcReportRunStatus = {
  New: 'new',
  Running: 'running',
  Succeeded: 'succeeded',
  Failed: 'failed',
  TimedOut: 'timed-out',
} as const;

export type ApiSvcReportRunStatus = typeof ApiSvcReportRunStatus[keyof typeof ApiSvcReportRunStatus];

/**
 *
 * @export
 * @interface ApiSvcReportRunStatusResponse
 */
export interface ApiSvcReportRunStatusResponse {
  /**
   *
   * @type {ApiSvcReportRunStatus}
   * @memberof ApiSvcReportRunStatusResponse
   */
  status: ApiSvcReportRunStatus;
}

/**
 * Wire shape for one report run row. Mirrors `ReportRunSummary` but uses plain types so tsoa can generate a complete OpenAPI spec: the underlying `ReportRunSummary` carries `errors: ReadonlyArray<string>` (tsoa stumbles on the type-parameter lookup) and `config: ReportRunConfig` (an abstract ta-json class with a discriminator decorator that tsoa can\'t introspect).  `config` is intentionally `{ [k: string]: unknown }` on the wire — V3 stores `ReportInputsConfig` so callers read `config.inputs[]`, but other report types may carry different shapes. The discriminator stays on the value.
 * @export
 * @interface ApiSvcReportRunSummaryDTO
 */
export interface ApiSvcReportRunSummaryDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportRunSummaryDTO
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportRunSummaryDTO
   */
  reportRunId: string;
  /**
   *
   * @type {ApiSvcReportRunType}
   * @memberof ApiSvcReportRunSummaryDTO
   */
  reportType: ApiSvcReportRunType;
  /**
   *
   * @type {ApiSvcReportRunStatus}
   * @memberof ApiSvcReportRunSummaryDTO
   */
  status: ApiSvcReportRunStatus;
  /**
   *
   * @type {number}
   * @memberof ApiSvcReportRunSummaryDTO
   */
  startedAtSec: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcReportRunSummaryDTO
   */
  completedAtSec?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportRunSummaryDTO
   */
  actorPrincipalId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcReportRunSummaryDTO
   */
  errors?: Array<string>;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ApiSvcReportRunSummaryDTO
   */
  config?: { [key: string]: any };
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcReportRunType = {
  BalanceReport: 'balance-report',
  GainLossReport: 'gain-loss-report',
  JournalReport: 'journal-report',
  DefiRoiReport: 'defi-roi-report',
  AdvancedBalanceReport: 'advanced-balance-report',
  AdvancedRelatedOrgsBalanceReport: 'advanced-related-orgs-balance-report',
  RelatedOrgsTransactionsReport: 'related-orgs-transactions-report',
  SodaReport: 'soda-report',
  UnspecifiedReport: 'unspecified-report',
  CashFlowStatement: 'cash-flow-statement',
  TestReport: 'test-report',
  DeletedIgnoredTransactionsReport: 'deleted-ignored-transactions-report',
  CloseChecklistReport: 'close-checklist-report',
  TrialBalanceReport: 'trial-balance-report',
  TransactionsExportReport: 'transactions-export-report',
  BalanceCheckReport: 'balance-check-report',
  ActionsReport: 'actions-report',
  CostBasisRollforwardReport: 'cost-basis-rollforward-report',
} as const;

export type ApiSvcReportRunType = typeof ApiSvcReportRunType[keyof typeof ApiSvcReportRunType];

/**
 *
 * @export
 * @interface ApiSvcReportSpecificOptions
 */
export interface ApiSvcReportSpecificOptions {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcReportSpecificOptions
   */
  includeInternalTransfers?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcReportsResponse
 */
export interface ApiSvcReportsResponse {
  /**
   *
   * @type {Array<ApiSvcCustomerReport>}
   * @memberof ApiSvcReportsResponse
   */
  items: Array<ApiSvcCustomerReport>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReportsResponse
   */
  nextPageToken?: string;
}
/**
 *
 * @export
 * @interface ApiSvcReprocessBlockedResponse
 */
export interface ApiSvcReprocessBlockedResponse {
  /**
   *
   * @type {number}
   * @memberof ApiSvcReprocessBlockedResponse
   */
  walletsProcessed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcReprocessBlockedResponse
   */
  walletsResolved: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcReprocessBlockedResponse
   */
  walletsStillBlocked: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcReprocessBlockedResponse
   */
  resolvedWalletIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcReprocessBlockedWallets200Response
 */
export interface ApiSvcReprocessBlockedWallets200Response {
  /**
   *
   * @type {number}
   * @memberof ApiSvcReprocessBlockedWallets200Response
   */
  walletsProcessed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcReprocessBlockedWallets200Response
   */
  walletsResolved: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcReprocessBlockedWallets200Response
   */
  walletsStillBlocked: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcReprocessBlockedWallets200Response
   */
  resolvedWalletIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReprocessBlockedWallets200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcReprocessBlockedWallets200Response
   */
  message: string;
}
/**
 * DTO for resolving pending changes for a transaction
 * @export
 * @interface ApiSvcResolveTransactionItemInterface
 */
export interface ApiSvcResolveTransactionItemInterface {
  /**
   * The ID of the transaction to resolve
   * @type {string}
   * @memberof ApiSvcResolveTransactionItemInterface
   */
  transactionId: string;
  /**
   *
   * @type {ApiSvcCategorizeTransactionDTO}
   * @memberof ApiSvcResolveTransactionItemInterface
   */
  categorization?: ApiSvcCategorizeTransactionDTO;
}
/**
 *
 * @export
 * @interface ApiSvcResolveTransactionPendingChanges200Response
 */
export interface ApiSvcResolveTransactionPendingChanges200Response {
  /**
   * Whether the operation was successful
   * @type {boolean}
   * @memberof ApiSvcResolveTransactionPendingChanges200Response
   */
  success: boolean;
  /**
   * Number of transactions processed
   * @type {number}
   * @memberof ApiSvcResolveTransactionPendingChanges200Response
   */
  processed: number;
  /**
   * Number of transactions successfully processed
   * @type {number}
   * @memberof ApiSvcResolveTransactionPendingChanges200Response
   */
  successCount: number;
  /**
   * Array of failed transactions with error messages
   * @type {Array<ApiSvcResolveTransactionsResponseFailedInner>}
   * @memberof ApiSvcResolveTransactionPendingChanges200Response
   */
  failed: Array<ApiSvcResolveTransactionsResponseFailedInner>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcResolveTransactionPendingChanges200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcResolveTransactionPendingChanges200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcResolveTransactionPendingChanges200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcResolveTransactionPendingChangesRequest
 */
export interface ApiSvcResolveTransactionPendingChangesRequest {
  /**
   *
   * @type {ApiSvcCategorizeTransactionDTO}
   * @memberof ApiSvcResolveTransactionPendingChangesRequest
   */
  categorization?: ApiSvcCategorizeTransactionDTO;
}
/**
 * DTO for resolving pending changes for multiple transactions
 * @export
 * @interface ApiSvcResolveTransactionsRequestDTO
 */
export interface ApiSvcResolveTransactionsRequestDTO {
  /**
   * List of transactions to resolve
   * @type {Array<ApiSvcResolveTransactionItemInterface>}
   * @memberof ApiSvcResolveTransactionsRequestDTO
   */
  transactions?: Array<ApiSvcResolveTransactionItemInterface>;
}
/**
 * Response interface for resolving transactions pending changes
 * @export
 * @interface ApiSvcResolveTransactionsResponse
 */
export interface ApiSvcResolveTransactionsResponse {
  /**
   * Whether the operation was successful
   * @type {boolean}
   * @memberof ApiSvcResolveTransactionsResponse
   */
  success: boolean;
  /**
   * Number of transactions processed
   * @type {number}
   * @memberof ApiSvcResolveTransactionsResponse
   */
  processed: number;
  /**
   * Number of transactions successfully processed
   * @type {number}
   * @memberof ApiSvcResolveTransactionsResponse
   */
  successCount: number;
  /**
   * Array of failed transactions with error messages
   * @type {Array<ApiSvcResolveTransactionsResponseFailedInner>}
   * @memberof ApiSvcResolveTransactionsResponse
   */
  failed: Array<ApiSvcResolveTransactionsResponseFailedInner>;
}
/**
 *
 * @export
 * @interface ApiSvcResolveTransactionsResponseFailedInner
 */
export interface ApiSvcResolveTransactionsResponseFailedInner {
  /**
   *
   * @type {string}
   * @memberof ApiSvcResolveTransactionsResponseFailedInner
   */
  error: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcResolveTransactionsResponseFailedInner
   */
  transactionId: string;
}
/**
 *
 * @export
 * @interface ApiSvcRippleInventoryCostBasisRollForwardLine
 */
export interface ApiSvcRippleInventoryCostBasisRollForwardLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  original_inventory: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  original_wallet: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  lotID: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  original_department: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  asset: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  units_beginning: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  carryingvalue_beginning: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  units_acquired: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  units_disposed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  units_ending: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  costbasis_acquired: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  costbasis_relieved: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  impairExpense: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  carryingvalue_ending: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  fiat_check_mustbe_zero: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardLine
   */
  qty_check_mustbe_zero: number;
}
/**
 *
 * @export
 * @interface ApiSvcRippleInventoryCostBasisRollForwardResp
 */
export interface ApiSvcRippleInventoryCostBasisRollForwardResp {
  /**
   *
   * @type {ApiSvcExportFileType}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardResp
   */
  fileType?: ApiSvcExportFileType;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardResp
   */
  exportIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardResp
   */
  exportId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardResp
   */
  filename?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardResp
   */
  metadata?: object;
  /**
   *
   * @type {Array<ApiSvcRippleInventoryCostBasisRollForwardLine>}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardResp
   */
  lines: Array<ApiSvcRippleInventoryCostBasisRollForwardLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRippleInventoryCostBasisRollForwardResp
   */
  pageToken?: string;
}

/**
 *
 * @export
 * @interface ApiSvcRoleDefinitionRecord
 */
export interface ApiSvcRoleDefinitionRecord {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRoleDefinitionRecord
   */
  RoleDefinitionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRoleDefinitionRecord
   */
  Name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRoleDefinitionRecord
   */
  Description: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRoleDefinitionRecord
   */
  Tags: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRoleDefinitionRecord
   */
  Scopes: Array<string>;
  /**
   *
   * @type {ApiSvcSubsidiaryAccess}
   * @memberof ApiSvcRoleDefinitionRecord
   */
  SubsidiaryAccess: ApiSvcSubsidiaryAccess;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRoleDefinitionRecord
   */
  Version?: number;
}

/**
 *
 * @export
 * @interface ApiSvcRolesDTO
 */
export interface ApiSvcRolesDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolesDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolesDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolesDTO
   */
  description?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRolesDTO
   */
  scopes?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRolesDTO
   */
  editable: boolean;
}
/**
 * Response DTO for rolled-up JE configuration (for TSOA/OpenAPI compatibility) Converts Map to Record for serialization
 * @export
 * @interface ApiSvcRolledUpJeReportConfigurationResponseDTO
 */
export interface ApiSvcRolledUpJeReportConfigurationResponseDTO {
  /**
   * When true, adjustments from internal transfers are grouped with other adjustments
   * @type {boolean}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  groupInternalTransferAdjustments: boolean;
  /**
   * Map of subsidiary IDs to their default settings (TSOA-compatible)
   * @type {{ [key: string]: ApiSvcRollupDefaultSettings; }}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  subsidiaryDefaultSettings?: { [key: string]: ApiSvcRollupDefaultSettings };
  /**
   * When true, excludes buy/sell sides of internal transfers (only fees are included)
   * @type {boolean}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  excludeInternalTransfers: boolean;
  /**
   *
   * @type {ApiSvcEntryTypeOverridesMap}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  entryTypeOverrides?: ApiSvcEntryTypeOverridesMap;
  /**
   * When true, adjustment lines on sell actions are merged into the SELL JE
   * @type {boolean}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  mergeAdjustmentsIntoSale: boolean;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  walletRollupRules: object;
  /**
   *
   * @type {ApiSvcRollupDefaultSettings}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  defaultSettings?: ApiSvcRollupDefaultSettings;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  connectionId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  deletedAtSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  updatedAtSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  createdAtSEC: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  createdBy?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  isDeleted: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  active: boolean;
  /**
   *
   * @type {Array<ApiSvcRollupGroupBy>}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  defaultGroupBy?: Array<ApiSvcRollupGroupBy>;
  /**
   *
   * @type {ApiSvcRollupStrategy}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  defaultRollupStrategy?: ApiSvcRollupStrategy;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  configId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJeReportConfigurationResponseDTO
   */
  orgId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcRolledUpJeReportResponse
 */
export interface ApiSvcRolledUpJeReportResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJeReportResponse
   */
  reportId: string;
  /**
   *
   * @type {ApiSvcReportRunStatus}
   * @memberof ApiSvcRolledUpJeReportResponse
   */
  status: ApiSvcReportRunStatus;
  /**
   *
   * @type {Array<ApiSvcRolledUpJournalEntry>}
   * @memberof ApiSvcRolledUpJeReportResponse
   */
  entries: Array<ApiSvcRolledUpJournalEntry>;
}

/**
 * Represents a journal entry created from a rolled-up JE report. These entries are persisted after generation and then pushed to ERP in a separate step.
 * @export
 * @interface ApiSvcRolledUpJournalEntry
 */
export interface ApiSvcRolledUpJournalEntry {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  reportId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  orgId: string;
  /**
   *
   * @type {ApiSvcAccountingEntry}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  accountingEntry: ApiSvcAccountingEntry;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  sourceTransactionIds: Array<string>;
  /**
   *
   * @type {ApiSvcRolledUpJournalEntryStatus}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  status: ApiSvcRolledUpJournalEntryStatus;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  pushedAt?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  erpEntryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRolledUpJournalEntry
   */
  errorMessage?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRolledUpJournalEntryStatus = {
  New: 'new',
  Pending: 'pending',
  Pushing: 'pushing',
  Synced: 'synced',
  Failed: 'failed',
} as const;

export type ApiSvcRolledUpJournalEntryStatus =
  typeof ApiSvcRolledUpJournalEntryStatus[keyof typeof ApiSvcRolledUpJournalEntryStatus];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRollupAction = {
  Rollup: 'rollup',
  RollupFromTo: 'rollupFromTo',
  RollupByAsset: 'rollupByAsset',
  NonRollup: 'nonRollup',
  Ignore: 'ignore',
} as const;

export type ApiSvcRollupAction = typeof ApiSvcRollupAction[keyof typeof ApiSvcRollupAction];

/**
 *
 * @export
 * @interface ApiSvcRollupConfig
 */
export interface ApiSvcRollupConfig {
  /**
   *
   * @type {Array<ApiSvcRollupRule>}
   * @memberof ApiSvcRollupConfig
   */
  rules?: Array<ApiSvcRollupRule> | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfig
   */
  rollupAll?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfig
   */
  rollupRemittance?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfig
   */
  rollupTokenRemittance?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfig
   */
  rollupFee?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfig
   */
  rollupTokenRevenue?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfig
   */
  rollupRevenue?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfig
   */
  seperateByLog?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRollupConfig
   */
  logSelector?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfig
   */
  seperateByAccount?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRollupConfig
   */
  accountCheck?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupConfig
   */
  metadata?: string;
  /**
   *
   * @type {ApiSvcRollupPeriod}
   * @memberof ApiSvcRollupConfig
   */
  rollupPeriod: ApiSvcRollupPeriod;
  /**
   *
   * @type {ApiSvcRollupSelector}
   * @memberof ApiSvcRollupConfig
   */
  rollupSelector: ApiSvcRollupSelector;
}

/**
 *
 * @export
 * @interface ApiSvcRollupConfigBase
 */
export interface ApiSvcRollupConfigBase {
  /**
   *
   * @type {ApiSvcRollupConfigTypes}
   * @memberof ApiSvcRollupConfigBase
   */
  type: ApiSvcRollupConfigTypes;
}

/**
 *
 * @export
 * @interface ApiSvcRollupConfigDTO
 */
export interface ApiSvcRollupConfigDTO {
  /**
   *
   * @type {ApiSvcRollupSelector}
   * @memberof ApiSvcRollupConfigDTO
   */
  rollupSelector: ApiSvcRollupSelector;
  /**
   *
   * @type {ApiSvcRollupPeriod}
   * @memberof ApiSvcRollupConfigDTO
   */
  rollupPeriod: ApiSvcRollupPeriod;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupConfigDTO
   */
  metadata?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRollupConfigDTO
   */
  accountCheck?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfigDTO
   */
  seperateByAccount?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRollupConfigDTO
   */
  logSelector?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfigDTO
   */
  seperateByLog?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfigDTO
   */
  rollupRevenue?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfigDTO
   */
  rollupTokenRevenue?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfigDTO
   */
  rollupFee?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfigDTO
   */
  rollupTokenRemittance?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfigDTO
   */
  rollupRemittance?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupConfigDTO
   */
  rollupAll?: boolean;
  /**
   *
   * @type {Array<ApiSvcRollupRuleDTO>}
   * @memberof ApiSvcRollupConfigDTO
   */
  rules?: Array<ApiSvcRollupRuleDTO>;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRollupConfigTypes = {
  WalletRollupByTime: 'wallet-rollup-by-time',
  RollupByTime: 'rollup-by-time',
} as const;

export type ApiSvcRollupConfigTypes = typeof ApiSvcRollupConfigTypes[keyof typeof ApiSvcRollupConfigTypes];

/**
 * Default settings for all entry types
 * @export
 * @interface ApiSvcRollupDefaultSettings
 */
export interface ApiSvcRollupDefaultSettings {
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcRollupDefaultSettings
   */
  gainLoss: ApiSvcEntryTypeDefaultSettings;
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcRollupDefaultSettings
   */
  adjustment: ApiSvcEntryTypeDefaultSettings;
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcRollupDefaultSettings
   */
  digitalAsset: ApiSvcEntryTypeDefaultSettings;
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcRollupDefaultSettings
   */
  unrealizedGainLoss?: ApiSvcEntryTypeDefaultSettings;
  /**
   * Optional timezone override for journal entries (e.g., \'America/Los_Angeles\' for PST). If not set, uses org\'s default timezone.
   * @type {string}
   * @memberof ApiSvcRollupDefaultSettings
   */
  timezone?: string;
  /**
   *
   * @type {ApiSvcEntryTypeDefaultSettings}
   * @memberof ApiSvcRollupDefaultSettings
   */
  clearing?: ApiSvcEntryTypeDefaultSettings;
  /**
   * Default contact ID to use when transaction has no contact
   * @type {string}
   * @memberof ApiSvcRollupDefaultSettings
   */
  defaultContactId?: string;
  /**
   * Metadata key-value map (TSOA-compatible alternative to Record<string, string>)
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcRollupDefaultSettings
   */
  metadata?: { [key: string]: string };
}
/**
 * Fields to group transactions by
 * @export
 * @enum {string}
 */

export const ApiSvcRollupGroupBy = {
  Category: 'category',
  Contact: 'contact',
  Asset: 'asset',
  Wallet: 'wallet',
  Subsidiary: 'subsidiary',
} as const;

export type ApiSvcRollupGroupBy = typeof ApiSvcRollupGroupBy[keyof typeof ApiSvcRollupGroupBy];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRollupPeriod = {
  Hour: 'hour',
  Day: 'day',
  Month: 'month',
  Minute: 'minute',
} as const;

export type ApiSvcRollupPeriod = typeof ApiSvcRollupPeriod[keyof typeof ApiSvcRollupPeriod];

/**
 *
 * @export
 * @interface ApiSvcRollupReprocessConfig
 */
export interface ApiSvcRollupReprocessConfig {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupReprocessConfig
   */
  runId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupReprocessConfig
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupReprocessConfig
   */
  walletId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRollupReprocessConfig
   */
  startTimeMS?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRollupReprocessConfig
   */
  endTimeMS?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupReprocessConfig
   */
  startTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupReprocessConfig
   */
  endTime?: string;
}
/**
 *
 * @export
 * @interface ApiSvcRollupRule
 */
export interface ApiSvcRollupRule {
  /**
   *
   * @type {number}
   * @memberof ApiSvcRollupRule
   */
  endSec?: number | null;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRollupRule
   */
  startSec?: number | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRollupRule
   */
  involvedAccounts?: Array<string> | null;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcRollupRule
   */
  metadata?: object | null;
  /**
   *
   * @type {ApiSvcRollupAction}
   * @memberof ApiSvcRollupRule
   */
  rollupAction: ApiSvcRollupAction;
  /**
   *
   * @type {ApiSvcFingerPrintType}
   * @memberof ApiSvcRollupRule
   */
  fingerPrint: ApiSvcFingerPrintType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupRule
   */
  classification: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupRule
   */
  ruleName: string;
}

/**
 *
 * @export
 * @interface ApiSvcRollupRuleDTO
 */
export interface ApiSvcRollupRuleDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupRuleDTO
   */
  ruleName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupRuleDTO
   */
  classification: string;
  /**
   *
   * @type {ApiSvcFingerPrintType}
   * @memberof ApiSvcRollupRuleDTO
   */
  fingerPrint: ApiSvcFingerPrintType;
  /**
   *
   * @type {ApiSvcRollupAction}
   * @memberof ApiSvcRollupRuleDTO
   */
  rollupAction: ApiSvcRollupAction;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcRollupRuleDTO
   */
  metadata?: object;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRollupRuleDTO
   */
  involvedAccounts?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRollupRuleDTO
   */
  startSec?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRollupRuleDTO
   */
  endSec?: number;
}

/**
 *
 * @export
 * @interface ApiSvcRollupRulesDTO
 */
export interface ApiSvcRollupRulesDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupRulesDTO
   */
  ruleName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRollupRulesDTO
   */
  classification: string;
  /**
   *
   * @type {ApiSvcFingerPrintType}
   * @memberof ApiSvcRollupRulesDTO
   */
  fingerPrint: ApiSvcFingerPrintType;
  /**
   *
   * @type {ApiSvcRollupAction}
   * @memberof ApiSvcRollupRulesDTO
   */
  rollupAction: ApiSvcRollupAction;
  /**
   *
   * @type {any}
   * @memberof ApiSvcRollupRulesDTO
   */
  metadata?: any;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupRulesDTO
   */
  separateByInvolvedAccounts?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRollupRulesDTO
   */
  involvedAccounts?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRollupRulesDTO
   */
  startSec?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRollupRulesDTO
   */
  endSec?: number;
  /**
   *
   * @type {ApiSvcRollupPeriod}
   * @memberof ApiSvcRollupRulesDTO
   */
  cadence: ApiSvcRollupPeriod;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRollupRulesDTO
   */
  counterParties?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupRulesDTO
   */
  counterPartyExcludeFees?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRollupRulesDTO
   */
  separateByCounterParty?: boolean;
  /**
   *
   * @type {ApiSvcTradeSeparation}
   * @memberof ApiSvcRollupRulesDTO
   */
  separateByTrade?: ApiSvcTradeSeparation;
  /**
   *
   * @type {ApiSvcRoundPeriod}
   * @memberof ApiSvcRollupRulesDTO
   */
  roundPeriod?: ApiSvcRoundPeriod;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRollupSelector = {
  Revenue: 'revenue',
  Fees: 'fees',
  Custom: 'custom',
  FeeAndRevenue: 'feeAndRevenue',
  AdvancedFilter: 'advancedFilter',
} as const;

export type ApiSvcRollupSelector = typeof ApiSvcRollupSelector[keyof typeof ApiSvcRollupSelector];

/**
 * Strategy for how transactions are rolled up
 * @export
 * @enum {string}
 */

export const ApiSvcRollupStrategy = {
  Detailed: 'DETAILED',
  Summarized: 'SUMMARIZED',
} as const;

export type ApiSvcRollupStrategy = typeof ApiSvcRollupStrategy[keyof typeof ApiSvcRollupStrategy];

/**
 *
 * @export
 * @interface ApiSvcRotateConnectionCredentials200Response
 */
export interface ApiSvcRotateConnectionCredentials200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  orgId: string;
  /**
   *
   * @type {ApiSvcConnectionType}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  type: ApiSvcConnectionType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  provider: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  lastSyncSEC?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  isDisabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  isDeleted: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  isSetupComplete: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  location?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  subAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  s3Bucket?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  s3Prefix?: string;
  /**
   *
   * @type {ApiSvcConnectionCategory}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  category?: ApiSvcConnectionCategory;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   * @deprecated
   */
  syncerVersion?: number;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  feeAccountCode?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  syncSubAccounts?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  accountCode?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  connectionSpecificFields?: object;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  isDefault?: boolean;
  /**
   *
   * @type {ApiSvcConnectionFlags}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  flags?: ApiSvcConnectionFlags;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  subAccountName?: string;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  lastSuccessfulJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  lastJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {number}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  lastRotatedAt?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  keyFingerprint?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRotateConnectionCredentials200Response
   */
  message: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcRoundPeriod = {
  StartOfPeriod: 'start-of-period',
  EndOfPeriod: 'end-of-period',
} as const;

export type ApiSvcRoundPeriod = typeof ApiSvcRoundPeriod[keyof typeof ApiSvcRoundPeriod];

/**
 *
 * @export
 * @interface ApiSvcRuleActionGraphQL
 */
export interface ApiSvcRuleActionGraphQL {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  type: ApiSvcRuleActionGraphQLTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcRuleActionGraphQL
   */
  labels?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRuleActionGraphQL
   */
  ignoreFailPricing?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  feeContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  categoryId: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRuleActionGraphQL
   */
  isIntercompanyTransfer?: boolean;
  /**
   *
   * @type {Array<ApiSvcDetailedCategorizationActionLines>}
   * @memberof ApiSvcRuleActionGraphQL
   */
  lines: Array<ApiSvcDetailedCategorizationActionLines>;
  /**
   *
   * @type {Array<ApiSvcSplit>}
   * @memberof ApiSvcRuleActionGraphQL
   */
  feeSplits?: Array<ApiSvcSplit>;
  /**
   *
   * @type {Array<ApiSvcSplit>}
   * @memberof ApiSvcRuleActionGraphQL
   */
  splits: Array<ApiSvcSplit>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  acquiredCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  acquiredContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  disposedCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  disposedContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleActionGraphQL
   */
  deFiWalletId: string;
}

export const ApiSvcRuleActionGraphQLTypeEnum = {
  DeFiCategorization: 'DeFiCategorization',
} as const;

export type ApiSvcRuleActionGraphQLTypeEnum =
  typeof ApiSvcRuleActionGraphQLTypeEnum[keyof typeof ApiSvcRuleActionGraphQLTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcRuleComparison
 */
export interface ApiSvcRuleComparison {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleComparison
   */
  value: string;
  /**
   *
   * @type {ApiSvcComparison}
   * @memberof ApiSvcRuleComparison
   */
  comparison: ApiSvcComparison;
}

/**
 *
 * @export
 * @interface ApiSvcRuleComparisonDTO
 */
export interface ApiSvcRuleComparisonDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleComparisonDTO
   */
  value: string;
  /**
   *
   * @type {ApiSvcComparisonGraphQL}
   * @memberof ApiSvcRuleComparisonDTO
   */
  comparison: ApiSvcComparisonGraphQL;
}

/**
 *
 * @export
 * @interface ApiSvcRuleProcessingResult
 */
export interface ApiSvcRuleProcessingResult {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRuleProcessingResult
   */
  applied: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleProcessingResult
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleProcessingResult
   */
  ruleId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleProcessingResult
   */
  txnId: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRuleProcessingResult
   */
  autoReconcile: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRuleProcessingResult
   */
  error?: string;
}
/**
 *
 * @export
 * @interface ApiSvcRulesErrorResponse
 */
export interface ApiSvcRulesErrorResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRulesErrorResponse
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRulesErrorResponse
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcRulesExecutionResponse
 */
export interface ApiSvcRulesExecutionResponse {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRulesExecutionResponse
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRulesExecutionResponse
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcRunBalanceCheckReportJob200Response
 */
export interface ApiSvcRunBalanceCheckReportJob200Response {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRunBalanceCheckReportJob200Response
   */
  accepted: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcRunESBalanceReportPreview200Response
 */
export interface ApiSvcRunESBalanceReportPreview200Response {
  /**
   *
   * @type {Array<ApiSvcAssetSummary>}
   * @memberof ApiSvcRunESBalanceReportPreview200Response
   */
  items: Array<ApiSvcAssetSummary>;
  /**
   *
   * @type {ApiSvcAssetSummary}
   * @memberof ApiSvcRunESBalanceReportPreview200Response
   */
  total: ApiSvcAssetSummary;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRunESBalanceReportPreview200Response
   */
  stack?: string;
}
/**
 *
 * @export
 * @interface ApiSvcRunRelatedOrgsTransctionsReportPreview200Response
 */
export interface ApiSvcRunRelatedOrgsTransctionsReportPreview200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRunRelatedOrgsTransctionsReportPreview200Response
   */
  nextPageToken: string;
  /**
   *
   * @type {Array<ApiSvcRelatedOrgsTransactionsLine>}
   * @memberof ApiSvcRunRelatedOrgsTransctionsReportPreview200Response
   */
  items: Array<ApiSvcRelatedOrgsTransactionsLine>;
}
/**
 *
 * @export
 * @interface ApiSvcRunReportParams
 */
export interface ApiSvcRunReportParams {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRunReportParams
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRunReportParams
   */
  to: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRunReportParams
   */
  walletId: string;
}
/**
 *
 * @export
 * @interface ApiSvcRunReportRequest
 */
export interface ApiSvcRunReportRequest {
  /**
   *
   * @type {ApiSvcRunScenarioParams}
   * @memberof ApiSvcRunReportRequest
   */
  gainLoss?: ApiSvcRunScenarioParams;
  /**
   *
   * @type {ApiSvcRelatedOrgsBalanceReportParams}
   * @memberof ApiSvcRunReportRequest
   */
  relatedOrgsBalanceReportParams?: ApiSvcRelatedOrgsBalanceReportParams;
  /**
   *
   * @type {ApiSvcRelatedOrgsTransactionsReportParams}
   * @memberof ApiSvcRunReportRequest
   */
  relatedOrgsTransactionsReportParams?: ApiSvcRelatedOrgsTransactionsReportParams;
}
/**
 *
 * @export
 * @interface ApiSvcRunReportRequestDTO
 */
export interface ApiSvcRunReportRequestDTO {
  /**
   *
   * @type {ApiSvcReportRunType}
   * @memberof ApiSvcRunReportRequestDTO
   */
  reportType: ApiSvcReportRunType;
  /**
   *
   * @type {Array<ApiSvcReportInput>}
   * @memberof ApiSvcRunReportRequestDTO
   */
  inputs: Array<ApiSvcReportInput>;
}

/**
 *
 * @export
 * @interface ApiSvcRunScenarioParams
 */
export interface ApiSvcRunScenarioParams {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRunScenarioParams
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRunScenarioParams
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcRunScenarioParams
   */
  endDate?: string;
  /**
   *
   * @type {ApiSvcTaxStrategyTypeDTO}
   * @memberof ApiSvcRunScenarioParams
   */
  strategy?: ApiSvcTaxStrategyTypeDTO;
  /**
   *
   * @type {ApiSvcTaxConfigInputDTO}
   * @memberof ApiSvcRunScenarioParams
   */
  config?: ApiSvcTaxConfigInputDTO;
  /**
   *
   * @type {Array<ApiSvcExchangeRateOverrideDTO>}
   * @memberof ApiSvcRunScenarioParams
   */
  overrideExchangeRates?: Array<ApiSvcExchangeRateOverrideDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRunScenarioParams
   */
  impair?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcRunScenarioParams
   */
  ignoreNFTs?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcRunSharedOrgsBalancesReportPreview200Response
 */
export interface ApiSvcRunSharedOrgsBalancesReportPreview200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcRunSharedOrgsBalancesReportPreview200Response
   */
  nextPageToken: string;
  /**
   *
   * @type {Array<ApiSvcRelatedOrgsBalanceLine>}
   * @memberof ApiSvcRunSharedOrgsBalancesReportPreview200Response
   */
  items: Array<ApiSvcRelatedOrgsBalanceLine>;
}
/**
 *
 * @export
 * @interface ApiSvcSSODTO
 */
export interface ApiSvcSSODTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSSODTO
   */
  idpSignOnUrl: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSSODTO
   */
  idpIssuer: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSSODTO
   */
  idpCertificate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSSODTO
   */
  defaultRoleId?: string;
  /**
   * \'perOrg\' (per-org SP endpoints) or \'generic\' (shared SP). Absent = legacy generic.
   * @type {string}
   * @memberof ApiSvcSSODTO
   */
  endpointMode?: ApiSvcSSODTOEndpointModeEnum;
}

export const ApiSvcSSODTOEndpointModeEnum = {
  PerOrg: 'perOrg',
  Generic: 'generic',
} as const;

export type ApiSvcSSODTOEndpointModeEnum =
  typeof ApiSvcSSODTOEndpointModeEnum[keyof typeof ApiSvcSSODTOEndpointModeEnum];

/**
 *
 * @export
 * @interface ApiSvcSamlProvisionRequest
 */
export interface ApiSvcSamlProvisionRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSamlProvisionRequest
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSamlProvisionRequest
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSamlProvisionRequest
   */
  assertedIdentity: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSamlProvisionRequest
   */
  roleId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcScimCreateRequest
 */
export interface ApiSvcScimCreateRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcScimCreateRequest
   */
  schemas?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimCreateRequest
   */
  userName: string;
  /**
   *
   * @type {ApiSvcName}
   * @memberof ApiSvcScimCreateRequest
   */
  name: ApiSvcName;
  /**
   *
   * @type {Array<ApiSvcScimEmail>}
   * @memberof ApiSvcScimCreateRequest
   */
  emails: Array<ApiSvcScimEmail>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimCreateRequest
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimCreateRequest
   */
  locale?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimCreateRequest
   */
  externalId: string;
  /**
   *
   * @type {Array<any>}
   * @memberof ApiSvcScimCreateRequest
   */
  groups?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimCreateRequest
   */
  password?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcScimCreateRequest
   */
  active: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimCreateRequest
   */
  title?: string;
  /**
   *
   * @type {ApiSvcIetfEnterpriseUser}
   * @memberof ApiSvcScimCreateRequest
   */
  'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User'?: ApiSvcIetfEnterpriseUser;
}
/**
 *
 * @export
 * @interface ApiSvcScimEmail
 */
export interface ApiSvcScimEmail {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcScimEmail
   */
  primary: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimEmail
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimEmail
   */
  type?: string;
}
/**
 *
 * @export
 * @interface ApiSvcScimGetUsers200Response
 */
export interface ApiSvcScimGetUsers200Response {
  /**
   *
   * @type {Array<any>}
   * @memberof ApiSvcScimGetUsers200Response
   */
  Resources: Array<any>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcScimGetUsers200Response
   */
  itemsPerPage: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcScimGetUsers200Response
   */
  startIndex: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcScimGetUsers200Response
   */
  totalResults: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcScimGetUsers200Response
   */
  schemas: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcScimPatchOperation
 */
export interface ApiSvcScimPatchOperation {
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimPatchOperation
   */
  op: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimPatchOperation
   */
  path?: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcScimPatchOperation
   */
  value?: any;
}
/**
 *
 * @export
 * @interface ApiSvcScimPatchRequest
 */
export interface ApiSvcScimPatchRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcScimPatchRequest
   */
  schemas: Array<string>;
  /**
   *
   * @type {Array<ApiSvcScimPatchOperation>}
   * @memberof ApiSvcScimPatchRequest
   */
  Operations: Array<ApiSvcScimPatchOperation>;
}
/**
 *
 * @export
 * @interface ApiSvcScimUpdateRequest
 */
export interface ApiSvcScimUpdateRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcScimUpdateRequest
   */
  schemas?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateRequest
   */
  displayName?: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcScimUpdateRequest
   */
  meta?: any;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateRequest
   */
  locale?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateRequest
   */
  externalId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateRequest
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateRequest
   */
  userName: string;
  /**
   *
   * @type {ApiSvcName}
   * @memberof ApiSvcScimUpdateRequest
   */
  name: ApiSvcName;
  /**
   *
   * @type {Array<ApiSvcScimEmail>}
   * @memberof ApiSvcScimUpdateRequest
   */
  emails: Array<ApiSvcScimEmail>;
  /**
   *
   * @type {Array<any>}
   * @memberof ApiSvcScimUpdateRequest
   */
  groups: Array<any>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcScimUpdateRequest
   */
  active: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcScimUpdateUser200Response
 */
export interface ApiSvcScimUpdateUser200Response {
  /**
   *
   * @type {ApiSvcScimUpdateUser200ResponseMeta}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  meta: ApiSvcScimUpdateUser200ResponseMeta;
  /**
   *
   * @type {any}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  roles: any;
  /**
   *
   * @type {Array<any>}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  groups: Array<any>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  active: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  locale: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  displayName: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  emails: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  externalId: any;
  /**
   *
   * @type {ApiSvcCreateUser201ResponseAnyOfName}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  name: ApiSvcCreateUser201ResponseAnyOfName;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  id: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcScimUpdateUser200Response
   */
  schemas: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcScimUpdateUser200ResponseMeta
 */
export interface ApiSvcScimUpdateUser200ResponseMeta {
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateUser200ResponseMeta
   */
  organization: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUpdateUser200ResponseMeta
   */
  resourceType: string;
}
/**
 *
 * @export
 * @interface ApiSvcScimUserSchema
 */
export interface ApiSvcScimUserSchema {
  /**
   *
   * @type {ApiSvcScimUserSchemaMeta}
   * @memberof ApiSvcScimUserSchema
   */
  meta: ApiSvcScimUserSchemaMeta;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcScimUserSchema
   */
  roles: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcScimUserSchema
   */
  groups: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcScimUserSchema
   */
  active: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchema
   */
  locale?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchema
   */
  displayName: string;
  /**
   *
   * @type {Array<ApiSvcScimUserSchemaEmailsInner>}
   * @memberof ApiSvcScimUserSchema
   */
  emails: Array<ApiSvcScimUserSchemaEmailsInner>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchema
   */
  externalId?: string;
  /**
   *
   * @type {ApiSvcCreateUser201ResponseAnyOfName}
   * @memberof ApiSvcScimUserSchema
   */
  name: ApiSvcCreateUser201ResponseAnyOfName;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchema
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchema
   */
  id: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcScimUserSchema
   */
  schemas: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcScimUserSchemaEmailsInner
 */
export interface ApiSvcScimUserSchemaEmailsInner {
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchemaEmailsInner
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchemaEmailsInner
   */
  value: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcScimUserSchemaEmailsInner
   */
  primary: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcScimUserSchemaMeta
 */
export interface ApiSvcScimUserSchemaMeta {
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchemaMeta
   */
  version?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchemaMeta
   */
  location?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchemaMeta
   */
  lastModified?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchemaMeta
   */
  created?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchemaMeta
   */
  organization: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchemaMeta
   */
  resourceType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcScimUserSchemaMeta
   */
  remoteSystem?: string;
}
/**
 *
 * @export
 * @interface ApiSvcSellTxnDetailsDTO
 */
export interface ApiSvcSellTxnDetailsDTO {
  /**
   *
   * @type {number}
   * @memberof ApiSvcSellTxnDetailsDTO
   */
  dateTimeSec: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSellTxnDetailsDTO
   */
  source: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSellTxnDetailsDTO
   */
  sourceAmount: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSellTxnDetailsDTO
   */
  target: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSellTxnDetailsDTO
   */
  targetAmount: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSellTxnDetailsDTO
   */
  exchangeRate: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSellTxnDetailsDTO
   */
  proceedsAccount?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSellTxnDetailsDTO
   */
  fee?: number;
}
/**
 *
 * @export
 * @interface ApiSvcSendNotificationEmailRequest
 */
export interface ApiSvcSendNotificationEmailRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSendNotificationEmailRequest
   */
  to: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendNotificationEmailRequest
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendNotificationEmailRequest
   */
  htmlBody: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendNotificationEmailRequest
   */
  plainBody?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendNotificationEmailRequest
   */
  idempotencyKey?: string;
}
/**
 *
 * @export
 * @interface ApiSvcSendPennyTestEmailV2
 */
export interface ApiSvcSendPennyTestEmailV2 {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendPennyTestEmailV2
   */
  businessName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendPennyTestEmailV2
   */
  requestingUserId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendPennyTestEmailV2
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendPennyTestEmailV2
   */
  requestId: string;
}
/**
 *
 * @export
 * @interface ApiSvcSendRemittanceAdviceDTO
 */
export interface ApiSvcSendRemittanceAdviceDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  network?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  templateVersion?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  exchangeRate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  tokenAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  tokenTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  paidAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  toAddress: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  txnHash: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  ccAddresses?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTO
   */
  email: string;
}
/**
 *
 * @export
 * @interface ApiSvcSendRemittanceAdviceDTOV1
 */
export interface ApiSvcSendRemittanceAdviceDTOV1 {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  network?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  remittanceLogoUrl: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  templateVersion?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  exchangeRate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  tokenAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  tokenTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  paidAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  toAddress: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  txnHash: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  ccAddresses?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendRemittanceAdviceDTOV1
   */
  email: string;
}
/**
 *
 * @export
 * @interface ApiSvcSendVendorInvitationRequest
 */
export interface ApiSvcSendVendorInvitationRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendVendorInvitationRequest
   */
  businessName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendVendorInvitationRequest
   */
  invitationCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendVendorInvitationRequest
   */
  inviteeEmail: string;
}
/**
 *
 * @export
 * @interface ApiSvcSendWhitelistnotificationEmailRequest
 */
export interface ApiSvcSendWhitelistnotificationEmailRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSendWhitelistnotificationEmailRequest
   */
  emails: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendWhitelistnotificationEmailRequest
   */
  requesterName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSendWhitelistnotificationEmailRequest
   */
  whitelistedAddress: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSftpPathAction = {
  Push: 'Push',
  Pull: 'Pull',
} as const;

export type ApiSvcSftpPathAction = typeof ApiSvcSftpPathAction[keyof typeof ApiSvcSftpPathAction];

/**
 *
 * @export
 * @interface ApiSvcSftpPathAssignmentDTO
 */
export interface ApiSvcSftpPathAssignmentDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathAssignmentDTO
   */
  checkListRunId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathAssignmentDTO
   */
  reportId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathAssignmentDTO
   */
  sftpPathId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSftpPathAssignmentDTO
   */
  assignedAt: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathAssignmentDTO
   */
  assignedBy?: string;
}
/**
 *
 * @export
 * @interface ApiSvcSftpPathDTO
 */
export interface ApiSvcSftpPathDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathDTO
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathDTO
   */
  connectionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathDTO
   */
  serverPath: string;
  /**
   *
   * @type {ApiSvcSftpPathAction}
   * @memberof ApiSvcSftpPathDTO
   */
  action: ApiSvcSftpPathAction;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSftpPathDTO
   */
  createdAt: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathDTO
   */
  createdBy?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSftpPathDTO
   */
  updatedAt?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpPathDTO
   */
  updatedBy?: string;
}

/**
 *
 * @export
 * @interface ApiSvcSftpToken
 */
export interface ApiSvcSftpToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpToken
   */
  id?: string;
  /**
   *
   * @type {ApiSvcTokenTypes}
   * @memberof ApiSvcSftpToken
   */
  type: ApiSvcTokenTypes;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSftpToken
   */
  sandbox?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpToken
   */
  host: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpToken
   */
  user: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpToken
   */
  port: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpToken
   */
  password?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpToken
   */
  pemKey?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpToken
   */
  pemPassword?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSftpToken
   */
  pgpPublicKey?: string;
}

/**
 *
 * @export
 * @interface ApiSvcSimpleAmountDTO
 */
export interface ApiSvcSimpleAmountDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleAmountDTO
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleAmountDTO
   */
  coin: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleAmountDTO
   */
  unit: string;
}
/**
 *
 * @export
 * @interface ApiSvcSimpleCategorizationAction
 */
export interface ApiSvcSimpleCategorizationAction {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSimpleCategorizationAction
   */
  labels?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSimpleCategorizationAction
   */
  ignoreFailPricing?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCategorizationAction
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCategorizationAction
   */
  feeContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCategorizationAction
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCategorizationAction
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCategorizationAction
   */
  type: ApiSvcSimpleCategorizationActionTypeEnum;
}

export const ApiSvcSimpleCategorizationActionTypeEnum = {
  SimpleCategorization: 'SimpleCategorization',
} as const;

export type ApiSvcSimpleCategorizationActionTypeEnum =
  typeof ApiSvcSimpleCategorizationActionTypeEnum[keyof typeof ApiSvcSimpleCategorizationActionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcSimpleCategorizationDTO
 */
export interface ApiSvcSimpleCategorizationDTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeSimple}
   * @memberof ApiSvcSimpleCategorizationDTO
   */
  type: ApiSvcCategorizationTypeSimple;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcSimpleCategorizationDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSimpleCategorizationDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCategorizationDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCategorizationDTO
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCategorizationDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCategorizationDTO
   */
  contactId: string;
  /**
   *
   * @type {ApiSvcSimpleCostBasisDTO}
   * @memberof ApiSvcSimpleCategorizationDTO
   */
  costBasis: ApiSvcSimpleCostBasisDTO;
  /**
   *
   * @type {ApiSvcSimpleFeeDTO}
   * @memberof ApiSvcSimpleCategorizationDTO
   */
  fee?: ApiSvcSimpleFeeDTO;
}

/**
 *
 * @export
 * @interface ApiSvcSimpleCostBasisDTO
 */
export interface ApiSvcSimpleCostBasisDTO {
  /**
   *
   * @type {ApiSvcCostBasisType}
   * @memberof ApiSvcSimpleCostBasisDTO
   */
  costBasisType: ApiSvcCostBasisType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCostBasisDTO
   */
  cost: string;
  /**
   *
   * @type {ApiSvcFiat}
   * @memberof ApiSvcSimpleCostBasisDTO
   */
  currency: ApiSvcFiat;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCostBasisDTO
   */
  exchangeRate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCostBasisDTO
   */
  notes?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleCostBasisDTO
   */
  invoiceId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcSimpleFeeDTO
 */
export interface ApiSvcSimpleFeeDTO {
  /**
   *
   * @type {ApiSvcFiat}
   * @memberof ApiSvcSimpleFeeDTO
   */
  fiat: ApiSvcFiat;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleFeeDTO
   */
  amount: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSimpleQueues = {
  TransactionSync: 'transaction-sync',
  RuleProcessing: 'rule-processing',
  AutomaticRuleProcessing: 'automatic-rule-processing',
} as const;

export type ApiSvcSimpleQueues = typeof ApiSvcSimpleQueues[keyof typeof ApiSvcSimpleQueues];

/**
 *
 * @export
 * @interface ApiSvcSimpleSplitCategorizationAction
 */
export interface ApiSvcSimpleSplitCategorizationAction {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSimpleSplitCategorizationAction
   */
  labels?: Array<string>;
  /**
   *
   * @type {Array<ApiSvcSplit>}
   * @memberof ApiSvcSimpleSplitCategorizationAction
   */
  feeSplits?: Array<ApiSvcSplit>;
  /**
   *
   * @type {Array<ApiSvcSplit>}
   * @memberof ApiSvcSimpleSplitCategorizationAction
   */
  splits: Array<ApiSvcSplit>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleSplitCategorizationAction
   */
  type: ApiSvcSimpleSplitCategorizationActionTypeEnum;
}

export const ApiSvcSimpleSplitCategorizationActionTypeEnum = {
  SimpleSplitCategorization: 'SimpleSplitCategorization',
} as const;

export type ApiSvcSimpleSplitCategorizationActionTypeEnum =
  typeof ApiSvcSimpleSplitCategorizationActionTypeEnum[keyof typeof ApiSvcSimpleSplitCategorizationActionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcSimpleTradeTxnDetailsDTO
 */
export interface ApiSvcSimpleTradeTxnDetailsDTO {
  /**
   *
   * @type {ApiSvcAmountDTO}
   * @memberof ApiSvcSimpleTradeTxnDetailsDTO
   */
  acquired: ApiSvcAmountDTO;
  /**
   *
   * @type {ApiSvcAmountDTO}
   * @memberof ApiSvcSimpleTradeTxnDetailsDTO
   */
  disposed: ApiSvcAmountDTO;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcSimpleTradeTxnDetailsDTO
   */
  acquiredCost: ApiSvcCostBasisDTO;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcSimpleTradeTxnDetailsDTO
   */
  disposedCost: ApiSvcCostBasisDTO;
  /**
   *
   * @type {ApiSvcDetailedFeeDTO}
   * @memberof ApiSvcSimpleTradeTxnDetailsDTO
   */
  fee?: ApiSvcDetailedFeeDTO;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSimpleTradeTxnDetailsDTO
   */
  systemCreated: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcSimpleTransactionDTO
 */
export interface ApiSvcSimpleTransactionDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleTransactionDTO
   */
  id: string;
  /**
   *
   * @type {ApiSvcExchangeRateDetails}
   * @memberof ApiSvcSimpleTransactionDTO
   */
  exchangeRates?: ApiSvcExchangeRateDetails;
  /**
   *
   * @type {ApiSvcTxnType}
   * @memberof ApiSvcSimpleTransactionDTO
   */
  typeGuess?: ApiSvcTxnType;
}

/**
 *
 * @export
 * @interface ApiSvcSimpleTransactionInput
 */
export interface ApiSvcSimpleTransactionInput {
  /**
   *
   * @type {ApiSvcFeeItemInput}
   * @memberof ApiSvcSimpleTransactionInput
   */
  fee?: ApiSvcFeeItemInput | null;
  /**
   *
   * @type {Array<ApiSvcExchangeRateInput>}
   * @memberof ApiSvcSimpleTransactionInput
   */
  exchangeRates?: Array<ApiSvcExchangeRateInput> | null;
  /**
   *
   * @type {ApiSvcCostBasisInput}
   * @memberof ApiSvcSimpleTransactionInput
   */
  costBasis: ApiSvcCostBasisInput;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleTransactionInput
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleTransactionInput
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleTransactionInput
   */
  description: string;
}
/**
 *
 * @export
 * @interface ApiSvcSimpleTxnDetailsDTO
 */
export interface ApiSvcSimpleTxnDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleTxnDetailsDTO
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleTxnDetailsDTO
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleTxnDetailsDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSimpleTxnDetailsDTO
   */
  description?: string;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcSimpleTxnDetailsDTO
   */
  costBasis: ApiSvcCostBasisDTO;
}
/**
 * Slug variable type for templated labels. Only meaningful when `allowSlugs` is true; pinned to one of these three values per Pat White\'s confirmation on 2026-05-29 — no `Boolean`/`Date` for now.    `String`      — any text value   `Integer`     — must parse as a whole number   `StringRegex` — text validated against `slugValidationPattern`
 * @export
 * @enum {string}
 */

export const ApiSvcSlugType = {
  String: 'String',
  Integer: 'Integer',
  StringRegex: 'StringRegex',
} as const;

export type ApiSvcSlugType = typeof ApiSvcSlugType[keyof typeof ApiSvcSlugType];

/**
 *
 * @export
 * @interface ApiSvcSodaLine
 */
export interface ApiSvcSodaLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaLine
   */
  walletRoleId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaLine
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaLine
   */
  walletName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaLine
   */
  assetId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaLine
   */
  assetTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaLine
   */
  quantity: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaLine
   */
  fairMarketValue: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaLine
   */
  bookBalance: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaLine
   */
  exchangeRate: string;
}
/**
 *
 * @export
 * @interface ApiSvcSodaReportResponse
 */
export interface ApiSvcSodaReportResponse {
  /**
   *
   * @type {number}
   * @memberof ApiSvcSodaReportResponse
   */
  reportAsOfSEC: number;
  /**
   *
   * @type {Array<ApiSvcSodaLine>}
   * @memberof ApiSvcSodaReportResponse
   */
  lines: Array<ApiSvcSodaLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaReportResponse
   */
  inventoryViewId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSodaReportResponse
   */
  runId?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSortDirection = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;

export type ApiSvcSortDirection = typeof ApiSvcSortDirection[keyof typeof ApiSvcSortDirection];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSources = {
  Custom: 'custom',
  Binance: 'binance',
  CoinbasePro: 'coinbasePro',
  Bitfinex: 'bitfinex',
  Kraken: 'kraken',
  ItBit: 'itBit',
  Bitstamp: 'bitstamp',
  BitGo: 'bitGo',
  Nydig: 'nydig',
  Bittrex: 'bittrex',
  Ftx: 'ftx',
  CoinbaseCustody: 'coinbaseCustody',
  Sfox: 'sfox',
  PrimeTrust: 'primeTrust',
  CoinbaseCommerce: 'coinbaseCommerce',
  Anchorage: 'anchorage',
  CoinbasePrime: 'coinbasePrime',
  Gemini: 'gemini',
  Fireblocks: 'fireblocks',
  CryptoDotCom: 'cryptoDotCom',
  Circle: 'Circle',
  Foundry: 'foundry',
  Loopring: 'loopring',
  Celo: 'celo',
  Polygon: 'polygon',
  Avalanche: 'avalanche',
  Stx: 'stx',
  Heco: 'heco',
  Bsc: 'bsc',
  Klay: 'klay',
  Flow: 'flow',
  Mina: 'mina',
  Sol: 'sol',
  Op: 'op',
  CoinbaseRetail: 'coinbaseRetail',
  Apt: 'apt',
} as const;

export type ApiSvcSources = typeof ApiSvcSources[keyof typeof ApiSvcSources];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSpecialMetadataType = {
  NetsuiteCustomRecordWallet: 'netsuite.customRecord.wallet',
} as const;

export type ApiSvcSpecialMetadataType = typeof ApiSvcSpecialMetadataType[keyof typeof ApiSvcSpecialMetadataType];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSpecialMetadataTypeNetsuiteWallet = {
  NetsuiteCustomRecordWallet: 'netsuite.customRecord.wallet',
} as const;

export type ApiSvcSpecialMetadataTypeNetsuiteWallet =
  typeof ApiSvcSpecialMetadataTypeNetsuiteWallet[keyof typeof ApiSvcSpecialMetadataTypeNetsuiteWallet];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSpecificIdentificationCoinSpendingStrategy = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export type ApiSvcSpecificIdentificationCoinSpendingStrategy =
  typeof ApiSvcSpecificIdentificationCoinSpendingStrategy[keyof typeof ApiSvcSpecificIdentificationCoinSpendingStrategy];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSpecificIdentificationSelectionPreference = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;

export type ApiSvcSpecificIdentificationSelectionPreference =
  typeof ApiSvcSpecificIdentificationSelectionPreference[keyof typeof ApiSvcSpecificIdentificationSelectionPreference];

/**
 *
 * @export
 * @interface ApiSvcSpecificIdentificationSelectionStrategy
 */
export interface ApiSvcSpecificIdentificationSelectionStrategy {
  /**
   *
   * @type {ApiSvcSpecificIdentificationCoinSpendingStrategy}
   * @memberof ApiSvcSpecificIdentificationSelectionStrategy
   */
  spendingStrategy: ApiSvcSpecificIdentificationCoinSpendingStrategy;
  /**
   *
   * @type {ApiSvcSpecificIdentificationSelectionPreference}
   * @memberof ApiSvcSpecificIdentificationSelectionStrategy
   */
  selectionPreference: ApiSvcSpecificIdentificationSelectionPreference;
}

/**
 *
 * @export
 * @interface ApiSvcSplit
 */
export interface ApiSvcSplit {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSplit
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplit
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplit
   */
  contactId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSplit
   */
  percentage?: number;
}
/**
 * Why a child cannot take part in an unsplit.  - `closed` / `suspended` mirror the state guard in unsplitTransaction. - `different-split-run` is a child whose metadata points at another parent or   another run. unsplitTransaction rejects those too. - `missing` is a child the split recorded that no longer resolves anywhere,   normally an independently deleted transaction. Terminal: because unsplit   requires an exact child count, the group can never be unsplit. - `not-materialized` is a child the event store still knows about but that   the read model has not caught up with. Transient, and worth presenting   differently from `missing`, since retrying later will succeed.
 * @export
 * @enum {string}
 */

export const ApiSvcSplitGroupBlockReason = {
  Closed: 'closed',
  Suspended: 'suspended',
  DifferentSplitRun: 'different-split-run',
  Missing: 'missing',
  NotMaterialized: 'not-materialized',
} as const;

export type ApiSvcSplitGroupBlockReason = typeof ApiSvcSplitGroupBlockReason[keyof typeof ApiSvcSplitGroupBlockReason];

/**
 *
 * @export
 * @interface ApiSvcSplitGroupChildDTO
 */
export interface ApiSvcSplitGroupChildDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitGroupChildDTO
   */
  txnId: string;
  /**
   * False when the child did not resolve in the read model.
   * @type {boolean}
   * @memberof ApiSvcSplitGroupChildDTO
   */
  found: boolean;
  /**
   *
   * @type {ApiSvcTransactionQueryDTO}
   * @memberof ApiSvcSplitGroupChildDTO
   */
  transaction?: ApiSvcTransactionQueryDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitGroupChildDTO
   */
  state?: string;
  /**
   * True when this child would cause unsplitTransaction to reject the whole operation. Unsplit is all-or-nothing, so a single blocked child stops it.
   * @type {boolean}
   * @memberof ApiSvcSplitGroupChildDTO
   */
  blocksUnsplit: boolean;
  /**
   *
   * @type {ApiSvcSplitGroupBlockReason}
   * @memberof ApiSvcSplitGroupChildDTO
   */
  blockReason?: ApiSvcSplitGroupBlockReason;
  /**
   * True when unsplitting would discard categorization work. Categorized children are Open, so unsplit deletes them without complaint; the caller needs to be able to say so before the user commits.
   * @type {boolean}
   * @memberof ApiSvcSplitGroupChildDTO
   */
  losesCategorization: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcSplitGroupResponseDTO
 */
export interface ApiSvcSplitGroupResponseDTO {
  /**
   * The transaction the split was performed on, restored by an unsplit.
   * @type {string}
   * @memberof ApiSvcSplitGroupResponseDTO
   */
  parentTxnId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitGroupResponseDTO
   */
  parentState?: string;
  /**
   *
   * @type {ApiSvcTransactionQueryDTO}
   * @memberof ApiSvcSplitGroupResponseDTO
   */
  parentTransaction?: ApiSvcTransactionQueryDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitGroupResponseDTO
   */
  splitRunId?: string;
  /**
   * How many children the split recorded: from child metadata when a child was asked about, and from the parent\'s split pointers when the parent was, so the answer does not depend on which member of the group you pass.
   * @type {number}
   * @memberof ApiSvcSplitGroupResponseDTO
   */
  expectedChildCount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSplitGroupResponseDTO
   */
  missingChildCount: number;
  /**
   *
   * @type {Array<ApiSvcSplitGroupChildDTO>}
   * @memberof ApiSvcSplitGroupResponseDTO
   */
  children: Array<ApiSvcSplitGroupChildDTO>;
  /**
   * Whether an unsplit is expected to succeed.  Necessary but not sufficient. This covers every precondition that can be evaluated from a read: child count, blocked children, and children on another parent or run. It cannot cover unsplitTransaction\'s post-command projection assertions, which are only known once the commands are built. Callers must still handle a failed unsplit rather than treating `true` as a guarantee.
   * @type {boolean}
   * @memberof ApiSvcSplitGroupResponseDTO
   */
  canUnsplit: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcSplitTransactionDTO
 */
export interface ApiSvcSplitTransactionDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitTransactionDTO
   */
  txnId: string;
  /**
   *
   * @type {Array<ApiSvcSplitTransactionLineDTO>}
   * @memberof ApiSvcSplitTransactionDTO
   */
  splits: Array<ApiSvcSplitTransactionLineDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcSplitTransactionLineDTO
 */
export interface ApiSvcSplitTransactionLineDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitTransactionLineDTO
   */
  amount: string;
}
/**
 *
 * @export
 * @interface ApiSvcSplitTransactionResponseDTO
 */
export interface ApiSvcSplitTransactionResponseDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitTransactionResponseDTO
   */
  sourceTxnId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSplitTransactionResponseDTO
   */
  childTxnIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcSplitTransactionV2200Response
 */
export interface ApiSvcSplitTransactionV2200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitTransactionV2200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitTransactionV2200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitTransactionV2200Response
   */
  traceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSplitTransactionV2200Response
   */
  sourceTxnId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSplitTransactionV2200Response
   */
  childTxnIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcSso200Response
 */
export interface ApiSvcSso200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSso200Response
   */
  idpSignOnUrl: string;
}
/**
 * Which SAML SP endpoints (entity id / Issuer and ACS / Reply URL) the auth service uses for an org. \'perOrg\' uses per-org URLs; \'generic\' uses the single shared SP. Per-org is OPT-IN — an absent value always means \'generic\' so existing IdP registrations keep working. See {@link ssoEndpointModeOrDefault}.
 * @export
 * @enum {string}
 */

export const ApiSvcSsoEndpointMode = {
  PerOrg: 'perOrg',
  Generic: 'generic',
} as const;

export type ApiSvcSsoEndpointMode = typeof ApiSvcSsoEndpointMode[keyof typeof ApiSvcSsoEndpointMode];

/**
 *
 * @export
 * @interface ApiSvcSsoSettings
 */
export interface ApiSvcSsoSettings {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSsoSettings
   */
  use: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSsoSettings
   */
  idpSignOnUrl: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSsoSettings
   */
  idpIssuer: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSsoSettings
   */
  idpCertificate: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSsoSettings
   */
  requireSso?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSsoSettings
   */
  defaultRoleId?: string;
  /**
   *
   * @type {ApiSvcSsoEndpointMode}
   * @memberof ApiSvcSsoSettings
   */
  endpointMode?: ApiSvcSsoEndpointMode;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcStages = {
  NeedsCategorization: 'needs-categorization',
  ToBeSynced: 'to-be-synced',
  Complete: 'complete',
  Ignored: 'ignored',
  Deleted: 'deleted',
} as const;

export type ApiSvcStages = typeof ApiSvcStages[keyof typeof ApiSvcStages];

/**
 *
 * @export
 * @interface ApiSvcStakingTransactionInput
 */
export interface ApiSvcStakingTransactionInput {
  /**
   *
   * @type {ApiSvcStakingTxnType}
   * @memberof ApiSvcStakingTransactionInput
   */
  stakingTxnType?: ApiSvcStakingTxnType | null;
  /**
   *
   * @type {ApiSvcCostBasisInput}
   * @memberof ApiSvcStakingTransactionInput
   */
  costBasis: ApiSvcCostBasisInput;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStakingTransactionInput
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStakingTransactionInput
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStakingTransactionInput
   */
  description: string;
}

/**
 *
 * @export
 * @interface ApiSvcStakingTxnDetailsDTO
 */
export interface ApiSvcStakingTxnDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcStakingTxnDetailsDTO
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStakingTxnDetailsDTO
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStakingTxnDetailsDTO
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStakingTxnDetailsDTO
   */
  description?: string;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcStakingTxnDetailsDTO
   */
  costBasis: ApiSvcCostBasisDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStakingTxnDetailsDTO
   */
  stakingTxnType: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcStakingTxnType = {
  Staking: 'Staking',
  Unstaking: 'Unstaking',
  Balancing: 'Balancing',
} as const;

export type ApiSvcStakingTxnType = typeof ApiSvcStakingTxnType[keyof typeof ApiSvcStakingTxnType];

/**
 *
 * @export
 * @interface ApiSvcStart200Response
 */
export interface ApiSvcStart200Response {
  /**
   *
   * @type {any}
   * @memberof ApiSvcStart200Response
   */
  jobRunId: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcStart200Response
   */
  correlationId: any;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStart200Response
   */
  executionId: string;
}
/**
 *
 * @export
 * @interface ApiSvcStart200ResponseAnyOf
 */
export interface ApiSvcStart200ResponseAnyOf {
  /**
   *
   * @type {any}
   * @memberof ApiSvcStart200ResponseAnyOf
   */
  jobRunId: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcStart200ResponseAnyOf
   */
  correlationId: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcStart200ResponseAnyOf
   */
  executionId: any;
}
/**
 *
 * @export
 * @interface ApiSvcStart200ResponseAnyOf1
 */
export interface ApiSvcStart200ResponseAnyOf1 {
  /**
   *
   * @type {any}
   * @memberof ApiSvcStart200ResponseAnyOf1
   */
  jobRunId?: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcStart200ResponseAnyOf1
   */
  correlationId: any;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStart200ResponseAnyOf1
   */
  executionId: string;
}
/**
 *
 * @export
 * @interface ApiSvcStartingBalanceDetail
 */
export interface ApiSvcStartingBalanceDetail {
  /**
   *
   * @type {string}
   * @memberof ApiSvcStartingBalanceDetail
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcStartingBalanceDetail
   */
  averageCost: string;
}
/**
 *
 * @export
 * @interface ApiSvcSubTransaction
 */
export interface ApiSvcSubTransaction {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSubTransaction
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSubTransaction
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSubTransaction
   */
  to: string;
  /**
   *
   * @type {ApiSvcTxnCryptoAmount}
   * @memberof ApiSvcSubTransaction
   */
  amount: ApiSvcTxnCryptoAmount;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSubTransaction
   */
  isFee?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSubTransaction
   */
  fromTokenAccount?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSubTransaction
   */
  toTokenAccount?: string;
}
/**
 *
 * @export
 * @interface ApiSvcSubscriptionDetailsDTO
 */
export interface ApiSvcSubscriptionDetailsDTO {
  /**
   *
   * @type {number}
   * @memberof ApiSvcSubscriptionDetailsDTO
   */
  accountingSeats: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSubscriptionDetailsDTO
   */
  walletSeats: number;
}
/**
 *
 * @export
 * @interface ApiSvcSubsidiary
 */
export interface ApiSvcSubsidiary {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSubsidiary
   */
  id: string;
  /**
   *
   * @type {ApiSvcSubsidiaryRelationship}
   * @memberof ApiSvcSubsidiary
   */
  subType: ApiSvcSubsidiaryRelationship;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSubsidiary
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSubsidiary
   */
  parentSubsidiaryId?: string;
  /**
   *
   * @type {ApiSvcFiat}
   * @memberof ApiSvcSubsidiary
   */
  functionalCurrency?: ApiSvcFiat;
  /**
   * connectionId.remoteSubsidiaryId, this is saved in metadata
   * @type {string}
   * @memberof ApiSvcSubsidiary
   */
  accountingConnectionSubsidiaryId?: string;
  /**
   * this is the standard accounting connection id
   * @type {string}
   * @memberof ApiSvcSubsidiary
   */
  accountingConnectionId?: string;
  /**
   * Bitwave ID for the digital asset account, not an account code
   * @type {string}
   * @memberof ApiSvcSubsidiary
   */
  digitalAssetAccountCode?: string;
  /**
   * Bitwave ID for the digital asset clearing account, not an account code
   * @type {string}
   * @memberof ApiSvcSubsidiary
   */
  digitalAssetClearingAccountCode?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSubsidiary
   */
  deleted?: boolean;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcSubsidiary
   */
  metadata?: object;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSubsidiaryAccess = {
  All: 'all',
  UserOrg: 'user-org',
  UserOrgAndChildren: 'user-org-and-children',
  SingleOrg: 'single-org',
} as const;

export type ApiSvcSubsidiaryAccess = typeof ApiSvcSubsidiaryAccess[keyof typeof ApiSvcSubsidiaryAccess];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSubsidiaryRelationship = {
  Fbo: 'fbo',
  Subsidiary: 'subsidiary',
  Root: 'root',
} as const;

export type ApiSvcSubsidiaryRelationship =
  typeof ApiSvcSubsidiaryRelationship[keyof typeof ApiSvcSubsidiaryRelationship];

/**
 *
 * @export
 * @interface ApiSvcSuccessPricedExchangeRateDTO
 */
export interface ApiSvcSuccessPricedExchangeRateDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSuccessPricedExchangeRateDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSuccessPricedExchangeRateDTO
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSuccessPricedExchangeRateDTO
   */
  to: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeSuccess}
   * @memberof ApiSvcSuccessPricedExchangeRateDTO
   */
  type: ApiSvcExchangeRateTypeSuccess;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSuccessPricedExchangeRateDTO
   */
  priceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSuccessPricedExchangeRateDTO
   */
  rate: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSuspendedTransactionStates = {
  Ignored: 'ignored',
  Deleted: 'deleted',
  Combined: 'combined',
  PreCategorized: 'pre-categorized',
} as const;

export type ApiSvcSuspendedTransactionStates =
  typeof ApiSvcSuspendedTransactionStates[keyof typeof ApiSvcSuspendedTransactionStates];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSyncCoordinatorJobRunStatus = {
  Started: 'started',
  InProgress: 'in-progress',
  Completed: 'completed',
  Failed: 'failed',
} as const;

export type ApiSvcSyncCoordinatorJobRunStatus =
  typeof ApiSvcSyncCoordinatorJobRunStatus[keyof typeof ApiSvcSyncCoordinatorJobRunStatus];

/**
 *
 * @export
 * @interface ApiSvcSyncCoordinatorJobRunSummaryDTO
 */
export interface ApiSvcSyncCoordinatorJobRunSummaryDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  jobRunId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  jobId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  jobName: string;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobType}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  jobType: ApiSvcSyncCoordinatorJobType;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunStatus}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  status: ApiSvcSyncCoordinatorJobRunStatus;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  startTimeSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  endTimeSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  lastHeartbeatSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  pipelineFreshnessSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  itemsProcessed?: number;
  /**
   *
   * @type {ApiSvcSyncError}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  syncError?: ApiSvcSyncError;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  balanceCheckJobRunId?: string;
  /**
   *
   * @type {ApiSvcBalanceCompareResult}
   * @memberof ApiSvcSyncCoordinatorJobRunSummaryDTO
   */
  balanceCheckResult?: ApiSvcBalanceCompareResult;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSyncCoordinatorJobType = {
  Sync: 'sync',
  Crawl: 'crawl',
  Report: 'report',
  Rules: 'rules',
  Custom: 'custom',
} as const;

export type ApiSvcSyncCoordinatorJobType =
  typeof ApiSvcSyncCoordinatorJobType[keyof typeof ApiSvcSyncCoordinatorJobType];

/**
 *
 * @export
 * @interface ApiSvcSyncCostBasisRollForwardEntries200Response
 */
export interface ApiSvcSyncCostBasisRollForwardEntries200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200Response
   */
  traceId?: string;
  /**
   *
   * @type {Array<ApiSvcRemoteSyncStatus>}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200Response
   */
  results: Array<ApiSvcRemoteSyncStatus>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200Response
   */
  entriesPushed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200Response
   */
  lineCount: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200Response
   */
  success: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcSyncCostBasisRollForwardEntries200ResponseAnyOf
 */
export interface ApiSvcSyncCostBasisRollForwardEntries200ResponseAnyOf {
  /**
   *
   * @type {Array<ApiSvcRemoteSyncStatus>}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200ResponseAnyOf
   */
  results: Array<ApiSvcRemoteSyncStatus>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200ResponseAnyOf
   */
  entriesPushed: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200ResponseAnyOf
   */
  lineCount: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSyncCostBasisRollForwardEntries200ResponseAnyOf
   */
  success: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcSyncCostBasisRollForwardEntriesReq
 */
export interface ApiSvcSyncCostBasisRollForwardEntriesReq {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  connectionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  inventoryViewId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  runId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  startSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  endSEC: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  includeSubsidiary?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  digitalAssetAccountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  gainLossAccountCode: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  contactId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  metadataIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncCostBasisRollForwardEntriesReq
   */
  subsidiaryId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcSyncEndpointConfig
 */
export interface ApiSvcSyncEndpointConfig {
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncEndpointConfig
   */
  displayName: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncEndpointConfig
   */
  orgidIndex?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncEndpointConfig
   */
  walletidIndex?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncEndpointConfig
   */
  connectionidIndex?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncEndpointConfig
   */
  addressIndex?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncEndpointConfig
   */
  endpoint: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncEndpointConfig
   */
  parsingToken: string;
}
/**
 *
 * @export
 * @interface ApiSvcSyncError
 */
export interface ApiSvcSyncError {
  /**
   *
   * @type {ApiSvcTransientErrorReasonInternalError}
   * @memberof ApiSvcSyncError
   */
  errorType: ApiSvcTransientErrorReasonInternalError;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  rawMessage?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncError
   */
  httpStatus?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcSyncError
   */
  metadata?: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  exchange?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  network?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  transactionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  reason?: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcSyncError
   */
  rawTransaction?: any;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  credentialType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  address: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncError
   */
  timeoutMs: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  operation?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncError
   */
  errorCode?: string;
}

/**
 *
 * @export
 * @interface ApiSvcSyncErrorType
 */
export interface ApiSvcSyncErrorType {}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcSyncStatus = {
  NUMBER_1: 1,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_20: 20,
  NUMBER_99: 99,
} as const;

export type ApiSvcSyncStatus = typeof ApiSvcSyncStatus[keyof typeof ApiSvcSyncStatus];

/**
 * A single version entry within a structured syncer version config. Defines a syncer version and an optional time range it applies to.  If neither inclusiveStartSEC nor exclusiveEndSEC is set, the version is open-ended (applies to all time).
 * @export
 * @interface ApiSvcSyncVersionTimeRangeSelection
 */
export interface ApiSvcSyncVersionTimeRangeSelection {
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncVersionTimeRangeSelection
   */
  version: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncVersionTimeRangeSelection
   */
  inclusiveStartSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSyncVersionTimeRangeSelection
   */
  exclusiveEndSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncVersionTimeRangeSelection
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSyncVersionTimeRangeSelection
   */
  updatedAt?: string;
}
/**
 *
 * @export
 * @interface ApiSvcSystemSendRemittanceAdviceDTO
 */
export interface ApiSvcSystemSendRemittanceAdviceDTO {
  /**
   *
   * @type {ApiSvcRemittanceOptions}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  remittanceOptions?: ApiSvcRemittanceOptions;
  /**
   *
   * @type {number}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  paidAtTimestampSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  network?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  remittanceLogoUrl: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  templateVersion?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  exchangeRate: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  tokenAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  tokenTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  paidAmount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  toAddress: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcSystemSendRemittanceAdviceDTO
   */
  txnHash: string;
}
/**
 *
 * @export
 * @interface ApiSvcTSOAContactsResponse
 */
export interface ApiSvcTSOAContactsResponse {
  /**
   *
   * @type {Array<ApiSvcContactDTO>}
   * @memberof ApiSvcTSOAContactsResponse
   */
  items: Array<ApiSvcContactDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOAContactsResponse
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOAContactsResponse
   */
  nextPage?: string;
}
/**
 *
 * @export
 * @interface ApiSvcTSOAErrorResponse
 */
export interface ApiSvcTSOAErrorResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOAErrorResponse
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOAErrorResponse
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcTSOARulesResponse
 */
export interface ApiSvcTSOARulesResponse {
  /**
   *
   * @type {Array<ApiSvcTransferRuleDTO>}
   * @memberof ApiSvcTSOARulesResponse
   */
  items: Array<ApiSvcTransferRuleDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOARulesResponse
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOARulesResponse
   */
  nextPage?: string;
}
/**
 *
 * @export
 * @interface ApiSvcTSOATransactionsLiteResponse
 */
export interface ApiSvcTSOATransactionsLiteResponse {
  /**
   *
   * @type {Array<ApiSvcTransactionLite>}
   * @memberof ApiSvcTSOATransactionsLiteResponse
   */
  txns: Array<ApiSvcTransactionLite>;
  /**
   *
   * @type {Array<ApiSvcCoinMapping>}
   * @memberof ApiSvcTSOATransactionsLiteResponse
   */
  coins: Array<ApiSvcCoinMapping>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOATransactionsLiteResponse
   */
  olderPageToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOATransactionsLiteResponse
   */
  newerPageToken?: string;
}
/**
 *
 * @export
 * @interface ApiSvcTSOATransactionsResponse
 */
export interface ApiSvcTSOATransactionsResponse {
  /**
   *
   * @type {Array<ApiSvcTransactionDTO>}
   * @memberof ApiSvcTSOATransactionsResponse
   */
  items: Array<ApiSvcTransactionDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOATransactionsResponse
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTSOATransactionsResponse
   */
  nextPage?: string;
}
/**
 *
 * @export
 * @interface ApiSvcTaskResult
 */
export interface ApiSvcTaskResult {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTaskResult
   */
  success: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTaskResult
   */
  errors: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTaskResult
   */
  deleteTask: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcTaxAcquisitionDetailsDTO
 */
export interface ApiSvcTaxAcquisitionDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxAcquisitionDetailsDTO
   */
  acquisitionCostInBaseCurrency: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxAcquisitionDetailsDTO
   */
  acquisitionDate: string;
}
/**
 *
 * @export
 * @interface ApiSvcTaxConfigDTO
 */
export interface ApiSvcTaxConfigDTO {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTaxConfigDTO
   */
  capitalizeTradingFees: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcTaxConfigInputDTO
 */
export interface ApiSvcTaxConfigInputDTO {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTaxConfigInputDTO
   */
  capitalizeFees: boolean;
  /**
   *
   * @type {any}
   * @memberof ApiSvcTaxConfigInputDTO
   */
  wrappingTreatments?: any;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTaxConfigInputDTO
   */
  specIdNetZero?: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcTaxDispositionDetailsDTO
 */
export interface ApiSvcTaxDispositionDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxDispositionDetailsDTO
   */
  dispositionProceedsInBaseCurrency: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxDispositionDetailsDTO
   */
  dispositionDate: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTaxGroupingType = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export type ApiSvcTaxGroupingType = typeof ApiSvcTaxGroupingType[keyof typeof ApiSvcTaxGroupingType];

/**
 *
 * @export
 * @interface ApiSvcTaxStartingBalanceExchangeRates
 */
export interface ApiSvcTaxStartingBalanceExchangeRates {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxStartingBalanceExchangeRates
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxStartingBalanceExchangeRates
   */
  averageCost: string;
}
/**
 *
 * @export
 * @interface ApiSvcTaxStrategy
 */
export interface ApiSvcTaxStrategy {
  /**
   *
   * @type {ApiSvcTaxStrategyType}
   * @memberof ApiSvcTaxStrategy
   */
  type: ApiSvcTaxStrategyType;
  /**
   *
   * @type {ApiSvcTaxGroupingType}
   * @memberof ApiSvcTaxStrategy
   */
  grouping: ApiSvcTaxGroupingType;
  /**
   *
   * @type {Array<ApiSvcCoin>}
   * @memberof ApiSvcTaxStrategy
   */
  excludeCoins?: Array<ApiSvcCoin>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTaxStrategy
   */
  taxStartDateSEC?: number;
  /**
   *
   * @type {Array<ApiSvcTaxStartingBalanceExchangeRates>}
   * @memberof ApiSvcTaxStrategy
   */
  startingBalancesExchangeRates?: Array<ApiSvcTaxStartingBalanceExchangeRates>;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTaxStrategyType = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
} as const;

export type ApiSvcTaxStrategyType = typeof ApiSvcTaxStrategyType[keyof typeof ApiSvcTaxStrategyType];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTaxStrategyTypeDTO = {
  Fifo: 'FIFO',
  Lifo: 'LIFO',
  Hifo: 'HIFO',
  CostAverage: 'CostAverage',
  SpecificIdentification: 'SpecificIdentification',
} as const;

export type ApiSvcTaxStrategyTypeDTO = typeof ApiSvcTaxStrategyTypeDTO[keyof typeof ApiSvcTaxStrategyTypeDTO];

/**
 *
 * @export
 * @interface ApiSvcTaxTxnInfoDTO
 */
export interface ApiSvcTaxTxnInfoDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxTxnInfoDTO
   */
  ticker: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTaxTxnInfoDTO
   */
  wallets: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxTxnInfoDTO
   */
  amount: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTaxTxnInfoDTO
   */
  cost?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTaxTxnInfoDTO
   */
  saleValue?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxTxnInfoDTO
   */
  exchangeRate?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTaxTxnInfoDTO
   */
  gainLoss?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTaxTxnInfoDTO
   */
  isGainLossComplete: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcTestPath200Response
 */
export interface ApiSvcTestPath200Response {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTestPath200Response
   */
  success: ApiSvcTestPath200ResponseSuccessEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTestPath200Response
   */
  error: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTestPath200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTestPath200Response
   */
  message: string;
}

export const ApiSvcTestPath200ResponseSuccessEnum = {
  False: false,
} as const;

export type ApiSvcTestPath200ResponseSuccessEnum =
  typeof ApiSvcTestPath200ResponseSuccessEnum[keyof typeof ApiSvcTestPath200ResponseSuccessEnum];

/**
 *
 * @export
 * @interface ApiSvcTestSftpPathRequest
 */
export interface ApiSvcTestSftpPathRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTestSftpPathRequest
   */
  connectionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTestSftpPathRequest
   */
  serverPath: string;
  /**
   *
   * @type {ApiSvcSftpPathAction}
   * @memberof ApiSvcTestSftpPathRequest
   */
  action: ApiSvcSftpPathAction;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTestSftpPathRequest
   */
  name?: string;
}

/**
 *
 * @export
 * @interface ApiSvcTestSftpPathResponse
 */
export interface ApiSvcTestSftpPathResponse {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTestSftpPathResponse
   */
  success: ApiSvcTestSftpPathResponseSuccessEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTestSftpPathResponse
   */
  error: string;
}

export const ApiSvcTestSftpPathResponseSuccessEnum = {
  False: false,
} as const;

export type ApiSvcTestSftpPathResponseSuccessEnum =
  typeof ApiSvcTestSftpPathResponseSuccessEnum[keyof typeof ApiSvcTestSftpPathResponseSuccessEnum];

/**
 *
 * @export
 * @interface ApiSvcTestSftpPathResponseAnyOf
 */
export interface ApiSvcTestSftpPathResponseAnyOf {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTestSftpPathResponseAnyOf
   */
  success: ApiSvcTestSftpPathResponseAnyOfSuccessEnum;
}

export const ApiSvcTestSftpPathResponseAnyOfSuccessEnum = {
  True: true,
} as const;

export type ApiSvcTestSftpPathResponseAnyOfSuccessEnum =
  typeof ApiSvcTestSftpPathResponseAnyOfSuccessEnum[keyof typeof ApiSvcTestSftpPathResponseAnyOfSuccessEnum];

/**
 *
 * @export
 * @interface ApiSvcTestSftpPathResponseAnyOf1
 */
export interface ApiSvcTestSftpPathResponseAnyOf1 {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTestSftpPathResponseAnyOf1
   */
  error: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTestSftpPathResponseAnyOf1
   */
  success: ApiSvcTestSftpPathResponseAnyOf1SuccessEnum;
}

export const ApiSvcTestSftpPathResponseAnyOf1SuccessEnum = {
  False: false,
} as const;

export type ApiSvcTestSftpPathResponseAnyOf1SuccessEnum =
  typeof ApiSvcTestSftpPathResponseAnyOf1SuccessEnum[keyof typeof ApiSvcTestSftpPathResponseAnyOf1SuccessEnum];

/**
 *
 * @export
 * @interface ApiSvcTimeoutError
 */
export interface ApiSvcTimeoutError {
  /**
   *
   * @type {ApiSvcTransientErrorReasonTimeout}
   * @memberof ApiSvcTimeoutError
   */
  errorType: ApiSvcTransientErrorReasonTimeout;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTimeoutError
   */
  rawMessage?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTimeoutError
   */
  httpStatus?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcTimeoutError
   */
  metadata?: object;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTimeoutError
   */
  timeoutMs: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTimeoutError
   */
  operation?: string;
}

/**
 *
 * @export
 * @interface ApiSvcToggleWalletRuleRequest
 */
export interface ApiSvcToggleWalletRuleRequest {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcToggleWalletRuleRequest
   */
  disabled: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcTokenFilteringRulesConfig
 */
export interface ApiSvcTokenFilteringRulesConfig {
  /**
   *
   * @type {Array<ApiSvcTokenFilteringRulesConfigWalletSyncPreferencesInner>}
   * @memberof ApiSvcTokenFilteringRulesConfig
   */
  walletSyncPreferences?: Array<ApiSvcTokenFilteringRulesConfigWalletSyncPreferencesInner>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTokenFilteringRulesConfig
   */
  filteredAddresses?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTokenFilteringRulesConfig
   */
  erc20FilterThreshold?: string;
  /**
   *
   * @type {Array<ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner>}
   * @memberof ApiSvcTokenFilteringRulesConfig
   */
  disabledDeployedByBlockHeightRules?: Array<ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner>;
  /**
   *
   * @type {Array<ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner>}
   * @memberof ApiSvcTokenFilteringRulesConfig
   */
  allowDeployedBlockHeightRules?: Array<ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTokenFilteringRulesConfig
   */
  disabledContractAddresses?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTokenFilteringRulesConfig
   */
  disabledDeployedByAddresses?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTokenFilteringRulesConfig
   */
  allowedDeployedByAddresses?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTokenFilteringRulesConfig
   */
  allowedContractAddresses?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner
 */
export interface ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner {
  /**
   *
   * @type {ApiSvcBlockHeightEvaluator}
   * @memberof ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner
   */
  evaluator: ApiSvcBlockHeightEvaluator;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTokenFilteringRulesConfigDisabledDeployedByBlockHeightRulesInner
   */
  blockNumber: string;
}

/**
 *
 * @export
 * @interface ApiSvcTokenFilteringRulesConfigWalletSyncPreferencesInner
 */
export interface ApiSvcTokenFilteringRulesConfigWalletSyncPreferencesInner {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTokenFilteringRulesConfigWalletSyncPreferencesInner
   */
  syncAllLogEvents?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTokenFilteringRulesConfigWalletSyncPreferencesInner
   */
  walletId: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTokenTypes = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_12: 12,
  NUMBER_13: 13,
  NUMBER_14: 14,
  NUMBER_15: 15,
  NUMBER_16: 16,
  NUMBER_17: 17,
  NUMBER_18: 18,
  NUMBER_19: 19,
  NUMBER_20: 20,
  NUMBER_21: 21,
  NUMBER_22: 22,
  NUMBER_23: 23,
  NUMBER_24: 24,
  NUMBER_25: 25,
  NUMBER_26: 26,
  NUMBER_27: 27,
  NUMBER_50: 50,
  NUMBER_200: 200,
  NUMBER_300: 300,
  NUMBER_500: 500,
  NUMBER_501: 501,
  NUMBER_600: 600,
  NUMBER_700: 700,
} as const;

export type ApiSvcTokenTypes = typeof ApiSvcTokenTypes[keyof typeof ApiSvcTokenTypes];

/**
 *
 * @export
 * @interface ApiSvcTradeAssetDTO
 */
export interface ApiSvcTradeAssetDTO {
  /**
   *
   * @type {ApiSvcAmountDTO}
   * @memberof ApiSvcTradeAssetDTO
   */
  asset: ApiSvcAmountDTO;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcTradeAssetDTO
   */
  fairMarketValue: ApiSvcCostBasisDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeAssetDTO
   */
  walletId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcTradeAssetInput
 */
export interface ApiSvcTradeAssetInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeAssetInput
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcCostBasisInput}
   * @memberof ApiSvcTradeAssetInput
   */
  fairMarketValue: ApiSvcCostBasisInput;
  /**
   *
   * @type {ApiSvcUncheckedAmountInput}
   * @memberof ApiSvcTradeAssetInput
   */
  asset: ApiSvcUncheckedAmountInput;
}
/**
 *
 * @export
 * @interface ApiSvcTradeCategorizationAction
 */
export interface ApiSvcTradeCategorizationAction {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTradeCategorizationAction
   */
  labels?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTradeCategorizationAction
   */
  ignoreFailPricing?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeCategorizationAction
   */
  feeContactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeCategorizationAction
   */
  type: ApiSvcTradeCategorizationActionTypeEnum;
}

export const ApiSvcTradeCategorizationActionTypeEnum = {
  TradeCategorization: 'TradeCategorization',
} as const;

export type ApiSvcTradeCategorizationActionTypeEnum =
  typeof ApiSvcTradeCategorizationActionTypeEnum[keyof typeof ApiSvcTradeCategorizationActionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcTradeCategorizationDTO
 */
export interface ApiSvcTradeCategorizationDTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeTrade}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  type: ApiSvcCategorizationTypeTrade;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  accountingConnectionId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  dateTimeSec: number;
  /**
   *
   * @type {Array<ApiSvcTradeLineDTO>}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  disposedAssets: Array<ApiSvcTradeLineDTO>;
  /**
   *
   * @type {Array<ApiSvcTradeLineDTO>}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  acquiredAssets: Array<ApiSvcTradeLineDTO>;
  /**
   *
   * @type {ApiSvcTradeFeeDTO}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  fees?: ApiSvcTradeFeeDTO;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTradeCategorizationDTO
   */
  carryForwardCostBasis?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcTradeFeeDTO
 */
export interface ApiSvcTradeFeeDTO {
  /**
   *
   * @type {Array<ApiSvcTradeAssetDTO>}
   * @memberof ApiSvcTradeFeeDTO
   */
  assets: Array<ApiSvcTradeAssetDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeFeeDTO
   */
  feeContactId: string;
}
/**
 *
 * @export
 * @interface ApiSvcTradeFeeInput
 */
export interface ApiSvcTradeFeeInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeFeeInput
   */
  feeContactId: string;
  /**
   *
   * @type {Array<ApiSvcTradeAssetInput>}
   * @memberof ApiSvcTradeFeeInput
   */
  assets: Array<ApiSvcTradeAssetInput>;
}
/**
 *
 * @export
 * @interface ApiSvcTradeLineDTO
 */
export interface ApiSvcTradeLineDTO {
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcTradeLineDTO
   */
  sourceValue: ApiSvcRawValueDTO;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcTradeLineDTO
   */
  appliedExchangeRateValue?: ApiSvcRawValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeLineDTO
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcCategorizedLineTypeTradeLine}
   * @memberof ApiSvcTradeLineDTO
   */
  type: ApiSvcCategorizedLineTypeTradeLine;
  /**
   *
   * @type {ApiSvcCategorizedLineDirection}
   * @memberof ApiSvcTradeLineDTO
   */
  direction: ApiSvcCategorizedLineDirection;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTradeSeparation = {
  Direction: 'direction',
  None: 'none',
  Assets: 'assets',
} as const;

export type ApiSvcTradeSeparation = typeof ApiSvcTradeSeparation[keyof typeof ApiSvcTradeSeparation];

/**
 *
 * @export
 * @interface ApiSvcTradeTransaction
 */
export interface ApiSvcTradeTransaction {
  /**
   *
   * @type {ApiSvcRemoteSystemId}
   * @memberof ApiSvcTradeTransaction
   */
  remoteSystemId?: ApiSvcRemoteSystemId;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeTransaction
   */
  type: ApiSvcTradeTransactionTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeTransaction
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeTransaction
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeTransaction
   */
  walletName?: string;
  /**
   *
   * @type {ApiSvcSources}
   * @memberof ApiSvcTradeTransaction
   */
  source: ApiSvcSources;
  /**
   *
   * @type {ApiSvcTradeType}
   * @memberof ApiSvcTradeTransaction
   */
  tradeType: ApiSvcTradeType;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcTradeTransaction
   */
  acquiredAssets: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcTradeTransaction
   */
  disposedAssets: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcTradeTransaction
   */
  fees: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTradeTransaction
   */
  createdSEC: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTradeTransaction
   */
  isComplete: boolean;
  /**
   *
   * @type {ApiSvcTxnOrigin}
   * @memberof ApiSvcTradeTransaction
   */
  txnOrigin?: ApiSvcTxnOrigin;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTradeTransaction
   */
  contactId?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcTradeTransaction
   */
  metadata?: { [key: string]: string };
}

export const ApiSvcTradeTransactionTypeEnum = {
  Trade: 'trade',
} as const;

export type ApiSvcTradeTransactionTypeEnum =
  typeof ApiSvcTradeTransactionTypeEnum[keyof typeof ApiSvcTradeTransactionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcTradeTransactionInput
 */
export interface ApiSvcTradeTransactionInput {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTradeTransactionInput
   */
  carryForwardCostBasis?: boolean | null;
  /**
   *
   * @type {ApiSvcTradeFeeInput}
   * @memberof ApiSvcTradeTransactionInput
   */
  tradeFee?: ApiSvcTradeFeeInput | null;
  /**
   *
   * @type {Array<ApiSvcExchangeRateInput>}
   * @memberof ApiSvcTradeTransactionInput
   */
  exchangeRates: Array<ApiSvcExchangeRateInput>;
  /**
   *
   * @type {Array<ApiSvcTradeAssetInput>}
   * @memberof ApiSvcTradeTransactionInput
   */
  disposedAssets: Array<ApiSvcTradeAssetInput>;
  /**
   *
   * @type {Array<ApiSvcTradeAssetInput>}
   * @memberof ApiSvcTradeTransactionInput
   */
  acquiredAssets: Array<ApiSvcTradeAssetInput>;
}
/**
 *
 * @export
 * @interface ApiSvcTradeTxnDetailsDTO
 */
export interface ApiSvcTradeTxnDetailsDTO {
  /**
   *
   * @type {Array<ApiSvcTradeAssetDTO>}
   * @memberof ApiSvcTradeTxnDetailsDTO
   */
  acquiredAssets: Array<ApiSvcTradeAssetDTO>;
  /**
   *
   * @type {Array<ApiSvcTradeAssetDTO>}
   * @memberof ApiSvcTradeTxnDetailsDTO
   */
  disposedAssets: Array<ApiSvcTradeAssetDTO>;
  /**
   *
   * @type {ApiSvcTradeFeeDTO}
   * @memberof ApiSvcTradeTxnDetailsDTO
   */
  tradeFee?: ApiSvcTradeFeeDTO;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTradeTxnDetailsDTO
   */
  systemCreated: boolean;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcTradeTxnDetailsDTO
   */
  exchangeRates?: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTradeTxnDetailsDTO
   */
  carryForwardCostBasis?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTradeType = {
  Buy: 'buy',
  Sell: 'sell',
} as const;

export type ApiSvcTradeType = typeof ApiSvcTradeType[keyof typeof ApiSvcTradeType];

/**
 *
 * @export
 * @interface ApiSvcTransactionActorDTO
 */
export interface ApiSvcTransactionActorDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionActorDTO
   */
  address: string;
  /**
   *
   * @type {ApiSvcAmountDTO}
   * @memberof ApiSvcTransactionActorDTO
   */
  amount: ApiSvcAmountDTO;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionActorLiteDTO
 */
export interface ApiSvcTransactionActorLiteDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionActorLiteDTO
   */
  address: string;
  /**
   *
   * @type {ApiSvcAmountLiteDTO}
   * @memberof ApiSvcTransactionActorLiteDTO
   */
  amount: ApiSvcAmountLiteDTO;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionChangeLog
 */
export interface ApiSvcTransactionChangeLog {
  /**
   *
   * @type {ApiSvcTransactionLite}
   * @memberof ApiSvcTransactionChangeLog
   */
  txn: ApiSvcTransactionLite;
  /**
   *
   * @type {Array<ApiSvcJournalEntryDTO>}
   * @memberof ApiSvcTransactionChangeLog
   */
  journalEntries: Array<ApiSvcJournalEntryDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionChangelogEntryDTO
 */
export interface ApiSvcTransactionChangelogEntryDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionChangelogEntryDTO
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionChangelogEntryDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionChangelogEntryDTO
   */
  updatedAt: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionChangelogEntryDTO
   */
  deleted: boolean;
  /**
   *
   * @type {ApiSvcTransactionLite}
   * @memberof ApiSvcTransactionChangelogEntryDTO
   */
  txn?: ApiSvcTransactionLite;
  /**
   *
   * @type {Array<ApiSvcJournalEntryDTO>}
   * @memberof ApiSvcTransactionChangelogEntryDTO
   */
  journalEntries?: Array<ApiSvcJournalEntryDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionDTO
 */
export interface ApiSvcTransactionDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionDTO
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionDTO
   */
  created: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionDTO
   */
  txnType: string;
  /**
   *
   * @type {Array<ApiSvcTransactionActorDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  from: Array<ApiSvcTransactionActorDTO>;
  /**
   *
   * @type {Array<ApiSvcTransactionActorDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  to: Array<ApiSvcTransactionActorDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionDTO
   */
  reconciliationStatus: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionDTO
   */
  categorizationStatus: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionDTO
   */
  taxReconciliationStatus: string;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  fees: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  amountsWithoutFees: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  amountsWithFees: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  fullAmountSet: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcWalletValues>}
   * @memberof ApiSvcTransactionDTO
   */
  valuesByWallets: Array<ApiSvcWalletValues>;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  paidFees: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  exchangeRates?: Array<ApiSvcExchangeRateDetailsDTO>;
  /**
   *
   * @type {Array<ApiSvcTransactionDetailsDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  details: Array<ApiSvcTransactionDetailsDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionDTO
   */
  isBlockchain: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionDTO
   */
  ignore: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionDTO
   */
  hasMatchedInvoices: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionDTO
   */
  readonly: boolean;
  /**
   *
   * @type {Array<ApiSvcWalletPointer>}
   * @memberof ApiSvcTransactionDTO
   */
  walletPointers: Array<ApiSvcWalletPointer>;
  /**
   *
   * @type {Array<ApiSvcAccountingDetailsDTO>}
   * @memberof ApiSvcTransactionDTO
   */
  accountingDetails?: Array<ApiSvcAccountingDetailsDTO>;
  /**
   *
   * @type {ApiSvcTaxTxnInfoDTO}
   * @memberof ApiSvcTransactionDTO
   */
  taxInfo?: ApiSvcTaxTxnInfoDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionDTO
   */
  memo?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionDTO
   */
  reconciledRemoteIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionDTO
   */
  combinedIntoTxnId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionDTO
   */
  combinedSubTxnIds?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionData
 */
export interface ApiSvcTransactionData {
  /**
   *
   * @type {any}
   * @memberof ApiSvcTransactionData
   */
  simple?: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcTransactionData
   */
  sell?: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcTransactionData
   */
  transfer?: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcTransactionData
   */
  accountTransfer?: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcTransactionData
   */
  staking?: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcTransactionData
   */
  detailed?: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcTransactionData
   */
  multivalue?: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcTransactionData
   */
  invoice?: any;
  /**
   *
   * @type {any}
   * @memberof ApiSvcTransactionData
   */
  trade?: any;
  /**
   *
   * @type {ApiSvcAdvanceDeFiTransactionInput}
   * @memberof ApiSvcTransactionData
   */
  advanceDeFi?: ApiSvcAdvanceDeFiTransactionInput;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionData
   */
  accountingConnectionId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionDataInput
 */
export interface ApiSvcTransactionDataInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionDataInput
   */
  editEtag?: string;
  /**
   *
   * @type {ApiSvcPreCategorizeOpsTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  opsPreTransaction?: ApiSvcPreCategorizeOpsTransactionInput | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionDataInput
   */
  accountingConnectionId?: string | null;
  /**
   *
   * @type {ApiSvcAdvanceDeFiTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  advanceDeFi?: ApiSvcAdvanceDeFiTransactionInput | null;
  /**
   *
   * @type {ApiSvcTradeTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  trade?: ApiSvcTradeTransactionInput | null;
  /**
   *
   * @type {ApiSvcInvoiceTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  invoice?: ApiSvcInvoiceTransactionInput | null;
  /**
   *
   * @type {ApiSvcMultiValueTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  multivalue?: ApiSvcMultiValueTransactionInput | null;
  /**
   *
   * @type {ApiSvcDeFiTransferTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  deFiTransfer?: ApiSvcDeFiTransferTransactionInput | null;
  /**
   *
   * @type {ApiSvcAssetStakingTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  assetStaking?: ApiSvcAssetStakingTransactionInput | null;
  /**
   *
   * @type {ApiSvcStakingTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  staking?: ApiSvcStakingTransactionInput | null;
  /**
   *
   * @type {ApiSvcAccountTransferTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  accountTransfer?: ApiSvcAccountTransferTransactionInput | null;
  /**
   *
   * @type {ApiSvcTransferTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  transfer?: ApiSvcTransferTransactionInput | null;
  /**
   *
   * @type {ApiSvcSimpleTransactionInput}
   * @memberof ApiSvcTransactionDataInput
   */
  simple?: ApiSvcSimpleTransactionInput | null;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionDetailsDTO
 */
export interface ApiSvcTransactionDetailsDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionDetailsDTO
   */
  from: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionDetailsDTO
   */
  to: Array<string>;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcTransactionDetailsDTO
   */
  amounts: Array<ApiSvcAmountDTO>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransactionDirection = {
  Inbound: 'Inbound',
  Outbound: 'Outbound',
  All: 'All',
  Na: 'NA',
  Empty: 'Empty',
} as const;

export type ApiSvcTransactionDirection = typeof ApiSvcTransactionDirection[keyof typeof ApiSvcTransactionDirection];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransactionDirectionGraphQL = {
  Inbound: 'Inbound',
  Outbound: 'Outbound',
  All: 'All',
  Na: 'NA',
  Empty: 'Empty',
} as const;

export type ApiSvcTransactionDirectionGraphQL =
  typeof ApiSvcTransactionDirectionGraphQL[keyof typeof ApiSvcTransactionDirectionGraphQL];

/**
 *
 * @export
 * @interface ApiSvcTransactionId
 */
export interface ApiSvcTransactionId {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionId
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionId
   */
  txId: string;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionIdsDTO
 */
export interface ApiSvcTransactionIdsDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionIdsDTO
   */
  txnIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionLite
 */
export interface ApiSvcTransactionLite {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionLite
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionLite
   */
  created: number;
  /**
   *
   * @type {ApiSvcTxnType}
   * @memberof ApiSvcTransactionLite
   */
  type: ApiSvcTxnType;
  /**
   *
   * @type {ApiSvcCategorizationStatusDTO}
   * @memberof ApiSvcTransactionLite
   */
  categorizationStatus: ApiSvcCategorizationStatusDTO;
  /**
   *
   * @type {ApiSvcReconciliationStatusDTO}
   * @memberof ApiSvcTransactionLite
   */
  reconciliationStatus: ApiSvcReconciliationStatusDTO;
  /**
   *
   * @type {ApiSvcExchangeRateDetails}
   * @memberof ApiSvcTransactionLite
   */
  exchangeRates?: ApiSvcExchangeRateDetails;
  /**
   *
   * @type {Array<ApiSvcAccountingDetailsDTO>}
   * @memberof ApiSvcTransactionLite
   */
  accountingDetails?: Array<ApiSvcAccountingDetailsDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionLite
   */
  categorizationSummary?: string;
  /**
   *
   * @type {Array<ApiSvcWalletAmountsLite>}
   * @memberof ApiSvcTransactionLite
   */
  walletAmounts: Array<ApiSvcWalletAmountsLite>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionLite
   */
  ignore: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionLite
   */
  memo?: string;
  /**
   *
   * @type {Array<ApiSvcTransactionActorLiteDTO>}
   * @memberof ApiSvcTransactionLite
   */
  from: Array<ApiSvcTransactionActorLiteDTO>;
  /**
   *
   * @type {Array<ApiSvcTransactionActorLiteDTO>}
   * @memberof ApiSvcTransactionLite
   */
  to: Array<ApiSvcTransactionActorLiteDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionLite
   */
  hasMatchedInvoices: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionLite
   */
  readonly: boolean;
  /**
   *
   * @type {Array<ApiSvcTxnViewLinkDTO>}
   * @memberof ApiSvcTransactionLite
   */
  viewLinks: Array<ApiSvcTxnViewLinkDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionLite
   */
  isCombined: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionLite
   */
  isCombinedSubTransaction: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionLite
   */
  errored?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionLite
   */
  methods: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionLite
   */
  accountingConnectionId?: string;
  /**
   *
   * @type {Array<ApiSvcTxnLineLiteDTO>}
   * @memberof ApiSvcTransactionLite
   */
  txnLines: Array<ApiSvcTxnLineLiteDTO>;
  /**
   *
   * @type {Array<ApiSvcAmountLiteDTO>}
   * @memberof ApiSvcTransactionLite
   */
  fullAmountSet: Array<ApiSvcAmountLiteDTO>;
  /**
   *
   * @type {Array<ApiSvcAmountLiteDTO>}
   * @memberof ApiSvcTransactionLite
   */
  fullAmountSetWithoutFees: Array<ApiSvcAmountLiteDTO>;
  /**
   *
   * @type {Array<object>}
   * @memberof ApiSvcTransactionLite
   */
  metadata?: Array<object>;
  /**
   *
   * @type {Array<ApiSvcAmountLiteDTO>}
   * @memberof ApiSvcTransactionLite
   */
  paidFees?: Array<ApiSvcAmountLiteDTO>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionLite
   */
  isManual?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionLite
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionLite
   */
  walletName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionLite
   */
  ticker?: string;
}

/**
 *
 * @export
 * @interface ApiSvcTransactionMovementDetails
 */
export interface ApiSvcTransactionMovementDetails {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionMovementDetails
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionMovementDetails
   */
  amount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionMovementDetails
   */
  ticker?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionMovementDetails
   */
  coinId?: number;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionQueryDTO
 */
export interface ApiSvcTransactionQueryDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryDTO
   */
  categorizationStatus: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryDTO
   */
  reconciliationStatus: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryDTO
   */
  timestamp: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryDTO
   */
  txViewLink?: string;
  /**
   *
   * @type {ApiSvcTxnType}
   * @memberof ApiSvcTransactionQueryDTO
   */
  transactionType: ApiSvcTxnType;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcTransactionQueryDTO
   */
  metadata?: object;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionQueryDTO
   */
  ignored: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryDTO
   */
  state: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryDTO
   */
  methodId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionQueryDTO
   */
  isTxnLineAndValuesMismatched: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionQueryDTO
   */
  isCombinedParent: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionQueryDTO
   */
  isEditable?: boolean;
  /**
   *
   * @type {Array<ApiSvcTransactionQueryLineDTO>}
   * @memberof ApiSvcTransactionQueryDTO
   */
  lines: Array<ApiSvcTransactionQueryLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryDTO
   */
  updatedAt: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionQueryDTO
   */
  version: number;
}

/**
 *
 * @export
 * @interface ApiSvcTransactionQueryLineDTO
 */
export interface ApiSvcTransactionQueryLineDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  transactionId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  line: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  amountCurrencyId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  amountCurrencyName?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  fairMarketValue?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  fairMarketValueCurrencyId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  fairMarketValueCurrencyName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  to: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  txnOrigin: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  categoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  operation: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionQueryLineDTO
   */
  networkId: string;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionStateDTO
 */
export interface ApiSvcTransactionStateDTO {
  /**
   *
   * @type {ApiSvcTransactionStateTypes}
   * @memberof ApiSvcTransactionStateDTO
   */
  type: ApiSvcTransactionStateTypes;
  /**
   *
   * @type {ApiSvcTransactionStates}
   * @memberof ApiSvcTransactionStateDTO
   */
  state: ApiSvcTransactionStates;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionStateDTO
   */
  version: number;
  /**
   *
   * @type {ApiSvcTransactionStateDTOTxn}
   * @memberof ApiSvcTransactionStateDTO
   */
  txn?: ApiSvcTransactionStateDTOTxn;
  /**
   *
   * @type {ApiSvcTransactionStateDTOMetadata}
   * @memberof ApiSvcTransactionStateDTO
   */
  metadata?: ApiSvcTransactionStateDTOMetadata;
  /**
   *
   * @type {ApiSvcTransactionStateDTOPrice}
   * @memberof ApiSvcTransactionStateDTO
   */
  price?: ApiSvcTransactionStateDTOPrice;
  /**
   *
   * @type {ApiSvcTransactionStateDTOCategorization}
   * @memberof ApiSvcTransactionStateDTO
   */
  categorization?: ApiSvcTransactionStateDTOCategorization;
  /**
   *
   * @type {ApiSvcTransactionStateDTONeedsReview}
   * @memberof ApiSvcTransactionStateDTO
   */
  needsReview?: ApiSvcTransactionStateDTONeedsReview;
  /**
   *
   * @type {ApiSvcTransactionStateDTOSync}
   * @memberof ApiSvcTransactionStateDTO
   */
  sync?: ApiSvcTransactionStateDTOSync;
  /**
   *
   * @type {ApiSvcTransactionStateDTOSuspend}
   * @memberof ApiSvcTransactionStateDTO
   */
  suspend?: ApiSvcTransactionStateDTOSuspend;
}

/**
 *
 * @export
 * @interface ApiSvcTransactionStateDTOCategorization
 */
export interface ApiSvcTransactionStateDTOCategorization {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionStateDTOCategorization
   */
  categorizeByRuleId?: string;
  /**
   *
   * @type {ApiSvcCategorizationDTO}
   * @memberof ApiSvcTransactionStateDTOCategorization
   */
  categorizationDetails: ApiSvcCategorizationDTO;
  /**
   *
   * @type {ApiSvcCategorizationMethodology}
   * @memberof ApiSvcTransactionStateDTOCategorization
   */
  categorizationMethod: ApiSvcCategorizationMethodology;
}

/**
 *
 * @export
 * @interface ApiSvcTransactionStateDTOMetadata
 */
export interface ApiSvcTransactionStateDTOMetadata {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionStateDTOMetadata
   */
  onCategorizeAutoSync?: boolean;
  /**
   *
   * @type {ApiSvcPreCategorizationDetailsDTO}
   * @memberof ApiSvcTransactionStateDTOMetadata
   */
  preCategorizationDetails?: ApiSvcPreCategorizationDetailsDTO;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionStateDTOMetadata
   */
  userGeneratedLabelIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionStateDTOMetadata
   */
  systemGeneratedLabelIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionStateDTOMetadata
   */
  memo?: string;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionStateDTONeedsReview
 */
export interface ApiSvcTransactionStateDTONeedsReview {
  /**
   *
   * @type {Array<ApiSvcPendingExpandedExchangeRateDTO>}
   * @memberof ApiSvcTransactionStateDTONeedsReview
   */
  pendingExchangeRates?: Array<ApiSvcPendingExpandedExchangeRateDTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionStateDTONeedsReview
   */
  pendingWalletIds?: Array<string>;
  /**
   *
   * @type {Array<ApiSvcTxnValueLineDTO>}
   * @memberof ApiSvcTransactionStateDTONeedsReview
   */
  pendingTxnLines?: Array<ApiSvcTxnValueLineDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionStateDTOPrice
 */
export interface ApiSvcTransactionStateDTOPrice {
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcTransactionStateDTOPrice
   */
  nonBaseCurrencyOverrideExchangeRates?: object;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcTransactionStateDTOPrice
   */
  nonBaseCurrencyExchangeRates?: object;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionStateDTOPrice
   */
  transactionPriceVersion?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcTransactionStateDTOPrice
   */
  overrideExchangeRates?: object;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcTransactionStateDTOPrice
   */
  exchangeRates: object;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionStateDTOSuspend
 */
export interface ApiSvcTransactionStateDTOSuspend {
  /**
   *
   * @type {ApiSvcCombinedTxnDTO}
   * @memberof ApiSvcTransactionStateDTOSuspend
   */
  combinedDetails: ApiSvcCombinedTxnDTO;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionStateDTOSync
 */
export interface ApiSvcTransactionStateDTOSync {
  /**
   *
   * @type {Array<ApiSvcRemoteSyncStatusDTO>}
   * @memberof ApiSvcTransactionStateDTOSync
   */
  remoteSyncStatuses: Array<ApiSvcRemoteSyncStatusDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionStateDTOTxn
 */
export interface ApiSvcTransactionStateDTOTxn {
  /**
   *
   * @type {ApiSvcCombinationDetailsDTO}
   * @memberof ApiSvcTransactionStateDTOTxn
   */
  combinationDetails?: ApiSvcCombinationDetailsDTO;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionStateDTOTxn
   */
  txnTimestampMS?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionStateDTOTxn
   */
  txnTimestampSEC: number;
  /**
   *
   * @type {ApiSvcTransactionType}
   * @memberof ApiSvcTransactionStateDTOTxn
   */
  txnType: ApiSvcTransactionType;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionStateDTOTxn
   */
  isTxnLineValuesMisMatched?: boolean;
  /**
   *
   * @type {Array<ApiSvcTxnValueLineDTO>}
   * @memberof ApiSvcTransactionStateDTOTxn
   */
  txnLines: Array<ApiSvcTxnValueLineDTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionStateDTOTxn
   */
  walletIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionStateDTOTxn
   */
  transactionId: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransactionStateTransitions = {
  MarkReadyToSync: 'mark-ready-to-sync',
  MarkNotReadyToSync: 'mark-not-ready-to-sync',
  MarkSynced: 'mark-synced',
  UnMarkSynced: 'un-mark-synced',
  Ignore: 'ignore',
  UnIgnore: 'un-ignore',
} as const;

export type ApiSvcTransactionStateTransitions =
  typeof ApiSvcTransactionStateTransitions[keyof typeof ApiSvcTransactionStateTransitions];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransactionStateTypes = {
  Open: 'open',
  Closed: 'closed',
  Suspended: 'suspended',
} as const;

export type ApiSvcTransactionStateTypes = typeof ApiSvcTransactionStateTypes[keyof typeof ApiSvcTransactionStateTypes];

/**
 *
 * @export
 * @interface ApiSvcTransactionStateUpdateDTO
 */
export interface ApiSvcTransactionStateUpdateDTO {
  /**
   *
   * @type {ApiSvcTransactionStateTransitions}
   * @memberof ApiSvcTransactionStateUpdateDTO
   */
  update: ApiSvcTransactionStateTransitions;
}

/**
 *
 * @export
 * @interface ApiSvcTransactionStates
 */
export interface ApiSvcTransactionStates {}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransactionType = {
  Send: 'send',
  Receive: 'receive',
  Trade: 'trade',
  Transfer: 'transfer',
  ContractExecution: 'contract-execution',
  Unknown: 'unknown',
} as const;

export type ApiSvcTransactionType = typeof ApiSvcTransactionType[keyof typeof ApiSvcTransactionType];

/**
 *
 * @export
 * @interface ApiSvcTransactionsListResponse
 */
export interface ApiSvcTransactionsListResponse {
  /**
   *
   * @type {Array<ApiSvcTransactionQueryDTO>}
   * @memberof ApiSvcTransactionsListResponse
   */
  transactions: Array<ApiSvcTransactionQueryDTO>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransactionsListResponse
   */
  assetIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsListResponse
   * @deprecated
   */
  pageToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsListResponse
   */
  nextToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsListResponse
   */
  prevToken?: string;
}
/**
 * Response contract for POST /orgs/:orgId/transactions/summary_v2, consumed by actions-svc (transactions_stats / transactions_sync). Field names and shape mirror the transactions-materializer summary_v2 response, which those Go commands were written against.
 * @export
 * @interface ApiSvcTransactionsSummaryV2Response
 */
export interface ApiSvcTransactionsSummaryV2Response {
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionsSummaryV2Response
   */
  needsCategorization: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionsSummaryV2Response
   */
  toBeReconciled: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionsSummaryV2Response
   */
  needsReview: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionsSummaryV2Response
   */
  all: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsSummaryV2Response
   */
  firstRecordDate: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcTransactionsUnionType
 */
export interface ApiSvcTransactionsUnionType {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsUnionType
   */
  type: ApiSvcTransactionsUnionTypeTypeEnum;
  /**
   *
   * @type {ApiSvcRemoteSystemId}
   * @memberof ApiSvcTransactionsUnionType
   */
  remoteSystemId?: ApiSvcRemoteSystemId;
  /**
   *
   * @type {ApiSvcTransactionId}
   * @memberof ApiSvcTransactionsUnionType
   */
  transactionId?: ApiSvcTransactionId;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsUnionType
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsUnionType
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsUnionType
   */
  walletName?: string;
  /**
   *
   * @type {ApiSvcSources}
   * @memberof ApiSvcTransactionsUnionType
   */
  source: ApiSvcSources;
  /**
   *
   * @type {ApiSvcExchangeTransferType}
   * @memberof ApiSvcTransactionsUnionType
   */
  transferType: ApiSvcExchangeTransferType;
  /**
   *
   * @type {ApiSvcTransferTransactionTransferAmount}
   * @memberof ApiSvcTransactionsUnionType
   */
  transferAmount: ApiSvcTransferTransactionTransferAmount;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransactionsUnionType
   */
  createdSEC: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionsUnionType
   */
  isComplete: boolean;
  /**
   *
   * @type {ApiSvcTxnOrigin}
   * @memberof ApiSvcTransactionsUnionType
   */
  txnOrigin?: ApiSvcTxnOrigin;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsUnionType
   */
  contactId?: string;
  /**
   *
   * @type {ApiSvcCryptoExchangeTransferMeta}
   * @memberof ApiSvcTransactionsUnionType
   */
  meta?: ApiSvcCryptoExchangeTransferMeta;
  /**
   *
   * @type {ApiSvcTransferTransactionTransferAmount}
   * @memberof ApiSvcTransactionsUnionType
   */
  fee?: ApiSvcTransferTransactionTransferAmount;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionsUnionType
   */
  isOnChain?: boolean;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcTransactionsUnionType
   */
  metadata?: { [key: string]: string };
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionsUnionType
   */
  isTrade?: boolean;
  /**
   *
   * @type {ApiSvcTradeType}
   * @memberof ApiSvcTransactionsUnionType
   */
  tradeType: ApiSvcTradeType;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcTransactionsUnionType
   */
  acquiredAssets: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcTransactionsUnionType
   */
  disposedAssets: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcTransactionsUnionType
   */
  fees: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {Array<ApiSvcTransactionMovementDetails>}
   * @memberof ApiSvcTransactionsUnionType
   */
  from: Array<ApiSvcTransactionMovementDetails>;
  /**
   *
   * @type {Array<ApiSvcTransactionMovementDetails>}
   * @memberof ApiSvcTransactionsUnionType
   */
  to: Array<ApiSvcTransactionMovementDetails>;
  /**
   *
   * @type {ApiSvcManualTxnTypes}
   * @memberof ApiSvcTransactionsUnionType
   */
  transactionType: ApiSvcManualTxnTypes;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcTransactionsUnionType
   */
  amounts: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransactionsUnionType
   */
  isTaxExempt?: boolean;
  /**
   *
   * @type {ApiSvcBlockchainTransactionDiscoveringAddress}
   * @memberof ApiSvcTransactionsUnionType
   */
  discoveringAddress: ApiSvcBlockchainTransactionDiscoveringAddress;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsUnionType
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsUnionType
   */
  block: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsUnionType
   */
  id: string;
  /**
   *
   * @type {ApiSvcAccountBasedBlockchainTransaction}
   * @memberof ApiSvcTransactionsUnionType
   */
  txn: ApiSvcAccountBasedBlockchainTransaction;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransactionsUnionType
   */
  fullTransactionDetailsLink?: string;
}

export const ApiSvcTransactionsUnionTypeTypeEnum = {
  Blockchain: 'blockchain',
} as const;

export type ApiSvcTransactionsUnionTypeTypeEnum =
  typeof ApiSvcTransactionsUnionTypeTypeEnum[keyof typeof ApiSvcTransactionsUnionTypeTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcTransferAssetDTO
 */
export interface ApiSvcTransferAssetDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferAssetDTO
   */
  transferToWalletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferAssetDTO
   */
  transferFromWalletId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransferAssetDTO
   */
  labels?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferAssetDTO
   */
  walletId: string;
  /**
   *
   * @type {ApiSvcAssetValueDTO}
   * @memberof ApiSvcTransferAssetDTO
   */
  asset: ApiSvcAssetValueDTO;
}
/**
 *
 * @export
 * @interface ApiSvcTransferAssetInput
 */
export interface ApiSvcTransferAssetInput {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransferAssetInput
   */
  labels?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferAssetInput
   */
  transferToWalletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferAssetInput
   */
  transferFromWalletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferAssetInput
   */
  walletId: string;
  /**
   *
   * @type {ApiSvcUncheckedAmountInput}
   * @memberof ApiSvcTransferAssetInput
   */
  asset: ApiSvcUncheckedAmountInput;
}
/**
 *
 * @export
 * @interface ApiSvcTransferCategorizationV1DTO
 */
export interface ApiSvcTransferCategorizationV1DTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeTransfer}
   * @memberof ApiSvcTransferCategorizationV1DTO
   */
  type: ApiSvcCategorizationTypeTransfer;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcTransferCategorizationV1DTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferCategorizationV1DTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferCategorizationV1DTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferCategorizationV1DTO
   */
  notes: string;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcTransferCategorizationV1DTO
   */
  feeCostBasis?: ApiSvcRawValueDTO;
  /**
   *
   * @type {Array<ApiSvcFeeLineDTO>}
   * @memberof ApiSvcTransferCategorizationV1DTO
   */
  fees?: Array<ApiSvcFeeLineDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferCategorizationV1DTO
   */
  feeContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferCategorizationV1DTO
   */
  feeWalletId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcTransferCategorizationV2DTO
 */
export interface ApiSvcTransferCategorizationV2DTO {
  /**
   *
   * @type {ApiSvcCategorizationTypeTransfer}
   * @memberof ApiSvcTransferCategorizationV2DTO
   */
  type: ApiSvcCategorizationTypeTransfer;
  /**
   *
   * @type {ApiSvcCategorizationMethod}
   * @memberof ApiSvcTransferCategorizationV2DTO
   */
  categorizationMethod: ApiSvcCategorizationMethod;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferCategorizationV2DTO
   */
  forceCategorize?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferCategorizationV2DTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferCategorizationV2DTO
   */
  notes: string;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcTransferCategorizationV2DTO
   */
  feeCostBasis?: ApiSvcRawValueDTO;
  /**
   *
   * @type {Array<ApiSvcFeeLineDTO>}
   * @memberof ApiSvcTransferCategorizationV2DTO
   */
  fees?: Array<ApiSvcFeeLineDTO>;
  /**
   *
   * @type {Array<ApiSvcTransferLineDTO>}
   * @memberof ApiSvcTransferCategorizationV2DTO
   */
  disposedAssets: Array<ApiSvcTransferLineDTO>;
  /**
   *
   * @type {Array<ApiSvcTransferLineDTO>}
   * @memberof ApiSvcTransferCategorizationV2DTO
   */
  acquiredAssets: Array<ApiSvcTransferLineDTO>;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransferDirection = {
  Incoming: 'Incoming',
  Outgoing: 'Outgoing',
} as const;

export type ApiSvcTransferDirection = typeof ApiSvcTransferDirection[keyof typeof ApiSvcTransferDirection];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransferDirectionInput = {
  Incoming: 'Incoming',
  Outgoing: 'Outgoing',
} as const;

export type ApiSvcTransferDirectionInput =
  typeof ApiSvcTransferDirectionInput[keyof typeof ApiSvcTransferDirectionInput];

/**
 *
 * @export
 * @interface ApiSvcTransferLineDTO
 */
export interface ApiSvcTransferLineDTO {
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcTransferLineDTO
   */
  sourceValue: ApiSvcRawValueDTO;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcTransferLineDTO
   */
  appliedExchangeRateValue?: ApiSvcRawValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferLineDTO
   */
  walletId?: string;
  /**
   *
   * @type {ApiSvcCategorizedLineTypeTransferLine}
   * @memberof ApiSvcTransferLineDTO
   */
  type: ApiSvcCategorizedLineTypeTransferLine;
  /**
   *
   * @type {ApiSvcCategorizedLineDirection}
   * @memberof ApiSvcTransferLineDTO
   */
  direction: ApiSvcCategorizedLineDirection;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferLineDTO
   */
  transferFromWalletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferLineDTO
   */
  transferToWalletId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcTransferRuleDTO
 */
export interface ApiSvcTransferRuleDTO {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferRuleDTO
   */
  allowMismatch?: boolean;
  /**
   *
   * @type {ApiSvcMetadataComparisonGraphQL}
   * @memberof ApiSvcTransferRuleDTO
   */
  metadataRule?: ApiSvcMetadataComparisonGraphQL;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTransferRuleDTO
   */
  includesCurrency?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  methodId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  accountingConnectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  type: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferRuleDTO
   */
  multiToken?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferRuleDTO
   */
  autoCategorizeFee?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferRuleDTO
   */
  collapseValues?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferRuleDTO
   */
  autoReconcile?: boolean;
  /**
   *
   * @type {ApiSvcTransactionDirectionGraphQL}
   * @memberof ApiSvcTransferRuleDTO
   */
  direction: ApiSvcTransactionDirectionGraphQL;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  walletId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransferRuleDTO
   */
  afterDateSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransferRuleDTO
   */
  beforeDateSEC?: number;
  /**
   *
   * @type {Array<ApiSvcRuleComparisonDTO>}
   * @memberof ApiSvcTransferRuleDTO
   */
  valueRules?: Array<ApiSvcRuleComparisonDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  toAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  fromAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  coin?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferRuleDTO
   */
  disabled: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  memo?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  description?: string;
  /**
   *
   * @type {ApiSvcRuleActionGraphQL}
   * @memberof ApiSvcTransferRuleDTO
   */
  action: ApiSvcRuleActionGraphQL;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransferRuleDTO
   */
  priority: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferRuleDTO
   */
  id: string;
  /**
   *
   * @type {ApiSvcCoin}
   * @memberof ApiSvcTransferRuleDTO
   */
  coinValue?: ApiSvcCoin;
}

/**
 *
 * @export
 * @interface ApiSvcTransferTransaction
 */
export interface ApiSvcTransferTransaction {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransaction
   */
  type: ApiSvcTransferTransactionTypeEnum;
  /**
   *
   * @type {ApiSvcRemoteSystemId}
   * @memberof ApiSvcTransferTransaction
   */
  remoteSystemId?: ApiSvcRemoteSystemId;
  /**
   *
   * @type {ApiSvcTransactionId}
   * @memberof ApiSvcTransferTransaction
   */
  transactionId?: ApiSvcTransactionId;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransaction
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransaction
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransaction
   */
  walletName?: string;
  /**
   *
   * @type {ApiSvcSources}
   * @memberof ApiSvcTransferTransaction
   */
  source: ApiSvcSources;
  /**
   *
   * @type {ApiSvcExchangeTransferType}
   * @memberof ApiSvcTransferTransaction
   */
  transferType: ApiSvcExchangeTransferType;
  /**
   *
   * @type {ApiSvcTransferTransactionTransferAmount}
   * @memberof ApiSvcTransferTransaction
   */
  transferAmount: ApiSvcTransferTransactionTransferAmount;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransferTransaction
   */
  createdSEC: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferTransaction
   */
  isComplete: boolean;
  /**
   *
   * @type {ApiSvcTxnOrigin}
   * @memberof ApiSvcTransferTransaction
   */
  txnOrigin?: ApiSvcTxnOrigin;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransaction
   */
  contactId?: string;
  /**
   *
   * @type {ApiSvcCryptoExchangeTransferMeta}
   * @memberof ApiSvcTransferTransaction
   */
  meta?: ApiSvcCryptoExchangeTransferMeta;
  /**
   *
   * @type {ApiSvcTransferTransactionTransferAmount}
   * @memberof ApiSvcTransferTransaction
   */
  fee?: ApiSvcTransferTransactionTransferAmount;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferTransaction
   */
  isOnChain?: boolean;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcTransferTransaction
   */
  metadata?: { [key: string]: string };
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTransferTransaction
   */
  isTrade?: boolean;
}

export const ApiSvcTransferTransactionTypeEnum = {
  Transfer: 'transfer',
} as const;

export type ApiSvcTransferTransactionTypeEnum =
  typeof ApiSvcTransferTransactionTypeEnum[keyof typeof ApiSvcTransferTransactionTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcTransferTransactionInput
 */
export interface ApiSvcTransferTransactionInput {
  /**
   *
   * @type {Array<ApiSvcDetailedFeeInput>}
   * @memberof ApiSvcTransferTransactionInput
   */
  detailedFees?: Array<ApiSvcDetailedFeeInput> | null;
  /**
   *
   * @type {Array<ApiSvcTransferAssetInput>}
   * @memberof ApiSvcTransferTransactionInput
   */
  acquiredAssets?: Array<ApiSvcTransferAssetInput> | null;
  /**
   *
   * @type {Array<ApiSvcTransferAssetInput>}
   * @memberof ApiSvcTransferTransactionInput
   */
  disposedAssets?: Array<ApiSvcTransferAssetInput> | null;
  /**
   *
   * @type {Array<ApiSvcExchangeRateInput>}
   * @memberof ApiSvcTransferTransactionInput
   */
  exchangeRates?: Array<ApiSvcExchangeRateInput> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransactionInput
   */
  feeWalletId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransactionInput
   */
  feeContactId?: string | null;
  /**
   *
   * @type {ApiSvcCostBasisInput}
   * @memberof ApiSvcTransferTransactionInput
   */
  feeCostBasis?: ApiSvcCostBasisInput | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransactionInput
   */
  notes: string;
}
/**
 *
 * @export
 * @interface ApiSvcTransferTransactionTransferAmount
 */
export interface ApiSvcTransferTransactionTransferAmount {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransactionTransferAmount
   */
  type: ApiSvcTransferTransactionTransferAmountTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransactionTransferAmount
   */
  amount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTransactionTransferAmount
   */
  ticker: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTransferTransactionTransferAmount
   */
  coinId?: number;
}

export const ApiSvcTransferTransactionTransferAmountTypeEnum = {
  Crypto: 'crypto',
} as const;

export type ApiSvcTransferTransactionTransferAmountTypeEnum =
  typeof ApiSvcTransferTransactionTransferAmountTypeEnum[keyof typeof ApiSvcTransferTransactionTransferAmountTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcTransferTxnDetailsDTO
 */
export interface ApiSvcTransferTxnDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTxnDetailsDTO
   */
  notes: string;
  /**
   *
   * @type {ApiSvcCostBasisDTO}
   * @memberof ApiSvcTransferTxnDetailsDTO
   */
  feeCostBasis?: ApiSvcCostBasisDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTxnDetailsDTO
   */
  feeContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTransferTxnDetailsDTO
   */
  feeWalletId?: string;
  /**
   *
   * @type {Array<ApiSvcExchangeRateDetailsDTO>}
   * @memberof ApiSvcTransferTxnDetailsDTO
   */
  exchangeRates?: Array<ApiSvcExchangeRateDetailsDTO>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransientErrorReason = {
  Timeout: 'timeout',
  InternalError: 'internal-error',
} as const;

export type ApiSvcTransientErrorReason = typeof ApiSvcTransientErrorReason[keyof typeof ApiSvcTransientErrorReason];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransientErrorReasonInternalError = {
  InternalError: 'internal-error',
} as const;

export type ApiSvcTransientErrorReasonInternalError =
  typeof ApiSvcTransientErrorReasonInternalError[keyof typeof ApiSvcTransientErrorReasonInternalError];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTransientErrorReasonTimeout = {
  Timeout: 'timeout',
} as const;

export type ApiSvcTransientErrorReasonTimeout =
  typeof ApiSvcTransientErrorReasonTimeout[keyof typeof ApiSvcTransientErrorReasonTimeout];

/**
 *
 * @export
 * @interface ApiSvcTriggerRulesExecution200Response
 */
export interface ApiSvcTriggerRulesExecution200Response {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTriggerRulesExecution200Response
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTriggerRulesExecution200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTriggerRulesExecution200Response
   */
  code: string;
}
/**
 *
 * @export
 * @interface ApiSvcTriggerRulesExecutionRequest
 */
export interface ApiSvcTriggerRulesExecutionRequest {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTriggerRulesExecutionRequest
   */
  executeUpdates?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTriggerRulesExecutionRequest
   */
  walletIds?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTriggerRulesExecutionRequest
   */
  after?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTriggerRulesExecutionRequest
   */
  before?: number;
  /**
   *
   * @type {ApiSvcLogLevel}
   * @memberof ApiSvcTriggerRulesExecutionRequest
   */
  minLogLevel?: ApiSvcLogLevel;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTriggerRulesExecutionRequest
   */
  logTxnIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTriggerRulesExecutionRequest
   */
  slackNotifyTxnIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTriggerRulesExecutionRequest
   */
  slackChannel?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcTriggerRulesExecutionRequest
   */
  skipExistingJobsCheck?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcTxnBatchCollisionWarning
 */
export interface ApiSvcTxnBatchCollisionWarning {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnBatchCollisionWarning
   */
  transactionId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcTxnBatchCollisionWarning
   */
  systemIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnBatchCollisionWarning
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcTxnCategorizeRow
 */
export interface ApiSvcTxnCategorizeRow {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCategorizeRow
   */
  transactionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCategorizeRow
   */
  transactionLineId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCategorizeRow
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCategorizeRow
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCategorizeRow
   */
  feeCategoryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCategorizeRow
   */
  feeContactId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCategorizeRow
   */
  walletId: string;
}
/**
 *
 * @export
 * @interface ApiSvcTxnCreateResponse
 */
export interface ApiSvcTxnCreateResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCreateResponse
   */
  id: string;
}
/**
 *
 * @export
 * @interface ApiSvcTxnCryptoAmount
 */
export interface ApiSvcTxnCryptoAmount {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCryptoAmount
   */
  type: ApiSvcTxnCryptoAmountTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCryptoAmount
   */
  amount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnCryptoAmount
   */
  ticker?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTxnCryptoAmount
   */
  coinId?: number;
}

export const ApiSvcTxnCryptoAmountTypeEnum = {
  Crypto: 'crypto',
} as const;

export type ApiSvcTxnCryptoAmountTypeEnum =
  typeof ApiSvcTxnCryptoAmountTypeEnum[keyof typeof ApiSvcTxnCryptoAmountTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcTxnErrorResponse
 */
export interface ApiSvcTxnErrorResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnErrorResponse
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnErrorResponse
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnErrorResponse
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcTxnFiatAmount
 */
export interface ApiSvcTxnFiatAmount {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnFiatAmount
   */
  type: ApiSvcTxnFiatAmountTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnFiatAmount
   */
  amount: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnFiatAmount
   */
  ticker: string;
}

export const ApiSvcTxnFiatAmountTypeEnum = {
  Fiat: 'fiat',
} as const;

export type ApiSvcTxnFiatAmountTypeEnum = typeof ApiSvcTxnFiatAmountTypeEnum[keyof typeof ApiSvcTxnFiatAmountTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcTxnLineLiteDTO
 */
export interface ApiSvcTxnLineLiteDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  txnLineId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  subId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  dateTimeSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  dateTime?: string;
  /**
   *
   * @type {ApiSvcTxnLineOperation}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  operation?: ApiSvcTxnLineOperation;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  assetId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  feeAssetId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  from?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  to?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  feeAmount?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  feeExchangeRate?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  feeValueInBaseCurrency?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  amount?: string;
  /**
   *
   * @type {ApiSvcTxnOrigin}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  txnOrigin?: ApiSvcTxnOrigin;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  metadata?: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLineLiteDTO
   */
  accountingConnection?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTxnLineOperation = {
  Withdraw: 'WITHDRAW',
  Deposit: 'DEPOSIT',
  Buy: 'BUY',
  Sell: 'SELL',
  Fee: 'FEE',
  Transfer: 'TRANSFER',
} as const;

export type ApiSvcTxnLineOperation = typeof ApiSvcTxnLineOperation[keyof typeof ApiSvcTxnLineOperation];

/**
 *
 * @export
 * @interface ApiSvcTxnLiteRecordResult
 */
export interface ApiSvcTxnLiteRecordResult {
  /**
   *
   * @type {Array<ApiSvcTransactionLite>}
   * @memberof ApiSvcTxnLiteRecordResult
   */
  items: Array<ApiSvcTransactionLite>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLiteRecordResult
   */
  olderPageToken?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnLiteRecordResult
   */
  newerPageToken?: string;
  /**
   *
   * @type {Array<ApiSvcCoinMapping>}
   * @memberof ApiSvcTxnLiteRecordResult
   */
  coins: Array<ApiSvcCoinMapping>;
}
/**
 * who or what service submitted the txn
 * @export
 * @enum {string}
 */

export const ApiSvcTxnOrigin = {
  ManualSystem: 'manual-system',
  ManualFeed: 'manual-feed',
  ManualImport: 'manual-import',
  ManualUser: 'manual-user',
  ManualApi: 'manual-api',
  InternalTransfer: 'internal-transfer',
  AutoExchangeSyncer: 'auto-exchange-syncer',
  AutoBlockchainSyncer: 'auto-blockchain-syncer',
  AutoBalanceDelta: 'auto-balance-delta',
  AutoSystem: 'auto-system',
  NotSpecified: 'not-specified',
} as const;

export type ApiSvcTxnOrigin = typeof ApiSvcTxnOrigin[keyof typeof ApiSvcTxnOrigin];

/**
 *
 * @export
 * @interface ApiSvcTxnPriceResult
 */
export interface ApiSvcTxnPriceResult {
  /**
   *
   * @type {number}
   * @memberof ApiSvcTxnPriceResult
   */
  retryAfter?: number;
  /**
   *
   * @type {ApiSvcSimpleTransactionDTO}
   * @memberof ApiSvcTxnPriceResult
   */
  txn: ApiSvcSimpleTransactionDTO;
}
/**
 *
 * @export
 * @interface ApiSvcTxnResponse
 */
export interface ApiSvcTxnResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnResponse
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnResponse
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnResponse
   */
  traceId?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTxnType = {
  Send: 'Send',
  Receive: 'Receive',
  Trade: 'Trade',
  Transfer: 'Transfer',
  ContractExecution: 'ContractExecution',
  Unknown: 'Unknown',
} as const;

export type ApiSvcTxnType = typeof ApiSvcTxnType[keyof typeof ApiSvcTxnType];

/**
 *
 * @export
 * @interface ApiSvcTxnValueLineDTO
 */
export interface ApiSvcTxnValueLineDTO {
  /**
   * the txn hash of the main txn
   * @type {string}
   * @memberof ApiSvcTxnValueLineDTO
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcTxnValueLineDTO
   */
  txnLineId: number;
  /**
   * unified timestamp
   * @type {number}
   * @memberof ApiSvcTxnValueLineDTO
   */
  dateTimeSEC: number;
  /**
   * unified timestamp, in milli seconds
   * @type {number}
   * @memberof ApiSvcTxnValueLineDTO
   */
  dateTimeMS?: number;
  /**
   *
   * @type {ApiSvcTxnLineOperation}
   * @memberof ApiSvcTxnValueLineDTO
   */
  operation: ApiSvcTxnLineOperation;
  /**
   *
   * @type {ApiSvcTxnOrigin}
   * @memberof ApiSvcTxnValueLineDTO
   */
  txnOrigin?: ApiSvcTxnOrigin;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcTxnValueLineDTO
   */
  amount: ApiSvcRawValueDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnValueLineDTO
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnValueLineDTO
   */
  from?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnValueLineDTO
   */
  to?: string;
  /**
   *
   * @type {ApiSvcExpandedExchangeRateDTO}
   * @memberof ApiSvcTxnValueLineDTO
   */
  exchangeRate?: ApiSvcExpandedExchangeRateDTO;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcTxnValueLineDTO
   */
  value?: ApiSvcRawValueDTO;
  /**
   *
   * @type {ApiSvcExpandedExchangeRateDTO}
   * @memberof ApiSvcTxnValueLineDTO
   */
  nonBaseCurrencyExchangeRate?: ApiSvcExpandedExchangeRateDTO;
  /**
   *
   * @type {ApiSvcRawValueDTO}
   * @memberof ApiSvcTxnValueLineDTO
   */
  nonBaseCurrencyValue?: ApiSvcRawValueDTO;
}

/**
 *
 * @export
 * @interface ApiSvcTxnViewLinkDTO
 */
export interface ApiSvcTxnViewLinkDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnViewLinkDTO
   */
  link: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcTxnViewLinkDTO
   */
  name: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcTxnWarnings = {
  CategorizationMissingCategorizationWalletId: 'categorization-missing-categorization-wallet-id',
  CategorizationLegacyCategorization: 'categorization-legacy-categorization',
  TxnMismatchedTxnlinesValues: 'txn-mismatched-txnlines-values',
  CategorizationFeeInferringCategoryId: 'categorization-fee-inferring-category-id',
  PreCategorizationWaitingForSyncing: 'pre-categorization-waiting-for-syncing',
} as const;

export type ApiSvcTxnWarnings = typeof ApiSvcTxnWarnings[keyof typeof ApiSvcTxnWarnings];

/**
 *
 * @export
 * @interface ApiSvcUnCombineTransactionsV2200Response
 */
export interface ApiSvcUnCombineTransactionsV2200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnCombineTransactionsV2200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnCombineTransactionsV2200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnCombineTransactionsV2200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcUnableToPriceExchangeRateDTO
 */
export interface ApiSvcUnableToPriceExchangeRateDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnableToPriceExchangeRateDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnableToPriceExchangeRateDTO
   */
  from: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnableToPriceExchangeRateDTO
   */
  to: string;
  /**
   *
   * @type {ApiSvcExchangeRateTypeUnableToPrice}
   * @memberof ApiSvcUnableToPriceExchangeRateDTO
   */
  type: ApiSvcExchangeRateTypeUnableToPrice;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnableToPriceExchangeRateDTO
   */
  priceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnableToPriceExchangeRateDTO
   */
  rate: ApiSvcUnableToPriceExchangeRateDTORateEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnableToPriceExchangeRateDTO
   */
  reason?: string;
}

export const ApiSvcUnableToPriceExchangeRateDTORateEnum = {
  _0: '0',
} as const;

export type ApiSvcUnableToPriceExchangeRateDTORateEnum =
  typeof ApiSvcUnableToPriceExchangeRateDTORateEnum[keyof typeof ApiSvcUnableToPriceExchangeRateDTORateEnum];

/**
 *
 * @export
 * @interface ApiSvcUncheckedAmountInput
 */
export interface ApiSvcUncheckedAmountInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUncheckedAmountInput
   */
  unit: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUncheckedAmountInput
   */
  coin: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUncheckedAmountInput
   */
  value: string;
}
/**
 *
 * @export
 * @interface ApiSvcUncheckedValueBase
 */
export interface ApiSvcUncheckedValueBase {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUncheckedValueBase
   */
  unit?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUncheckedValueBase
   */
  coin: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUncheckedValueBase
   */
  value: string;
}
/**
 *
 * @export
 * @interface ApiSvcUncombinedTransactionsResponse
 */
export interface ApiSvcUncombinedTransactionsResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUncombinedTransactionsResponse
   */
  status: ApiSvcUncombinedTransactionsResponseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUncombinedTransactionsResponse
   */
  txId: string;
}

export const ApiSvcUncombinedTransactionsResponseStatusEnum = {
  Fulfilled: 'fulfilled',
  Rejected: 'rejected',
} as const;

export type ApiSvcUncombinedTransactionsResponseStatusEnum =
  typeof ApiSvcUncombinedTransactionsResponseStatusEnum[keyof typeof ApiSvcUncombinedTransactionsResponseStatusEnum];

/**
 *
 * @export
 * @interface ApiSvcUndeleteTransactionsV2200Response
 */
export interface ApiSvcUndeleteTransactionsV2200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUndeleteTransactionsV2200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUndeleteTransactionsV2200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUndeleteTransactionsV2200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcUnmappableTickerError
 */
export interface ApiSvcUnmappableTickerError {
  /**
   *
   * @type {ApiSvcPermanantlyFatalErrorReasonUnmappableTicker}
   * @memberof ApiSvcUnmappableTickerError
   */
  errorType: ApiSvcPermanantlyFatalErrorReasonUnmappableTicker;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnmappableTickerError
   */
  rawMessage?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcUnmappableTickerError
   */
  httpStatus?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcUnmappableTickerError
   */
  metadata?: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnmappableTickerError
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnmappableTickerError
   */
  exchange?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnmappableTickerError
   */
  network?: string;
}

/**
 *
 * @export
 * @interface ApiSvcUnmappableTransactionError
 */
export interface ApiSvcUnmappableTransactionError {
  /**
   *
   * @type {ApiSvcPermanantlyFatalErrorReasonUnmappableTransaction}
   * @memberof ApiSvcUnmappableTransactionError
   */
  errorType: ApiSvcPermanantlyFatalErrorReasonUnmappableTransaction;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnmappableTransactionError
   */
  rawMessage?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcUnmappableTransactionError
   */
  httpStatus?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcUnmappableTransactionError
   */
  metadata?: object;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnmappableTransactionError
   */
  transactionId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnmappableTransactionError
   */
  reason?: string;
  /**
   *
   * @type {any}
   * @memberof ApiSvcUnmappableTransactionError
   */
  rawTransaction?: any;
}

/**
 *
 * @export
 * @interface ApiSvcUnsplitTransactionDTO
 */
export interface ApiSvcUnsplitTransactionDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnsplitTransactionDTO
   */
  txnId: string;
}
/**
 *
 * @export
 * @interface ApiSvcUnsplitTransactionResponseDTO
 */
export interface ApiSvcUnsplitTransactionResponseDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnsplitTransactionResponseDTO
   */
  sourceTxnId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcUnsplitTransactionResponseDTO
   */
  childTxnIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcUnsplitTransactionV2200Response
 */
export interface ApiSvcUnsplitTransactionV2200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnsplitTransactionV2200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnsplitTransactionV2200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnsplitTransactionV2200Response
   */
  traceId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUnsplitTransactionV2200Response
   */
  sourceTxnId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcUnsplitTransactionV2200Response
   */
  childTxnIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateInventoryGroupRequest
 */
export interface ApiSvcUpdateInventoryGroupRequest {
  /**
   *
   * @type {Array<ApiSvcInventoryGroupDTOWalletIdsToInventoryIdsInner>}
   * @memberof ApiSvcUpdateInventoryGroupRequest
   */
  walletIdsToInventoryIds?: Array<ApiSvcInventoryGroupDTOWalletIdsToInventoryIdsInner>;
  /**
   *
   * @type {Array<ApiSvcUpdateInventoryGroupRequestInventoryIdsToGlAccountIdsInner>}
   * @memberof ApiSvcUpdateInventoryGroupRequest
   */
  inventoryIdsToGlAccountIds?: Array<ApiSvcUpdateInventoryGroupRequestInventoryIdsToGlAccountIdsInner>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcUpdateInventoryGroupRequest
   */
  accountingConnectionIds?: Array<string>;
  /**
   *
   * @type {ApiSvcMissingWalletHandling}
   * @memberof ApiSvcUpdateInventoryGroupRequest
   */
  missingWalletHandling?: ApiSvcMissingWalletHandling;
}

/**
 *
 * @export
 * @interface ApiSvcUpdateInventoryGroupRequestInventoryIdsToGlAccountIdsInner
 */
export interface ApiSvcUpdateInventoryGroupRequestInventoryIdsToGlAccountIdsInner {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateInventoryGroupRequestInventoryIdsToGlAccountIdsInner
   */
  inventoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateInventoryGroupRequestInventoryIdsToGlAccountIdsInner
   */
  glAccountId: string;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateInventoryViewRequest
 */
export interface ApiSvcUpdateInventoryViewRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateInventoryViewRequest
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpdateInventoryViewRequest
   */
  allowUpdate: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateInvoicesFromRemoteSourceDTO
 */
export interface ApiSvcUpdateInvoicesFromRemoteSourceDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcUpdateInvoicesFromRemoteSourceDTO
   */
  invoiceIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateMetadataFromRemoteSourceDTO
 */
export interface ApiSvcUpdateMetadataFromRemoteSourceDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcUpdateMetadataFromRemoteSourceDTO
   */
  metadataIds: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateNetsuiteWalletCustomRecord
 */
export interface ApiSvcUpdateNetsuiteWalletCustomRecord {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpdateNetsuiteWalletCustomRecord
   */
  propagateToRemoteSystem?: boolean;
  /**
   *
   * @type {ApiSvcSpecialMetadataTypeNetsuiteWallet}
   * @memberof ApiSvcUpdateNetsuiteWalletCustomRecord
   */
  type: ApiSvcSpecialMetadataTypeNetsuiteWallet;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpdateNetsuiteWalletCustomRecord
   */
  isValidated: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcUpdateNetsuiteWalletCustomRecord
   */
  lastValidatedSEC: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateNetsuiteWalletCustomRecord
   */
  networkId: string;
}

/**
 *
 * @export
 * @interface ApiSvcUpdateOpsTransactionPayload
 */
export interface ApiSvcUpdateOpsTransactionPayload {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateOpsTransactionPayload
   */
  transactionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateOpsTransactionPayload
   */
  sent?: string;
  /**
   *
   * @type {Array<ApiSvcMultiValueTransactionItemInput>}
   * @memberof ApiSvcUpdateOpsTransactionPayload
   */
  invoiceLines?: Array<ApiSvcMultiValueTransactionItemInput>;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateReportSnapshotRequest
 */
export interface ApiSvcUpdateReportSnapshotRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateReportSnapshotRequest
   */
  title: string;
}
/**
 * Data transfer object for updating rollup configuration Note: walletRollupRules is an object/map in the DTO for HTTP/TSOA compatibility, but is converted to a Map internally. Format: { \"wallet-id\": WalletRollupRuleData, ... }
 * @export
 * @interface ApiSvcUpdateRolledUpJeReportConfigurationDTO
 */
export interface ApiSvcUpdateRolledUpJeReportConfigurationDTO {
  /**
   * When true, adjustments from internal transfers are grouped with other adjustments
   * @type {boolean}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  groupInternalTransferAdjustments?: boolean;
  /**
   * Partial per-subsidiary default settings updates (PATCH-friendly)
   * @type {{ [key: string]: ApiSvcPartialRollupDefaultSettings; }}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  subsidiaryDefaultSettings?: { [key: string]: ApiSvcPartialRollupDefaultSettings };
  /**
   * When true, excludes buy/sell sides of internal transfers (only fees are included)
   * @type {boolean}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  excludeInternalTransfers?: boolean;
  /**
   *
   * @type {ApiSvcEntryTypeOverridesMap}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  entryTypeOverrides?: ApiSvcEntryTypeOverridesMap;
  /**
   * When true, adjustment lines on sell actions are merged into the SELL JE
   * @type {boolean}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  mergeAdjustmentsIntoSale?: boolean;
  /**
   *
   * @type {ApiSvcPartialRollupDefaultSettings}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  defaultSettings?: ApiSvcPartialRollupDefaultSettings;
  /**
   * Map of wallet IDs to their rollup rules (TSOA-compatible) Use this instead of Record<string, WalletRollupRuleData> because TSOA doesn\'t handle Record properly
   * @type {{ [key: string]: ApiSvcWalletRollupRuleData; }}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  walletRollupRules?: { [key: string]: ApiSvcWalletRollupRuleData };
  /**
   *
   * @type {Array<ApiSvcRollupGroupBy>}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  defaultGroupBy?: Array<ApiSvcRollupGroupBy>;
  /**
   *
   * @type {ApiSvcRollupStrategy}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  defaultRollupStrategy?: ApiSvcRollupStrategy;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateRolledUpJeReportConfigurationDTO
   */
  name?: string;
}

/**
 *
 * @export
 * @interface ApiSvcUpdateSftpPathRequest
 */
export interface ApiSvcUpdateSftpPathRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateSftpPathRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateSftpPathRequest
   */
  serverPath?: string;
  /**
   *
   * @type {ApiSvcSftpPathAction}
   * @memberof ApiSvcUpdateSftpPathRequest
   */
  action?: ApiSvcSftpPathAction;
}

/**
 * Request DTO for updating subsidiary coin account mappings. Defines which GL accounts to use for each cryptocurrency per subsidiary.
 * @export
 * @interface ApiSvcUpdateSubsidiaryCoinMappingsRequest
 */
export interface ApiSvcUpdateSubsidiaryCoinMappingsRequest {
  /**
   * Map of subsidiary IDs to their coin account mappings. Example: { \"sub1\": { \"BTC\": \"1100\", \"ETH\": \"1101\" } }
   * @type {{ [key: string]: { [key: string]: string; }; }}
   * @memberof ApiSvcUpdateSubsidiaryCoinMappingsRequest
   */
  explicitMappings: { [key: string]: { [key: string]: string } };
}
/**
 *
 * @export
 * @interface ApiSvcUpdateTransactionStatus200Response
 */
export interface ApiSvcUpdateTransactionStatus200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateTransactionStatus200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateTransactionStatus200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateTransactionStatus200Response
   */
  traceId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateTransactionTimestamp200Response
 */
export interface ApiSvcUpdateTransactionTimestamp200Response {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateTransactionTimestamp200Response
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateTransactionTimestamp200Response
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateTransactionTimestamp200Response
   */
  traceId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpdateTransactionTimestamp200Response
   */
  success: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateTransactionTimestamp200ResponseAnyOf
 */
export interface ApiSvcUpdateTransactionTimestamp200ResponseAnyOf {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpdateTransactionTimestamp200ResponseAnyOf
   */
  success: boolean;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateTransactionTimestampRequest
 */
export interface ApiSvcUpdateTransactionTimestampRequest {
  /**
   *
   * @type {number}
   * @memberof ApiSvcUpdateTransactionTimestampRequest
   */
  newTimestampSEC: number;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateWalletBalanceRequest
 */
export interface ApiSvcUpdateWalletBalanceRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateWalletBalanceRequest
   */
  ticker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateWalletBalanceRequest
   */
  amount: string;
}
/**
 *
 * @export
 * @interface ApiSvcUpdateWalletBalancesRequest
 */
export interface ApiSvcUpdateWalletBalancesRequest {
  /**
   *
   * @type {Array<ApiSvcUpdateWalletBalanceRequest>}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  balances: Array<ApiSvcUpdateWalletBalanceRequest>;
  /**
   *
   * @type {number}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  timestampSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  balanceTimestampSEC?: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  blockId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  balanceSource?: string;
  /**
   *
   * @type {ApiSvcBalanceType}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  balanceType?: ApiSvcBalanceType;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  remoteBalanceType?: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  txnCount?: number;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  metadata?: { [key: string]: string };
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpdateWalletBalancesRequest
   */
  liveBalance?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcUpdateWalletRuleRequest
 */
export interface ApiSvcUpdateWalletRuleRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateWalletRuleRequest
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateWalletRuleRequest
   */
  metadataKey?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpdateWalletRuleRequest
   */
  metadataValue?: string;
}
/**
 *
 * @export
 * @interface ApiSvcUpsertRollupReprocessRequestDTO
 */
export interface ApiSvcUpsertRollupReprocessRequestDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertRollupReprocessRequestDTO
   */
  startTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertRollupReprocessRequestDTO
   */
  endTime?: string;
}
/**
 *
 * @export
 * @interface ApiSvcUpsertTransactionRequest
 */
export interface ApiSvcUpsertTransactionRequest {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  type: ApiSvcUpsertTransactionRequestTypeEnum;
  /**
   *
   * @type {ApiSvcRemoteSystemId}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  remoteSystemId?: ApiSvcRemoteSystemId;
  /**
   *
   * @type {ApiSvcTransactionId}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  transactionId?: ApiSvcTransactionId;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  walletName?: string;
  /**
   *
   * @type {ApiSvcSources}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  source: ApiSvcSources;
  /**
   *
   * @type {ApiSvcExchangeTransferType}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  transferType: ApiSvcExchangeTransferType;
  /**
   *
   * @type {ApiSvcTransferTransactionTransferAmount}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  transferAmount: ApiSvcTransferTransactionTransferAmount;
  /**
   *
   * @type {number}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  createdSEC: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  isComplete: boolean;
  /**
   *
   * @type {ApiSvcTxnOrigin}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  txnOrigin?: ApiSvcTxnOrigin;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  contactId?: string;
  /**
   *
   * @type {ApiSvcCryptoExchangeTransferMeta}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  meta?: ApiSvcCryptoExchangeTransferMeta;
  /**
   *
   * @type {ApiSvcTransferTransactionTransferAmount}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  fee?: ApiSvcTransferTransactionTransferAmount;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  isOnChain?: boolean;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  metadata?: { [key: string]: string };
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  isTrade?: boolean;
  /**
   *
   * @type {ApiSvcTradeType}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  tradeType: ApiSvcTradeType;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  acquiredAssets: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  disposedAssets: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  fees: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {Array<ApiSvcTransactionMovementDetails>}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  from: Array<ApiSvcTransactionMovementDetails>;
  /**
   *
   * @type {Array<ApiSvcTransactionMovementDetails>}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  to: Array<ApiSvcTransactionMovementDetails>;
  /**
   *
   * @type {ApiSvcManualTxnTypes}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  transactionType: ApiSvcManualTxnTypes;
  /**
   *
   * @type {Array<ApiSvcTransferTransactionTransferAmount>}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  amounts: Array<ApiSvcTransferTransactionTransferAmount>;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  isTaxExempt?: boolean;
  /**
   *
   * @type {ApiSvcBlockchainTransactionDiscoveringAddress}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  discoveringAddress: ApiSvcBlockchainTransactionDiscoveringAddress;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  block: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  id: string;
  /**
   *
   * @type {ApiSvcAccountBasedBlockchainTransaction}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  txn: ApiSvcAccountBasedBlockchainTransaction;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertTransactionRequest
   */
  fullTransactionDetailsLink?: string;
}

export const ApiSvcUpsertTransactionRequestTypeEnum = {
  Blockchain: 'blockchain',
} as const;

export type ApiSvcUpsertTransactionRequestTypeEnum =
  typeof ApiSvcUpsertTransactionRequestTypeEnum[keyof typeof ApiSvcUpsertTransactionRequestTypeEnum];

/**
 *
 * @export
 * @interface ApiSvcUpsertWalletRollupRequestDTO
 */
export interface ApiSvcUpsertWalletRollupRequestDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUpsertWalletRollupRequestDTO
   */
  address: string;
  /**
   *
   * @type {ApiSvcRollupConfigTypes}
   * @memberof ApiSvcUpsertWalletRollupRequestDTO
   */
  type: ApiSvcRollupConfigTypes;
  /**
   *
   * @type {Array<ApiSvcRollupRulesDTO>}
   * @memberof ApiSvcUpsertWalletRollupRequestDTO
   */
  rules: Array<ApiSvcRollupRulesDTO>;
}

/**
 *
 * @export
 * @interface ApiSvcUserIdentity
 */
export interface ApiSvcUserIdentity {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserIdentity
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserIdentity
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserIdentity
   */
  assertedIdentity?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcUserIdentity
   */
  roles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcUserIdentity
   */
  walletIds?: Array<string>;
}
/**
 *
 * @export
 * @interface ApiSvcUserPointer
 */
export interface ApiSvcUserPointer {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserPointer
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserPointer
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserPointer
   */
  email?: string;
}
/**
 *
 * @export
 * @interface ApiSvcUserRole
 */
export interface ApiSvcUserRole {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserRole
   */
  userId: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcUserRole
   */
  role: number;
}
/**
 *
 * @export
 * @interface ApiSvcUserTosAcceptance
 */
export interface ApiSvcUserTosAcceptance {
  /**
   * Latest version of the TOS that has been accepted
   * @type {string}
   * @memberof ApiSvcUserTosAcceptance
   */
  tosVersion: string;
  /**
   * Date of TOS acceptance, in seconds since Unix epoch
   * @type {number}
   * @memberof ApiSvcUserTosAcceptance
   */
  acceptedOn: number;
}
/**
 *
 * @export
 * @interface ApiSvcUserWallet
 */
export interface ApiSvcUserWallet {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserWallet
   */
  connectType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserWallet
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserWallet
   */
  networkId: string;
}
/**
 *
 * @export
 * @interface ApiSvcUserWalletDTO
 */
export interface ApiSvcUserWalletDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserWalletDTO
   */
  networkId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserWalletDTO
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUserWalletDTO
   */
  connectType: string;
}
/**
 *
 * @export
 * @interface ApiSvcUsernameBasedToken
 */
export interface ApiSvcUsernameBasedToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcUsernameBasedToken
   */
  user: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcUsernameBasedToken
   */
  password: string;
}
/**
 *
 * @export
 * @interface ApiSvcValueBase
 */
export interface ApiSvcValueBase {
  /**
   *
   * @type {number}
   * @memberof ApiSvcValueBase
   */
  type: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcValueBase
   */
  value: string;
  /**
   * prefers to use currencyId method instead
   * @type {string}
   * @memberof ApiSvcValueBase
   */
  valueIdentifier: string;
}
/**
 *
 * @export
 * @interface ApiSvcValueDTO
 */
export interface ApiSvcValueDTO {
  /**
   *
   * @type {ApiSvcValueDTOTypes}
   * @memberof ApiSvcValueDTO
   */
  type: ApiSvcValueDTOTypes;
  /**
   *
   * @type {number}
   * @memberof ApiSvcValueDTO
   */
  amount: number;
  /**
   * this is the bw ticker, e.g. ETH, BTC
   * @type {string}
   * @memberof ApiSvcValueDTO
   */
  ticker: string;
  /**
   * only for fiat type, the fiat ticker
   * @type {string}
   * @memberof ApiSvcValueDTO
   */
  fiat?: string;
  /**
   * only for coin type, the coin ticker
   * @type {string}
   * @memberof ApiSvcValueDTO
   */
  coin?: string;
  /**
   * only for coin type, the coin unit name
   * @type {string}
   * @memberof ApiSvcValueDTO
   */
  coinUnit?: string;
  /**
   * optional, could optimize processing if known, e.g. COIN.10
   * @type {string}
   * @memberof ApiSvcValueDTO
   */
  assetId?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcValueDTOTypes = {
  Fiat: 'Fiat',
  Coin: 'Coin',
} as const;

export type ApiSvcValueDTOTypes = typeof ApiSvcValueDTOTypes[keyof typeof ApiSvcValueDTOTypes];

/**
 *
 * @export
 * @interface ApiSvcValueDetail
 */
export interface ApiSvcValueDetail {
  /**
   *
   * @type {string}
   * @memberof ApiSvcValueDetail
   */
  symbol: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcValueDetail
   */
  value: string;
}
/**
 *
 * @export
 * @interface ApiSvcValueDetailsDTO
 */
export interface ApiSvcValueDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcValueDetailsDTO
   */
  symbol: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcValueDetailsDTO
   */
  value: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcValueExtractor = {
  Royalty: 'royalty',
  Commission: 'commission',
  Amount: 'amount',
  Fee: 'fee',
  Revenue: 'revenue',
  LrcFee: 'lrcFee',
  TotalFee: 'totalFee',
} as const;

export type ApiSvcValueExtractor = typeof ApiSvcValueExtractor[keyof typeof ApiSvcValueExtractor];

/**
 *
 * @export
 * @interface ApiSvcValueInput
 */
export interface ApiSvcValueInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcValueInput
   */
  symbol: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcValueInput
   */
  value: string;
}
/**
 *
 * @export
 * @interface ApiSvcVarianceReport
 */
export interface ApiSvcVarianceReport {
  /**
   *
   * @type {Array<ApiSvcVarianceReportLine>}
   * @memberof ApiSvcVarianceReport
   */
  lines: Array<ApiSvcVarianceReportLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReport
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReport
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReport
   */
  walletId: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReport
   */
  coinId: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcVarianceReportCreationParams
 */
export interface ApiSvcVarianceReportCreationParams {
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportCreationParams
   */
  coinId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportCreationParams
   */
  walletId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportCreationParams
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportCreationParams
   */
  orgId: string;
}
/**
 *
 * @export
 * @interface ApiSvcVarianceReportLine
 */
export interface ApiSvcVarianceReportLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  accountId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  adjustmentActionSummary: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcVarianceReportLine
   */
  adjustmentAmount: number | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  adjustmentRequired: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcVarianceReportLine
   */
  amount: number | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  amountTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  blockchainId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  categoryId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  coinId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  cost: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  costTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  description: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcVarianceReportLine
   */
  externalBalance: number | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  fee: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  feeTicker: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  fromAddress: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  groupId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  memo: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  metadataActionAmt: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  metadataCoinId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  metadataDate: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcVarianceReportLine
   */
  metadataExternalBalance: number | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  metadataRegisterBalance: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  metadataSummaryNotes: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  metadataWalletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  registerBalance: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  remoteContactId: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcVarianceReportLine
   */
  taxExempt: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  time: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  toAddress: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  tradeId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  transactionType: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLine
   */
  import: string;
}
/**
 *
 * @export
 * @interface ApiSvcVarianceReportLineV2
 */
export interface ApiSvcVarianceReportLineV2 {
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLineV2
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLineV2
   */
  assetId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLineV2
   */
  assetSymbol: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLineV2
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportLineV2
   */
  externalBalanceTimestamp: string | null;
  /**
   *
   * @type {number}
   * @memberof ApiSvcVarianceReportLineV2
   */
  registerBalance: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcVarianceReportLineV2
   */
  externalBalance: number | null;
  /**
   *
   * @type {number}
   * @memberof ApiSvcVarianceReportLineV2
   */
  balanceDifference: number | null;
}
/**
 *
 * @export
 * @interface ApiSvcVarianceReportV2
 */
export interface ApiSvcVarianceReportV2 {
  /**
   *
   * @type {Array<ApiSvcVarianceReportLineV2>}
   * @memberof ApiSvcVarianceReportV2
   */
  lines: Array<ApiSvcVarianceReportLineV2>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportV2
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportV2
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportV2
   */
  walletId: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcVarianceReportV2
   */
  coinId: string | null;
}
/**
 *
 * @export
 * @interface ApiSvcWalletAmountsLite
 */
export interface ApiSvcWalletAmountsLite {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletAmountsLite
   */
  walletId: string;
  /**
   *
   * @type {Array<ApiSvcAmountLiteDTO>}
   * @memberof ApiSvcWalletAmountsLite
   */
  amounts: Array<ApiSvcAmountLiteDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcWalletBalanceDTO
 */
export interface ApiSvcWalletBalanceDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletBalanceDTO
   */
  balanceId?: string;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcWalletBalanceDTO
   */
  balances: Array<ApiSvcAmountDTO>;
  /**
   *
   * @type {ApiSvcFiatValueDTO}
   * @memberof ApiSvcWalletBalanceDTO
   */
  totalFiatValue?: ApiSvcFiatValueDTO;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletBalanceDTO
   */
  timestampSEC?: number;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcWalletBalanceDTO
   */
  metadata?: object;
}
/**
 *
 * @export
 * @interface ApiSvcWalletBalanceInventoryLine
 */
export interface ApiSvcWalletBalanceInventoryLine {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletBalanceInventoryLine
   */
  wallet: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletBalanceInventoryLine
   */
  token: string;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletBalanceInventoryLine
   */
  balance: number;
}
/**
 *
 * @export
 * @interface ApiSvcWalletBalanceInventoryResp
 */
export interface ApiSvcWalletBalanceInventoryResp {
  /**
   *
   * @type {Array<ApiSvcWalletBalanceInventoryLine>}
   * @memberof ApiSvcWalletBalanceInventoryResp
   */
  lines: Array<ApiSvcWalletBalanceInventoryLine>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletBalanceInventoryResp
   */
  pageToken?: string;
}
/**
 *
 * @export
 * @interface ApiSvcWalletCaptureInviteParams
 */
export interface ApiSvcWalletCaptureInviteParams {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletCaptureInviteParams
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletCaptureInviteParams
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletCaptureInviteParams
   */
  inviteLink: string;
}
/**
 *
 * @export
 * @interface ApiSvcWalletFlagsType
 */
export interface ApiSvcWalletFlagsType {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletFlagsType
   */
  syncStateMigrationTest?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletFlagsType
   */
  trackingMode?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletFlagsType
   */
  upsertV2?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletFlagsType
   */
  syncerVersion?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletFlagsType
   */
  syncEndDateSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletFlagsType
   */
  syncStartDateSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletFlagsType
   */
  solanaBlockRewardsEndTime?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletFlagsType
   */
  solanaBlockRewardsStartTime?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletFlagsType
   */
  solanaBlockRewardsEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletFlagsType
   */
  solanaInflationStakingRewardsEndTime?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletFlagsType
   */
  solanaInflationStakingRewardsStartTime?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletFlagsType
   */
  solanaInflationStakingRewardsEnabled?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcWalletIdTypes = {
  Wallet: 'wallet',
  Enterprise: 'enterprise',
  Exchange: 'exchange',
  MultisigWatch: 'multisig-watch',
  HardwareWallet: 'hardware-wallet',
  UserWallet: 'user-wallet',
  Manual: 'manual',
  ManualBlockchainWallet: 'manual-blockchain-wallet',
  Connection: 'connection',
  AccountBasedBlockchainWallet: 'account-based-blockchain-wallet',
  Group: 'group',
  DefiWallet: 'defi-wallet',
  CeloWallet: 'celo-wallet',
  PolygonWallet: 'polygon-wallet',
  AvalancheWallet: 'avalanche-wallet',
  BscWallet: 'bsc-wallet',
  HecoWallet: 'heco-wallet',
  StxWallet: 'stx-wallet',
  OptimismWallet: 'optimism-wallet',
} as const;

export type ApiSvcWalletIdTypes = typeof ApiSvcWalletIdTypes[keyof typeof ApiSvcWalletIdTypes];

/**
 *
 * @export
 * @interface ApiSvcWalletInput
 */
export interface ApiSvcWalletInput {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  viewKey?: string;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcWalletInput
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletInput
   */
  isBalanceMonitoringOnly?: boolean;
  /**
   *
   * @type {ApiSvcWalletSyncSetting}
   * @memberof ApiSvcWalletInput
   */
  userSyncSetting?: ApiSvcWalletSyncSetting;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  walletRoleId?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcWalletInput
   */
  metadata?: object | null;
  /**
   *
   * @type {ApiSvcWalletFlagsType}
   * @memberof ApiSvcWalletInput
   */
  flags?: ApiSvcWalletFlagsType | null;
  /**
   *
   * @type {ApiSvcDefiWalletInput}
   * @memberof ApiSvcWalletInput
   */
  defi?: ApiSvcDefiWalletInput | null;
  /**
   *
   * @type {ApiSvcLrcMarketplaceWallet}
   * @memberof ApiSvcWalletInput
   */
  lrcMarketplace?: ApiSvcLrcMarketplaceWallet | null;
  /**
   *
   * @type {ApiSvcGroupWallet}
   * @memberof ApiSvcWalletInput
   */
  group?: ApiSvcGroupWallet | null;
  /**
   *
   * @type {ApiSvcNetworkAddressWallet}
   * @memberof ApiSvcWalletInput
   */
  accountBasedBlockchain?: ApiSvcNetworkAddressWallet | null;
  /**
   *
   * @type {ApiSvcAddressWallet}
   * @memberof ApiSvcWalletInput
   */
  addressBasedBlockchain?: ApiSvcAddressWallet | null;
  /**
   *
   * @type {ApiSvcUserWallet}
   * @memberof ApiSvcWalletInput
   */
  user?: ApiSvcUserWallet | null;
  /**
   *
   * @type {ApiSvcManualWallet}
   * @memberof ApiSvcWalletInput
   */
  manual?: ApiSvcManualWallet | null;
  /**
   *
   * @type {ApiSvcHardwareWallet}
   * @memberof ApiSvcWalletInput
   */
  hardware?: ApiSvcHardwareWallet | null;
  /**
   *
   * @type {ApiSvcMultisigWallet}
   * @memberof ApiSvcWalletInput
   */
  multisig?: ApiSvcMultisigWallet | null;
  /**
   *
   * @type {ApiSvcEnterpriseWalletInput}
   * @memberof ApiSvcWalletInput
   */
  eh?: ApiSvcEnterpriseWalletInput | null;
  /**
   *
   * @type {ApiSvcWatch}
   * @memberof ApiSvcWalletInput
   */
  watch?: ApiSvcWatch | null;
  /**
   *
   * @type {Array<ApiSvcWatch>}
   * @memberof ApiSvcWalletInput
   */
  watches?: Array<ApiSvcWatch> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  defaultFeeCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  defaultFeeContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  defaultOutflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  defaultOutflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  defaultInflowContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  defaultInflowCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  accountingConnection?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  subsidiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletInput
   */
  name: string;
}

/**
 *
 * @export
 * @interface ApiSvcWalletManagerCreateStatus
 */
export interface ApiSvcWalletManagerCreateStatus {
  /**
   * True if wallet creation succeeded
   * @type {boolean}
   * @memberof ApiSvcWalletManagerCreateStatus
   */
  success: boolean;
  /**
   * Id of the wallet/connection that was newly created
   * @type {string}
   * @memberof ApiSvcWalletManagerCreateStatus
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletManagerCreateStatus
   */
  failureReason?: string;
}
/**
 *
 * @export
 * @interface ApiSvcWalletPayload
 */
export interface ApiSvcWalletPayload {
  /**
   * The remoteWalletId from wallet manager svc
   * @type {string}
   * @memberof ApiSvcWalletPayload
   */
  remoteWalletId: string;
  /**
   *
   * @type {ApiSvcWalletInput}
   * @memberof ApiSvcWalletPayload
   */
  wallet: ApiSvcWalletInput;
  /**
   * Permissions
   * @type {Array<ApiSvcWalletPermissionInput>}
   * @memberof ApiSvcWalletPayload
   */
  prems: Array<ApiSvcWalletPermissionInput>;
}
/**
 *
 * @export
 * @interface ApiSvcWalletPermissionInput
 */
export interface ApiSvcWalletPermissionInput {
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletPermissionInput
   */
  role: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletPermissionInput
   */
  userId: string;
}
/**
 *
 * @export
 * @interface ApiSvcWalletPointer
 */
export interface ApiSvcWalletPointer {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletPointer
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletPointer
   */
  walletId: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletPointer
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletPointer
   */
  networkId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcWalletPointer
   */
  addresses: Array<string>;
  /**
   * this means the wallet pointer is tied to an accounting categorization
   * @type {string}
   * @memberof ApiSvcWalletPointer
   */
  accountingDetailTransactionId?: string;
}
/**
 *
 * @export
 * @interface ApiSvcWalletResponse
 */
export interface ApiSvcWalletResponse {
  /**
   *
   * @type {ApiSvcWalletResponseDTO}
   * @memberof ApiSvcWalletResponse
   */
  data: ApiSvcWalletResponseDTO;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcWalletResponse
   */
  _links: object;
}
/**
 *
 * @export
 * @interface ApiSvcWalletResponseDTO
 */
export interface ApiSvcWalletResponseDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  description?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcWalletResponseDTO
   */
  addresses: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  orgId: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  deleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  remoteId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  disabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletResponseDTO
   */
  type: number;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  networkId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  connectionId?: string;
  /**
   *
   * @type {ApiSvcRollupConfigDTO}
   * @memberof ApiSvcWalletResponseDTO
   */
  rollupConfig?: ApiSvcRollupConfigDTO;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcWalletResponseDTO
   */
  metadata?: object;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  isSyncEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  isBalanceMonitoringOnly: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  isSyncEnabledSystem: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  isSyncEnabledUser: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletResponseDTO
   */
  lastSuccessfulSyncSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletResponseDTO
   */
  lastSuccessfulBalanceCheckSEC?: number;
  /**
   *
   * @type {ApiSvcBalanceCheckResultDTO}
   * @memberof ApiSvcWalletResponseDTO
   */
  latestBalanceCheck?: ApiSvcBalanceCheckResultDTO;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletResponseDTO
   */
  createdSEC?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  categorizeTransactions?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  accrualCadence?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  syncToLatestInteraction?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  generateAccruals?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletResponseDTO
   */
  categorizeAccruals?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  defaultAccrualContact?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  defaultAccrualCategory?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  subsidiaryId?: string;
  /**
   *
   * @type {ApiSvcWalletsFlags}
   * @memberof ApiSvcWalletResponseDTO
   */
  flags?: ApiSvcWalletsFlags;
  /**
   * Structured syncer version configuration.  Replaces the legacy scalar `syncerVersion` field with a multi-service, multi-workflow, time-range-aware version map.  Structure:   { [serviceName]: { [workflowId]: SyncVersionTimeRangeSelection[] } }  Example:   {     \"abbs-sync-svc\": {       \"canton-incremental-sync-workflow\": [{ version: 1 }],       \"canton-full-sync-workflow\": [         { version: 1, exclusiveEndSEC: 1700000000 },         { version: 2, inclusiveStartSEC: 1700000000 }       ]     }   }  When absent or empty, consumers should default to version 1 for all workflows.
   * @type {{ [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection>; }; }}
   * @memberof ApiSvcWalletResponseDTO
   */
  structuredSyncerVersionConfig?: { [key: string]: { [key: string]: Array<ApiSvcSyncVersionTimeRangeSelection> } };
  /**
   *
   * @type {ApiSvcWalletBalanceDTO}
   * @memberof ApiSvcWalletResponseDTO
   */
  balance?: ApiSvcWalletBalanceDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  walletRoleId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  exchangeConnectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  vaultAddress?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  protocol?: string;
  /**
   *
   * @type {ApiSvcWalletSyncSetting}
   * @memberof ApiSvcWalletResponseDTO
   */
  systemSyncSetting?: ApiSvcWalletSyncSetting;
  /**
   *
   * @type {ApiSvcWalletSyncSetting}
   * @memberof ApiSvcWalletResponseDTO
   */
  userSyncSetting?: ApiSvcWalletSyncSetting;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  systemSyncSettingReason?: string;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcWalletResponseDTO
   */
  lastSuccessfulJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {ApiSvcSyncCoordinatorJobRunSummaryDTO}
   * @memberof ApiSvcWalletResponseDTO
   */
  lastJobRun?: ApiSvcSyncCoordinatorJobRunSummaryDTO;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  viewKey?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletResponseDTO
   */
  parentWalletId?: string;
}

/**
 *
 * @export
 * @interface ApiSvcWalletRole
 */
export interface ApiSvcWalletRole {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRole
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRole
   */
  name: string;
}
/**
 * Wallet rollup rule as plain object (for DTOs)
 * @export
 * @interface ApiSvcWalletRollupRuleData
 */
export interface ApiSvcWalletRollupRuleData {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRollupRuleData
   */
  digitalAssetAccountCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRollupRuleData
   */
  unrealizedGainLossAccountCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRollupRuleData
   */
  adjustmentAccountCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRollupRuleData
   */
  gainLossAccountCode?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRollupRuleData
   */
  description?: string;
  /**
   *
   * @type {Array<ApiSvcRollupGroupBy>}
   * @memberof ApiSvcWalletRollupRuleData
   */
  groupBy?: Array<ApiSvcRollupGroupBy>;
  /**
   *
   * @type {ApiSvcRollupStrategy}
   * @memberof ApiSvcWalletRollupRuleData
   */
  rollupStrategy?: ApiSvcRollupStrategy;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRollupRuleData
   */
  walletName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRollupRuleData
   */
  walletId?: string;
}

/**
 * State for wallet rule, could be undefined Use guard method to determine if it is the full entity
 * @export
 * @interface ApiSvcWalletRule
 */
export interface ApiSvcWalletRule {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRule
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRule
   */
  ruleId?: string;
  /**
   *
   * @type {ApiSvcWalletRuleType}
   * @memberof ApiSvcWalletRule
   */
  ruleType?: ApiSvcWalletRuleType;
  /**
   *
   * @type {ApiSvcSubsidiary}
   * @memberof ApiSvcWalletRule
   */
  ruleValue?: ApiSvcSubsidiary;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRule
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRule
   */
  metadataKey?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletRule
   */
  metadataValue?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletRule
   */
  enabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletRule
   */
  isDeleted: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletRule
   */
  createdAtSEC: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletRule
   */
  updatedAtSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletRule
   */
  deletedAtSEC?: number;
}

/**
 * Type of wallet rule
 * @export
 * @enum {string}
 */

export const ApiSvcWalletRuleType = {
  Subsidiary: 'SUBSIDIARY',
} as const;

export type ApiSvcWalletRuleType = typeof ApiSvcWalletRuleType[keyof typeof ApiSvcWalletRuleType];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcWalletSortOrder = {
  Asc: 'asc',
  Desc: 'desc',
} as const;

export type ApiSvcWalletSortOrder = typeof ApiSvcWalletSortOrder[keyof typeof ApiSvcWalletSortOrder];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcWalletSyncSetting = {
  Enabled: 'enabled',
  DisabledManual: 'disabled-manual',
  DisabledBadConfig: 'disabled-bad-config',
  DisabledDeprecated: 'disabled-deprecated',
  DisabledOther: 'disabled-other',
  DisabledCreationBlockedOnRules: 'disabled-creation-blocked-on-rules',
} as const;

export type ApiSvcWalletSyncSetting = typeof ApiSvcWalletSyncSetting[keyof typeof ApiSvcWalletSyncSetting];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcWalletTrackingModes = {
  BalanceDelta: 'balance_delta',
  Balance: 'balance',
  TransactionBalance: 'transaction_balance',
} as const;

export type ApiSvcWalletTrackingModes = typeof ApiSvcWalletTrackingModes[keyof typeof ApiSvcWalletTrackingModes];

/**
 *
 * @export
 * @enum {string}
 */

export const ApiSvcWalletTypes = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_12: 12,
  NUMBER_13: 13,
  NUMBER_14: 14,
  NUMBER_15: 15,
  NUMBER_17: 17,
  NUMBER_20: 20,
  NUMBER_21: 21,
  NUMBER_22: 22,
  NUMBER_999: 999,
} as const;

export type ApiSvcWalletTypes = typeof ApiSvcWalletTypes[keyof typeof ApiSvcWalletTypes];

/**
 *
 * @export
 * @interface ApiSvcWalletValues
 */
export interface ApiSvcWalletValues {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletValues
   */
  walletId: string;
  /**
   *
   * @type {Array<ApiSvcAmountDTO>}
   * @memberof ApiSvcWalletValues
   */
  amounts: Array<ApiSvcAmountDTO>;
}
/**
 *
 * @export
 * @interface ApiSvcWalletsCreateParams
 */
export interface ApiSvcWalletsCreateParams {
  /**
   *
   * @type {Array<ApiSvcWalletPayload>}
   * @memberof ApiSvcWalletsCreateParams
   */
  wallets: Array<ApiSvcWalletPayload>;
}
/**
 *
 * @export
 * @interface ApiSvcWalletsErrorResponse
 */
export interface ApiSvcWalletsErrorResponse {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletsErrorResponse
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletsErrorResponse
   */
  message: string;
}
/**
 *
 * @export
 * @interface ApiSvcWalletsFlags
 */
export interface ApiSvcWalletsFlags {
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletsFlags
   */
  solanaInflationStakingRewardsEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletsFlags
   */
  solanaInflationStakingRewardsStartTime?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletsFlags
   */
  solanaInflationStakingRewardsEndTime?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletsFlags
   */
  solanaBlockRewardsEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletsFlags
   */
  solanaBlockRewardsStartTime?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletsFlags
   */
  solanaBlockRewardsEndTime?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletsFlags
   */
  solanaHistoricalAccountEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletsFlags
   */
  syncStartDateSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletsFlags
   */
  syncEndDateSEC?: number;
  /**
   *
   * @type {number}
   * @memberof ApiSvcWalletsFlags
   * @deprecated
   */
  syncerVersion?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiSvcWalletsFlags
   */
  upsertV2?: boolean;
  /**
   *
   * @type {ApiSvcWalletTrackingModes}
   * @memberof ApiSvcWalletsFlags
   */
  trackingMode?: ApiSvcWalletTrackingModes;
  /**
   * (TEMP) Per-wallet flag: opt this wallet into the org-aware sync state test prior to global enable
   * @type {boolean}
   * @memberof ApiSvcWalletsFlags
   */
  syncStateMigrationTest?: boolean;
}

/**
 *
 * @export
 * @interface ApiSvcWalletsResponse
 */
export interface ApiSvcWalletsResponse {
  /**
   *
   * @type {Array<ApiSvcWalletResponseDTO>}
   * @memberof ApiSvcWalletsResponse
   */
  items: Array<ApiSvcWalletResponseDTO>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletsResponse
   */
  previousPage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWalletsResponse
   */
  nextPage?: string;
}
/**
 *
 * @export
 * @interface ApiSvcWatch
 */
export interface ApiSvcWatch {
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcWatch
   */
  metadata?: object | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatch
   */
  remoteId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatch
   */
  derivationKey?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcWatch
   */
  addresses?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatch
   */
  address?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatch
   */
  coin: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatch
   */
  type: string;
}
/**
 *
 * @export
 * @interface ApiSvcWatchDTO
 */
export interface ApiSvcWatchDTO {
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatchDTO
   */
  type: string;
  /**
   *
   * @type {ApiSvcCoin}
   * @memberof ApiSvcWatchDTO
   */
  coin: ApiSvcCoin;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatchDTO
   */
  address?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiSvcWatchDTO
   */
  addresses?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatchDTO
   */
  derivationKey?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatchDTO
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatchDTO
   */
  connectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcWatchDTO
   */
  remoteId?: string;
  /**
   * Construct a type with a set of properties K of type T
   * @type {object}
   * @memberof ApiSvcWatchDTO
   */
  metadata?: object;
}

/**
 *
 * @export
 * @interface ApiSvcXApiKeyToken
 */
export interface ApiSvcXApiKeyToken {
  /**
   *
   * @type {string}
   * @memberof ApiSvcXApiKeyToken
   */
  xApiKey: string;
  /**
   *
   * @type {string}
   * @memberof ApiSvcXApiKeyToken
   */
  subAccountName: string;
}

/**
 * AddressEnrollmentApi - axios parameter creator
 * @export
 */
export const AddressEnrollmentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmAddressManually: async (
      orgId: string,
      contactId: string,
      address: string,
      paymentCurrency: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('confirmAddressManually', 'orgId', orgId);
      // verify required parameter 'contactId' is not null or undefined
      assertParamExists('confirmAddressManually', 'contactId', contactId);
      // verify required parameter 'address' is not null or undefined
      assertParamExists('confirmAddressManually', 'address', address);
      // verify required parameter 'paymentCurrency' is not null or undefined
      assertParamExists('confirmAddressManually', 'paymentCurrency', paymentCurrency);
      const localVarPath = `/addressEnrollment/enrollAddress/org/{orgId}/contactId/{contactId}/address/{address}/manual`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'contactId'}}`, encodeURIComponent(String(contactId)))
        .replace(`{${'address'}}`, encodeURIComponent(String(address)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (paymentCurrency !== undefined) {
        localVarQueryParameter['paymentCurrency'] = paymentCurrency;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} amount
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmAddressPennyTest: async (
      orgId: string,
      contactId: string,
      address: string,
      amount: string,
      paymentCurrency: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('confirmAddressPennyTest', 'orgId', orgId);
      // verify required parameter 'contactId' is not null or undefined
      assertParamExists('confirmAddressPennyTest', 'contactId', contactId);
      // verify required parameter 'address' is not null or undefined
      assertParamExists('confirmAddressPennyTest', 'address', address);
      // verify required parameter 'amount' is not null or undefined
      assertParamExists('confirmAddressPennyTest', 'amount', amount);
      // verify required parameter 'paymentCurrency' is not null or undefined
      assertParamExists('confirmAddressPennyTest', 'paymentCurrency', paymentCurrency);
      const localVarPath =
        `/addressEnrollment/enrollAddress/org/{orgId}/contactId/{contactId}/address/{address}/amount/{amount}`
          .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
          .replace(`{${'contactId'}}`, encodeURIComponent(String(contactId)))
          .replace(`{${'address'}}`, encodeURIComponent(String(address)))
          .replace(`{${'amount'}}`, encodeURIComponent(String(amount)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (paymentCurrency !== undefined) {
        localVarQueryParameter['paymentCurrency'] = paymentCurrency;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} signature
     * @param {string} signatureData
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmAddressSignature: async (
      orgId: string,
      contactId: string,
      address: string,
      signature: string,
      signatureData: string,
      paymentCurrency: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('confirmAddressSignature', 'orgId', orgId);
      // verify required parameter 'contactId' is not null or undefined
      assertParamExists('confirmAddressSignature', 'contactId', contactId);
      // verify required parameter 'address' is not null or undefined
      assertParamExists('confirmAddressSignature', 'address', address);
      // verify required parameter 'signature' is not null or undefined
      assertParamExists('confirmAddressSignature', 'signature', signature);
      // verify required parameter 'signatureData' is not null or undefined
      assertParamExists('confirmAddressSignature', 'signatureData', signatureData);
      // verify required parameter 'paymentCurrency' is not null or undefined
      assertParamExists('confirmAddressSignature', 'paymentCurrency', paymentCurrency);
      const localVarPath =
        `/addressEnrollment/enrollAddress/org/{orgId}/contactId/{contactId}/address/{address}/signature/{signature}`
          .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
          .replace(`{${'contactId'}}`, encodeURIComponent(String(contactId)))
          .replace(`{${'address'}}`, encodeURIComponent(String(address)))
          .replace(`{${'signature'}}`, encodeURIComponent(String(signature)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (signatureData !== undefined) {
        localVarQueryParameter['signatureData'] = signatureData;
      }

      if (paymentCurrency !== undefined) {
        localVarQueryParameter['paymentCurrency'] = paymentCurrency;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} address
     * @param {string} contactId
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAddressStatus: async (
      orgId: string,
      address: string,
      contactId: string,
      paymentCurrency: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getAddressStatus', 'orgId', orgId);
      // verify required parameter 'address' is not null or undefined
      assertParamExists('getAddressStatus', 'address', address);
      // verify required parameter 'contactId' is not null or undefined
      assertParamExists('getAddressStatus', 'contactId', contactId);
      // verify required parameter 'paymentCurrency' is not null or undefined
      assertParamExists('getAddressStatus', 'paymentCurrency', paymentCurrency);
      const localVarPath = `/addressEnrollment/getAddressStatus/org/{orgId}/address/{address}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'address'}}`, encodeURIComponent(String(address)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (contactId !== undefined) {
        localVarQueryParameter['contactId'] = contactId;
      }

      if (paymentCurrency !== undefined) {
        localVarQueryParameter['paymentCurrency'] = paymentCurrency;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAddressStatusExternal: async (
      orgId: string,
      contactId: string,
      address: string,
      paymentCurrency: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getAddressStatusExternal', 'orgId', orgId);
      // verify required parameter 'contactId' is not null or undefined
      assertParamExists('getAddressStatusExternal', 'contactId', contactId);
      // verify required parameter 'address' is not null or undefined
      assertParamExists('getAddressStatusExternal', 'address', address);
      // verify required parameter 'paymentCurrency' is not null or undefined
      assertParamExists('getAddressStatusExternal', 'paymentCurrency', paymentCurrency);
      const localVarPath =
        `/addressEnrollment/getAddressStatusExternal/org/{orgId}/contactId/{contactId}/address/{address}`
          .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
          .replace(`{${'contactId'}}`, encodeURIComponent(String(contactId)))
          .replace(`{${'address'}}`, encodeURIComponent(String(address)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (paymentCurrency !== undefined) {
        localVarQueryParameter['paymentCurrency'] = paymentCurrency;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} emailAddress
     * @param {string} paymentCurrency
     * @param {Array<string>} [ccAddresses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initiateAddressEnrollment: async (
      orgId: string,
      contactId: string,
      address: string,
      emailAddress: string,
      paymentCurrency: string,
      ccAddresses?: Array<string>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('initiateAddressEnrollment', 'orgId', orgId);
      // verify required parameter 'contactId' is not null or undefined
      assertParamExists('initiateAddressEnrollment', 'contactId', contactId);
      // verify required parameter 'address' is not null or undefined
      assertParamExists('initiateAddressEnrollment', 'address', address);
      // verify required parameter 'emailAddress' is not null or undefined
      assertParamExists('initiateAddressEnrollment', 'emailAddress', emailAddress);
      // verify required parameter 'paymentCurrency' is not null or undefined
      assertParamExists('initiateAddressEnrollment', 'paymentCurrency', paymentCurrency);
      const localVarPath =
        `/addressEnrollment/initiateAddressEnrollment/org/{orgId}/contactId/{contactId}/address/{address}`
          .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
          .replace(`{${'contactId'}}`, encodeURIComponent(String(contactId)))
          .replace(`{${'address'}}`, encodeURIComponent(String(address)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (emailAddress !== undefined) {
        localVarQueryParameter['emailAddress'] = emailAddress;
      }

      if (paymentCurrency !== undefined) {
        localVarQueryParameter['paymentCurrency'] = paymentCurrency;
      }

      if (ccAddresses) {
        localVarQueryParameter['ccAddresses'] = ccAddresses;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AddressEnrollmentApi - functional programming interface
 * @export
 */
export const AddressEnrollmentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AddressEnrollmentApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmAddressManually(
      orgId: string,
      contactId: string,
      address: string,
      paymentCurrency: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcConfirmAddressManually200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.confirmAddressManually(
        orgId,
        contactId,
        address,
        paymentCurrency,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} amount
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmAddressPennyTest(
      orgId: string,
      contactId: string,
      address: string,
      amount: string,
      paymentCurrency: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.confirmAddressPennyTest(
        orgId,
        contactId,
        address,
        amount,
        paymentCurrency,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} signature
     * @param {string} signatureData
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmAddressSignature(
      orgId: string,
      contactId: string,
      address: string,
      signature: string,
      signatureData: string,
      paymentCurrency: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.confirmAddressSignature(
        orgId,
        contactId,
        address,
        signature,
        signatureData,
        paymentCurrency,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} address
     * @param {string} contactId
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAddressStatus(
      orgId: string,
      address: string,
      contactId: string,
      paymentCurrency: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcAddressEnrollmentStatus>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAddressStatus(
        orgId,
        address,
        contactId,
        paymentCurrency,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAddressStatusExternal(
      orgId: string,
      contactId: string,
      address: string,
      paymentCurrency: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcExternalAddressEnrollmentStatus>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAddressStatusExternal(
        orgId,
        contactId,
        address,
        paymentCurrency,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} emailAddress
     * @param {string} paymentCurrency
     * @param {Array<string>} [ccAddresses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initiateAddressEnrollment(
      orgId: string,
      contactId: string,
      address: string,
      emailAddress: string,
      paymentCurrency: string,
      ccAddresses?: Array<string>,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initiateAddressEnrollment(
        orgId,
        contactId,
        address,
        emailAddress,
        paymentCurrency,
        ccAddresses,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * AddressEnrollmentApi - factory interface
 * @export
 */
export const AddressEnrollmentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AddressEnrollmentApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmAddressManually(
      orgId: string,
      contactId: string,
      address: string,
      paymentCurrency: string,
      options?: any
    ): AxiosPromise<ApiSvcConfirmAddressManually200Response> {
      return localVarFp
        .confirmAddressManually(orgId, contactId, address, paymentCurrency, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} amount
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmAddressPennyTest(
      orgId: string,
      contactId: string,
      address: string,
      amount: string,
      paymentCurrency: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .confirmAddressPennyTest(orgId, contactId, address, amount, paymentCurrency, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} signature
     * @param {string} signatureData
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmAddressSignature(
      orgId: string,
      contactId: string,
      address: string,
      signature: string,
      signatureData: string,
      paymentCurrency: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .confirmAddressSignature(orgId, contactId, address, signature, signatureData, paymentCurrency, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} address
     * @param {string} contactId
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAddressStatus(
      orgId: string,
      address: string,
      contactId: string,
      paymentCurrency: string,
      options?: any
    ): AxiosPromise<ApiSvcAddressEnrollmentStatus> {
      return localVarFp
        .getAddressStatus(orgId, address, contactId, paymentCurrency, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} paymentCurrency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAddressStatusExternal(
      orgId: string,
      contactId: string,
      address: string,
      paymentCurrency: string,
      options?: any
    ): AxiosPromise<ApiSvcExternalAddressEnrollmentStatus> {
      return localVarFp
        .getAddressStatusExternal(orgId, contactId, address, paymentCurrency, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} contactId
     * @param {string} address
     * @param {string} emailAddress
     * @param {string} paymentCurrency
     * @param {Array<string>} [ccAddresses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initiateAddressEnrollment(
      orgId: string,
      contactId: string,
      address: string,
      emailAddress: string,
      paymentCurrency: string,
      ccAddresses?: Array<string>,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .initiateAddressEnrollment(orgId, contactId, address, emailAddress, paymentCurrency, ccAddresses, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AddressEnrollmentApi - object-oriented interface
 * @export
 * @class AddressEnrollmentApi
 * @extends {BaseAPI}
 */
export class AddressEnrollmentApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {string} contactId
   * @param {string} address
   * @param {string} paymentCurrency
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressEnrollmentApi
   */
  public confirmAddressManually(
    orgId: string,
    contactId: string,
    address: string,
    paymentCurrency: string,
    options?: AxiosRequestConfig
  ) {
    return AddressEnrollmentApiFp(this.configuration)
      .confirmAddressManually(orgId, contactId, address, paymentCurrency, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} contactId
   * @param {string} address
   * @param {string} amount
   * @param {string} paymentCurrency
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressEnrollmentApi
   */
  public confirmAddressPennyTest(
    orgId: string,
    contactId: string,
    address: string,
    amount: string,
    paymentCurrency: string,
    options?: AxiosRequestConfig
  ) {
    return AddressEnrollmentApiFp(this.configuration)
      .confirmAddressPennyTest(orgId, contactId, address, amount, paymentCurrency, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} contactId
   * @param {string} address
   * @param {string} signature
   * @param {string} signatureData
   * @param {string} paymentCurrency
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressEnrollmentApi
   */
  public confirmAddressSignature(
    orgId: string,
    contactId: string,
    address: string,
    signature: string,
    signatureData: string,
    paymentCurrency: string,
    options?: AxiosRequestConfig
  ) {
    return AddressEnrollmentApiFp(this.configuration)
      .confirmAddressSignature(orgId, contactId, address, signature, signatureData, paymentCurrency, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} address
   * @param {string} contactId
   * @param {string} paymentCurrency
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressEnrollmentApi
   */
  public getAddressStatus(
    orgId: string,
    address: string,
    contactId: string,
    paymentCurrency: string,
    options?: AxiosRequestConfig
  ) {
    return AddressEnrollmentApiFp(this.configuration)
      .getAddressStatus(orgId, address, contactId, paymentCurrency, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} contactId
   * @param {string} address
   * @param {string} paymentCurrency
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressEnrollmentApi
   */
  public getAddressStatusExternal(
    orgId: string,
    contactId: string,
    address: string,
    paymentCurrency: string,
    options?: AxiosRequestConfig
  ) {
    return AddressEnrollmentApiFp(this.configuration)
      .getAddressStatusExternal(orgId, contactId, address, paymentCurrency, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} contactId
   * @param {string} address
   * @param {string} emailAddress
   * @param {string} paymentCurrency
   * @param {Array<string>} [ccAddresses]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressEnrollmentApi
   */
  public initiateAddressEnrollment(
    orgId: string,
    contactId: string,
    address: string,
    emailAddress: string,
    paymentCurrency: string,
    ccAddresses?: Array<string>,
    options?: AxiosRequestConfig
  ) {
    return AddressEnrollmentApiFp(this.configuration)
      .initiateAddressEnrollment(orgId, contactId, address, emailAddress, paymentCurrency, ccAddresses, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Provides you with an authentication token to access the Bitwave API.
     * @param {string} grantType
     * @param {ApiSvcOAuth2TokenTypes} [requestedTokenType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getToken: async (
      grantType: string,
      requestedTokenType?: ApiSvcOAuth2TokenTypes,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'grantType' is not null or undefined
      assertParamExists('getToken', 'grantType', grantType);
      const localVarPath = `/v2/oauth/token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (grantType !== undefined) {
        localVarQueryParameter['grant_type'] = grantType;
      }

      if (requestedTokenType !== undefined) {
        localVarQueryParameter['requested_token_type'] = requestedTokenType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getTokenV1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/oauth/token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration);
  return {
    /**
     * Provides you with an authentication token to access the Bitwave API.
     * @param {string} grantType
     * @param {ApiSvcOAuth2TokenTypes} [requestedTokenType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getToken(
      grantType: string,
      requestedTokenType?: ApiSvcOAuth2TokenTypes,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTokenV1200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getToken(grantType, requestedTokenType, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async getTokenV1(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTokenV1200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTokenV1(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthenticationApiFp(configuration);
  return {
    /**
     * Provides you with an authentication token to access the Bitwave API.
     * @param {string} grantType
     * @param {ApiSvcOAuth2TokenTypes} [requestedTokenType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getToken(
      grantType: string,
      requestedTokenType?: ApiSvcOAuth2TokenTypes,
      options?: any
    ): AxiosPromise<ApiSvcGetTokenV1200Response> {
      return localVarFp.getToken(grantType, requestedTokenType, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getTokenV1(options?: any): AxiosPromise<ApiSvcGetTokenV1200Response> {
      return localVarFp.getTokenV1(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
  /**
   * Provides you with an authentication token to access the Bitwave API.
   * @param {string} grantType
   * @param {ApiSvcOAuth2TokenTypes} [requestedTokenType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public getToken(grantType: string, requestedTokenType?: ApiSvcOAuth2TokenTypes, options?: AxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .getToken(grantType, requestedTokenType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public getTokenV1(options?: AxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .getTokenV1(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Bulk existence check for a bounded set of category ids (<= 100). Returns the subset that exist. Same contract/rationale as ContactsController.contactsBatch.
     * @param {string} orgId
     * @param {ApiSvcBatchLookupRequest} apiSvcBatchLookupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesBatch: async (
      orgId: string,
      apiSvcBatchLookupRequest: ApiSvcBatchLookupRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('categoriesBatch', 'orgId', orgId);
      // verify required parameter 'apiSvcBatchLookupRequest' is not null or undefined
      assertParamExists('categoriesBatch', 'apiSvcBatchLookupRequest', apiSvcBatchLookupRequest);
      const localVarPath = `/org/{orgId}/categories/batch`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcBatchLookupRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateCategoryRequest} apiSvcCreateCategoryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCategory: async (
      orgId: string,
      apiSvcCreateCategoryRequest: ApiSvcCreateCategoryRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createCategory', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateCategoryRequest' is not null or undefined
      assertParamExists('createCategory', 'apiSvcCreateCategoryRequest', apiSvcCreateCategoryRequest);
      const localVarPath = `/org/{orgId}/categories`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateCategoryRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCategories: async (
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getCategories', 'orgId', orgId);
      const localVarPath = `/org/{orgId}/categories`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageLimit !== undefined) {
        localVarQueryParameter['pageLimit'] = pageLimit;
      }

      if (paginationToken !== undefined) {
        localVarQueryParameter['paginationToken'] = paginationToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration);
  return {
    /**
     * Bulk existence check for a bounded set of category ids (<= 100). Returns the subset that exist. Same contract/rationale as ContactsController.contactsBatch.
     * @param {string} orgId
     * @param {ApiSvcBatchLookupRequest} apiSvcBatchLookupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesBatch(
      orgId: string,
      apiSvcBatchLookupRequest: ApiSvcBatchLookupRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCategoriesBatch200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesBatch(
        orgId,
        apiSvcBatchLookupRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateCategoryRequest} apiSvcCreateCategoryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCategory(
      orgId: string,
      apiSvcCreateCategoryRequest: ApiSvcCreateCategoryRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCombineTransactionsV2200ResponseAnyOf>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(
        orgId,
        apiSvcCreateCategoryRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCategories(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetCategories200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(
        orgId,
        pageLimit,
        paginationToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = CategoriesApiFp(configuration);
  return {
    /**
     * Bulk existence check for a bounded set of category ids (<= 100). Returns the subset that exist. Same contract/rationale as ContactsController.contactsBatch.
     * @param {string} orgId
     * @param {ApiSvcBatchLookupRequest} apiSvcBatchLookupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesBatch(
      orgId: string,
      apiSvcBatchLookupRequest: ApiSvcBatchLookupRequest,
      options?: any
    ): AxiosPromise<ApiSvcCategoriesBatch200Response> {
      return localVarFp
        .categoriesBatch(orgId, apiSvcBatchLookupRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateCategoryRequest} apiSvcCreateCategoryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCategory(
      orgId: string,
      apiSvcCreateCategoryRequest: ApiSvcCreateCategoryRequest,
      options?: any
    ): AxiosPromise<ApiSvcCombineTransactionsV2200ResponseAnyOf> {
      return localVarFp
        .createCategory(orgId, apiSvcCreateCategoryRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCategories(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcGetCategories200Response> {
      return localVarFp
        .getCategories(orgId, pageLimit, paginationToken, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
  /**
   * Bulk existence check for a bounded set of category ids (<= 100). Returns the subset that exist. Same contract/rationale as ContactsController.contactsBatch.
   * @param {string} orgId
   * @param {ApiSvcBatchLookupRequest} apiSvcBatchLookupRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesBatch(
    orgId: string,
    apiSvcBatchLookupRequest: ApiSvcBatchLookupRequest,
    options?: AxiosRequestConfig
  ) {
    return CategoriesApiFp(this.configuration)
      .categoriesBatch(orgId, apiSvcBatchLookupRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateCategoryRequest} apiSvcCreateCategoryRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public createCategory(
    orgId: string,
    apiSvcCreateCategoryRequest: ApiSvcCreateCategoryRequest,
    options?: AxiosRequestConfig
  ) {
    return CategoriesApiFp(this.configuration)
      .createCategory(orgId, apiSvcCreateCategoryRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {number} [pageLimit]
   * @param {string} [paginationToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public getCategories(orgId: string, pageLimit?: number, paginationToken?: string, options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .getCategories(orgId, pageLimit, paginationToken, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ClientDataApi - axios parameter creator
 * @export
 */
export const ClientDataApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} clientId
     * @param {string} accountId
     * @param {string} transactionId
     * @param {ApiSvcCreateTransferRecord} apiSvcCreateTransferRecord
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createClientTransaction: async (
      orgId: string,
      clientId: string,
      accountId: string,
      transactionId: string,
      apiSvcCreateTransferRecord: ApiSvcCreateTransferRecord,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createClientTransaction', 'orgId', orgId);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('createClientTransaction', 'clientId', clientId);
      // verify required parameter 'accountId' is not null or undefined
      assertParamExists('createClientTransaction', 'accountId', accountId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('createClientTransaction', 'transactionId', transactionId);
      // verify required parameter 'apiSvcCreateTransferRecord' is not null or undefined
      assertParamExists('createClientTransaction', 'apiSvcCreateTransferRecord', apiSvcCreateTransferRecord);
      const localVarPath = `/orgs/{orgId}/clients/{clientId}/accounts/{accountId}/transactions/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'accountId'}}`, encodeURIComponent(String(accountId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateTransferRecord,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateGainLossReport: async (
      orgId: string,
      customerId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('generateGainLossReport', 'orgId', orgId);
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists('generateGainLossReport', 'customerId', customerId);
      const localVarPath = `/orgs/{orgId}/customers/{customerId}/reports/gainLossReport`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'customerId'}}`, encodeURIComponent(String(customerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} clientId
     * @param {boolean} [missingCostBasis]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientTransactions: async (
      orgId: string,
      clientId: string,
      missingCostBasis?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getClientTransactions', 'orgId', orgId);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('getClientTransactions', 'clientId', clientId);
      const localVarPath = `/orgs/{orgId}/clients/{clientId}/transactions`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (missingCostBasis !== undefined) {
        localVarQueryParameter['missingCostBasis'] = missingCostBasis;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getClients', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/clients`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientsV2: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getClientsV2', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/v2/clients`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} clientOrgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientsWallets: async (
      orgId: string,
      clientOrgId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getClientsWallets', 'orgId', orgId);
      // verify required parameter 'clientOrgId' is not null or undefined
      assertParamExists('getClientsWallets', 'clientOrgId', clientOrgId);
      const localVarPath = `/orgs/{orgId}/clients/{clientOrgId}/wallets`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'clientOrgId'}}`, encodeURIComponent(String(clientOrgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerReports: async (
      orgId: string,
      customerId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getCustomerReports', 'orgId', orgId);
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists('getCustomerReports', 'customerId', customerId);
      const localVarPath = `/orgs/{orgId}/customers/{customerId}/reports`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'customerId'}}`, encodeURIComponent(String(customerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmployeesV2: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getEmployeesV2', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/v2/employees`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ClientDataApi - functional programming interface
 * @export
 */
export const ClientDataApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ClientDataApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} clientId
     * @param {string} accountId
     * @param {string} transactionId
     * @param {ApiSvcCreateTransferRecord} apiSvcCreateTransferRecord
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createClientTransaction(
      orgId: string,
      clientId: string,
      accountId: string,
      transactionId: string,
      apiSvcCreateTransferRecord: ApiSvcCreateTransferRecord,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateClientTransaction200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createClientTransaction(
        orgId,
        clientId,
        accountId,
        transactionId,
        apiSvcCreateTransferRecord,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateGainLossReport(
      orgId: string,
      customerId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcReportExecutionTask>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generateGainLossReport(orgId, customerId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} clientId
     * @param {boolean} [missingCostBasis]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClientTransactions(
      orgId: string,
      clientId: string,
      missingCostBasis?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcTxnLiteRecordResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getClientTransactions(
        orgId,
        clientId,
        missingCostBasis,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClients(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetClients200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getClients(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClientsV2(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetClientsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getClientsV2(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} clientOrgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClientsWallets(
      orgId: string,
      clientOrgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcWalletResponseDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getClientsWallets(orgId, clientOrgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCustomerReports(
      orgId: string,
      customerId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcReportsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerReports(orgId, customerId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEmployeesV2(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetClientsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeesV2(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ClientDataApi - factory interface
 * @export
 */
export const ClientDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ClientDataApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} clientId
     * @param {string} accountId
     * @param {string} transactionId
     * @param {ApiSvcCreateTransferRecord} apiSvcCreateTransferRecord
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createClientTransaction(
      orgId: string,
      clientId: string,
      accountId: string,
      transactionId: string,
      apiSvcCreateTransferRecord: ApiSvcCreateTransferRecord,
      options?: any
    ): AxiosPromise<ApiSvcCreateClientTransaction200Response> {
      return localVarFp
        .createClientTransaction(orgId, clientId, accountId, transactionId, apiSvcCreateTransferRecord, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateGainLossReport(orgId: string, customerId: string, options?: any): AxiosPromise<ApiSvcReportExecutionTask> {
      return localVarFp.generateGainLossReport(orgId, customerId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} clientId
     * @param {boolean} [missingCostBasis]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientTransactions(
      orgId: string,
      clientId: string,
      missingCostBasis?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcTxnLiteRecordResult> {
      return localVarFp
        .getClientTransactions(orgId, clientId, missingCostBasis, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients(orgId: string, options?: any): AxiosPromise<ApiSvcGetClients200Response> {
      return localVarFp.getClients(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientsV2(orgId: string, options?: any): AxiosPromise<ApiSvcGetClientsV2200Response> {
      return localVarFp.getClientsV2(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} clientOrgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientsWallets(orgId: string, clientOrgId: string, options?: any): AxiosPromise<Array<ApiSvcWalletResponseDTO>> {
      return localVarFp.getClientsWallets(orgId, clientOrgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerReports(orgId: string, customerId: string, options?: any): AxiosPromise<ApiSvcReportsResponse> {
      return localVarFp.getCustomerReports(orgId, customerId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmployeesV2(orgId: string, options?: any): AxiosPromise<ApiSvcGetClientsV2200Response> {
      return localVarFp.getEmployeesV2(orgId, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * ClientDataApi - object-oriented interface
 * @export
 * @class ClientDataApi
 * @extends {BaseAPI}
 */
export class ClientDataApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {string} clientId
   * @param {string} accountId
   * @param {string} transactionId
   * @param {ApiSvcCreateTransferRecord} apiSvcCreateTransferRecord
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataApi
   */
  public createClientTransaction(
    orgId: string,
    clientId: string,
    accountId: string,
    transactionId: string,
    apiSvcCreateTransferRecord: ApiSvcCreateTransferRecord,
    options?: AxiosRequestConfig
  ) {
    return ClientDataApiFp(this.configuration)
      .createClientTransaction(orgId, clientId, accountId, transactionId, apiSvcCreateTransferRecord, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} customerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataApi
   */
  public generateGainLossReport(orgId: string, customerId: string, options?: AxiosRequestConfig) {
    return ClientDataApiFp(this.configuration)
      .generateGainLossReport(orgId, customerId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} clientId
   * @param {boolean} [missingCostBasis]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataApi
   */
  public getClientTransactions(
    orgId: string,
    clientId: string,
    missingCostBasis?: boolean,
    options?: AxiosRequestConfig
  ) {
    return ClientDataApiFp(this.configuration)
      .getClientTransactions(orgId, clientId, missingCostBasis, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataApi
   */
  public getClients(orgId: string, options?: AxiosRequestConfig) {
    return ClientDataApiFp(this.configuration)
      .getClients(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataApi
   */
  public getClientsV2(orgId: string, options?: AxiosRequestConfig) {
    return ClientDataApiFp(this.configuration)
      .getClientsV2(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} clientOrgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataApi
   */
  public getClientsWallets(orgId: string, clientOrgId: string, options?: AxiosRequestConfig) {
    return ClientDataApiFp(this.configuration)
      .getClientsWallets(orgId, clientOrgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} customerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataApi
   */
  public getCustomerReports(orgId: string, customerId: string, options?: AxiosRequestConfig) {
    return ClientDataApiFp(this.configuration)
      .getCustomerReports(orgId, customerId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClientDataApi
   */
  public getEmployeesV2(orgId: string, options?: AxiosRequestConfig) {
    return ClientDataApiFp(this.configuration)
      .getEmployeesV2(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ConnectionsApi - axios parameter creator
 * @export
 */
export const ConnectionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConnection: async (
      orgId: string,
      apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createConnection', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateConnectionDTO' is not null or undefined
      assertParamExists('createConnection', 'apiSvcCreateConnectionDTO', apiSvcCreateConnectionDTO);
      const localVarPath = `/orgs/{orgId}/connections`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateConnectionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcCreateMetadataDTO} apiSvcCreateMetadataDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConnectionMetadata: async (
      orgId: string,
      connectionId: string,
      apiSvcCreateMetadataDTO: ApiSvcCreateMetadataDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createConnectionMetadata', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('createConnectionMetadata', 'connectionId', connectionId);
      // verify required parameter 'apiSvcCreateMetadataDTO' is not null or undefined
      assertParamExists('createConnectionMetadata', 'apiSvcCreateMetadataDTO', apiSvcCreateMetadataDTO);
      const localVarPath = `/orgs/{orgId}/connection/{connectionId}/metadata`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateMetadataDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create a manual accounting connection for an organization. Manual connections come pre-configured with default Digital Assets and Crypto Fees categories.
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createManualAccountingConnection: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createManualAccountingConnection', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/connections/manual`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcEnableConnectionMetadataRequest} apiSvcEnableConnectionMetadataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableConnectionMetadata: async (
      orgId: string,
      connectionId: string,
      apiSvcEnableConnectionMetadataRequest: ApiSvcEnableConnectionMetadataRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('disableConnectionMetadata', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('disableConnectionMetadata', 'connectionId', connectionId);
      // verify required parameter 'apiSvcEnableConnectionMetadataRequest' is not null or undefined
      assertParamExists(
        'disableConnectionMetadata',
        'apiSvcEnableConnectionMetadataRequest',
        apiSvcEnableConnectionMetadataRequest
      );
      const localVarPath = `/orgs/{orgId}/connection/{connectionId}/metadata!disable`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcEnableConnectionMetadataRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcEnableConnectionMetadataRequest} apiSvcEnableConnectionMetadataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableConnectionMetadata: async (
      orgId: string,
      connectionId: string,
      apiSvcEnableConnectionMetadataRequest: ApiSvcEnableConnectionMetadataRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('enableConnectionMetadata', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('enableConnectionMetadata', 'connectionId', connectionId);
      // verify required parameter 'apiSvcEnableConnectionMetadataRequest' is not null or undefined
      assertParamExists(
        'enableConnectionMetadata',
        'apiSvcEnableConnectionMetadataRequest',
        apiSvcEnableConnectionMetadataRequest
      );
      const localVarPath = `/orgs/{orgId}/connection/{connectionId}/metadata!enable`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcEnableConnectionMetadataRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns information regarding a particular connection for your Bitwave organization.
     * @param {string} orgId
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConnection: async (
      orgId: string,
      connectionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getConnection', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('getConnection', 'connectionId', connectionId);
      const localVarPath = `/orgs/{orgId}/connections/{connectionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {boolean} [includeDisabled]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConnectionMetadata: async (
      orgId: string,
      connectionId: string,
      includeDisabled?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getConnectionMetadata', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('getConnectionMetadata', 'connectionId', connectionId);
      const localVarPath = `/orgs/{orgId}/connection/{connectionId}/metadata`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (includeDisabled !== undefined) {
        localVarQueryParameter['includeDisabled'] = includeDisabled;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns all connections associated with an organization.
     * @param {string} orgId
     * @param {ApiSvcConnectionType} [type]
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {boolean} [overrideCache]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConnections: async (
      orgId: string,
      type?: ApiSvcConnectionType,
      pageLimit?: number,
      paginationToken?: string,
      overrideCache?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getConnections', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/connections`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (pageLimit !== undefined) {
        localVarQueryParameter['pageLimit'] = pageLimit;
      }

      if (paginationToken !== undefined) {
        localVarQueryParameter['paginationToken'] = paginationToken;
      }

      if (overrideCache !== undefined) {
        localVarQueryParameter['overrideCache'] = overrideCache;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get subsidiary coin account mappings for an accounting connection. Returns both explicit mappings (user-configured) and materialized mappings (with inheritance).
     * @param {string} orgId
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubsidiaryCoinMappings: async (
      orgId: string,
      connectionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getSubsidiaryCoinMappings', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('getSubsidiaryCoinMappings', 'connectionId', connectionId);
      const localVarPath = `/orgs/{orgId}/connection/{connectionId}/subsidiary-coin-mappings`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rotateConnectionCredentials: async (
      orgId: string,
      connectionId: string,
      apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('rotateConnectionCredentials', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('rotateConnectionCredentials', 'connectionId', connectionId);
      // verify required parameter 'apiSvcCreateConnectionDTO' is not null or undefined
      assertParamExists('rotateConnectionCredentials', 'apiSvcCreateConnectionDTO', apiSvcCreateConnectionDTO);
      const localVarPath = `/orgs/{orgId}/connections/{connectionId}/credentials`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateConnectionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {string} metadataId
     * @param {ApiSvcUpdateNetsuiteWalletCustomRecord} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateConnectionMetadata: async (
      orgId: string,
      connectionId: string,
      metadataId: string,
      body: ApiSvcUpdateNetsuiteWalletCustomRecord,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateConnectionMetadata', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('updateConnectionMetadata', 'connectionId', connectionId);
      // verify required parameter 'metadataId' is not null or undefined
      assertParamExists('updateConnectionMetadata', 'metadataId', metadataId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('updateConnectionMetadata', 'body', body);
      const localVarPath = `/orgs/{orgId}/connection/{connectionId}/metadata/{metadataId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)))
        .replace(`{${'metadataId'}}`, encodeURIComponent(String(metadataId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcUpdateMetadataFromRemoteSourceDTO} apiSvcUpdateMetadataFromRemoteSourceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateConnectionMetadataFromRemoteSource: async (
      orgId: string,
      connectionId: string,
      apiSvcUpdateMetadataFromRemoteSourceDTO: ApiSvcUpdateMetadataFromRemoteSourceDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateConnectionMetadataFromRemoteSource', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('updateConnectionMetadataFromRemoteSource', 'connectionId', connectionId);
      // verify required parameter 'apiSvcUpdateMetadataFromRemoteSourceDTO' is not null or undefined
      assertParamExists(
        'updateConnectionMetadataFromRemoteSource',
        'apiSvcUpdateMetadataFromRemoteSourceDTO',
        apiSvcUpdateMetadataFromRemoteSourceDTO
      );
      const localVarPath = `/orgs/{orgId}/connection/{connectionId}/metadata`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateMetadataFromRemoteSourceDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcPatchConnectionRequest} apiSvcPatchConnectionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePartial: async (
      orgId: string,
      connectionId: string,
      apiSvcPatchConnectionRequest: ApiSvcPatchConnectionRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updatePartial', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('updatePartial', 'connectionId', connectionId);
      // verify required parameter 'apiSvcPatchConnectionRequest' is not null or undefined
      assertParamExists('updatePartial', 'apiSvcPatchConnectionRequest', apiSvcPatchConnectionRequest);
      const localVarPath = `/orgs/{orgId}/connections/{connectionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcPatchConnectionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update subsidiary coin account mappings for an accounting connection. Mappings define which GL accounts to use for each cryptocurrency per subsidiary. Child subsidiaries inherit parent mappings, with child mappings overriding parent mappings.
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcUpdateSubsidiaryCoinMappingsRequest} apiSvcUpdateSubsidiaryCoinMappingsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubsidiaryCoinMappings: async (
      orgId: string,
      connectionId: string,
      apiSvcUpdateSubsidiaryCoinMappingsRequest: ApiSvcUpdateSubsidiaryCoinMappingsRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateSubsidiaryCoinMappings', 'orgId', orgId);
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('updateSubsidiaryCoinMappings', 'connectionId', connectionId);
      // verify required parameter 'apiSvcUpdateSubsidiaryCoinMappingsRequest' is not null or undefined
      assertParamExists(
        'updateSubsidiaryCoinMappings',
        'apiSvcUpdateSubsidiaryCoinMappingsRequest',
        apiSvcUpdateSubsidiaryCoinMappingsRequest
      );
      const localVarPath = `/orgs/{orgId}/connection/{connectionId}/subsidiary-coin-mappings`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'connectionId'}}`, encodeURIComponent(String(connectionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateSubsidiaryCoinMappingsRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateConnection: async (
      orgId: string,
      apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('validateConnection', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateConnectionDTO' is not null or undefined
      assertParamExists('validateConnection', 'apiSvcCreateConnectionDTO', apiSvcCreateConnectionDTO);
      const localVarPath = `/orgs/{orgId}/connections/validate`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateConnectionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ConnectionsApi - functional programming interface
 * @export
 */
export const ConnectionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ConnectionsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createConnection(
      orgId: string,
      apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateConnection200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createConnection(
        orgId,
        apiSvcCreateConnectionDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcCreateMetadataDTO} apiSvcCreateMetadataDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createConnectionMetadata(
      orgId: string,
      connectionId: string,
      apiSvcCreateMetadataDTO: ApiSvcCreateMetadataDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcMetadataRecordDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createConnectionMetadata(
        orgId,
        connectionId,
        apiSvcCreateMetadataDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Create a manual accounting connection for an organization. Manual connections come pre-configured with default Digital Assets and Crypto Fees categories.
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createManualAccountingConnection(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateManualAccountingConnection200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createManualAccountingConnection(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcEnableConnectionMetadataRequest} apiSvcEnableConnectionMetadataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disableConnectionMetadata(
      orgId: string,
      connectionId: string,
      apiSvcEnableConnectionMetadataRequest: ApiSvcEnableConnectionMetadataRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.disableConnectionMetadata(
        orgId,
        connectionId,
        apiSvcEnableConnectionMetadataRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcEnableConnectionMetadataRequest} apiSvcEnableConnectionMetadataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async enableConnectionMetadata(
      orgId: string,
      connectionId: string,
      apiSvcEnableConnectionMetadataRequest: ApiSvcEnableConnectionMetadataRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.enableConnectionMetadata(
        orgId,
        connectionId,
        apiSvcEnableConnectionMetadataRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns information regarding a particular connection for your Bitwave organization.
     * @param {string} orgId
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConnection(
      orgId: string,
      connectionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetConnection200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getConnection(orgId, connectionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {boolean} [includeDisabled]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConnectionMetadata(
      orgId: string,
      connectionId: string,
      includeDisabled?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcMetadataRecordDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionMetadata(
        orgId,
        connectionId,
        includeDisabled,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns all connections associated with an organization.
     * @param {string} orgId
     * @param {ApiSvcConnectionType} [type]
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {boolean} [overrideCache]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConnections(
      orgId: string,
      type?: ApiSvcConnectionType,
      pageLimit?: number,
      paginationToken?: string,
      overrideCache?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetConnections200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getConnections(
        orgId,
        type,
        pageLimit,
        paginationToken,
        overrideCache,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get subsidiary coin account mappings for an accounting connection. Returns both explicit mappings (user-configured) and materialized mappings (with inheritance).
     * @param {string} orgId
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubsidiaryCoinMappings(
      orgId: string,
      connectionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetSubsidiaryCoinMappings200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSubsidiaryCoinMappings(orgId, connectionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rotateConnectionCredentials(
      orgId: string,
      connectionId: string,
      apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRotateConnectionCredentials200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rotateConnectionCredentials(
        orgId,
        connectionId,
        apiSvcCreateConnectionDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {string} metadataId
     * @param {ApiSvcUpdateNetsuiteWalletCustomRecord} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateConnectionMetadata(
      orgId: string,
      connectionId: string,
      metadataId: string,
      body: ApiSvcUpdateNetsuiteWalletCustomRecord,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateConnectionMetadata(
        orgId,
        connectionId,
        metadataId,
        body,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcUpdateMetadataFromRemoteSourceDTO} apiSvcUpdateMetadataFromRemoteSourceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateConnectionMetadataFromRemoteSource(
      orgId: string,
      connectionId: string,
      apiSvcUpdateMetadataFromRemoteSourceDTO: ApiSvcUpdateMetadataFromRemoteSourceDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcMetadataRecordDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateConnectionMetadataFromRemoteSource(
        orgId,
        connectionId,
        apiSvcUpdateMetadataFromRemoteSourceDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcPatchConnectionRequest} apiSvcPatchConnectionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePartial(
      orgId: string,
      connectionId: string,
      apiSvcPatchConnectionRequest: ApiSvcPatchConnectionRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePartial(
        orgId,
        connectionId,
        apiSvcPatchConnectionRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update subsidiary coin account mappings for an accounting connection. Mappings define which GL accounts to use for each cryptocurrency per subsidiary. Child subsidiaries inherit parent mappings, with child mappings overriding parent mappings.
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcUpdateSubsidiaryCoinMappingsRequest} apiSvcUpdateSubsidiaryCoinMappingsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSubsidiaryCoinMappings(
      orgId: string,
      connectionId: string,
      apiSvcUpdateSubsidiaryCoinMappingsRequest: ApiSvcUpdateSubsidiaryCoinMappingsRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubsidiaryCoinMappings(
        orgId,
        connectionId,
        apiSvcUpdateSubsidiaryCoinMappingsRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async validateConnection(
      orgId: string,
      apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcAccountValidationResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.validateConnection(
        orgId,
        apiSvcCreateConnectionDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ConnectionsApi - factory interface
 * @export
 */
export const ConnectionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ConnectionsApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConnection(
      orgId: string,
      apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
      options?: any
    ): AxiosPromise<ApiSvcCreateConnection200Response> {
      return localVarFp
        .createConnection(orgId, apiSvcCreateConnectionDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcCreateMetadataDTO} apiSvcCreateMetadataDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConnectionMetadata(
      orgId: string,
      connectionId: string,
      apiSvcCreateMetadataDTO: ApiSvcCreateMetadataDTO,
      options?: any
    ): AxiosPromise<ApiSvcMetadataRecordDTO> {
      return localVarFp
        .createConnectionMetadata(orgId, connectionId, apiSvcCreateMetadataDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create a manual accounting connection for an organization. Manual connections come pre-configured with default Digital Assets and Crypto Fees categories.
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createManualAccountingConnection(
      orgId: string,
      options?: any
    ): AxiosPromise<ApiSvcCreateManualAccountingConnection200Response> {
      return localVarFp.createManualAccountingConnection(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcEnableConnectionMetadataRequest} apiSvcEnableConnectionMetadataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableConnectionMetadata(
      orgId: string,
      connectionId: string,
      apiSvcEnableConnectionMetadataRequest: ApiSvcEnableConnectionMetadataRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .disableConnectionMetadata(orgId, connectionId, apiSvcEnableConnectionMetadataRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcEnableConnectionMetadataRequest} apiSvcEnableConnectionMetadataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableConnectionMetadata(
      orgId: string,
      connectionId: string,
      apiSvcEnableConnectionMetadataRequest: ApiSvcEnableConnectionMetadataRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .enableConnectionMetadata(orgId, connectionId, apiSvcEnableConnectionMetadataRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns information regarding a particular connection for your Bitwave organization.
     * @param {string} orgId
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConnection(orgId: string, connectionId: string, options?: any): AxiosPromise<ApiSvcGetConnection200Response> {
      return localVarFp.getConnection(orgId, connectionId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {boolean} [includeDisabled]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConnectionMetadata(
      orgId: string,
      connectionId: string,
      includeDisabled?: boolean,
      options?: any
    ): AxiosPromise<Array<ApiSvcMetadataRecordDTO>> {
      return localVarFp
        .getConnectionMetadata(orgId, connectionId, includeDisabled, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns all connections associated with an organization.
     * @param {string} orgId
     * @param {ApiSvcConnectionType} [type]
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {boolean} [overrideCache]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConnections(
      orgId: string,
      type?: ApiSvcConnectionType,
      pageLimit?: number,
      paginationToken?: string,
      overrideCache?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcGetConnections200Response> {
      return localVarFp
        .getConnections(orgId, type, pageLimit, paginationToken, overrideCache, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get subsidiary coin account mappings for an accounting connection. Returns both explicit mappings (user-configured) and materialized mappings (with inheritance).
     * @param {string} orgId
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubsidiaryCoinMappings(
      orgId: string,
      connectionId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetSubsidiaryCoinMappings200Response> {
      return localVarFp
        .getSubsidiaryCoinMappings(orgId, connectionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rotateConnectionCredentials(
      orgId: string,
      connectionId: string,
      apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
      options?: any
    ): AxiosPromise<ApiSvcRotateConnectionCredentials200Response> {
      return localVarFp
        .rotateConnectionCredentials(orgId, connectionId, apiSvcCreateConnectionDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {string} metadataId
     * @param {ApiSvcUpdateNetsuiteWalletCustomRecord} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateConnectionMetadata(
      orgId: string,
      connectionId: string,
      metadataId: string,
      body: ApiSvcUpdateNetsuiteWalletCustomRecord,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateConnectionMetadata(orgId, connectionId, metadataId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcUpdateMetadataFromRemoteSourceDTO} apiSvcUpdateMetadataFromRemoteSourceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateConnectionMetadataFromRemoteSource(
      orgId: string,
      connectionId: string,
      apiSvcUpdateMetadataFromRemoteSourceDTO: ApiSvcUpdateMetadataFromRemoteSourceDTO,
      options?: any
    ): AxiosPromise<Array<ApiSvcMetadataRecordDTO>> {
      return localVarFp
        .updateConnectionMetadataFromRemoteSource(orgId, connectionId, apiSvcUpdateMetadataFromRemoteSourceDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcPatchConnectionRequest} apiSvcPatchConnectionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePartial(
      orgId: string,
      connectionId: string,
      apiSvcPatchConnectionRequest: ApiSvcPatchConnectionRequest,
      options?: any
    ): AxiosPromise<any> {
      return localVarFp
        .updatePartial(orgId, connectionId, apiSvcPatchConnectionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update subsidiary coin account mappings for an accounting connection. Mappings define which GL accounts to use for each cryptocurrency per subsidiary. Child subsidiaries inherit parent mappings, with child mappings overriding parent mappings.
     * @param {string} orgId
     * @param {string} connectionId
     * @param {ApiSvcUpdateSubsidiaryCoinMappingsRequest} apiSvcUpdateSubsidiaryCoinMappingsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubsidiaryCoinMappings(
      orgId: string,
      connectionId: string,
      apiSvcUpdateSubsidiaryCoinMappingsRequest: ApiSvcUpdateSubsidiaryCoinMappingsRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateSubsidiaryCoinMappings(orgId, connectionId, apiSvcUpdateSubsidiaryCoinMappingsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateConnection(
      orgId: string,
      apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
      options?: any
    ): AxiosPromise<ApiSvcAccountValidationResponse> {
      return localVarFp
        .validateConnection(orgId, apiSvcCreateConnectionDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ConnectionsApi - object-oriented interface
 * @export
 * @class ConnectionsApi
 * @extends {BaseAPI}
 */
export class ConnectionsApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public createConnection(
    orgId: string,
    apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .createConnection(orgId, apiSvcCreateConnectionDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} connectionId
   * @param {ApiSvcCreateMetadataDTO} apiSvcCreateMetadataDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public createConnectionMetadata(
    orgId: string,
    connectionId: string,
    apiSvcCreateMetadataDTO: ApiSvcCreateMetadataDTO,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .createConnectionMetadata(orgId, connectionId, apiSvcCreateMetadataDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Create a manual accounting connection for an organization. Manual connections come pre-configured with default Digital Assets and Crypto Fees categories.
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public createManualAccountingConnection(orgId: string, options?: AxiosRequestConfig) {
    return ConnectionsApiFp(this.configuration)
      .createManualAccountingConnection(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} connectionId
   * @param {ApiSvcEnableConnectionMetadataRequest} apiSvcEnableConnectionMetadataRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public disableConnectionMetadata(
    orgId: string,
    connectionId: string,
    apiSvcEnableConnectionMetadataRequest: ApiSvcEnableConnectionMetadataRequest,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .disableConnectionMetadata(orgId, connectionId, apiSvcEnableConnectionMetadataRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} connectionId
   * @param {ApiSvcEnableConnectionMetadataRequest} apiSvcEnableConnectionMetadataRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public enableConnectionMetadata(
    orgId: string,
    connectionId: string,
    apiSvcEnableConnectionMetadataRequest: ApiSvcEnableConnectionMetadataRequest,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .enableConnectionMetadata(orgId, connectionId, apiSvcEnableConnectionMetadataRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns information regarding a particular connection for your Bitwave organization.
   * @param {string} orgId
   * @param {string} connectionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public getConnection(orgId: string, connectionId: string, options?: AxiosRequestConfig) {
    return ConnectionsApiFp(this.configuration)
      .getConnection(orgId, connectionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} connectionId
   * @param {boolean} [includeDisabled]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public getConnectionMetadata(
    orgId: string,
    connectionId: string,
    includeDisabled?: boolean,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .getConnectionMetadata(orgId, connectionId, includeDisabled, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns all connections associated with an organization.
   * @param {string} orgId
   * @param {ApiSvcConnectionType} [type]
   * @param {number} [pageLimit]
   * @param {string} [paginationToken]
   * @param {boolean} [overrideCache]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public getConnections(
    orgId: string,
    type?: ApiSvcConnectionType,
    pageLimit?: number,
    paginationToken?: string,
    overrideCache?: boolean,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .getConnections(orgId, type, pageLimit, paginationToken, overrideCache, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get subsidiary coin account mappings for an accounting connection. Returns both explicit mappings (user-configured) and materialized mappings (with inheritance).
   * @param {string} orgId
   * @param {string} connectionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public getSubsidiaryCoinMappings(orgId: string, connectionId: string, options?: AxiosRequestConfig) {
    return ConnectionsApiFp(this.configuration)
      .getSubsidiaryCoinMappings(orgId, connectionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} connectionId
   * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public rotateConnectionCredentials(
    orgId: string,
    connectionId: string,
    apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .rotateConnectionCredentials(orgId, connectionId, apiSvcCreateConnectionDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} connectionId
   * @param {string} metadataId
   * @param {ApiSvcUpdateNetsuiteWalletCustomRecord} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public updateConnectionMetadata(
    orgId: string,
    connectionId: string,
    metadataId: string,
    body: ApiSvcUpdateNetsuiteWalletCustomRecord,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .updateConnectionMetadata(orgId, connectionId, metadataId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} connectionId
   * @param {ApiSvcUpdateMetadataFromRemoteSourceDTO} apiSvcUpdateMetadataFromRemoteSourceDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public updateConnectionMetadataFromRemoteSource(
    orgId: string,
    connectionId: string,
    apiSvcUpdateMetadataFromRemoteSourceDTO: ApiSvcUpdateMetadataFromRemoteSourceDTO,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .updateConnectionMetadataFromRemoteSource(orgId, connectionId, apiSvcUpdateMetadataFromRemoteSourceDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} connectionId
   * @param {ApiSvcPatchConnectionRequest} apiSvcPatchConnectionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public updatePartial(
    orgId: string,
    connectionId: string,
    apiSvcPatchConnectionRequest: ApiSvcPatchConnectionRequest,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .updatePartial(orgId, connectionId, apiSvcPatchConnectionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Update subsidiary coin account mappings for an accounting connection. Mappings define which GL accounts to use for each cryptocurrency per subsidiary. Child subsidiaries inherit parent mappings, with child mappings overriding parent mappings.
   * @param {string} orgId
   * @param {string} connectionId
   * @param {ApiSvcUpdateSubsidiaryCoinMappingsRequest} apiSvcUpdateSubsidiaryCoinMappingsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public updateSubsidiaryCoinMappings(
    orgId: string,
    connectionId: string,
    apiSvcUpdateSubsidiaryCoinMappingsRequest: ApiSvcUpdateSubsidiaryCoinMappingsRequest,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .updateSubsidiaryCoinMappings(orgId, connectionId, apiSvcUpdateSubsidiaryCoinMappingsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateConnectionDTO} apiSvcCreateConnectionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectionsApi
   */
  public validateConnection(
    orgId: string,
    apiSvcCreateConnectionDTO: ApiSvcCreateConnectionDTO,
    options?: AxiosRequestConfig
  ) {
    return ConnectionsApiFp(this.configuration)
      .validateConnection(orgId, apiSvcCreateConnectionDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Bulk existence check for a bounded set of contact ids (<= 100). Returns the subset that exist. Lets a caller (e.g. import-svc validating an upload) check only the contacts a file references instead of paging the whole list.
     * @param {string} orgId
     * @param {ApiSvcBatchLookupRequest} apiSvcBatchLookupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsBatch: async (
      orgId: string,
      apiSvcBatchLookupRequest: ApiSvcBatchLookupRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('contactsBatch', 'orgId', orgId);
      // verify required parameter 'apiSvcBatchLookupRequest' is not null or undefined
      assertParamExists('contactsBatch', 'apiSvcBatchLookupRequest', apiSvcBatchLookupRequest);
      const localVarPath = `/contacts/{orgId}/batch`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcBatchLookupRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns all the contacts for an organization within Bitwave. Contacts can either be created manually within Bitwave or imported from your ERP software via Bitwave integration.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContacts: async (
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getContacts', 'orgId', orgId);
      const localVarPath = `/contacts/{orgId}`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageLimit !== undefined) {
        localVarQueryParameter['pageLimit'] = pageLimit;
      }

      if (paginationToken !== undefined) {
        localVarQueryParameter['paginationToken'] = paginationToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Searches an organization\'s enabled contacts by name prefix. Intended for typeahead pickers: returns at most `limit` matches instead of the full contact list, which for large organizations can exceed 70k records.
     * @param {string} orgId
     * @param {string} nameQuery
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchContacts: async (
      orgId: string,
      nameQuery: string,
      limit?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('searchContacts', 'orgId', orgId);
      // verify required parameter 'nameQuery' is not null or undefined
      assertParamExists('searchContacts', 'nameQuery', nameQuery);
      const localVarPath = `/contacts/{orgId}/search`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (nameQuery !== undefined) {
        localVarQueryParameter['nameQuery'] = nameQuery;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration);
  return {
    /**
     * Bulk existence check for a bounded set of contact ids (<= 100). Returns the subset that exist. Lets a caller (e.g. import-svc validating an upload) check only the contacts a file references instead of paging the whole list.
     * @param {string} orgId
     * @param {ApiSvcBatchLookupRequest} apiSvcBatchLookupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsBatch(
      orgId: string,
      apiSvcBatchLookupRequest: ApiSvcBatchLookupRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCategoriesBatch200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsBatch(orgId, apiSvcBatchLookupRequest, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns all the contacts for an organization within Bitwave. Contacts can either be created manually within Bitwave or imported from your ERP software via Bitwave integration.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getContacts(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetContacts200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getContacts(orgId, pageLimit, paginationToken, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Searches an organization\'s enabled contacts by name prefix. Intended for typeahead pickers: returns at most `limit` matches instead of the full contact list, which for large organizations can exceed 70k records.
     * @param {string} orgId
     * @param {string} nameQuery
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchContacts(
      orgId: string,
      nameQuery: string,
      limit?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetContacts200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchContacts(orgId, nameQuery, limit, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ContactsApiFp(configuration);
  return {
    /**
     * Bulk existence check for a bounded set of contact ids (<= 100). Returns the subset that exist. Lets a caller (e.g. import-svc validating an upload) check only the contacts a file references instead of paging the whole list.
     * @param {string} orgId
     * @param {ApiSvcBatchLookupRequest} apiSvcBatchLookupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsBatch(
      orgId: string,
      apiSvcBatchLookupRequest: ApiSvcBatchLookupRequest,
      options?: any
    ): AxiosPromise<ApiSvcCategoriesBatch200Response> {
      return localVarFp
        .contactsBatch(orgId, apiSvcBatchLookupRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns all the contacts for an organization within Bitwave. Contacts can either be created manually within Bitwave or imported from your ERP software via Bitwave integration.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContacts(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcGetContacts200Response> {
      return localVarFp
        .getContacts(orgId, pageLimit, paginationToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Searches an organization\'s enabled contacts by name prefix. Intended for typeahead pickers: returns at most `limit` matches instead of the full contact list, which for large organizations can exceed 70k records.
     * @param {string} orgId
     * @param {string} nameQuery
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchContacts(
      orgId: string,
      nameQuery: string,
      limit?: number,
      options?: any
    ): AxiosPromise<ApiSvcGetContacts200Response> {
      return localVarFp.searchContacts(orgId, nameQuery, limit, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
  /**
   * Bulk existence check for a bounded set of contact ids (<= 100). Returns the subset that exist. Lets a caller (e.g. import-svc validating an upload) check only the contacts a file references instead of paging the whole list.
   * @param {string} orgId
   * @param {ApiSvcBatchLookupRequest} apiSvcBatchLookupRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsBatch(
    orgId: string,
    apiSvcBatchLookupRequest: ApiSvcBatchLookupRequest,
    options?: AxiosRequestConfig
  ) {
    return ContactsApiFp(this.configuration)
      .contactsBatch(orgId, apiSvcBatchLookupRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns all the contacts for an organization within Bitwave. Contacts can either be created manually within Bitwave or imported from your ERP software via Bitwave integration.
   * @param {string} orgId
   * @param {number} [pageLimit]
   * @param {string} [paginationToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public getContacts(orgId: string, pageLimit?: number, paginationToken?: string, options?: AxiosRequestConfig) {
    return ContactsApiFp(this.configuration)
      .getContacts(orgId, pageLimit, paginationToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Searches an organization\'s enabled contacts by name prefix. Intended for typeahead pickers: returns at most `limit` matches instead of the full contact list, which for large organizations can exceed 70k records.
   * @param {string} orgId
   * @param {string} nameQuery
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public searchContacts(orgId: string, nameQuery: string, limit?: number, options?: AxiosRequestConfig) {
    return ContactsApiFp(this.configuration)
      .searchContacts(orgId, nameQuery, limit, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcVarianceReportCreationParams} apiSvcVarianceReportCreationParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createVarianceReport: async (
      orgId: string,
      apiSvcVarianceReportCreationParams: ApiSvcVarianceReportCreationParams,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createVarianceReport', 'orgId', orgId);
      // verify required parameter 'apiSvcVarianceReportCreationParams' is not null or undefined
      assertParamExists(
        'createVarianceReport',
        'apiSvcVarianceReportCreationParams',
        apiSvcVarianceReportCreationParams
      );
      const localVarPath = `/orgs/{orgId}/variance`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcVarianceReportCreationParams,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcVarianceReportCreationParams} apiSvcVarianceReportCreationParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createVarianceReport(
      orgId: string,
      apiSvcVarianceReportCreationParams: ApiSvcVarianceReportCreationParams,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateVarianceReport200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createVarianceReport(
        orgId,
        apiSvcVarianceReportCreationParams,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = DefaultApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcVarianceReportCreationParams} apiSvcVarianceReportCreationParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createVarianceReport(
      orgId: string,
      apiSvcVarianceReportCreationParams: ApiSvcVarianceReportCreationParams,
      options?: any
    ): AxiosPromise<ApiSvcCreateVarianceReport200Response> {
      return localVarFp
        .createVarianceReport(orgId, apiSvcVarianceReportCreationParams, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {ApiSvcVarianceReportCreationParams} apiSvcVarianceReportCreationParams
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createVarianceReport(
    orgId: string,
    apiSvcVarianceReportCreationParams: ApiSvcVarianceReportCreationParams,
    options?: AxiosRequestConfig
  ) {
    return DefaultApiFp(this.configuration)
      .createVarianceReport(orgId, apiSvcVarianceReportCreationParams, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ExportApi - axios parameter creator
 * @export
 */
export const ExportApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} exportId
     * @param {boolean} rawUrl
     * @param {string} [exportType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExport: async (
      orgId: string,
      exportId: string,
      rawUrl: boolean,
      exportType?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getExport', 'orgId', orgId);
      // verify required parameter 'exportId' is not null or undefined
      assertParamExists('getExport', 'exportId', exportId);
      // verify required parameter 'rawUrl' is not null or undefined
      assertParamExists('getExport', 'rawUrl', rawUrl);
      const localVarPath = `/v2/orgs/{orgId}/exports/{exportId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'exportId'}}`, encodeURIComponent(String(exportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (rawUrl !== undefined) {
        localVarQueryParameter['rawUrl'] = rawUrl;
      }

      if (exportType !== undefined) {
        localVarQueryParameter['exportType'] = exportType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} exportId
     * @param {string} [exportType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExportPost: async (
      orgId: string,
      exportId: string,
      exportType?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getExportPost', 'orgId', orgId);
      // verify required parameter 'exportId' is not null or undefined
      assertParamExists('getExportPost', 'exportId', exportId);
      const localVarPath = `/v2/orgs/{orgId}/exports/{exportId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'exportId'}}`, encodeURIComponent(String(exportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (exportType !== undefined) {
        localVarQueryParameter['exportType'] = exportType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listExports: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('listExports', 'orgId', orgId);
      const localVarPath = `/v2/orgs/{orgId}/exports`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportParams} apiSvcRunReportParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runExport: async (
      orgId: string,
      apiSvcRunReportParams: ApiSvcRunReportParams,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('runExport', 'orgId', orgId);
      // verify required parameter 'apiSvcRunReportParams' is not null or undefined
      assertParamExists('runExport', 'apiSvcRunReportParams', apiSvcRunReportParams);
      const localVarPath = `/v2/orgs/{orgId}/exports`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(apiSvcRunReportParams, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExportApi - functional programming interface
 * @export
 */
export const ExportApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ExportApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} exportId
     * @param {boolean} rawUrl
     * @param {string} [exportType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getExport(
      orgId: string,
      exportId: string,
      rawUrl: boolean,
      exportType?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getExport(orgId, exportId, rawUrl, exportType, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} exportId
     * @param {string} [exportType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getExportPost(
      orgId: string,
      exportId: string,
      exportType?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getExportPost(orgId, exportId, exportType, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listExports(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listExports(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportParams} apiSvcRunReportParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async runExport(
      orgId: string,
      apiSvcRunReportParams: ApiSvcRunReportParams,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.runExport(orgId, apiSvcRunReportParams, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ExportApi - factory interface
 * @export
 */
export const ExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ExportApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} exportId
     * @param {boolean} rawUrl
     * @param {string} [exportType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExport(orgId: string, exportId: string, rawUrl: boolean, exportType?: string, options?: any): AxiosPromise<any> {
      return localVarFp
        .getExport(orgId, exportId, rawUrl, exportType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} exportId
     * @param {string} [exportType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExportPost(orgId: string, exportId: string, exportType?: string, options?: any): AxiosPromise<any> {
      return localVarFp.getExportPost(orgId, exportId, exportType, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listExports(orgId: string, options?: any): AxiosPromise<any> {
      return localVarFp.listExports(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportParams} apiSvcRunReportParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runExport(orgId: string, apiSvcRunReportParams: ApiSvcRunReportParams, options?: any): AxiosPromise<any> {
      return localVarFp.runExport(orgId, apiSvcRunReportParams, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * ExportApi - object-oriented interface
 * @export
 * @class ExportApi
 * @extends {BaseAPI}
 */
export class ExportApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {string} exportId
   * @param {boolean} rawUrl
   * @param {string} [exportType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  public getExport(
    orgId: string,
    exportId: string,
    rawUrl: boolean,
    exportType?: string,
    options?: AxiosRequestConfig
  ) {
    return ExportApiFp(this.configuration)
      .getExport(orgId, exportId, rawUrl, exportType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} exportId
   * @param {string} [exportType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  public getExportPost(orgId: string, exportId: string, exportType?: string, options?: AxiosRequestConfig) {
    return ExportApiFp(this.configuration)
      .getExportPost(orgId, exportId, exportType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  public listExports(orgId: string, options?: AxiosRequestConfig) {
    return ExportApiFp(this.configuration)
      .listExports(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRunReportParams} apiSvcRunReportParams
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  public runExport(orgId: string, apiSvcRunReportParams: ApiSvcRunReportParams, options?: AxiosRequestConfig) {
    return ExportApiFp(this.configuration)
      .runExport(orgId, apiSvcRunReportParams, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} inventoryViewUpdateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelViewUpdate: async (
      orgId: string,
      inventoryViewId: string,
      inventoryViewUpdateId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('cancelViewUpdate', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('cancelViewUpdate', 'inventoryViewId', inventoryViewId);
      // verify required parameter 'inventoryViewUpdateId' is not null or undefined
      assertParamExists('cancelViewUpdate', 'inventoryViewUpdateId', inventoryViewUpdateId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/{inventoryViewUpdateId}/cancel`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)))
        .replace(`{${'inventoryViewUpdateId'}}`, encodeURIComponent(String(inventoryViewUpdateId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateInventoryGroupRequest} apiSvcCreateInventoryGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInventoryGroup: async (
      orgId: string,
      apiSvcCreateInventoryGroupRequest: ApiSvcCreateInventoryGroupRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createInventoryGroup', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateInventoryGroupRequest' is not null or undefined
      assertParamExists('createInventoryGroup', 'apiSvcCreateInventoryGroupRequest', apiSvcCreateInventoryGroupRequest);
      const localVarPath = `/orgs/{orgId}/inventory-groups`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateInventoryGroupRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateInventoryViewRequest} apiSvcCreateInventoryViewRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createView: async (
      orgId: string,
      apiSvcCreateInventoryViewRequest: ApiSvcCreateInventoryViewRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createView', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateInventoryViewRequest' is not null or undefined
      assertParamExists('createView', 'apiSvcCreateInventoryViewRequest', apiSvcCreateInventoryViewRequest);
      const localVarPath = `/orgs/{orgId}/inventory-views`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateInventoryViewRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInventory: async (
      orgId: string,
      inventoryId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deleteInventory', 'orgId', orgId);
      // verify required parameter 'inventoryId' is not null or undefined
      assertParamExists('deleteInventory', 'inventoryId', inventoryId);
      const localVarPath = `/orgs/{orgId}/inventories/{inventoryId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryId'}}`, encodeURIComponent(String(inventoryId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInventoryGroup: async (
      orgId: string,
      inventoryGroupId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deleteInventoryGroup', 'orgId', orgId);
      // verify required parameter 'inventoryGroupId' is not null or undefined
      assertParamExists('deleteInventoryGroup', 'inventoryGroupId', inventoryGroupId);
      const localVarPath = `/orgs/{orgId}/inventory-groups/{inventoryGroupId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryGroupId'}}`, encodeURIComponent(String(inventoryGroupId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteView: async (
      orgId: string,
      inventoryViewId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deleteView', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('deleteView', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} colId
     * @param {boolean} showEmptyLots
     * @param {string} [asOf]
     * @param {string} [pageToken]
     * @param {string} [startDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionColumnUniqueValues: async (
      orgId: string,
      inventoryViewId: string,
      colId: string,
      showEmptyLots: boolean,
      asOf?: string,
      pageToken?: string,
      startDate?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getActionColumnUniqueValues', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getActionColumnUniqueValues', 'inventoryViewId', inventoryViewId);
      // verify required parameter 'colId' is not null or undefined
      assertParamExists('getActionColumnUniqueValues', 'colId', colId);
      // verify required parameter 'showEmptyLots' is not null or undefined
      assertParamExists('getActionColumnUniqueValues', 'showEmptyLots', showEmptyLots);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/actions/columns/{colId}/unique`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)))
        .replace(`{${'colId'}}`, encodeURIComponent(String(colId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (showEmptyLots !== undefined) {
        localVarQueryParameter['showEmptyLots'] = showEmptyLots;
      }

      if (asOf !== undefined) {
        localVarQueryParameter['asOf'] = asOf;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionColumns: async (
      orgId: string,
      inventoryViewId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getActionColumns', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getActionColumns', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/actions/columns`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionsJeReport: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getActionsJeReport', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getActionsJeReport', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/actions-je-report`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {string} [granularity]
     * @param {boolean} [includeInternalTransfers]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionsSummaryReport: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      granularity?: string,
      includeInternalTransfers?: boolean,
      exportResults?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getActionsSummaryReport', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getActionsSummaryReport', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/actions-summary-report`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (granularity !== undefined) {
        localVarQueryParameter['granularity'] = granularity;
      }

      if (includeInternalTransfers !== undefined) {
        localVarQueryParameter['includeInternalTransfers'] = includeInternalTransfers;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionsTrialBalanceReport: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getActionsTrialBalanceReport', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getActionsTrialBalanceReport', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/actions-tb-report`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdvancedActionsReport: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getAdvancedActionsReport', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getAdvancedActionsReport', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/advanced-action-report`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [useInventory]
     * @param {boolean} [useWallet]
     * @param {boolean} [useLot]
     * @param {boolean} [exportResults]
     * @param {boolean} [includeFmv]
     * @param {boolean} [includeSubsidiary]
     * @param {boolean} [excludeInternalTransfersFromCostBasisCalculations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdvancedCostBasisRollForward: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      useInventory?: boolean,
      useWallet?: boolean,
      useLot?: boolean,
      exportResults?: boolean,
      includeFmv?: boolean,
      includeSubsidiary?: boolean,
      excludeInternalTransfersFromCostBasisCalculations?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getAdvancedCostBasisRollForward', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getAdvancedCostBasisRollForward', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/advanced-cost-basis-roll-forward`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (useInventory !== undefined) {
        localVarQueryParameter['useInventory'] = useInventory;
      }

      if (useWallet !== undefined) {
        localVarQueryParameter['useWallet'] = useWallet;
      }

      if (useLot !== undefined) {
        localVarQueryParameter['useLot'] = useLot;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      if (includeFmv !== undefined) {
        localVarQueryParameter['includeFmv'] = includeFmv;
      }

      if (includeSubsidiary !== undefined) {
        localVarQueryParameter['includeSubsidiary'] = includeSubsidiary;
      }

      if (excludeInternalTransfersFromCostBasisCalculations !== undefined) {
        localVarQueryParameter['excludeInternalTransfersFromCostBasisCalculations'] =
          excludeInternalTransfersFromCostBasisCalculations;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryBalanceCheckReport: async (
      orgId: string,
      endDate?: string,
      exportResults?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInventoryBalanceCheckReport', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/inventory-views/reports/balance-check-report`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {number} [pageSize]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryBalanceCheckReportPaginated: async (
      orgId: string,
      endDate?: string,
      exportResults?: boolean,
      pageSize?: number,
      pageToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInventoryBalanceCheckReportPaginated', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/inventory-views/reports/balance-check-report-paginated`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {boolean} [includeFmv]
     * @param {boolean} [includeSubsidiary]
     * @param {boolean} [excludeInternalTransfersFromCostBasisCalculations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryCostBasisRollForward: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      includeFmv?: boolean,
      includeSubsidiary?: boolean,
      excludeInternalTransfersFromCostBasisCalculations?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInventoryCostBasisRollForward', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getInventoryCostBasisRollForward', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/cost-basis-roll-forward`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      if (includeFmv !== undefined) {
        localVarQueryParameter['includeFmv'] = includeFmv;
      }

      if (includeSubsidiary !== undefined) {
        localVarQueryParameter['includeSubsidiary'] = includeSubsidiary;
      }

      if (excludeInternalTransfersFromCostBasisCalculations !== undefined) {
        localVarQueryParameter['excludeInternalTransfersFromCostBasisCalculations'] =
          excludeInternalTransfersFromCostBasisCalculations;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {Array<string>} [inventory]
     * @param {Array<string>} [subsidiaryId]
     * @param {Array<string>} [walletId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryEnhancedGainLoss: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      inventory?: Array<string>,
      subsidiaryId?: Array<string>,
      walletId?: Array<string>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInventoryEnhancedGainLoss', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getInventoryEnhancedGainLoss', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/enhanced-gain-loss`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      if (inventory) {
        localVarQueryParameter['inventory'] = inventory;
      }

      if (subsidiaryId) {
        localVarQueryParameter['subsidiaryId'] = subsidiaryId;
      }

      if (walletId) {
        localVarQueryParameter['walletId'] = walletId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryGroup: async (
      orgId: string,
      inventoryGroupId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInventoryGroup', 'orgId', orgId);
      // verify required parameter 'inventoryGroupId' is not null or undefined
      assertParamExists('getInventoryGroup', 'inventoryGroupId', inventoryGroupId);
      const localVarPath = `/orgs/{orgId}/inventory-groups/{inventoryGroupId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryGroupId'}}`, encodeURIComponent(String(inventoryGroupId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryGroups: async (
      orgId: string,
      pageToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInventoryGroups', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/inventory-groups`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryJeReclass: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInventoryJeReclass', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getInventoryJeReclass', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/je-reclass`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryRows: async (
      orgId: string,
      inventoryViewId: string,
      pageToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInventoryRows', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getInventoryRows', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/rows`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} colId
     * @param {boolean} showEmptyLots
     * @param {string} [asOf]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLotColumnUniqueValues: async (
      orgId: string,
      inventoryViewId: string,
      colId: string,
      showEmptyLots: boolean,
      asOf?: string,
      pageToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getLotColumnUniqueValues', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getLotColumnUniqueValues', 'inventoryViewId', inventoryViewId);
      // verify required parameter 'colId' is not null or undefined
      assertParamExists('getLotColumnUniqueValues', 'colId', colId);
      // verify required parameter 'showEmptyLots' is not null or undefined
      assertParamExists('getLotColumnUniqueValues', 'showEmptyLots', showEmptyLots);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/lots/columns/{colId}/unique`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)))
        .replace(`{${'colId'}}`, encodeURIComponent(String(colId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (showEmptyLots !== undefined) {
        localVarQueryParameter['showEmptyLots'] = showEmptyLots;
      }

      if (asOf !== undefined) {
        localVarQueryParameter['asOf'] = asOf;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLotColumns: async (
      orgId: string,
      inventoryViewId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getLotColumns', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getLotColumns', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/lots/columns`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRippleInventoryCostBasisRollForward: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getRippleInventoryCostBasisRollForward', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getRippleInventoryCostBasisRollForward', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/ripple-cost-basis-roll-forward`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSageErpJeReport: async (
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getSageErpJeReport', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getSageErpJeReport', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/sage-erp-je-report`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSodaReport: async (
      orgId: string,
      inventoryViewId: string,
      endDate?: string,
      exportResults?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getSodaReport', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getSodaReport', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/soda-report`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} inventoryViewUpdateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUpdateDownloadLinks: async (
      orgId: string,
      inventoryViewId: string,
      inventoryViewUpdateId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getUpdateDownloadLinks', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getUpdateDownloadLinks', 'inventoryViewId', inventoryViewId);
      // verify required parameter 'inventoryViewUpdateId' is not null or undefined
      assertParamExists('getUpdateDownloadLinks', 'inventoryViewUpdateId', inventoryViewUpdateId);
      const localVarPath =
        `/orgs/{orgId}/inventory-views/{inventoryViewId}/updates/{inventoryViewUpdateId}/download-links`
          .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
          .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)))
          .replace(`{${'inventoryViewUpdateId'}}`, encodeURIComponent(String(inventoryViewUpdateId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getView: async (orgId: string, inventoryViewId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getView', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getView', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {string} [pageToken]
     * @param {Array<string>} [runId]
     * @param {Array<number>} [timestampSEC]
     * @param {Array<string>} [action]
     * @param {Array<string>} [status]
     * @param {Array<string>} [txnId]
     * @param {Array<string>} [eventId]
     * @param {Array<string>} [lotId]
     * @param {Array<string>} [asset]
     * @param {Array<string>} [assetId]
     * @param {Array<string>} [assetUnitAdj]
     * @param {Array<string>} [assetBalance]
     * @param {Array<number>} [lotAcquisitionTimestampSEC]
     * @param {Array<string>} [txnExchangeRate]
     * @param {Array<string>} [carryingValue]
     * @param {Array<string>} [impairmentExpense]
     * @param {Array<string>} [fairMarketValueDisposed]
     * @param {Array<string>} [shortTermGainLoss]
     * @param {Array<string>} [longTermGainLoss]
     * @param {Array<string>} [undatedGainLoss]
     * @param {Array<string>} [costBasisAcquired]
     * @param {Array<string>} [costBasisRelieved]
     * @param {Array<string>} [costAverageRate]
     * @param {Array<boolean>} [isTrade]
     * @param {Array<string>} [lineError]
     * @param {string} [sortField]
     * @param {ApiSvcSortDirection} [sortDirection]
     * @param {boolean} [exportResults]
     * @param {Array<string>} [inventory]
     * @param {Array<string>} [wallet]
     * @param {Array<string>} [subsidiaryId]
     * @param {string} [startDate]
     * @param {Array<string>} [fromWallet]
     * @param {Array<string>} [toWallet]
     * @param {Array<string>} [category]
     * @param {Array<string>} [categoryType]
     * @param {Array<string>} [categoryCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewActions: async (
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      pageToken?: string,
      runId?: Array<string>,
      timestampSEC?: Array<number>,
      action?: Array<string>,
      status?: Array<string>,
      txnId?: Array<string>,
      eventId?: Array<string>,
      lotId?: Array<string>,
      asset?: Array<string>,
      assetId?: Array<string>,
      assetUnitAdj?: Array<string>,
      assetBalance?: Array<string>,
      lotAcquisitionTimestampSEC?: Array<number>,
      txnExchangeRate?: Array<string>,
      carryingValue?: Array<string>,
      impairmentExpense?: Array<string>,
      fairMarketValueDisposed?: Array<string>,
      shortTermGainLoss?: Array<string>,
      longTermGainLoss?: Array<string>,
      undatedGainLoss?: Array<string>,
      costBasisAcquired?: Array<string>,
      costBasisRelieved?: Array<string>,
      costAverageRate?: Array<string>,
      isTrade?: Array<boolean>,
      lineError?: Array<string>,
      sortField?: string,
      sortDirection?: ApiSvcSortDirection,
      exportResults?: boolean,
      inventory?: Array<string>,
      wallet?: Array<string>,
      subsidiaryId?: Array<string>,
      startDate?: string,
      fromWallet?: Array<string>,
      toWallet?: Array<string>,
      category?: Array<string>,
      categoryType?: Array<string>,
      categoryCode?: Array<string>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getViewActions', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getViewActions', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/actions`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (asOf !== undefined) {
        localVarQueryParameter['asOf'] = asOf;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      if (runId) {
        localVarQueryParameter['runId'] = runId;
      }

      if (timestampSEC) {
        localVarQueryParameter['timestampSEC'] = timestampSEC;
      }

      if (action) {
        localVarQueryParameter['action'] = action;
      }

      if (status) {
        localVarQueryParameter['status'] = status;
      }

      if (txnId) {
        localVarQueryParameter['txnId'] = txnId;
      }

      if (eventId) {
        localVarQueryParameter['eventId'] = eventId;
      }

      if (lotId) {
        localVarQueryParameter['lotId'] = lotId;
      }

      if (asset) {
        localVarQueryParameter['asset'] = asset;
      }

      if (assetId) {
        localVarQueryParameter['assetId'] = assetId;
      }

      if (assetUnitAdj) {
        localVarQueryParameter['assetUnitAdj'] = assetUnitAdj;
      }

      if (assetBalance) {
        localVarQueryParameter['assetBalance'] = assetBalance;
      }

      if (lotAcquisitionTimestampSEC) {
        localVarQueryParameter['lotAcquisitionTimestampSEC'] = lotAcquisitionTimestampSEC;
      }

      if (txnExchangeRate) {
        localVarQueryParameter['txnExchangeRate'] = txnExchangeRate;
      }

      if (carryingValue) {
        localVarQueryParameter['carryingValue'] = carryingValue;
      }

      if (impairmentExpense) {
        localVarQueryParameter['impairmentExpense'] = impairmentExpense;
      }

      if (fairMarketValueDisposed) {
        localVarQueryParameter['fairMarketValueDisposed'] = fairMarketValueDisposed;
      }

      if (shortTermGainLoss) {
        localVarQueryParameter['shortTermGainLoss'] = shortTermGainLoss;
      }

      if (longTermGainLoss) {
        localVarQueryParameter['longTermGainLoss'] = longTermGainLoss;
      }

      if (undatedGainLoss) {
        localVarQueryParameter['undatedGainLoss'] = undatedGainLoss;
      }

      if (costBasisAcquired) {
        localVarQueryParameter['costBasisAcquired'] = costBasisAcquired;
      }

      if (costBasisRelieved) {
        localVarQueryParameter['costBasisRelieved'] = costBasisRelieved;
      }

      if (costAverageRate) {
        localVarQueryParameter['costAverageRate'] = costAverageRate;
      }

      if (isTrade) {
        localVarQueryParameter['isTrade'] = isTrade;
      }

      if (lineError) {
        localVarQueryParameter['lineError'] = lineError;
      }

      if (sortField !== undefined) {
        localVarQueryParameter['sort_field'] = sortField;
      }

      if (sortDirection !== undefined) {
        localVarQueryParameter['sort_direction'] = sortDirection;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      if (inventory) {
        localVarQueryParameter['inventory'] = inventory;
      }

      if (wallet) {
        localVarQueryParameter['wallet'] = wallet;
      }

      if (subsidiaryId) {
        localVarQueryParameter['subsidiaryId'] = subsidiaryId;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (fromWallet) {
        localVarQueryParameter['fromWallet'] = fromWallet;
      }

      if (toWallet) {
        localVarQueryParameter['toWallet'] = toWallet;
      }

      if (category) {
        localVarQueryParameter['category'] = category;
      }

      if (categoryType) {
        localVarQueryParameter['categoryType'] = categoryType;
      }

      if (categoryCode) {
        localVarQueryParameter['categoryCode'] = categoryCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {boolean} [groupByInventory]
     * @param {boolean} [ignoreInternalTransfers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewBalance: async (
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      groupByInventory?: boolean,
      ignoreInternalTransfers?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getViewBalance', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getViewBalance', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/balance`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (asOf !== undefined) {
        localVarQueryParameter['asOf'] = asOf;
      }

      if (groupByInventory !== undefined) {
        localVarQueryParameter['groupByInventory'] = groupByInventory;
      }

      if (ignoreInternalTransfers !== undefined) {
        localVarQueryParameter['ignoreInternalTransfers'] = ignoreInternalTransfers;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {boolean} [groupByInventory]
     * @param {boolean} [includeSubsidiary]
     * @param {number} [pageSize]
     * @param {string} [pageToken]
     * @param {boolean} [ignoreInternalTransfers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewBalancePaginated: async (
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      groupByInventory?: boolean,
      includeSubsidiary?: boolean,
      pageSize?: number,
      pageToken?: string,
      ignoreInternalTransfers?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getViewBalancePaginated', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getViewBalancePaginated', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/balance-paginated`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (asOf !== undefined) {
        localVarQueryParameter['asOf'] = asOf;
      }

      if (groupByInventory !== undefined) {
        localVarQueryParameter['groupByInventory'] = groupByInventory;
      }

      if (includeSubsidiary !== undefined) {
        localVarQueryParameter['includeSubsidiary'] = includeSubsidiary;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      if (ignoreInternalTransfers !== undefined) {
        localVarQueryParameter['ignoreInternalTransfers'] = ignoreInternalTransfers;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {string} [startDate]
     * @param {boolean} [ignoreInternalTransfers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewCounts: async (
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      startDate?: string,
      ignoreInternalTransfers?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getViewCounts', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getViewCounts', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/counts`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (asOf !== undefined) {
        localVarQueryParameter['asOf'] = asOf;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (ignoreInternalTransfers !== undefined) {
        localVarQueryParameter['ignoreInternalTransfers'] = ignoreInternalTransfers;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {boolean} [showEmptyLots]
     * @param {string} [pageToken]
     * @param {Array<number>} [timestampSEC]
     * @param {Array<string>} [lotId]
     * @param {Array<string>} [asset]
     * @param {Array<number>} [qty]
     * @param {Array<number>} [unitsAcquired]
     * @param {Array<number>} [unitsDisposed]
     * @param {Array<number>} [costBasisAcquired]
     * @param {Array<number>} [costBasisRelieved]
     * @param {Array<number>} [impairmentExpense]
     * @param {Array<number>} [costBasis]
     * @param {Array<number>} [carryingValue]
     * @param {string} [sortField]
     * @param {ApiSvcSortDirection} [sortDirection]
     * @param {boolean} [exportResults]
     * @param {Array<string>} [inventory]
     * @param {boolean} [groupByInventory]
     * @param {boolean} [includeSubsidiary]
     * @param {Array<string>} [subsidiaryId]
     * @param {string} [startDate]
     * @param {boolean} [includeFairMarketValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewLots: async (
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      showEmptyLots?: boolean,
      pageToken?: string,
      timestampSEC?: Array<number>,
      lotId?: Array<string>,
      asset?: Array<string>,
      qty?: Array<number>,
      unitsAcquired?: Array<number>,
      unitsDisposed?: Array<number>,
      costBasisAcquired?: Array<number>,
      costBasisRelieved?: Array<number>,
      impairmentExpense?: Array<number>,
      costBasis?: Array<number>,
      carryingValue?: Array<number>,
      sortField?: string,
      sortDirection?: ApiSvcSortDirection,
      exportResults?: boolean,
      inventory?: Array<string>,
      groupByInventory?: boolean,
      includeSubsidiary?: boolean,
      subsidiaryId?: Array<string>,
      startDate?: string,
      includeFairMarketValue?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getViewLots', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getViewLots', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/lots`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (asOf !== undefined) {
        localVarQueryParameter['asOf'] = asOf;
      }

      if (showEmptyLots !== undefined) {
        localVarQueryParameter['showEmptyLots'] = showEmptyLots;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      if (timestampSEC) {
        localVarQueryParameter['timestampSEC'] = timestampSEC;
      }

      if (lotId) {
        localVarQueryParameter['lotId'] = lotId;
      }

      if (asset) {
        localVarQueryParameter['asset'] = asset;
      }

      if (qty) {
        localVarQueryParameter['qty'] = qty;
      }

      if (unitsAcquired) {
        localVarQueryParameter['unitsAcquired'] = unitsAcquired;
      }

      if (unitsDisposed) {
        localVarQueryParameter['unitsDisposed'] = unitsDisposed;
      }

      if (costBasisAcquired) {
        localVarQueryParameter['costBasisAcquired'] = costBasisAcquired;
      }

      if (costBasisRelieved) {
        localVarQueryParameter['costBasisRelieved'] = costBasisRelieved;
      }

      if (impairmentExpense) {
        localVarQueryParameter['impairmentExpense'] = impairmentExpense;
      }

      if (costBasis) {
        localVarQueryParameter['costBasis'] = costBasis;
      }

      if (carryingValue) {
        localVarQueryParameter['carryingValue'] = carryingValue;
      }

      if (sortField !== undefined) {
        localVarQueryParameter['sort_field'] = sortField;
      }

      if (sortDirection !== undefined) {
        localVarQueryParameter['sort_direction'] = sortDirection;
      }

      if (exportResults !== undefined) {
        localVarQueryParameter['exportResults'] = exportResults;
      }

      if (inventory) {
        localVarQueryParameter['inventory'] = inventory;
      }

      if (groupByInventory !== undefined) {
        localVarQueryParameter['groupByInventory'] = groupByInventory;
      }

      if (includeSubsidiary !== undefined) {
        localVarQueryParameter['includeSubsidiary'] = includeSubsidiary;
      }

      if (subsidiaryId) {
        localVarQueryParameter['subsidiaryId'] = subsidiaryId;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (includeFairMarketValue !== undefined) {
        localVarQueryParameter['includeFairMarketValue'] = includeFairMarketValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewUpdates: async (
      orgId: string,
      inventoryViewId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getViewUpdates', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getViewUpdates', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/updates`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViews: async (orgId: string, pageToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getViews', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/inventory-views`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletBalanceInventoryReport: async (
      orgId: string,
      inventoryViewId: string,
      endDate?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getWalletBalanceInventoryReport', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getWalletBalanceInventoryReport', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reports/wallet-balance-report`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} startDate
     * @param {string} endDate
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getsGainLossSummary: async (
      orgId: string,
      inventoryViewId: string,
      startDate: string,
      endDate: string,
      pageToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getsGainLossSummary', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('getsGainLossSummary', 'inventoryViewId', inventoryViewId);
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('getsGainLossSummary', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('getsGainLossSummary', 'endDate', endDate);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/gain-loss-summary`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBalanceCheckJobRequest} apiSvcBalanceCheckJobRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runBalanceCheckReportJob: async (
      orgId: string,
      apiSvcBalanceCheckJobRequest: ApiSvcBalanceCheckJobRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('runBalanceCheckReportJob', 'orgId', orgId);
      // verify required parameter 'apiSvcBalanceCheckJobRequest' is not null or undefined
      assertParamExists('runBalanceCheckReportJob', 'apiSvcBalanceCheckJobRequest', apiSvcBalanceCheckJobRequest);
      const localVarPath = `/orgs/{orgId}/inventory-views/reports/balance-check-report-job`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcBalanceCheckJobRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcInventoryReallocationReportReq} apiSvcInventoryReallocationReportReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runInventoryReallocationReport: async (
      orgId: string,
      apiSvcInventoryReallocationReportReq: ApiSvcInventoryReallocationReportReq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('runInventoryReallocationReport', 'orgId', orgId);
      // verify required parameter 'apiSvcInventoryReallocationReportReq' is not null or undefined
      assertParamExists(
        'runInventoryReallocationReport',
        'apiSvcInventoryReallocationReportReq',
        apiSvcInventoryReallocationReportReq
      );
      const localVarPath = `/orgs/{orgId}/inventory-views/reports/reallocation-report`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcInventoryReallocationReportReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {ApiSvcInventoryReallocationReportReq} apiSvcInventoryReallocationReportReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerInventoryViewReallocation: async (
      orgId: string,
      inventoryViewId: string,
      apiSvcInventoryReallocationReportReq: ApiSvcInventoryReallocationReportReq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('triggerInventoryViewReallocation', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('triggerInventoryViewReallocation', 'inventoryViewId', inventoryViewId);
      // verify required parameter 'apiSvcInventoryReallocationReportReq' is not null or undefined
      assertParamExists(
        'triggerInventoryViewReallocation',
        'apiSvcInventoryReallocationReportReq',
        apiSvcInventoryReallocationReportReq
      );
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/reallocations`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcInventoryReallocationReportReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerViewUpdate: async (
      orgId: string,
      inventoryViewId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('triggerViewUpdate', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('triggerViewUpdate', 'inventoryViewId', inventoryViewId);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/updates`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {ApiSvcInventoryViewUpdateEnhancedReq} apiSvcInventoryViewUpdateEnhancedReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerViewUpdateEnhanced: async (
      orgId: string,
      inventoryViewId: string,
      apiSvcInventoryViewUpdateEnhancedReq: ApiSvcInventoryViewUpdateEnhancedReq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('triggerViewUpdateEnhanced', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('triggerViewUpdateEnhanced', 'inventoryViewId', inventoryViewId);
      // verify required parameter 'apiSvcInventoryViewUpdateEnhancedReq' is not null or undefined
      assertParamExists(
        'triggerViewUpdateEnhanced',
        'apiSvcInventoryViewUpdateEnhancedReq',
        apiSvcInventoryViewUpdateEnhancedReq
      );
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/update-requests`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcInventoryViewUpdateEnhancedReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} runIdReference
     * @param {string} startingDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerViewUpdateIncremental: async (
      orgId: string,
      inventoryViewId: string,
      runIdReference: string,
      startingDate: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('triggerViewUpdateIncremental', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('triggerViewUpdateIncremental', 'inventoryViewId', inventoryViewId);
      // verify required parameter 'runIdReference' is not null or undefined
      assertParamExists('triggerViewUpdateIncremental', 'runIdReference', runIdReference);
      // verify required parameter 'startingDate' is not null or undefined
      assertParamExists('triggerViewUpdateIncremental', 'startingDate', startingDate);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}/{runIdReference}/{startingDate}/updates`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)))
        .replace(`{${'runIdReference'}}`, encodeURIComponent(String(runIdReference)))
        .replace(`{${'startingDate'}}`, encodeURIComponent(String(startingDate)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryGroupId
     * @param {ApiSvcUpdateInventoryGroupRequest} apiSvcUpdateInventoryGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInventoryGroup: async (
      orgId: string,
      inventoryGroupId: string,
      apiSvcUpdateInventoryGroupRequest: ApiSvcUpdateInventoryGroupRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateInventoryGroup', 'orgId', orgId);
      // verify required parameter 'inventoryGroupId' is not null or undefined
      assertParamExists('updateInventoryGroup', 'inventoryGroupId', inventoryGroupId);
      // verify required parameter 'apiSvcUpdateInventoryGroupRequest' is not null or undefined
      assertParamExists('updateInventoryGroup', 'apiSvcUpdateInventoryGroupRequest', apiSvcUpdateInventoryGroupRequest);
      const localVarPath = `/orgs/{orgId}/inventory-groups/{inventoryGroupId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryGroupId'}}`, encodeURIComponent(String(inventoryGroupId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateInventoryGroupRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {ApiSvcUpdateInventoryViewRequest} apiSvcUpdateInventoryViewRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateViewProperties: async (
      orgId: string,
      inventoryViewId: string,
      apiSvcUpdateInventoryViewRequest: ApiSvcUpdateInventoryViewRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateViewProperties', 'orgId', orgId);
      // verify required parameter 'inventoryViewId' is not null or undefined
      assertParamExists('updateViewProperties', 'inventoryViewId', inventoryViewId);
      // verify required parameter 'apiSvcUpdateInventoryViewRequest' is not null or undefined
      assertParamExists('updateViewProperties', 'apiSvcUpdateInventoryViewRequest', apiSvcUpdateInventoryViewRequest);
      const localVarPath = `/orgs/{orgId}/inventory-views/{inventoryViewId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'inventoryViewId'}}`, encodeURIComponent(String(inventoryViewId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateInventoryViewRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} inventoryViewUpdateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelViewUpdate(
      orgId: string,
      inventoryViewId: string,
      inventoryViewUpdateId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCancelResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancelViewUpdate(
        orgId,
        inventoryViewId,
        inventoryViewUpdateId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateInventoryGroupRequest} apiSvcCreateInventoryGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createInventoryGroup(
      orgId: string,
      apiSvcCreateInventoryGroupRequest: ApiSvcCreateInventoryGroupRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createInventoryGroup(
        orgId,
        apiSvcCreateInventoryGroupRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateInventoryViewRequest} apiSvcCreateInventoryViewRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createView(
      orgId: string,
      apiSvcCreateInventoryViewRequest: ApiSvcCreateInventoryViewRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createView(
        orgId,
        apiSvcCreateInventoryViewRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteInventory(
      orgId: string,
      inventoryId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInventory(orgId, inventoryId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteInventoryGroup(
      orgId: string,
      inventoryGroupId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInventoryGroup(orgId, inventoryGroupId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteView(
      orgId: string,
      inventoryViewId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteView(orgId, inventoryViewId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} colId
     * @param {boolean} showEmptyLots
     * @param {string} [asOf]
     * @param {string} [pageToken]
     * @param {string} [startDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getActionColumnUniqueValues(
      orgId: string,
      inventoryViewId: string,
      colId: string,
      showEmptyLots: boolean,
      asOf?: string,
      pageToken?: string,
      startDate?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcColumnUniqueValueResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getActionColumnUniqueValues(
        orgId,
        inventoryViewId,
        colId,
        showEmptyLots,
        asOf,
        pageToken,
        startDate,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getActionColumns(
      orgId: string,
      inventoryViewId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getActionColumns(orgId, inventoryViewId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getActionsJeReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCsvExportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getActionsJeReport(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {string} [granularity]
     * @param {boolean} [includeInternalTransfers]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getActionsSummaryReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      granularity?: string,
      includeInternalTransfers?: boolean,
      exportResults?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcActionsSummaryReportResp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getActionsSummaryReport(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        granularity,
        includeInternalTransfers,
        exportResults,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getActionsTrialBalanceReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCsvExportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getActionsTrialBalanceReport(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAdvancedActionsReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCsvExportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvancedActionsReport(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [useInventory]
     * @param {boolean} [useWallet]
     * @param {boolean} [useLot]
     * @param {boolean} [exportResults]
     * @param {boolean} [includeFmv]
     * @param {boolean} [includeSubsidiary]
     * @param {boolean} [excludeInternalTransfersFromCostBasisCalculations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAdvancedCostBasisRollForward(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      useInventory?: boolean,
      useWallet?: boolean,
      useLot?: boolean,
      exportResults?: boolean,
      includeFmv?: boolean,
      includeSubsidiary?: boolean,
      excludeInternalTransfersFromCostBasisCalculations?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcAdvancedCostBasisRollForwardResp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvancedCostBasisRollForward(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        useInventory,
        useWallet,
        useLot,
        exportResults,
        includeFmv,
        includeSubsidiary,
        excludeInternalTransfersFromCostBasisCalculations,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInventoryBalanceCheckReport(
      orgId: string,
      endDate?: string,
      exportResults?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetInventoryBalanceCheckReport200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryBalanceCheckReport(
        orgId,
        endDate,
        exportResults,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {number} [pageSize]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInventoryBalanceCheckReportPaginated(
      orgId: string,
      endDate?: string,
      exportResults?: boolean,
      pageSize?: number,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryBalanceCheckReportResp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryBalanceCheckReportPaginated(
        orgId,
        endDate,
        exportResults,
        pageSize,
        pageToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {boolean} [includeFmv]
     * @param {boolean} [includeSubsidiary]
     * @param {boolean} [excludeInternalTransfersFromCostBasisCalculations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInventoryCostBasisRollForward(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      includeFmv?: boolean,
      includeSubsidiary?: boolean,
      excludeInternalTransfersFromCostBasisCalculations?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryCostBasisRollForwardResp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryCostBasisRollForward(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        exportResults,
        includeFmv,
        includeSubsidiary,
        excludeInternalTransfersFromCostBasisCalculations,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {Array<string>} [inventory]
     * @param {Array<string>} [subsidiaryId]
     * @param {Array<string>} [walletId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInventoryEnhancedGainLoss(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      inventory?: Array<string>,
      subsidiaryId?: Array<string>,
      walletId?: Array<string>,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryEnhancedGainLossResp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryEnhancedGainLoss(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        exportResults,
        inventory,
        subsidiaryId,
        walletId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInventoryGroup(
      orgId: string,
      inventoryGroupId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryGroupResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryGroup(orgId, inventoryGroupId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInventoryGroups(
      orgId: string,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryGroupsResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryGroups(orgId, pageToken, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInventoryJeReclass(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryJeReclassResp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryJeReclass(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        exportResults,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInventoryRows(
      orgId: string,
      inventoryViewId: string,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryViewsResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryRows(
        orgId,
        inventoryViewId,
        pageToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} colId
     * @param {boolean} showEmptyLots
     * @param {string} [asOf]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLotColumnUniqueValues(
      orgId: string,
      inventoryViewId: string,
      colId: string,
      showEmptyLots: boolean,
      asOf?: string,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcColumnUniqueValueResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLotColumnUniqueValues(
        orgId,
        inventoryViewId,
        colId,
        showEmptyLots,
        asOf,
        pageToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLotColumns(
      orgId: string,
      inventoryViewId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLotColumns(orgId, inventoryViewId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRippleInventoryCostBasisRollForward(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRippleInventoryCostBasisRollForwardResp>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRippleInventoryCostBasisRollForward(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        exportResults,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSageErpJeReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCsvExportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSageErpJeReport(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSodaReport(
      orgId: string,
      inventoryViewId: string,
      endDate?: string,
      exportResults?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcSodaReportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSodaReport(
        orgId,
        inventoryViewId,
        endDate,
        exportResults,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} inventoryViewUpdateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUpdateDownloadLinks(
      orgId: string,
      inventoryViewId: string,
      inventoryViewUpdateId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryViewDownloadLinksResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUpdateDownloadLinks(
        orgId,
        inventoryViewId,
        inventoryViewUpdateId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getView(
      orgId: string,
      inventoryViewId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryViewResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getView(orgId, inventoryViewId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {string} [pageToken]
     * @param {Array<string>} [runId]
     * @param {Array<number>} [timestampSEC]
     * @param {Array<string>} [action]
     * @param {Array<string>} [status]
     * @param {Array<string>} [txnId]
     * @param {Array<string>} [eventId]
     * @param {Array<string>} [lotId]
     * @param {Array<string>} [asset]
     * @param {Array<string>} [assetId]
     * @param {Array<string>} [assetUnitAdj]
     * @param {Array<string>} [assetBalance]
     * @param {Array<number>} [lotAcquisitionTimestampSEC]
     * @param {Array<string>} [txnExchangeRate]
     * @param {Array<string>} [carryingValue]
     * @param {Array<string>} [impairmentExpense]
     * @param {Array<string>} [fairMarketValueDisposed]
     * @param {Array<string>} [shortTermGainLoss]
     * @param {Array<string>} [longTermGainLoss]
     * @param {Array<string>} [undatedGainLoss]
     * @param {Array<string>} [costBasisAcquired]
     * @param {Array<string>} [costBasisRelieved]
     * @param {Array<string>} [costAverageRate]
     * @param {Array<boolean>} [isTrade]
     * @param {Array<string>} [lineError]
     * @param {string} [sortField]
     * @param {ApiSvcSortDirection} [sortDirection]
     * @param {boolean} [exportResults]
     * @param {Array<string>} [inventory]
     * @param {Array<string>} [wallet]
     * @param {Array<string>} [subsidiaryId]
     * @param {string} [startDate]
     * @param {Array<string>} [fromWallet]
     * @param {Array<string>} [toWallet]
     * @param {Array<string>} [category]
     * @param {Array<string>} [categoryType]
     * @param {Array<string>} [categoryCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getViewActions(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      pageToken?: string,
      runId?: Array<string>,
      timestampSEC?: Array<number>,
      action?: Array<string>,
      status?: Array<string>,
      txnId?: Array<string>,
      eventId?: Array<string>,
      lotId?: Array<string>,
      asset?: Array<string>,
      assetId?: Array<string>,
      assetUnitAdj?: Array<string>,
      assetBalance?: Array<string>,
      lotAcquisitionTimestampSEC?: Array<number>,
      txnExchangeRate?: Array<string>,
      carryingValue?: Array<string>,
      impairmentExpense?: Array<string>,
      fairMarketValueDisposed?: Array<string>,
      shortTermGainLoss?: Array<string>,
      longTermGainLoss?: Array<string>,
      undatedGainLoss?: Array<string>,
      costBasisAcquired?: Array<string>,
      costBasisRelieved?: Array<string>,
      costAverageRate?: Array<string>,
      isTrade?: Array<boolean>,
      lineError?: Array<string>,
      sortField?: string,
      sortDirection?: ApiSvcSortDirection,
      exportResults?: boolean,
      inventory?: Array<string>,
      wallet?: Array<string>,
      subsidiaryId?: Array<string>,
      startDate?: string,
      fromWallet?: Array<string>,
      toWallet?: Array<string>,
      category?: Array<string>,
      categoryType?: Array<string>,
      categoryCode?: Array<string>,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryActionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getViewActions(
        orgId,
        inventoryViewId,
        asOf,
        pageToken,
        runId,
        timestampSEC,
        action,
        status,
        txnId,
        eventId,
        lotId,
        asset,
        assetId,
        assetUnitAdj,
        assetBalance,
        lotAcquisitionTimestampSEC,
        txnExchangeRate,
        carryingValue,
        impairmentExpense,
        fairMarketValueDisposed,
        shortTermGainLoss,
        longTermGainLoss,
        undatedGainLoss,
        costBasisAcquired,
        costBasisRelieved,
        costAverageRate,
        isTrade,
        lineError,
        sortField,
        sortDirection,
        exportResults,
        inventory,
        wallet,
        subsidiaryId,
        startDate,
        fromWallet,
        toWallet,
        category,
        categoryType,
        categoryCode,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {boolean} [groupByInventory]
     * @param {boolean} [ignoreInternalTransfers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getViewBalance(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      groupByInventory?: boolean,
      ignoreInternalTransfers?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryBalanceResp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getViewBalance(
        orgId,
        inventoryViewId,
        asOf,
        groupByInventory,
        ignoreInternalTransfers,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {boolean} [groupByInventory]
     * @param {boolean} [includeSubsidiary]
     * @param {number} [pageSize]
     * @param {string} [pageToken]
     * @param {boolean} [ignoreInternalTransfers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getViewBalancePaginated(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      groupByInventory?: boolean,
      includeSubsidiary?: boolean,
      pageSize?: number,
      pageToken?: string,
      ignoreInternalTransfers?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryBalanceRespPaginated>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getViewBalancePaginated(
        orgId,
        inventoryViewId,
        asOf,
        groupByInventory,
        includeSubsidiary,
        pageSize,
        pageToken,
        ignoreInternalTransfers,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {string} [startDate]
     * @param {boolean} [ignoreInternalTransfers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getViewCounts(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      startDate?: string,
      ignoreInternalTransfers?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryCountsResp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getViewCounts(
        orgId,
        inventoryViewId,
        asOf,
        startDate,
        ignoreInternalTransfers,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {boolean} [showEmptyLots]
     * @param {string} [pageToken]
     * @param {Array<number>} [timestampSEC]
     * @param {Array<string>} [lotId]
     * @param {Array<string>} [asset]
     * @param {Array<number>} [qty]
     * @param {Array<number>} [unitsAcquired]
     * @param {Array<number>} [unitsDisposed]
     * @param {Array<number>} [costBasisAcquired]
     * @param {Array<number>} [costBasisRelieved]
     * @param {Array<number>} [impairmentExpense]
     * @param {Array<number>} [costBasis]
     * @param {Array<number>} [carryingValue]
     * @param {string} [sortField]
     * @param {ApiSvcSortDirection} [sortDirection]
     * @param {boolean} [exportResults]
     * @param {Array<string>} [inventory]
     * @param {boolean} [groupByInventory]
     * @param {boolean} [includeSubsidiary]
     * @param {Array<string>} [subsidiaryId]
     * @param {string} [startDate]
     * @param {boolean} [includeFairMarketValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getViewLots(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      showEmptyLots?: boolean,
      pageToken?: string,
      timestampSEC?: Array<number>,
      lotId?: Array<string>,
      asset?: Array<string>,
      qty?: Array<number>,
      unitsAcquired?: Array<number>,
      unitsDisposed?: Array<number>,
      costBasisAcquired?: Array<number>,
      costBasisRelieved?: Array<number>,
      impairmentExpense?: Array<number>,
      costBasis?: Array<number>,
      carryingValue?: Array<number>,
      sortField?: string,
      sortDirection?: ApiSvcSortDirection,
      exportResults?: boolean,
      inventory?: Array<string>,
      groupByInventory?: boolean,
      includeSubsidiary?: boolean,
      subsidiaryId?: Array<string>,
      startDate?: string,
      includeFairMarketValue?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryLotResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getViewLots(
        orgId,
        inventoryViewId,
        asOf,
        showEmptyLots,
        pageToken,
        timestampSEC,
        lotId,
        asset,
        qty,
        unitsAcquired,
        unitsDisposed,
        costBasisAcquired,
        costBasisRelieved,
        impairmentExpense,
        costBasis,
        carryingValue,
        sortField,
        sortDirection,
        exportResults,
        inventory,
        groupByInventory,
        includeSubsidiary,
        subsidiaryId,
        startDate,
        includeFairMarketValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getViewUpdates(
      orgId: string,
      inventoryViewId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryViewUpdatesResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getViewUpdates(orgId, inventoryViewId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getViews(
      orgId: string,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryViewsResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getViews(orgId, pageToken, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWalletBalanceInventoryReport(
      orgId: string,
      inventoryViewId: string,
      endDate?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcWalletBalanceInventoryResp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletBalanceInventoryReport(
        orgId,
        inventoryViewId,
        endDate,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} startDate
     * @param {string} endDate
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getsGainLossSummary(
      orgId: string,
      inventoryViewId: string,
      startDate: string,
      endDate: string,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGainLossSummaryResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getsGainLossSummary(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        pageToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBalanceCheckJobRequest} apiSvcBalanceCheckJobRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async runBalanceCheckReportJob(
      orgId: string,
      apiSvcBalanceCheckJobRequest: ApiSvcBalanceCheckJobRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRunBalanceCheckReportJob200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.runBalanceCheckReportJob(
        orgId,
        apiSvcBalanceCheckJobRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcInventoryReallocationReportReq} apiSvcInventoryReallocationReportReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async runInventoryReallocationReport(
      orgId: string,
      apiSvcInventoryReallocationReportReq: ApiSvcInventoryReallocationReportReq,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryReallocationResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.runInventoryReallocationReport(
        orgId,
        apiSvcInventoryReallocationReportReq,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {ApiSvcInventoryReallocationReportReq} apiSvcInventoryReallocationReportReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async triggerInventoryViewReallocation(
      orgId: string,
      inventoryViewId: string,
      apiSvcInventoryReallocationReportReq: ApiSvcInventoryReallocationReportReq,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.triggerInventoryViewReallocation(
        orgId,
        inventoryViewId,
        apiSvcInventoryReallocationReportReq,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async triggerViewUpdate(
      orgId: string,
      inventoryViewId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.triggerViewUpdate(orgId, inventoryViewId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {ApiSvcInventoryViewUpdateEnhancedReq} apiSvcInventoryViewUpdateEnhancedReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async triggerViewUpdateEnhanced(
      orgId: string,
      inventoryViewId: string,
      apiSvcInventoryViewUpdateEnhancedReq: ApiSvcInventoryViewUpdateEnhancedReq,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.triggerViewUpdateEnhanced(
        orgId,
        inventoryViewId,
        apiSvcInventoryViewUpdateEnhancedReq,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} runIdReference
     * @param {string} startingDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async triggerViewUpdateIncremental(
      orgId: string,
      inventoryViewId: string,
      runIdReference: string,
      startingDate: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.triggerViewUpdateIncremental(
        orgId,
        inventoryViewId,
        runIdReference,
        startingDate,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryGroupId
     * @param {ApiSvcUpdateInventoryGroupRequest} apiSvcUpdateInventoryGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateInventoryGroup(
      orgId: string,
      inventoryGroupId: string,
      apiSvcUpdateInventoryGroupRequest: ApiSvcUpdateInventoryGroupRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryGroupResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateInventoryGroup(
        orgId,
        inventoryGroupId,
        apiSvcUpdateInventoryGroupRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {ApiSvcUpdateInventoryViewRequest} apiSvcUpdateInventoryViewRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateViewProperties(
      orgId: string,
      inventoryViewId: string,
      apiSvcUpdateInventoryViewRequest: ApiSvcUpdateInventoryViewRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInventoryViewResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateViewProperties(
        orgId,
        inventoryViewId,
        apiSvcUpdateInventoryViewRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = InventoryApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} inventoryViewUpdateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelViewUpdate(
      orgId: string,
      inventoryViewId: string,
      inventoryViewUpdateId: string,
      options?: any
    ): AxiosPromise<ApiSvcCancelResult> {
      return localVarFp
        .cancelViewUpdate(orgId, inventoryViewId, inventoryViewUpdateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateInventoryGroupRequest} apiSvcCreateInventoryGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInventoryGroup(
      orgId: string,
      apiSvcCreateInventoryGroupRequest: ApiSvcCreateInventoryGroupRequest,
      options?: any
    ): AxiosPromise<ApiSvcCreateResult> {
      return localVarFp
        .createInventoryGroup(orgId, apiSvcCreateInventoryGroupRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateInventoryViewRequest} apiSvcCreateInventoryViewRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createView(
      orgId: string,
      apiSvcCreateInventoryViewRequest: ApiSvcCreateInventoryViewRequest,
      options?: any
    ): AxiosPromise<ApiSvcCreateResult> {
      return localVarFp
        .createView(orgId, apiSvcCreateInventoryViewRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInventory(orgId: string, inventoryId: string, options?: any): AxiosPromise<void> {
      return localVarFp.deleteInventory(orgId, inventoryId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInventoryGroup(orgId: string, inventoryGroupId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .deleteInventoryGroup(orgId, inventoryGroupId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteView(orgId: string, inventoryViewId: string, options?: any): AxiosPromise<void> {
      return localVarFp.deleteView(orgId, inventoryViewId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} colId
     * @param {boolean} showEmptyLots
     * @param {string} [asOf]
     * @param {string} [pageToken]
     * @param {string} [startDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionColumnUniqueValues(
      orgId: string,
      inventoryViewId: string,
      colId: string,
      showEmptyLots: boolean,
      asOf?: string,
      pageToken?: string,
      startDate?: string,
      options?: any
    ): AxiosPromise<ApiSvcColumnUniqueValueResponse> {
      return localVarFp
        .getActionColumnUniqueValues(orgId, inventoryViewId, colId, showEmptyLots, asOf, pageToken, startDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionColumns(orgId: string, inventoryViewId: string, options?: any): AxiosPromise<Array<string>> {
      return localVarFp.getActionColumns(orgId, inventoryViewId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionsJeReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options?: any
    ): AxiosPromise<ApiSvcCsvExportResponse> {
      return localVarFp
        .getActionsJeReport(orgId, inventoryViewId, startDate, endDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {string} [granularity]
     * @param {boolean} [includeInternalTransfers]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionsSummaryReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      granularity?: string,
      includeInternalTransfers?: boolean,
      exportResults?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcActionsSummaryReportResp> {
      return localVarFp
        .getActionsSummaryReport(
          orgId,
          inventoryViewId,
          startDate,
          endDate,
          granularity,
          includeInternalTransfers,
          exportResults,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActionsTrialBalanceReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options?: any
    ): AxiosPromise<ApiSvcCsvExportResponse> {
      return localVarFp
        .getActionsTrialBalanceReport(orgId, inventoryViewId, startDate, endDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdvancedActionsReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options?: any
    ): AxiosPromise<ApiSvcCsvExportResponse> {
      return localVarFp
        .getAdvancedActionsReport(orgId, inventoryViewId, startDate, endDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [useInventory]
     * @param {boolean} [useWallet]
     * @param {boolean} [useLot]
     * @param {boolean} [exportResults]
     * @param {boolean} [includeFmv]
     * @param {boolean} [includeSubsidiary]
     * @param {boolean} [excludeInternalTransfersFromCostBasisCalculations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdvancedCostBasisRollForward(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      useInventory?: boolean,
      useWallet?: boolean,
      useLot?: boolean,
      exportResults?: boolean,
      includeFmv?: boolean,
      includeSubsidiary?: boolean,
      excludeInternalTransfersFromCostBasisCalculations?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcAdvancedCostBasisRollForwardResp> {
      return localVarFp
        .getAdvancedCostBasisRollForward(
          orgId,
          inventoryViewId,
          startDate,
          endDate,
          useInventory,
          useWallet,
          useLot,
          exportResults,
          includeFmv,
          includeSubsidiary,
          excludeInternalTransfersFromCostBasisCalculations,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryBalanceCheckReport(
      orgId: string,
      endDate?: string,
      exportResults?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcGetInventoryBalanceCheckReport200Response> {
      return localVarFp
        .getInventoryBalanceCheckReport(orgId, endDate, exportResults, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {number} [pageSize]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryBalanceCheckReportPaginated(
      orgId: string,
      endDate?: string,
      exportResults?: boolean,
      pageSize?: number,
      pageToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcInventoryBalanceCheckReportResp> {
      return localVarFp
        .getInventoryBalanceCheckReportPaginated(orgId, endDate, exportResults, pageSize, pageToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {boolean} [includeFmv]
     * @param {boolean} [includeSubsidiary]
     * @param {boolean} [excludeInternalTransfersFromCostBasisCalculations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryCostBasisRollForward(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      includeFmv?: boolean,
      includeSubsidiary?: boolean,
      excludeInternalTransfersFromCostBasisCalculations?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcInventoryCostBasisRollForwardResp> {
      return localVarFp
        .getInventoryCostBasisRollForward(
          orgId,
          inventoryViewId,
          startDate,
          endDate,
          exportResults,
          includeFmv,
          includeSubsidiary,
          excludeInternalTransfersFromCostBasisCalculations,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {Array<string>} [inventory]
     * @param {Array<string>} [subsidiaryId]
     * @param {Array<string>} [walletId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryEnhancedGainLoss(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      inventory?: Array<string>,
      subsidiaryId?: Array<string>,
      walletId?: Array<string>,
      options?: any
    ): AxiosPromise<ApiSvcInventoryEnhancedGainLossResp> {
      return localVarFp
        .getInventoryEnhancedGainLoss(
          orgId,
          inventoryViewId,
          startDate,
          endDate,
          exportResults,
          inventory,
          subsidiaryId,
          walletId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryGroup(
      orgId: string,
      inventoryGroupId: string,
      options?: any
    ): AxiosPromise<ApiSvcInventoryGroupResponse> {
      return localVarFp.getInventoryGroup(orgId, inventoryGroupId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryGroups(orgId: string, pageToken?: string, options?: any): AxiosPromise<ApiSvcInventoryGroupsResult> {
      return localVarFp.getInventoryGroups(orgId, pageToken, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryJeReclass(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcInventoryJeReclassResp> {
      return localVarFp
        .getInventoryJeReclass(orgId, inventoryViewId, startDate, endDate, exportResults, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryRows(
      orgId: string,
      inventoryViewId: string,
      pageToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcInventoryViewsResult> {
      return localVarFp
        .getInventoryRows(orgId, inventoryViewId, pageToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} colId
     * @param {boolean} showEmptyLots
     * @param {string} [asOf]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLotColumnUniqueValues(
      orgId: string,
      inventoryViewId: string,
      colId: string,
      showEmptyLots: boolean,
      asOf?: string,
      pageToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcColumnUniqueValueResponse> {
      return localVarFp
        .getLotColumnUniqueValues(orgId, inventoryViewId, colId, showEmptyLots, asOf, pageToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLotColumns(orgId: string, inventoryViewId: string, options?: any): AxiosPromise<Array<string>> {
      return localVarFp.getLotColumns(orgId, inventoryViewId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRippleInventoryCostBasisRollForward(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      exportResults?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcRippleInventoryCostBasisRollForwardResp> {
      return localVarFp
        .getRippleInventoryCostBasisRollForward(orgId, inventoryViewId, startDate, endDate, exportResults, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSageErpJeReport(
      orgId: string,
      inventoryViewId: string,
      startDate?: string,
      endDate?: string,
      options?: any
    ): AxiosPromise<ApiSvcCsvExportResponse> {
      return localVarFp
        .getSageErpJeReport(orgId, inventoryViewId, startDate, endDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [endDate]
     * @param {boolean} [exportResults]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSodaReport(
      orgId: string,
      inventoryViewId: string,
      endDate?: string,
      exportResults?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcSodaReportResponse> {
      return localVarFp
        .getSodaReport(orgId, inventoryViewId, endDate, exportResults, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} inventoryViewUpdateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUpdateDownloadLinks(
      orgId: string,
      inventoryViewId: string,
      inventoryViewUpdateId: string,
      options?: any
    ): AxiosPromise<ApiSvcInventoryViewDownloadLinksResponse> {
      return localVarFp
        .getUpdateDownloadLinks(orgId, inventoryViewId, inventoryViewUpdateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getView(orgId: string, inventoryViewId: string, options?: any): AxiosPromise<ApiSvcInventoryViewResponse> {
      return localVarFp.getView(orgId, inventoryViewId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {string} [pageToken]
     * @param {Array<string>} [runId]
     * @param {Array<number>} [timestampSEC]
     * @param {Array<string>} [action]
     * @param {Array<string>} [status]
     * @param {Array<string>} [txnId]
     * @param {Array<string>} [eventId]
     * @param {Array<string>} [lotId]
     * @param {Array<string>} [asset]
     * @param {Array<string>} [assetId]
     * @param {Array<string>} [assetUnitAdj]
     * @param {Array<string>} [assetBalance]
     * @param {Array<number>} [lotAcquisitionTimestampSEC]
     * @param {Array<string>} [txnExchangeRate]
     * @param {Array<string>} [carryingValue]
     * @param {Array<string>} [impairmentExpense]
     * @param {Array<string>} [fairMarketValueDisposed]
     * @param {Array<string>} [shortTermGainLoss]
     * @param {Array<string>} [longTermGainLoss]
     * @param {Array<string>} [undatedGainLoss]
     * @param {Array<string>} [costBasisAcquired]
     * @param {Array<string>} [costBasisRelieved]
     * @param {Array<string>} [costAverageRate]
     * @param {Array<boolean>} [isTrade]
     * @param {Array<string>} [lineError]
     * @param {string} [sortField]
     * @param {ApiSvcSortDirection} [sortDirection]
     * @param {boolean} [exportResults]
     * @param {Array<string>} [inventory]
     * @param {Array<string>} [wallet]
     * @param {Array<string>} [subsidiaryId]
     * @param {string} [startDate]
     * @param {Array<string>} [fromWallet]
     * @param {Array<string>} [toWallet]
     * @param {Array<string>} [category]
     * @param {Array<string>} [categoryType]
     * @param {Array<string>} [categoryCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewActions(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      pageToken?: string,
      runId?: Array<string>,
      timestampSEC?: Array<number>,
      action?: Array<string>,
      status?: Array<string>,
      txnId?: Array<string>,
      eventId?: Array<string>,
      lotId?: Array<string>,
      asset?: Array<string>,
      assetId?: Array<string>,
      assetUnitAdj?: Array<string>,
      assetBalance?: Array<string>,
      lotAcquisitionTimestampSEC?: Array<number>,
      txnExchangeRate?: Array<string>,
      carryingValue?: Array<string>,
      impairmentExpense?: Array<string>,
      fairMarketValueDisposed?: Array<string>,
      shortTermGainLoss?: Array<string>,
      longTermGainLoss?: Array<string>,
      undatedGainLoss?: Array<string>,
      costBasisAcquired?: Array<string>,
      costBasisRelieved?: Array<string>,
      costAverageRate?: Array<string>,
      isTrade?: Array<boolean>,
      lineError?: Array<string>,
      sortField?: string,
      sortDirection?: ApiSvcSortDirection,
      exportResults?: boolean,
      inventory?: Array<string>,
      wallet?: Array<string>,
      subsidiaryId?: Array<string>,
      startDate?: string,
      fromWallet?: Array<string>,
      toWallet?: Array<string>,
      category?: Array<string>,
      categoryType?: Array<string>,
      categoryCode?: Array<string>,
      options?: any
    ): AxiosPromise<ApiSvcInventoryActionResponse> {
      return localVarFp
        .getViewActions(
          orgId,
          inventoryViewId,
          asOf,
          pageToken,
          runId,
          timestampSEC,
          action,
          status,
          txnId,
          eventId,
          lotId,
          asset,
          assetId,
          assetUnitAdj,
          assetBalance,
          lotAcquisitionTimestampSEC,
          txnExchangeRate,
          carryingValue,
          impairmentExpense,
          fairMarketValueDisposed,
          shortTermGainLoss,
          longTermGainLoss,
          undatedGainLoss,
          costBasisAcquired,
          costBasisRelieved,
          costAverageRate,
          isTrade,
          lineError,
          sortField,
          sortDirection,
          exportResults,
          inventory,
          wallet,
          subsidiaryId,
          startDate,
          fromWallet,
          toWallet,
          category,
          categoryType,
          categoryCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {boolean} [groupByInventory]
     * @param {boolean} [ignoreInternalTransfers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewBalance(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      groupByInventory?: boolean,
      ignoreInternalTransfers?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcInventoryBalanceResp> {
      return localVarFp
        .getViewBalance(orgId, inventoryViewId, asOf, groupByInventory, ignoreInternalTransfers, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {boolean} [groupByInventory]
     * @param {boolean} [includeSubsidiary]
     * @param {number} [pageSize]
     * @param {string} [pageToken]
     * @param {boolean} [ignoreInternalTransfers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewBalancePaginated(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      groupByInventory?: boolean,
      includeSubsidiary?: boolean,
      pageSize?: number,
      pageToken?: string,
      ignoreInternalTransfers?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcInventoryBalanceRespPaginated> {
      return localVarFp
        .getViewBalancePaginated(
          orgId,
          inventoryViewId,
          asOf,
          groupByInventory,
          includeSubsidiary,
          pageSize,
          pageToken,
          ignoreInternalTransfers,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {string} [startDate]
     * @param {boolean} [ignoreInternalTransfers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewCounts(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      startDate?: string,
      ignoreInternalTransfers?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcInventoryCountsResp> {
      return localVarFp
        .getViewCounts(orgId, inventoryViewId, asOf, startDate, ignoreInternalTransfers, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [asOf]
     * @param {boolean} [showEmptyLots]
     * @param {string} [pageToken]
     * @param {Array<number>} [timestampSEC]
     * @param {Array<string>} [lotId]
     * @param {Array<string>} [asset]
     * @param {Array<number>} [qty]
     * @param {Array<number>} [unitsAcquired]
     * @param {Array<number>} [unitsDisposed]
     * @param {Array<number>} [costBasisAcquired]
     * @param {Array<number>} [costBasisRelieved]
     * @param {Array<number>} [impairmentExpense]
     * @param {Array<number>} [costBasis]
     * @param {Array<number>} [carryingValue]
     * @param {string} [sortField]
     * @param {ApiSvcSortDirection} [sortDirection]
     * @param {boolean} [exportResults]
     * @param {Array<string>} [inventory]
     * @param {boolean} [groupByInventory]
     * @param {boolean} [includeSubsidiary]
     * @param {Array<string>} [subsidiaryId]
     * @param {string} [startDate]
     * @param {boolean} [includeFairMarketValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewLots(
      orgId: string,
      inventoryViewId: string,
      asOf?: string,
      showEmptyLots?: boolean,
      pageToken?: string,
      timestampSEC?: Array<number>,
      lotId?: Array<string>,
      asset?: Array<string>,
      qty?: Array<number>,
      unitsAcquired?: Array<number>,
      unitsDisposed?: Array<number>,
      costBasisAcquired?: Array<number>,
      costBasisRelieved?: Array<number>,
      impairmentExpense?: Array<number>,
      costBasis?: Array<number>,
      carryingValue?: Array<number>,
      sortField?: string,
      sortDirection?: ApiSvcSortDirection,
      exportResults?: boolean,
      inventory?: Array<string>,
      groupByInventory?: boolean,
      includeSubsidiary?: boolean,
      subsidiaryId?: Array<string>,
      startDate?: string,
      includeFairMarketValue?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcInventoryLotResponse> {
      return localVarFp
        .getViewLots(
          orgId,
          inventoryViewId,
          asOf,
          showEmptyLots,
          pageToken,
          timestampSEC,
          lotId,
          asset,
          qty,
          unitsAcquired,
          unitsDisposed,
          costBasisAcquired,
          costBasisRelieved,
          impairmentExpense,
          costBasis,
          carryingValue,
          sortField,
          sortDirection,
          exportResults,
          inventory,
          groupByInventory,
          includeSubsidiary,
          subsidiaryId,
          startDate,
          includeFairMarketValue,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViewUpdates(
      orgId: string,
      inventoryViewId: string,
      options?: any
    ): AxiosPromise<ApiSvcInventoryViewUpdatesResult> {
      return localVarFp.getViewUpdates(orgId, inventoryViewId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getViews(orgId: string, pageToken?: string, options?: any): AxiosPromise<ApiSvcInventoryViewsResult> {
      return localVarFp.getViews(orgId, pageToken, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletBalanceInventoryReport(
      orgId: string,
      inventoryViewId: string,
      endDate?: string,
      options?: any
    ): AxiosPromise<ApiSvcWalletBalanceInventoryResp> {
      return localVarFp
        .getWalletBalanceInventoryReport(orgId, inventoryViewId, endDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} startDate
     * @param {string} endDate
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getsGainLossSummary(
      orgId: string,
      inventoryViewId: string,
      startDate: string,
      endDate: string,
      pageToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcGainLossSummaryResponse> {
      return localVarFp
        .getsGainLossSummary(orgId, inventoryViewId, startDate, endDate, pageToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBalanceCheckJobRequest} apiSvcBalanceCheckJobRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runBalanceCheckReportJob(
      orgId: string,
      apiSvcBalanceCheckJobRequest: ApiSvcBalanceCheckJobRequest,
      options?: any
    ): AxiosPromise<ApiSvcRunBalanceCheckReportJob200Response> {
      return localVarFp
        .runBalanceCheckReportJob(orgId, apiSvcBalanceCheckJobRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcInventoryReallocationReportReq} apiSvcInventoryReallocationReportReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runInventoryReallocationReport(
      orgId: string,
      apiSvcInventoryReallocationReportReq: ApiSvcInventoryReallocationReportReq,
      options?: any
    ): AxiosPromise<ApiSvcInventoryReallocationResponse> {
      return localVarFp
        .runInventoryReallocationReport(orgId, apiSvcInventoryReallocationReportReq, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {ApiSvcInventoryReallocationReportReq} apiSvcInventoryReallocationReportReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerInventoryViewReallocation(
      orgId: string,
      inventoryViewId: string,
      apiSvcInventoryReallocationReportReq: ApiSvcInventoryReallocationReportReq,
      options?: any
    ): AxiosPromise<ApiSvcCreateResult> {
      return localVarFp
        .triggerInventoryViewReallocation(orgId, inventoryViewId, apiSvcInventoryReallocationReportReq, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerViewUpdate(orgId: string, inventoryViewId: string, options?: any): AxiosPromise<ApiSvcCreateResult> {
      return localVarFp.triggerViewUpdate(orgId, inventoryViewId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {ApiSvcInventoryViewUpdateEnhancedReq} apiSvcInventoryViewUpdateEnhancedReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerViewUpdateEnhanced(
      orgId: string,
      inventoryViewId: string,
      apiSvcInventoryViewUpdateEnhancedReq: ApiSvcInventoryViewUpdateEnhancedReq,
      options?: any
    ): AxiosPromise<ApiSvcCreateResult> {
      return localVarFp
        .triggerViewUpdateEnhanced(orgId, inventoryViewId, apiSvcInventoryViewUpdateEnhancedReq, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {string} runIdReference
     * @param {string} startingDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerViewUpdateIncremental(
      orgId: string,
      inventoryViewId: string,
      runIdReference: string,
      startingDate: string,
      options?: any
    ): AxiosPromise<ApiSvcCreateResult> {
      return localVarFp
        .triggerViewUpdateIncremental(orgId, inventoryViewId, runIdReference, startingDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryGroupId
     * @param {ApiSvcUpdateInventoryGroupRequest} apiSvcUpdateInventoryGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInventoryGroup(
      orgId: string,
      inventoryGroupId: string,
      apiSvcUpdateInventoryGroupRequest: ApiSvcUpdateInventoryGroupRequest,
      options?: any
    ): AxiosPromise<ApiSvcInventoryGroupResponse> {
      return localVarFp
        .updateInventoryGroup(orgId, inventoryGroupId, apiSvcUpdateInventoryGroupRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} inventoryViewId
     * @param {ApiSvcUpdateInventoryViewRequest} apiSvcUpdateInventoryViewRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateViewProperties(
      orgId: string,
      inventoryViewId: string,
      apiSvcUpdateInventoryViewRequest: ApiSvcUpdateInventoryViewRequest,
      options?: any
    ): AxiosPromise<ApiSvcInventoryViewResponse> {
      return localVarFp
        .updateViewProperties(orgId, inventoryViewId, apiSvcUpdateInventoryViewRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} inventoryViewUpdateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public cancelViewUpdate(
    orgId: string,
    inventoryViewId: string,
    inventoryViewUpdateId: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .cancelViewUpdate(orgId, inventoryViewId, inventoryViewUpdateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateInventoryGroupRequest} apiSvcCreateInventoryGroupRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public createInventoryGroup(
    orgId: string,
    apiSvcCreateInventoryGroupRequest: ApiSvcCreateInventoryGroupRequest,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .createInventoryGroup(orgId, apiSvcCreateInventoryGroupRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateInventoryViewRequest} apiSvcCreateInventoryViewRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public createView(
    orgId: string,
    apiSvcCreateInventoryViewRequest: ApiSvcCreateInventoryViewRequest,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .createView(orgId, apiSvcCreateInventoryViewRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public deleteInventory(orgId: string, inventoryId: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .deleteInventory(orgId, inventoryId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryGroupId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public deleteInventoryGroup(orgId: string, inventoryGroupId: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .deleteInventoryGroup(orgId, inventoryGroupId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public deleteView(orgId: string, inventoryViewId: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .deleteView(orgId, inventoryViewId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} colId
   * @param {boolean} showEmptyLots
   * @param {string} [asOf]
   * @param {string} [pageToken]
   * @param {string} [startDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getActionColumnUniqueValues(
    orgId: string,
    inventoryViewId: string,
    colId: string,
    showEmptyLots: boolean,
    asOf?: string,
    pageToken?: string,
    startDate?: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getActionColumnUniqueValues(orgId, inventoryViewId, colId, showEmptyLots, asOf, pageToken, startDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getActionColumns(orgId: string, inventoryViewId: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .getActionColumns(orgId, inventoryViewId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getActionsJeReport(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getActionsJeReport(orgId, inventoryViewId, startDate, endDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {string} [granularity]
   * @param {boolean} [includeInternalTransfers]
   * @param {boolean} [exportResults]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getActionsSummaryReport(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    granularity?: string,
    includeInternalTransfers?: boolean,
    exportResults?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getActionsSummaryReport(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        granularity,
        includeInternalTransfers,
        exportResults,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getActionsTrialBalanceReport(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getActionsTrialBalanceReport(orgId, inventoryViewId, startDate, endDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getAdvancedActionsReport(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getAdvancedActionsReport(orgId, inventoryViewId, startDate, endDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {boolean} [useInventory]
   * @param {boolean} [useWallet]
   * @param {boolean} [useLot]
   * @param {boolean} [exportResults]
   * @param {boolean} [includeFmv]
   * @param {boolean} [includeSubsidiary]
   * @param {boolean} [excludeInternalTransfersFromCostBasisCalculations]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getAdvancedCostBasisRollForward(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    useInventory?: boolean,
    useWallet?: boolean,
    useLot?: boolean,
    exportResults?: boolean,
    includeFmv?: boolean,
    includeSubsidiary?: boolean,
    excludeInternalTransfersFromCostBasisCalculations?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getAdvancedCostBasisRollForward(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        useInventory,
        useWallet,
        useLot,
        exportResults,
        includeFmv,
        includeSubsidiary,
        excludeInternalTransfersFromCostBasisCalculations,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} [endDate]
   * @param {boolean} [exportResults]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getInventoryBalanceCheckReport(
    orgId: string,
    endDate?: string,
    exportResults?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getInventoryBalanceCheckReport(orgId, endDate, exportResults, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} [endDate]
   * @param {boolean} [exportResults]
   * @param {number} [pageSize]
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getInventoryBalanceCheckReportPaginated(
    orgId: string,
    endDate?: string,
    exportResults?: boolean,
    pageSize?: number,
    pageToken?: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getInventoryBalanceCheckReportPaginated(orgId, endDate, exportResults, pageSize, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {boolean} [exportResults]
   * @param {boolean} [includeFmv]
   * @param {boolean} [includeSubsidiary]
   * @param {boolean} [excludeInternalTransfersFromCostBasisCalculations]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getInventoryCostBasisRollForward(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    exportResults?: boolean,
    includeFmv?: boolean,
    includeSubsidiary?: boolean,
    excludeInternalTransfersFromCostBasisCalculations?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getInventoryCostBasisRollForward(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        exportResults,
        includeFmv,
        includeSubsidiary,
        excludeInternalTransfersFromCostBasisCalculations,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {boolean} [exportResults]
   * @param {Array<string>} [inventory]
   * @param {Array<string>} [subsidiaryId]
   * @param {Array<string>} [walletId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getInventoryEnhancedGainLoss(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    exportResults?: boolean,
    inventory?: Array<string>,
    subsidiaryId?: Array<string>,
    walletId?: Array<string>,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getInventoryEnhancedGainLoss(
        orgId,
        inventoryViewId,
        startDate,
        endDate,
        exportResults,
        inventory,
        subsidiaryId,
        walletId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryGroupId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getInventoryGroup(orgId: string, inventoryGroupId: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .getInventoryGroup(orgId, inventoryGroupId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getInventoryGroups(orgId: string, pageToken?: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .getInventoryGroups(orgId, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {boolean} [exportResults]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getInventoryJeReclass(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    exportResults?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getInventoryJeReclass(orgId, inventoryViewId, startDate, endDate, exportResults, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getInventoryRows(orgId: string, inventoryViewId: string, pageToken?: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .getInventoryRows(orgId, inventoryViewId, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} colId
   * @param {boolean} showEmptyLots
   * @param {string} [asOf]
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getLotColumnUniqueValues(
    orgId: string,
    inventoryViewId: string,
    colId: string,
    showEmptyLots: boolean,
    asOf?: string,
    pageToken?: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getLotColumnUniqueValues(orgId, inventoryViewId, colId, showEmptyLots, asOf, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getLotColumns(orgId: string, inventoryViewId: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .getLotColumns(orgId, inventoryViewId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {boolean} [exportResults]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getRippleInventoryCostBasisRollForward(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    exportResults?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getRippleInventoryCostBasisRollForward(orgId, inventoryViewId, startDate, endDate, exportResults, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getSageErpJeReport(
    orgId: string,
    inventoryViewId: string,
    startDate?: string,
    endDate?: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getSageErpJeReport(orgId, inventoryViewId, startDate, endDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [endDate]
   * @param {boolean} [exportResults]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getSodaReport(
    orgId: string,
    inventoryViewId: string,
    endDate?: string,
    exportResults?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getSodaReport(orgId, inventoryViewId, endDate, exportResults, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} inventoryViewUpdateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getUpdateDownloadLinks(
    orgId: string,
    inventoryViewId: string,
    inventoryViewUpdateId: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getUpdateDownloadLinks(orgId, inventoryViewId, inventoryViewUpdateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getView(orgId: string, inventoryViewId: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .getView(orgId, inventoryViewId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [asOf]
   * @param {string} [pageToken]
   * @param {Array<string>} [runId]
   * @param {Array<number>} [timestampSEC]
   * @param {Array<string>} [action]
   * @param {Array<string>} [status]
   * @param {Array<string>} [txnId]
   * @param {Array<string>} [eventId]
   * @param {Array<string>} [lotId]
   * @param {Array<string>} [asset]
   * @param {Array<string>} [assetId]
   * @param {Array<string>} [assetUnitAdj]
   * @param {Array<string>} [assetBalance]
   * @param {Array<number>} [lotAcquisitionTimestampSEC]
   * @param {Array<string>} [txnExchangeRate]
   * @param {Array<string>} [carryingValue]
   * @param {Array<string>} [impairmentExpense]
   * @param {Array<string>} [fairMarketValueDisposed]
   * @param {Array<string>} [shortTermGainLoss]
   * @param {Array<string>} [longTermGainLoss]
   * @param {Array<string>} [undatedGainLoss]
   * @param {Array<string>} [costBasisAcquired]
   * @param {Array<string>} [costBasisRelieved]
   * @param {Array<string>} [costAverageRate]
   * @param {Array<boolean>} [isTrade]
   * @param {Array<string>} [lineError]
   * @param {string} [sortField]
   * @param {ApiSvcSortDirection} [sortDirection]
   * @param {boolean} [exportResults]
   * @param {Array<string>} [inventory]
   * @param {Array<string>} [wallet]
   * @param {Array<string>} [subsidiaryId]
   * @param {string} [startDate]
   * @param {Array<string>} [fromWallet]
   * @param {Array<string>} [toWallet]
   * @param {Array<string>} [category]
   * @param {Array<string>} [categoryType]
   * @param {Array<string>} [categoryCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getViewActions(
    orgId: string,
    inventoryViewId: string,
    asOf?: string,
    pageToken?: string,
    runId?: Array<string>,
    timestampSEC?: Array<number>,
    action?: Array<string>,
    status?: Array<string>,
    txnId?: Array<string>,
    eventId?: Array<string>,
    lotId?: Array<string>,
    asset?: Array<string>,
    assetId?: Array<string>,
    assetUnitAdj?: Array<string>,
    assetBalance?: Array<string>,
    lotAcquisitionTimestampSEC?: Array<number>,
    txnExchangeRate?: Array<string>,
    carryingValue?: Array<string>,
    impairmentExpense?: Array<string>,
    fairMarketValueDisposed?: Array<string>,
    shortTermGainLoss?: Array<string>,
    longTermGainLoss?: Array<string>,
    undatedGainLoss?: Array<string>,
    costBasisAcquired?: Array<string>,
    costBasisRelieved?: Array<string>,
    costAverageRate?: Array<string>,
    isTrade?: Array<boolean>,
    lineError?: Array<string>,
    sortField?: string,
    sortDirection?: ApiSvcSortDirection,
    exportResults?: boolean,
    inventory?: Array<string>,
    wallet?: Array<string>,
    subsidiaryId?: Array<string>,
    startDate?: string,
    fromWallet?: Array<string>,
    toWallet?: Array<string>,
    category?: Array<string>,
    categoryType?: Array<string>,
    categoryCode?: Array<string>,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getViewActions(
        orgId,
        inventoryViewId,
        asOf,
        pageToken,
        runId,
        timestampSEC,
        action,
        status,
        txnId,
        eventId,
        lotId,
        asset,
        assetId,
        assetUnitAdj,
        assetBalance,
        lotAcquisitionTimestampSEC,
        txnExchangeRate,
        carryingValue,
        impairmentExpense,
        fairMarketValueDisposed,
        shortTermGainLoss,
        longTermGainLoss,
        undatedGainLoss,
        costBasisAcquired,
        costBasisRelieved,
        costAverageRate,
        isTrade,
        lineError,
        sortField,
        sortDirection,
        exportResults,
        inventory,
        wallet,
        subsidiaryId,
        startDate,
        fromWallet,
        toWallet,
        category,
        categoryType,
        categoryCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [asOf]
   * @param {boolean} [groupByInventory]
   * @param {boolean} [ignoreInternalTransfers]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getViewBalance(
    orgId: string,
    inventoryViewId: string,
    asOf?: string,
    groupByInventory?: boolean,
    ignoreInternalTransfers?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getViewBalance(orgId, inventoryViewId, asOf, groupByInventory, ignoreInternalTransfers, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [asOf]
   * @param {boolean} [groupByInventory]
   * @param {boolean} [includeSubsidiary]
   * @param {number} [pageSize]
   * @param {string} [pageToken]
   * @param {boolean} [ignoreInternalTransfers]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getViewBalancePaginated(
    orgId: string,
    inventoryViewId: string,
    asOf?: string,
    groupByInventory?: boolean,
    includeSubsidiary?: boolean,
    pageSize?: number,
    pageToken?: string,
    ignoreInternalTransfers?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getViewBalancePaginated(
        orgId,
        inventoryViewId,
        asOf,
        groupByInventory,
        includeSubsidiary,
        pageSize,
        pageToken,
        ignoreInternalTransfers,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [asOf]
   * @param {string} [startDate]
   * @param {boolean} [ignoreInternalTransfers]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getViewCounts(
    orgId: string,
    inventoryViewId: string,
    asOf?: string,
    startDate?: string,
    ignoreInternalTransfers?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getViewCounts(orgId, inventoryViewId, asOf, startDate, ignoreInternalTransfers, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [asOf]
   * @param {boolean} [showEmptyLots]
   * @param {string} [pageToken]
   * @param {Array<number>} [timestampSEC]
   * @param {Array<string>} [lotId]
   * @param {Array<string>} [asset]
   * @param {Array<number>} [qty]
   * @param {Array<number>} [unitsAcquired]
   * @param {Array<number>} [unitsDisposed]
   * @param {Array<number>} [costBasisAcquired]
   * @param {Array<number>} [costBasisRelieved]
   * @param {Array<number>} [impairmentExpense]
   * @param {Array<number>} [costBasis]
   * @param {Array<number>} [carryingValue]
   * @param {string} [sortField]
   * @param {ApiSvcSortDirection} [sortDirection]
   * @param {boolean} [exportResults]
   * @param {Array<string>} [inventory]
   * @param {boolean} [groupByInventory]
   * @param {boolean} [includeSubsidiary]
   * @param {Array<string>} [subsidiaryId]
   * @param {string} [startDate]
   * @param {boolean} [includeFairMarketValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getViewLots(
    orgId: string,
    inventoryViewId: string,
    asOf?: string,
    showEmptyLots?: boolean,
    pageToken?: string,
    timestampSEC?: Array<number>,
    lotId?: Array<string>,
    asset?: Array<string>,
    qty?: Array<number>,
    unitsAcquired?: Array<number>,
    unitsDisposed?: Array<number>,
    costBasisAcquired?: Array<number>,
    costBasisRelieved?: Array<number>,
    impairmentExpense?: Array<number>,
    costBasis?: Array<number>,
    carryingValue?: Array<number>,
    sortField?: string,
    sortDirection?: ApiSvcSortDirection,
    exportResults?: boolean,
    inventory?: Array<string>,
    groupByInventory?: boolean,
    includeSubsidiary?: boolean,
    subsidiaryId?: Array<string>,
    startDate?: string,
    includeFairMarketValue?: boolean,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getViewLots(
        orgId,
        inventoryViewId,
        asOf,
        showEmptyLots,
        pageToken,
        timestampSEC,
        lotId,
        asset,
        qty,
        unitsAcquired,
        unitsDisposed,
        costBasisAcquired,
        costBasisRelieved,
        impairmentExpense,
        costBasis,
        carryingValue,
        sortField,
        sortDirection,
        exportResults,
        inventory,
        groupByInventory,
        includeSubsidiary,
        subsidiaryId,
        startDate,
        includeFairMarketValue,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getViewUpdates(orgId: string, inventoryViewId: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .getViewUpdates(orgId, inventoryViewId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getViews(orgId: string, pageToken?: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .getViews(orgId, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} [endDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getWalletBalanceInventoryReport(
    orgId: string,
    inventoryViewId: string,
    endDate?: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getWalletBalanceInventoryReport(orgId, inventoryViewId, endDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} startDate
   * @param {string} endDate
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public getsGainLossSummary(
    orgId: string,
    inventoryViewId: string,
    startDate: string,
    endDate: string,
    pageToken?: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .getsGainLossSummary(orgId, inventoryViewId, startDate, endDate, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcBalanceCheckJobRequest} apiSvcBalanceCheckJobRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public runBalanceCheckReportJob(
    orgId: string,
    apiSvcBalanceCheckJobRequest: ApiSvcBalanceCheckJobRequest,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .runBalanceCheckReportJob(orgId, apiSvcBalanceCheckJobRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcInventoryReallocationReportReq} apiSvcInventoryReallocationReportReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public runInventoryReallocationReport(
    orgId: string,
    apiSvcInventoryReallocationReportReq: ApiSvcInventoryReallocationReportReq,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .runInventoryReallocationReport(orgId, apiSvcInventoryReallocationReportReq, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {ApiSvcInventoryReallocationReportReq} apiSvcInventoryReallocationReportReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public triggerInventoryViewReallocation(
    orgId: string,
    inventoryViewId: string,
    apiSvcInventoryReallocationReportReq: ApiSvcInventoryReallocationReportReq,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .triggerInventoryViewReallocation(orgId, inventoryViewId, apiSvcInventoryReallocationReportReq, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public triggerViewUpdate(orgId: string, inventoryViewId: string, options?: AxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .triggerViewUpdate(orgId, inventoryViewId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {ApiSvcInventoryViewUpdateEnhancedReq} apiSvcInventoryViewUpdateEnhancedReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public triggerViewUpdateEnhanced(
    orgId: string,
    inventoryViewId: string,
    apiSvcInventoryViewUpdateEnhancedReq: ApiSvcInventoryViewUpdateEnhancedReq,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .triggerViewUpdateEnhanced(orgId, inventoryViewId, apiSvcInventoryViewUpdateEnhancedReq, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {string} runIdReference
   * @param {string} startingDate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public triggerViewUpdateIncremental(
    orgId: string,
    inventoryViewId: string,
    runIdReference: string,
    startingDate: string,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .triggerViewUpdateIncremental(orgId, inventoryViewId, runIdReference, startingDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryGroupId
   * @param {ApiSvcUpdateInventoryGroupRequest} apiSvcUpdateInventoryGroupRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public updateInventoryGroup(
    orgId: string,
    inventoryGroupId: string,
    apiSvcUpdateInventoryGroupRequest: ApiSvcUpdateInventoryGroupRequest,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .updateInventoryGroup(orgId, inventoryGroupId, apiSvcUpdateInventoryGroupRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} inventoryViewId
   * @param {ApiSvcUpdateInventoryViewRequest} apiSvcUpdateInventoryViewRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public updateViewProperties(
    orgId: string,
    inventoryViewId: string,
    apiSvcUpdateInventoryViewRequest: ApiSvcUpdateInventoryViewRequest,
    options?: AxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .updateViewProperties(orgId, inventoryViewId, apiSvcUpdateInventoryViewRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * InvoicesApi - axios parameter creator
 * @export
 */
export const InvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} invoiceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceForId: async (
      orgId: string,
      invoiceId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInvoiceForId', 'orgId', orgId);
      // verify required parameter 'invoiceId' is not null or undefined
      assertParamExists('getInvoiceForId', 'invoiceId', invoiceId);
      const localVarPath = `/invoices/{orgId}/invoice/{invoiceId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'invoiceId'}}`, encodeURIComponent(String(invoiceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {boolean} [includeDisabled]
     * @param {string} [contactId]
     * @param {string} [lastRef]
     * @param {number} [pageSize]
     * @param {any} [orderDirection]
     * @param {string} [orderKey]
     * @param {string} [filterString]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoices: async (
      orgId: string,
      includeDisabled?: boolean,
      contactId?: string,
      lastRef?: string,
      pageSize?: number,
      orderDirection?: any,
      orderKey?: string,
      filterString?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getInvoices', 'orgId', orgId);
      const localVarPath = `/invoices/{orgId}`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (includeDisabled !== undefined) {
        localVarQueryParameter['includeDisabled'] = includeDisabled;
      }

      if (contactId !== undefined) {
        localVarQueryParameter['contactId'] = contactId;
      }

      if (lastRef !== undefined) {
        localVarQueryParameter['lastRef'] = lastRef;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      if (orderDirection !== undefined) {
        localVarQueryParameter['orderDirection'] = orderDirection;
      }

      if (orderKey !== undefined) {
        localVarQueryParameter['orderKey'] = orderKey;
      }

      if (filterString !== undefined) {
        localVarQueryParameter['filterString'] = filterString;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} invoiceId
     * @param {ApiSvcSendRemittanceAdviceDTO} apiSvcSendRemittanceAdviceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendRemittanceAdvice: async (
      orgId: string,
      invoiceId: string,
      apiSvcSendRemittanceAdviceDTO: ApiSvcSendRemittanceAdviceDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('sendRemittanceAdvice', 'orgId', orgId);
      // verify required parameter 'invoiceId' is not null or undefined
      assertParamExists('sendRemittanceAdvice', 'invoiceId', invoiceId);
      // verify required parameter 'apiSvcSendRemittanceAdviceDTO' is not null or undefined
      assertParamExists('sendRemittanceAdvice', 'apiSvcSendRemittanceAdviceDTO', apiSvcSendRemittanceAdviceDTO);
      const localVarPath = `/invoices/{orgId}/invoice/{invoiceId}/email/remittance-advice`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'invoiceId'}}`, encodeURIComponent(String(invoiceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcSendRemittanceAdviceDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} invoiceId
     * @param {ApiSvcSendRemittanceAdviceDTOV1} apiSvcSendRemittanceAdviceDTOV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendRemittanceAdviceV2: async (
      orgId: string,
      invoiceId: string,
      apiSvcSendRemittanceAdviceDTOV1: ApiSvcSendRemittanceAdviceDTOV1,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('sendRemittanceAdviceV2', 'orgId', orgId);
      // verify required parameter 'invoiceId' is not null or undefined
      assertParamExists('sendRemittanceAdviceV2', 'invoiceId', invoiceId);
      // verify required parameter 'apiSvcSendRemittanceAdviceDTOV1' is not null or undefined
      assertParamExists('sendRemittanceAdviceV2', 'apiSvcSendRemittanceAdviceDTOV1', apiSvcSendRemittanceAdviceDTOV1);
      const localVarPath = `/invoices/{orgId}/invoice/{invoiceId}/email/remittance-advice-v2`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'invoiceId'}}`, encodeURIComponent(String(invoiceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcSendRemittanceAdviceDTOV1,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUpdateInvoicesFromRemoteSourceDTO} apiSvcUpdateInvoicesFromRemoteSourceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvoicesFromRemoteSource: async (
      orgId: string,
      apiSvcUpdateInvoicesFromRemoteSourceDTO: ApiSvcUpdateInvoicesFromRemoteSourceDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateInvoicesFromRemoteSource', 'orgId', orgId);
      // verify required parameter 'apiSvcUpdateInvoicesFromRemoteSourceDTO' is not null or undefined
      assertParamExists(
        'updateInvoicesFromRemoteSource',
        'apiSvcUpdateInvoicesFromRemoteSourceDTO',
        apiSvcUpdateInvoicesFromRemoteSourceDTO
      );
      const localVarPath = `/invoices/{orgId}`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateInvoicesFromRemoteSourceDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InvoicesApi - functional programming interface
 * @export
 */
export const InvoicesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} invoiceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInvoiceForId(
      orgId: string,
      invoiceId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInvoiceDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceForId(orgId, invoiceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {boolean} [includeDisabled]
     * @param {string} [contactId]
     * @param {string} [lastRef]
     * @param {number} [pageSize]
     * @param {any} [orderDirection]
     * @param {string} [orderKey]
     * @param {string} [filterString]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInvoices(
      orgId: string,
      includeDisabled?: boolean,
      contactId?: string,
      lastRef?: string,
      pageSize?: number,
      orderDirection?: any,
      orderKey?: string,
      filterString?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcInvoicesDTOFilteredPaginated>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(
        orgId,
        includeDisabled,
        contactId,
        lastRef,
        pageSize,
        orderDirection,
        orderKey,
        filterString,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} invoiceId
     * @param {ApiSvcSendRemittanceAdviceDTO} apiSvcSendRemittanceAdviceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendRemittanceAdvice(
      orgId: string,
      invoiceId: string,
      apiSvcSendRemittanceAdviceDTO: ApiSvcSendRemittanceAdviceDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sendRemittanceAdvice(
        orgId,
        invoiceId,
        apiSvcSendRemittanceAdviceDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} invoiceId
     * @param {ApiSvcSendRemittanceAdviceDTOV1} apiSvcSendRemittanceAdviceDTOV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendRemittanceAdviceV2(
      orgId: string,
      invoiceId: string,
      apiSvcSendRemittanceAdviceDTOV1: ApiSvcSendRemittanceAdviceDTOV1,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sendRemittanceAdviceV2(
        orgId,
        invoiceId,
        apiSvcSendRemittanceAdviceDTOV1,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUpdateInvoicesFromRemoteSourceDTO} apiSvcUpdateInvoicesFromRemoteSourceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateInvoicesFromRemoteSource(
      orgId: string,
      apiSvcUpdateInvoicesFromRemoteSourceDTO: ApiSvcUpdateInvoicesFromRemoteSourceDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcInvoiceDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateInvoicesFromRemoteSource(
        orgId,
        apiSvcUpdateInvoicesFromRemoteSourceDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * InvoicesApi - factory interface
 * @export
 */
export const InvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = InvoicesApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} invoiceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceForId(orgId: string, invoiceId: string, options?: any): AxiosPromise<ApiSvcInvoiceDTO> {
      return localVarFp.getInvoiceForId(orgId, invoiceId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {boolean} [includeDisabled]
     * @param {string} [contactId]
     * @param {string} [lastRef]
     * @param {number} [pageSize]
     * @param {any} [orderDirection]
     * @param {string} [orderKey]
     * @param {string} [filterString]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoices(
      orgId: string,
      includeDisabled?: boolean,
      contactId?: string,
      lastRef?: string,
      pageSize?: number,
      orderDirection?: any,
      orderKey?: string,
      filterString?: string,
      options?: any
    ): AxiosPromise<ApiSvcInvoicesDTOFilteredPaginated> {
      return localVarFp
        .getInvoices(
          orgId,
          includeDisabled,
          contactId,
          lastRef,
          pageSize,
          orderDirection,
          orderKey,
          filterString,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} invoiceId
     * @param {ApiSvcSendRemittanceAdviceDTO} apiSvcSendRemittanceAdviceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendRemittanceAdvice(
      orgId: string,
      invoiceId: string,
      apiSvcSendRemittanceAdviceDTO: ApiSvcSendRemittanceAdviceDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .sendRemittanceAdvice(orgId, invoiceId, apiSvcSendRemittanceAdviceDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} invoiceId
     * @param {ApiSvcSendRemittanceAdviceDTOV1} apiSvcSendRemittanceAdviceDTOV1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendRemittanceAdviceV2(
      orgId: string,
      invoiceId: string,
      apiSvcSendRemittanceAdviceDTOV1: ApiSvcSendRemittanceAdviceDTOV1,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .sendRemittanceAdviceV2(orgId, invoiceId, apiSvcSendRemittanceAdviceDTOV1, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUpdateInvoicesFromRemoteSourceDTO} apiSvcUpdateInvoicesFromRemoteSourceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvoicesFromRemoteSource(
      orgId: string,
      apiSvcUpdateInvoicesFromRemoteSourceDTO: ApiSvcUpdateInvoicesFromRemoteSourceDTO,
      options?: any
    ): AxiosPromise<Array<ApiSvcInvoiceDTO>> {
      return localVarFp
        .updateInvoicesFromRemoteSource(orgId, apiSvcUpdateInvoicesFromRemoteSourceDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * InvoicesApi - object-oriented interface
 * @export
 * @class InvoicesApi
 * @extends {BaseAPI}
 */
export class InvoicesApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {string} invoiceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  public getInvoiceForId(orgId: string, invoiceId: string, options?: AxiosRequestConfig) {
    return InvoicesApiFp(this.configuration)
      .getInvoiceForId(orgId, invoiceId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {boolean} [includeDisabled]
   * @param {string} [contactId]
   * @param {string} [lastRef]
   * @param {number} [pageSize]
   * @param {any} [orderDirection]
   * @param {string} [orderKey]
   * @param {string} [filterString]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  public getInvoices(
    orgId: string,
    includeDisabled?: boolean,
    contactId?: string,
    lastRef?: string,
    pageSize?: number,
    orderDirection?: any,
    orderKey?: string,
    filterString?: string,
    options?: AxiosRequestConfig
  ) {
    return InvoicesApiFp(this.configuration)
      .getInvoices(
        orgId,
        includeDisabled,
        contactId,
        lastRef,
        pageSize,
        orderDirection,
        orderKey,
        filterString,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} invoiceId
   * @param {ApiSvcSendRemittanceAdviceDTO} apiSvcSendRemittanceAdviceDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  public sendRemittanceAdvice(
    orgId: string,
    invoiceId: string,
    apiSvcSendRemittanceAdviceDTO: ApiSvcSendRemittanceAdviceDTO,
    options?: AxiosRequestConfig
  ) {
    return InvoicesApiFp(this.configuration)
      .sendRemittanceAdvice(orgId, invoiceId, apiSvcSendRemittanceAdviceDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} invoiceId
   * @param {ApiSvcSendRemittanceAdviceDTOV1} apiSvcSendRemittanceAdviceDTOV1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  public sendRemittanceAdviceV2(
    orgId: string,
    invoiceId: string,
    apiSvcSendRemittanceAdviceDTOV1: ApiSvcSendRemittanceAdviceDTOV1,
    options?: AxiosRequestConfig
  ) {
    return InvoicesApiFp(this.configuration)
      .sendRemittanceAdviceV2(orgId, invoiceId, apiSvcSendRemittanceAdviceDTOV1, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcUpdateInvoicesFromRemoteSourceDTO} apiSvcUpdateInvoicesFromRemoteSourceDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  public updateInvoicesFromRemoteSource(
    orgId: string,
    apiSvcUpdateInvoicesFromRemoteSourceDTO: ApiSvcUpdateInvoicesFromRemoteSourceDTO,
    options?: AxiosRequestConfig
  ) {
    return InvoicesApiFp(this.configuration)
      .updateInvoicesFromRemoteSource(orgId, apiSvcUpdateInvoicesFromRemoteSourceDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Callback for the workflow step
     * @param {string} workflowDefinitionId
     * @param {string} workflow
     * @param {string} step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    callback: async (
      workflowDefinitionId: string,
      workflow: string,
      step: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'workflowDefinitionId' is not null or undefined
      assertParamExists('callback', 'workflowDefinitionId', workflowDefinitionId);
      // verify required parameter 'workflow' is not null or undefined
      assertParamExists('callback', 'workflow', workflow);
      // verify required parameter 'step' is not null or undefined
      assertParamExists('callback', 'step', step);
      const localVarPath = `/jobs/callback/workflowDefinitions/{workflowDefinitionId}/workflows/{workflow}/steps/{step}`
        .replace(`{${'workflowDefinitionId'}}`, encodeURIComponent(String(workflowDefinitionId)))
        .replace(`{${'workflow'}}`, encodeURIComponent(String(workflow)))
        .replace(`{${'step'}}`, encodeURIComponent(String(step)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets a list of jobs
     * @param {string} [jobRunnerId] Optional runner ID filter — only return jobs for this runner. Used when multiple roles share the same host.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJob: async (jobRunnerId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/jobs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (jobRunnerId !== undefined) {
        localVarQueryParameter['jobRunnerId'] = jobRunnerId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Starts a workflow instance running
     * @param {string} workflowDefinitionId
     * @param {string} jobId
     * @param {string} [taskFilter]
     * @param {boolean} [overrideHeartbeatCheck]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    start: async (
      workflowDefinitionId: string,
      jobId: string,
      taskFilter?: string,
      overrideHeartbeatCheck?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'workflowDefinitionId' is not null or undefined
      assertParamExists('start', 'workflowDefinitionId', workflowDefinitionId);
      // verify required parameter 'jobId' is not null or undefined
      assertParamExists('start', 'jobId', jobId);
      const localVarPath = `/jobs/{workflowDefinitionId}/{jobId}/start`
        .replace(`{${'workflowDefinitionId'}}`, encodeURIComponent(String(workflowDefinitionId)))
        .replace(`{${'jobId'}}`, encodeURIComponent(String(jobId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (taskFilter !== undefined) {
        localVarQueryParameter['taskFilter'] = taskFilter;
      }

      if (overrideHeartbeatCheck !== undefined) {
        localVarQueryParameter['overrideHeartbeatCheck'] = overrideHeartbeatCheck;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration);
  return {
    /**
     * Callback for the workflow step
     * @param {string} workflowDefinitionId
     * @param {string} workflow
     * @param {string} step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async callback(
      workflowDefinitionId: string,
      workflow: string,
      step: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.callback(workflowDefinitionId, workflow, step, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Gets a list of jobs
     * @param {string} [jobRunnerId] Optional runner ID filter — only return jobs for this runner. Used when multiple roles share the same host.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getJob(
      jobRunnerId?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcJobsPageResultDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getJob(jobRunnerId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Starts a workflow instance running
     * @param {string} workflowDefinitionId
     * @param {string} jobId
     * @param {string} [taskFilter]
     * @param {boolean} [overrideHeartbeatCheck]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async start(
      workflowDefinitionId: string,
      jobId: string,
      taskFilter?: string,
      overrideHeartbeatCheck?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcStart200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.start(
        workflowDefinitionId,
        jobId,
        taskFilter,
        overrideHeartbeatCheck,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = JobsApiFp(configuration);
  return {
    /**
     * Callback for the workflow step
     * @param {string} workflowDefinitionId
     * @param {string} workflow
     * @param {string} step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    callback(workflowDefinitionId: string, workflow: string, step: string, options?: any): AxiosPromise<any> {
      return localVarFp
        .callback(workflowDefinitionId, workflow, step, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gets a list of jobs
     * @param {string} [jobRunnerId] Optional runner ID filter — only return jobs for this runner. Used when multiple roles share the same host.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJob(jobRunnerId?: string, options?: any): AxiosPromise<ApiSvcJobsPageResultDto> {
      return localVarFp.getJob(jobRunnerId, options).then((request) => request(axios, basePath));
    },
    /**
     * Starts a workflow instance running
     * @param {string} workflowDefinitionId
     * @param {string} jobId
     * @param {string} [taskFilter]
     * @param {boolean} [overrideHeartbeatCheck]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    start(
      workflowDefinitionId: string,
      jobId: string,
      taskFilter?: string,
      overrideHeartbeatCheck?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcStart200Response> {
      return localVarFp
        .start(workflowDefinitionId, jobId, taskFilter, overrideHeartbeatCheck, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
  /**
   * Callback for the workflow step
   * @param {string} workflowDefinitionId
   * @param {string} workflow
   * @param {string} step
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public callback(workflowDefinitionId: string, workflow: string, step: string, options?: AxiosRequestConfig) {
    return JobsApiFp(this.configuration)
      .callback(workflowDefinitionId, workflow, step, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Gets a list of jobs
   * @param {string} [jobRunnerId] Optional runner ID filter — only return jobs for this runner. Used when multiple roles share the same host.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public getJob(jobRunnerId?: string, options?: AxiosRequestConfig) {
    return JobsApiFp(this.configuration)
      .getJob(jobRunnerId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Starts a workflow instance running
   * @param {string} workflowDefinitionId
   * @param {string} jobId
   * @param {string} [taskFilter]
   * @param {boolean} [overrideHeartbeatCheck]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public start(
    workflowDefinitionId: string,
    jobId: string,
    taskFilter?: string,
    overrideHeartbeatCheck?: boolean,
    options?: AxiosRequestConfig
  ) {
    return JobsApiFp(this.configuration)
      .start(workflowDefinitionId, jobId, taskFilter, overrideHeartbeatCheck, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * LabelsApi - axios parameter creator
 * @export
 */
export const LabelsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Create a new label definition
     * @param {string} orgId
     * @param {ApiSvcCreateOrgLabelRequest} apiSvcCreateOrgLabelRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrgLabelDefinition: async (
      orgId: string,
      apiSvcCreateOrgLabelRequest: ApiSvcCreateOrgLabelRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createOrgLabelDefinition', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateOrgLabelRequest' is not null or undefined
      assertParamExists('createOrgLabelDefinition', 'apiSvcCreateOrgLabelRequest', apiSvcCreateOrgLabelRequest);
      const localVarPath = `/orgs/{orgId}/labels`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateOrgLabelRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Delete a label definition
     * @param {string} orgId
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrgLabelDefinition: async (
      orgId: string,
      labelId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deleteOrgLabelDefinition', 'orgId', orgId);
      // verify required parameter 'labelId' is not null or undefined
      assertParamExists('deleteOrgLabelDefinition', 'labelId', labelId);
      const localVarPath = `/orgs/{orgId}/labels/{labelId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'labelId'}}`, encodeURIComponent(String(labelId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get a single label definition
     * @param {string} orgId
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgLabelDefinition: async (
      orgId: string,
      labelId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrgLabelDefinition', 'orgId', orgId);
      // verify required parameter 'labelId' is not null or undefined
      assertParamExists('getOrgLabelDefinition', 'labelId', labelId);
      const localVarPath = `/orgs/{orgId}/labels/{labelId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'labelId'}}`, encodeURIComponent(String(labelId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns label definitions for an organization, with optional filters.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken] Server-issued cursor from a prior page. Filter parameters (&#x60;allowSlugs&#x60; / &#x60;slugType&#x60; / &#x60;search&#x60; / &#x60;status&#x60;) MUST be identical to those used when the token was issued; mixing filters across pages produces undefined ordering and may skip or duplicate reserved rows.
     * @param {boolean} [allowSlugs] Restrict to slug-enabled templates (&#x60;true&#x60;) or bare-tag labels (&#x60;false&#x60;). Omit for \&quot;all\&quot;.
     * @param {ApiSvcSlugType} [slugType] Restrict to a specific slug variable type. Implies &#x60;allowSlugs&#x3D;true&#x60; semantically.
     * @param {string} [search] Case-insensitive substring match against label name OR description.
     * @param {ApiSvcOrgLabelStatusFilter} [status] &#x60;enabled&#x60; | &#x60;disabled&#x60; | &#x60;all&#x60; (default &#x60;all&#x60;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgLabelDefinitions: async (
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      allowSlugs?: boolean,
      slugType?: ApiSvcSlugType,
      search?: string,
      status?: ApiSvcOrgLabelStatusFilter,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrgLabelDefinitions', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/labels`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageLimit !== undefined) {
        localVarQueryParameter['pageLimit'] = pageLimit;
      }

      if (paginationToken !== undefined) {
        localVarQueryParameter['paginationToken'] = paginationToken;
      }

      if (allowSlugs !== undefined) {
        localVarQueryParameter['allowSlugs'] = allowSlugs;
      }

      if (slugType !== undefined) {
        localVarQueryParameter['slugType'] = slugType;
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search;
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns the set of slug-enabled label identifiers currently in use by an org. Used by the rules picker / filter dropdowns to enumerate available slug templates without paginating through every label.  Reserved labels are excluded — they\'re bare tags, not templates.
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgLabelSlugTemplates: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrgLabelSlugTemplates', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/labels/slug-templates`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Partially update a label definition.  Editable fields: `description`, `disabled`, `slugValidationPattern`. `name`, `allowSlugs`, and `slugType` are immutable post-create.
     * @param {string} orgId
     * @param {string} labelId
     * @param {ApiSvcPatchOrgLabelRequest} apiSvcPatchOrgLabelRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchOrgLabelDefinition: async (
      orgId: string,
      labelId: string,
      apiSvcPatchOrgLabelRequest: ApiSvcPatchOrgLabelRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('patchOrgLabelDefinition', 'orgId', orgId);
      // verify required parameter 'labelId' is not null or undefined
      assertParamExists('patchOrgLabelDefinition', 'labelId', labelId);
      // verify required parameter 'apiSvcPatchOrgLabelRequest' is not null or undefined
      assertParamExists('patchOrgLabelDefinition', 'apiSvcPatchOrgLabelRequest', apiSvcPatchOrgLabelRequest);
      const localVarPath = `/orgs/{orgId}/labels/{labelId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'labelId'}}`, encodeURIComponent(String(labelId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcPatchOrgLabelRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LabelsApi - functional programming interface
 * @export
 */
export const LabelsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LabelsApiAxiosParamCreator(configuration);
  return {
    /**
     * Create a new label definition
     * @param {string} orgId
     * @param {ApiSvcCreateOrgLabelRequest} apiSvcCreateOrgLabelRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createOrgLabelDefinition(
      orgId: string,
      apiSvcCreateOrgLabelRequest: ApiSvcCreateOrgLabelRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcOrgLabelDefinition>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createOrgLabelDefinition(
        orgId,
        apiSvcCreateOrgLabelRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Delete a label definition
     * @param {string} orgId
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteOrgLabelDefinition(
      orgId: string,
      labelId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrgLabelDefinition(orgId, labelId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get a single label definition
     * @param {string} orgId
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrgLabelDefinition(
      orgId: string,
      labelId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetOrgLabelDefinition200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgLabelDefinition(orgId, labelId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns label definitions for an organization, with optional filters.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken] Server-issued cursor from a prior page. Filter parameters (&#x60;allowSlugs&#x60; / &#x60;slugType&#x60; / &#x60;search&#x60; / &#x60;status&#x60;) MUST be identical to those used when the token was issued; mixing filters across pages produces undefined ordering and may skip or duplicate reserved rows.
     * @param {boolean} [allowSlugs] Restrict to slug-enabled templates (&#x60;true&#x60;) or bare-tag labels (&#x60;false&#x60;). Omit for \&quot;all\&quot;.
     * @param {ApiSvcSlugType} [slugType] Restrict to a specific slug variable type. Implies &#x60;allowSlugs&#x3D;true&#x60; semantically.
     * @param {string} [search] Case-insensitive substring match against label name OR description.
     * @param {ApiSvcOrgLabelStatusFilter} [status] &#x60;enabled&#x60; | &#x60;disabled&#x60; | &#x60;all&#x60; (default &#x60;all&#x60;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrgLabelDefinitions(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      allowSlugs?: boolean,
      slugType?: ApiSvcSlugType,
      search?: string,
      status?: ApiSvcOrgLabelStatusFilter,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcOrgLabelDefinitionsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgLabelDefinitions(
        orgId,
        pageLimit,
        paginationToken,
        allowSlugs,
        slugType,
        search,
        status,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns the set of slug-enabled label identifiers currently in use by an org. Used by the rules picker / filter dropdowns to enumerate available slug templates without paginating through every label.  Reserved labels are excluded — they\'re bare tags, not templates.
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrgLabelSlugTemplates(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcOrgLabelSlugTemplatesResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgLabelSlugTemplates(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Partially update a label definition.  Editable fields: `description`, `disabled`, `slugValidationPattern`. `name`, `allowSlugs`, and `slugType` are immutable post-create.
     * @param {string} orgId
     * @param {string} labelId
     * @param {ApiSvcPatchOrgLabelRequest} apiSvcPatchOrgLabelRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchOrgLabelDefinition(
      orgId: string,
      labelId: string,
      apiSvcPatchOrgLabelRequest: ApiSvcPatchOrgLabelRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetOrgLabelDefinition200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchOrgLabelDefinition(
        orgId,
        labelId,
        apiSvcPatchOrgLabelRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * LabelsApi - factory interface
 * @export
 */
export const LabelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = LabelsApiFp(configuration);
  return {
    /**
     * Create a new label definition
     * @param {string} orgId
     * @param {ApiSvcCreateOrgLabelRequest} apiSvcCreateOrgLabelRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrgLabelDefinition(
      orgId: string,
      apiSvcCreateOrgLabelRequest: ApiSvcCreateOrgLabelRequest,
      options?: any
    ): AxiosPromise<ApiSvcOrgLabelDefinition> {
      return localVarFp
        .createOrgLabelDefinition(orgId, apiSvcCreateOrgLabelRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Delete a label definition
     * @param {string} orgId
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrgLabelDefinition(
      orgId: string,
      labelId: string,
      options?: any
    ): AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response> {
      return localVarFp.deleteOrgLabelDefinition(orgId, labelId, options).then((request) => request(axios, basePath));
    },
    /**
     * Get a single label definition
     * @param {string} orgId
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgLabelDefinition(
      orgId: string,
      labelId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetOrgLabelDefinition200Response> {
      return localVarFp.getOrgLabelDefinition(orgId, labelId, options).then((request) => request(axios, basePath));
    },
    /**
     * Returns label definitions for an organization, with optional filters.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken] Server-issued cursor from a prior page. Filter parameters (&#x60;allowSlugs&#x60; / &#x60;slugType&#x60; / &#x60;search&#x60; / &#x60;status&#x60;) MUST be identical to those used when the token was issued; mixing filters across pages produces undefined ordering and may skip or duplicate reserved rows.
     * @param {boolean} [allowSlugs] Restrict to slug-enabled templates (&#x60;true&#x60;) or bare-tag labels (&#x60;false&#x60;). Omit for \&quot;all\&quot;.
     * @param {ApiSvcSlugType} [slugType] Restrict to a specific slug variable type. Implies &#x60;allowSlugs&#x3D;true&#x60; semantically.
     * @param {string} [search] Case-insensitive substring match against label name OR description.
     * @param {ApiSvcOrgLabelStatusFilter} [status] &#x60;enabled&#x60; | &#x60;disabled&#x60; | &#x60;all&#x60; (default &#x60;all&#x60;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgLabelDefinitions(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      allowSlugs?: boolean,
      slugType?: ApiSvcSlugType,
      search?: string,
      status?: ApiSvcOrgLabelStatusFilter,
      options?: any
    ): AxiosPromise<ApiSvcOrgLabelDefinitionsResponse> {
      return localVarFp
        .getOrgLabelDefinitions(orgId, pageLimit, paginationToken, allowSlugs, slugType, search, status, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns the set of slug-enabled label identifiers currently in use by an org. Used by the rules picker / filter dropdowns to enumerate available slug templates without paginating through every label.  Reserved labels are excluded — they\'re bare tags, not templates.
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgLabelSlugTemplates(orgId: string, options?: any): AxiosPromise<ApiSvcOrgLabelSlugTemplatesResponse> {
      return localVarFp.getOrgLabelSlugTemplates(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     * Partially update a label definition.  Editable fields: `description`, `disabled`, `slugValidationPattern`. `name`, `allowSlugs`, and `slugType` are immutable post-create.
     * @param {string} orgId
     * @param {string} labelId
     * @param {ApiSvcPatchOrgLabelRequest} apiSvcPatchOrgLabelRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchOrgLabelDefinition(
      orgId: string,
      labelId: string,
      apiSvcPatchOrgLabelRequest: ApiSvcPatchOrgLabelRequest,
      options?: any
    ): AxiosPromise<ApiSvcGetOrgLabelDefinition200Response> {
      return localVarFp
        .patchOrgLabelDefinition(orgId, labelId, apiSvcPatchOrgLabelRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * LabelsApi - object-oriented interface
 * @export
 * @class LabelsApi
 * @extends {BaseAPI}
 */
export class LabelsApi extends BaseAPI {
  /**
   * Create a new label definition
   * @param {string} orgId
   * @param {ApiSvcCreateOrgLabelRequest} apiSvcCreateOrgLabelRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LabelsApi
   */
  public createOrgLabelDefinition(
    orgId: string,
    apiSvcCreateOrgLabelRequest: ApiSvcCreateOrgLabelRequest,
    options?: AxiosRequestConfig
  ) {
    return LabelsApiFp(this.configuration)
      .createOrgLabelDefinition(orgId, apiSvcCreateOrgLabelRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Delete a label definition
   * @param {string} orgId
   * @param {string} labelId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LabelsApi
   */
  public deleteOrgLabelDefinition(orgId: string, labelId: string, options?: AxiosRequestConfig) {
    return LabelsApiFp(this.configuration)
      .deleteOrgLabelDefinition(orgId, labelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get a single label definition
   * @param {string} orgId
   * @param {string} labelId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LabelsApi
   */
  public getOrgLabelDefinition(orgId: string, labelId: string, options?: AxiosRequestConfig) {
    return LabelsApiFp(this.configuration)
      .getOrgLabelDefinition(orgId, labelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns label definitions for an organization, with optional filters.
   * @param {string} orgId
   * @param {number} [pageLimit]
   * @param {string} [paginationToken] Server-issued cursor from a prior page. Filter parameters (&#x60;allowSlugs&#x60; / &#x60;slugType&#x60; / &#x60;search&#x60; / &#x60;status&#x60;) MUST be identical to those used when the token was issued; mixing filters across pages produces undefined ordering and may skip or duplicate reserved rows.
   * @param {boolean} [allowSlugs] Restrict to slug-enabled templates (&#x60;true&#x60;) or bare-tag labels (&#x60;false&#x60;). Omit for \&quot;all\&quot;.
   * @param {ApiSvcSlugType} [slugType] Restrict to a specific slug variable type. Implies &#x60;allowSlugs&#x3D;true&#x60; semantically.
   * @param {string} [search] Case-insensitive substring match against label name OR description.
   * @param {ApiSvcOrgLabelStatusFilter} [status] &#x60;enabled&#x60; | &#x60;disabled&#x60; | &#x60;all&#x60; (default &#x60;all&#x60;).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LabelsApi
   */
  public getOrgLabelDefinitions(
    orgId: string,
    pageLimit?: number,
    paginationToken?: string,
    allowSlugs?: boolean,
    slugType?: ApiSvcSlugType,
    search?: string,
    status?: ApiSvcOrgLabelStatusFilter,
    options?: AxiosRequestConfig
  ) {
    return LabelsApiFp(this.configuration)
      .getOrgLabelDefinitions(orgId, pageLimit, paginationToken, allowSlugs, slugType, search, status, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns the set of slug-enabled label identifiers currently in use by an org. Used by the rules picker / filter dropdowns to enumerate available slug templates without paginating through every label.  Reserved labels are excluded — they\'re bare tags, not templates.
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LabelsApi
   */
  public getOrgLabelSlugTemplates(orgId: string, options?: AxiosRequestConfig) {
    return LabelsApiFp(this.configuration)
      .getOrgLabelSlugTemplates(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Partially update a label definition.  Editable fields: `description`, `disabled`, `slugValidationPattern`. `name`, `allowSlugs`, and `slugType` are immutable post-create.
   * @param {string} orgId
   * @param {string} labelId
   * @param {ApiSvcPatchOrgLabelRequest} apiSvcPatchOrgLabelRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LabelsApi
   */
  public patchOrgLabelDefinition(
    orgId: string,
    labelId: string,
    apiSvcPatchOrgLabelRequest: ApiSvcPatchOrgLabelRequest,
    options?: AxiosRequestConfig
  ) {
    return LabelsApiFp(this.configuration)
      .patchOrgLabelDefinition(orgId, labelId, apiSvcPatchOrgLabelRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Send an internal notification (Slack) on behalf of an org. Generic passthrough to the notification service: the caller supplies the target channel and the fully-formed message. The first consumer is the DeFi upsell \"Request a Protocol\" flow; reuse it for other notifications.
     * @param {string} orgId
     * @param {ApiSvcNotificationRequest} apiSvcNotificationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createNotification: async (
      orgId: string,
      apiSvcNotificationRequest: ApiSvcNotificationRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createNotification', 'orgId', orgId);
      // verify required parameter 'apiSvcNotificationRequest' is not null or undefined
      assertParamExists('createNotification', 'apiSvcNotificationRequest', apiSvcNotificationRequest);
      const localVarPath = `/orgs/{orgId}/notifications`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcNotificationRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration);
  return {
    /**
     * Send an internal notification (Slack) on behalf of an org. Generic passthrough to the notification service: the caller supplies the target channel and the fully-formed message. The first consumer is the DeFi upsell \"Request a Protocol\" flow; reuse it for other notifications.
     * @param {string} orgId
     * @param {ApiSvcNotificationRequest} apiSvcNotificationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createNotification(
      orgId: string,
      apiSvcNotificationRequest: ApiSvcNotificationRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createNotification(
        orgId,
        apiSvcNotificationRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = NotificationsApiFp(configuration);
  return {
    /**
     * Send an internal notification (Slack) on behalf of an org. Generic passthrough to the notification service: the caller supplies the target channel and the fully-formed message. The first consumer is the DeFi upsell \"Request a Protocol\" flow; reuse it for other notifications.
     * @param {string} orgId
     * @param {ApiSvcNotificationRequest} apiSvcNotificationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createNotification(
      orgId: string,
      apiSvcNotificationRequest: ApiSvcNotificationRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .createNotification(orgId, apiSvcNotificationRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
  /**
   * Send an internal notification (Slack) on behalf of an org. Generic passthrough to the notification service: the caller supplies the target channel and the fully-formed message. The first consumer is the DeFi upsell \"Request a Protocol\" flow; reuse it for other notifications.
   * @param {string} orgId
   * @param {ApiSvcNotificationRequest} apiSvcNotificationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  public createNotification(
    orgId: string,
    apiSvcNotificationRequest: ApiSvcNotificationRequest,
    options?: AxiosRequestConfig
  ) {
    return NotificationsApiFp(this.configuration)
      .createNotification(orgId, apiSvcNotificationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateSubsidiaryRequest} apiSvcCreateSubsidiaryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSubsidiary: async (
      orgId: string,
      apiSvcCreateSubsidiaryRequest: ApiSvcCreateSubsidiaryRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createSubsidiary', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateSubsidiaryRequest' is not null or undefined
      assertParamExists('createSubsidiary', 'apiSvcCreateSubsidiaryRequest', apiSvcCreateSubsidiaryRequest);
      const localVarPath = `/orgs/{orgId}/subsidiaries`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateSubsidiaryRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcNetworks} networkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTokenFilteringRules: async (
      orgId: string,
      networkId: ApiSvcNetworks,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTokenFilteringRules', 'orgId', orgId);
      // verify required parameter 'networkId' is not null or undefined
      assertParamExists('getTokenFilteringRules', 'networkId', networkId);
      const localVarPath = `/orgSyncRules/{orgId}/tokenFilterRules/{networkId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'networkId'}}`, encodeURIComponent(String(networkId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns all organizations associated with a user\'s account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserOrganizations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/organizations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSubsidiaries: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('listSubsidiaries', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/subsidiaries`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateSubsidiaryRequest} apiSvcCreateSubsidiaryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createSubsidiary(
      orgId: string,
      apiSvcCreateSubsidiaryRequest: ApiSvcCreateSubsidiaryRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcSubsidiary>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createSubsidiary(
        orgId,
        apiSvcCreateSubsidiaryRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcNetworks} networkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTokenFilteringRules(
      orgId: string,
      networkId: ApiSvcNetworks,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTokenFilteringRules200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTokenFilteringRules(orgId, networkId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns all organizations associated with a user\'s account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserOrganizations(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetUserOrganizations200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUserOrganizations(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listSubsidiaries(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcSubsidiary>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listSubsidiaries(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = OrganizationsApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateSubsidiaryRequest} apiSvcCreateSubsidiaryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSubsidiary(
      orgId: string,
      apiSvcCreateSubsidiaryRequest: ApiSvcCreateSubsidiaryRequest,
      options?: any
    ): AxiosPromise<ApiSvcSubsidiary> {
      return localVarFp
        .createSubsidiary(orgId, apiSvcCreateSubsidiaryRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcNetworks} networkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTokenFilteringRules(
      orgId: string,
      networkId: ApiSvcNetworks,
      options?: any
    ): AxiosPromise<ApiSvcGetTokenFilteringRules200Response> {
      return localVarFp.getTokenFilteringRules(orgId, networkId, options).then((request) => request(axios, basePath));
    },
    /**
     * Returns all organizations associated with a user\'s account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserOrganizations(options?: any): AxiosPromise<ApiSvcGetUserOrganizations200Response> {
      return localVarFp.getUserOrganizations(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSubsidiaries(orgId: string, options?: any): AxiosPromise<Array<ApiSvcSubsidiary>> {
      return localVarFp.listSubsidiaries(orgId, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateSubsidiaryRequest} apiSvcCreateSubsidiaryRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationsApi
   */
  public createSubsidiary(
    orgId: string,
    apiSvcCreateSubsidiaryRequest: ApiSvcCreateSubsidiaryRequest,
    options?: AxiosRequestConfig
  ) {
    return OrganizationsApiFp(this.configuration)
      .createSubsidiary(orgId, apiSvcCreateSubsidiaryRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcNetworks} networkId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationsApi
   */
  public getTokenFilteringRules(orgId: string, networkId: ApiSvcNetworks, options?: AxiosRequestConfig) {
    return OrganizationsApiFp(this.configuration)
      .getTokenFilteringRules(orgId, networkId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns all organizations associated with a user\'s account.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationsApi
   */
  public getUserOrganizations(options?: AxiosRequestConfig) {
    return OrganizationsApiFp(this.configuration)
      .getUserOrganizations(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationsApi
   */
  public listSubsidiaries(orgId: string, options?: AxiosRequestConfig) {
    return OrganizationsApiFp(this.configuration)
      .listSubsidiaries(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * OrgsApi - axios parameter creator
 * @export
 */
export const OrgsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Promote an org\'s managed table from CENTRALIZED/DUAL_WRITE to PER_ORG. Creates the per-org BQ table if missing, copies any centralized rows for this org into it, and stamps the migratedAtSEC label so the read path switches over. Idempotent — returns skipped=true if already PER_ORG.  For brand-new orgs with no centralized data this still does the right thing: 0 rows copied, table created empty, phase flips to PER_ORG.
     * @param {string} orgId
     * @param {string} tableType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    backfillManagedTable: async (
      orgId: string,
      tableType: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('backfillManagedTable', 'orgId', orgId);
      // verify required parameter 'tableType' is not null or undefined
      assertParamExists('backfillManagedTable', 'tableType', tableType);
      const localVarPath = `/orgs/{orgId}/managed-tables/{tableType}/backfill`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'tableType'}}`, encodeURIComponent(String(tableType)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} executionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelClone: async (orgId: string, executionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('cancelClone', 'orgId', orgId);
      // verify required parameter 'executionId' is not null or undefined
      assertParamExists('cancelClone', 'executionId', executionId);
      const localVarPath = `/orgs/{orgId}/clone/{executionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'executionId'}}`, encodeURIComponent(String(executionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCloneOrgConfigDTO} apiSvcCloneOrgConfigDTO
     * @param {string} [toOrgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloneOrg: async (
      orgId: string,
      apiSvcCloneOrgConfigDTO: ApiSvcCloneOrgConfigDTO,
      toOrgId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('cloneOrg', 'orgId', orgId);
      // verify required parameter 'apiSvcCloneOrgConfigDTO' is not null or undefined
      assertParamExists('cloneOrg', 'apiSvcCloneOrgConfigDTO', apiSvcCloneOrgConfigDTO);
      const localVarPath = `/orgs/{orgId}/clone`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (toOrgId !== undefined) {
        localVarQueryParameter['toOrgId'] = toOrgId;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCloneOrgConfigDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} executionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCloneResult: async (
      orgId: string,
      executionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getCloneResult', 'orgId', orgId);
      // verify required parameter 'executionId' is not null or undefined
      assertParamExists('getCloneResult', 'executionId', executionId);
      const localVarPath = `/orgs/{orgId}/clone/{executionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'executionId'}}`, encodeURIComponent(String(executionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrg: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getOrg', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoles: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getRoles', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/roles`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrgsApi - functional programming interface
 * @export
 */
export const OrgsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OrgsApiAxiosParamCreator(configuration);
  return {
    /**
     * Promote an org\'s managed table from CENTRALIZED/DUAL_WRITE to PER_ORG. Creates the per-org BQ table if missing, copies any centralized rows for this org into it, and stamps the migratedAtSEC label so the read path switches over. Idempotent — returns skipped=true if already PER_ORG.  For brand-new orgs with no centralized data this still does the right thing: 0 rows copied, table created empty, phase flips to PER_ORG.
     * @param {string} orgId
     * @param {string} tableType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async backfillManagedTable(
      orgId: string,
      tableType: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcBackfillOrgManagedTableResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.backfillManagedTable(orgId, tableType, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} executionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelClone(
      orgId: string,
      executionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancelClone(orgId, executionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCloneOrgConfigDTO} apiSvcCloneOrgConfigDTO
     * @param {string} [toOrgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cloneOrg(
      orgId: string,
      apiSvcCloneOrgConfigDTO: ApiSvcCloneOrgConfigDTO,
      toOrgId?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cloneOrg(
        orgId,
        apiSvcCloneOrgConfigDTO,
        toOrgId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} executionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCloneResult(
      orgId: string,
      executionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCloneWorkflowResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCloneResult(orgId, executionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrg(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetOrg200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrg(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoles(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcRolesDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * OrgsApi - factory interface
 * @export
 */
export const OrgsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = OrgsApiFp(configuration);
  return {
    /**
     * Promote an org\'s managed table from CENTRALIZED/DUAL_WRITE to PER_ORG. Creates the per-org BQ table if missing, copies any centralized rows for this org into it, and stamps the migratedAtSEC label so the read path switches over. Idempotent — returns skipped=true if already PER_ORG.  For brand-new orgs with no centralized data this still does the right thing: 0 rows copied, table created empty, phase flips to PER_ORG.
     * @param {string} orgId
     * @param {string} tableType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    backfillManagedTable(
      orgId: string,
      tableType: string,
      options?: any
    ): AxiosPromise<ApiSvcBackfillOrgManagedTableResult> {
      return localVarFp.backfillManagedTable(orgId, tableType, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} executionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelClone(orgId: string, executionId: string, options?: any): AxiosPromise<void> {
      return localVarFp.cancelClone(orgId, executionId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCloneOrgConfigDTO} apiSvcCloneOrgConfigDTO
     * @param {string} [toOrgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloneOrg(
      orgId: string,
      apiSvcCloneOrgConfigDTO: ApiSvcCloneOrgConfigDTO,
      toOrgId?: string,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .cloneOrg(orgId, apiSvcCloneOrgConfigDTO, toOrgId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} executionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCloneResult(orgId: string, executionId: string, options?: any): AxiosPromise<ApiSvcCloneWorkflowResult> {
      return localVarFp.getCloneResult(orgId, executionId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrg(orgId: string, options?: any): AxiosPromise<ApiSvcGetOrg200Response> {
      return localVarFp.getOrg(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoles(orgId: string, options?: any): AxiosPromise<Array<ApiSvcRolesDTO>> {
      return localVarFp.getRoles(orgId, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * OrgsApi - object-oriented interface
 * @export
 * @class OrgsApi
 * @extends {BaseAPI}
 */
export class OrgsApi extends BaseAPI {
  /**
   * Promote an org\'s managed table from CENTRALIZED/DUAL_WRITE to PER_ORG. Creates the per-org BQ table if missing, copies any centralized rows for this org into it, and stamps the migratedAtSEC label so the read path switches over. Idempotent — returns skipped=true if already PER_ORG.  For brand-new orgs with no centralized data this still does the right thing: 0 rows copied, table created empty, phase flips to PER_ORG.
   * @param {string} orgId
   * @param {string} tableType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public backfillManagedTable(orgId: string, tableType: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .backfillManagedTable(orgId, tableType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} executionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public cancelClone(orgId: string, executionId: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .cancelClone(orgId, executionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCloneOrgConfigDTO} apiSvcCloneOrgConfigDTO
   * @param {string} [toOrgId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public cloneOrg(
    orgId: string,
    apiSvcCloneOrgConfigDTO: ApiSvcCloneOrgConfigDTO,
    toOrgId?: string,
    options?: AxiosRequestConfig
  ) {
    return OrgsApiFp(this.configuration)
      .cloneOrg(orgId, apiSvcCloneOrgConfigDTO, toOrgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} executionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public getCloneResult(orgId: string, executionId: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .getCloneResult(orgId, executionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public getOrg(orgId: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .getOrg(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgsApi
   */
  public getRoles(orgId: string, options?: AxiosRequestConfig) {
    return OrgsApiFp(this.configuration)
      .getRoles(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PricesApi - axios parameter creator
 * @export
 */
export const PricesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcClearOrgPriceCacheOptions} apiSvcClearOrgPriceCacheOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clearCache: async (
      orgId: string,
      apiSvcClearOrgPriceCacheOptions: ApiSvcClearOrgPriceCacheOptions,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('clearCache', 'orgId', orgId);
      // verify required parameter 'apiSvcClearOrgPriceCacheOptions' is not null or undefined
      assertParamExists('clearCache', 'apiSvcClearOrgPriceCacheOptions', apiSvcClearOrgPriceCacheOptions);
      const localVarPath = `/orgs/{orgId}/cache-clear`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcClearOrgPriceCacheOptions,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPricingContext: async (orgId: string, body: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createPricingContext', 'orgId', orgId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('createPricingContext', 'body', body);
      const localVarPath = `/orgs/{orgId}/pricing-contexts`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPricingContextRoute: async (
      orgId: string,
      body: any,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createPricingContextRoute', 'orgId', orgId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('createPricingContextRoute', 'body', body);
      const localVarPath = `/orgs/{orgId}/pricing-context-routes`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcPricingReportParams} apiSvcPricingReportParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePricingReports: async (
      orgId: string,
      apiSvcPricingReportParams: ApiSvcPricingReportParams,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('generatePricingReports', 'orgId', orgId);
      // verify required parameter 'apiSvcPricingReportParams' is not null or undefined
      assertParamExists('generatePricingReports', 'apiSvcPricingReportParams', apiSvcPricingReportParams);
      const localVarPath = `/orgs/{orgId}/pricing-report`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcPricingReportParams,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} priceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrice: async (orgId: string, priceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getPrice', 'orgId', orgId);
      // verify required parameter 'priceId' is not null or undefined
      assertParamExists('getPrice', 'priceId', priceId);
      const localVarPath = `/orgs/{orgId}/prices/{priceId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'priceId'}}`, encodeURIComponent(String(priceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricingContextRoutes: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getPricingContextRoutes', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/pricing-context-routes`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricingContexts: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getPricingContexts', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/pricing-contexts`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Audit history for a single pricing directive/rule: what happened to it (created, updated, disabled, enabled), who did it, and when. Proxies price-svc\'s audit-log endpoint so the web-app can render a rule\'s change history. See PriceSvcPricingRuleAuditLogDTO.complete for the fidelity caveat on orgs not yet cut over to event sourcing.
     * @param {string} orgId
     * @param {string} pricingDirectiveId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricingDirectiveAuditLog: async (
      orgId: string,
      pricingDirectiveId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getPricingDirectiveAuditLog', 'orgId', orgId);
      // verify required parameter 'pricingDirectiveId' is not null or undefined
      assertParamExists('getPricingDirectiveAuditLog', 'pricingDirectiveId', pricingDirectiveId);
      const localVarPath = `/orgs/{orgId}/pricing-directives/{pricingDirectiveId}/audit-log`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'pricingDirectiveId'}}`, encodeURIComponent(String(pricingDirectiveId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPricingContext: async (
      orgId: string,
      id: string,
      body: any,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('patchPricingContext', 'orgId', orgId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('patchPricingContext', 'id', id);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('patchPricingContext', 'body', body);
      const localVarPath = `/orgs/{orgId}/pricing-contexts/{id}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPricingContextRoute: async (
      orgId: string,
      id: string,
      body: any,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('patchPricingContextRoute', 'orgId', orgId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('patchPricingContextRoute', 'id', id);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('patchPricingContextRoute', 'body', body);
      const localVarPath = `/orgs/{orgId}/pricing-context-routes/{id}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} fromAssetId
     * @param {string} toAssetId
     * @param {number} timestampSEC
     * @param {ApiSvcPriceSvcWellKnownPricingContexts} context
     * @param {ApiSvcPricingPeriod} [overrideResolution]
     * @param {ApiSvcPricingMethod} [overrideMethodology]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceAsset: async (
      orgId: string,
      fromAssetId: string,
      toAssetId: string,
      timestampSEC: number,
      context: ApiSvcPriceSvcWellKnownPricingContexts,
      overrideResolution?: ApiSvcPricingPeriod,
      overrideMethodology?: ApiSvcPricingMethod,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('priceAsset', 'orgId', orgId);
      // verify required parameter 'fromAssetId' is not null or undefined
      assertParamExists('priceAsset', 'fromAssetId', fromAssetId);
      // verify required parameter 'toAssetId' is not null or undefined
      assertParamExists('priceAsset', 'toAssetId', toAssetId);
      // verify required parameter 'timestampSEC' is not null or undefined
      assertParamExists('priceAsset', 'timestampSEC', timestampSEC);
      // verify required parameter 'context' is not null or undefined
      assertParamExists('priceAsset', 'context', context);
      const localVarPath = `/orgs/{orgId}/prices`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (fromAssetId !== undefined) {
        localVarQueryParameter['fromAssetId'] = fromAssetId;
      }

      if (toAssetId !== undefined) {
        localVarQueryParameter['toAssetId'] = toAssetId;
      }

      if (timestampSEC !== undefined) {
        localVarQueryParameter['timestampSEC'] = timestampSEC;
      }

      if (context !== undefined) {
        localVarQueryParameter['context'] = context;
      }

      if (overrideResolution !== undefined) {
        localVarQueryParameter['overrideResolution'] = overrideResolution;
      }

      if (overrideMethodology !== undefined) {
        localVarQueryParameter['overrideMethodology'] = overrideMethodology;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceTransaction: async (
      orgId: string,
      transactionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('priceTransaction', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('priceTransaction', 'transactionId', transactionId);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/price`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePricingContext: async (
      orgId: string,
      id: string,
      body: any,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updatePricingContext', 'orgId', orgId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('updatePricingContext', 'id', id);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('updatePricingContext', 'body', body);
      const localVarPath = `/orgs/{orgId}/pricing-contexts/{id}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePricingContextRoute: async (
      orgId: string,
      id: string,
      body: any,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updatePricingContextRoute', 'orgId', orgId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('updatePricingContextRoute', 'id', id);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('updatePricingContextRoute', 'body', body);
      const localVarPath = `/orgs/{orgId}/pricing-context-routes/{id}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PricesApi - functional programming interface
 * @export
 */
export const PricesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PricesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcClearOrgPriceCacheOptions} apiSvcClearOrgPriceCacheOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clearCache(
      orgId: string,
      apiSvcClearOrgPriceCacheOptions: ApiSvcClearOrgPriceCacheOptions,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcClearCache200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clearCache(
        orgId,
        apiSvcClearOrgPriceCacheOptions,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPricingContext(
      orgId: string,
      body: any,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcContactErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createPricingContext(orgId, body, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPricingContextRoute(
      orgId: string,
      body: any,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreatePricingContextRoute200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createPricingContextRoute(orgId, body, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcPricingReportParams} apiSvcPricingReportParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generatePricingReports(
      orgId: string,
      apiSvcPricingReportParams: ApiSvcPricingReportParams,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGeneratePricingReports200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generatePricingReports(
        orgId,
        apiSvcPricingReportParams,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} priceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPrice(
      orgId: string,
      priceId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetPrice200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPrice(orgId, priceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPricingContextRoutes(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetPricingContextRoutes200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPricingContextRoutes(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPricingContexts(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetPricingContexts200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPricingContexts(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Audit history for a single pricing directive/rule: what happened to it (created, updated, disabled, enabled), who did it, and when. Proxies price-svc\'s audit-log endpoint so the web-app can render a rule\'s change history. See PriceSvcPricingRuleAuditLogDTO.complete for the fidelity caveat on orgs not yet cut over to event sourcing.
     * @param {string} orgId
     * @param {string} pricingDirectiveId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPricingDirectiveAuditLog(
      orgId: string,
      pricingDirectiveId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcPriceSvcPricingRuleAuditLogDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPricingDirectiveAuditLog(
        orgId,
        pricingDirectiveId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchPricingContext(
      orgId: string,
      id: string,
      body: any,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcContactErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchPricingContext(orgId, id, body, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchPricingContextRoute(
      orgId: string,
      id: string,
      body: any,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcContactErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchPricingContextRoute(orgId, id, body, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} fromAssetId
     * @param {string} toAssetId
     * @param {number} timestampSEC
     * @param {ApiSvcPriceSvcWellKnownPricingContexts} context
     * @param {ApiSvcPricingPeriod} [overrideResolution]
     * @param {ApiSvcPricingMethod} [overrideMethodology]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async priceAsset(
      orgId: string,
      fromAssetId: string,
      toAssetId: string,
      timestampSEC: number,
      context: ApiSvcPriceSvcWellKnownPricingContexts,
      overrideResolution?: ApiSvcPricingPeriod,
      overrideMethodology?: ApiSvcPricingMethod,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcPriceAsset200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.priceAsset(
        orgId,
        fromAssetId,
        toAssetId,
        timestampSEC,
        context,
        overrideResolution,
        overrideMethodology,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async priceTransaction(
      orgId: string,
      transactionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcPriceTransaction200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.priceTransaction(orgId, transactionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePricingContext(
      orgId: string,
      id: string,
      body: any,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcContactErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePricingContext(orgId, id, body, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePricingContextRoute(
      orgId: string,
      id: string,
      body: any,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcContactErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePricingContextRoute(orgId, id, body, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * PricesApi - factory interface
 * @export
 */
export const PricesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = PricesApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcClearOrgPriceCacheOptions} apiSvcClearOrgPriceCacheOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clearCache(
      orgId: string,
      apiSvcClearOrgPriceCacheOptions: ApiSvcClearOrgPriceCacheOptions,
      options?: any
    ): AxiosPromise<ApiSvcClearCache200Response> {
      return localVarFp
        .clearCache(orgId, apiSvcClearOrgPriceCacheOptions, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPricingContext(orgId: string, body: any, options?: any): AxiosPromise<ApiSvcContactErrorResponse> {
      return localVarFp.createPricingContext(orgId, body, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPricingContextRoute(
      orgId: string,
      body: any,
      options?: any
    ): AxiosPromise<ApiSvcCreatePricingContextRoute200Response> {
      return localVarFp.createPricingContextRoute(orgId, body, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcPricingReportParams} apiSvcPricingReportParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePricingReports(
      orgId: string,
      apiSvcPricingReportParams: ApiSvcPricingReportParams,
      options?: any
    ): AxiosPromise<ApiSvcGeneratePricingReports200Response> {
      return localVarFp
        .generatePricingReports(orgId, apiSvcPricingReportParams, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} priceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrice(orgId: string, priceId: string, options?: any): AxiosPromise<ApiSvcGetPrice200Response> {
      return localVarFp.getPrice(orgId, priceId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricingContextRoutes(orgId: string, options?: any): AxiosPromise<ApiSvcGetPricingContextRoutes200Response> {
      return localVarFp.getPricingContextRoutes(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricingContexts(orgId: string, options?: any): AxiosPromise<ApiSvcGetPricingContexts200Response> {
      return localVarFp.getPricingContexts(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     * Audit history for a single pricing directive/rule: what happened to it (created, updated, disabled, enabled), who did it, and when. Proxies price-svc\'s audit-log endpoint so the web-app can render a rule\'s change history. See PriceSvcPricingRuleAuditLogDTO.complete for the fidelity caveat on orgs not yet cut over to event sourcing.
     * @param {string} orgId
     * @param {string} pricingDirectiveId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPricingDirectiveAuditLog(
      orgId: string,
      pricingDirectiveId: string,
      options?: any
    ): AxiosPromise<ApiSvcPriceSvcPricingRuleAuditLogDTO> {
      return localVarFp
        .getPricingDirectiveAuditLog(orgId, pricingDirectiveId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPricingContext(orgId: string, id: string, body: any, options?: any): AxiosPromise<ApiSvcContactErrorResponse> {
      return localVarFp.patchPricingContext(orgId, id, body, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPricingContextRoute(
      orgId: string,
      id: string,
      body: any,
      options?: any
    ): AxiosPromise<ApiSvcContactErrorResponse> {
      return localVarFp.patchPricingContextRoute(orgId, id, body, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} fromAssetId
     * @param {string} toAssetId
     * @param {number} timestampSEC
     * @param {ApiSvcPriceSvcWellKnownPricingContexts} context
     * @param {ApiSvcPricingPeriod} [overrideResolution]
     * @param {ApiSvcPricingMethod} [overrideMethodology]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceAsset(
      orgId: string,
      fromAssetId: string,
      toAssetId: string,
      timestampSEC: number,
      context: ApiSvcPriceSvcWellKnownPricingContexts,
      overrideResolution?: ApiSvcPricingPeriod,
      overrideMethodology?: ApiSvcPricingMethod,
      options?: any
    ): AxiosPromise<ApiSvcPriceAsset200Response> {
      return localVarFp
        .priceAsset(
          orgId,
          fromAssetId,
          toAssetId,
          timestampSEC,
          context,
          overrideResolution,
          overrideMethodology,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceTransaction(
      orgId: string,
      transactionId: string,
      options?: any
    ): AxiosPromise<ApiSvcPriceTransaction200Response> {
      return localVarFp.priceTransaction(orgId, transactionId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePricingContext(
      orgId: string,
      id: string,
      body: any,
      options?: any
    ): AxiosPromise<ApiSvcContactErrorResponse> {
      return localVarFp.updatePricingContext(orgId, id, body, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} id
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePricingContextRoute(
      orgId: string,
      id: string,
      body: any,
      options?: any
    ): AxiosPromise<ApiSvcContactErrorResponse> {
      return localVarFp.updatePricingContextRoute(orgId, id, body, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * PricesApi - object-oriented interface
 * @export
 * @class PricesApi
 * @extends {BaseAPI}
 */
export class PricesApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {ApiSvcClearOrgPriceCacheOptions} apiSvcClearOrgPriceCacheOptions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public clearCache(
    orgId: string,
    apiSvcClearOrgPriceCacheOptions: ApiSvcClearOrgPriceCacheOptions,
    options?: AxiosRequestConfig
  ) {
    return PricesApiFp(this.configuration)
      .clearCache(orgId, apiSvcClearOrgPriceCacheOptions, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {any} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public createPricingContext(orgId: string, body: any, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .createPricingContext(orgId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {any} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public createPricingContextRoute(orgId: string, body: any, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .createPricingContextRoute(orgId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcPricingReportParams} apiSvcPricingReportParams
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public generatePricingReports(
    orgId: string,
    apiSvcPricingReportParams: ApiSvcPricingReportParams,
    options?: AxiosRequestConfig
  ) {
    return PricesApiFp(this.configuration)
      .generatePricingReports(orgId, apiSvcPricingReportParams, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} priceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public getPrice(orgId: string, priceId: string, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .getPrice(orgId, priceId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public getPricingContextRoutes(orgId: string, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .getPricingContextRoutes(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public getPricingContexts(orgId: string, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .getPricingContexts(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Audit history for a single pricing directive/rule: what happened to it (created, updated, disabled, enabled), who did it, and when. Proxies price-svc\'s audit-log endpoint so the web-app can render a rule\'s change history. See PriceSvcPricingRuleAuditLogDTO.complete for the fidelity caveat on orgs not yet cut over to event sourcing.
   * @param {string} orgId
   * @param {string} pricingDirectiveId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public getPricingDirectiveAuditLog(orgId: string, pricingDirectiveId: string, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .getPricingDirectiveAuditLog(orgId, pricingDirectiveId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} id
   * @param {any} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public patchPricingContext(orgId: string, id: string, body: any, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .patchPricingContext(orgId, id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} id
   * @param {any} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public patchPricingContextRoute(orgId: string, id: string, body: any, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .patchPricingContextRoute(orgId, id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} fromAssetId
   * @param {string} toAssetId
   * @param {number} timestampSEC
   * @param {ApiSvcPriceSvcWellKnownPricingContexts} context
   * @param {ApiSvcPricingPeriod} [overrideResolution]
   * @param {ApiSvcPricingMethod} [overrideMethodology]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public priceAsset(
    orgId: string,
    fromAssetId: string,
    toAssetId: string,
    timestampSEC: number,
    context: ApiSvcPriceSvcWellKnownPricingContexts,
    overrideResolution?: ApiSvcPricingPeriod,
    overrideMethodology?: ApiSvcPricingMethod,
    options?: AxiosRequestConfig
  ) {
    return PricesApiFp(this.configuration)
      .priceAsset(
        orgId,
        fromAssetId,
        toAssetId,
        timestampSEC,
        context,
        overrideResolution,
        overrideMethodology,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public priceTransaction(orgId: string, transactionId: string, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .priceTransaction(orgId, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} id
   * @param {any} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public updatePricingContext(orgId: string, id: string, body: any, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .updatePricingContext(orgId, id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} id
   * @param {any} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricesApi
   */
  public updatePricingContextRoute(orgId: string, id: string, body: any, options?: AxiosRequestConfig) {
    return PricesApiFp(this.configuration)
      .updatePricingContextRoute(orgId, id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * QueuesApi - axios parameter creator
 * @export
 */
export const QueuesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {ApiSvcSimpleQueues} queueId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    handleTask: async (
      queueId: ApiSvcSimpleQueues,
      body: any,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'queueId' is not null or undefined
      assertParamExists('handleTask', 'queueId', queueId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('handleTask', 'body', body);
      const localVarPath = `/simple-queues/{queueId}`.replace(`{${'queueId'}}`, encodeURIComponent(String(queueId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QueuesApi - functional programming interface
 * @export
 */
export const QueuesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = QueuesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {ApiSvcSimpleQueues} queueId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async handleTask(
      queueId: ApiSvcSimpleQueues,
      body: any,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.handleTask(queueId, body, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * QueuesApi - factory interface
 * @export
 */
export const QueuesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = QueuesApiFp(configuration);
  return {
    /**
     *
     * @param {ApiSvcSimpleQueues} queueId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    handleTask(queueId: ApiSvcSimpleQueues, body: any, options?: any): AxiosPromise<void> {
      return localVarFp.handleTask(queueId, body, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * QueuesApi - object-oriented interface
 * @export
 * @class QueuesApi
 * @extends {BaseAPI}
 */
export class QueuesApi extends BaseAPI {
  /**
   *
   * @param {ApiSvcSimpleQueues} queueId
   * @param {any} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QueuesApi
   */
  public handleTask(queueId: ApiSvcSimpleQueues, body: any, options?: AxiosRequestConfig) {
    return QueuesApiFp(this.configuration)
      .handleTask(queueId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ReportingApi - axios parameter creator
 * @export
 */
export const ReportingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {ApiSvcRecordBinaryContent} binaryContent
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFileSnapshot: async (
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      binaryContent: ApiSvcRecordBinaryContent,
      file: File,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createFileSnapshot', 'orgId', orgId);
      // verify required parameter 'recordBucket' is not null or undefined
      assertParamExists('createFileSnapshot', 'recordBucket', recordBucket);
      // verify required parameter 'binaryContent' is not null or undefined
      assertParamExists('createFileSnapshot', 'binaryContent', binaryContent);
      // verify required parameter 'file' is not null or undefined
      assertParamExists('createFileSnapshot', 'file', file);
      const localVarPath = `/v2/orgs/{orgId}/reports/snapshots/{recordBucket}/{binaryContent}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'recordBucket'}}`, encodeURIComponent(String(recordBucket)))
        .replace(`{${'binaryContent'}}`, encodeURIComponent(String(binaryContent)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {ApiSvcCreateSodaReportSnapshotRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSnapshot: async (
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      body: ApiSvcCreateSodaReportSnapshotRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createSnapshot', 'orgId', orgId);
      // verify required parameter 'recordBucket' is not null or undefined
      assertParamExists('createSnapshot', 'recordBucket', recordBucket);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('createSnapshot', 'body', body);
      const localVarPath = `/v2/orgs/{orgId}/reports/snapshots/{recordBucket}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'recordBucket'}}`, encodeURIComponent(String(recordBucket)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSnapshot: async (
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deleteSnapshot', 'orgId', orgId);
      // verify required parameter 'recordBucket' is not null or undefined
      assertParamExists('deleteSnapshot', 'recordBucket', recordBucket);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('deleteSnapshot', 'id', id);
      const localVarPath = `/v2/orgs/{orgId}/reports/snapshots/{recordBucket}/{id}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'recordBucket'}}`, encodeURIComponent(String(recordBucket)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Download close report PDF Returns a signed download URL for the PDF file
     * @param {string} orgId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadCloseReport: async (
      orgId: string,
      reportId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('downloadCloseReport', 'orgId', orgId);
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('downloadCloseReport', 'reportId', reportId);
      const localVarPath = `/v2/orgs/{orgId}/close-reports/{reportId}/download`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'reportId'}}`, encodeURIComponent(String(reportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Streams the report run\'s persisted payload as CSV. api-svc reads the JSON blob from GCS and emits CSV in the response body — no direct GCS signed URL handed to the client so the transform happens server-side.  Returns a `Readable` (not a `string`) on purpose: tsoa\'s generated route handler JSON-encodes any string/object return value via `res.json(...)`, which would (a) wrap the CSV in quotes and escape newlines and (b) reset Content-Type to `application/json` — corrupting the download. Returning a stream routes through tsoa\'s `data.pipe(response)` branch instead, which preserves the `Content-Type: text/csv` + `Content-Disposition` headers set below. Same pattern as `ReportsController.getFileSnapshot`.
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadReportRun: async (
      orgId: string,
      reportRunId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('downloadReportRun', 'orgId', orgId);
      // verify required parameter 'reportRunId' is not null or undefined
      assertParamExists('downloadReportRun', 'reportRunId', reportRunId);
      const localVarPath = `/v2/orgs/{orgId}/report-runs/{reportRunId}/download`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'reportRunId'}}`, encodeURIComponent(String(reportRunId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Export deleted or ignored transactions for a given date range Returns a CSV/ZIP file with all transaction data including deletion/ignore metadata
     * @param {string} orgId
     * @param {string} startDate
     * @param {string} endDate
     * @param {boolean} [allowZip]
     * @param {boolean} [useOrgTimezone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportDeletedIgnoredTransactions: async (
      orgId: string,
      startDate: string,
      endDate: string,
      allowZip?: boolean,
      useOrgTimezone?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('exportDeletedIgnoredTransactions', 'orgId', orgId);
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('exportDeletedIgnoredTransactions', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('exportDeletedIgnoredTransactions', 'endDate', endDate);
      const localVarPath = `/v2/orgs/{orgId}/deleted-ignored-transactions-export`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (allowZip !== undefined) {
        localVarQueryParameter['allowZip'] = allowZip;
      }

      if (useOrgTimezone !== undefined) {
        localVarQueryParameter['useOrgTimezone'] = useOrgTimezone;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Generate a close checklist certification report Creates a PDF summary with links to existing exception reports
     * @param {string} orgId
     * @param {ApiSvcGenerateCloseReportRequest} apiSvcGenerateCloseReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateCloseReport: async (
      orgId: string,
      apiSvcGenerateCloseReportRequest: ApiSvcGenerateCloseReportRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('generateCloseReport', 'orgId', orgId);
      // verify required parameter 'apiSvcGenerateCloseReportRequest' is not null or undefined
      assertParamExists('generateCloseReport', 'apiSvcGenerateCloseReportRequest', apiSvcGenerateCloseReportRequest);
      const localVarPath = `/v2/orgs/{orgId}/close-reports`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcGenerateCloseReportRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Phase 1 of the two-phase workflow.
     * @param {string} orgId
     * @param {ApiSvcGenerateRolledUpJeReportRequest} apiSvcGenerateRolledUpJeReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateRolledUpJeReport: async (
      orgId: string,
      apiSvcGenerateRolledUpJeReportRequest: ApiSvcGenerateRolledUpJeReportRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('generateRolledUpJeReport', 'orgId', orgId);
      // verify required parameter 'apiSvcGenerateRolledUpJeReportRequest' is not null or undefined
      assertParamExists(
        'generateRolledUpJeReport',
        'apiSvcGenerateRolledUpJeReportRequest',
        apiSvcGenerateRolledUpJeReportRequest
      );
      const localVarPath = `/v2/orgs/{orgId}/reports/rolledUpJe`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcGenerateRolledUpJeReportRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get close report details by report ID Returns full report metadata including checks, status, and period info
     * @param {string} orgId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCloseReportDetails: async (
      orgId: string,
      reportId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getCloseReportDetails', 'orgId', orgId);
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('getCloseReportDetails', 'reportId', reportId);
      const localVarPath = `/v2/orgs/{orgId}/close-reports/{reportId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'reportId'}}`, encodeURIComponent(String(reportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the Temporal workflow status for a close report PDF generation. Use the reportRunId returned from generateCloseReport to poll for completion.
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCloseReportWorkflowStatus: async (
      orgId: string,
      reportRunId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getCloseReportWorkflowStatus', 'orgId', orgId);
      // verify required parameter 'reportRunId' is not null or undefined
      assertParamExists('getCloseReportWorkflowStatus', 'reportRunId', reportRunId);
      const localVarPath = `/v2/orgs/{orgId}/close-reports/workflow-status/{reportRunId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'reportRunId'}}`, encodeURIComponent(String(reportRunId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileSnapshot: async (
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getFileSnapshot', 'orgId', orgId);
      // verify required parameter 'recordBucket' is not null or undefined
      assertParamExists('getFileSnapshot', 'recordBucket', recordBucket);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getFileSnapshot', 'id', id);
      const localVarPath = `/v2/orgs/{orgId}/reports/snapshots/{recordBucket}/file/{id}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'recordBucket'}}`, encodeURIComponent(String(recordBucket)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportId
     * @param {boolean} [includeDownloadUrls]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReport: async (
      orgId: string,
      reportId: string,
      includeDownloadUrls?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getReport', 'orgId', orgId);
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('getReport', 'reportId', reportId);
      const localVarPath = `/v2/orgs/{orgId}/reports/{reportId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'reportId'}}`, encodeURIComponent(String(reportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (includeDownloadUrls !== undefined) {
        localVarQueryParameter['includeDownloadUrls'] = includeDownloadUrls;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportDefinitions: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getReportDefinitions', 'orgId', orgId);
      const localVarPath = `/v2/orgs/{orgId}/report-definitions`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportRunResult: async (
      orgId: string,
      reportRunId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getReportRunResult', 'orgId', orgId);
      // verify required parameter 'reportRunId' is not null or undefined
      assertParamExists('getReportRunResult', 'reportRunId', reportRunId);
      const localVarPath = `/v2/orgs/{orgId}/report-runs/{reportRunId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'reportRunId'}}`, encodeURIComponent(String(reportRunId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportRunStatus: async (
      orgId: string,
      reportRunId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getReportRunStatus', 'orgId', orgId);
      // verify required parameter 'reportRunId' is not null or undefined
      assertParamExists('getReportRunStatus', 'reportRunId', reportRunId);
      const localVarPath = `/v2/orgs/{orgId}/report-runs/{reportRunId}/status`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'reportRunId'}}`, encodeURIComponent(String(reportRunId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcReportRunConfigTypes} type
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReports: async (
      orgId: string,
      type: ApiSvcReportRunConfigTypes,
      pageToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getReports', 'orgId', orgId);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('getReports', 'type', type);
      const localVarPath = `/v2/orgs/{orgId}/reports`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRolledUpJeReport: async (
      orgId: string,
      reportId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getRolledUpJeReport', 'orgId', orgId);
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('getRolledUpJeReport', 'reportId', reportId);
      const localVarPath = `/v2/orgs/{orgId}/reports/rolledUpJe/{reportId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'reportId'}}`, encodeURIComponent(String(reportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSnapshot: async (
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getSnapshot', 'orgId', orgId);
      // verify required parameter 'recordBucket' is not null or undefined
      assertParamExists('getSnapshot', 'recordBucket', recordBucket);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getSnapshot', 'id', id);
      const localVarPath = `/v2/orgs/{orgId}/reports/snapshots/{recordBucket}/{id}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'recordBucket'}}`, encodeURIComponent(String(recordBucket)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSnapshots: async (
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getSnapshots', 'orgId', orgId);
      // verify required parameter 'recordBucket' is not null or undefined
      assertParamExists('getSnapshots', 'recordBucket', recordBucket);
      const localVarPath = `/v2/orgs/{orgId}/reports/snapshots/{recordBucket}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'recordBucket'}}`, encodeURIComponent(String(recordBucket)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * List all close reports for an organization with pagination Returns paginated array of report summaries
     * @param {string} orgId
     * @param {number} [limit]
     * @param {string} [cursor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCloseReports: async (
      orgId: string,
      limit?: number,
      cursor?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('listCloseReports', 'orgId', orgId);
      const localVarPath = `/v2/orgs/{orgId}/close-reports`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (cursor !== undefined) {
        localVarQueryParameter['cursor'] = cursor;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lists report runs for an org by type, ordered by `startedAt` descending. Backs the V3 UI\'s past-runs table on the balance-report page.  `limit` caps the page size at   ; an absent or out-of-range value falls back to   . `pageToken` is an opaque cursor from a previous response.
     * @param {string} orgId
     * @param {ApiSvcReportRunType} type
     * @param {number} [limit]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listReportRuns: async (
      orgId: string,
      type: ApiSvcReportRunType,
      limit?: number,
      pageToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('listReportRuns', 'orgId', orgId);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('listReportRuns', 'type', type);
      const localVarPath = `/v2/orgs/{orgId}/report-runs`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    persistSnapshot: async (
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('persistSnapshot', 'orgId', orgId);
      // verify required parameter 'recordBucket' is not null or undefined
      assertParamExists('persistSnapshot', 'recordBucket', recordBucket);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('persistSnapshot', 'id', id);
      const localVarPath = `/v2/orgs/{orgId}/reports/snapshots/{recordBucket}/{id}/persist`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'recordBucket'}}`, encodeURIComponent(String(recordBucket)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Phase 2 of the two-phase workflow.
     * @param {string} orgId
     * @param {string} reportId
     * @param {ApiSvcPushRolledUpJeReportRequest} apiSvcPushRolledUpJeReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushRolledUpJeReport: async (
      orgId: string,
      reportId: string,
      apiSvcPushRolledUpJeReportRequest: ApiSvcPushRolledUpJeReportRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('pushRolledUpJeReport', 'orgId', orgId);
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('pushRolledUpJeReport', 'reportId', reportId);
      // verify required parameter 'apiSvcPushRolledUpJeReportRequest' is not null or undefined
      assertParamExists('pushRolledUpJeReport', 'apiSvcPushRolledUpJeReportRequest', apiSvcPushRolledUpJeReportRequest);
      const localVarPath = `/v2/orgs/{orgId}/reports/rolledUpJe/{reportId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'reportId'}}`, encodeURIComponent(String(reportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcPushRolledUpJeReportRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    run: async (
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('run', 'orgId', orgId);
      // verify required parameter 'apiSvcRunReportRequest' is not null or undefined
      assertParamExists('run', 'apiSvcRunReportRequest', apiSvcRunReportRequest);
      const localVarPath = `/v2/orgs/{orgId}/reports`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcRunReportRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runESBalanceReportPreview: async (
      orgId: string,
      date: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('runESBalanceReportPreview', 'orgId', orgId);
      // verify required parameter 'date' is not null or undefined
      assertParamExists('runESBalanceReportPreview', 'date', date);
      const localVarPath = `/v2/orgs/{orgId}/reports/esBalanceReport/preview`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runRelatedOrgsTransactionsReportSave: async (
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('runRelatedOrgsTransactionsReportSave', 'orgId', orgId);
      // verify required parameter 'apiSvcRunReportRequest' is not null or undefined
      assertParamExists('runRelatedOrgsTransactionsReportSave', 'apiSvcRunReportRequest', apiSvcRunReportRequest);
      const localVarPath = `/v2/orgs/{orgId}/reports/relatedOrgsTransactions/save`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcRunReportRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runRelatedOrgsTransctionsReportPreview: async (
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('runRelatedOrgsTransctionsReportPreview', 'orgId', orgId);
      // verify required parameter 'apiSvcRunReportRequest' is not null or undefined
      assertParamExists('runRelatedOrgsTransctionsReportPreview', 'apiSvcRunReportRequest', apiSvcRunReportRequest);
      const localVarPath = `/v2/orgs/{orgId}/reports/relatedOrgsTransactions/preview`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcRunReportRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runSharedOrgsBalancesReportPreview: async (
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('runSharedOrgsBalancesReportPreview', 'orgId', orgId);
      // verify required parameter 'apiSvcRunReportRequest' is not null or undefined
      assertParamExists('runSharedOrgsBalancesReportPreview', 'apiSvcRunReportRequest', apiSvcRunReportRequest);
      const localVarPath = `/v2/orgs/{orgId}/reports/relatedOrgsBalances/preview`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcRunReportRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runSharedOrgsBalancesReportSave: async (
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('runSharedOrgsBalancesReportSave', 'orgId', orgId);
      // verify required parameter 'apiSvcRunReportRequest' is not null or undefined
      assertParamExists('runSharedOrgsBalancesReportSave', 'apiSvcRunReportRequest', apiSvcRunReportRequest);
      const localVarPath = `/v2/orgs/{orgId}/reports/relatedOrgsBalances/save`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcRunReportRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequestDTO} apiSvcRunReportRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    startReportRun: async (
      orgId: string,
      apiSvcRunReportRequestDTO: ApiSvcRunReportRequestDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('startReportRun', 'orgId', orgId);
      // verify required parameter 'apiSvcRunReportRequestDTO' is not null or undefined
      assertParamExists('startReportRun', 'apiSvcRunReportRequestDTO', apiSvcRunReportRequestDTO);
      const localVarPath = `/v2/orgs/{orgId}/report-runs`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcRunReportRequestDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {ApiSvcUpdateReportSnapshotRequest} apiSvcUpdateReportSnapshotRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSnapshot: async (
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      apiSvcUpdateReportSnapshotRequest: ApiSvcUpdateReportSnapshotRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateSnapshot', 'orgId', orgId);
      // verify required parameter 'recordBucket' is not null or undefined
      assertParamExists('updateSnapshot', 'recordBucket', recordBucket);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('updateSnapshot', 'id', id);
      // verify required parameter 'apiSvcUpdateReportSnapshotRequest' is not null or undefined
      assertParamExists('updateSnapshot', 'apiSvcUpdateReportSnapshotRequest', apiSvcUpdateReportSnapshotRequest);
      const localVarPath = `/v2/orgs/{orgId}/reports/snapshots/{recordBucket}/{id}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'recordBucket'}}`, encodeURIComponent(String(recordBucket)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateReportSnapshotRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ReportingApi - functional programming interface
 * @export
 */
export const ReportingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReportingApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {ApiSvcRecordBinaryContent} binaryContent
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createFileSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      binaryContent: ApiSvcRecordBinaryContent,
      file: File,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcFileRecord>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createFileSnapshot(
        orgId,
        recordBucket,
        binaryContent,
        file,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {ApiSvcCreateSodaReportSnapshotRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      body: ApiSvcCreateSodaReportSnapshotRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcFileRecord>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createSnapshot(orgId, recordBucket, body, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSnapshot(orgId, recordBucket, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Download close report PDF Returns a signed download URL for the PDF file
     * @param {string} orgId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async downloadCloseReport(
      orgId: string,
      reportId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcDownloadCloseReport200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCloseReport(orgId, reportId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Streams the report run\'s persisted payload as CSV. api-svc reads the JSON blob from GCS and emits CSV in the response body — no direct GCS signed URL handed to the client so the transform happens server-side.  Returns a `Readable` (not a `string`) on purpose: tsoa\'s generated route handler JSON-encodes any string/object return value via `res.json(...)`, which would (a) wrap the CSV in quotes and escape newlines and (b) reset Content-Type to `application/json` — corrupting the download. Returning a stream routes through tsoa\'s `data.pipe(response)` branch instead, which preserves the `Content-Type: text/csv` + `Content-Disposition` headers set below. Same pattern as `ReportsController.getFileSnapshot`.
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async downloadReportRun(
      orgId: string,
      reportRunId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.downloadReportRun(orgId, reportRunId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Export deleted or ignored transactions for a given date range Returns a CSV/ZIP file with all transaction data including deletion/ignore metadata
     * @param {string} orgId
     * @param {string} startDate
     * @param {string} endDate
     * @param {boolean} [allowZip]
     * @param {boolean} [useOrgTimezone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportDeletedIgnoredTransactions(
      orgId: string,
      startDate: string,
      endDate: string,
      allowZip?: boolean,
      useOrgTimezone?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcExportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportDeletedIgnoredTransactions(
        orgId,
        startDate,
        endDate,
        allowZip,
        useOrgTimezone,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Generate a close checklist certification report Creates a PDF summary with links to existing exception reports
     * @param {string} orgId
     * @param {ApiSvcGenerateCloseReportRequest} apiSvcGenerateCloseReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateCloseReport(
      orgId: string,
      apiSvcGenerateCloseReportRequest: ApiSvcGenerateCloseReportRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGenerateCloseReportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generateCloseReport(
        orgId,
        apiSvcGenerateCloseReportRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Phase 1 of the two-phase workflow.
     * @param {string} orgId
     * @param {ApiSvcGenerateRolledUpJeReportRequest} apiSvcGenerateRolledUpJeReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateRolledUpJeReport(
      orgId: string,
      apiSvcGenerateRolledUpJeReportRequest: ApiSvcGenerateRolledUpJeReportRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGenerateRolledUpJeReportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generateRolledUpJeReport(
        orgId,
        apiSvcGenerateRolledUpJeReportRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get close report details by report ID Returns full report metadata including checks, status, and period info
     * @param {string} orgId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCloseReportDetails(
      orgId: string,
      reportId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetReportDetailsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCloseReportDetails(orgId, reportId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get the Temporal workflow status for a close report PDF generation. Use the reportRunId returned from generateCloseReport to poll for completion.
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCloseReportWorkflowStatus(
      orgId: string,
      reportRunId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCloseReportWorkflowStatusResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCloseReportWorkflowStatus(
        orgId,
        reportRunId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFileSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getFileSnapshot(orgId, recordBucket, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportId
     * @param {boolean} [includeDownloadUrls]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReport(
      orgId: string,
      reportId: string,
      includeDownloadUrls?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetReport200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReport(
        orgId,
        reportId,
        includeDownloadUrls,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReportDefinitions(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReportDefinitions(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReportRunResult(
      orgId: string,
      reportRunId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcReportData>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReportRunResult(orgId, reportRunId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReportRunStatus(
      orgId: string,
      reportRunId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcReportRunStatusResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReportRunStatus(orgId, reportRunId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcReportRunConfigTypes} type
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReports(
      orgId: string,
      type: ApiSvcReportRunConfigTypes,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetReports200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReports(orgId, type, pageToken, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRolledUpJeReport(
      orgId: string,
      reportId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRolledUpJeReportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRolledUpJeReport(orgId, reportId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSnapshot(orgId, recordBucket, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSnapshots(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcFileRecord>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSnapshots(orgId, recordBucket, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * List all close reports for an organization with pagination Returns paginated array of report summaries
     * @param {string} orgId
     * @param {number} [limit]
     * @param {string} [cursor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCloseReports(
      orgId: string,
      limit?: number,
      cursor?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcListCloseReportsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCloseReports(orgId, limit, cursor, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Lists report runs for an org by type, ordered by `startedAt` descending. Backs the V3 UI\'s past-runs table on the balance-report page.  `limit` caps the page size at   ; an absent or out-of-range value falls back to   . `pageToken` is an opaque cursor from a previous response.
     * @param {string} orgId
     * @param {ApiSvcReportRunType} type
     * @param {number} [limit]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listReportRuns(
      orgId: string,
      type: ApiSvcReportRunType,
      limit?: number,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcListReportRunsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listReportRuns(orgId, type, limit, pageToken, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async persistSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.persistSnapshot(orgId, recordBucket, id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Phase 2 of the two-phase workflow.
     * @param {string} orgId
     * @param {string} reportId
     * @param {ApiSvcPushRolledUpJeReportRequest} apiSvcPushRolledUpJeReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pushRolledUpJeReport(
      orgId: string,
      reportId: string,
      apiSvcPushRolledUpJeReportRequest: ApiSvcPushRolledUpJeReportRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcPushRolledUpJeReportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pushRolledUpJeReport(
        orgId,
        reportId,
        apiSvcPushRolledUpJeReportRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async run(
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.run(orgId, apiSvcRunReportRequest, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async runESBalanceReportPreview(
      orgId: string,
      date: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRunESBalanceReportPreview200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.runESBalanceReportPreview(orgId, date, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async runRelatedOrgsTransactionsReportSave(
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.runRelatedOrgsTransactionsReportSave(
        orgId,
        apiSvcRunReportRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async runRelatedOrgsTransctionsReportPreview(
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ApiSvcRunRelatedOrgsTransctionsReportPreview200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.runRelatedOrgsTransctionsReportPreview(
        orgId,
        apiSvcRunReportRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async runSharedOrgsBalancesReportPreview(
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRunSharedOrgsBalancesReportPreview200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.runSharedOrgsBalancesReportPreview(
        orgId,
        apiSvcRunReportRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async runSharedOrgsBalancesReportSave(
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.runSharedOrgsBalancesReportSave(
        orgId,
        apiSvcRunReportRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequestDTO} apiSvcRunReportRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async startReportRun(
      orgId: string,
      apiSvcRunReportRequestDTO: ApiSvcRunReportRequestDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcReportRunResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.startReportRun(
        orgId,
        apiSvcRunReportRequestDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {ApiSvcUpdateReportSnapshotRequest} apiSvcUpdateReportSnapshotRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      apiSvcUpdateReportSnapshotRequest: ApiSvcUpdateReportSnapshotRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateSnapshot(
        orgId,
        recordBucket,
        id,
        apiSvcUpdateReportSnapshotRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ReportingApi - factory interface
 * @export
 */
export const ReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ReportingApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {ApiSvcRecordBinaryContent} binaryContent
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFileSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      binaryContent: ApiSvcRecordBinaryContent,
      file: File,
      options?: any
    ): AxiosPromise<ApiSvcFileRecord> {
      return localVarFp
        .createFileSnapshot(orgId, recordBucket, binaryContent, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {ApiSvcCreateSodaReportSnapshotRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      body: ApiSvcCreateSodaReportSnapshotRequest,
      options?: any
    ): AxiosPromise<ApiSvcFileRecord> {
      return localVarFp.createSnapshot(orgId, recordBucket, body, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSnapshot(orgId: string, recordBucket: ApiSvcRecordBucket, id: string, options?: any): AxiosPromise<void> {
      return localVarFp.deleteSnapshot(orgId, recordBucket, id, options).then((request) => request(axios, basePath));
    },
    /**
     * Download close report PDF Returns a signed download URL for the PDF file
     * @param {string} orgId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadCloseReport(
      orgId: string,
      reportId: string,
      options?: any
    ): AxiosPromise<ApiSvcDownloadCloseReport200Response> {
      return localVarFp.downloadCloseReport(orgId, reportId, options).then((request) => request(axios, basePath));
    },
    /**
     * Streams the report run\'s persisted payload as CSV. api-svc reads the JSON blob from GCS and emits CSV in the response body — no direct GCS signed URL handed to the client so the transform happens server-side.  Returns a `Readable` (not a `string`) on purpose: tsoa\'s generated route handler JSON-encodes any string/object return value via `res.json(...)`, which would (a) wrap the CSV in quotes and escape newlines and (b) reset Content-Type to `application/json` — corrupting the download. Returning a stream routes through tsoa\'s `data.pipe(response)` branch instead, which preserves the `Content-Type: text/csv` + `Content-Disposition` headers set below. Same pattern as `ReportsController.getFileSnapshot`.
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadReportRun(orgId: string, reportRunId: string, options?: any): AxiosPromise<string> {
      return localVarFp.downloadReportRun(orgId, reportRunId, options).then((request) => request(axios, basePath));
    },
    /**
     * Export deleted or ignored transactions for a given date range Returns a CSV/ZIP file with all transaction data including deletion/ignore metadata
     * @param {string} orgId
     * @param {string} startDate
     * @param {string} endDate
     * @param {boolean} [allowZip]
     * @param {boolean} [useOrgTimezone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportDeletedIgnoredTransactions(
      orgId: string,
      startDate: string,
      endDate: string,
      allowZip?: boolean,
      useOrgTimezone?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcExportResponse> {
      return localVarFp
        .exportDeletedIgnoredTransactions(orgId, startDate, endDate, allowZip, useOrgTimezone, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Generate a close checklist certification report Creates a PDF summary with links to existing exception reports
     * @param {string} orgId
     * @param {ApiSvcGenerateCloseReportRequest} apiSvcGenerateCloseReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateCloseReport(
      orgId: string,
      apiSvcGenerateCloseReportRequest: ApiSvcGenerateCloseReportRequest,
      options?: any
    ): AxiosPromise<ApiSvcGenerateCloseReportResponse> {
      return localVarFp
        .generateCloseReport(orgId, apiSvcGenerateCloseReportRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Phase 1 of the two-phase workflow.
     * @param {string} orgId
     * @param {ApiSvcGenerateRolledUpJeReportRequest} apiSvcGenerateRolledUpJeReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateRolledUpJeReport(
      orgId: string,
      apiSvcGenerateRolledUpJeReportRequest: ApiSvcGenerateRolledUpJeReportRequest,
      options?: any
    ): AxiosPromise<ApiSvcGenerateRolledUpJeReportResponse> {
      return localVarFp
        .generateRolledUpJeReport(orgId, apiSvcGenerateRolledUpJeReportRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get close report details by report ID Returns full report metadata including checks, status, and period info
     * @param {string} orgId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCloseReportDetails(
      orgId: string,
      reportId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetReportDetailsResponse> {
      return localVarFp.getCloseReportDetails(orgId, reportId, options).then((request) => request(axios, basePath));
    },
    /**
     * Get the Temporal workflow status for a close report PDF generation. Use the reportRunId returned from generateCloseReport to poll for completion.
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCloseReportWorkflowStatus(
      orgId: string,
      reportRunId: string,
      options?: any
    ): AxiosPromise<ApiSvcCloseReportWorkflowStatusResponse> {
      return localVarFp
        .getCloseReportWorkflowStatus(orgId, reportRunId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileSnapshot(orgId: string, recordBucket: ApiSvcRecordBucket, id: string, options?: any): AxiosPromise<string> {
      return localVarFp.getFileSnapshot(orgId, recordBucket, id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportId
     * @param {boolean} [includeDownloadUrls]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReport(
      orgId: string,
      reportId: string,
      includeDownloadUrls?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcGetReport200Response> {
      return localVarFp
        .getReport(orgId, reportId, includeDownloadUrls, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportDefinitions(orgId: string, options?: any): AxiosPromise<void> {
      return localVarFp.getReportDefinitions(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportRunResult(orgId: string, reportRunId: string, options?: any): AxiosPromise<ApiSvcReportData> {
      return localVarFp.getReportRunResult(orgId, reportRunId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportRunStatus(orgId: string, reportRunId: string, options?: any): AxiosPromise<ApiSvcReportRunStatusResponse> {
      return localVarFp.getReportRunStatus(orgId, reportRunId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcReportRunConfigTypes} type
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReports(
      orgId: string,
      type: ApiSvcReportRunConfigTypes,
      pageToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcGetReports200Response> {
      return localVarFp.getReports(orgId, type, pageToken, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRolledUpJeReport(orgId: string, reportId: string, options?: any): AxiosPromise<ApiSvcRolledUpJeReportResponse> {
      return localVarFp.getRolledUpJeReport(orgId, reportId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSnapshot(orgId: string, recordBucket: ApiSvcRecordBucket, id: string, options?: any): AxiosPromise<any> {
      return localVarFp.getSnapshot(orgId, recordBucket, id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSnapshots(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      options?: any
    ): AxiosPromise<Array<ApiSvcFileRecord>> {
      return localVarFp.getSnapshots(orgId, recordBucket, options).then((request) => request(axios, basePath));
    },
    /**
     * List all close reports for an organization with pagination Returns paginated array of report summaries
     * @param {string} orgId
     * @param {number} [limit]
     * @param {string} [cursor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCloseReports(
      orgId: string,
      limit?: number,
      cursor?: string,
      options?: any
    ): AxiosPromise<ApiSvcListCloseReportsResponse> {
      return localVarFp.listCloseReports(orgId, limit, cursor, options).then((request) => request(axios, basePath));
    },
    /**
     * Lists report runs for an org by type, ordered by `startedAt` descending. Backs the V3 UI\'s past-runs table on the balance-report page.  `limit` caps the page size at   ; an absent or out-of-range value falls back to   . `pageToken` is an opaque cursor from a previous response.
     * @param {string} orgId
     * @param {ApiSvcReportRunType} type
     * @param {number} [limit]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listReportRuns(
      orgId: string,
      type: ApiSvcReportRunType,
      limit?: number,
      pageToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcListReportRunsResponse> {
      return localVarFp
        .listReportRuns(orgId, type, limit, pageToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    persistSnapshot(orgId: string, recordBucket: ApiSvcRecordBucket, id: string, options?: any): AxiosPromise<void> {
      return localVarFp.persistSnapshot(orgId, recordBucket, id, options).then((request) => request(axios, basePath));
    },
    /**
     * Phase 2 of the two-phase workflow.
     * @param {string} orgId
     * @param {string} reportId
     * @param {ApiSvcPushRolledUpJeReportRequest} apiSvcPushRolledUpJeReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pushRolledUpJeReport(
      orgId: string,
      reportId: string,
      apiSvcPushRolledUpJeReportRequest: ApiSvcPushRolledUpJeReportRequest,
      options?: any
    ): AxiosPromise<ApiSvcPushRolledUpJeReportResponse> {
      return localVarFp
        .pushRolledUpJeReport(orgId, reportId, apiSvcPushRolledUpJeReportRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    run(orgId: string, apiSvcRunReportRequest: ApiSvcRunReportRequest, options?: any): AxiosPromise<string> {
      return localVarFp.run(orgId, apiSvcRunReportRequest, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runESBalanceReportPreview(
      orgId: string,
      date: string,
      options?: any
    ): AxiosPromise<ApiSvcRunESBalanceReportPreview200Response> {
      return localVarFp.runESBalanceReportPreview(orgId, date, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runRelatedOrgsTransactionsReportSave(
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .runRelatedOrgsTransactionsReportSave(orgId, apiSvcRunReportRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runRelatedOrgsTransctionsReportPreview(
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options?: any
    ): AxiosPromise<ApiSvcRunRelatedOrgsTransctionsReportPreview200Response> {
      return localVarFp
        .runRelatedOrgsTransctionsReportPreview(orgId, apiSvcRunReportRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runSharedOrgsBalancesReportPreview(
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options?: any
    ): AxiosPromise<ApiSvcRunSharedOrgsBalancesReportPreview200Response> {
      return localVarFp
        .runSharedOrgsBalancesReportPreview(orgId, apiSvcRunReportRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runSharedOrgsBalancesReportSave(
      orgId: string,
      apiSvcRunReportRequest: ApiSvcRunReportRequest,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .runSharedOrgsBalancesReportSave(orgId, apiSvcRunReportRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRunReportRequestDTO} apiSvcRunReportRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    startReportRun(
      orgId: string,
      apiSvcRunReportRequestDTO: ApiSvcRunReportRequestDTO,
      options?: any
    ): AxiosPromise<ApiSvcReportRunResponse> {
      return localVarFp
        .startReportRun(orgId, apiSvcRunReportRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcRecordBucket} recordBucket
     * @param {string} id
     * @param {ApiSvcUpdateReportSnapshotRequest} apiSvcUpdateReportSnapshotRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSnapshot(
      orgId: string,
      recordBucket: ApiSvcRecordBucket,
      id: string,
      apiSvcUpdateReportSnapshotRequest: ApiSvcUpdateReportSnapshotRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateSnapshot(orgId, recordBucket, id, apiSvcUpdateReportSnapshotRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ReportingApi - object-oriented interface
 * @export
 * @class ReportingApi
 * @extends {BaseAPI}
 */
export class ReportingApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRecordBucket} recordBucket
   * @param {ApiSvcRecordBinaryContent} binaryContent
   * @param {File} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public createFileSnapshot(
    orgId: string,
    recordBucket: ApiSvcRecordBucket,
    binaryContent: ApiSvcRecordBinaryContent,
    file: File,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .createFileSnapshot(orgId, recordBucket, binaryContent, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRecordBucket} recordBucket
   * @param {ApiSvcCreateSodaReportSnapshotRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public createSnapshot(
    orgId: string,
    recordBucket: ApiSvcRecordBucket,
    body: ApiSvcCreateSodaReportSnapshotRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .createSnapshot(orgId, recordBucket, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRecordBucket} recordBucket
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public deleteSnapshot(orgId: string, recordBucket: ApiSvcRecordBucket, id: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .deleteSnapshot(orgId, recordBucket, id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Download close report PDF Returns a signed download URL for the PDF file
   * @param {string} orgId
   * @param {string} reportId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public downloadCloseReport(orgId: string, reportId: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .downloadCloseReport(orgId, reportId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Streams the report run\'s persisted payload as CSV. api-svc reads the JSON blob from GCS and emits CSV in the response body — no direct GCS signed URL handed to the client so the transform happens server-side.  Returns a `Readable` (not a `string`) on purpose: tsoa\'s generated route handler JSON-encodes any string/object return value via `res.json(...)`, which would (a) wrap the CSV in quotes and escape newlines and (b) reset Content-Type to `application/json` — corrupting the download. Returning a stream routes through tsoa\'s `data.pipe(response)` branch instead, which preserves the `Content-Type: text/csv` + `Content-Disposition` headers set below. Same pattern as `ReportsController.getFileSnapshot`.
   * @param {string} orgId
   * @param {string} reportRunId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public downloadReportRun(orgId: string, reportRunId: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .downloadReportRun(orgId, reportRunId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Export deleted or ignored transactions for a given date range Returns a CSV/ZIP file with all transaction data including deletion/ignore metadata
   * @param {string} orgId
   * @param {string} startDate
   * @param {string} endDate
   * @param {boolean} [allowZip]
   * @param {boolean} [useOrgTimezone]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public exportDeletedIgnoredTransactions(
    orgId: string,
    startDate: string,
    endDate: string,
    allowZip?: boolean,
    useOrgTimezone?: boolean,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .exportDeletedIgnoredTransactions(orgId, startDate, endDate, allowZip, useOrgTimezone, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Generate a close checklist certification report Creates a PDF summary with links to existing exception reports
   * @param {string} orgId
   * @param {ApiSvcGenerateCloseReportRequest} apiSvcGenerateCloseReportRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public generateCloseReport(
    orgId: string,
    apiSvcGenerateCloseReportRequest: ApiSvcGenerateCloseReportRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .generateCloseReport(orgId, apiSvcGenerateCloseReportRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Phase 1 of the two-phase workflow.
   * @param {string} orgId
   * @param {ApiSvcGenerateRolledUpJeReportRequest} apiSvcGenerateRolledUpJeReportRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public generateRolledUpJeReport(
    orgId: string,
    apiSvcGenerateRolledUpJeReportRequest: ApiSvcGenerateRolledUpJeReportRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .generateRolledUpJeReport(orgId, apiSvcGenerateRolledUpJeReportRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get close report details by report ID Returns full report metadata including checks, status, and period info
   * @param {string} orgId
   * @param {string} reportId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getCloseReportDetails(orgId: string, reportId: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getCloseReportDetails(orgId, reportId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the Temporal workflow status for a close report PDF generation. Use the reportRunId returned from generateCloseReport to poll for completion.
   * @param {string} orgId
   * @param {string} reportRunId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getCloseReportWorkflowStatus(orgId: string, reportRunId: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getCloseReportWorkflowStatus(orgId, reportRunId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRecordBucket} recordBucket
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getFileSnapshot(orgId: string, recordBucket: ApiSvcRecordBucket, id: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getFileSnapshot(orgId, recordBucket, id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} reportId
   * @param {boolean} [includeDownloadUrls]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getReport(orgId: string, reportId: string, includeDownloadUrls?: boolean, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getReport(orgId, reportId, includeDownloadUrls, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getReportDefinitions(orgId: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getReportDefinitions(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} reportRunId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getReportRunResult(orgId: string, reportRunId: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getReportRunResult(orgId, reportRunId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} reportRunId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getReportRunStatus(orgId: string, reportRunId: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getReportRunStatus(orgId, reportRunId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcReportRunConfigTypes} type
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getReports(orgId: string, type: ApiSvcReportRunConfigTypes, pageToken?: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getReports(orgId, type, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} reportId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getRolledUpJeReport(orgId: string, reportId: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getRolledUpJeReport(orgId, reportId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRecordBucket} recordBucket
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getSnapshot(orgId: string, recordBucket: ApiSvcRecordBucket, id: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getSnapshot(orgId, recordBucket, id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRecordBucket} recordBucket
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public getSnapshots(orgId: string, recordBucket: ApiSvcRecordBucket, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .getSnapshots(orgId, recordBucket, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * List all close reports for an organization with pagination Returns paginated array of report summaries
   * @param {string} orgId
   * @param {number} [limit]
   * @param {string} [cursor]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public listCloseReports(orgId: string, limit?: number, cursor?: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .listCloseReports(orgId, limit, cursor, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lists report runs for an org by type, ordered by `startedAt` descending. Backs the V3 UI\'s past-runs table on the balance-report page.  `limit` caps the page size at   ; an absent or out-of-range value falls back to   . `pageToken` is an opaque cursor from a previous response.
   * @param {string} orgId
   * @param {ApiSvcReportRunType} type
   * @param {number} [limit]
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public listReportRuns(
    orgId: string,
    type: ApiSvcReportRunType,
    limit?: number,
    pageToken?: string,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .listReportRuns(orgId, type, limit, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRecordBucket} recordBucket
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public persistSnapshot(orgId: string, recordBucket: ApiSvcRecordBucket, id: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .persistSnapshot(orgId, recordBucket, id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Phase 2 of the two-phase workflow.
   * @param {string} orgId
   * @param {string} reportId
   * @param {ApiSvcPushRolledUpJeReportRequest} apiSvcPushRolledUpJeReportRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public pushRolledUpJeReport(
    orgId: string,
    reportId: string,
    apiSvcPushRolledUpJeReportRequest: ApiSvcPushRolledUpJeReportRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .pushRolledUpJeReport(orgId, reportId, apiSvcPushRolledUpJeReportRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public run(orgId: string, apiSvcRunReportRequest: ApiSvcRunReportRequest, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .run(orgId, apiSvcRunReportRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} date
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public runESBalanceReportPreview(orgId: string, date: string, options?: AxiosRequestConfig) {
    return ReportingApiFp(this.configuration)
      .runESBalanceReportPreview(orgId, date, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public runRelatedOrgsTransactionsReportSave(
    orgId: string,
    apiSvcRunReportRequest: ApiSvcRunReportRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .runRelatedOrgsTransactionsReportSave(orgId, apiSvcRunReportRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public runRelatedOrgsTransctionsReportPreview(
    orgId: string,
    apiSvcRunReportRequest: ApiSvcRunReportRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .runRelatedOrgsTransctionsReportPreview(orgId, apiSvcRunReportRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public runSharedOrgsBalancesReportPreview(
    orgId: string,
    apiSvcRunReportRequest: ApiSvcRunReportRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .runSharedOrgsBalancesReportPreview(orgId, apiSvcRunReportRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRunReportRequest} apiSvcRunReportRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public runSharedOrgsBalancesReportSave(
    orgId: string,
    apiSvcRunReportRequest: ApiSvcRunReportRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .runSharedOrgsBalancesReportSave(orgId, apiSvcRunReportRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRunReportRequestDTO} apiSvcRunReportRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public startReportRun(
    orgId: string,
    apiSvcRunReportRequestDTO: ApiSvcRunReportRequestDTO,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .startReportRun(orgId, apiSvcRunReportRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcRecordBucket} recordBucket
   * @param {string} id
   * @param {ApiSvcUpdateReportSnapshotRequest} apiSvcUpdateReportSnapshotRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public updateSnapshot(
    orgId: string,
    recordBucket: ApiSvcRecordBucket,
    id: string,
    apiSvcUpdateReportSnapshotRequest: ApiSvcUpdateReportSnapshotRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportingApiFp(this.configuration)
      .updateSnapshot(orgId, recordBucket, id, apiSvcUpdateReportSnapshotRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [tags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoleDefinitions: async (tags?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/roles/definitions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (tags !== undefined) {
        localVarQueryParameter['tags'] = tags;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [tags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoleDefinitions(
      tags?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcRoleDefinitionRecord>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoleDefinitions(tags, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = RolesApiFp(configuration);
  return {
    /**
     *
     * @param {string} [tags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoleDefinitions(tags?: string, options?: any): AxiosPromise<Array<ApiSvcRoleDefinitionRecord>> {
      return localVarFp.getRoleDefinitions(tags, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
  /**
   *
   * @param {string} [tags]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolesApi
   */
  public getRoleDefinitions(tags?: string, options?: AxiosRequestConfig) {
    return RolesApiFp(this.configuration)
      .getRoleDefinitions(tags, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RolledUpJEConfigurationApi - axios parameter creator
 * @export
 */
export const RolledUpJEConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Create a new rollup configuration for an organization
     * @param {string} orgId
     * @param {ApiSvcCreateRolledUpJeReportConfigurationDTO} apiSvcCreateRolledUpJeReportConfigurationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRolledUpJeReportConfiguration: async (
      orgId: string,
      apiSvcCreateRolledUpJeReportConfigurationDTO: ApiSvcCreateRolledUpJeReportConfigurationDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createRolledUpJeReportConfiguration', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateRolledUpJeReportConfigurationDTO' is not null or undefined
      assertParamExists(
        'createRolledUpJeReportConfiguration',
        'apiSvcCreateRolledUpJeReportConfigurationDTO',
        apiSvcCreateRolledUpJeReportConfigurationDTO
      );
      const localVarPath = `/orgs/{orgId}/rolled-up-je-configurations`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateRolledUpJeReportConfigurationDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get a specific rollup configuration by ID
     * @param {string} orgId
     * @param {string} configId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRolledUpJeReportConfiguration: async (
      orgId: string,
      configId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getRolledUpJeReportConfiguration', 'orgId', orgId);
      // verify required parameter 'configId' is not null or undefined
      assertParamExists('getRolledUpJeReportConfiguration', 'configId', configId);
      const localVarPath = `/orgs/{orgId}/rolled-up-je-configurations/{configId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'configId'}}`, encodeURIComponent(String(configId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * List rollup configurations for an organization
     * @param {string} orgId
     * @param {boolean} [activeOnly] - If true, only return active configurations
     * @param {boolean} [includeDeleted] - If true, include deleted configurations (default: false)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRolledUpJeReportConfigurations: async (
      orgId: string,
      activeOnly?: boolean,
      includeDeleted?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('listRolledUpJeReportConfigurations', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/rolled-up-je-configurations`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (activeOnly !== undefined) {
        localVarQueryParameter['activeOnly'] = activeOnly;
      }

      if (includeDeleted !== undefined) {
        localVarQueryParameter['includeDeleted'] = includeDeleted;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update an existing rollup configuration
     * @param {string} orgId
     * @param {string} configId
     * @param {ApiSvcUpdateRolledUpJeReportConfigurationDTO} apiSvcUpdateRolledUpJeReportConfigurationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRolledUpJeReportConfiguration: async (
      orgId: string,
      configId: string,
      apiSvcUpdateRolledUpJeReportConfigurationDTO: ApiSvcUpdateRolledUpJeReportConfigurationDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateRolledUpJeReportConfiguration', 'orgId', orgId);
      // verify required parameter 'configId' is not null or undefined
      assertParamExists('updateRolledUpJeReportConfiguration', 'configId', configId);
      // verify required parameter 'apiSvcUpdateRolledUpJeReportConfigurationDTO' is not null or undefined
      assertParamExists(
        'updateRolledUpJeReportConfiguration',
        'apiSvcUpdateRolledUpJeReportConfigurationDTO',
        apiSvcUpdateRolledUpJeReportConfigurationDTO
      );
      const localVarPath = `/orgs/{orgId}/rolled-up-je-configurations/{configId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'configId'}}`, encodeURIComponent(String(configId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateRolledUpJeReportConfigurationDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RolledUpJEConfigurationApi - functional programming interface
 * @export
 */
export const RolledUpJEConfigurationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RolledUpJEConfigurationApiAxiosParamCreator(configuration);
  return {
    /**
     * Create a new rollup configuration for an organization
     * @param {string} orgId
     * @param {ApiSvcCreateRolledUpJeReportConfigurationDTO} apiSvcCreateRolledUpJeReportConfigurationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRolledUpJeReportConfiguration(
      orgId: string,
      apiSvcCreateRolledUpJeReportConfigurationDTO: ApiSvcCreateRolledUpJeReportConfigurationDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRolledUpJeReportConfigurationResponseDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRolledUpJeReportConfiguration(
        orgId,
        apiSvcCreateRolledUpJeReportConfigurationDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get a specific rollup configuration by ID
     * @param {string} orgId
     * @param {string} configId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRolledUpJeReportConfiguration(
      orgId: string,
      configId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRolledUpJeReportConfigurationResponseDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRolledUpJeReportConfiguration(
        orgId,
        configId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * List rollup configurations for an organization
     * @param {string} orgId
     * @param {boolean} [activeOnly] - If true, only return active configurations
     * @param {boolean} [includeDeleted] - If true, include deleted configurations (default: false)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listRolledUpJeReportConfigurations(
      orgId: string,
      activeOnly?: boolean,
      includeDeleted?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcRolledUpJeReportConfigurationResponseDTO>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listRolledUpJeReportConfigurations(
        orgId,
        activeOnly,
        includeDeleted,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update an existing rollup configuration
     * @param {string} orgId
     * @param {string} configId
     * @param {ApiSvcUpdateRolledUpJeReportConfigurationDTO} apiSvcUpdateRolledUpJeReportConfigurationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRolledUpJeReportConfiguration(
      orgId: string,
      configId: string,
      apiSvcUpdateRolledUpJeReportConfigurationDTO: ApiSvcUpdateRolledUpJeReportConfigurationDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRolledUpJeReportConfiguration(
        orgId,
        configId,
        apiSvcUpdateRolledUpJeReportConfigurationDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * RolledUpJEConfigurationApi - factory interface
 * @export
 */
export const RolledUpJEConfigurationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RolledUpJEConfigurationApiFp(configuration);
  return {
    /**
     * Create a new rollup configuration for an organization
     * @param {string} orgId
     * @param {ApiSvcCreateRolledUpJeReportConfigurationDTO} apiSvcCreateRolledUpJeReportConfigurationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRolledUpJeReportConfiguration(
      orgId: string,
      apiSvcCreateRolledUpJeReportConfigurationDTO: ApiSvcCreateRolledUpJeReportConfigurationDTO,
      options?: any
    ): AxiosPromise<ApiSvcRolledUpJeReportConfigurationResponseDTO> {
      return localVarFp
        .createRolledUpJeReportConfiguration(orgId, apiSvcCreateRolledUpJeReportConfigurationDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get a specific rollup configuration by ID
     * @param {string} orgId
     * @param {string} configId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRolledUpJeReportConfiguration(
      orgId: string,
      configId: string,
      options?: any
    ): AxiosPromise<ApiSvcRolledUpJeReportConfigurationResponseDTO> {
      return localVarFp
        .getRolledUpJeReportConfiguration(orgId, configId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * List rollup configurations for an organization
     * @param {string} orgId
     * @param {boolean} [activeOnly] - If true, only return active configurations
     * @param {boolean} [includeDeleted] - If true, include deleted configurations (default: false)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRolledUpJeReportConfigurations(
      orgId: string,
      activeOnly?: boolean,
      includeDeleted?: boolean,
      options?: any
    ): AxiosPromise<Array<ApiSvcRolledUpJeReportConfigurationResponseDTO>> {
      return localVarFp
        .listRolledUpJeReportConfigurations(orgId, activeOnly, includeDeleted, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update an existing rollup configuration
     * @param {string} orgId
     * @param {string} configId
     * @param {ApiSvcUpdateRolledUpJeReportConfigurationDTO} apiSvcUpdateRolledUpJeReportConfigurationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRolledUpJeReportConfiguration(
      orgId: string,
      configId: string,
      apiSvcUpdateRolledUpJeReportConfigurationDTO: ApiSvcUpdateRolledUpJeReportConfigurationDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateRolledUpJeReportConfiguration(orgId, configId, apiSvcUpdateRolledUpJeReportConfigurationDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RolledUpJEConfigurationApi - object-oriented interface
 * @export
 * @class RolledUpJEConfigurationApi
 * @extends {BaseAPI}
 */
export class RolledUpJEConfigurationApi extends BaseAPI {
  /**
   * Create a new rollup configuration for an organization
   * @param {string} orgId
   * @param {ApiSvcCreateRolledUpJeReportConfigurationDTO} apiSvcCreateRolledUpJeReportConfigurationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolledUpJEConfigurationApi
   */
  public createRolledUpJeReportConfiguration(
    orgId: string,
    apiSvcCreateRolledUpJeReportConfigurationDTO: ApiSvcCreateRolledUpJeReportConfigurationDTO,
    options?: AxiosRequestConfig
  ) {
    return RolledUpJEConfigurationApiFp(this.configuration)
      .createRolledUpJeReportConfiguration(orgId, apiSvcCreateRolledUpJeReportConfigurationDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get a specific rollup configuration by ID
   * @param {string} orgId
   * @param {string} configId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolledUpJEConfigurationApi
   */
  public getRolledUpJeReportConfiguration(orgId: string, configId: string, options?: AxiosRequestConfig) {
    return RolledUpJEConfigurationApiFp(this.configuration)
      .getRolledUpJeReportConfiguration(orgId, configId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * List rollup configurations for an organization
   * @param {string} orgId
   * @param {boolean} [activeOnly] - If true, only return active configurations
   * @param {boolean} [includeDeleted] - If true, include deleted configurations (default: false)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolledUpJEConfigurationApi
   */
  public listRolledUpJeReportConfigurations(
    orgId: string,
    activeOnly?: boolean,
    includeDeleted?: boolean,
    options?: AxiosRequestConfig
  ) {
    return RolledUpJEConfigurationApiFp(this.configuration)
      .listRolledUpJeReportConfigurations(orgId, activeOnly, includeDeleted, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Update an existing rollup configuration
   * @param {string} orgId
   * @param {string} configId
   * @param {ApiSvcUpdateRolledUpJeReportConfigurationDTO} apiSvcUpdateRolledUpJeReportConfigurationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolledUpJEConfigurationApi
   */
  public updateRolledUpJeReportConfiguration(
    orgId: string,
    configId: string,
    apiSvcUpdateRolledUpJeReportConfigurationDTO: ApiSvcUpdateRolledUpJeReportConfigurationDTO,
    options?: AxiosRequestConfig
  ) {
    return RolledUpJEConfigurationApiFp(this.configuration)
      .updateRolledUpJeReportConfiguration(orgId, configId, apiSvcUpdateRolledUpJeReportConfigurationDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RulesApi - axios parameter creator
 * @export
 */
export const RulesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Returns specific rule for an organization within Bitwave based upon the ruleId.
     * @param {string} orgId
     * @param {string} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRuleById: async (orgId: string, ruleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getRuleById', 'orgId', orgId);
      // verify required parameter 'ruleId' is not null or undefined
      assertParamExists('getRuleById', 'ruleId', ruleId);
      const localVarPath = `/org/{orgId}/rules/{ruleId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'ruleId'}}`, encodeURIComponent(String(ruleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns all the rules for an organization within Bitwave.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRules: async (
      orgId: string,
      pageLimit?: number,
      pageToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getRules', 'orgId', orgId);
      const localVarPath = `/org/{orgId}/rules`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageLimit !== undefined) {
        localVarQueryParameter['pageLimit'] = pageLimit;
      }

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Triggers rule execution for an organization.
     * @param {string} orgId
     * @param {ApiSvcTriggerRulesExecutionRequest} apiSvcTriggerRulesExecutionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerRulesExecution: async (
      orgId: string,
      apiSvcTriggerRulesExecutionRequest: ApiSvcTriggerRulesExecutionRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('triggerRulesExecution', 'orgId', orgId);
      // verify required parameter 'apiSvcTriggerRulesExecutionRequest' is not null or undefined
      assertParamExists(
        'triggerRulesExecution',
        'apiSvcTriggerRulesExecutionRequest',
        apiSvcTriggerRulesExecutionRequest
      );
      const localVarPath = `/org/{orgId}/rules/execute`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTriggerRulesExecutionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RulesApi - functional programming interface
 * @export
 */
export const RulesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RulesApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns specific rule for an organization within Bitwave based upon the ruleId.
     * @param {string} orgId
     * @param {string} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRuleById(
      orgId: string,
      ruleId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetRules200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRuleById(orgId, ruleId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns all the rules for an organization within Bitwave.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRules(
      orgId: string,
      pageLimit?: number,
      pageToken?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetRules200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRules(orgId, pageLimit, pageToken, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Triggers rule execution for an organization.
     * @param {string} orgId
     * @param {ApiSvcTriggerRulesExecutionRequest} apiSvcTriggerRulesExecutionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async triggerRulesExecution(
      orgId: string,
      apiSvcTriggerRulesExecutionRequest: ApiSvcTriggerRulesExecutionRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcTriggerRulesExecution200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.triggerRulesExecution(
        orgId,
        apiSvcTriggerRulesExecutionRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * RulesApi - factory interface
 * @export
 */
export const RulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = RulesApiFp(configuration);
  return {
    /**
     * Returns specific rule for an organization within Bitwave based upon the ruleId.
     * @param {string} orgId
     * @param {string} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRuleById(orgId: string, ruleId: string, options?: any): AxiosPromise<ApiSvcGetRules200Response> {
      return localVarFp.getRuleById(orgId, ruleId, options).then((request) => request(axios, basePath));
    },
    /**
     * Returns all the rules for an organization within Bitwave.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRules(
      orgId: string,
      pageLimit?: number,
      pageToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcGetRules200Response> {
      return localVarFp.getRules(orgId, pageLimit, pageToken, options).then((request) => request(axios, basePath));
    },
    /**
     * Triggers rule execution for an organization.
     * @param {string} orgId
     * @param {ApiSvcTriggerRulesExecutionRequest} apiSvcTriggerRulesExecutionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerRulesExecution(
      orgId: string,
      apiSvcTriggerRulesExecutionRequest: ApiSvcTriggerRulesExecutionRequest,
      options?: any
    ): AxiosPromise<ApiSvcTriggerRulesExecution200Response> {
      return localVarFp
        .triggerRulesExecution(orgId, apiSvcTriggerRulesExecutionRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RulesApi - object-oriented interface
 * @export
 * @class RulesApi
 * @extends {BaseAPI}
 */
export class RulesApi extends BaseAPI {
  /**
   * Returns specific rule for an organization within Bitwave based upon the ruleId.
   * @param {string} orgId
   * @param {string} ruleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RulesApi
   */
  public getRuleById(orgId: string, ruleId: string, options?: AxiosRequestConfig) {
    return RulesApiFp(this.configuration)
      .getRuleById(orgId, ruleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns all the rules for an organization within Bitwave.
   * @param {string} orgId
   * @param {number} [pageLimit]
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RulesApi
   */
  public getRules(orgId: string, pageLimit?: number, pageToken?: string, options?: AxiosRequestConfig) {
    return RulesApiFp(this.configuration)
      .getRules(orgId, pageLimit, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Triggers rule execution for an organization.
   * @param {string} orgId
   * @param {ApiSvcTriggerRulesExecutionRequest} apiSvcTriggerRulesExecutionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RulesApi
   */
  public triggerRulesExecution(
    orgId: string,
    apiSvcTriggerRulesExecutionRequest: ApiSvcTriggerRulesExecutionRequest,
    options?: AxiosRequestConfig
  ) {
    return RulesApiFp(this.configuration)
      .triggerRulesExecution(orgId, apiSvcTriggerRulesExecutionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SAMLProvisioningApi - axios parameter creator
 * @export
 */
export const SAMLProvisioningApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcSamlProvisionRequest} apiSvcSamlProvisionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    provisionSamlUser: async (
      orgId: string,
      apiSvcSamlProvisionRequest: ApiSvcSamlProvisionRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('provisionSamlUser', 'orgId', orgId);
      // verify required parameter 'apiSvcSamlProvisionRequest' is not null or undefined
      assertParamExists('provisionSamlUser', 'apiSvcSamlProvisionRequest', apiSvcSamlProvisionRequest);
      const localVarPath = `/v2/orgs/{orgId}/users/provision-saml`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcSamlProvisionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SAMLProvisioningApi - functional programming interface
 * @export
 */
export const SAMLProvisioningApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SAMLProvisioningApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcSamlProvisionRequest} apiSvcSamlProvisionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async provisionSamlUser(
      orgId: string,
      apiSvcSamlProvisionRequest: ApiSvcSamlProvisionRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcProvisionSamlUser201Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.provisionSamlUser(
        orgId,
        apiSvcSamlProvisionRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SAMLProvisioningApi - factory interface
 * @export
 */
export const SAMLProvisioningApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SAMLProvisioningApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcSamlProvisionRequest} apiSvcSamlProvisionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    provisionSamlUser(
      orgId: string,
      apiSvcSamlProvisionRequest: ApiSvcSamlProvisionRequest,
      options?: any
    ): AxiosPromise<ApiSvcProvisionSamlUser201Response> {
      return localVarFp
        .provisionSamlUser(orgId, apiSvcSamlProvisionRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SAMLProvisioningApi - object-oriented interface
 * @export
 * @class SAMLProvisioningApi
 * @extends {BaseAPI}
 */
export class SAMLProvisioningApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {ApiSvcSamlProvisionRequest} apiSvcSamlProvisionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SAMLProvisioningApi
   */
  public provisionSamlUser(
    orgId: string,
    apiSvcSamlProvisionRequest: ApiSvcSamlProvisionRequest,
    options?: AxiosRequestConfig
  ) {
    return SAMLProvisioningApiFp(this.configuration)
      .provisionSamlUser(orgId, apiSvcSamlProvisionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SCIMApi - axios parameter creator
 * @export
 */
export const SCIMApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcScimCreateRequest} apiSvcScimCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser: async (
      orgId: string,
      apiSvcScimCreateRequest: ApiSvcScimCreateRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createUser', 'orgId', orgId);
      // verify required parameter 'apiSvcScimCreateRequest' is not null or undefined
      assertParamExists('createUser', 'apiSvcScimCreateRequest', apiSvcScimCreateRequest);
      const localVarPath = `/orgs/{orgId}/scim/v2/Users`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcScimCreateRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScimUser: async (userId: string, orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('getScimUser', 'userId', userId);
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getScimUser', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/scim/v2/Users/{userId}`
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)))
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {string} orgId
     * @param {ApiSvcScimPatchRequest} apiSvcScimPatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchScimUser: async (
      userId: string,
      orgId: string,
      apiSvcScimPatchRequest: ApiSvcScimPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('patchScimUser', 'userId', userId);
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('patchScimUser', 'orgId', orgId);
      // verify required parameter 'apiSvcScimPatchRequest' is not null or undefined
      assertParamExists('patchScimUser', 'apiSvcScimPatchRequest', apiSvcScimPatchRequest);
      const localVarPath = `/orgs/{orgId}/scim/v2/Users/{userId}`
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)))
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcScimPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scimGetUsers: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('scimGetUsers', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/scim/v2/Users`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {string} orgId
     * @param {ApiSvcScimUpdateRequest} apiSvcScimUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scimUpdateUser: async (
      userId: string,
      orgId: string,
      apiSvcScimUpdateRequest: ApiSvcScimUpdateRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('scimUpdateUser', 'userId', userId);
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('scimUpdateUser', 'orgId', orgId);
      // verify required parameter 'apiSvcScimUpdateRequest' is not null or undefined
      assertParamExists('scimUpdateUser', 'apiSvcScimUpdateRequest', apiSvcScimUpdateRequest);
      const localVarPath = `/orgs/{orgId}/scim/v2/Users/{userId}`
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)))
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcScimUpdateRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SCIMApi - functional programming interface
 * @export
 */
export const SCIMApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SCIMApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcScimCreateRequest} apiSvcScimCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createUser(
      orgId: string,
      apiSvcScimCreateRequest: ApiSvcScimCreateRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateUser201Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(orgId, apiSvcScimCreateRequest, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} userId
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getScimUser(
      userId: string,
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcScimUserSchema>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getScimUser(userId, orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} userId
     * @param {string} orgId
     * @param {ApiSvcScimPatchRequest} apiSvcScimPatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchScimUser(
      userId: string,
      orgId: string,
      apiSvcScimPatchRequest: ApiSvcScimPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcPatchScimUser200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchScimUser(
        userId,
        orgId,
        apiSvcScimPatchRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async scimGetUsers(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcScimGetUsers200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.scimGetUsers(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} userId
     * @param {string} orgId
     * @param {ApiSvcScimUpdateRequest} apiSvcScimUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async scimUpdateUser(
      userId: string,
      orgId: string,
      apiSvcScimUpdateRequest: ApiSvcScimUpdateRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcScimUpdateUser200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.scimUpdateUser(
        userId,
        orgId,
        apiSvcScimUpdateRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SCIMApi - factory interface
 * @export
 */
export const SCIMApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SCIMApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcScimCreateRequest} apiSvcScimCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(
      orgId: string,
      apiSvcScimCreateRequest: ApiSvcScimCreateRequest,
      options?: any
    ): AxiosPromise<ApiSvcCreateUser201Response> {
      return localVarFp.createUser(orgId, apiSvcScimCreateRequest, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} userId
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScimUser(userId: string, orgId: string, options?: any): AxiosPromise<ApiSvcScimUserSchema> {
      return localVarFp.getScimUser(userId, orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} userId
     * @param {string} orgId
     * @param {ApiSvcScimPatchRequest} apiSvcScimPatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchScimUser(
      userId: string,
      orgId: string,
      apiSvcScimPatchRequest: ApiSvcScimPatchRequest,
      options?: any
    ): AxiosPromise<ApiSvcPatchScimUser200Response> {
      return localVarFp
        .patchScimUser(userId, orgId, apiSvcScimPatchRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scimGetUsers(orgId: string, options?: any): AxiosPromise<ApiSvcScimGetUsers200Response> {
      return localVarFp.scimGetUsers(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} userId
     * @param {string} orgId
     * @param {ApiSvcScimUpdateRequest} apiSvcScimUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scimUpdateUser(
      userId: string,
      orgId: string,
      apiSvcScimUpdateRequest: ApiSvcScimUpdateRequest,
      options?: any
    ): AxiosPromise<ApiSvcScimUpdateUser200Response> {
      return localVarFp
        .scimUpdateUser(userId, orgId, apiSvcScimUpdateRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SCIMApi - object-oriented interface
 * @export
 * @class SCIMApi
 * @extends {BaseAPI}
 */
export class SCIMApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {ApiSvcScimCreateRequest} apiSvcScimCreateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SCIMApi
   */
  public createUser(orgId: string, apiSvcScimCreateRequest: ApiSvcScimCreateRequest, options?: AxiosRequestConfig) {
    return SCIMApiFp(this.configuration)
      .createUser(orgId, apiSvcScimCreateRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} userId
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SCIMApi
   */
  public getScimUser(userId: string, orgId: string, options?: AxiosRequestConfig) {
    return SCIMApiFp(this.configuration)
      .getScimUser(userId, orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} userId
   * @param {string} orgId
   * @param {ApiSvcScimPatchRequest} apiSvcScimPatchRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SCIMApi
   */
  public patchScimUser(
    userId: string,
    orgId: string,
    apiSvcScimPatchRequest: ApiSvcScimPatchRequest,
    options?: AxiosRequestConfig
  ) {
    return SCIMApiFp(this.configuration)
      .patchScimUser(userId, orgId, apiSvcScimPatchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SCIMApi
   */
  public scimGetUsers(orgId: string, options?: AxiosRequestConfig) {
    return SCIMApiFp(this.configuration)
      .scimGetUsers(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} userId
   * @param {string} orgId
   * @param {ApiSvcScimUpdateRequest} apiSvcScimUpdateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SCIMApi
   */
  public scimUpdateUser(
    userId: string,
    orgId: string,
    apiSvcScimUpdateRequest: ApiSvcScimUpdateRequest,
    options?: AxiosRequestConfig
  ) {
    return SCIMApiFp(this.configuration)
      .scimUpdateUser(userId, orgId, apiSvcScimUpdateRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SftpPathsApi - axios parameter creator
 * @export
 */
export const SftpPathsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Assign (or replace) the SFTP push path for a single report task in a checklist run. Idempotent upsert keyed by (checkListRunId, reportId).
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {string} reportId
     * @param {ApiSvcAssignSftpPathRequest} apiSvcAssignSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignPath: async (
      orgId: string,
      checkListRunId: string,
      reportId: string,
      apiSvcAssignSftpPathRequest: ApiSvcAssignSftpPathRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('assignPath', 'orgId', orgId);
      // verify required parameter 'checkListRunId' is not null or undefined
      assertParamExists('assignPath', 'checkListRunId', checkListRunId);
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('assignPath', 'reportId', reportId);
      // verify required parameter 'apiSvcAssignSftpPathRequest' is not null or undefined
      assertParamExists('assignPath', 'apiSvcAssignSftpPathRequest', apiSvcAssignSftpPathRequest);
      const localVarPath = `/orgs/{orgId}/checklist-runs/{checkListRunId}/reports/{reportId}/sftp-path`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'checkListRunId'}}`, encodeURIComponent(String(checkListRunId)))
        .replace(`{${'reportId'}}`, encodeURIComponent(String(reportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcAssignSftpPathRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Bulk-assign report → path mappings for a checklist run. Used by Screen 2 when the user fills the modal table at close-period creation time.
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {ApiSvcBulkAssignSftpPathRequest} apiSvcBulkAssignSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkAssignPaths: async (
      orgId: string,
      checkListRunId: string,
      apiSvcBulkAssignSftpPathRequest: ApiSvcBulkAssignSftpPathRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('bulkAssignPaths', 'orgId', orgId);
      // verify required parameter 'checkListRunId' is not null or undefined
      assertParamExists('bulkAssignPaths', 'checkListRunId', checkListRunId);
      // verify required parameter 'apiSvcBulkAssignSftpPathRequest' is not null or undefined
      assertParamExists('bulkAssignPaths', 'apiSvcBulkAssignSftpPathRequest', apiSvcBulkAssignSftpPathRequest);
      const localVarPath = `/orgs/{orgId}/checklist-runs/{checkListRunId}/sftp-path-assignments`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'checkListRunId'}}`, encodeURIComponent(String(checkListRunId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcBulkAssignSftpPathRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateSftpPathRequest} apiSvcCreateSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPath: async (
      orgId: string,
      apiSvcCreateSftpPathRequest: ApiSvcCreateSftpPathRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createPath', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateSftpPathRequest' is not null or undefined
      assertParamExists('createPath', 'apiSvcCreateSftpPathRequest', apiSvcCreateSftpPathRequest);
      const localVarPath = `/orgs/{orgId}/sftp-paths`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateSftpPathRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} pathId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePath: async (orgId: string, pathId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deletePath', 'orgId', orgId);
      // verify required parameter 'pathId' is not null or undefined
      assertParamExists('deletePath', 'pathId', pathId);
      const localVarPath = `/orgs/{orgId}/sftp-paths/{pathId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'pathId'}}`, encodeURIComponent(String(pathId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Resolve a routing decision in one round trip: returns the assignment for (runId, reportId) JOINED with the path it points to. Designed for the actions-svc worker so it can do (assignment + path) in one call instead of two. 404 means \"no assignment OR the path was deleted\" — worker falls through to its legacy code path on 404.
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssignmentWithPath: async (
      orgId: string,
      checkListRunId: string,
      reportId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getAssignmentWithPath', 'orgId', orgId);
      // verify required parameter 'checkListRunId' is not null or undefined
      assertParamExists('getAssignmentWithPath', 'checkListRunId', checkListRunId);
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('getAssignmentWithPath', 'reportId', reportId);
      const localVarPath = `/orgs/{orgId}/checklist-runs/{checkListRunId}/reports/{reportId}/sftp-path`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'checkListRunId'}}`, encodeURIComponent(String(checkListRunId)))
        .replace(`{${'reportId'}}`, encodeURIComponent(String(reportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} pathId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPath: async (orgId: string, pathId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getPath', 'orgId', orgId);
      // verify required parameter 'pathId' is not null or undefined
      assertParamExists('getPath', 'pathId', pathId);
      const localVarPath = `/orgs/{orgId}/sftp-paths/{pathId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'pathId'}}`, encodeURIComponent(String(pathId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * List all (reportId → sftpPathId) assignments for a close-period checklist run. Used by Screen 2 (close setup) to pre-populate the per-report dropdowns and by Screen 3 (run-time) to render the current selection on each \"Push To SFTP\" subtask.
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAssignments: async (
      orgId: string,
      checkListRunId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('listAssignments', 'orgId', orgId);
      // verify required parameter 'checkListRunId' is not null or undefined
      assertParamExists('listAssignments', 'checkListRunId', checkListRunId);
      const localVarPath = `/orgs/{orgId}/checklist-runs/{checkListRunId}/sftp-path-assignments`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'checkListRunId'}}`, encodeURIComponent(String(checkListRunId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * List SFTP paths for an org. Optionally filter by connectionId and/or action (Push/Pull). The \"Push to SFTP\" close-checklist selector should call this with action=Push.
     * @param {string} orgId
     * @param {string} [connectionId]
     * @param {ApiSvcSftpPathAction} [action]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPaths: async (
      orgId: string,
      connectionId?: string,
      action?: ApiSvcSftpPathAction,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('listPaths', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/sftp-paths`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (connectionId !== undefined) {
        localVarQueryParameter['connectionId'] = connectionId;
      }

      if (action !== undefined) {
        localVarQueryParameter['action'] = action;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Probe the SFTP server to verify the directory exists. Backs the \"Test Path\" button in the Edit Path dialog — returns 200 with { ok: false, error } when the directory is missing (non-blocking UI error), and 400 only for input/connection-level problems.  Requires a write scope: a Push test puts (then deletes) a probe file on the customer\'s SFTP server, so read-only users can\'t trigger remote writes.
     * @param {string} orgId
     * @param {ApiSvcTestSftpPathRequest} apiSvcTestSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    testPath: async (
      orgId: string,
      apiSvcTestSftpPathRequest: ApiSvcTestSftpPathRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('testPath', 'orgId', orgId);
      // verify required parameter 'apiSvcTestSftpPathRequest' is not null or undefined
      assertParamExists('testPath', 'apiSvcTestSftpPathRequest', apiSvcTestSftpPathRequest);
      const localVarPath = `/orgs/{orgId}/sftp-paths/test`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTestSftpPathRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unassignPath: async (
      orgId: string,
      checkListRunId: string,
      reportId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('unassignPath', 'orgId', orgId);
      // verify required parameter 'checkListRunId' is not null or undefined
      assertParamExists('unassignPath', 'checkListRunId', checkListRunId);
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('unassignPath', 'reportId', reportId);
      const localVarPath = `/orgs/{orgId}/checklist-runs/{checkListRunId}/reports/{reportId}/sftp-path`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'checkListRunId'}}`, encodeURIComponent(String(checkListRunId)))
        .replace(`{${'reportId'}}`, encodeURIComponent(String(reportId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} pathId
     * @param {ApiSvcUpdateSftpPathRequest} apiSvcUpdateSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePath: async (
      orgId: string,
      pathId: string,
      apiSvcUpdateSftpPathRequest: ApiSvcUpdateSftpPathRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updatePath', 'orgId', orgId);
      // verify required parameter 'pathId' is not null or undefined
      assertParamExists('updatePath', 'pathId', pathId);
      // verify required parameter 'apiSvcUpdateSftpPathRequest' is not null or undefined
      assertParamExists('updatePath', 'apiSvcUpdateSftpPathRequest', apiSvcUpdateSftpPathRequest);
      const localVarPath = `/orgs/{orgId}/sftp-paths/{pathId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'pathId'}}`, encodeURIComponent(String(pathId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateSftpPathRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SftpPathsApi - functional programming interface
 * @export
 */
export const SftpPathsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SftpPathsApiAxiosParamCreator(configuration);
  return {
    /**
     * Assign (or replace) the SFTP push path for a single report task in a checklist run. Idempotent upsert keyed by (checkListRunId, reportId).
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {string} reportId
     * @param {ApiSvcAssignSftpPathRequest} apiSvcAssignSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignPath(
      orgId: string,
      checkListRunId: string,
      reportId: string,
      apiSvcAssignSftpPathRequest: ApiSvcAssignSftpPathRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcAssignPath200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assignPath(
        orgId,
        checkListRunId,
        reportId,
        apiSvcAssignSftpPathRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Bulk-assign report → path mappings for a checklist run. Used by Screen 2 when the user fills the modal table at close-period creation time.
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {ApiSvcBulkAssignSftpPathRequest} apiSvcBulkAssignSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bulkAssignPaths(
      orgId: string,
      checkListRunId: string,
      apiSvcBulkAssignSftpPathRequest: ApiSvcBulkAssignSftpPathRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcListAssignments200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bulkAssignPaths(
        orgId,
        checkListRunId,
        apiSvcBulkAssignSftpPathRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateSftpPathRequest} apiSvcCreateSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPath(
      orgId: string,
      apiSvcCreateSftpPathRequest: ApiSvcCreateSftpPathRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreatePath200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createPath(orgId, apiSvcCreateSftpPathRequest, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} pathId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePath(
      orgId: string,
      pathId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deletePath(orgId, pathId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Resolve a routing decision in one round trip: returns the assignment for (runId, reportId) JOINED with the path it points to. Designed for the actions-svc worker so it can do (assignment + path) in one call instead of two. 404 means \"no assignment OR the path was deleted\" — worker falls through to its legacy code path on 404.
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssignmentWithPath(
      orgId: string,
      checkListRunId: string,
      reportId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetAssignmentWithPath200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignmentWithPath(
        orgId,
        checkListRunId,
        reportId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} pathId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPath(
      orgId: string,
      pathId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreatePath200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPath(orgId, pathId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * List all (reportId → sftpPathId) assignments for a close-period checklist run. Used by Screen 2 (close setup) to pre-populate the per-report dropdowns and by Screen 3 (run-time) to render the current selection on each \"Push To SFTP\" subtask.
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listAssignments(
      orgId: string,
      checkListRunId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcListAssignments200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listAssignments(orgId, checkListRunId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * List SFTP paths for an org. Optionally filter by connectionId and/or action (Push/Pull). The \"Push to SFTP\" close-checklist selector should call this with action=Push.
     * @param {string} orgId
     * @param {string} [connectionId]
     * @param {ApiSvcSftpPathAction} [action]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listPaths(
      orgId: string,
      connectionId?: string,
      action?: ApiSvcSftpPathAction,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcListPaths200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listPaths(orgId, connectionId, action, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Probe the SFTP server to verify the directory exists. Backs the \"Test Path\" button in the Edit Path dialog — returns 200 with { ok: false, error } when the directory is missing (non-blocking UI error), and 400 only for input/connection-level problems.  Requires a write scope: a Push test puts (then deletes) a probe file on the customer\'s SFTP server, so read-only users can\'t trigger remote writes.
     * @param {string} orgId
     * @param {ApiSvcTestSftpPathRequest} apiSvcTestSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async testPath(
      orgId: string,
      apiSvcTestSftpPathRequest: ApiSvcTestSftpPathRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcTestPath200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.testPath(orgId, apiSvcTestSftpPathRequest, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unassignPath(
      orgId: string,
      checkListRunId: string,
      reportId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unassignPath(orgId, checkListRunId, reportId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} pathId
     * @param {ApiSvcUpdateSftpPathRequest} apiSvcUpdateSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePath(
      orgId: string,
      pathId: string,
      apiSvcUpdateSftpPathRequest: ApiSvcUpdateSftpPathRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreatePath200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePath(
        orgId,
        pathId,
        apiSvcUpdateSftpPathRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SftpPathsApi - factory interface
 * @export
 */
export const SftpPathsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SftpPathsApiFp(configuration);
  return {
    /**
     * Assign (or replace) the SFTP push path for a single report task in a checklist run. Idempotent upsert keyed by (checkListRunId, reportId).
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {string} reportId
     * @param {ApiSvcAssignSftpPathRequest} apiSvcAssignSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignPath(
      orgId: string,
      checkListRunId: string,
      reportId: string,
      apiSvcAssignSftpPathRequest: ApiSvcAssignSftpPathRequest,
      options?: any
    ): AxiosPromise<ApiSvcAssignPath200Response> {
      return localVarFp
        .assignPath(orgId, checkListRunId, reportId, apiSvcAssignSftpPathRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Bulk-assign report → path mappings for a checklist run. Used by Screen 2 when the user fills the modal table at close-period creation time.
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {ApiSvcBulkAssignSftpPathRequest} apiSvcBulkAssignSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkAssignPaths(
      orgId: string,
      checkListRunId: string,
      apiSvcBulkAssignSftpPathRequest: ApiSvcBulkAssignSftpPathRequest,
      options?: any
    ): AxiosPromise<ApiSvcListAssignments200Response> {
      return localVarFp
        .bulkAssignPaths(orgId, checkListRunId, apiSvcBulkAssignSftpPathRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateSftpPathRequest} apiSvcCreateSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPath(
      orgId: string,
      apiSvcCreateSftpPathRequest: ApiSvcCreateSftpPathRequest,
      options?: any
    ): AxiosPromise<ApiSvcCreatePath200Response> {
      return localVarFp
        .createPath(orgId, apiSvcCreateSftpPathRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} pathId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePath(orgId: string, pathId: string, options?: any): AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response> {
      return localVarFp.deletePath(orgId, pathId, options).then((request) => request(axios, basePath));
    },
    /**
     * Resolve a routing decision in one round trip: returns the assignment for (runId, reportId) JOINED with the path it points to. Designed for the actions-svc worker so it can do (assignment + path) in one call instead of two. 404 means \"no assignment OR the path was deleted\" — worker falls through to its legacy code path on 404.
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssignmentWithPath(
      orgId: string,
      checkListRunId: string,
      reportId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetAssignmentWithPath200Response> {
      return localVarFp
        .getAssignmentWithPath(orgId, checkListRunId, reportId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} pathId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPath(orgId: string, pathId: string, options?: any): AxiosPromise<ApiSvcCreatePath200Response> {
      return localVarFp.getPath(orgId, pathId, options).then((request) => request(axios, basePath));
    },
    /**
     * List all (reportId → sftpPathId) assignments for a close-period checklist run. Used by Screen 2 (close setup) to pre-populate the per-report dropdowns and by Screen 3 (run-time) to render the current selection on each \"Push To SFTP\" subtask.
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAssignments(
      orgId: string,
      checkListRunId: string,
      options?: any
    ): AxiosPromise<ApiSvcListAssignments200Response> {
      return localVarFp.listAssignments(orgId, checkListRunId, options).then((request) => request(axios, basePath));
    },
    /**
     * List SFTP paths for an org. Optionally filter by connectionId and/or action (Push/Pull). The \"Push to SFTP\" close-checklist selector should call this with action=Push.
     * @param {string} orgId
     * @param {string} [connectionId]
     * @param {ApiSvcSftpPathAction} [action]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPaths(
      orgId: string,
      connectionId?: string,
      action?: ApiSvcSftpPathAction,
      options?: any
    ): AxiosPromise<ApiSvcListPaths200Response> {
      return localVarFp.listPaths(orgId, connectionId, action, options).then((request) => request(axios, basePath));
    },
    /**
     * Probe the SFTP server to verify the directory exists. Backs the \"Test Path\" button in the Edit Path dialog — returns 200 with { ok: false, error } when the directory is missing (non-blocking UI error), and 400 only for input/connection-level problems.  Requires a write scope: a Push test puts (then deletes) a probe file on the customer\'s SFTP server, so read-only users can\'t trigger remote writes.
     * @param {string} orgId
     * @param {ApiSvcTestSftpPathRequest} apiSvcTestSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    testPath(
      orgId: string,
      apiSvcTestSftpPathRequest: ApiSvcTestSftpPathRequest,
      options?: any
    ): AxiosPromise<ApiSvcTestPath200Response> {
      return localVarFp.testPath(orgId, apiSvcTestSftpPathRequest, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} checkListRunId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unassignPath(
      orgId: string,
      checkListRunId: string,
      reportId: string,
      options?: any
    ): AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response> {
      return localVarFp
        .unassignPath(orgId, checkListRunId, reportId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} pathId
     * @param {ApiSvcUpdateSftpPathRequest} apiSvcUpdateSftpPathRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePath(
      orgId: string,
      pathId: string,
      apiSvcUpdateSftpPathRequest: ApiSvcUpdateSftpPathRequest,
      options?: any
    ): AxiosPromise<ApiSvcCreatePath200Response> {
      return localVarFp
        .updatePath(orgId, pathId, apiSvcUpdateSftpPathRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SftpPathsApi - object-oriented interface
 * @export
 * @class SftpPathsApi
 * @extends {BaseAPI}
 */
export class SftpPathsApi extends BaseAPI {
  /**
   * Assign (or replace) the SFTP push path for a single report task in a checklist run. Idempotent upsert keyed by (checkListRunId, reportId).
   * @param {string} orgId
   * @param {string} checkListRunId
   * @param {string} reportId
   * @param {ApiSvcAssignSftpPathRequest} apiSvcAssignSftpPathRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public assignPath(
    orgId: string,
    checkListRunId: string,
    reportId: string,
    apiSvcAssignSftpPathRequest: ApiSvcAssignSftpPathRequest,
    options?: AxiosRequestConfig
  ) {
    return SftpPathsApiFp(this.configuration)
      .assignPath(orgId, checkListRunId, reportId, apiSvcAssignSftpPathRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Bulk-assign report → path mappings for a checklist run. Used by Screen 2 when the user fills the modal table at close-period creation time.
   * @param {string} orgId
   * @param {string} checkListRunId
   * @param {ApiSvcBulkAssignSftpPathRequest} apiSvcBulkAssignSftpPathRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public bulkAssignPaths(
    orgId: string,
    checkListRunId: string,
    apiSvcBulkAssignSftpPathRequest: ApiSvcBulkAssignSftpPathRequest,
    options?: AxiosRequestConfig
  ) {
    return SftpPathsApiFp(this.configuration)
      .bulkAssignPaths(orgId, checkListRunId, apiSvcBulkAssignSftpPathRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateSftpPathRequest} apiSvcCreateSftpPathRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public createPath(
    orgId: string,
    apiSvcCreateSftpPathRequest: ApiSvcCreateSftpPathRequest,
    options?: AxiosRequestConfig
  ) {
    return SftpPathsApiFp(this.configuration)
      .createPath(orgId, apiSvcCreateSftpPathRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} pathId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public deletePath(orgId: string, pathId: string, options?: AxiosRequestConfig) {
    return SftpPathsApiFp(this.configuration)
      .deletePath(orgId, pathId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Resolve a routing decision in one round trip: returns the assignment for (runId, reportId) JOINED with the path it points to. Designed for the actions-svc worker so it can do (assignment + path) in one call instead of two. 404 means \"no assignment OR the path was deleted\" — worker falls through to its legacy code path on 404.
   * @param {string} orgId
   * @param {string} checkListRunId
   * @param {string} reportId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public getAssignmentWithPath(orgId: string, checkListRunId: string, reportId: string, options?: AxiosRequestConfig) {
    return SftpPathsApiFp(this.configuration)
      .getAssignmentWithPath(orgId, checkListRunId, reportId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} pathId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public getPath(orgId: string, pathId: string, options?: AxiosRequestConfig) {
    return SftpPathsApiFp(this.configuration)
      .getPath(orgId, pathId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * List all (reportId → sftpPathId) assignments for a close-period checklist run. Used by Screen 2 (close setup) to pre-populate the per-report dropdowns and by Screen 3 (run-time) to render the current selection on each \"Push To SFTP\" subtask.
   * @param {string} orgId
   * @param {string} checkListRunId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public listAssignments(orgId: string, checkListRunId: string, options?: AxiosRequestConfig) {
    return SftpPathsApiFp(this.configuration)
      .listAssignments(orgId, checkListRunId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * List SFTP paths for an org. Optionally filter by connectionId and/or action (Push/Pull). The \"Push to SFTP\" close-checklist selector should call this with action=Push.
   * @param {string} orgId
   * @param {string} [connectionId]
   * @param {ApiSvcSftpPathAction} [action]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public listPaths(orgId: string, connectionId?: string, action?: ApiSvcSftpPathAction, options?: AxiosRequestConfig) {
    return SftpPathsApiFp(this.configuration)
      .listPaths(orgId, connectionId, action, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Probe the SFTP server to verify the directory exists. Backs the \"Test Path\" button in the Edit Path dialog — returns 200 with { ok: false, error } when the directory is missing (non-blocking UI error), and 400 only for input/connection-level problems.  Requires a write scope: a Push test puts (then deletes) a probe file on the customer\'s SFTP server, so read-only users can\'t trigger remote writes.
   * @param {string} orgId
   * @param {ApiSvcTestSftpPathRequest} apiSvcTestSftpPathRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public testPath(orgId: string, apiSvcTestSftpPathRequest: ApiSvcTestSftpPathRequest, options?: AxiosRequestConfig) {
    return SftpPathsApiFp(this.configuration)
      .testPath(orgId, apiSvcTestSftpPathRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} checkListRunId
   * @param {string} reportId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public unassignPath(orgId: string, checkListRunId: string, reportId: string, options?: AxiosRequestConfig) {
    return SftpPathsApiFp(this.configuration)
      .unassignPath(orgId, checkListRunId, reportId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} pathId
   * @param {ApiSvcUpdateSftpPathRequest} apiSvcUpdateSftpPathRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SftpPathsApi
   */
  public updatePath(
    orgId: string,
    pathId: string,
    apiSvcUpdateSftpPathRequest: ApiSvcUpdateSftpPathRequest,
    options?: AxiosRequestConfig
  ) {
    return SftpPathsApiFp(this.configuration)
      .updatePath(orgId, pathId, apiSvcUpdateSftpPathRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TokensApi - axios parameter creator
 * @export
 */
export const TokensApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableScimToken: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('disableScimToken', 'orgId', orgId);
      const localVarPath = `/v2/orgs/{orgId}/tokens/scim-token`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateScimToken: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('generateScimToken', 'orgId', orgId);
      const localVarPath = `/v2/orgs/{orgId}/tokens/scim-token`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TokensApi - functional programming interface
 * @export
 */
export const TokensApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TokensApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disableScimToken(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.disableScimToken(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateScimToken(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generateScimToken(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * TokensApi - factory interface
 * @export
 */
export const TokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = TokensApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableScimToken(orgId: string, options?: any): AxiosPromise<void> {
      return localVarFp.disableScimToken(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateScimToken(orgId: string, options?: any): AxiosPromise<string> {
      return localVarFp.generateScimToken(orgId, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * TokensApi - object-oriented interface
 * @export
 * @class TokensApi
 * @extends {BaseAPI}
 */
export class TokensApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TokensApi
   */
  public disableScimToken(orgId: string, options?: AxiosRequestConfig) {
    return TokensApiFp(this.configuration)
      .disableScimToken(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TokensApi
   */
  public generateScimToken(orgId: string, options?: AxiosRequestConfig) {
    return TokensApiFp(this.configuration)
      .generateScimToken(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete: async (orgId: string, transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('_delete', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('_delete', 'transactionId', transactionId);
      const localVarPath = `/txns/{orgId}/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Categorizes your transaction within Bitwave. Some of the categories within Bitwave include Simple, Account Transfer, Detailed, Invoice/Bill Payment, and DeFi.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionData} apiSvcTransactionData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransaction: async (
      orgId: string,
      transactionId: string,
      apiSvcTransactionData: ApiSvcTransactionData,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('categorizeTransaction', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('categorizeTransaction', 'transactionId', transactionId);
      // verify required parameter 'apiSvcTransactionData' is not null or undefined
      assertParamExists('categorizeTransaction', 'apiSvcTransactionData', apiSvcTransactionData);
      const localVarPath = `/txns/categorize/{orgId}/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(apiSvcTransactionData, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionData} apiSvcTransactionData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransactionContext: async (
      orgId: string,
      transactionId: string,
      apiSvcTransactionData: ApiSvcTransactionData,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('categorizeTransactionContext', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('categorizeTransactionContext', 'transactionId', transactionId);
      // verify required parameter 'apiSvcTransactionData' is not null or undefined
      assertParamExists('categorizeTransactionContext', 'apiSvcTransactionData', apiSvcTransactionData);
      const localVarPath = `/txns/contextCategorize/{orgId}/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(apiSvcTransactionData, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {Array<Array<ApiSvcTxnCategorizeRow>>} apiSvcTxnCategorizeRow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransactions: async (
      orgId: string,
      apiSvcTxnCategorizeRow: Array<Array<ApiSvcTxnCategorizeRow>>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('categorizeTransactions', 'orgId', orgId);
      // verify required parameter 'apiSvcTxnCategorizeRow' is not null or undefined
      assertParamExists('categorizeTransactions', 'apiSvcTxnCategorizeRow', apiSvcTxnCategorizeRow);
      const localVarPath = `/txns/categorizeBulk/{orgId}`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTxnCategorizeRow,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create Transaction batch
     * @param {string} orgId
     * @param {Array<ApiSvcCreateTransactionDTO>} apiSvcCreateTransactionDTO
     * @param {boolean} [immediate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTransactionBatch: async (
      orgId: string,
      apiSvcCreateTransactionDTO: Array<ApiSvcCreateTransactionDTO>,
      immediate?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createTransactionBatch', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateTransactionDTO' is not null or undefined
      assertParamExists('createTransactionBatch', 'apiSvcCreateTransactionDTO', apiSvcCreateTransactionDTO);
      const localVarPath = `/txns/orgs/{orgId}/transactions`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (immediate !== undefined) {
        localVarQueryParameter['immediate'] = immediate;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateTransactionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Provides you with additional transaction details, such as time, address, and transaction amount.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {boolean} [includeExchangeRates]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransaction: async (
      orgId: string,
      transactionId: string,
      includeExchangeRates?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransaction', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('getTransaction', 'transactionId', transactionId);
      const localVarPath = `/txns/{orgId}/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (includeExchangeRates !== undefined) {
        localVarQueryParameter['includeExchangeRates'] = includeExchangeRates;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns all the transactions for your Bitwave organization.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {string} [categorizationStatus]
     * @param {boolean} [includeExchangeRates]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsPaginated: async (
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      categorizationStatus?: string,
      includeExchangeRates?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionsPaginated', 'orgId', orgId);
      const localVarPath = `/txns/{orgId}`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageLimit !== undefined) {
        localVarQueryParameter['pageLimit'] = pageLimit;
      }

      if (paginationToken !== undefined) {
        localVarQueryParameter['paginationToken'] = paginationToken;
      }

      if (categorizationStatus !== undefined) {
        localVarQueryParameter['categorizationStatus'] = categorizationStatus;
      }

      if (includeExchangeRates !== undefined) {
        localVarQueryParameter['includeExchangeRates'] = includeExchangeRates;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enables you to create a transaction manually into Bitwave.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} sourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    head: async (
      orgId: string,
      transactionId: string,
      sourceId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('head', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('head', 'transactionId', transactionId);
      // verify required parameter 'sourceId' is not null or undefined
      assertParamExists('head', 'sourceId', sourceId);
      const localVarPath = `/txns/{orgId}/{transactionId}/{sourceId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)))
        .replace(`{${'sourceId'}}`, encodeURIComponent(String(sourceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceTransactionSec: async (
      orgId: string,
      transactionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('priceTransactionSec', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('priceTransactionSec', 'transactionId', transactionId);
      const localVarPath = `/txns/price_sec/{orgId}/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enables you to create a transaction manually into Bitwave.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} sourceId
     * @param {ApiSvcUpsertTransactionRequest} apiSvcUpsertTransactionRequest
     * @param {boolean} [uncategorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertTransaction: async (
      orgId: string,
      transactionId: string,
      sourceId: string,
      apiSvcUpsertTransactionRequest: ApiSvcUpsertTransactionRequest,
      uncategorize?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('upsertTransaction', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('upsertTransaction', 'transactionId', transactionId);
      // verify required parameter 'sourceId' is not null or undefined
      assertParamExists('upsertTransaction', 'sourceId', sourceId);
      // verify required parameter 'apiSvcUpsertTransactionRequest' is not null or undefined
      assertParamExists('upsertTransaction', 'apiSvcUpsertTransactionRequest', apiSvcUpsertTransactionRequest);
      const localVarPath = `/txns/{orgId}/{transactionId}/{sourceId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)))
        .replace(`{${'sourceId'}}`, encodeURIComponent(String(sourceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (uncategorize !== undefined) {
        localVarQueryParameter['uncategorize'] = uncategorize;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpsertTransactionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} sourceId
     * @param {Array<ApiSvcIndexedTransactionsUnionType>} apiSvcIndexedTransactionsUnionType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertTransactions: async (
      orgId: string,
      sourceId: string,
      apiSvcIndexedTransactionsUnionType: Array<ApiSvcIndexedTransactionsUnionType>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('upsertTransactions', 'orgId', orgId);
      // verify required parameter 'sourceId' is not null or undefined
      assertParamExists('upsertTransactions', 'sourceId', sourceId);
      // verify required parameter 'apiSvcIndexedTransactionsUnionType' is not null or undefined
      assertParamExists('upsertTransactions', 'apiSvcIndexedTransactionsUnionType', apiSvcIndexedTransactionsUnionType);
      const localVarPath = `/txns/orgs/{orgId}/sources/{sourceId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'sourceId'}}`, encodeURIComponent(String(sourceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcIndexedTransactionsUnionType,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _delete(
      orgId: string,
      transactionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator._delete(orgId, transactionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Categorizes your transaction within Bitwave. Some of the categories within Bitwave include Simple, Account Transfer, Detailed, Invoice/Bill Payment, and DeFi.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionData} apiSvcTransactionData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categorizeTransaction(
      orgId: string,
      transactionId: string,
      apiSvcTransactionData: ApiSvcTransactionData,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCategorizeTransaction200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categorizeTransaction(
        orgId,
        transactionId,
        apiSvcTransactionData,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionData} apiSvcTransactionData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categorizeTransactionContext(
      orgId: string,
      transactionId: string,
      apiSvcTransactionData: ApiSvcTransactionData,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCategorizeTransaction200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categorizeTransactionContext(
        orgId,
        transactionId,
        apiSvcTransactionData,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {Array<Array<ApiSvcTxnCategorizeRow>>} apiSvcTxnCategorizeRow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categorizeTransactions(
      orgId: string,
      apiSvcTxnCategorizeRow: Array<Array<ApiSvcTxnCategorizeRow>>,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCategorizeTransactions200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categorizeTransactions(
        orgId,
        apiSvcTxnCategorizeRow,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Create Transaction batch
     * @param {string} orgId
     * @param {Array<ApiSvcCreateTransactionDTO>} apiSvcCreateTransactionDTO
     * @param {boolean} [immediate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createTransactionBatch(
      orgId: string,
      apiSvcCreateTransactionDTO: Array<ApiSvcCreateTransactionDTO>,
      immediate?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateTransactionBatch200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createTransactionBatch(
        orgId,
        apiSvcCreateTransactionDTO,
        immediate,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Provides you with additional transaction details, such as time, address, and transaction amount.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {boolean} [includeExchangeRates]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransaction(
      orgId: string,
      transactionId: string,
      includeExchangeRates?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransaction200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransaction(
        orgId,
        transactionId,
        includeExchangeRates,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns all the transactions for your Bitwave organization.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {string} [categorizationStatus]
     * @param {boolean} [includeExchangeRates]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionsPaginated(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      categorizationStatus?: string,
      includeExchangeRates?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionsPaginated200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsPaginated(
        orgId,
        pageLimit,
        paginationToken,
        categorizationStatus,
        includeExchangeRates,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Enables you to create a transaction manually into Bitwave.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} sourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async head(
      orgId: string,
      transactionId: string,
      sourceId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.head(orgId, transactionId, sourceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async priceTransactionSec(
      orgId: string,
      transactionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcTxnPriceResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.priceTransactionSec(orgId, transactionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Enables you to create a transaction manually into Bitwave.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} sourceId
     * @param {ApiSvcUpsertTransactionRequest} apiSvcUpsertTransactionRequest
     * @param {boolean} [uncategorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertTransaction(
      orgId: string,
      transactionId: string,
      sourceId: string,
      apiSvcUpsertTransactionRequest: ApiSvcUpsertTransactionRequest,
      uncategorize?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCategorizeTransaction200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.upsertTransaction(
        orgId,
        transactionId,
        sourceId,
        apiSvcUpsertTransactionRequest,
        uncategorize,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} sourceId
     * @param {Array<ApiSvcIndexedTransactionsUnionType>} apiSvcIndexedTransactionsUnionType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertTransactions(
      orgId: string,
      sourceId: string,
      apiSvcIndexedTransactionsUnionType: Array<ApiSvcIndexedTransactionsUnionType>,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSvcTxnResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.upsertTransactions(
        orgId,
        sourceId,
        apiSvcIndexedTransactionsUnionType,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionsApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete(orgId: string, transactionId: string, options?: any): AxiosPromise<void> {
      return localVarFp._delete(orgId, transactionId, options).then((request) => request(axios, basePath));
    },
    /**
     * Categorizes your transaction within Bitwave. Some of the categories within Bitwave include Simple, Account Transfer, Detailed, Invoice/Bill Payment, and DeFi.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionData} apiSvcTransactionData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransaction(
      orgId: string,
      transactionId: string,
      apiSvcTransactionData: ApiSvcTransactionData,
      options?: any
    ): AxiosPromise<ApiSvcCategorizeTransaction200Response> {
      return localVarFp
        .categorizeTransaction(orgId, transactionId, apiSvcTransactionData, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionData} apiSvcTransactionData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransactionContext(
      orgId: string,
      transactionId: string,
      apiSvcTransactionData: ApiSvcTransactionData,
      options?: any
    ): AxiosPromise<ApiSvcCategorizeTransaction200Response> {
      return localVarFp
        .categorizeTransactionContext(orgId, transactionId, apiSvcTransactionData, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {Array<Array<ApiSvcTxnCategorizeRow>>} apiSvcTxnCategorizeRow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransactions(
      orgId: string,
      apiSvcTxnCategorizeRow: Array<Array<ApiSvcTxnCategorizeRow>>,
      options?: any
    ): AxiosPromise<ApiSvcCategorizeTransactions200Response> {
      return localVarFp
        .categorizeTransactions(orgId, apiSvcTxnCategorizeRow, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create Transaction batch
     * @param {string} orgId
     * @param {Array<ApiSvcCreateTransactionDTO>} apiSvcCreateTransactionDTO
     * @param {boolean} [immediate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTransactionBatch(
      orgId: string,
      apiSvcCreateTransactionDTO: Array<ApiSvcCreateTransactionDTO>,
      immediate?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcCreateTransactionBatch200Response> {
      return localVarFp
        .createTransactionBatch(orgId, apiSvcCreateTransactionDTO, immediate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Provides you with additional transaction details, such as time, address, and transaction amount.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {boolean} [includeExchangeRates]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransaction(
      orgId: string,
      transactionId: string,
      includeExchangeRates?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcGetTransaction200Response> {
      return localVarFp
        .getTransaction(orgId, transactionId, includeExchangeRates, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns all the transactions for your Bitwave organization.
     * @param {string} orgId
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {string} [categorizationStatus]
     * @param {boolean} [includeExchangeRates]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsPaginated(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      categorizationStatus?: string,
      includeExchangeRates?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionsPaginated200Response> {
      return localVarFp
        .getTransactionsPaginated(
          orgId,
          pageLimit,
          paginationToken,
          categorizationStatus,
          includeExchangeRates,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Enables you to create a transaction manually into Bitwave.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} sourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    head(orgId: string, transactionId: string, sourceId: string, options?: any): AxiosPromise<void> {
      return localVarFp.head(orgId, transactionId, sourceId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceTransactionSec(orgId: string, transactionId: string, options?: any): AxiosPromise<ApiSvcTxnPriceResult> {
      return localVarFp.priceTransactionSec(orgId, transactionId, options).then((request) => request(axios, basePath));
    },
    /**
     * Enables you to create a transaction manually into Bitwave.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} sourceId
     * @param {ApiSvcUpsertTransactionRequest} apiSvcUpsertTransactionRequest
     * @param {boolean} [uncategorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertTransaction(
      orgId: string,
      transactionId: string,
      sourceId: string,
      apiSvcUpsertTransactionRequest: ApiSvcUpsertTransactionRequest,
      uncategorize?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcCategorizeTransaction200Response> {
      return localVarFp
        .upsertTransaction(orgId, transactionId, sourceId, apiSvcUpsertTransactionRequest, uncategorize, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} sourceId
     * @param {Array<ApiSvcIndexedTransactionsUnionType>} apiSvcIndexedTransactionsUnionType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertTransactions(
      orgId: string,
      sourceId: string,
      apiSvcIndexedTransactionsUnionType: Array<ApiSvcIndexedTransactionsUnionType>,
      options?: any
    ): AxiosPromise<Array<ApiSvcTxnResponse>> {
      return localVarFp
        .upsertTransactions(orgId, sourceId, apiSvcIndexedTransactionsUnionType, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public _delete(orgId: string, transactionId: string, options?: AxiosRequestConfig) {
    return TransactionsApiFp(this.configuration)
      ._delete(orgId, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Categorizes your transaction within Bitwave. Some of the categories within Bitwave include Simple, Account Transfer, Detailed, Invoice/Bill Payment, and DeFi.
   * @param {string} orgId
   * @param {string} transactionId
   * @param {ApiSvcTransactionData} apiSvcTransactionData
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public categorizeTransaction(
    orgId: string,
    transactionId: string,
    apiSvcTransactionData: ApiSvcTransactionData,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .categorizeTransaction(orgId, transactionId, apiSvcTransactionData, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {ApiSvcTransactionData} apiSvcTransactionData
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public categorizeTransactionContext(
    orgId: string,
    transactionId: string,
    apiSvcTransactionData: ApiSvcTransactionData,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .categorizeTransactionContext(orgId, transactionId, apiSvcTransactionData, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {Array<Array<ApiSvcTxnCategorizeRow>>} apiSvcTxnCategorizeRow
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public categorizeTransactions(
    orgId: string,
    apiSvcTxnCategorizeRow: Array<Array<ApiSvcTxnCategorizeRow>>,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .categorizeTransactions(orgId, apiSvcTxnCategorizeRow, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Create Transaction batch
   * @param {string} orgId
   * @param {Array<ApiSvcCreateTransactionDTO>} apiSvcCreateTransactionDTO
   * @param {boolean} [immediate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public createTransactionBatch(
    orgId: string,
    apiSvcCreateTransactionDTO: Array<ApiSvcCreateTransactionDTO>,
    immediate?: boolean,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .createTransactionBatch(orgId, apiSvcCreateTransactionDTO, immediate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Provides you with additional transaction details, such as time, address, and transaction amount.
   * @param {string} orgId
   * @param {string} transactionId
   * @param {boolean} [includeExchangeRates]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public getTransaction(
    orgId: string,
    transactionId: string,
    includeExchangeRates?: boolean,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .getTransaction(orgId, transactionId, includeExchangeRates, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns all the transactions for your Bitwave organization.
   * @param {string} orgId
   * @param {number} [pageLimit]
   * @param {string} [paginationToken]
   * @param {string} [categorizationStatus]
   * @param {boolean} [includeExchangeRates]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public getTransactionsPaginated(
    orgId: string,
    pageLimit?: number,
    paginationToken?: string,
    categorizationStatus?: string,
    includeExchangeRates?: boolean,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .getTransactionsPaginated(orgId, pageLimit, paginationToken, categorizationStatus, includeExchangeRates, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Enables you to create a transaction manually into Bitwave.
   * @param {string} orgId
   * @param {string} transactionId
   * @param {string} sourceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public head(orgId: string, transactionId: string, sourceId: string, options?: AxiosRequestConfig) {
    return TransactionsApiFp(this.configuration)
      .head(orgId, transactionId, sourceId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public priceTransactionSec(orgId: string, transactionId: string, options?: AxiosRequestConfig) {
    return TransactionsApiFp(this.configuration)
      .priceTransactionSec(orgId, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Enables you to create a transaction manually into Bitwave.
   * @param {string} orgId
   * @param {string} transactionId
   * @param {string} sourceId
   * @param {ApiSvcUpsertTransactionRequest} apiSvcUpsertTransactionRequest
   * @param {boolean} [uncategorize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public upsertTransaction(
    orgId: string,
    transactionId: string,
    sourceId: string,
    apiSvcUpsertTransactionRequest: ApiSvcUpsertTransactionRequest,
    uncategorize?: boolean,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .upsertTransaction(orgId, transactionId, sourceId, apiSvcUpsertTransactionRequest, uncategorize, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} sourceId
   * @param {Array<ApiSvcIndexedTransactionsUnionType>} apiSvcIndexedTransactionsUnionType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public upsertTransactions(
    orgId: string,
    sourceId: string,
    apiSvcIndexedTransactionsUnionType: Array<ApiSvcIndexedTransactionsUnionType>,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .upsertTransactions(orgId, sourceId, apiSvcIndexedTransactionsUnionType, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransactionsLookupsApi - axios parameter creator
 * @export
 */
export const TransactionsLookupsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} fieldName
     * @param {number} [limit]
     * @param {string} [startsWith]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionLookups: async (
      orgId: string,
      fieldName: string,
      limit?: number,
      startsWith?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionLookups', 'orgId', orgId);
      // verify required parameter 'fieldName' is not null or undefined
      assertParamExists('getTransactionLookups', 'fieldName', fieldName);
      const localVarPath = `/orgs/{orgId}/lookups`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (fieldName !== undefined) {
        localVarQueryParameter['fieldName'] = fieldName;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (startsWith !== undefined) {
        localVarQueryParameter['startsWith'] = startsWith;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionsLookupsApi - functional programming interface
 * @export
 */
export const TransactionsLookupsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TransactionsLookupsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} fieldName
     * @param {number} [limit]
     * @param {string} [startsWith]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionLookups(
      orgId: string,
      fieldName: string,
      limit?: number,
      startsWith?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionLookups200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionLookups(
        orgId,
        fieldName,
        limit,
        startsWith,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * TransactionsLookupsApi - factory interface
 * @export
 */
export const TransactionsLookupsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionsLookupsApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} fieldName
     * @param {number} [limit]
     * @param {string} [startsWith]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionLookups(
      orgId: string,
      fieldName: string,
      limit?: number,
      startsWith?: string,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionLookups200Response> {
      return localVarFp
        .getTransactionLookups(orgId, fieldName, limit, startsWith, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransactionsLookupsApi - object-oriented interface
 * @export
 * @class TransactionsLookupsApi
 * @extends {BaseAPI}
 */
export class TransactionsLookupsApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {string} fieldName
   * @param {number} [limit]
   * @param {string} [startsWith]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsLookupsApi
   */
  public getTransactionLookups(
    orgId: string,
    fieldName: string,
    limit?: number,
    startsWith?: string,
    options?: AxiosRequestConfig
  ) {
    return TransactionsLookupsApiFp(this.configuration)
      .getTransactionLookups(orgId, fieldName, limit, startsWith, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransactionsV2Api - axios parameter creator
 * @export
 */
export const TransactionsV2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcApplyPriceVersionRequest} apiSvcApplyPriceVersionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyPriceVersion: async (
      orgId: string,
      transactionId: string,
      apiSvcApplyPriceVersionRequest: ApiSvcApplyPriceVersionRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('applyPriceVersion', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('applyPriceVersion', 'transactionId', transactionId);
      // verify required parameter 'apiSvcApplyPriceVersionRequest' is not null or undefined
      assertParamExists('applyPriceVersion', 'apiSvcApplyPriceVersionRequest', apiSvcApplyPriceVersionRequest);
      const localVarPath = `/{orgId}/transactions/{transactionId}/prices/apply-version`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcApplyPriceVersionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkCategorizeTransactionsDTO} apiSvcBulkCategorizeTransactionsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCategorizeTransactions: async (
      orgId: string,
      apiSvcBulkCategorizeTransactionsDTO: ApiSvcBulkCategorizeTransactionsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('bulkCategorizeTransactions', 'orgId', orgId);
      // verify required parameter 'apiSvcBulkCategorizeTransactionsDTO' is not null or undefined
      assertParamExists(
        'bulkCategorizeTransactions',
        'apiSvcBulkCategorizeTransactionsDTO',
        apiSvcBulkCategorizeTransactionsDTO
      );
      const localVarPath = `/orgs/{orgId}/transactions`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcBulkCategorizeTransactionsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkTransactionStateUpdateDTO} apiSvcBulkTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpdateTransactionStatus: async (
      orgId: string,
      apiSvcBulkTransactionStateUpdateDTO: ApiSvcBulkTransactionStateUpdateDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('bulkUpdateTransactionStatus', 'orgId', orgId);
      // verify required parameter 'apiSvcBulkTransactionStateUpdateDTO' is not null or undefined
      assertParamExists(
        'bulkUpdateTransactionStatus',
        'apiSvcBulkTransactionStateUpdateDTO',
        apiSvcBulkTransactionStateUpdateDTO
      );
      const localVarPath = `/orgs/{orgId}/transactions/bulk-state`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcBulkTransactionStateUpdateDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates the categorization for a transaction
     * @param {string} orgId Identifier for the organization
     * @param {string} transactionId Identifier for the transaction
     * @param {ApiSvcCategorizeTransactionDTO} apiSvcCategorizeTransactionDTO Categorize transaction DTO
     * @param {boolean} [autoReconcile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransactionPatch: async (
      orgId: string,
      transactionId: string,
      apiSvcCategorizeTransactionDTO: ApiSvcCategorizeTransactionDTO,
      autoReconcile?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('categorizeTransactionPatch', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('categorizeTransactionPatch', 'transactionId', transactionId);
      // verify required parameter 'apiSvcCategorizeTransactionDTO' is not null or undefined
      assertParamExists('categorizeTransactionPatch', 'apiSvcCategorizeTransactionDTO', apiSvcCategorizeTransactionDTO);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (autoReconcile !== undefined) {
        localVarQueryParameter['autoReconcile'] = autoReconcile;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCategorizeTransactionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Checks price IDs for dirty prices
     * @param {string} orgId Identifier for the organization
     * @param {Array<string>} priceIds Set of price IDs to check for dirty status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkPriceDirty: async (
      orgId: string,
      priceIds: Array<string>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('checkPriceDirty', 'orgId', orgId);
      // verify required parameter 'priceIds' is not null or undefined
      assertParamExists('checkPriceDirty', 'priceIds', priceIds);
      const localVarPath = `/orgs/{orgId}/transactions/dirty`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (priceIds) {
        localVarQueryParameter['priceIds'] = priceIds;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Applies a rule to to a transaction
     * @param {string} orgId Identifier for the organization
     * @param {string} transactionId Identifier for the transaction
     * @param {string} ruleId Identifier for the rule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkRuleApplication: async (
      orgId: string,
      transactionId: string,
      ruleId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('checkRuleApplication', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('checkRuleApplication', 'transactionId', transactionId);
      // verify required parameter 'ruleId' is not null or undefined
      assertParamExists('checkRuleApplication', 'ruleId', ruleId);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/rules/{ruleId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)))
        .replace(`{${'ruleId'}}`, encodeURIComponent(String(ruleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    combineTransactions: async (
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('combineTransactions', 'orgId', orgId);
      // verify required parameter 'apiSvcTransactionIdsDTO' is not null or undefined
      assertParamExists('combineTransactions', 'apiSvcTransactionIdsDTO', apiSvcTransactionIdsDTO);
      const localVarPath = `/orgs/{orgId}/transactions!combine`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionIdsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    combineTransactionsV2: async (
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('combineTransactionsV2', 'orgId', orgId);
      // verify required parameter 'apiSvcTransactionIdsDTO' is not null or undefined
      assertParamExists('combineTransactionsV2', 'apiSvcTransactionIdsDTO', apiSvcTransactionIdsDTO);
      const localVarPath = `/orgs/{orgId}/transactions/combine`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionIdsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulkTransactionStateWorkflowStatus: async (
      orgId: string,
      workflowId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getBulkTransactionStateWorkflowStatus', 'orgId', orgId);
      // verify required parameter 'workflowId' is not null or undefined
      assertParamExists('getBulkTransactionStateWorkflowStatus', 'workflowId', workflowId);
      const localVarPath = `/orgs/{orgId}/transactions/bulk-state/{workflowId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'workflowId'}}`, encodeURIComponent(String(workflowId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNetworks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/networks`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Read-only description of a split group, for a confirmation step that needs to show what an unsplit will delete and restore before the user commits. Uses the read scope: this changes nothing.
     * @param {string} orgId
     * @param {string} txnId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSplitGroupV2: async (orgId: string, txnId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getSplitGroupV2', 'orgId', orgId);
      // verify required parameter 'txnId' is not null or undefined
      assertParamExists('getSplitGroupV2', 'txnId', txnId);
      const localVarPath = `/orgs/{orgId}/transactions/{txnId}/split-group`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'txnId'}}`, encodeURIComponent(String(txnId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionAuditLog: async (
      orgId: string,
      transactionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionAuditLog', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('getTransactionAuditLog', 'transactionId', transactionId);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/history`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionChangeLog: async (
      orgId: string,
      pageToken?: string,
      pageSize?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionChangeLog', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/transactions/changelog`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageToken !== undefined) {
        localVarQueryParameter['pageToken'] = pageToken;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionPriceAuditLog: async (
      orgId: string,
      transactionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionPriceAuditLog', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('getTransactionPriceAuditLog', 'transactionId', transactionId);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/prices/history`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionState: async (
      orgId: string,
      transactionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionState', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('getTransactionState', 'transactionId', transactionId);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns a paginated list of all transactions for a Bitwave organization
     * @param {string} orgId Identifier for the organization
     * @param {number} [pageLimit] Maximum number of transactions to return
     * @param {string} [paginationToken] Pagination token from a previous request
     * @param {ApiSvcCategorizationStatusDTO} [categorizationFilter] Filter transactitons by a categorization status
     * @param {ApiSvcReconciliationStatusDTO} [reconciliationFilter] Flag to include exchange rates in transactions
     * @param {ApiSvcReconciliationStatusDTO} [taxReconciliationFilter] Depreciated - use \&#39;taxReconciliationFilter\&#39; parameter instead
     * @param {ApiSvcAccountDetailsTypeDTO} [accountingTransactionType] Filter transactions by a specific type
     * @param {boolean} [accountingTransactionTaxable] Filter transactions by taxable or non-taxable status
     * @param {boolean} [accountingTaxDetailsMissing] Filter transactions by missing or present tax details
     * @param {boolean} [accountingIsTrade] Filter transactions by trade or non-trade
     * @param {Array<string>} [walletFilter] Filter transactions associated with one or more wallet IDs
     * @param {ApiSvcIgnoreTypeDTO} [ignoreFilter] Filter transactions by ignored status
     * @param {number} [beforeDateTime] Filter transactions from before a datetime
     * @param {number} [afterDateTime] Filter transactions from after a datetime
     * @param {string} [pivotDate] Filter transactions from before (desc dateOrder) or after (asc dateOrder) a pivot date
     * @param {Array<string>} [addresses] Filter transactions associated with one or more wallet addresses
     * @param {Array<string>} [searchTokens] Filter Transactions by one or more crypto tokens
     * @param {boolean} [errored] Filter transactions by errored or non-errored status
     * @param {ApiSvcDateOrder} [dateOrder] Set the order of transactions returned by asc or desc date
     * @param {string} [timezone] Set the timezone displayed in transactions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsLite: async (
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      categorizationFilter?: ApiSvcCategorizationStatusDTO,
      reconciliationFilter?: ApiSvcReconciliationStatusDTO,
      taxReconciliationFilter?: ApiSvcReconciliationStatusDTO,
      accountingTransactionType?: ApiSvcAccountDetailsTypeDTO,
      accountingTransactionTaxable?: boolean,
      accountingTaxDetailsMissing?: boolean,
      accountingIsTrade?: boolean,
      walletFilter?: Array<string>,
      ignoreFilter?: ApiSvcIgnoreTypeDTO,
      beforeDateTime?: number,
      afterDateTime?: number,
      pivotDate?: string,
      addresses?: Array<string>,
      searchTokens?: Array<string>,
      errored?: boolean,
      dateOrder?: ApiSvcDateOrder,
      timezone?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionsLite', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/transactions`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageLimit !== undefined) {
        localVarQueryParameter['pageLimit'] = pageLimit;
      }

      if (paginationToken !== undefined) {
        localVarQueryParameter['paginationToken'] = paginationToken;
      }

      if (categorizationFilter !== undefined) {
        localVarQueryParameter['categorizationFilter'] = categorizationFilter;
      }

      if (reconciliationFilter !== undefined) {
        localVarQueryParameter['reconciliationFilter'] = reconciliationFilter;
      }

      if (taxReconciliationFilter !== undefined) {
        localVarQueryParameter['taxReconciliationFilter'] = taxReconciliationFilter;
      }

      if (accountingTransactionType !== undefined) {
        localVarQueryParameter['accountingTransactionType'] = accountingTransactionType;
      }

      if (accountingTransactionTaxable !== undefined) {
        localVarQueryParameter['accountingTransactionTaxable'] = accountingTransactionTaxable;
      }

      if (accountingTaxDetailsMissing !== undefined) {
        localVarQueryParameter['accountingTaxDetailsMissing'] = accountingTaxDetailsMissing;
      }

      if (accountingIsTrade !== undefined) {
        localVarQueryParameter['accountingIsTrade'] = accountingIsTrade;
      }

      if (walletFilter) {
        localVarQueryParameter['walletFilter'] = walletFilter;
      }

      if (ignoreFilter !== undefined) {
        localVarQueryParameter['ignoreFilter'] = ignoreFilter;
      }

      if (beforeDateTime !== undefined) {
        localVarQueryParameter['beforeDateTime'] = beforeDateTime;
      }

      if (afterDateTime !== undefined) {
        localVarQueryParameter['afterDateTime'] = afterDateTime;
      }

      if (pivotDate !== undefined) {
        localVarQueryParameter['pivotDate'] = pivotDate;
      }

      if (addresses) {
        localVarQueryParameter['addresses'] = addresses;
      }

      if (searchTokens) {
        localVarQueryParameter['searchTokens'] = searchTokens;
      }

      if (errored !== undefined) {
        localVarQueryParameter['errored'] = errored;
      }

      if (dateOrder !== undefined) {
        localVarQueryParameter['dateOrder'] = dateOrder;
      }

      if (timezone !== undefined) {
        localVarQueryParameter['timezone'] = timezone;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Transaction summary counts for a Bitwave organization. The response shape mirrors the transactions-materializer summary_v2 contract consumed by actions-svc (transactions_stats / transactions_sync).
     * @param {string} orgId Identifier for the organization
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsSummaryV2: async (
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionsSummaryV2', 'orgId', orgId);
      // verify required parameter 'apiSvcGetTransactionsRequest' is not null or undefined
      assertParamExists('getTransactionsSummaryV2', 'apiSvcGetTransactionsRequest', apiSvcGetTransactionsRequest);
      const localVarPath = `/orgs/{orgId}/transactions/summary_v2`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcGetTransactionsRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    healTransaction: async (
      orgId: string,
      transactionId: string,
      type: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('healTransaction', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('healTransaction', 'transactionId', transactionId);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('healTransaction', 'type', type);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/!heal`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healTransactionV2: async (
      orgId: string,
      transactionId: string,
      type: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('healTransactionV2', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('healTransactionV2', 'transactionId', transactionId);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('healTransactionV2', 'type', type);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/heal`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcPreCategorizeInvoiceTransactionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    preCategorizeTransaction: async (
      orgId: string,
      transactionId: string,
      body: ApiSvcPreCategorizeInvoiceTransactionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('preCategorizeTransaction', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('preCategorizeTransaction', 'transactionId', transactionId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('preCategorizeTransaction', 'body', body);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/!precategorize`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeWalletFromTransaction: async (
      orgId: string,
      transactionId: string,
      walletId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('removeWalletFromTransaction', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('removeWalletFromTransaction', 'transactionId', transactionId);
      // verify required parameter 'walletId' is not null or undefined
      assertParamExists('removeWalletFromTransaction', 'walletId', walletId);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/wallets/{walletId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)))
        .replace(`{${'walletId'}}`, encodeURIComponent(String(walletId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} action
     * @param {ApiSvcResolveTransactionPendingChangesRequest} apiSvcResolveTransactionPendingChangesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveTransactionPendingChanges: async (
      orgId: string,
      transactionId: string,
      action: string,
      apiSvcResolveTransactionPendingChangesRequest: ApiSvcResolveTransactionPendingChangesRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('resolveTransactionPendingChanges', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('resolveTransactionPendingChanges', 'transactionId', transactionId);
      // verify required parameter 'action' is not null or undefined
      assertParamExists('resolveTransactionPendingChanges', 'action', action);
      // verify required parameter 'apiSvcResolveTransactionPendingChangesRequest' is not null or undefined
      assertParamExists(
        'resolveTransactionPendingChanges',
        'apiSvcResolveTransactionPendingChangesRequest',
        apiSvcResolveTransactionPendingChangesRequest
      );
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/resolve`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (action !== undefined) {
        localVarQueryParameter['action'] = action;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcResolveTransactionPendingChangesRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} action
     * @param {ApiSvcResolveTransactionsRequestDTO} apiSvcResolveTransactionsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveTransactionsPendingChanges: async (
      orgId: string,
      action: string,
      apiSvcResolveTransactionsRequestDTO: ApiSvcResolveTransactionsRequestDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('resolveTransactionsPendingChanges', 'orgId', orgId);
      // verify required parameter 'action' is not null or undefined
      assertParamExists('resolveTransactionsPendingChanges', 'action', action);
      // verify required parameter 'apiSvcResolveTransactionsRequestDTO' is not null or undefined
      assertParamExists(
        'resolveTransactionsPendingChanges',
        'apiSvcResolveTransactionsRequestDTO',
        apiSvcResolveTransactionsRequestDTO
      );
      const localVarPath = `/orgs/{orgId}/transactions/resolve`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (action !== undefined) {
        localVarQueryParameter['action'] = action;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcResolveTransactionsRequestDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Recovery endpoint for transactions stuck in the sync pipeline. Handles three states (typically caused by SyncProcessManager races or missed triggers):  - `syncing`        : cascades syncing -> failed-to-sync -> ready-to-sync  - `failed-to-sync` : transitions failed-to-sync -> ready-to-sync  - `ready-to-sync`  : re-emits TxnMarkedReadyToSync (no state change) to                       re-trigger the SyncProcessManager After this, the sync flow can pick the txn up again.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryStuckSync: async (
      orgId: string,
      transactionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('retryStuckSync', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('retryStuckSync', 'transactionId', transactionId);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/retry-stuck-sync`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcSplitTransactionDTO} apiSvcSplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    splitTransactionV2: async (
      orgId: string,
      apiSvcSplitTransactionDTO: ApiSvcSplitTransactionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('splitTransactionV2', 'orgId', orgId);
      // verify required parameter 'apiSvcSplitTransactionDTO' is not null or undefined
      assertParamExists('splitTransactionV2', 'apiSvcSplitTransactionDTO', apiSvcSplitTransactionDTO);
      const localVarPath = `/orgs/{orgId}/transactions/split`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcSplitTransactionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * TEMPORARY DEMO ENDPOINT - Sync cost basis roll forward entries to ERP
     * @param {string} orgId Identifier for the organization
     * @param {ApiSvcSyncCostBasisRollForwardEntriesReq} apiSvcSyncCostBasisRollForwardEntriesReq Request body with connection, inventory view, and date range
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncCostBasisRollForwardEntries: async (
      orgId: string,
      apiSvcSyncCostBasisRollForwardEntriesReq: ApiSvcSyncCostBasisRollForwardEntriesReq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('syncCostBasisRollForwardEntries', 'orgId', orgId);
      // verify required parameter 'apiSvcSyncCostBasisRollForwardEntriesReq' is not null or undefined
      assertParamExists(
        'syncCostBasisRollForwardEntries',
        'apiSvcSyncCostBasisRollForwardEntriesReq',
        apiSvcSyncCostBasisRollForwardEntriesReq
      );
      const localVarPath = `/orgs/{orgId}/transactions/!sync-cost-basis-roll-forward`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcSyncCostBasisRollForwardEntriesReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    unCombineTransactions: async (
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('unCombineTransactions', 'orgId', orgId);
      // verify required parameter 'apiSvcTransactionIdsDTO' is not null or undefined
      assertParamExists('unCombineTransactions', 'apiSvcTransactionIdsDTO', apiSvcTransactionIdsDTO);
      const localVarPath = `/orgs/{orgId}/transactions!uncombine`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionIdsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unCombineTransactionsV2: async (
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('unCombineTransactionsV2', 'orgId', orgId);
      // verify required parameter 'apiSvcTransactionIdsDTO' is not null or undefined
      assertParamExists('unCombineTransactionsV2', 'apiSvcTransactionIdsDTO', apiSvcTransactionIdsDTO);
      const localVarPath = `/orgs/{orgId}/transactions/uncombine`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionIdsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    undeleteTransactions: async (
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('undeleteTransactions', 'orgId', orgId);
      // verify required parameter 'apiSvcTransactionIdsDTO' is not null or undefined
      assertParamExists('undeleteTransactions', 'apiSvcTransactionIdsDTO', apiSvcTransactionIdsDTO);
      const localVarPath = `/orgs/{orgId}/transactions!undelete`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionIdsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undeleteTransactionsV2: async (
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('undeleteTransactionsV2', 'orgId', orgId);
      // verify required parameter 'apiSvcTransactionIdsDTO' is not null or undefined
      assertParamExists('undeleteTransactionsV2', 'apiSvcTransactionIdsDTO', apiSvcTransactionIdsDTO);
      const localVarPath = `/orgs/{orgId}/transactions/undelete`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionIdsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUnsplitTransactionDTO} apiSvcUnsplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unsplitTransactionV2: async (
      orgId: string,
      apiSvcUnsplitTransactionDTO: ApiSvcUnsplitTransactionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('unsplitTransactionV2', 'orgId', orgId);
      // verify required parameter 'apiSvcUnsplitTransactionDTO' is not null or undefined
      assertParamExists('unsplitTransactionV2', 'apiSvcUnsplitTransactionDTO', apiSvcUnsplitTransactionDTO);
      const localVarPath = `/orgs/{orgId}/transactions/unsplit`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUnsplitTransactionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionStateUpdateDTO} apiSvcTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransactionStatus: async (
      orgId: string,
      transactionId: string,
      apiSvcTransactionStateUpdateDTO: ApiSvcTransactionStateUpdateDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateTransactionStatus', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('updateTransactionStatus', 'transactionId', transactionId);
      // verify required parameter 'apiSvcTransactionStateUpdateDTO' is not null or undefined
      assertParamExists('updateTransactionStatus', 'apiSvcTransactionStateUpdateDTO', apiSvcTransactionStateUpdateDTO);
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/state`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionStateUpdateDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcUpdateTransactionTimestampRequest} apiSvcUpdateTransactionTimestampRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransactionTimestamp: async (
      orgId: string,
      transactionId: string,
      apiSvcUpdateTransactionTimestampRequest: ApiSvcUpdateTransactionTimestampRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateTransactionTimestamp', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('updateTransactionTimestamp', 'transactionId', transactionId);
      // verify required parameter 'apiSvcUpdateTransactionTimestampRequest' is not null or undefined
      assertParamExists(
        'updateTransactionTimestamp',
        'apiSvcUpdateTransactionTimestampRequest',
        apiSvcUpdateTransactionTimestampRequest
      );
      const localVarPath = `/orgs/{orgId}/transactions/{transactionId}/timestamp`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateTransactionTimestampRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionsV2Api - functional programming interface
 * @export
 */
export const TransactionsV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TransactionsV2ApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcApplyPriceVersionRequest} apiSvcApplyPriceVersionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async applyPriceVersion(
      orgId: string,
      transactionId: string,
      apiSvcApplyPriceVersionRequest: ApiSvcApplyPriceVersionRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.applyPriceVersion(
        orgId,
        transactionId,
        apiSvcApplyPriceVersionRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkCategorizeTransactionsDTO} apiSvcBulkCategorizeTransactionsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bulkCategorizeTransactions(
      orgId: string,
      apiSvcBulkCategorizeTransactionsDTO: ApiSvcBulkCategorizeTransactionsDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcBulkCategorizeTransactions200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCategorizeTransactions(
        orgId,
        apiSvcBulkCategorizeTransactionsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkTransactionStateUpdateDTO} apiSvcBulkTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bulkUpdateTransactionStatus(
      orgId: string,
      apiSvcBulkTransactionStateUpdateDTO: ApiSvcBulkTransactionStateUpdateDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcBulkUpdateTransactionStatus200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateTransactionStatus(
        orgId,
        apiSvcBulkTransactionStateUpdateDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Updates the categorization for a transaction
     * @param {string} orgId Identifier for the organization
     * @param {string} transactionId Identifier for the transaction
     * @param {ApiSvcCategorizeTransactionDTO} apiSvcCategorizeTransactionDTO Categorize transaction DTO
     * @param {boolean} [autoReconcile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categorizeTransactionPatch(
      orgId: string,
      transactionId: string,
      apiSvcCategorizeTransactionDTO: ApiSvcCategorizeTransactionDTO,
      autoReconcile?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcTxnErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categorizeTransactionPatch(
        orgId,
        transactionId,
        apiSvcCategorizeTransactionDTO,
        autoReconcile,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Checks price IDs for dirty prices
     * @param {string} orgId Identifier for the organization
     * @param {Array<string>} priceIds Set of price IDs to check for dirty status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkPriceDirty(
      orgId: string,
      priceIds: Array<string>,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCheckPriceDirty200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkPriceDirty(orgId, priceIds, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Applies a rule to to a transaction
     * @param {string} orgId Identifier for the organization
     * @param {string} transactionId Identifier for the transaction
     * @param {string} ruleId Identifier for the rule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkRuleApplication(
      orgId: string,
      transactionId: string,
      ruleId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCheckRuleApplication200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkRuleApplication(
        orgId,
        transactionId,
        ruleId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async combineTransactions(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCombineTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.combineTransactions(
        orgId,
        apiSvcTransactionIdsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async combineTransactionsV2(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCombineTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.combineTransactionsV2(
        orgId,
        apiSvcTransactionIdsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBulkTransactionStateWorkflowStatus(
      orgId: string,
      workflowId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetBulkTransactionStateWorkflowStatus200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBulkTransactionStateWorkflowStatus(
        orgId,
        workflowId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNetworks(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getNetworks(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Read-only description of a split group, for a confirmation step that needs to show what an unsplit will delete and restore before the user commits. Uses the read scope: this changes nothing.
     * @param {string} orgId
     * @param {string} txnId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSplitGroupV2(
      orgId: string,
      txnId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetSplitGroupV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSplitGroupV2(orgId, txnId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionAuditLog(
      orgId: string,
      transactionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionAuditLog200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionAuditLog(orgId, transactionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionChangeLog(
      orgId: string,
      pageToken?: string,
      pageSize?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionChangeLog200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionChangeLog(
        orgId,
        pageToken,
        pageSize,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionPriceAuditLog(
      orgId: string,
      transactionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionAuditLog200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionPriceAuditLog(
        orgId,
        transactionId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionState(
      orgId: string,
      transactionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionState200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionState(orgId, transactionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns a paginated list of all transactions for a Bitwave organization
     * @param {string} orgId Identifier for the organization
     * @param {number} [pageLimit] Maximum number of transactions to return
     * @param {string} [paginationToken] Pagination token from a previous request
     * @param {ApiSvcCategorizationStatusDTO} [categorizationFilter] Filter transactitons by a categorization status
     * @param {ApiSvcReconciliationStatusDTO} [reconciliationFilter] Flag to include exchange rates in transactions
     * @param {ApiSvcReconciliationStatusDTO} [taxReconciliationFilter] Depreciated - use \&#39;taxReconciliationFilter\&#39; parameter instead
     * @param {ApiSvcAccountDetailsTypeDTO} [accountingTransactionType] Filter transactions by a specific type
     * @param {boolean} [accountingTransactionTaxable] Filter transactions by taxable or non-taxable status
     * @param {boolean} [accountingTaxDetailsMissing] Filter transactions by missing or present tax details
     * @param {boolean} [accountingIsTrade] Filter transactions by trade or non-trade
     * @param {Array<string>} [walletFilter] Filter transactions associated with one or more wallet IDs
     * @param {ApiSvcIgnoreTypeDTO} [ignoreFilter] Filter transactions by ignored status
     * @param {number} [beforeDateTime] Filter transactions from before a datetime
     * @param {number} [afterDateTime] Filter transactions from after a datetime
     * @param {string} [pivotDate] Filter transactions from before (desc dateOrder) or after (asc dateOrder) a pivot date
     * @param {Array<string>} [addresses] Filter transactions associated with one or more wallet addresses
     * @param {Array<string>} [searchTokens] Filter Transactions by one or more crypto tokens
     * @param {boolean} [errored] Filter transactions by errored or non-errored status
     * @param {ApiSvcDateOrder} [dateOrder] Set the order of transactions returned by asc or desc date
     * @param {string} [timezone] Set the timezone displayed in transactions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionsLite(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      categorizationFilter?: ApiSvcCategorizationStatusDTO,
      reconciliationFilter?: ApiSvcReconciliationStatusDTO,
      taxReconciliationFilter?: ApiSvcReconciliationStatusDTO,
      accountingTransactionType?: ApiSvcAccountDetailsTypeDTO,
      accountingTransactionTaxable?: boolean,
      accountingTaxDetailsMissing?: boolean,
      accountingIsTrade?: boolean,
      walletFilter?: Array<string>,
      ignoreFilter?: ApiSvcIgnoreTypeDTO,
      beforeDateTime?: number,
      afterDateTime?: number,
      pivotDate?: string,
      addresses?: Array<string>,
      searchTokens?: Array<string>,
      errored?: boolean,
      dateOrder?: ApiSvcDateOrder,
      timezone?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionsLite200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsLite(
        orgId,
        pageLimit,
        paginationToken,
        categorizationFilter,
        reconciliationFilter,
        taxReconciliationFilter,
        accountingTransactionType,
        accountingTransactionTaxable,
        accountingTaxDetailsMissing,
        accountingIsTrade,
        walletFilter,
        ignoreFilter,
        beforeDateTime,
        afterDateTime,
        pivotDate,
        addresses,
        searchTokens,
        errored,
        dateOrder,
        timezone,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Transaction summary counts for a Bitwave organization. The response shape mirrors the transactions-materializer summary_v2 contract consumed by actions-svc (transactions_stats / transactions_sync).
     * @param {string} orgId Identifier for the organization
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionsSummaryV2(
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionsSummaryV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsSummaryV2(
        orgId,
        apiSvcGetTransactionsRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async healTransaction(
      orgId: string,
      transactionId: string,
      type: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.healTransaction(orgId, transactionId, type, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async healTransactionV2(
      orgId: string,
      transactionId: string,
      type: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.healTransactionV2(orgId, transactionId, type, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcPreCategorizeInvoiceTransactionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async preCategorizeTransaction(
      orgId: string,
      transactionId: string,
      body: ApiSvcPreCategorizeInvoiceTransactionDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcTxnErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.preCategorizeTransaction(
        orgId,
        transactionId,
        body,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeWalletFromTransaction(
      orgId: string,
      transactionId: string,
      walletId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcTxnErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.removeWalletFromTransaction(
        orgId,
        transactionId,
        walletId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} action
     * @param {ApiSvcResolveTransactionPendingChangesRequest} apiSvcResolveTransactionPendingChangesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resolveTransactionPendingChanges(
      orgId: string,
      transactionId: string,
      action: string,
      apiSvcResolveTransactionPendingChangesRequest: ApiSvcResolveTransactionPendingChangesRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcResolveTransactionPendingChanges200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resolveTransactionPendingChanges(
        orgId,
        transactionId,
        action,
        apiSvcResolveTransactionPendingChangesRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} action
     * @param {ApiSvcResolveTransactionsRequestDTO} apiSvcResolveTransactionsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resolveTransactionsPendingChanges(
      orgId: string,
      action: string,
      apiSvcResolveTransactionsRequestDTO: ApiSvcResolveTransactionsRequestDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcResolveTransactionsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resolveTransactionsPendingChanges(
        orgId,
        action,
        apiSvcResolveTransactionsRequestDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Recovery endpoint for transactions stuck in the sync pipeline. Handles three states (typically caused by SyncProcessManager races or missed triggers):  - `syncing`        : cascades syncing -> failed-to-sync -> ready-to-sync  - `failed-to-sync` : transitions failed-to-sync -> ready-to-sync  - `ready-to-sync`  : re-emits TxnMarkedReadyToSync (no state change) to                       re-trigger the SyncProcessManager After this, the sync flow can pick the txn up again.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async retryStuckSync(
      orgId: string,
      transactionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.retryStuckSync(orgId, transactionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcSplitTransactionDTO} apiSvcSplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async splitTransactionV2(
      orgId: string,
      apiSvcSplitTransactionDTO: ApiSvcSplitTransactionDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcSplitTransactionV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.splitTransactionV2(
        orgId,
        apiSvcSplitTransactionDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * TEMPORARY DEMO ENDPOINT - Sync cost basis roll forward entries to ERP
     * @param {string} orgId Identifier for the organization
     * @param {ApiSvcSyncCostBasisRollForwardEntriesReq} apiSvcSyncCostBasisRollForwardEntriesReq Request body with connection, inventory view, and date range
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async syncCostBasisRollForwardEntries(
      orgId: string,
      apiSvcSyncCostBasisRollForwardEntriesReq: ApiSvcSyncCostBasisRollForwardEntriesReq,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcSyncCostBasisRollForwardEntries200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.syncCostBasisRollForwardEntries(
        orgId,
        apiSvcSyncCostBasisRollForwardEntriesReq,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async unCombineTransactions(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUnCombineTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unCombineTransactions(
        orgId,
        apiSvcTransactionIdsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unCombineTransactionsV2(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUnCombineTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unCombineTransactionsV2(
        orgId,
        apiSvcTransactionIdsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async undeleteTransactions(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.undeleteTransactions(
        orgId,
        apiSvcTransactionIdsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async undeleteTransactionsV2(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.undeleteTransactionsV2(
        orgId,
        apiSvcTransactionIdsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUnsplitTransactionDTO} apiSvcUnsplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unsplitTransactionV2(
      orgId: string,
      apiSvcUnsplitTransactionDTO: ApiSvcUnsplitTransactionDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUnsplitTransactionV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unsplitTransactionV2(
        orgId,
        apiSvcUnsplitTransactionDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionStateUpdateDTO} apiSvcTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTransactionStatus(
      orgId: string,
      transactionId: string,
      apiSvcTransactionStateUpdateDTO: ApiSvcTransactionStateUpdateDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUpdateTransactionStatus200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransactionStatus(
        orgId,
        transactionId,
        apiSvcTransactionStateUpdateDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcUpdateTransactionTimestampRequest} apiSvcUpdateTransactionTimestampRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTransactionTimestamp(
      orgId: string,
      transactionId: string,
      apiSvcUpdateTransactionTimestampRequest: ApiSvcUpdateTransactionTimestampRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUpdateTransactionTimestamp200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransactionTimestamp(
        orgId,
        transactionId,
        apiSvcUpdateTransactionTimestampRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * TransactionsV2Api - factory interface
 * @export
 */
export const TransactionsV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionsV2ApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcApplyPriceVersionRequest} apiSvcApplyPriceVersionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyPriceVersion(
      orgId: string,
      transactionId: string,
      apiSvcApplyPriceVersionRequest: ApiSvcApplyPriceVersionRequest,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .applyPriceVersion(orgId, transactionId, apiSvcApplyPriceVersionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkCategorizeTransactionsDTO} apiSvcBulkCategorizeTransactionsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCategorizeTransactions(
      orgId: string,
      apiSvcBulkCategorizeTransactionsDTO: ApiSvcBulkCategorizeTransactionsDTO,
      options?: any
    ): AxiosPromise<ApiSvcBulkCategorizeTransactions200Response> {
      return localVarFp
        .bulkCategorizeTransactions(orgId, apiSvcBulkCategorizeTransactionsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkTransactionStateUpdateDTO} apiSvcBulkTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpdateTransactionStatus(
      orgId: string,
      apiSvcBulkTransactionStateUpdateDTO: ApiSvcBulkTransactionStateUpdateDTO,
      options?: any
    ): AxiosPromise<ApiSvcBulkUpdateTransactionStatus200Response> {
      return localVarFp
        .bulkUpdateTransactionStatus(orgId, apiSvcBulkTransactionStateUpdateDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the categorization for a transaction
     * @param {string} orgId Identifier for the organization
     * @param {string} transactionId Identifier for the transaction
     * @param {ApiSvcCategorizeTransactionDTO} apiSvcCategorizeTransactionDTO Categorize transaction DTO
     * @param {boolean} [autoReconcile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransactionPatch(
      orgId: string,
      transactionId: string,
      apiSvcCategorizeTransactionDTO: ApiSvcCategorizeTransactionDTO,
      autoReconcile?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcTxnErrorResponse> {
      return localVarFp
        .categorizeTransactionPatch(orgId, transactionId, apiSvcCategorizeTransactionDTO, autoReconcile, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Checks price IDs for dirty prices
     * @param {string} orgId Identifier for the organization
     * @param {Array<string>} priceIds Set of price IDs to check for dirty status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkPriceDirty(
      orgId: string,
      priceIds: Array<string>,
      options?: any
    ): AxiosPromise<ApiSvcCheckPriceDirty200Response> {
      return localVarFp.checkPriceDirty(orgId, priceIds, options).then((request) => request(axios, basePath));
    },
    /**
     * Applies a rule to to a transaction
     * @param {string} orgId Identifier for the organization
     * @param {string} transactionId Identifier for the transaction
     * @param {string} ruleId Identifier for the rule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkRuleApplication(
      orgId: string,
      transactionId: string,
      ruleId: string,
      options?: any
    ): AxiosPromise<ApiSvcCheckRuleApplication200Response> {
      return localVarFp
        .checkRuleApplication(orgId, transactionId, ruleId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    combineTransactions(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: any
    ): AxiosPromise<ApiSvcCombineTransactionsV2200Response> {
      return localVarFp
        .combineTransactions(orgId, apiSvcTransactionIdsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    combineTransactionsV2(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: any
    ): AxiosPromise<ApiSvcCombineTransactionsV2200Response> {
      return localVarFp
        .combineTransactionsV2(orgId, apiSvcTransactionIdsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulkTransactionStateWorkflowStatus(
      orgId: string,
      workflowId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetBulkTransactionStateWorkflowStatus200Response> {
      return localVarFp
        .getBulkTransactionStateWorkflowStatus(orgId, workflowId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNetworks(options?: any): AxiosPromise<Array<any>> {
      return localVarFp.getNetworks(options).then((request) => request(axios, basePath));
    },
    /**
     * Read-only description of a split group, for a confirmation step that needs to show what an unsplit will delete and restore before the user commits. Uses the read scope: this changes nothing.
     * @param {string} orgId
     * @param {string} txnId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSplitGroupV2(orgId: string, txnId: string, options?: any): AxiosPromise<ApiSvcGetSplitGroupV2200Response> {
      return localVarFp.getSplitGroupV2(orgId, txnId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionAuditLog(
      orgId: string,
      transactionId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionAuditLog200Response> {
      return localVarFp
        .getTransactionAuditLog(orgId, transactionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} [pageToken]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionChangeLog(
      orgId: string,
      pageToken?: string,
      pageSize?: number,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionChangeLog200Response> {
      return localVarFp
        .getTransactionChangeLog(orgId, pageToken, pageSize, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionPriceAuditLog(
      orgId: string,
      transactionId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionAuditLog200Response> {
      return localVarFp
        .getTransactionPriceAuditLog(orgId, transactionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionState(
      orgId: string,
      transactionId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionState200Response> {
      return localVarFp.getTransactionState(orgId, transactionId, options).then((request) => request(axios, basePath));
    },
    /**
     * Returns a paginated list of all transactions for a Bitwave organization
     * @param {string} orgId Identifier for the organization
     * @param {number} [pageLimit] Maximum number of transactions to return
     * @param {string} [paginationToken] Pagination token from a previous request
     * @param {ApiSvcCategorizationStatusDTO} [categorizationFilter] Filter transactitons by a categorization status
     * @param {ApiSvcReconciliationStatusDTO} [reconciliationFilter] Flag to include exchange rates in transactions
     * @param {ApiSvcReconciliationStatusDTO} [taxReconciliationFilter] Depreciated - use \&#39;taxReconciliationFilter\&#39; parameter instead
     * @param {ApiSvcAccountDetailsTypeDTO} [accountingTransactionType] Filter transactions by a specific type
     * @param {boolean} [accountingTransactionTaxable] Filter transactions by taxable or non-taxable status
     * @param {boolean} [accountingTaxDetailsMissing] Filter transactions by missing or present tax details
     * @param {boolean} [accountingIsTrade] Filter transactions by trade or non-trade
     * @param {Array<string>} [walletFilter] Filter transactions associated with one or more wallet IDs
     * @param {ApiSvcIgnoreTypeDTO} [ignoreFilter] Filter transactions by ignored status
     * @param {number} [beforeDateTime] Filter transactions from before a datetime
     * @param {number} [afterDateTime] Filter transactions from after a datetime
     * @param {string} [pivotDate] Filter transactions from before (desc dateOrder) or after (asc dateOrder) a pivot date
     * @param {Array<string>} [addresses] Filter transactions associated with one or more wallet addresses
     * @param {Array<string>} [searchTokens] Filter Transactions by one or more crypto tokens
     * @param {boolean} [errored] Filter transactions by errored or non-errored status
     * @param {ApiSvcDateOrder} [dateOrder] Set the order of transactions returned by asc or desc date
     * @param {string} [timezone] Set the timezone displayed in transactions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsLite(
      orgId: string,
      pageLimit?: number,
      paginationToken?: string,
      categorizationFilter?: ApiSvcCategorizationStatusDTO,
      reconciliationFilter?: ApiSvcReconciliationStatusDTO,
      taxReconciliationFilter?: ApiSvcReconciliationStatusDTO,
      accountingTransactionType?: ApiSvcAccountDetailsTypeDTO,
      accountingTransactionTaxable?: boolean,
      accountingTaxDetailsMissing?: boolean,
      accountingIsTrade?: boolean,
      walletFilter?: Array<string>,
      ignoreFilter?: ApiSvcIgnoreTypeDTO,
      beforeDateTime?: number,
      afterDateTime?: number,
      pivotDate?: string,
      addresses?: Array<string>,
      searchTokens?: Array<string>,
      errored?: boolean,
      dateOrder?: ApiSvcDateOrder,
      timezone?: string,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionsLite200Response> {
      return localVarFp
        .getTransactionsLite(
          orgId,
          pageLimit,
          paginationToken,
          categorizationFilter,
          reconciliationFilter,
          taxReconciliationFilter,
          accountingTransactionType,
          accountingTransactionTaxable,
          accountingTaxDetailsMissing,
          accountingIsTrade,
          walletFilter,
          ignoreFilter,
          beforeDateTime,
          afterDateTime,
          pivotDate,
          addresses,
          searchTokens,
          errored,
          dateOrder,
          timezone,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Transaction summary counts for a Bitwave organization. The response shape mirrors the transactions-materializer summary_v2 contract consumed by actions-svc (transactions_stats / transactions_sync).
     * @param {string} orgId Identifier for the organization
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsSummaryV2(
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionsSummaryV2200Response> {
      return localVarFp
        .getTransactionsSummaryV2(orgId, apiSvcGetTransactionsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    healTransaction(
      orgId: string,
      transactionId: string,
      type: string,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .healTransaction(orgId, transactionId, type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healTransactionV2(
      orgId: string,
      transactionId: string,
      type: string,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .healTransactionV2(orgId, transactionId, type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcPreCategorizeInvoiceTransactionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    preCategorizeTransaction(
      orgId: string,
      transactionId: string,
      body: ApiSvcPreCategorizeInvoiceTransactionDTO,
      options?: any
    ): AxiosPromise<ApiSvcTxnErrorResponse> {
      return localVarFp
        .preCategorizeTransaction(orgId, transactionId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeWalletFromTransaction(
      orgId: string,
      transactionId: string,
      walletId: string,
      options?: any
    ): AxiosPromise<ApiSvcTxnErrorResponse> {
      return localVarFp
        .removeWalletFromTransaction(orgId, transactionId, walletId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} action
     * @param {ApiSvcResolveTransactionPendingChangesRequest} apiSvcResolveTransactionPendingChangesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveTransactionPendingChanges(
      orgId: string,
      transactionId: string,
      action: string,
      apiSvcResolveTransactionPendingChangesRequest: ApiSvcResolveTransactionPendingChangesRequest,
      options?: any
    ): AxiosPromise<ApiSvcResolveTransactionPendingChanges200Response> {
      return localVarFp
        .resolveTransactionPendingChanges(
          orgId,
          transactionId,
          action,
          apiSvcResolveTransactionPendingChangesRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} action
     * @param {ApiSvcResolveTransactionsRequestDTO} apiSvcResolveTransactionsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveTransactionsPendingChanges(
      orgId: string,
      action: string,
      apiSvcResolveTransactionsRequestDTO: ApiSvcResolveTransactionsRequestDTO,
      options?: any
    ): AxiosPromise<ApiSvcResolveTransactionsResponse> {
      return localVarFp
        .resolveTransactionsPendingChanges(orgId, action, apiSvcResolveTransactionsRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Recovery endpoint for transactions stuck in the sync pipeline. Handles three states (typically caused by SyncProcessManager races or missed triggers):  - `syncing`        : cascades syncing -> failed-to-sync -> ready-to-sync  - `failed-to-sync` : transitions failed-to-sync -> ready-to-sync  - `ready-to-sync`  : re-emits TxnMarkedReadyToSync (no state change) to                       re-trigger the SyncProcessManager After this, the sync flow can pick the txn up again.
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryStuckSync(
      orgId: string,
      transactionId: string,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp.retryStuckSync(orgId, transactionId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcSplitTransactionDTO} apiSvcSplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    splitTransactionV2(
      orgId: string,
      apiSvcSplitTransactionDTO: ApiSvcSplitTransactionDTO,
      options?: any
    ): AxiosPromise<ApiSvcSplitTransactionV2200Response> {
      return localVarFp
        .splitTransactionV2(orgId, apiSvcSplitTransactionDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * TEMPORARY DEMO ENDPOINT - Sync cost basis roll forward entries to ERP
     * @param {string} orgId Identifier for the organization
     * @param {ApiSvcSyncCostBasisRollForwardEntriesReq} apiSvcSyncCostBasisRollForwardEntriesReq Request body with connection, inventory view, and date range
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncCostBasisRollForwardEntries(
      orgId: string,
      apiSvcSyncCostBasisRollForwardEntriesReq: ApiSvcSyncCostBasisRollForwardEntriesReq,
      options?: any
    ): AxiosPromise<ApiSvcSyncCostBasisRollForwardEntries200Response> {
      return localVarFp
        .syncCostBasisRollForwardEntries(orgId, apiSvcSyncCostBasisRollForwardEntriesReq, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    unCombineTransactions(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: any
    ): AxiosPromise<ApiSvcUnCombineTransactionsV2200Response> {
      return localVarFp
        .unCombineTransactions(orgId, apiSvcTransactionIdsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unCombineTransactionsV2(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: any
    ): AxiosPromise<ApiSvcUnCombineTransactionsV2200Response> {
      return localVarFp
        .unCombineTransactionsV2(orgId, apiSvcTransactionIdsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    undeleteTransactions(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .undeleteTransactions(orgId, apiSvcTransactionIdsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undeleteTransactionsV2(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .undeleteTransactionsV2(orgId, apiSvcTransactionIdsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUnsplitTransactionDTO} apiSvcUnsplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unsplitTransactionV2(
      orgId: string,
      apiSvcUnsplitTransactionDTO: ApiSvcUnsplitTransactionDTO,
      options?: any
    ): AxiosPromise<ApiSvcUnsplitTransactionV2200Response> {
      return localVarFp
        .unsplitTransactionV2(orgId, apiSvcUnsplitTransactionDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionStateUpdateDTO} apiSvcTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransactionStatus(
      orgId: string,
      transactionId: string,
      apiSvcTransactionStateUpdateDTO: ApiSvcTransactionStateUpdateDTO,
      options?: any
    ): AxiosPromise<ApiSvcUpdateTransactionStatus200Response> {
      return localVarFp
        .updateTransactionStatus(orgId, transactionId, apiSvcTransactionStateUpdateDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcUpdateTransactionTimestampRequest} apiSvcUpdateTransactionTimestampRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransactionTimestamp(
      orgId: string,
      transactionId: string,
      apiSvcUpdateTransactionTimestampRequest: ApiSvcUpdateTransactionTimestampRequest,
      options?: any
    ): AxiosPromise<ApiSvcUpdateTransactionTimestamp200Response> {
      return localVarFp
        .updateTransactionTimestamp(orgId, transactionId, apiSvcUpdateTransactionTimestampRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransactionsV2Api - object-oriented interface
 * @export
 * @class TransactionsV2Api
 * @extends {BaseAPI}
 */
export class TransactionsV2Api extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {ApiSvcApplyPriceVersionRequest} apiSvcApplyPriceVersionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public applyPriceVersion(
    orgId: string,
    transactionId: string,
    apiSvcApplyPriceVersionRequest: ApiSvcApplyPriceVersionRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .applyPriceVersion(orgId, transactionId, apiSvcApplyPriceVersionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcBulkCategorizeTransactionsDTO} apiSvcBulkCategorizeTransactionsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public bulkCategorizeTransactions(
    orgId: string,
    apiSvcBulkCategorizeTransactionsDTO: ApiSvcBulkCategorizeTransactionsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .bulkCategorizeTransactions(orgId, apiSvcBulkCategorizeTransactionsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcBulkTransactionStateUpdateDTO} apiSvcBulkTransactionStateUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public bulkUpdateTransactionStatus(
    orgId: string,
    apiSvcBulkTransactionStateUpdateDTO: ApiSvcBulkTransactionStateUpdateDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .bulkUpdateTransactionStatus(orgId, apiSvcBulkTransactionStateUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Updates the categorization for a transaction
   * @param {string} orgId Identifier for the organization
   * @param {string} transactionId Identifier for the transaction
   * @param {ApiSvcCategorizeTransactionDTO} apiSvcCategorizeTransactionDTO Categorize transaction DTO
   * @param {boolean} [autoReconcile]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public categorizeTransactionPatch(
    orgId: string,
    transactionId: string,
    apiSvcCategorizeTransactionDTO: ApiSvcCategorizeTransactionDTO,
    autoReconcile?: boolean,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .categorizeTransactionPatch(orgId, transactionId, apiSvcCategorizeTransactionDTO, autoReconcile, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Checks price IDs for dirty prices
   * @param {string} orgId Identifier for the organization
   * @param {Array<string>} priceIds Set of price IDs to check for dirty status
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public checkPriceDirty(orgId: string, priceIds: Array<string>, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .checkPriceDirty(orgId, priceIds, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Applies a rule to to a transaction
   * @param {string} orgId Identifier for the organization
   * @param {string} transactionId Identifier for the transaction
   * @param {string} ruleId Identifier for the rule
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public checkRuleApplication(orgId: string, transactionId: string, ruleId: string, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .checkRuleApplication(orgId, transactionId, ruleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public combineTransactions(
    orgId: string,
    apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .combineTransactions(orgId, apiSvcTransactionIdsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public combineTransactionsV2(
    orgId: string,
    apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .combineTransactionsV2(orgId, apiSvcTransactionIdsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} workflowId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public getBulkTransactionStateWorkflowStatus(orgId: string, workflowId: string, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .getBulkTransactionStateWorkflowStatus(orgId, workflowId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public getNetworks(options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .getNetworks(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Read-only description of a split group, for a confirmation step that needs to show what an unsplit will delete and restore before the user commits. Uses the read scope: this changes nothing.
   * @param {string} orgId
   * @param {string} txnId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public getSplitGroupV2(orgId: string, txnId: string, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .getSplitGroupV2(orgId, txnId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public getTransactionAuditLog(orgId: string, transactionId: string, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .getTransactionAuditLog(orgId, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} [pageToken]
   * @param {number} [pageSize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public getTransactionChangeLog(orgId: string, pageToken?: string, pageSize?: number, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .getTransactionChangeLog(orgId, pageToken, pageSize, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public getTransactionPriceAuditLog(orgId: string, transactionId: string, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .getTransactionPriceAuditLog(orgId, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public getTransactionState(orgId: string, transactionId: string, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .getTransactionState(orgId, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns a paginated list of all transactions for a Bitwave organization
   * @param {string} orgId Identifier for the organization
   * @param {number} [pageLimit] Maximum number of transactions to return
   * @param {string} [paginationToken] Pagination token from a previous request
   * @param {ApiSvcCategorizationStatusDTO} [categorizationFilter] Filter transactitons by a categorization status
   * @param {ApiSvcReconciliationStatusDTO} [reconciliationFilter] Flag to include exchange rates in transactions
   * @param {ApiSvcReconciliationStatusDTO} [taxReconciliationFilter] Depreciated - use \&#39;taxReconciliationFilter\&#39; parameter instead
   * @param {ApiSvcAccountDetailsTypeDTO} [accountingTransactionType] Filter transactions by a specific type
   * @param {boolean} [accountingTransactionTaxable] Filter transactions by taxable or non-taxable status
   * @param {boolean} [accountingTaxDetailsMissing] Filter transactions by missing or present tax details
   * @param {boolean} [accountingIsTrade] Filter transactions by trade or non-trade
   * @param {Array<string>} [walletFilter] Filter transactions associated with one or more wallet IDs
   * @param {ApiSvcIgnoreTypeDTO} [ignoreFilter] Filter transactions by ignored status
   * @param {number} [beforeDateTime] Filter transactions from before a datetime
   * @param {number} [afterDateTime] Filter transactions from after a datetime
   * @param {string} [pivotDate] Filter transactions from before (desc dateOrder) or after (asc dateOrder) a pivot date
   * @param {Array<string>} [addresses] Filter transactions associated with one or more wallet addresses
   * @param {Array<string>} [searchTokens] Filter Transactions by one or more crypto tokens
   * @param {boolean} [errored] Filter transactions by errored or non-errored status
   * @param {ApiSvcDateOrder} [dateOrder] Set the order of transactions returned by asc or desc date
   * @param {string} [timezone] Set the timezone displayed in transactions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public getTransactionsLite(
    orgId: string,
    pageLimit?: number,
    paginationToken?: string,
    categorizationFilter?: ApiSvcCategorizationStatusDTO,
    reconciliationFilter?: ApiSvcReconciliationStatusDTO,
    taxReconciliationFilter?: ApiSvcReconciliationStatusDTO,
    accountingTransactionType?: ApiSvcAccountDetailsTypeDTO,
    accountingTransactionTaxable?: boolean,
    accountingTaxDetailsMissing?: boolean,
    accountingIsTrade?: boolean,
    walletFilter?: Array<string>,
    ignoreFilter?: ApiSvcIgnoreTypeDTO,
    beforeDateTime?: number,
    afterDateTime?: number,
    pivotDate?: string,
    addresses?: Array<string>,
    searchTokens?: Array<string>,
    errored?: boolean,
    dateOrder?: ApiSvcDateOrder,
    timezone?: string,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .getTransactionsLite(
        orgId,
        pageLimit,
        paginationToken,
        categorizationFilter,
        reconciliationFilter,
        taxReconciliationFilter,
        accountingTransactionType,
        accountingTransactionTaxable,
        accountingTaxDetailsMissing,
        accountingIsTrade,
        walletFilter,
        ignoreFilter,
        beforeDateTime,
        afterDateTime,
        pivotDate,
        addresses,
        searchTokens,
        errored,
        dateOrder,
        timezone,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Transaction summary counts for a Bitwave organization. The response shape mirrors the transactions-materializer summary_v2 contract consumed by actions-svc (transactions_stats / transactions_sync).
   * @param {string} orgId Identifier for the organization
   * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public getTransactionsSummaryV2(
    orgId: string,
    apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .getTransactionsSummaryV2(orgId, apiSvcGetTransactionsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {string} type
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public healTransaction(orgId: string, transactionId: string, type: string, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .healTransaction(orgId, transactionId, type, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {string} type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public healTransactionV2(orgId: string, transactionId: string, type: string, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .healTransactionV2(orgId, transactionId, type, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {ApiSvcPreCategorizeInvoiceTransactionDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public preCategorizeTransaction(
    orgId: string,
    transactionId: string,
    body: ApiSvcPreCategorizeInvoiceTransactionDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .preCategorizeTransaction(orgId, transactionId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {string} walletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public removeWalletFromTransaction(
    orgId: string,
    transactionId: string,
    walletId: string,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .removeWalletFromTransaction(orgId, transactionId, walletId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {string} action
   * @param {ApiSvcResolveTransactionPendingChangesRequest} apiSvcResolveTransactionPendingChangesRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public resolveTransactionPendingChanges(
    orgId: string,
    transactionId: string,
    action: string,
    apiSvcResolveTransactionPendingChangesRequest: ApiSvcResolveTransactionPendingChangesRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .resolveTransactionPendingChanges(
        orgId,
        transactionId,
        action,
        apiSvcResolveTransactionPendingChangesRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} action
   * @param {ApiSvcResolveTransactionsRequestDTO} apiSvcResolveTransactionsRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public resolveTransactionsPendingChanges(
    orgId: string,
    action: string,
    apiSvcResolveTransactionsRequestDTO: ApiSvcResolveTransactionsRequestDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .resolveTransactionsPendingChanges(orgId, action, apiSvcResolveTransactionsRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Recovery endpoint for transactions stuck in the sync pipeline. Handles three states (typically caused by SyncProcessManager races or missed triggers):  - `syncing`        : cascades syncing -> failed-to-sync -> ready-to-sync  - `failed-to-sync` : transitions failed-to-sync -> ready-to-sync  - `ready-to-sync`  : re-emits TxnMarkedReadyToSync (no state change) to                       re-trigger the SyncProcessManager After this, the sync flow can pick the txn up again.
   * @param {string} orgId
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public retryStuckSync(orgId: string, transactionId: string, options?: AxiosRequestConfig) {
    return TransactionsV2ApiFp(this.configuration)
      .retryStuckSync(orgId, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcSplitTransactionDTO} apiSvcSplitTransactionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public splitTransactionV2(
    orgId: string,
    apiSvcSplitTransactionDTO: ApiSvcSplitTransactionDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .splitTransactionV2(orgId, apiSvcSplitTransactionDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * TEMPORARY DEMO ENDPOINT - Sync cost basis roll forward entries to ERP
   * @param {string} orgId Identifier for the organization
   * @param {ApiSvcSyncCostBasisRollForwardEntriesReq} apiSvcSyncCostBasisRollForwardEntriesReq Request body with connection, inventory view, and date range
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public syncCostBasisRollForwardEntries(
    orgId: string,
    apiSvcSyncCostBasisRollForwardEntriesReq: ApiSvcSyncCostBasisRollForwardEntriesReq,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .syncCostBasisRollForwardEntries(orgId, apiSvcSyncCostBasisRollForwardEntriesReq, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public unCombineTransactions(
    orgId: string,
    apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .unCombineTransactions(orgId, apiSvcTransactionIdsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public unCombineTransactionsV2(
    orgId: string,
    apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .unCombineTransactionsV2(orgId, apiSvcTransactionIdsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public undeleteTransactions(
    orgId: string,
    apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .undeleteTransactions(orgId, apiSvcTransactionIdsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public undeleteTransactionsV2(
    orgId: string,
    apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .undeleteTransactionsV2(orgId, apiSvcTransactionIdsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcUnsplitTransactionDTO} apiSvcUnsplitTransactionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public unsplitTransactionV2(
    orgId: string,
    apiSvcUnsplitTransactionDTO: ApiSvcUnsplitTransactionDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .unsplitTransactionV2(orgId, apiSvcUnsplitTransactionDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {ApiSvcTransactionStateUpdateDTO} apiSvcTransactionStateUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public updateTransactionStatus(
    orgId: string,
    transactionId: string,
    apiSvcTransactionStateUpdateDTO: ApiSvcTransactionStateUpdateDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .updateTransactionStatus(orgId, transactionId, apiSvcTransactionStateUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {ApiSvcUpdateTransactionTimestampRequest} apiSvcUpdateTransactionTimestampRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV2Api
   */
  public updateTransactionTimestamp(
    orgId: string,
    transactionId: string,
    apiSvcUpdateTransactionTimestampRequest: ApiSvcUpdateTransactionTimestampRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV2ApiFp(this.configuration)
      .updateTransactionTimestamp(orgId, transactionId, apiSvcUpdateTransactionTimestampRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransactionsV3Api - axios parameter creator
 * @export
 */
export const TransactionsV3ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkCategorizeTransactionsDTO} apiSvcBulkCategorizeTransactionsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCategorizeTransactionsV3: async (
      orgId: string,
      apiSvcBulkCategorizeTransactionsDTO: ApiSvcBulkCategorizeTransactionsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('bulkCategorizeTransactionsV3', 'orgId', orgId);
      // verify required parameter 'apiSvcBulkCategorizeTransactionsDTO' is not null or undefined
      assertParamExists(
        'bulkCategorizeTransactionsV3',
        'apiSvcBulkCategorizeTransactionsDTO',
        apiSvcBulkCategorizeTransactionsDTO
      );
      const localVarPath = `/v3/orgs/{orgId}/transactions`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcBulkCategorizeTransactionsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkTransactionStateUpdateDTO} apiSvcBulkTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpdateTransactionStateV3: async (
      orgId: string,
      apiSvcBulkTransactionStateUpdateDTO: ApiSvcBulkTransactionStateUpdateDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('bulkUpdateTransactionStateV3', 'orgId', orgId);
      // verify required parameter 'apiSvcBulkTransactionStateUpdateDTO' is not null or undefined
      assertParamExists(
        'bulkUpdateTransactionStateV3',
        'apiSvcBulkTransactionStateUpdateDTO',
        apiSvcBulkTransactionStateUpdateDTO
      );
      const localVarPath = `/v3/orgs/{orgId}/transactions/bulk-state`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcBulkTransactionStateUpdateDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcCategorizeTransactionDTO} apiSvcCategorizeTransactionDTO
     * @param {boolean} [autoReconcile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransactionPatchV3: async (
      orgId: string,
      transactionId: string,
      apiSvcCategorizeTransactionDTO: ApiSvcCategorizeTransactionDTO,
      autoReconcile?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('categorizeTransactionPatchV3', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('categorizeTransactionPatchV3', 'transactionId', transactionId);
      // verify required parameter 'apiSvcCategorizeTransactionDTO' is not null or undefined
      assertParamExists(
        'categorizeTransactionPatchV3',
        'apiSvcCategorizeTransactionDTO',
        apiSvcCategorizeTransactionDTO
      );
      const localVarPath = `/v3/orgs/{orgId}/transactions/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (autoReconcile !== undefined) {
        localVarQueryParameter['autoReconcile'] = autoReconcile;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCategorizeTransactionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    combineTransactionsV3: async (
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('combineTransactionsV3', 'orgId', orgId);
      // verify required parameter 'apiSvcTransactionIdsDTO' is not null or undefined
      assertParamExists('combineTransactionsV3', 'apiSvcTransactionIdsDTO', apiSvcTransactionIdsDTO);
      const localVarPath = `/v3/orgs/{orgId}/transactions/combine`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionIdsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportTransactionsV3: async (
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('exportTransactionsV3', 'orgId', orgId);
      // verify required parameter 'apiSvcGetTransactionsRequest' is not null or undefined
      assertParamExists('exportTransactionsV3', 'apiSvcGetTransactionsRequest', apiSvcGetTransactionsRequest);
      const localVarPath = `/v3/orgs/{orgId}/transactions/export`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcGetTransactionsRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulkTransactionStateWorkflowStatusV3: async (
      orgId: string,
      workflowId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getBulkTransactionStateWorkflowStatusV3', 'orgId', orgId);
      // verify required parameter 'workflowId' is not null or undefined
      assertParamExists('getBulkTransactionStateWorkflowStatusV3', 'workflowId', workflowId);
      const localVarPath = `/v3/orgs/{orgId}/transactions/bulk-state/{workflowId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'workflowId'}}`, encodeURIComponent(String(workflowId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Read-only description of a split group, for a confirmation step that needs to show what an unsplit will delete and restore before the user commits. Uses the read scope: this changes nothing.
     * @param {string} orgId
     * @param {string} txnId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSplitGroupV3: async (orgId: string, txnId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getSplitGroupV3', 'orgId', orgId);
      // verify required parameter 'txnId' is not null or undefined
      assertParamExists('getSplitGroupV3', 'txnId', txnId);
      const localVarPath = `/v3/orgs/{orgId}/transactions/{txnId}/split-group`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'txnId'}}`, encodeURIComponent(String(txnId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionV3: async (
      orgId: string,
      transactionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionV3', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('getTransactionV3', 'transactionId', transactionId);
      const localVarPath = `/v3/orgs/{orgId}/transactions/{transactionId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {number} [pageSize]
     * @param {string} [nextToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsChangelogV3: async (
      orgId: string,
      pageSize?: number,
      nextToken?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionsChangelogV3', 'orgId', orgId);
      const localVarPath = `/v3/orgs/{orgId}/transactions/changelog`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      if (nextToken !== undefined) {
        localVarQueryParameter['nextToken'] = nextToken;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsCountV3: async (
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionsCountV3', 'orgId', orgId);
      // verify required parameter 'apiSvcGetTransactionsRequest' is not null or undefined
      assertParamExists('getTransactionsCountV3', 'apiSvcGetTransactionsRequest', apiSvcGetTransactionsRequest);
      const localVarPath = `/v3/orgs/{orgId}/transactions/count`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcGetTransactionsRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsV3: async (
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getTransactionsV3', 'orgId', orgId);
      // verify required parameter 'apiSvcGetTransactionsRequest' is not null or undefined
      assertParamExists('getTransactionsV3', 'apiSvcGetTransactionsRequest', apiSvcGetTransactionsRequest);
      const localVarPath = `/v3/orgs/{orgId}/transactions/search`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcGetTransactionsRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healTransactionV3: async (
      orgId: string,
      transactionId: string,
      type: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('healTransactionV3', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('healTransactionV3', 'transactionId', transactionId);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('healTransactionV3', 'type', type);
      const localVarPath = `/v3/orgs/{orgId}/transactions/{transactionId}/heal`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcPreCategorizeInvoiceTransactionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    preCategorizeTransactionV3: async (
      orgId: string,
      transactionId: string,
      body: ApiSvcPreCategorizeInvoiceTransactionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('preCategorizeTransactionV3', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('preCategorizeTransactionV3', 'transactionId', transactionId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('preCategorizeTransactionV3', 'body', body);
      const localVarPath = `/v3/orgs/{orgId}/transactions/{transactionId}/!precategorize`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceTransactionV3: async (
      orgId: string,
      transactionId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('priceTransactionV3', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('priceTransactionV3', 'transactionId', transactionId);
      const localVarPath = `/v3/orgs/{orgId}/transactions/{transactionId}/price`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} action
     * @param {ApiSvcResolveTransactionPendingChangesRequest} apiSvcResolveTransactionPendingChangesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveTransactionPendingChangesV3: async (
      orgId: string,
      transactionId: string,
      action: string,
      apiSvcResolveTransactionPendingChangesRequest: ApiSvcResolveTransactionPendingChangesRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('resolveTransactionPendingChangesV3', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('resolveTransactionPendingChangesV3', 'transactionId', transactionId);
      // verify required parameter 'action' is not null or undefined
      assertParamExists('resolveTransactionPendingChangesV3', 'action', action);
      // verify required parameter 'apiSvcResolveTransactionPendingChangesRequest' is not null or undefined
      assertParamExists(
        'resolveTransactionPendingChangesV3',
        'apiSvcResolveTransactionPendingChangesRequest',
        apiSvcResolveTransactionPendingChangesRequest
      );
      const localVarPath = `/v3/orgs/{orgId}/transactions/{transactionId}/resolve`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (action !== undefined) {
        localVarQueryParameter['action'] = action;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcResolveTransactionPendingChangesRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} action
     * @param {ApiSvcResolveTransactionsRequestDTO} apiSvcResolveTransactionsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveTransactionsPendingChangesV3: async (
      orgId: string,
      action: string,
      apiSvcResolveTransactionsRequestDTO: ApiSvcResolveTransactionsRequestDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('resolveTransactionsPendingChangesV3', 'orgId', orgId);
      // verify required parameter 'action' is not null or undefined
      assertParamExists('resolveTransactionsPendingChangesV3', 'action', action);
      // verify required parameter 'apiSvcResolveTransactionsRequestDTO' is not null or undefined
      assertParamExists(
        'resolveTransactionsPendingChangesV3',
        'apiSvcResolveTransactionsRequestDTO',
        apiSvcResolveTransactionsRequestDTO
      );
      const localVarPath = `/v3/orgs/{orgId}/transactions/resolve`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (action !== undefined) {
        localVarQueryParameter['action'] = action;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcResolveTransactionsRequestDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcSplitTransactionDTO} apiSvcSplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    splitTransactionV3: async (
      orgId: string,
      apiSvcSplitTransactionDTO: ApiSvcSplitTransactionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('splitTransactionV3', 'orgId', orgId);
      // verify required parameter 'apiSvcSplitTransactionDTO' is not null or undefined
      assertParamExists('splitTransactionV3', 'apiSvcSplitTransactionDTO', apiSvcSplitTransactionDTO);
      const localVarPath = `/v3/orgs/{orgId}/transactions/split`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcSplitTransactionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unCombineTransactionsV3: async (
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('unCombineTransactionsV3', 'orgId', orgId);
      // verify required parameter 'apiSvcTransactionIdsDTO' is not null or undefined
      assertParamExists('unCombineTransactionsV3', 'apiSvcTransactionIdsDTO', apiSvcTransactionIdsDTO);
      const localVarPath = `/v3/orgs/{orgId}/transactions/uncombine`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionIdsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undeleteTransactionsV3: async (
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('undeleteTransactionsV3', 'orgId', orgId);
      // verify required parameter 'apiSvcTransactionIdsDTO' is not null or undefined
      assertParamExists('undeleteTransactionsV3', 'apiSvcTransactionIdsDTO', apiSvcTransactionIdsDTO);
      const localVarPath = `/v3/orgs/{orgId}/transactions/undelete`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionIdsDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUnsplitTransactionDTO} apiSvcUnsplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unsplitTransactionV3: async (
      orgId: string,
      apiSvcUnsplitTransactionDTO: ApiSvcUnsplitTransactionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('unsplitTransactionV3', 'orgId', orgId);
      // verify required parameter 'apiSvcUnsplitTransactionDTO' is not null or undefined
      assertParamExists('unsplitTransactionV3', 'apiSvcUnsplitTransactionDTO', apiSvcUnsplitTransactionDTO);
      const localVarPath = `/v3/orgs/{orgId}/transactions/unsplit`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUnsplitTransactionDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionStateUpdateDTO} apiSvcTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransactionStateV3: async (
      orgId: string,
      transactionId: string,
      apiSvcTransactionStateUpdateDTO: ApiSvcTransactionStateUpdateDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateTransactionStateV3', 'orgId', orgId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('updateTransactionStateV3', 'transactionId', transactionId);
      // verify required parameter 'apiSvcTransactionStateUpdateDTO' is not null or undefined
      assertParamExists('updateTransactionStateV3', 'apiSvcTransactionStateUpdateDTO', apiSvcTransactionStateUpdateDTO);
      const localVarPath = `/v3/orgs/{orgId}/transactions/{transactionId}/state`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'transactionId'}}`, encodeURIComponent(String(transactionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcTransactionStateUpdateDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionsV3Api - functional programming interface
 * @export
 */
export const TransactionsV3ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TransactionsV3ApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkCategorizeTransactionsDTO} apiSvcBulkCategorizeTransactionsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bulkCategorizeTransactionsV3(
      orgId: string,
      apiSvcBulkCategorizeTransactionsDTO: ApiSvcBulkCategorizeTransactionsDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcBulkCategorizeTransactions200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCategorizeTransactionsV3(
        orgId,
        apiSvcBulkCategorizeTransactionsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkTransactionStateUpdateDTO} apiSvcBulkTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bulkUpdateTransactionStateV3(
      orgId: string,
      apiSvcBulkTransactionStateUpdateDTO: ApiSvcBulkTransactionStateUpdateDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcBulkUpdateTransactionStatus200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateTransactionStateV3(
        orgId,
        apiSvcBulkTransactionStateUpdateDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcCategorizeTransactionDTO} apiSvcCategorizeTransactionDTO
     * @param {boolean} [autoReconcile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categorizeTransactionPatchV3(
      orgId: string,
      transactionId: string,
      apiSvcCategorizeTransactionDTO: ApiSvcCategorizeTransactionDTO,
      autoReconcile?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categorizeTransactionPatchV3(
        orgId,
        transactionId,
        apiSvcCategorizeTransactionDTO,
        autoReconcile,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async combineTransactionsV3(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCombineTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.combineTransactionsV3(
        orgId,
        apiSvcTransactionIdsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportTransactionsV3(
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportTransactionsV3(
        orgId,
        apiSvcGetTransactionsRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBulkTransactionStateWorkflowStatusV3(
      orgId: string,
      workflowId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetBulkTransactionStateWorkflowStatus200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBulkTransactionStateWorkflowStatusV3(
        orgId,
        workflowId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Read-only description of a split group, for a confirmation step that needs to show what an unsplit will delete and restore before the user commits. Uses the read scope: this changes nothing.
     * @param {string} orgId
     * @param {string} txnId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSplitGroupV3(
      orgId: string,
      txnId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetSplitGroupV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSplitGroupV3(orgId, txnId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionV3(
      orgId: string,
      transactionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionV3200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionV3(orgId, transactionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {number} [pageSize]
     * @param {string} [nextToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionsChangelogV3(
      orgId: string,
      pageSize?: number,
      nextToken?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionsChangelogV3200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsChangelogV3(
        orgId,
        pageSize,
        nextToken,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionsCountV3(
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionsCountV3200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsCountV3(
        orgId,
        apiSvcGetTransactionsRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionsV3(
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetTransactionsV3200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsV3(
        orgId,
        apiSvcGetTransactionsRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async healTransactionV3(
      orgId: string,
      transactionId: string,
      type: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.healTransactionV3(orgId, transactionId, type, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcPreCategorizeInvoiceTransactionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async preCategorizeTransactionV3(
      orgId: string,
      transactionId: string,
      body: ApiSvcPreCategorizeInvoiceTransactionDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.preCategorizeTransactionV3(
        orgId,
        transactionId,
        body,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async priceTransactionV3(
      orgId: string,
      transactionId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcPriceTransactionV3200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.priceTransactionV3(orgId, transactionId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} action
     * @param {ApiSvcResolveTransactionPendingChangesRequest} apiSvcResolveTransactionPendingChangesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resolveTransactionPendingChangesV3(
      orgId: string,
      transactionId: string,
      action: string,
      apiSvcResolveTransactionPendingChangesRequest: ApiSvcResolveTransactionPendingChangesRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcResolveTransactionPendingChanges200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resolveTransactionPendingChangesV3(
        orgId,
        transactionId,
        action,
        apiSvcResolveTransactionPendingChangesRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} action
     * @param {ApiSvcResolveTransactionsRequestDTO} apiSvcResolveTransactionsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resolveTransactionsPendingChangesV3(
      orgId: string,
      action: string,
      apiSvcResolveTransactionsRequestDTO: ApiSvcResolveTransactionsRequestDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcResolveTransactionsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resolveTransactionsPendingChangesV3(
        orgId,
        action,
        apiSvcResolveTransactionsRequestDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcSplitTransactionDTO} apiSvcSplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async splitTransactionV3(
      orgId: string,
      apiSvcSplitTransactionDTO: ApiSvcSplitTransactionDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcSplitTransactionV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.splitTransactionV3(
        orgId,
        apiSvcSplitTransactionDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unCombineTransactionsV3(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUnCombineTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unCombineTransactionsV3(
        orgId,
        apiSvcTransactionIdsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async undeleteTransactionsV3(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUndeleteTransactionsV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.undeleteTransactionsV3(
        orgId,
        apiSvcTransactionIdsDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUnsplitTransactionDTO} apiSvcUnsplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unsplitTransactionV3(
      orgId: string,
      apiSvcUnsplitTransactionDTO: ApiSvcUnsplitTransactionDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUnsplitTransactionV2200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unsplitTransactionV3(
        orgId,
        apiSvcUnsplitTransactionDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionStateUpdateDTO} apiSvcTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTransactionStateV3(
      orgId: string,
      transactionId: string,
      apiSvcTransactionStateUpdateDTO: ApiSvcTransactionStateUpdateDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcUpdateTransactionStatus200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransactionStateV3(
        orgId,
        transactionId,
        apiSvcTransactionStateUpdateDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * TransactionsV3Api - factory interface
 * @export
 */
export const TransactionsV3ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionsV3ApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkCategorizeTransactionsDTO} apiSvcBulkCategorizeTransactionsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCategorizeTransactionsV3(
      orgId: string,
      apiSvcBulkCategorizeTransactionsDTO: ApiSvcBulkCategorizeTransactionsDTO,
      options?: any
    ): AxiosPromise<ApiSvcBulkCategorizeTransactions200Response> {
      return localVarFp
        .bulkCategorizeTransactionsV3(orgId, apiSvcBulkCategorizeTransactionsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcBulkTransactionStateUpdateDTO} apiSvcBulkTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpdateTransactionStateV3(
      orgId: string,
      apiSvcBulkTransactionStateUpdateDTO: ApiSvcBulkTransactionStateUpdateDTO,
      options?: any
    ): AxiosPromise<ApiSvcBulkUpdateTransactionStatus200Response> {
      return localVarFp
        .bulkUpdateTransactionStateV3(orgId, apiSvcBulkTransactionStateUpdateDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcCategorizeTransactionDTO} apiSvcCategorizeTransactionDTO
     * @param {boolean} [autoReconcile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categorizeTransactionPatchV3(
      orgId: string,
      transactionId: string,
      apiSvcCategorizeTransactionDTO: ApiSvcCategorizeTransactionDTO,
      autoReconcile?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .categorizeTransactionPatchV3(orgId, transactionId, apiSvcCategorizeTransactionDTO, autoReconcile, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    combineTransactionsV3(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: any
    ): AxiosPromise<ApiSvcCombineTransactionsV2200Response> {
      return localVarFp
        .combineTransactionsV3(orgId, apiSvcTransactionIdsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportTransactionsV3(
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .exportTransactionsV3(orgId, apiSvcGetTransactionsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulkTransactionStateWorkflowStatusV3(
      orgId: string,
      workflowId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetBulkTransactionStateWorkflowStatus200Response> {
      return localVarFp
        .getBulkTransactionStateWorkflowStatusV3(orgId, workflowId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Read-only description of a split group, for a confirmation step that needs to show what an unsplit will delete and restore before the user commits. Uses the read scope: this changes nothing.
     * @param {string} orgId
     * @param {string} txnId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSplitGroupV3(orgId: string, txnId: string, options?: any): AxiosPromise<ApiSvcGetSplitGroupV2200Response> {
      return localVarFp.getSplitGroupV3(orgId, txnId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionV3(
      orgId: string,
      transactionId: string,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionV3200Response> {
      return localVarFp.getTransactionV3(orgId, transactionId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {number} [pageSize]
     * @param {string} [nextToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsChangelogV3(
      orgId: string,
      pageSize?: number,
      nextToken?: string,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionsChangelogV3200Response> {
      return localVarFp
        .getTransactionsChangelogV3(orgId, pageSize, nextToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsCountV3(
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionsCountV3200Response> {
      return localVarFp
        .getTransactionsCountV3(orgId, apiSvcGetTransactionsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsV3(
      orgId: string,
      apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
      options?: any
    ): AxiosPromise<ApiSvcGetTransactionsV3200Response> {
      return localVarFp
        .getTransactionsV3(orgId, apiSvcGetTransactionsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healTransactionV3(
      orgId: string,
      transactionId: string,
      type: string,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .healTransactionV3(orgId, transactionId, type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcPreCategorizeInvoiceTransactionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    preCategorizeTransactionV3(
      orgId: string,
      transactionId: string,
      body: ApiSvcPreCategorizeInvoiceTransactionDTO,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .preCategorizeTransactionV3(orgId, transactionId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceTransactionV3(
      orgId: string,
      transactionId: string,
      options?: any
    ): AxiosPromise<ApiSvcPriceTransactionV3200Response> {
      return localVarFp.priceTransactionV3(orgId, transactionId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {string} action
     * @param {ApiSvcResolveTransactionPendingChangesRequest} apiSvcResolveTransactionPendingChangesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveTransactionPendingChangesV3(
      orgId: string,
      transactionId: string,
      action: string,
      apiSvcResolveTransactionPendingChangesRequest: ApiSvcResolveTransactionPendingChangesRequest,
      options?: any
    ): AxiosPromise<ApiSvcResolveTransactionPendingChanges200Response> {
      return localVarFp
        .resolveTransactionPendingChangesV3(
          orgId,
          transactionId,
          action,
          apiSvcResolveTransactionPendingChangesRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} action
     * @param {ApiSvcResolveTransactionsRequestDTO} apiSvcResolveTransactionsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveTransactionsPendingChangesV3(
      orgId: string,
      action: string,
      apiSvcResolveTransactionsRequestDTO: ApiSvcResolveTransactionsRequestDTO,
      options?: any
    ): AxiosPromise<ApiSvcResolveTransactionsResponse> {
      return localVarFp
        .resolveTransactionsPendingChangesV3(orgId, action, apiSvcResolveTransactionsRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcSplitTransactionDTO} apiSvcSplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    splitTransactionV3(
      orgId: string,
      apiSvcSplitTransactionDTO: ApiSvcSplitTransactionDTO,
      options?: any
    ): AxiosPromise<ApiSvcSplitTransactionV2200Response> {
      return localVarFp
        .splitTransactionV3(orgId, apiSvcSplitTransactionDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unCombineTransactionsV3(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: any
    ): AxiosPromise<ApiSvcUnCombineTransactionsV2200Response> {
      return localVarFp
        .unCombineTransactionsV3(orgId, apiSvcTransactionIdsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undeleteTransactionsV3(
      orgId: string,
      apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
      options?: any
    ): AxiosPromise<ApiSvcUndeleteTransactionsV2200Response> {
      return localVarFp
        .undeleteTransactionsV3(orgId, apiSvcTransactionIdsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUnsplitTransactionDTO} apiSvcUnsplitTransactionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unsplitTransactionV3(
      orgId: string,
      apiSvcUnsplitTransactionDTO: ApiSvcUnsplitTransactionDTO,
      options?: any
    ): AxiosPromise<ApiSvcUnsplitTransactionV2200Response> {
      return localVarFp
        .unsplitTransactionV3(orgId, apiSvcUnsplitTransactionDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} transactionId
     * @param {ApiSvcTransactionStateUpdateDTO} apiSvcTransactionStateUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransactionStateV3(
      orgId: string,
      transactionId: string,
      apiSvcTransactionStateUpdateDTO: ApiSvcTransactionStateUpdateDTO,
      options?: any
    ): AxiosPromise<ApiSvcUpdateTransactionStatus200Response> {
      return localVarFp
        .updateTransactionStateV3(orgId, transactionId, apiSvcTransactionStateUpdateDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransactionsV3Api - object-oriented interface
 * @export
 * @class TransactionsV3Api
 * @extends {BaseAPI}
 */
export class TransactionsV3Api extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {ApiSvcBulkCategorizeTransactionsDTO} apiSvcBulkCategorizeTransactionsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public bulkCategorizeTransactionsV3(
    orgId: string,
    apiSvcBulkCategorizeTransactionsDTO: ApiSvcBulkCategorizeTransactionsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .bulkCategorizeTransactionsV3(orgId, apiSvcBulkCategorizeTransactionsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcBulkTransactionStateUpdateDTO} apiSvcBulkTransactionStateUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public bulkUpdateTransactionStateV3(
    orgId: string,
    apiSvcBulkTransactionStateUpdateDTO: ApiSvcBulkTransactionStateUpdateDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .bulkUpdateTransactionStateV3(orgId, apiSvcBulkTransactionStateUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {ApiSvcCategorizeTransactionDTO} apiSvcCategorizeTransactionDTO
   * @param {boolean} [autoReconcile]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public categorizeTransactionPatchV3(
    orgId: string,
    transactionId: string,
    apiSvcCategorizeTransactionDTO: ApiSvcCategorizeTransactionDTO,
    autoReconcile?: boolean,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .categorizeTransactionPatchV3(orgId, transactionId, apiSvcCategorizeTransactionDTO, autoReconcile, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public combineTransactionsV3(
    orgId: string,
    apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .combineTransactionsV3(orgId, apiSvcTransactionIdsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public exportTransactionsV3(
    orgId: string,
    apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .exportTransactionsV3(orgId, apiSvcGetTransactionsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} workflowId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public getBulkTransactionStateWorkflowStatusV3(orgId: string, workflowId: string, options?: AxiosRequestConfig) {
    return TransactionsV3ApiFp(this.configuration)
      .getBulkTransactionStateWorkflowStatusV3(orgId, workflowId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Read-only description of a split group, for a confirmation step that needs to show what an unsplit will delete and restore before the user commits. Uses the read scope: this changes nothing.
   * @param {string} orgId
   * @param {string} txnId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public getSplitGroupV3(orgId: string, txnId: string, options?: AxiosRequestConfig) {
    return TransactionsV3ApiFp(this.configuration)
      .getSplitGroupV3(orgId, txnId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public getTransactionV3(orgId: string, transactionId: string, options?: AxiosRequestConfig) {
    return TransactionsV3ApiFp(this.configuration)
      .getTransactionV3(orgId, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {number} [pageSize]
   * @param {string} [nextToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public getTransactionsChangelogV3(
    orgId: string,
    pageSize?: number,
    nextToken?: string,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .getTransactionsChangelogV3(orgId, pageSize, nextToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public getTransactionsCountV3(
    orgId: string,
    apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .getTransactionsCountV3(orgId, apiSvcGetTransactionsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcGetTransactionsRequest} apiSvcGetTransactionsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public getTransactionsV3(
    orgId: string,
    apiSvcGetTransactionsRequest: ApiSvcGetTransactionsRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .getTransactionsV3(orgId, apiSvcGetTransactionsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {string} type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public healTransactionV3(orgId: string, transactionId: string, type: string, options?: AxiosRequestConfig) {
    return TransactionsV3ApiFp(this.configuration)
      .healTransactionV3(orgId, transactionId, type, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {ApiSvcPreCategorizeInvoiceTransactionDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public preCategorizeTransactionV3(
    orgId: string,
    transactionId: string,
    body: ApiSvcPreCategorizeInvoiceTransactionDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .preCategorizeTransactionV3(orgId, transactionId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public priceTransactionV3(orgId: string, transactionId: string, options?: AxiosRequestConfig) {
    return TransactionsV3ApiFp(this.configuration)
      .priceTransactionV3(orgId, transactionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {string} action
   * @param {ApiSvcResolveTransactionPendingChangesRequest} apiSvcResolveTransactionPendingChangesRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public resolveTransactionPendingChangesV3(
    orgId: string,
    transactionId: string,
    action: string,
    apiSvcResolveTransactionPendingChangesRequest: ApiSvcResolveTransactionPendingChangesRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .resolveTransactionPendingChangesV3(
        orgId,
        transactionId,
        action,
        apiSvcResolveTransactionPendingChangesRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} action
   * @param {ApiSvcResolveTransactionsRequestDTO} apiSvcResolveTransactionsRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public resolveTransactionsPendingChangesV3(
    orgId: string,
    action: string,
    apiSvcResolveTransactionsRequestDTO: ApiSvcResolveTransactionsRequestDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .resolveTransactionsPendingChangesV3(orgId, action, apiSvcResolveTransactionsRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcSplitTransactionDTO} apiSvcSplitTransactionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public splitTransactionV3(
    orgId: string,
    apiSvcSplitTransactionDTO: ApiSvcSplitTransactionDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .splitTransactionV3(orgId, apiSvcSplitTransactionDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public unCombineTransactionsV3(
    orgId: string,
    apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .unCombineTransactionsV3(orgId, apiSvcTransactionIdsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcTransactionIdsDTO} apiSvcTransactionIdsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public undeleteTransactionsV3(
    orgId: string,
    apiSvcTransactionIdsDTO: ApiSvcTransactionIdsDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .undeleteTransactionsV3(orgId, apiSvcTransactionIdsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcUnsplitTransactionDTO} apiSvcUnsplitTransactionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public unsplitTransactionV3(
    orgId: string,
    apiSvcUnsplitTransactionDTO: ApiSvcUnsplitTransactionDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .unsplitTransactionV3(orgId, apiSvcUnsplitTransactionDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} transactionId
   * @param {ApiSvcTransactionStateUpdateDTO} apiSvcTransactionStateUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsV3Api
   */
  public updateTransactionStateV3(
    orgId: string,
    transactionId: string,
    apiSvcTransactionStateUpdateDTO: ApiSvcTransactionStateUpdateDTO,
    options?: AxiosRequestConfig
  ) {
    return TransactionsV3ApiFp(this.configuration)
      .updateTransactionStateV3(orgId, transactionId, apiSvcTransactionStateUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Returns current user\'s account information, such as their name, email, and role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    me: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/users/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sso: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/users/sso`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns current user\'s account information, such as their name, email, and role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async me(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcMe200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.me(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sso(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcSso200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sso(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UsersApiFp(configuration);
  return {
    /**
     * Returns current user\'s account information, such as their name, email, and role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    me(options?: any): AxiosPromise<ApiSvcMe200Response> {
      return localVarFp.me(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sso(options?: any): AxiosPromise<ApiSvcSso200Response> {
      return localVarFp.sso(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   * Returns current user\'s account information, such as their name, email, and role.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public me(options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .me(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public sso(options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .sso(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * WalletRulesApi - axios parameter creator
 * @export
 */
export const WalletRulesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Create a new wallet rule
     * @param {string} orgId
     * @param {ApiSvcCreateWalletRuleRequest} apiSvcCreateWalletRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWalletRule: async (
      orgId: string,
      apiSvcCreateWalletRuleRequest: ApiSvcCreateWalletRuleRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createWalletRule', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateWalletRuleRequest' is not null or undefined
      assertParamExists('createWalletRule', 'apiSvcCreateWalletRuleRequest', apiSvcCreateWalletRuleRequest);
      const localVarPath = `/orgs/{orgId}/wallet-rules`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateWalletRuleRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Delete a wallet rule
     * @param {string} orgId
     * @param {string} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteWalletRule: async (orgId: string, ruleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deleteWalletRule', 'orgId', orgId);
      // verify required parameter 'ruleId' is not null or undefined
      assertParamExists('deleteWalletRule', 'ruleId', ruleId);
      const localVarPath = `/orgs/{orgId}/wallet-rules/{ruleId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'ruleId'}}`, encodeURIComponent(String(ruleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns all wallet rules for an organization
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletRules: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getWalletRules', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/wallet-rules`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Re-run wallet rules against wallets blocked due to rules failures
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reprocessBlockedWallets: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('reprocessBlockedWallets', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/wallet-rules/reprocess-blocked`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable or disable a wallet rule
     * @param {string} orgId
     * @param {string} ruleId
     * @param {ApiSvcToggleWalletRuleRequest} apiSvcToggleWalletRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleWalletRule: async (
      orgId: string,
      ruleId: string,
      apiSvcToggleWalletRuleRequest: ApiSvcToggleWalletRuleRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('toggleWalletRule', 'orgId', orgId);
      // verify required parameter 'ruleId' is not null or undefined
      assertParamExists('toggleWalletRule', 'ruleId', ruleId);
      // verify required parameter 'apiSvcToggleWalletRuleRequest' is not null or undefined
      assertParamExists('toggleWalletRule', 'apiSvcToggleWalletRuleRequest', apiSvcToggleWalletRuleRequest);
      const localVarPath = `/orgs/{orgId}/wallet-rules/{ruleId}/toggle`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'ruleId'}}`, encodeURIComponent(String(ruleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcToggleWalletRuleRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update an existing wallet rule
     * @param {string} orgId
     * @param {string} ruleId
     * @param {ApiSvcUpdateWalletRuleRequest} apiSvcUpdateWalletRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWalletRule: async (
      orgId: string,
      ruleId: string,
      apiSvcUpdateWalletRuleRequest: ApiSvcUpdateWalletRuleRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateWalletRule', 'orgId', orgId);
      // verify required parameter 'ruleId' is not null or undefined
      assertParamExists('updateWalletRule', 'ruleId', ruleId);
      // verify required parameter 'apiSvcUpdateWalletRuleRequest' is not null or undefined
      assertParamExists('updateWalletRule', 'apiSvcUpdateWalletRuleRequest', apiSvcUpdateWalletRuleRequest);
      const localVarPath = `/orgs/{orgId}/wallet-rules/{ruleId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'ruleId'}}`, encodeURIComponent(String(ruleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateWalletRuleRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WalletRulesApi - functional programming interface
 * @export
 */
export const WalletRulesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WalletRulesApiAxiosParamCreator(configuration);
  return {
    /**
     * Create a new wallet rule
     * @param {string} orgId
     * @param {ApiSvcCreateWalletRuleRequest} apiSvcCreateWalletRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createWalletRule(
      orgId: string,
      apiSvcCreateWalletRuleRequest: ApiSvcCreateWalletRuleRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateWalletRule200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createWalletRule(
        orgId,
        apiSvcCreateWalletRuleRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Delete a wallet rule
     * @param {string} orgId
     * @param {string} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteWalletRule(
      orgId: string,
      ruleId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWalletRule(orgId, ruleId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns all wallet rules for an organization
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWalletRules(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetWalletRules200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletRules(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Re-run wallet rules against wallets blocked due to rules failures
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reprocessBlockedWallets(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcReprocessBlockedWallets200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reprocessBlockedWallets(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Enable or disable a wallet rule
     * @param {string} orgId
     * @param {string} ruleId
     * @param {ApiSvcToggleWalletRuleRequest} apiSvcToggleWalletRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async toggleWalletRule(
      orgId: string,
      ruleId: string,
      apiSvcToggleWalletRuleRequest: ApiSvcToggleWalletRuleRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.toggleWalletRule(
        orgId,
        ruleId,
        apiSvcToggleWalletRuleRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update an existing wallet rule
     * @param {string} orgId
     * @param {string} ruleId
     * @param {ApiSvcUpdateWalletRuleRequest} apiSvcUpdateWalletRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateWalletRule(
      orgId: string,
      ruleId: string,
      apiSvcUpdateWalletRuleRequest: ApiSvcUpdateWalletRuleRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateWalletRule200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateWalletRule(
        orgId,
        ruleId,
        apiSvcUpdateWalletRuleRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * WalletRulesApi - factory interface
 * @export
 */
export const WalletRulesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = WalletRulesApiFp(configuration);
  return {
    /**
     * Create a new wallet rule
     * @param {string} orgId
     * @param {ApiSvcCreateWalletRuleRequest} apiSvcCreateWalletRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWalletRule(
      orgId: string,
      apiSvcCreateWalletRuleRequest: ApiSvcCreateWalletRuleRequest,
      options?: any
    ): AxiosPromise<ApiSvcCreateWalletRule200Response> {
      return localVarFp
        .createWalletRule(orgId, apiSvcCreateWalletRuleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Delete a wallet rule
     * @param {string} orgId
     * @param {string} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteWalletRule(
      orgId: string,
      ruleId: string,
      options?: any
    ): AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response> {
      return localVarFp.deleteWalletRule(orgId, ruleId, options).then((request) => request(axios, basePath));
    },
    /**
     * Returns all wallet rules for an organization
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletRules(orgId: string, options?: any): AxiosPromise<ApiSvcGetWalletRules200Response> {
      return localVarFp.getWalletRules(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     * Re-run wallet rules against wallets blocked due to rules failures
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reprocessBlockedWallets(orgId: string, options?: any): AxiosPromise<ApiSvcReprocessBlockedWallets200Response> {
      return localVarFp.reprocessBlockedWallets(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     * Enable or disable a wallet rule
     * @param {string} orgId
     * @param {string} ruleId
     * @param {ApiSvcToggleWalletRuleRequest} apiSvcToggleWalletRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleWalletRule(
      orgId: string,
      ruleId: string,
      apiSvcToggleWalletRuleRequest: ApiSvcToggleWalletRuleRequest,
      options?: any
    ): AxiosPromise<ApiSvcDeleteOrgLabelDefinition200Response> {
      return localVarFp
        .toggleWalletRule(orgId, ruleId, apiSvcToggleWalletRuleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update an existing wallet rule
     * @param {string} orgId
     * @param {string} ruleId
     * @param {ApiSvcUpdateWalletRuleRequest} apiSvcUpdateWalletRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWalletRule(
      orgId: string,
      ruleId: string,
      apiSvcUpdateWalletRuleRequest: ApiSvcUpdateWalletRuleRequest,
      options?: any
    ): AxiosPromise<ApiSvcCreateWalletRule200Response> {
      return localVarFp
        .updateWalletRule(orgId, ruleId, apiSvcUpdateWalletRuleRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * WalletRulesApi - object-oriented interface
 * @export
 * @class WalletRulesApi
 * @extends {BaseAPI}
 */
export class WalletRulesApi extends BaseAPI {
  /**
   * Create a new wallet rule
   * @param {string} orgId
   * @param {ApiSvcCreateWalletRuleRequest} apiSvcCreateWalletRuleRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletRulesApi
   */
  public createWalletRule(
    orgId: string,
    apiSvcCreateWalletRuleRequest: ApiSvcCreateWalletRuleRequest,
    options?: AxiosRequestConfig
  ) {
    return WalletRulesApiFp(this.configuration)
      .createWalletRule(orgId, apiSvcCreateWalletRuleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Delete a wallet rule
   * @param {string} orgId
   * @param {string} ruleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletRulesApi
   */
  public deleteWalletRule(orgId: string, ruleId: string, options?: AxiosRequestConfig) {
    return WalletRulesApiFp(this.configuration)
      .deleteWalletRule(orgId, ruleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns all wallet rules for an organization
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletRulesApi
   */
  public getWalletRules(orgId: string, options?: AxiosRequestConfig) {
    return WalletRulesApiFp(this.configuration)
      .getWalletRules(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Re-run wallet rules against wallets blocked due to rules failures
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletRulesApi
   */
  public reprocessBlockedWallets(orgId: string, options?: AxiosRequestConfig) {
    return WalletRulesApiFp(this.configuration)
      .reprocessBlockedWallets(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Enable or disable a wallet rule
   * @param {string} orgId
   * @param {string} ruleId
   * @param {ApiSvcToggleWalletRuleRequest} apiSvcToggleWalletRuleRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletRulesApi
   */
  public toggleWalletRule(
    orgId: string,
    ruleId: string,
    apiSvcToggleWalletRuleRequest: ApiSvcToggleWalletRuleRequest,
    options?: AxiosRequestConfig
  ) {
    return WalletRulesApiFp(this.configuration)
      .toggleWalletRule(orgId, ruleId, apiSvcToggleWalletRuleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Update an existing wallet rule
   * @param {string} orgId
   * @param {string} ruleId
   * @param {ApiSvcUpdateWalletRuleRequest} apiSvcUpdateWalletRuleRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletRulesApi
   */
  public updateWalletRule(
    orgId: string,
    ruleId: string,
    apiSvcUpdateWalletRuleRequest: ApiSvcUpdateWalletRuleRequest,
    options?: AxiosRequestConfig
  ) {
    return WalletRulesApiFp(this.configuration)
      .updateWalletRule(orgId, ruleId, apiSvcUpdateWalletRuleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * WalletsApi - axios parameter creator
 * @export
 */
export const WalletsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelRollupReprocess: async (
      orgId: string,
      runId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('cancelRollupReprocess', 'orgId', orgId);
      // verify required parameter 'runId' is not null or undefined
      assertParamExists('cancelRollupReprocess', 'runId', runId);
      const localVarPath = `/orgs/{orgId}/rollupReprocess/{runId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'runId'}}`, encodeURIComponent(String(runId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateWalletRequest} apiSvcCreateWalletRequest
     * @param {boolean} [makeUnique]
     * @param {boolean} [validateAddressFormat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWallet: async (
      orgId: string,
      apiSvcCreateWalletRequest: ApiSvcCreateWalletRequest,
      makeUnique?: boolean,
      validateAddressFormat?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createWallet', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateWalletRequest' is not null or undefined
      assertParamExists('createWallet', 'apiSvcCreateWalletRequest', apiSvcCreateWalletRequest);
      const localVarPath = `/orgs/{orgId}/wallets`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (makeUnique !== undefined) {
        localVarQueryParameter['makeUnique'] = makeUnique;
      }

      if (validateAddressFormat !== undefined) {
        localVarQueryParameter['validateAddressFormat'] = validateAddressFormat;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateWalletRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateWalletRoleRequestDTO} apiSvcCreateWalletRoleRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWalletRole: async (
      orgId: string,
      apiSvcCreateWalletRoleRequestDTO: ApiSvcCreateWalletRoleRequestDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createWalletRole', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateWalletRoleRequestDTO' is not null or undefined
      assertParamExists('createWalletRole', 'apiSvcCreateWalletRoleRequestDTO', apiSvcCreateWalletRoleRequestDTO);
      const localVarPath = `/orgs/{orgId}/walletRoles`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcCreateWalletRoleRequestDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {ApiSvcUpsertWalletRollupRequestDTO} apiSvcUpsertWalletRollupRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWalletRollup: async (
      orgId: string,
      walletId: string,
      apiSvcUpsertWalletRollupRequestDTO: ApiSvcUpsertWalletRollupRequestDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('createWalletRollup', 'orgId', orgId);
      // verify required parameter 'walletId' is not null or undefined
      assertParamExists('createWalletRollup', 'walletId', walletId);
      // verify required parameter 'apiSvcUpsertWalletRollupRequestDTO' is not null or undefined
      assertParamExists('createWalletRollup', 'apiSvcUpsertWalletRollupRequestDTO', apiSvcUpsertWalletRollupRequestDTO);
      const localVarPath = `/orgs/{orgId}/wallets/{walletId}/rollup`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'walletId'}}`, encodeURIComponent(String(walletId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpsertWalletRollupRequestDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletRoleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteWalletRole: async (
      orgId: string,
      walletRoleId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('deleteWalletRole', 'orgId', orgId);
      // verify required parameter 'walletRoleId' is not null or undefined
      assertParamExists('deleteWalletRole', 'walletRoleId', walletRoleId);
      const localVarPath = `/orgs/{orgId}/walletRoles/{walletRoleId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'walletRoleId'}}`, encodeURIComponent(String(walletRoleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forceMaterializeWalletLiveBalance: async (
      orgId: string,
      walletId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('forceMaterializeWalletLiveBalance', 'orgId', orgId);
      // verify required parameter 'walletId' is not null or undefined
      assertParamExists('forceMaterializeWalletLiveBalance', 'walletId', walletId);
      const localVarPath = `/orgs/{orgId}/wallets/{walletId}/livebalance`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'walletId'}}`, encodeURIComponent(String(walletId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRollupReprocess: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getRollupReprocess', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/rollupReprocess`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWallet: async (orgId: string, walletId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getWallet', 'orgId', orgId);
      // verify required parameter 'walletId' is not null or undefined
      assertParamExists('getWallet', 'walletId', walletId);
      const localVarPath = `/orgs/{orgId}/wallets/{walletId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'walletId'}}`, encodeURIComponent(String(walletId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletRoles: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getWalletRoles', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/walletRoles`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletRollup: async (
      orgId: string,
      walletId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getWalletRollup', 'orgId', orgId);
      // verify required parameter 'walletId' is not null or undefined
      assertParamExists('getWalletRollup', 'walletId', walletId);
      const localVarPath = `/orgs/{orgId}/wallets/{walletId}/rollup`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'walletId'}}`, encodeURIComponent(String(walletId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns all the wallets associated with your organization.
     * @param {string} orgId
     * @param {ApiSvcWalletIdTypes} [walletIdType]
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {any} [networkId]
     * @param {string} [connectionId]
     * @param {boolean} [callWalletSvc]
     * @param {ApiSvcCoin} [enabledCoin]
     * @param {boolean} [loadBalances]
     * @param {boolean} [loadBalancesFairValue]
     * @param {string} [namePrefix]
     * @param {ApiSvcWalletSortOrder} [nameSortOrder]
     * @param {boolean} [excludeDisabled]
     * @param {Array<string>} [subsidiaryIds]
     * @param {Array<ApiSvcWalletSyncSetting>} [includeSystemSyncSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWallets: async (
      orgId: string,
      walletIdType?: ApiSvcWalletIdTypes,
      pageLimit?: number,
      paginationToken?: string,
      networkId?: any,
      connectionId?: string,
      callWalletSvc?: boolean,
      enabledCoin?: ApiSvcCoin,
      loadBalances?: boolean,
      loadBalancesFairValue?: boolean,
      namePrefix?: string,
      nameSortOrder?: ApiSvcWalletSortOrder,
      excludeDisabled?: boolean,
      subsidiaryIds?: Array<string>,
      includeSystemSyncSettings?: Array<ApiSvcWalletSyncSetting>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('getWallets', 'orgId', orgId);
      const localVarPath = `/orgs/{orgId}/wallets`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (walletIdType !== undefined) {
        localVarQueryParameter['walletIdType'] = walletIdType;
      }

      if (pageLimit !== undefined) {
        localVarQueryParameter['pageLimit'] = pageLimit;
      }

      if (paginationToken !== undefined) {
        localVarQueryParameter['paginationToken'] = paginationToken;
      }

      if (networkId !== undefined) {
        localVarQueryParameter['networkId'] = networkId;
      }

      if (connectionId !== undefined) {
        localVarQueryParameter['connectionId'] = connectionId;
      }

      if (callWalletSvc !== undefined) {
        localVarQueryParameter['callWalletSvc'] = callWalletSvc;
      }

      if (enabledCoin !== undefined) {
        localVarQueryParameter['enabledCoin'] = enabledCoin;
      }

      if (loadBalances !== undefined) {
        localVarQueryParameter['loadBalances'] = loadBalances;
      }

      if (loadBalancesFairValue !== undefined) {
        localVarQueryParameter['loadBalancesFairValue'] = loadBalancesFairValue;
      }

      if (namePrefix !== undefined) {
        localVarQueryParameter['namePrefix'] = namePrefix;
      }

      if (nameSortOrder !== undefined) {
        localVarQueryParameter['nameSortOrder'] = nameSortOrder;
      }

      if (excludeDisabled !== undefined) {
        localVarQueryParameter['excludeDisabled'] = excludeDisabled;
      }

      if (subsidiaryIds) {
        localVarQueryParameter['subsidiaryIds'] = subsidiaryIds;
      }

      if (includeSystemSyncSettings) {
        localVarQueryParameter['includeSystemSyncSettings'] = includeSystemSyncSettings;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {Array<ApiSvcUpdateWalletBalanceRequest>} apiSvcUpdateWalletBalanceRequest
     * @param {number} [timestampSEC]
     * @param {boolean} [updateLiveBalance]
     * @param {boolean} [runBalanceCheck]
     * @param {boolean} [fullBalanceCheck]
     * @param {string} [walletDescription]
     * @param {string} [blockId]
     * @param {number} [balanceTimestampSEC]
     * @param {string} [metadataJson]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBalance: async (
      orgId: string,
      walletId: string,
      apiSvcUpdateWalletBalanceRequest: Array<ApiSvcUpdateWalletBalanceRequest>,
      timestampSEC?: number,
      updateLiveBalance?: boolean,
      runBalanceCheck?: boolean,
      fullBalanceCheck?: boolean,
      walletDescription?: string,
      blockId?: string,
      balanceTimestampSEC?: number,
      metadataJson?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateBalance', 'orgId', orgId);
      // verify required parameter 'walletId' is not null or undefined
      assertParamExists('updateBalance', 'walletId', walletId);
      // verify required parameter 'apiSvcUpdateWalletBalanceRequest' is not null or undefined
      assertParamExists('updateBalance', 'apiSvcUpdateWalletBalanceRequest', apiSvcUpdateWalletBalanceRequest);
      const localVarPath = `/orgs/{orgId}/wallets/{walletId}/balance`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'walletId'}}`, encodeURIComponent(String(walletId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (timestampSEC !== undefined) {
        localVarQueryParameter['timestampSEC'] = timestampSEC;
      }

      if (updateLiveBalance !== undefined) {
        localVarQueryParameter['updateLiveBalance'] = updateLiveBalance;
      }

      if (runBalanceCheck !== undefined) {
        localVarQueryParameter['runBalanceCheck'] = runBalanceCheck;
      }

      if (fullBalanceCheck !== undefined) {
        localVarQueryParameter['fullBalanceCheck'] = fullBalanceCheck;
      }

      if (walletDescription !== undefined) {
        localVarQueryParameter['walletDescription'] = walletDescription;
      }

      if (blockId !== undefined) {
        localVarQueryParameter['blockId'] = blockId;
      }

      if (balanceTimestampSEC !== undefined) {
        localVarQueryParameter['balanceTimestampSEC'] = balanceTimestampSEC;
      }

      if (metadataJson !== undefined) {
        localVarQueryParameter['metadataJson'] = metadataJson;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateWalletBalanceRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {Array<ApiSvcUpdateWalletBalancesRequest>} apiSvcUpdateWalletBalancesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBalances: async (
      orgId: string,
      walletId: string,
      apiSvcUpdateWalletBalancesRequest: Array<ApiSvcUpdateWalletBalancesRequest>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateBalances', 'orgId', orgId);
      // verify required parameter 'walletId' is not null or undefined
      assertParamExists('updateBalances', 'walletId', walletId);
      // verify required parameter 'apiSvcUpdateWalletBalancesRequest' is not null or undefined
      assertParamExists('updateBalances', 'apiSvcUpdateWalletBalancesRequest', apiSvcUpdateWalletBalancesRequest);
      const localVarPath = `/orgs/{orgId}/wallets/{walletId}/balances`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'walletId'}}`, encodeURIComponent(String(walletId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpdateWalletBalancesRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {ApiSvcPatchWalletRequest} apiSvcPatchWalletRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWallet: async (
      orgId: string,
      walletId: string,
      apiSvcPatchWalletRequest: ApiSvcPatchWalletRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('updateWallet', 'orgId', orgId);
      // verify required parameter 'walletId' is not null or undefined
      assertParamExists('updateWallet', 'walletId', walletId);
      // verify required parameter 'apiSvcPatchWalletRequest' is not null or undefined
      assertParamExists('updateWallet', 'apiSvcPatchWalletRequest', apiSvcPatchWalletRequest);
      const localVarPath = `/orgs/{orgId}/wallets/{walletId}`
        .replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)))
        .replace(`{${'walletId'}}`, encodeURIComponent(String(walletId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcPatchWalletRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUpsertRollupReprocessRequestDTO} apiSvcUpsertRollupReprocessRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertRollupReprocesses: async (
      orgId: string,
      apiSvcUpsertRollupReprocessRequestDTO: ApiSvcUpsertRollupReprocessRequestDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('upsertRollupReprocesses', 'orgId', orgId);
      // verify required parameter 'apiSvcUpsertRollupReprocessRequestDTO' is not null or undefined
      assertParamExists(
        'upsertRollupReprocesses',
        'apiSvcUpsertRollupReprocessRequestDTO',
        apiSvcUpsertRollupReprocessRequestDTO
      );
      const localVarPath = `/orgs/{orgId}/rollupReprocess`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiSvcUpsertRollupReprocessRequestDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateWalletDTO} apiSvcCreateWalletDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateWallet: async (
      orgId: string,
      apiSvcCreateWalletDTO: ApiSvcCreateWalletDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('validateWallet', 'orgId', orgId);
      // verify required parameter 'apiSvcCreateWalletDTO' is not null or undefined
      assertParamExists('validateWallet', 'apiSvcCreateWalletDTO', apiSvcCreateWalletDTO);
      const localVarPath = `/orgs/{orgId}/wallets/validate`.replace(`{${'orgId'}}`, encodeURIComponent(String(orgId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(apiSvcCreateWalletDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WalletsApi - functional programming interface
 * @export
 */
export const WalletsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WalletsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelRollupReprocess(
      orgId: string,
      runId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancelRollupReprocess(orgId, runId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateWalletRequest} apiSvcCreateWalletRequest
     * @param {boolean} [makeUnique]
     * @param {boolean} [validateAddressFormat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createWallet(
      orgId: string,
      apiSvcCreateWalletRequest: ApiSvcCreateWalletRequest,
      makeUnique?: boolean,
      validateAddressFormat?: boolean,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcCreateWallet200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createWallet(
        orgId,
        apiSvcCreateWalletRequest,
        makeUnique,
        validateAddressFormat,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateWalletRoleRequestDTO} apiSvcCreateWalletRoleRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createWalletRole(
      orgId: string,
      apiSvcCreateWalletRoleRequestDTO: ApiSvcCreateWalletRoleRequestDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createWalletRole(
        orgId,
        apiSvcCreateWalletRoleRequestDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {ApiSvcUpsertWalletRollupRequestDTO} apiSvcUpsertWalletRollupRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createWalletRollup(
      orgId: string,
      walletId: string,
      apiSvcUpsertWalletRollupRequestDTO: ApiSvcUpsertWalletRollupRequestDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createWalletRollup(
        orgId,
        walletId,
        apiSvcUpsertWalletRollupRequestDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletRoleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteWalletRole(
      orgId: string,
      walletRoleId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWalletRole(orgId, walletRoleId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forceMaterializeWalletLiveBalance(
      orgId: string,
      walletId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcForceMaterializeWalletLiveBalance200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.forceMaterializeWalletLiveBalance(
        orgId,
        walletId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRollupReprocess(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRollupReprocessConfig>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRollupReprocess(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWallet(
      orgId: string,
      walletId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetWallet200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWallet(orgId, walletId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWalletRoles(
      orgId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetWalletRoles200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletRoles(orgId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWalletRollup(
      orgId: string,
      walletId: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRollupConfigBase>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletRollup(orgId, walletId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Returns all the wallets associated with your organization.
     * @param {string} orgId
     * @param {ApiSvcWalletIdTypes} [walletIdType]
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {any} [networkId]
     * @param {string} [connectionId]
     * @param {boolean} [callWalletSvc]
     * @param {ApiSvcCoin} [enabledCoin]
     * @param {boolean} [loadBalances]
     * @param {boolean} [loadBalancesFairValue]
     * @param {string} [namePrefix]
     * @param {ApiSvcWalletSortOrder} [nameSortOrder]
     * @param {boolean} [excludeDisabled]
     * @param {Array<string>} [subsidiaryIds]
     * @param {Array<ApiSvcWalletSyncSetting>} [includeSystemSyncSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWallets(
      orgId: string,
      walletIdType?: ApiSvcWalletIdTypes,
      pageLimit?: number,
      paginationToken?: string,
      networkId?: any,
      connectionId?: string,
      callWalletSvc?: boolean,
      enabledCoin?: ApiSvcCoin,
      loadBalances?: boolean,
      loadBalancesFairValue?: boolean,
      namePrefix?: string,
      nameSortOrder?: ApiSvcWalletSortOrder,
      excludeDisabled?: boolean,
      subsidiaryIds?: Array<string>,
      includeSystemSyncSettings?: Array<ApiSvcWalletSyncSetting>,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcGetWallets200Response>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWallets(
        orgId,
        walletIdType,
        pageLimit,
        paginationToken,
        networkId,
        connectionId,
        callWalletSvc,
        enabledCoin,
        loadBalances,
        loadBalancesFairValue,
        namePrefix,
        nameSortOrder,
        excludeDisabled,
        subsidiaryIds,
        includeSystemSyncSettings,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {Array<ApiSvcUpdateWalletBalanceRequest>} apiSvcUpdateWalletBalanceRequest
     * @param {number} [timestampSEC]
     * @param {boolean} [updateLiveBalance]
     * @param {boolean} [runBalanceCheck]
     * @param {boolean} [fullBalanceCheck]
     * @param {string} [walletDescription]
     * @param {string} [blockId]
     * @param {number} [balanceTimestampSEC]
     * @param {string} [metadataJson]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBalance(
      orgId: string,
      walletId: string,
      apiSvcUpdateWalletBalanceRequest: Array<ApiSvcUpdateWalletBalanceRequest>,
      timestampSEC?: number,
      updateLiveBalance?: boolean,
      runBalanceCheck?: boolean,
      fullBalanceCheck?: boolean,
      walletDescription?: string,
      blockId?: string,
      balanceTimestampSEC?: number,
      metadataJson?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcWalletsErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateBalance(
        orgId,
        walletId,
        apiSvcUpdateWalletBalanceRequest,
        timestampSEC,
        updateLiveBalance,
        runBalanceCheck,
        fullBalanceCheck,
        walletDescription,
        blockId,
        balanceTimestampSEC,
        metadataJson,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {Array<ApiSvcUpdateWalletBalancesRequest>} apiSvcUpdateWalletBalancesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBalances(
      orgId: string,
      walletId: string,
      apiSvcUpdateWalletBalancesRequest: Array<ApiSvcUpdateWalletBalancesRequest>,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcWalletsErrorResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateBalances(
        orgId,
        walletId,
        apiSvcUpdateWalletBalancesRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {ApiSvcPatchWalletRequest} apiSvcPatchWalletRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateWallet(
      orgId: string,
      walletId: string,
      apiSvcPatchWalletRequest: ApiSvcPatchWalletRequest,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateWallet(
        orgId,
        walletId,
        apiSvcPatchWalletRequest,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUpsertRollupReprocessRequestDTO} apiSvcUpsertRollupReprocessRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertRollupReprocesses(
      orgId: string,
      apiSvcUpsertRollupReprocessRequestDTO: ApiSvcUpsertRollupReprocessRequestDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSvcRollupReprocessConfig>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.upsertRollupReprocesses(
        orgId,
        apiSvcUpsertRollupReprocessRequestDTO,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateWalletDTO} apiSvcCreateWalletDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async validateWallet(
      orgId: string,
      apiSvcCreateWalletDTO: ApiSvcCreateWalletDTO,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.validateWallet(orgId, apiSvcCreateWalletDTO, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * WalletsApi - factory interface
 * @export
 */
export const WalletsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = WalletsApiFp(configuration);
  return {
    /**
     *
     * @param {string} orgId
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelRollupReprocess(orgId: string, runId: string, options?: any): AxiosPromise<void> {
      return localVarFp.cancelRollupReprocess(orgId, runId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateWalletRequest} apiSvcCreateWalletRequest
     * @param {boolean} [makeUnique]
     * @param {boolean} [validateAddressFormat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWallet(
      orgId: string,
      apiSvcCreateWalletRequest: ApiSvcCreateWalletRequest,
      makeUnique?: boolean,
      validateAddressFormat?: boolean,
      options?: any
    ): AxiosPromise<ApiSvcCreateWallet200Response> {
      return localVarFp
        .createWallet(orgId, apiSvcCreateWalletRequest, makeUnique, validateAddressFormat, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateWalletRoleRequestDTO} apiSvcCreateWalletRoleRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWalletRole(
      orgId: string,
      apiSvcCreateWalletRoleRequestDTO: ApiSvcCreateWalletRoleRequestDTO,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .createWalletRole(orgId, apiSvcCreateWalletRoleRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {ApiSvcUpsertWalletRollupRequestDTO} apiSvcUpsertWalletRollupRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWalletRollup(
      orgId: string,
      walletId: string,
      apiSvcUpsertWalletRollupRequestDTO: ApiSvcUpsertWalletRollupRequestDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .createWalletRollup(orgId, walletId, apiSvcUpsertWalletRollupRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletRoleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteWalletRole(orgId: string, walletRoleId: string, options?: any): AxiosPromise<void> {
      return localVarFp.deleteWalletRole(orgId, walletRoleId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forceMaterializeWalletLiveBalance(
      orgId: string,
      walletId: string,
      options?: any
    ): AxiosPromise<ApiSvcForceMaterializeWalletLiveBalance200Response> {
      return localVarFp
        .forceMaterializeWalletLiveBalance(orgId, walletId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRollupReprocess(orgId: string, options?: any): AxiosPromise<ApiSvcRollupReprocessConfig> {
      return localVarFp.getRollupReprocess(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWallet(orgId: string, walletId: string, options?: any): AxiosPromise<ApiSvcGetWallet200Response> {
      return localVarFp.getWallet(orgId, walletId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletRoles(orgId: string, options?: any): AxiosPromise<ApiSvcGetWalletRoles200Response> {
      return localVarFp.getWalletRoles(orgId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletRollup(orgId: string, walletId: string, options?: any): AxiosPromise<ApiSvcRollupConfigBase> {
      return localVarFp.getWalletRollup(orgId, walletId, options).then((request) => request(axios, basePath));
    },
    /**
     * Returns all the wallets associated with your organization.
     * @param {string} orgId
     * @param {ApiSvcWalletIdTypes} [walletIdType]
     * @param {number} [pageLimit]
     * @param {string} [paginationToken]
     * @param {any} [networkId]
     * @param {string} [connectionId]
     * @param {boolean} [callWalletSvc]
     * @param {ApiSvcCoin} [enabledCoin]
     * @param {boolean} [loadBalances]
     * @param {boolean} [loadBalancesFairValue]
     * @param {string} [namePrefix]
     * @param {ApiSvcWalletSortOrder} [nameSortOrder]
     * @param {boolean} [excludeDisabled]
     * @param {Array<string>} [subsidiaryIds]
     * @param {Array<ApiSvcWalletSyncSetting>} [includeSystemSyncSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWallets(
      orgId: string,
      walletIdType?: ApiSvcWalletIdTypes,
      pageLimit?: number,
      paginationToken?: string,
      networkId?: any,
      connectionId?: string,
      callWalletSvc?: boolean,
      enabledCoin?: ApiSvcCoin,
      loadBalances?: boolean,
      loadBalancesFairValue?: boolean,
      namePrefix?: string,
      nameSortOrder?: ApiSvcWalletSortOrder,
      excludeDisabled?: boolean,
      subsidiaryIds?: Array<string>,
      includeSystemSyncSettings?: Array<ApiSvcWalletSyncSetting>,
      options?: any
    ): AxiosPromise<ApiSvcGetWallets200Response> {
      return localVarFp
        .getWallets(
          orgId,
          walletIdType,
          pageLimit,
          paginationToken,
          networkId,
          connectionId,
          callWalletSvc,
          enabledCoin,
          loadBalances,
          loadBalancesFairValue,
          namePrefix,
          nameSortOrder,
          excludeDisabled,
          subsidiaryIds,
          includeSystemSyncSettings,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {Array<ApiSvcUpdateWalletBalanceRequest>} apiSvcUpdateWalletBalanceRequest
     * @param {number} [timestampSEC]
     * @param {boolean} [updateLiveBalance]
     * @param {boolean} [runBalanceCheck]
     * @param {boolean} [fullBalanceCheck]
     * @param {string} [walletDescription]
     * @param {string} [blockId]
     * @param {number} [balanceTimestampSEC]
     * @param {string} [metadataJson]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBalance(
      orgId: string,
      walletId: string,
      apiSvcUpdateWalletBalanceRequest: Array<ApiSvcUpdateWalletBalanceRequest>,
      timestampSEC?: number,
      updateLiveBalance?: boolean,
      runBalanceCheck?: boolean,
      fullBalanceCheck?: boolean,
      walletDescription?: string,
      blockId?: string,
      balanceTimestampSEC?: number,
      metadataJson?: string,
      options?: any
    ): AxiosPromise<ApiSvcWalletsErrorResponse> {
      return localVarFp
        .updateBalance(
          orgId,
          walletId,
          apiSvcUpdateWalletBalanceRequest,
          timestampSEC,
          updateLiveBalance,
          runBalanceCheck,
          fullBalanceCheck,
          walletDescription,
          blockId,
          balanceTimestampSEC,
          metadataJson,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {Array<ApiSvcUpdateWalletBalancesRequest>} apiSvcUpdateWalletBalancesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBalances(
      orgId: string,
      walletId: string,
      apiSvcUpdateWalletBalancesRequest: Array<ApiSvcUpdateWalletBalancesRequest>,
      options?: any
    ): AxiosPromise<ApiSvcWalletsErrorResponse> {
      return localVarFp
        .updateBalances(orgId, walletId, apiSvcUpdateWalletBalancesRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {string} walletId
     * @param {ApiSvcPatchWalletRequest} apiSvcPatchWalletRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWallet(
      orgId: string,
      walletId: string,
      apiSvcPatchWalletRequest: ApiSvcPatchWalletRequest,
      options?: any
    ): AxiosPromise<any> {
      return localVarFp
        .updateWallet(orgId, walletId, apiSvcPatchWalletRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcUpsertRollupReprocessRequestDTO} apiSvcUpsertRollupReprocessRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertRollupReprocesses(
      orgId: string,
      apiSvcUpsertRollupReprocessRequestDTO: ApiSvcUpsertRollupReprocessRequestDTO,
      options?: any
    ): AxiosPromise<ApiSvcRollupReprocessConfig> {
      return localVarFp
        .upsertRollupReprocesses(orgId, apiSvcUpsertRollupReprocessRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} orgId
     * @param {ApiSvcCreateWalletDTO} apiSvcCreateWalletDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateWallet(orgId: string, apiSvcCreateWalletDTO: ApiSvcCreateWalletDTO, options?: any): AxiosPromise<any> {
      return localVarFp
        .validateWallet(orgId, apiSvcCreateWalletDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * WalletsApi - object-oriented interface
 * @export
 * @class WalletsApi
 * @extends {BaseAPI}
 */
export class WalletsApi extends BaseAPI {
  /**
   *
   * @param {string} orgId
   * @param {string} runId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public cancelRollupReprocess(orgId: string, runId: string, options?: AxiosRequestConfig) {
    return WalletsApiFp(this.configuration)
      .cancelRollupReprocess(orgId, runId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateWalletRequest} apiSvcCreateWalletRequest
   * @param {boolean} [makeUnique]
   * @param {boolean} [validateAddressFormat]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public createWallet(
    orgId: string,
    apiSvcCreateWalletRequest: ApiSvcCreateWalletRequest,
    makeUnique?: boolean,
    validateAddressFormat?: boolean,
    options?: AxiosRequestConfig
  ) {
    return WalletsApiFp(this.configuration)
      .createWallet(orgId, apiSvcCreateWalletRequest, makeUnique, validateAddressFormat, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateWalletRoleRequestDTO} apiSvcCreateWalletRoleRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public createWalletRole(
    orgId: string,
    apiSvcCreateWalletRoleRequestDTO: ApiSvcCreateWalletRoleRequestDTO,
    options?: AxiosRequestConfig
  ) {
    return WalletsApiFp(this.configuration)
      .createWalletRole(orgId, apiSvcCreateWalletRoleRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} walletId
   * @param {ApiSvcUpsertWalletRollupRequestDTO} apiSvcUpsertWalletRollupRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public createWalletRollup(
    orgId: string,
    walletId: string,
    apiSvcUpsertWalletRollupRequestDTO: ApiSvcUpsertWalletRollupRequestDTO,
    options?: AxiosRequestConfig
  ) {
    return WalletsApiFp(this.configuration)
      .createWalletRollup(orgId, walletId, apiSvcUpsertWalletRollupRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} walletRoleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public deleteWalletRole(orgId: string, walletRoleId: string, options?: AxiosRequestConfig) {
    return WalletsApiFp(this.configuration)
      .deleteWalletRole(orgId, walletRoleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} walletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public forceMaterializeWalletLiveBalance(orgId: string, walletId: string, options?: AxiosRequestConfig) {
    return WalletsApiFp(this.configuration)
      .forceMaterializeWalletLiveBalance(orgId, walletId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public getRollupReprocess(orgId: string, options?: AxiosRequestConfig) {
    return WalletsApiFp(this.configuration)
      .getRollupReprocess(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} walletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public getWallet(orgId: string, walletId: string, options?: AxiosRequestConfig) {
    return WalletsApiFp(this.configuration)
      .getWallet(orgId, walletId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public getWalletRoles(orgId: string, options?: AxiosRequestConfig) {
    return WalletsApiFp(this.configuration)
      .getWalletRoles(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} walletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public getWalletRollup(orgId: string, walletId: string, options?: AxiosRequestConfig) {
    return WalletsApiFp(this.configuration)
      .getWalletRollup(orgId, walletId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns all the wallets associated with your organization.
   * @param {string} orgId
   * @param {ApiSvcWalletIdTypes} [walletIdType]
   * @param {number} [pageLimit]
   * @param {string} [paginationToken]
   * @param {any} [networkId]
   * @param {string} [connectionId]
   * @param {boolean} [callWalletSvc]
   * @param {ApiSvcCoin} [enabledCoin]
   * @param {boolean} [loadBalances]
   * @param {boolean} [loadBalancesFairValue]
   * @param {string} [namePrefix]
   * @param {ApiSvcWalletSortOrder} [nameSortOrder]
   * @param {boolean} [excludeDisabled]
   * @param {Array<string>} [subsidiaryIds]
   * @param {Array<ApiSvcWalletSyncSetting>} [includeSystemSyncSettings]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public getWallets(
    orgId: string,
    walletIdType?: ApiSvcWalletIdTypes,
    pageLimit?: number,
    paginationToken?: string,
    networkId?: any,
    connectionId?: string,
    callWalletSvc?: boolean,
    enabledCoin?: ApiSvcCoin,
    loadBalances?: boolean,
    loadBalancesFairValue?: boolean,
    namePrefix?: string,
    nameSortOrder?: ApiSvcWalletSortOrder,
    excludeDisabled?: boolean,
    subsidiaryIds?: Array<string>,
    includeSystemSyncSettings?: Array<ApiSvcWalletSyncSetting>,
    options?: AxiosRequestConfig
  ) {
    return WalletsApiFp(this.configuration)
      .getWallets(
        orgId,
        walletIdType,
        pageLimit,
        paginationToken,
        networkId,
        connectionId,
        callWalletSvc,
        enabledCoin,
        loadBalances,
        loadBalancesFairValue,
        namePrefix,
        nameSortOrder,
        excludeDisabled,
        subsidiaryIds,
        includeSystemSyncSettings,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} walletId
   * @param {Array<ApiSvcUpdateWalletBalanceRequest>} apiSvcUpdateWalletBalanceRequest
   * @param {number} [timestampSEC]
   * @param {boolean} [updateLiveBalance]
   * @param {boolean} [runBalanceCheck]
   * @param {boolean} [fullBalanceCheck]
   * @param {string} [walletDescription]
   * @param {string} [blockId]
   * @param {number} [balanceTimestampSEC]
   * @param {string} [metadataJson]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public updateBalance(
    orgId: string,
    walletId: string,
    apiSvcUpdateWalletBalanceRequest: Array<ApiSvcUpdateWalletBalanceRequest>,
    timestampSEC?: number,
    updateLiveBalance?: boolean,
    runBalanceCheck?: boolean,
    fullBalanceCheck?: boolean,
    walletDescription?: string,
    blockId?: string,
    balanceTimestampSEC?: number,
    metadataJson?: string,
    options?: AxiosRequestConfig
  ) {
    return WalletsApiFp(this.configuration)
      .updateBalance(
        orgId,
        walletId,
        apiSvcUpdateWalletBalanceRequest,
        timestampSEC,
        updateLiveBalance,
        runBalanceCheck,
        fullBalanceCheck,
        walletDescription,
        blockId,
        balanceTimestampSEC,
        metadataJson,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} walletId
   * @param {Array<ApiSvcUpdateWalletBalancesRequest>} apiSvcUpdateWalletBalancesRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public updateBalances(
    orgId: string,
    walletId: string,
    apiSvcUpdateWalletBalancesRequest: Array<ApiSvcUpdateWalletBalancesRequest>,
    options?: AxiosRequestConfig
  ) {
    return WalletsApiFp(this.configuration)
      .updateBalances(orgId, walletId, apiSvcUpdateWalletBalancesRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {string} walletId
   * @param {ApiSvcPatchWalletRequest} apiSvcPatchWalletRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public updateWallet(
    orgId: string,
    walletId: string,
    apiSvcPatchWalletRequest: ApiSvcPatchWalletRequest,
    options?: AxiosRequestConfig
  ) {
    return WalletsApiFp(this.configuration)
      .updateWallet(orgId, walletId, apiSvcPatchWalletRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcUpsertRollupReprocessRequestDTO} apiSvcUpsertRollupReprocessRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public upsertRollupReprocesses(
    orgId: string,
    apiSvcUpsertRollupReprocessRequestDTO: ApiSvcUpsertRollupReprocessRequestDTO,
    options?: AxiosRequestConfig
  ) {
    return WalletsApiFp(this.configuration)
      .upsertRollupReprocesses(orgId, apiSvcUpsertRollupReprocessRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} orgId
   * @param {ApiSvcCreateWalletDTO} apiSvcCreateWalletDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletsApi
   */
  public validateWallet(orgId: string, apiSvcCreateWalletDTO: ApiSvcCreateWalletDTO, options?: AxiosRequestConfig) {
    return WalletsApiFp(this.configuration)
      .validateWallet(orgId, apiSvcCreateWalletDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
